import { h as _objectWithoutProperties, _ as _objectSpread2 } from './common.js';
import { jsx } from '@emotion/react/jsx-runtime';
import * as React from 'react';
import _styled from '@emotion/styled/base';
import { useTheme, css } from '@emotion/react';

var _excluded = ["icons", "size", "fill"];
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var BaseIconTemplate = function BaseIconTemplate(_ref) {
  var icons = _ref.icons,
    size = _ref.size,
    fill = _ref.fill,
    rest = _objectWithoutProperties(_ref, _excluded);
  var Icon = icons[size];
  var theme = useTheme();
  return jsx(Icon, _objectSpread2(_objectSpread2({}, rest), {}, {
    css: [fill && /*#__PURE__*/css("color:", fill(theme), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:css;"))]
  }));
};
var IconTemplate = /*#__PURE__*/_styled(BaseIconTemplate, process.env.NODE_ENV === "production" ? {
  target: "ey1aqhe0"
} : {
  target: "ey1aqhe0",
  label: "IconTemplate"
})(process.env.NODE_ENV === "production" ? {
  name: "1jdn8uc",
  styles: "*[fill]{fill:currentColor;}"
} : {
  name: "1jdn8uc",
  styles: "*[fill]{fill:currentColor;}",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

var _path$dm, _path2$4c;
function _extends$dB() { return _extends$dB = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$dB.apply(null, arguments); }
var SvgInfo12 = function SvgInfo12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$dB({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$dm || (_path$dm = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M5.4 7.9a.6.6 0 0 0 1.2 0v-2a.6.6 0 1 0-1.2 0zM5.4 4.3a.6.6 0 0 0 1.2 0v-.05a.6.6 0 1 0-1.2 0z"
  })), _path2$4c || (_path2$4c = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M11 6A5 5 0 1 1 1 6a5 5 0 0 1 10 0M9.8 6a3.8 3.8 0 1 1-7.6 0 3.8 3.8 0 0 1 7.6 0",
    clipRule: "evenodd"
  })));
};

var _path$dl, _path2$4b;
function _extends$dA() { return _extends$dA = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$dA.apply(null, arguments); }
var SvgInfo16 = function SvgInfo16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$dA({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$dl || (_path$dl = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M8 6.45a.75.75 0 0 1-.75-.75v-.067a.75.75 0 0 1 1.5 0V5.7a.75.75 0 0 1-.75.75M7.25 10.5a.75.75 0 0 0 1.5 0V7.7a.75.75 0 0 0-1.5 0z"
  })), _path2$4b || (_path2$4b = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8 14.667A6.667 6.667 0 1 0 8 1.334a6.667 6.667 0 0 0 0 13.333m0-1.5A5.167 5.167 0 1 0 8 2.833a5.167 5.167 0 0 0 0 10.334",
    clipRule: "evenodd"
  })));
};

var _path$dk, _path2$4a;
function _extends$dz() { return _extends$dz = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$dz.apply(null, arguments); }
var SvgInfo18 = function SvgInfo18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$dz({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$dk || (_path$dk = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M9 7.2a.8.8 0 0 1-.8-.8v-.075a.8.8 0 0 1 1.6 0V6.4a.8.8 0 0 1-.8.8M8.2 11.7a.8.8 0 0 0 1.6 0V8.55a.8.8 0 1 0-1.6 0z"
  })), _path2$4a || (_path2$4a = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M9 16.5a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15m0-1.6A5.9 5.9 0 1 0 9 3.1a5.9 5.9 0 0 0 0 11.8",
    clipRule: "evenodd"
  })));
};

var _path$dj, _path2$49;
function _extends$dy() { return _extends$dy = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$dy.apply(null, arguments); }
var SvgInfo24 = function SvgInfo24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$dy({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$dj || (_path$dj = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M12 9.7a.9.9 0 0 1-.9-.9v-.1a.9.9 0 1 1 1.8 0v.1a.9.9 0 0 1-.9.9M11.1 15.5a.9.9 0 1 0 1.8 0v-4.2a.9.9 0 1 0-1.8 0z"
  })), _path2$49 || (_path2$49 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10m0-1.8a8.2 8.2 0 1 0 0-16.4 8.2 8.2 0 0 0 0 16.4",
    clipRule: "evenodd"
  })));
};

var _path$di, _path2$48;
function _extends$dx() { return _extends$dx = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$dx.apply(null, arguments); }
var SvgInfo32 = function SvgInfo32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$dx({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$di || (_path$di = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M16 12.733a1 1 0 0 1-1-1V11.6a1 1 0 1 1 2 0v.133a1 1 0 0 1-1 1M15 20.5a1 1 0 1 0 2 0v-5.6a1 1 0 1 0-2 0z"
  })), _path2$48 || (_path2$48 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M16 29.333c7.364 0 13.333-5.97 13.333-13.333S23.363 2.667 16 2.667 2.667 8.636 2.667 16 8.636 29.333 16 29.333m0-2c6.26 0 11.333-5.074 11.333-11.333S22.26 4.667 16 4.667 4.667 9.74 4.667 16 9.74 27.333 16 27.333",
    clipRule: "evenodd"
  })));
};

var _path$dh, _path2$47;
function _extends$dw() { return _extends$dw = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$dw.apply(null, arguments); }
var SvgInfo48 = function SvgInfo48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$dw({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$dh || (_path$dh = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M24 19a1.2 1.2 0 0 1-1.2-1.2v-.2a1.2 1.2 0 0 1 2.4 0v.2A1.2 1.2 0 0 1 24 19M22.8 30.4a1.2 1.2 0 0 0 2.4 0V22a1.2 1.2 0 0 0-2.4 0z"
  })), _path2$47 || (_path2$47 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M24 44c11.045 0 20-8.954 20-20S35.045 4 24 4 4 12.954 4 24s8.954 20 20 20m0-2.4c9.72 0 17.6-7.88 17.6-17.6S33.72 6.4 24 6.4 6.4 14.28 6.4 24 14.28 41.6 24 41.6",
    clipRule: "evenodd"
  })));
};

var InfoIcon = function InfoIcon(props) {
  var info = {
    12: SvgInfo12,
    16: SvgInfo16,
    18: SvgInfo18,
    24: SvgInfo24,
    32: SvgInfo32,
    48: SvgInfo48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: info
  }, props));
};

var _path$dg;
function _extends$dv() { return _extends$dv = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$dv.apply(null, arguments); }
var SvgAlertFilled12 = function SvgAlertFilled12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$dv({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$dg || (_path$dg = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "m1.066 7.435 2.822-5.08C4.802.71 7.169.71 8.084 2.356l2.822 5.08c.888 1.6-.269 3.565-2.098 3.565H3.164c-1.83 0-2.986-1.966-2.098-3.565M6 4a.6.6 0 0 1 .6.6v2.1a.6.6 0 0 1-1.2 0V4.6A.6.6 0 0 1 6 4m0 3.8a.6.6 0 0 1 .6.6v.05a.6.6 0 1 1-1.2 0V8.4a.6.6 0 0 1 .6-.6",
    clipRule: "evenodd"
  })));
};

var _path$df;
function _extends$du() { return _extends$du = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$du.apply(null, arguments); }
var SvgAlertFilled16 = function SvgAlertFilled16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$du({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$df || (_path$df = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M1.51 9.961 5.271 3.19c1.18-2.126 4.238-2.126 5.42 0l3.762 6.772c1.147 2.067-.347 4.606-2.71 4.606H4.219c-2.363 0-3.858-2.54-2.71-4.606M8 5.351a.75.75 0 0 1 .75.75v2.8a.75.75 0 0 1-1.5 0V6.1A.75.75 0 0 1 8 5.35m0 4.899a.75.75 0 0 1 .75.75v.067a.75.75 0 0 1-1.5 0V11a.75.75 0 0 1 .75-.75",
    clipRule: "evenodd"
  })));
};

var _path$de;
function _extends$dt() { return _extends$dt = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$dt.apply(null, arguments); }
var SvgAlertFilled18 = function SvgAlertFilled18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$dt({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$de || (_path$de = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "m1.746 11.816 4.742-8.537c1.086-1.954 3.897-1.954 4.983 0l4.742 8.537c1.055 1.9-.318 4.234-2.491 4.234H4.237c-2.173 0-3.547-2.335-2.491-4.234M9 6a.8.8 0 0 1 .8.8v3.15a.8.8 0 0 1-1.6 0V6.8A.8.8 0 0 1 9 6m0 5.4a.8.8 0 0 1 .8.8v.075a.8.8 0 0 1-1.6 0V12.2a.8.8 0 0 1 .8-.8",
    clipRule: "evenodd"
  })));
};

var _path$dd;
function _extends$ds() { return _extends$ds = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$ds.apply(null, arguments); }
var SvgAlertFilled24 = function SvgAlertFilled24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$ds({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$dd || (_path$dd = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M2.657 15.16 8.301 5.002c1.6-2.88 5.742-2.88 7.342 0l5.644 10.158c1.555 2.8-.47 6.24-3.672 6.24H6.33c-3.203 0-5.227-3.44-3.672-6.24M12 8.8a.9.9 0 0 1 .9.9v4.2a.9.9 0 1 1-1.8 0V9.7a.9.9 0 0 1 .9-.9m0 6.7a.9.9 0 0 1 .9.9v.1a.9.9 0 1 1-1.8 0v-.1a.9.9 0 0 1 .9-.9",
    clipRule: "evenodd"
  })));
};

var _path$dc;
function _extends$dr() { return _extends$dr = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$dr.apply(null, arguments); }
var SvgAlertFilled32 = function SvgAlertFilled32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$dr({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$dc || (_path$dc = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "m3.893 20.408 7.524-13.544c1.982-3.567 7.11-3.567 9.092 0l7.524 13.544c1.926 3.466-.58 7.725-4.546 7.725H8.439c-3.964 0-6.47-4.26-4.545-7.725M16 11.933a1 1 0 0 1 1 1v5.6a1 1 0 1 1-2 0v-5.6a1 1 0 0 1 1-1m0 8.934a1 1 0 0 1 1 1V22a1 1 0 1 1-2 0v-.133a1 1 0 0 1 1-1",
    clipRule: "evenodd"
  })));
};

var _path$db;
function _extends$dq() { return _extends$dq = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$dq.apply(null, arguments); }
var SvgAlertFilled48 = function SvgAlertFilled48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$dq({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$db || (_path$db = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M6.364 30.903 17.65 10.587c2.743-4.938 9.844-4.938 12.587 0l11.287 20.316c2.666 4.8-.804 10.697-6.294 10.697H12.658c-5.49 0-8.96-5.898-6.294-10.697M24 18.1a1.3 1.3 0 0 1 1.3 1.3v8.4a1.3 1.3 0 1 1-2.6 0v-8.4a1.3 1.3 0 0 1 1.3-1.3m0 13.4a1.3 1.3 0 0 1 1.3 1.3v.2a1.3 1.3 0 1 1-2.6 0v-.2a1.3 1.3 0 0 1 1.3-1.3",
    clipRule: "evenodd"
  })));
};

var AlertFilledIcon = function AlertFilledIcon(props) {
  var alertFilled = {
    12: SvgAlertFilled12,
    16: SvgAlertFilled16,
    18: SvgAlertFilled18,
    24: SvgAlertFilled24,
    32: SvgAlertFilled32,
    48: SvgAlertFilled48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: alertFilled
  }, props));
};

var _g$e, _defs$e;
function _extends$dp() { return _extends$dp = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$dp.apply(null, arguments); }
var SvgAdd12 = function SvgAdd12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$dp({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _g$e || (_g$e = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#add_12_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M6.6 1.5a.6.6 0 0 0-1.2 0v3.9H1.5a.6.6 0 0 0 0 1.2h3.9v3.9a.6.6 0 1 0 1.2 0V6.6h3.9a.6.6 0 1 0 0-1.2H6.6z"
  }))), _defs$e || (_defs$e = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "add_12_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h12v12H0z"
  })))));
};

var _path$da;
function _extends$do() { return _extends$do = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$do.apply(null, arguments); }
var SvgAdd16 = function SvgAdd16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$do({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$da || (_path$da = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M8.75 2a.75.75 0 0 0-1.5 0v5.25H2a.75.75 0 0 0 0 1.5h5.25V14a.75.75 0 0 0 1.5 0V8.75H14a.75.75 0 0 0 0-1.5H8.75z"
  })));
};

var _path$d9;
function _extends$dn() { return _extends$dn = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$dn.apply(null, arguments); }
var SvgAdd18 = function SvgAdd18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$dn({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$d9 || (_path$d9 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M9.8 2.25a.8.8 0 1 0-1.6 0V8.2H2.25a.8.8 0 0 0 0 1.6H8.2v5.95a.8.8 0 0 0 1.6 0V9.8h5.95a.8.8 0 0 0 0-1.6H9.8z"
  })));
};

var _path$d8;
function _extends$dm() { return _extends$dm = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$dm.apply(null, arguments); }
var SvgAdd24 = function SvgAdd24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$dm({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$d8 || (_path$d8 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M12.9 3a.9.9 0 1 0-1.8 0v8.1H3a.9.9 0 1 0 0 1.8h8.1V21a.9.9 0 0 0 1.8 0v-8.1H21a.9.9 0 0 0 0-1.8h-8.1z"
  })));
};

var _path$d7;
function _extends$dl() { return _extends$dl = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$dl.apply(null, arguments); }
var SvgAdd32 = function SvgAdd32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$dl({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$d7 || (_path$d7 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M17 4a1 1 0 1 0-2 0v11H4a1 1 0 1 0 0 2h11v11a1 1 0 1 0 2 0V17h11a1 1 0 1 0 0-2H17z"
  })));
};

var _path$d6;
function _extends$dk() { return _extends$dk = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$dk.apply(null, arguments); }
var SvgAdd48 = function SvgAdd48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$dk({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$d6 || (_path$d6 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M25.2 6a1.2 1.2 0 1 0-2.4 0v16.8H6a1.2 1.2 0 0 0 0 2.4h16.8V42a1.2 1.2 0 0 0 2.4 0V25.2H42a1.2 1.2 0 1 0 0-2.4H25.2z"
  })));
};

var AddIcon = function AddIcon(props) {
  var add = {
    12: SvgAdd12,
    16: SvgAdd16,
    18: SvgAdd18,
    24: SvgAdd24,
    32: SvgAdd32,
    48: SvgAdd48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: add
  }, props));
};

var _path$d5, _path2$46, _path3$F;
function _extends$dj() { return _extends$dj = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$dj.apply(null, arguments); }
var SvgAddCircle12 = function SvgAddCircle12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$dj({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$d5 || (_path$d5 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M2.2 6a3.8 3.8 0 1 0 7.6 0 3.8 3.8 0 0 0-7.6 0M6 1a5 5 0 1 0 0 10A5 5 0 0 0 6 1",
    clipRule: "evenodd"
  })), _path2$46 || (_path2$46 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M6 3.8a.45.45 0 0 1 .45.45v3.5a.45.45 0 1 1-.9 0v-3.5A.45.45 0 0 1 6 3.8",
    clipRule: "evenodd"
  })), _path3$F || (_path3$F = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8.2 6a.45.45 0 0 1-.45.45h-3.5a.45.45 0 1 1 0-.9h3.5A.45.45 0 0 1 8.2 6",
    clipRule: "evenodd"
  })));
};

var _path$d4, _path2$45, _path3$E;
function _extends$di() { return _extends$di = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$di.apply(null, arguments); }
var SvgAddCircle16 = function SvgAddCircle16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$di({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$d4 || (_path$d4 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M2.834 8a5.167 5.167 0 1 0 10.333 0A5.167 5.167 0 0 0 2.834 8M8 1.333a6.667 6.667 0 1 0 0 13.333A6.667 6.667 0 0 0 8 1.333",
    clipRule: "evenodd"
  })), _path2$45 || (_path2$45 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8 4.9a.6.6 0 0 1 .6.6v5a.6.6 0 0 1-1.2 0v-5a.6.6 0 0 1 .6-.6",
    clipRule: "evenodd"
  })), _path3$E || (_path3$E = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M11.1 8a.6.6 0 0 1-.6.6h-5a.6.6 0 0 1 0-1.2h5a.6.6 0 0 1 .6.6",
    clipRule: "evenodd"
  })));
};

var _path$d3, _path2$44, _path3$D;
function _extends$dh() { return _extends$dh = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$dh.apply(null, arguments); }
var SvgAddCircle18 = function SvgAddCircle18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$dh({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$d3 || (_path$d3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M3.1 9a5.9 5.9 0 1 0 11.8 0A5.9 5.9 0 0 0 3.1 9M9 1.5a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15",
    clipRule: "evenodd"
  })), _path2$44 || (_path2$44 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M9 5.6a.65.65 0 0 1 .65.65v5.5a.65.65 0 1 1-1.3 0v-5.5A.65.65 0 0 1 9 5.6",
    clipRule: "evenodd"
  })), _path3$D || (_path3$D = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M12.4 9a.65.65 0 0 1-.65.65h-5.5a.65.65 0 0 1 0-1.3h5.5a.65.65 0 0 1 .65.65",
    clipRule: "evenodd"
  })));
};

var _path$d2, _path2$43, _path3$C;
function _extends$dg() { return _extends$dg = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$dg.apply(null, arguments); }
var SvgAddCircle24 = function SvgAddCircle24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$dg({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$d2 || (_path$d2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M3.8 12a8.2 8.2 0 1 0 16.4 0 8.2 8.2 0 0 0-16.4 0M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2",
    clipRule: "evenodd"
  })), _path2$43 || (_path2$43 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M12 7.2a.8.8 0 0 1 .8.8v8a.8.8 0 0 1-1.6 0V8a.8.8 0 0 1 .8-.8",
    clipRule: "evenodd"
  })), _path3$C || (_path3$C = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M16.8 12a.8.8 0 0 1-.8.8H8a.8.8 0 0 1 0-1.6h8a.8.8 0 0 1 .8.8",
    clipRule: "evenodd"
  })));
};

var _path$d1, _path2$42, _path3$B;
function _extends$df() { return _extends$df = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$df.apply(null, arguments); }
var SvgAddCircle32 = function SvgAddCircle32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$df({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$d1 || (_path$d1 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M4.667 16c0 6.26 5.074 11.333 11.333 11.333S27.333 22.26 27.333 16 22.26 4.667 16 4.667 4.667 9.74 4.667 16M16 2.667C8.636 2.666 2.667 8.636 2.667 16S8.636 29.333 16 29.333 29.333 23.363 29.333 16 23.363 2.667 16 2.667",
    clipRule: "evenodd"
  })), _path2$42 || (_path2$42 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M16 9.05a.95.95 0 0 1 .95.95v12a.95.95 0 0 1-1.9 0V10a.95.95 0 0 1 .95-.95",
    clipRule: "evenodd"
  })), _path3$B || (_path3$B = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M22.95 16a.95.95 0 0 1-.95.95H10a.95.95 0 1 1 0-1.9h12a.95.95 0 0 1 .95.95",
    clipRule: "evenodd"
  })));
};

var _path$d0, _path2$41, _path3$A;
function _extends$de() { return _extends$de = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$de.apply(null, arguments); }
var SvgAddCircle48 = function SvgAddCircle48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$de({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$d0 || (_path$d0 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M6.4 24c0 9.72 7.88 17.6 17.6 17.6S41.6 33.72 41.6 24 33.72 6.4 24 6.4 6.4 14.28 6.4 24M24 4C12.954 4 4 12.954 4 24s8.954 20 20 20 20-8.954 20-20S35.046 4 24 4",
    clipRule: "evenodd"
  })), _path2$41 || (_path2$41 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M24 13.9a1.1 1.1 0 0 1 1.1 1.1v18a1.1 1.1 0 0 1-2.2 0V15a1.1 1.1 0 0 1 1.1-1.1",
    clipRule: "evenodd"
  })), _path3$A || (_path3$A = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M34.1 24a1.1 1.1 0 0 1-1.1 1.1H15a1.1 1.1 0 0 1 0-2.2h18a1.1 1.1 0 0 1 1.1 1.1",
    clipRule: "evenodd"
  })));
};

var AddCircleIcon = function AddCircleIcon(props) {
  var addCircle = {
    12: SvgAddCircle12,
    16: SvgAddCircle16,
    18: SvgAddCircle18,
    24: SvgAddCircle24,
    32: SvgAddCircle32,
    48: SvgAddCircle48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: addCircle
  }, props));
};

var _path$c$;
function _extends$dd() { return _extends$dd = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$dd.apply(null, arguments); }
var SvgAddCircleFilled12 = function SvgAddCircleFilled12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$dd({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$c$ || (_path$c$ = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M6 1a5 5 0 1 0 0 10A5 5 0 0 0 6 1m.45 3.25a.45.45 0 1 0-.9 0v1.3h-1.3a.45.45 0 1 0 0 .9h1.3v1.3a.45.45 0 1 0 .9 0v-1.3h1.3a.45.45 0 1 0 0-.9h-1.3z",
    clipRule: "evenodd"
  })));
};

var _path$c_;
function _extends$dc() { return _extends$dc = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$dc.apply(null, arguments); }
var SvgAddCircleFilled16 = function SvgAddCircleFilled16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$dc({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$c_ || (_path$c_ = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8 1.333a6.667 6.667 0 1 0 0 13.333A6.667 6.667 0 0 0 8 1.333M8.6 5.5a.6.6 0 0 0-1.2 0v1.9H5.5a.6.6 0 0 0 0 1.2h1.9v1.9a.6.6 0 0 0 1.2 0V8.6h1.9a.6.6 0 1 0 0-1.2H8.6z",
    clipRule: "evenodd"
  })));
};

var _path$cZ;
function _extends$db() { return _extends$db = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$db.apply(null, arguments); }
var SvgAddCircleFilled18 = function SvgAddCircleFilled18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$db({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$cZ || (_path$cZ = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M9 1.5a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15m.65 4.75a.65.65 0 0 0-1.3 0v2.1h-2.1a.65.65 0 1 0 0 1.3h2.1v2.1a.65.65 0 1 0 1.3 0v-2.1h2.1a.65.65 0 1 0 0-1.3h-2.1z",
    clipRule: "evenodd"
  })));
};

var _path$cY;
function _extends$da() { return _extends$da = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$da.apply(null, arguments); }
var SvgAddCircleFilled24 = function SvgAddCircleFilled24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$da({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$cY || (_path$cY = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2m.8 6a.8.8 0 0 0-1.6 0v3.2H8a.8.8 0 1 0 0 1.6h3.2V16a.8.8 0 1 0 1.6 0v-3.2H16a.8.8 0 0 0 0-1.6h-3.2z",
    clipRule: "evenodd"
  })));
};

var _path$cX;
function _extends$d9() { return _extends$d9 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$d9.apply(null, arguments); }
var SvgAddCircleFilled32 = function SvgAddCircleFilled32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$d9({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$cX || (_path$cX = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M16 2.667C8.636 2.667 2.667 8.637 2.667 16S8.636 29.334 16 29.334 29.333 23.364 29.333 16 23.363 2.667 16 2.667M16.95 10a.95.95 0 0 0-1.9 0v5.05H10a.95.95 0 0 0 0 1.9h5.05V22a.95.95 0 0 0 1.9 0v-5.05H22a.95.95 0 1 0 0-1.9h-5.05z",
    clipRule: "evenodd"
  })));
};

var _path$cW;
function _extends$d8() { return _extends$d8 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$d8.apply(null, arguments); }
var SvgAddCircleFilled48 = function SvgAddCircleFilled48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$d8({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$cW || (_path$cW = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M24 4C12.954 4 4 12.954 4 24s8.954 20 20 20 20-8.954 20-20S35.046 4 24 4m1.1 11a1.1 1.1 0 0 0-2.2 0v7.9H15a1.1 1.1 0 0 0 0 2.2h7.9V33a1.1 1.1 0 0 0 2.2 0v-7.9H33a1.1 1.1 0 0 0 0-2.2h-7.9z",
    clipRule: "evenodd"
  })));
};

var AddCircleFilledIcon = function AddCircleFilledIcon(props) {
  var addCircleFilled = {
    12: SvgAddCircleFilled12,
    16: SvgAddCircleFilled16,
    18: SvgAddCircleFilled18,
    24: SvgAddCircleFilled24,
    32: SvgAddCircleFilled32,
    48: SvgAddCircleFilled48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: addCircleFilled
  }, props));
};

var _path$cV, _path2$40;
function _extends$d7() { return _extends$d7 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$d7.apply(null, arguments); }
var SvgAlert12 = function SvgAlert12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$d7({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$cV || (_path$cV = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M6 4a.6.6 0 0 1 .6.6v2.1a.6.6 0 0 1-1.2 0V4.6A.6.6 0 0 1 6 4M6 7.65a.6.6 0 0 1 .6.6v.05a.6.6 0 0 1-1.2 0v-.05a.6.6 0 0 1 .6-.6"
  })), _path2$40 || (_path2$40 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M3.888 2.356 1.066 7.435C.178 9.035 1.334 11 3.164 11h5.644c1.83 0 2.986-1.966 2.098-3.565l-2.822-5.08C7.169.71 4.802.71 3.888 2.356M3.164 9.8a1.2 1.2 0 0 1-1.049-1.783l2.822-5.079a1.2 1.2 0 0 1 2.098 0l2.822 5.08A1.2 1.2 0 0 1 8.807 9.8z",
    clipRule: "evenodd"
  })));
};

var _path$cU, _path2$3$;
function _extends$d6() { return _extends$d6 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$d6.apply(null, arguments); }
var SvgAlert16 = function SvgAlert16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$d6({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$cU || (_path$cU = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M8 5.35a.75.75 0 0 1 .75.75v2.8a.75.75 0 0 1-1.5 0V6.1A.75.75 0 0 1 8 5.35M8 10.05a.75.75 0 0 1 .75.75v.067a.75.75 0 0 1-1.5 0V10.8a.75.75 0 0 1 .75-.75"
  })), _path2$3$ || (_path2$3$ = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M5.272 3.19 1.509 9.96c-1.148 2.066.347 4.606 2.71 4.606h7.525c2.363 0 3.858-2.54 2.71-4.606L10.69 3.19c-1.18-2.126-4.238-2.126-5.42 0m-2.451 7.5 3.762-6.772c.61-1.098 2.188-1.098 2.797 0l3.762 6.772a1.6 1.6 0 0 1-1.398 2.377H4.219a1.6 1.6 0 0 1-1.398-2.377",
    clipRule: "evenodd"
  })));
};

var _path$cT, _path2$3_;
function _extends$d5() { return _extends$d5 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$d5.apply(null, arguments); }
var SvgAlert18 = function SvgAlert18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$d5({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$cT || (_path$cT = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M9 6a.8.8 0 0 1 .8.8v3.15a.8.8 0 0 1-1.6 0V6.8A.8.8 0 0 1 9 6M9 11.2a.8.8 0 0 1 .8.8v.075a.8.8 0 0 1-1.6 0V12a.8.8 0 0 1 .8-.8"
  })), _path2$3_ || (_path2$3_ = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "m6.182 3.315-4.573 8.23C.425 13.68 1.967 16.3 4.407 16.3h9.145c2.44 0 3.982-2.621 2.797-4.754l-4.572-8.23c-1.22-2.195-4.376-2.195-5.595 0m4.196.777 4.572 8.23a1.6 1.6 0 0 1-1.398 2.378H4.407a1.6 1.6 0 0 1-1.399-2.377l4.573-8.23c.61-1.098 2.187-1.098 2.797 0",
    clipRule: "evenodd"
  })));
};

var _path$cS, _path2$3Z;
function _extends$d4() { return _extends$d4 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$d4.apply(null, arguments); }
var SvgAlert24 = function SvgAlert24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$d4({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$cS || (_path$cS = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M12 8.8a.9.9 0 0 1 .9.9v4.2a.9.9 0 1 1-1.8 0V9.7a.9.9 0 0 1 .9-.9M12 15.5a.9.9 0 0 1 .9.9v.1a.9.9 0 1 1-1.8 0v-.1a.9.9 0 0 1 .9-.9"
  })), _path2$3Z || (_path2$3Z = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8.3 5.002 2.658 15.16c-1.555 2.8.47 6.24 3.672 6.24h11.286c3.203 0 5.227-3.44 3.672-6.24L15.643 5.002c-1.6-2.88-5.742-2.88-7.342 0M4.23 16.034 9.875 5.876c.914-1.646 3.282-1.646 4.196 0l5.643 10.158c.89 1.6-.268 3.566-2.098 3.566H6.33c-1.83 0-2.987-1.966-2.098-3.566",
    clipRule: "evenodd"
  })));
};

var _path$cR, _path2$3Y;
function _extends$d3() { return _extends$d3 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$d3.apply(null, arguments); }
var SvgAlert32 = function SvgAlert32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$d3({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$cR || (_path$cR = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M16 11.933a1 1 0 0 1 1 1v5.6a1 1 0 1 1-2 0v-5.6a1 1 0 0 1 1-1M16 20.867a1 1 0 0 1 1 1V22a1 1 0 1 1-2 0v-.133a1 1 0 0 1 1-1"
  })), _path2$3Y || (_path2$3Y = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M11.417 6.864 3.893 20.408c-1.926 3.466.58 7.725 4.545 7.725h15.05c3.964 0 6.47-4.26 4.545-7.725L20.51 6.864c-1.982-3.567-7.11-3.567-9.092 0M5.641 21.379l7.525-13.544c1.219-2.195 4.375-2.195 5.594 0l7.525 13.544c1.185 2.133-.358 4.754-2.797 4.754H8.438c-2.44 0-3.982-2.621-2.797-4.754",
    clipRule: "evenodd"
  })));
};

var _path$cQ, _path2$3X;
function _extends$d2() { return _extends$d2 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$d2.apply(null, arguments); }
var SvgAlert48 = function SvgAlert48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$d2({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$cQ || (_path$cQ = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M24 18.2a1.2 1.2 0 0 1 1.2 1.2v8.4a1.2 1.2 0 0 1-2.4 0v-8.4a1.2 1.2 0 0 1 1.2-1.2M24 31.5a1.3 1.3 0 0 1 1.3 1.3v.2a1.3 1.3 0 1 1-2.6 0v-.2a1.3 1.3 0 0 1 1.3-1.3"
  })), _path2$3X || (_path2$3X = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M17.65 10.587 6.365 30.903c-2.666 4.8.804 10.697 6.294 10.697H35.23c5.49 0 8.96-5.898 6.294-10.697L30.238 10.587c-2.743-4.938-9.844-4.938-12.587 0M8.463 32.07l11.286-20.316c1.83-3.292 6.563-3.292 8.392 0l11.287 20.316c1.778 3.2-.536 7.131-4.196 7.131H12.658c-3.66 0-5.974-3.932-4.196-7.131",
    clipRule: "evenodd"
  })));
};

var AlertIcon = function AlertIcon(props) {
  var alert = {
    12: SvgAlert12,
    16: SvgAlert16,
    18: SvgAlert18,
    24: SvgAlert24,
    32: SvgAlert32,
    48: SvgAlert48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: alert
  }, props));
};

var _path$cP;
function _extends$d1() { return _extends$d1 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$d1.apply(null, arguments); }
var SvgArrowClockwise12 = function SvgArrowClockwise12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$d1({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$cP || (_path$cP = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M2.15 6a3.85 3.85 0 0 1 6.47-2.82l-.308.308A.3.3 0 0 0 8.524 4H10a.3.3 0 0 0 .3-.3V2.224a.3.3 0 0 0-.512-.212l-.248.248A5.15 5.15 0 1 0 11.15 6a.65.65 0 1 0-1.3 0 3.85 3.85 0 0 1-7.7 0"
  })));
};

var _path$cO;
function _extends$d0() { return _extends$d0 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$d0.apply(null, arguments); }
var SvgArrowClockwise16 = function SvgArrowClockwise16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$d0({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$cO || (_path$cO = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M2.8 8a5.2 5.2 0 0 1 8.746-3.803l-.453.454a.4.4 0 0 0 .283.683h1.967a.4.4 0 0 0 .4-.4V2.966a.4.4 0 0 0-.683-.283l-.382.382A6.8 6.8 0 1 0 14.8 8a.8.8 0 0 0-1.6 0A5.2 5.2 0 0 1 2.8 8"
  })));
};

var _path$cN;
function _extends$c$() { return _extends$c$ = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$c$.apply(null, arguments); }
var SvgArrowClockwise18 = function SvgArrowClockwise18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$c$({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$cN || (_path$cN = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M3.05 9a5.95 5.95 0 0 1 10.03-4.33l-.476.477a.5.5 0 0 0 .353.853H15a.5.5 0 0 0 .5-.5V3.457a.5.5 0 0 0-.854-.353l-.434.434A7.55 7.55 0 1 0 16.55 9a.8.8 0 0 0-1.6 0 5.95 5.95 0 0 1-11.9 0"
  })));
};

var _path$cM;
function _extends$c_() { return _extends$c_ = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$c_.apply(null, arguments); }
var SvgArrowClockwise24 = function SvgArrowClockwise24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$c_({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$cM || (_path$cM = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M3.9 12a8.1 8.1 0 0 1 13.727-5.827l-.632.632A.7.7 0 0 0 17.49 8h2.61a.7.7 0 0 0 .7-.7V4.69a.7.7 0 0 0-1.195-.495L18.9 4.9A9.87 9.87 0 0 0 12 2.1c-5.468 0-9.9 4.432-9.9 9.9s4.432 9.9 9.9 9.9 9.9-4.432 9.9-9.9a.9.9 0 1 0-1.8 0 8.1 8.1 0 0 1-16.2 0"
  })));
};

var _path$cL;
function _extends$cZ() { return _extends$cZ = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$cZ.apply(null, arguments); }
var SvgArrowClockwise32 = function SvgArrowClockwise32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$cZ({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$cL || (_path$cL = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M5 16C5 9.925 9.925 5 16 5a10.96 10.96 0 0 1 7.61 3.057l-.903.903c-.63.63-.184 1.707.707 1.707h3.253a1 1 0 0 0 1-1V6.414c0-.89-1.078-1.337-1.707-.707l-.936.935A12.96 12.96 0 0 0 16 3C8.82 3 3 8.82 3 16s5.82 13 13 13 13-5.82 13-13a1 1 0 1 0-2 0c0 6.075-4.925 11-11 11S5 22.075 5 16"
  })));
};

var _path$cK;
function _extends$cY() { return _extends$cY = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$cY.apply(null, arguments); }
var SvgArrowClockwise48 = function SvgArrowClockwise48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$cY({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$cK || (_path$cK = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M7.2 24C7.2 14.72 14.722 7.2 24 7.2a16.74 16.74 0 0 1 11.627 4.673l-1.566 1.566c-.945.945-.276 2.56 1.06 2.56H40a1.5 1.5 0 0 0 1.5-1.5V9.622c0-1.336-1.616-2.005-2.56-1.06l-1.616 1.615A19.14 19.14 0 0 0 24 4.8C13.396 4.8 4.8 13.396 4.8 24S13.396 43.2 24 43.2 43.2 34.604 43.2 24a1.2 1.2 0 0 0-2.4 0c0 9.278-7.522 16.8-16.8 16.8S7.2 33.278 7.2 24"
  })));
};

var ArrowClockwiseIcon = function ArrowClockwiseIcon(props) {
  var arrowClockwise = {
    12: SvgArrowClockwise12,
    16: SvgArrowClockwise16,
    18: SvgArrowClockwise18,
    24: SvgArrowClockwise24,
    32: SvgArrowClockwise32,
    48: SvgArrowClockwise48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: arrowClockwise
  }, props));
};

var _path$cJ;
function _extends$cX() { return _extends$cX = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$cX.apply(null, arguments); }
var SvgArrowDown12 = function SvgArrowDown12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$cX({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$cJ || (_path$cJ = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M10.672 5.432a.6.6 0 0 0-.847.05l-3.218 3.62V1.33a.6.6 0 0 0-1.2 0v7.772l-3.218-3.62a.6.6 0 0 0-.897.797l4.266 4.8a.6.6 0 0 0 .897 0l4.267-4.8a.6.6 0 0 0-.05-.847",
    clipRule: "evenodd"
  })));
};

var _path$cI;
function _extends$cW() { return _extends$cW = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$cW.apply(null, arguments); }
var SvgArrowDown16 = function SvgArrowDown16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$cW({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$cI || (_path$cI = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M14.186 7.276a.75.75 0 0 0-1.059.062L8.75 12.264V1.77a.75.75 0 1 0-1.5 0v10.494L2.87 7.338a.75.75 0 1 0-1.121.997l5.688 6.4a.75.75 0 0 0 1.122 0l5.688-6.4a.75.75 0 0 0-.062-1.059",
    clipRule: "evenodd"
  })));
};

var _path$cH;
function _extends$cV() { return _extends$cV = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$cV.apply(null, arguments); }
var SvgArrowDown18 = function SvgArrowDown18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$cV({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$cH || (_path$cH = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M15.931 8.217a.8.8 0 0 0-1.13.066L9.8 13.911V1.99a.8.8 0 1 0-1.6 0v11.92L3.198 8.284a.8.8 0 1 0-1.196 1.063l6.4 7.2a.8.8 0 0 0 1.196 0l6.4-7.2a.8.8 0 0 0-.067-1.129",
    clipRule: "evenodd"
  })));
};

var _path$cG;
function _extends$cU() { return _extends$cU = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$cU.apply(null, arguments); }
var SvgArrowDown24 = function SvgArrowDown24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$cU({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$cG || (_path$cG = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M21.125 11.087a.9.9 0 0 0-1.27.075l-6.962 7.83V2.66a.9.9 0 1 0-1.8 0v16.333l-6.96-7.831a.9.9 0 0 0-1.346 1.196l8.534 9.6a.9.9 0 0 0 1.345 0l8.533-9.6a.9.9 0 0 0-.074-1.27",
    clipRule: "evenodd"
  })));
};

var _path$cF;
function _extends$cT() { return _extends$cT = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$cT.apply(null, arguments); }
var SvgArrowDown32 = function SvgArrowDown32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$cT({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$cF || (_path$cF = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M28.04 14.926a1 1 0 0 0-1.412.083l-9.63 10.834V3.54a1 1 0 1 0-2 0v22.303L5.368 15.01a1 1 0 1 0-1.495 1.329l11.378 12.8a1 1 0 0 0 1.494 0l11.378-12.8a1 1 0 0 0-.083-1.412",
    clipRule: "evenodd"
  })));
};

var _path$cE;
function _extends$cS() { return _extends$cS = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$cS.apply(null, arguments); }
var SvgArrowDown48 = function SvgArrowDown48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$cS({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$cE || (_path$cE = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M41.87 22.613a1.2 1.2 0 0 0-1.693.1l-14.97 16.84V5.31a1.2 1.2 0 1 0-2.4 0v34.244L7.837 22.713a1.2 1.2 0 0 0-1.794 1.594l17.067 19.2a1.2 1.2 0 0 0 1.794 0l17.067-19.2a1.2 1.2 0 0 0-.1-1.694",
    clipRule: "evenodd"
  })));
};

var ArrowDownIcon = function ArrowDownIcon(props) {
  var arrowDown = {
    12: SvgArrowDown12,
    16: SvgArrowDown16,
    18: SvgArrowDown18,
    24: SvgArrowDown24,
    32: SvgArrowDown32,
    48: SvgArrowDown48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: arrowDown
  }, props));
};

var _path$cD;
function _extends$cR() { return _extends$cR = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$cR.apply(null, arguments); }
var SvgArrowLeft12 = function SvgArrowLeft12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$cR({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$cD || (_path$cD = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M6.648 1.331a.6.6 0 0 1-.05.847l-3.62 3.219h7.772a.6.6 0 1 1 0 1.2H2.978l3.62 3.218a.6.6 0 1 1-.797.897l-4.8-4.267a.6.6 0 0 1 0-.897l4.8-4.267a.6.6 0 0 1 .847.05",
    clipRule: "evenodd"
  })));
};

var _path$cC;
function _extends$cQ() { return _extends$cQ = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$cQ.apply(null, arguments); }
var SvgArrowLeft16 = function SvgArrowLeft16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$cQ({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$cC || (_path$cC = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8.83 1.808a.75.75 0 0 1-.062 1.06L3.843 7.245h10.494a.75.75 0 0 1 0 1.5H3.843l4.925 4.378a.75.75 0 1 1-.996 1.121l-6.4-5.689a.75.75 0 0 1 0-1.121l6.4-5.689a.75.75 0 0 1 1.059.062",
    clipRule: "evenodd"
  })));
};

var _path$cB;
function _extends$cP() { return _extends$cP = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$cP.apply(null, arguments); }
var SvgArrowLeft18 = function SvgArrowLeft18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$cP({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$cB || (_path$cB = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M9.898 2.063a.8.8 0 0 1-.066 1.13L4.204 8.195h11.921a.8.8 0 1 1 0 1.6H4.205l5.627 5.002a.8.8 0 1 1-1.063 1.196l-7.2-6.4a.8.8 0 0 1 0-1.196l7.2-6.4a.8.8 0 0 1 1.129.066",
    clipRule: "evenodd"
  })));
};

var _path$cA;
function _extends$cO() { return _extends$cO = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$cO.apply(null, arguments); }
var SvgArrowLeft24 = function SvgArrowLeft24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$cO({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$cA || (_path$cA = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M13.073 2.862a.9.9 0 0 1-.075 1.27l-7.83 6.961H21.5a.9.9 0 1 1 0 1.8H5.167l7.83 6.961a.9.9 0 1 1-1.195 1.345l-9.6-8.533a.9.9 0 0 1 0-1.345l9.6-8.534a.9.9 0 0 1 1.27.075",
    clipRule: "evenodd"
  })));
};

var _path$cz;
function _extends$cN() { return _extends$cN = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$cN.apply(null, arguments); }
var SvgArrowLeft32 = function SvgArrowLeft32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$cN({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$cz || (_path$cz = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M17.277 3.949a1 1 0 0 1-.083 1.412L6.36 14.99h22.303a1 1 0 1 1 0 2H6.36l10.834 9.63a1 1 0 0 1-1.328 1.495l-12.8-11.378a1 1 0 0 1 0-1.494l12.8-11.378a1 1 0 0 1 1.411.083",
    clipRule: "evenodd"
  })));
};

var _path$cy;
function _extends$cM() { return _extends$cM = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$cM.apply(null, arguments); }
var SvgArrowLeft48 = function SvgArrowLeft48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$cM({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$cy || (_path$cy = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M25.697 6.123a1.2 1.2 0 0 1-.1 1.694l-16.84 14.97H43a1.2 1.2 0 0 1 0 2.4H8.756l16.841 14.97a1.2 1.2 0 1 1-1.594 1.793l-19.2-17.067a1.2 1.2 0 0 1 0-1.793l19.2-17.067a1.2 1.2 0 0 1 1.694.1",
    clipRule: "evenodd"
  })));
};

var ArrowLeftIcon = function ArrowLeftIcon(props) {
  var arrowLeft = {
    12: SvgArrowLeft12,
    16: SvgArrowLeft16,
    18: SvgArrowLeft18,
    24: SvgArrowLeft24,
    32: SvgArrowLeft32,
    48: SvgArrowLeft48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: arrowLeft
  }, props));
};

var _g$d, _defs$d;
function _extends$cL() { return _extends$cL = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$cL.apply(null, arguments); }
var SvgArrowLeftArrowRight12 = function SvgArrowLeftArrowRight12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$cL({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 480 480"
  }, props), _g$d || (_g$d = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 48,
    clipPath: "url(#arrowLeftArrowRight_12_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98 146h284m-284 0 88 88m-88-88 88-88m196 276H98m284 0-88-88m88 88-88 88"
  }))), _defs$d || (_defs$d = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "arrowLeftArrowRight_12_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h480v480H0z"
  })))));
};

var _g$c, _defs$c;
function _extends$cK() { return _extends$cK = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$cK.apply(null, arguments); }
var SvgArrowLeftArrowRight16 = function SvgArrowLeftArrowRight16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$cK({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 480 480"
  }, props), _g$c || (_g$c = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 45,
    clipPath: "url(#arrowLeftArrowRight_16_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98 146h284m-284 0 88 88m-88-88 88-88m196 276H98m284 0-88-88m88 88-88 88"
  }))), _defs$c || (_defs$c = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "arrowLeftArrowRight_16_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h480v480H0z"
  })))));
};

var _g$b, _defs$b;
function _extends$cJ() { return _extends$cJ = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$cJ.apply(null, arguments); }
var SvgArrowLeftArrowRight18 = function SvgArrowLeftArrowRight18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$cJ({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 480 480"
  }, props), _g$b || (_g$b = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 42.67,
    clipPath: "url(#arrowLeftArrowRight_18_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98 146h284m-284 0 88 88m-88-88 88-88m196 276H98m284 0-88-88m88 88-88 88"
  }))), _defs$b || (_defs$b = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "arrowLeftArrowRight_18_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h480v480H0z"
  })))));
};

var _g$a, _defs$a;
function _extends$cI() { return _extends$cI = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$cI.apply(null, arguments); }
var SvgArrowLeftArrowRight24 = function SvgArrowLeftArrowRight24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$cI({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 480 480"
  }, props), _g$a || (_g$a = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 36,
    clipPath: "url(#arrowLeftArrowRight_24_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98 146h284m-284 0 88 88m-88-88 88-88m196 276H98m284 0-88-88m88 88-88 88"
  }))), _defs$a || (_defs$a = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "arrowLeftArrowRight_24_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h480v480H0z"
  })))));
};

var _g$9, _defs$9;
function _extends$cH() { return _extends$cH = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$cH.apply(null, arguments); }
var SvgArrowLeftArrowRight32 = function SvgArrowLeftArrowRight32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$cH({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 480 480"
  }, props), _g$9 || (_g$9 = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 30,
    clipPath: "url(#arrowLeftArrowRight_32_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98 146h284m-284 0 88 88m-88-88 88-88m196 276H98m284 0-88-88m88 88-88 88"
  }))), _defs$9 || (_defs$9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "arrowLeftArrowRight_32_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h480v480H0z"
  })))));
};

var _g$8, _defs$8;
function _extends$cG() { return _extends$cG = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$cG.apply(null, arguments); }
var SvgArrowLeftArrowRight48 = function SvgArrowLeftArrowRight48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$cG({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none",
    viewBox: "0 0 480 480"
  }, props), _g$8 || (_g$8 = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 24,
    clipPath: "url(#arrowLeftArrowRight_48_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98 146h284m-284 0 88 88m-88-88 88-88m196 276H98m284 0-88-88m88 88-88 88"
  }))), _defs$8 || (_defs$8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "arrowLeftArrowRight_48_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h480v480H0z"
  })))));
};

var ArrowLeftArrowRightIcon = function ArrowLeftArrowRightIcon(props) {
  var arrowRight = {
    12: SvgArrowLeftArrowRight12,
    16: SvgArrowLeftArrowRight16,
    18: SvgArrowLeftArrowRight18,
    24: SvgArrowLeftArrowRight24,
    32: SvgArrowLeftArrowRight32,
    48: SvgArrowLeftArrowRight48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: arrowRight
  }, props));
};

var _path$cx;
function _extends$cF() { return _extends$cF = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$cF.apply(null, arguments); }
var SvgArrowRight12 = function SvgArrowRight12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$cF({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$cx || (_path$cx = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M5.351 1.331a.6.6 0 0 0 .05.847l3.62 3.219H1.25a.6.6 0 0 0 0 1.2h7.772l-3.62 3.218a.6.6 0 1 0 .797.897l4.8-4.267a.6.6 0 0 0 0-.897l-4.8-4.267a.6.6 0 0 0-.848.05",
    clipRule: "evenodd"
  })));
};

var _path$cw;
function _extends$cE() { return _extends$cE = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$cE.apply(null, arguments); }
var SvgArrowRight16 = function SvgArrowRight16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$cE({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$cw || (_path$cw = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M7.173 1.808a.75.75 0 0 0 .062 1.06l4.926 4.378H1.667a.75.75 0 1 0 0 1.5H12.16l-4.926 4.378a.75.75 0 1 0 .997 1.121l6.4-5.689a.75.75 0 0 0 0-1.121l-6.4-5.689a.75.75 0 0 0-1.06.062",
    clipRule: "evenodd"
  })));
};

var _path$cv;
function _extends$cD() { return _extends$cD = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$cD.apply(null, arguments); }
var SvgArrowRight18 = function SvgArrowRight18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$cD({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$cv || (_path$cv = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8.102 2.063a.8.8 0 0 0 .066 1.13l5.628 5.002H1.875a.8.8 0 1 0 0 1.6h11.92l-5.627 5.002a.8.8 0 0 0 1.063 1.196l7.2-6.4a.8.8 0 0 0 0-1.196l-7.2-6.4a.8.8 0 0 0-1.129.066",
    clipRule: "evenodd"
  })));
};

var _path$cu;
function _extends$cC() { return _extends$cC = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$cC.apply(null, arguments); }
var SvgArrowRight24 = function SvgArrowRight24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$cC({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$cu || (_path$cu = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M10.927 2.862a.9.9 0 0 0 .075 1.27l7.83 6.961H2.5a.9.9 0 1 0 0 1.8h16.333l-7.83 6.961a.9.9 0 1 0 1.195 1.345l9.6-8.533a.9.9 0 0 0 0-1.345l-9.6-8.534a.9.9 0 0 0-1.27.075",
    clipRule: "evenodd"
  })));
};

var _path$ct;
function _extends$cB() { return _extends$cB = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$cB.apply(null, arguments); }
var SvgArrowRight32 = function SvgArrowRight32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$cB({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$ct || (_path$ct = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M14.72 3.949a1 1 0 0 0 .082 1.412l10.834 9.63H3.333a1 1 0 1 0 0 2h22.303l-10.834 9.63a1 1 0 0 0 1.329 1.495l12.8-11.378a1 1 0 0 0 0-1.494L16.13 3.866a1 1 0 0 0-1.412.083",
    clipRule: "evenodd"
  })));
};

var _path$cs;
function _extends$cA() { return _extends$cA = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$cA.apply(null, arguments); }
var SvgArrowRight48 = function SvgArrowRight48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$cA({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$cs || (_path$cs = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M22.303 6.123a1.2 1.2 0 0 0 .1 1.694l16.84 14.97H5a1.2 1.2 0 0 0 0 2.4h34.244l-16.841 14.97a1.2 1.2 0 0 0 1.594 1.793l19.2-17.067a1.2 1.2 0 0 0 0-1.793l-19.2-17.067a1.2 1.2 0 0 0-1.694.1",
    clipRule: "evenodd"
  })));
};

var ArrowRightIcon = function ArrowRightIcon(props) {
  var arrowRight = {
    12: SvgArrowRight12,
    16: SvgArrowRight16,
    18: SvgArrowRight18,
    24: SvgArrowRight24,
    32: SvgArrowRight32,
    48: SvgArrowRight48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: arrowRight
  }, props));
};

var _path$cr;
function _extends$cz() { return _extends$cz = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$cz.apply(null, arguments); }
var SvgArrowUp12 = function SvgArrowUp12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$cz({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$cr || (_path$cr = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M1.341 6.57a.6.6 0 0 0 .847-.05L5.407 2.9v7.772a.6.6 0 0 0 1.2 0V2.9l3.218 3.62a.6.6 0 0 0 .897-.797L6.455.923a.6.6 0 0 0-.897 0l-4.267 4.8a.6.6 0 0 0 .05.847",
    clipRule: "evenodd"
  })));
};

var _path$cq;
function _extends$cy() { return _extends$cy = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$cy.apply(null, arguments); }
var SvgArrowUp16 = function SvgArrowUp16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$cy({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$cq || (_path$cq = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M1.812 8.723A.75.75 0 0 0 2.87 8.66l4.378-4.925v10.494a.75.75 0 0 0 1.5 0V3.735l4.378 4.925a.75.75 0 1 0 1.121-.996l-5.688-6.4a.75.75 0 0 0-1.122 0l-5.688 6.4a.75.75 0 0 0 .062 1.059",
    clipRule: "evenodd"
  })));
};

var _path$cp;
function _extends$cx() { return _extends$cx = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$cx.apply(null, arguments); }
var SvgArrowUp18 = function SvgArrowUp18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$cx({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$cp || (_path$cp = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M2.069 9.78a.8.8 0 0 0 1.129-.066L8.2 4.087v11.92a.8.8 0 0 0 1.6 0V4.088l5.002 5.627a.8.8 0 0 0 1.196-1.063l-6.4-7.2a.8.8 0 0 0-1.196 0l-6.4 7.2a.8.8 0 0 0 .067 1.13",
    clipRule: "evenodd"
  })));
};

var _path$co;
function _extends$cw() { return _extends$cw = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$cw.apply(null, arguments); }
var SvgArrowUp24 = function SvgArrowUp24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$cw({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$co || (_path$co = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M2.862 12.916a.9.9 0 0 0 1.27-.075l6.961-7.83v16.332a.9.9 0 0 0 1.8 0V5.01l6.961 7.831a.9.9 0 1 0 1.345-1.196l-8.533-9.6a.9.9 0 0 0-1.345 0l-8.534 9.6a.9.9 0 0 0 .075 1.27",
    clipRule: "evenodd"
  })));
};

var _path$cn;
function _extends$cv() { return _extends$cv = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$cv.apply(null, arguments); }
var SvgArrowUp32 = function SvgArrowUp32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$cv({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$cn || (_path$cn = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M3.956 17.072a1 1 0 0 0 1.412-.083l9.63-10.834v22.303a1 1 0 1 0 2 0V6.155l9.63 10.834a1 1 0 1 0 1.495-1.329L16.745 2.86a1 1 0 0 0-1.495 0L3.874 15.66a1 1 0 0 0 .083 1.412",
    clipRule: "evenodd"
  })));
};

var _path$cm;
function _extends$cu() { return _extends$cu = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$cu.apply(null, arguments); }
var SvgArrowUp48 = function SvgArrowUp48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$cu({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$cm || (_path$cm = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M6.143 25.384a1.2 1.2 0 0 0 1.694-.1l14.97-16.84v34.243a1.2 1.2 0 1 0 2.4 0V8.443l14.97 16.841a1.2 1.2 0 0 0 1.793-1.594L24.904 4.49a1.2 1.2 0 0 0-1.794 0L6.043 23.69a1.2 1.2 0 0 0 .1 1.694",
    clipRule: "evenodd"
  })));
};

var ArrowUpIcon = function ArrowUpIcon(props) {
  var arrowUp = {
    12: SvgArrowUp12,
    16: SvgArrowUp16,
    18: SvgArrowUp18,
    24: SvgArrowUp24,
    32: SvgArrowUp32,
    48: SvgArrowUp48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: arrowUp
  }, props));
};

var _path$cl, _path2$3W, _path3$z;
function _extends$ct() { return _extends$ct = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$ct.apply(null, arguments); }
var SvgAttach12 = function SvgAttach12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$ct({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$cl || (_path$cl = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M5.576 2.04A3.1 3.1 0 0 1 9.96 6.424L7.065 9.32l-.848-.848L9.11 5.576a1.9 1.9 0 0 0-2.687-2.687L3.242 6.07a.6.6 0 1 1-.848-.849z",
    clipRule: "evenodd"
  })), _path2$3W || (_path2$3W = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M2.659 7.432a2.225 2.225 0 0 0 3.147 3.147l1.259-1.26-.848-.848-1.26 1.26a1.025 1.025 0 1 1-1.45-1.45l3.448-3.448-.849-.848z",
    clipRule: "evenodd"
  })), _path3$z || (_path3$z = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M6.636 3.455a1.35 1.35 0 1 1 1.91 1.909L5.54 8.369a.6.6 0 1 1-.848-.849l3.005-3.005a.15.15 0 1 0-.212-.212L5.069 6.72l-.849-.848z",
    clipRule: "evenodd"
  })));
};

var _path$ck, _path2$3V, _path3$y;
function _extends$cs() { return _extends$cs = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$cs.apply(null, arguments); }
var SvgAttach16 = function SvgAttach16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$cs({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$ck || (_path$ck = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M7.47 2.756a4.083 4.083 0 0 1 5.774 5.774l-3.86 3.86-1.06-1.06 3.86-3.86A2.583 2.583 0 1 0 8.53 3.816L4.288 8.06a.75.75 0 1 1-1.061-1.06z",
    clipRule: "evenodd"
  })), _path2$3V || (_path2$3V = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M3.58 9.944a2.917 2.917 0 0 0 4.125 4.125l1.68-1.68-1.061-1.06-1.68 1.68a1.417 1.417 0 0 1-2.003-2.004L9.237 6.41l-1.06-1.06z",
    clipRule: "evenodd"
  })), _path3$y || (_path3$y = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8.884 4.641a1.75 1.75 0 1 1 2.475 2.475l-4.007 4.007a.75.75 0 1 1-1.06-1.06l4.006-4.008a.25.25 0 0 0-.353-.353L6.724 8.923l-1.061-1.06z",
    clipRule: "evenodd"
  })));
};

var _path$cj, _path2$3U, _path3$x;
function _extends$cr() { return _extends$cr = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$cr.apply(null, arguments); }
var SvgAttach18 = function SvgAttach18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$cr({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$cj || (_path$cj = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8.434 3.131a4.55 4.55 0 1 1 6.435 6.435l-4.342 4.342-1.131-1.132 4.342-4.342a2.95 2.95 0 0 0-4.172-4.172L4.793 9.035a.8.8 0 0 1-1.131-1.131z",
    clipRule: "evenodd"
  })), _path2$3U || (_path2$3U = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M4.06 11.219a3.237 3.237 0 1 0 4.578 4.578l1.89-1.89-1.132-1.13-1.89 1.889A1.637 1.637 0 1 1 5.19 12.35l5.171-5.17L9.23 6.047z",
    clipRule: "evenodd"
  })), _path3$x || (_path3$x = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M10.026 5.252a1.925 1.925 0 1 1 2.722 2.723L8.24 12.483a.8.8 0 0 1-1.131-1.132l4.508-4.508a.325.325 0 0 0-.46-.46l-3.624 3.625-1.131-1.132z",
    clipRule: "evenodd"
  })));
};

var _path$ci, _path2$3T, _path3$w;
function _extends$cq() { return _extends$cq = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$cq.apply(null, arguments); }
var SvgAttach24 = function SvgAttach24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$cq({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$ci || (_path$ci = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M11.363 4.293a5.9 5.9 0 0 1 8.344 8.343l-5.79 5.79-1.272-1.273 5.79-5.79a4.1 4.1 0 1 0-5.799-5.798L6.272 11.93A.9.9 0 0 1 5 10.656z",
    clipRule: "evenodd"
  })), _path2$3T || (_path2$3T = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M5.53 15.076a4.15 4.15 0 0 0 5.869 5.869l2.519-2.52-1.273-1.272-2.52 2.52a2.35 2.35 0 0 1-3.322-3.324l6.894-6.895-1.273-1.272z",
    clipRule: "evenodd"
  })), _path3$w || (_path3$w = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M13.485 7.12a2.4 2.4 0 1 1 3.394 3.395l-6.01 6.01a.9.9 0 0 1-1.273-1.272l6.01-6.01a.6.6 0 0 0-.848-.85l-4.832 4.833-1.273-1.273z",
    clipRule: "evenodd"
  })));
};

var _path$ch, _path2$3S, _path3$v;
function _extends$cp() { return _extends$cp = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$cp.apply(null, arguments); }
var SvgAttach32 = function SvgAttach32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$cp({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$ch || (_path$ch = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M15.293 5.865a7.667 7.667 0 1 1 10.843 10.842l-7.72 7.72-1.414-1.415 7.72-7.72a5.667 5.667 0 1 0-8.015-8.013l-8.485 8.485a1 1 0 1 1-1.414-1.414z",
    clipRule: "evenodd"
  })), _path2$3S || (_path2$3S = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M7.515 20.243a5.333 5.333 0 0 0 7.542 7.542l3.36-3.359-1.415-1.414-3.359 3.359a3.333 3.333 0 0 1-4.714-4.714l9.193-9.193-1.415-1.414z",
    clipRule: "evenodd"
  })), _path3$v || (_path3$v = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M18.122 9.636a3 3 0 1 1 4.242 4.243l-8.014 8.013a1 1 0 0 1-1.414-1.414l8.014-8.014a1 1 0 0 0-1.414-1.414l-6.443 6.443-1.414-1.415z",
    clipRule: "evenodd"
  })));
};

var _path$cg, _path2$3R, _path3$u;
function _extends$co() { return _extends$co = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$co.apply(null, arguments); }
var SvgAttach48 = function SvgAttach48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$co({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$cg || (_path$cg = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M23.151 9.01c4.374-4.374 11.466-4.374 15.84 0 4.373 4.373 4.373 11.465 0 15.839L27.41 36.428l-1.696-1.698 11.578-11.578a8.8 8.8 0 1 0-12.445-12.445L12.12 23.434a1.2 1.2 0 1 1-1.697-1.697z",
    clipRule: "evenodd"
  })), _path2$3R || (_path2$3R = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M11.484 30.576a7.7 7.7 0 0 0 10.89 10.89l5.038-5.038-1.697-1.698-5.039 5.039a5.3 5.3 0 0 1-7.495-7.496L26.97 18.485l-1.697-1.697z",
    clipRule: "evenodd"
  })), _path3$u || (_path3$u = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M27.394 14.666a4.2 4.2 0 0 1 5.94 5.94l-12.021 12.02a1.2 1.2 0 1 1-1.697-1.696l12.02-12.021a1.8 1.8 0 0 0-2.545-2.546l-9.664 9.664-1.697-1.697z",
    clipRule: "evenodd"
  })));
};

var AttachIcon = function AttachIcon(props) {
  var attach = {
    12: SvgAttach12,
    16: SvgAttach16,
    18: SvgAttach18,
    24: SvgAttach24,
    32: SvgAttach32,
    48: SvgAttach48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: attach
  }, props));
};

var _path$cf;
function _extends$cn() { return _extends$cn = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$cn.apply(null, arguments); }
var SvgBullhorn12 = function SvgBullhorn12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$cn({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$cf || (_path$cf = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8.192 1.312A2.1 2.1 0 0 1 11.1 3.25v4.5A2.1 2.1 0 0 1 8.192 9.69L7.1 9.233V9.5A1.1 1.1 0 0 1 6 10.6H5a1.1 1.1 0 0 1-1.1-1.1V8.1H1.5a.6.6 0 0 1-.6-.6v-4a.6.6 0 0 1 .6-.6h2.88zM3.9 4.1H2.1v2.8h1.8zm1.2 4.3.8.333V9.4h-.8zm0-1.3V3.9l3.554-1.48a.9.9 0 0 1 1.246.83v4.5a.9.9 0 0 1-1.246.83z",
    clipRule: "evenodd"
  })));
};

var _path$ce;
function _extends$cm() { return _extends$cm = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$cm.apply(null, arguments); }
var SvgBullhorn16 = function SvgBullhorn16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$cm({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$ce || (_path$ce = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M10.942 1.795c1.812-.755 3.808.576 3.808 2.538v6c0 1.963-1.996 3.294-3.808 2.539l-1.525-.636v.43c0 .783-.635 1.417-1.417 1.417H6.667a1.417 1.417 0 0 1-1.417-1.416V10.75H2a.75.75 0 0 1-.75-.75V4.667a.75.75 0 0 1 .75-.75h3.85zM5.25 5.417h-2.5V9.25h2.5zm1.5 5.708 1.167.486v.972H6.75zm0-1.625V5.167l4.77-1.987a1.25 1.25 0 0 1 1.73 1.153v6a1.25 1.25 0 0 1-1.73 1.154z",
    clipRule: "evenodd"
  })));
};

var _path$cd;
function _extends$cl() { return _extends$cl = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$cl.apply(null, arguments); }
var SvgBullhorn18 = function SvgBullhorn18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$cl({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$cd || (_path$cd = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M12.077 2.06c2.009-.838 4.223.639 4.223 2.815v6.75c0 2.176-2.214 3.652-4.223 2.815L10.3 13.7v.55a1.55 1.55 0 0 1-1.55 1.55h-1.5a1.55 1.55 0 0 1-1.55-1.55v-2.2H2a.8.8 0 0 1-.8-.8v-6a.8.8 0 0 1 .8-.8h4.34zM5.7 6.05H2.8v4.4h2.9zm1.6 6.4 1.4.583V14.2H7.3zm0-1.733V5.783l5.392-2.247A1.45 1.45 0 0 1 14.7 4.875v6.75a1.45 1.45 0 0 1-2.008 1.338z",
    clipRule: "evenodd"
  })));
};

var _path$cc;
function _extends$ck() { return _extends$ck = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$ck.apply(null, arguments); }
var SvgBullhorn24 = function SvgBullhorn24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$ck({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$cc || (_path$cc = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M16.5 2.9c2.569-1.07 5.4.817 5.4 3.6v9c0 2.783-2.831 4.67-5.4 3.6l-2.6-1.083V19a1.9 1.9 0 0 1-1.9 1.9h-2A1.9 1.9 0 0 1 8.1 19v-3.1H3a.9.9 0 0 1-.9-.9V7a.9.9 0 0 1 .9-.9h5.82zm-8.4 5H3.9v6.2h4.2zm1.8 8.45 2.2.917V19a.1.1 0 0 1-.1.1h-2a.1.1 0 0 1-.1-.1zm0-1.95V7.6l7.292-3.038A2.1 2.1 0 0 1 20.1 6.5v9a2.1 2.1 0 0 1-2.908 1.939z",
    clipRule: "evenodd"
  })));
};

var _path$cb;
function _extends$cj() { return _extends$cj = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$cj.apply(null, arguments); }
var SvgBullhorn32 = function SvgBullhorn32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$cj({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$cb || (_path$cb = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M22.077 4.051C25.37 2.68 29 5.1 29 8.667v12c0 3.568-3.63 5.987-6.923 4.615l-3.744-1.56v1.611A2.333 2.333 0 0 1 16 27.668h-2.667A2.333 2.333 0 0 1 11 25.333V21H4a1 1 0 0 1-1-1V9.333a1 1 0 0 1 1-1h7.8zM11 10.334H5V19h6zM13 21.5l3.333 1.389v2.445c0 .184-.149.333-.333.333h-2.667a.333.333 0 0 1-.333-.334zm0-2.166V10l9.846-4.102C24.822 5.074 27 6.526 27 8.667v12c0 2.14-2.178 3.592-4.154 2.769z",
    clipRule: "evenodd"
  })));
};

var _path$ca;
function _extends$ci() { return _extends$ci = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$ci.apply(null, arguments); }
var SvgBullhorn48 = function SvgBullhorn48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$ci({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$ca || (_path$ca = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M33.23 6.354C37.974 4.378 43.2 7.862 43.2 13v18c0 5.138-5.227 8.622-9.97 6.646l-6.03-2.513V38a3.2 3.2 0 0 1-3.2 3.2h-4a3.2 3.2 0 0 1-3.2-3.2v-6.8H6A1.2 1.2 0 0 1 4.8 30V14A1.2 1.2 0 0 1 6 12.8h11.76zM16.8 15.2H7.2v13.6h9.6zm2.4 16.6 5.6 2.333V38a.8.8 0 0 1-.8.8h-4a.8.8 0 0 1-.8-.8zm0-2.6V14.8l14.954-6.23C37.316 7.251 40.8 9.574 40.8 13v18c0 3.425-3.484 5.748-6.646 4.43z",
    clipRule: "evenodd"
  })));
};

var BullhornIcon = function BullhornIcon(props) {
  var bullhorn = {
    12: SvgBullhorn12,
    16: SvgBullhorn16,
    18: SvgBullhorn18,
    24: SvgBullhorn24,
    32: SvgBullhorn32,
    48: SvgBullhorn48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: bullhorn
  }, props));
};

var _path$c9;
function _extends$ch() { return _extends$ch = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$ch.apply(null, arguments); }
var SvgBullhornFilled12 = function SvgBullhornFilled12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$ch({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$c9 || (_path$c9 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M3.184 3.174H1.5a.45.45 0 0 0-.45.45v3.063c0 .249.201.45.45.45h1.684zM8.917 1.286a1.45 1.45 0 0 1 2.008 1.339v5.01a1.45 1.45 0 0 1-2.009 1.34L4.384 7.09V3.173zM4.384 8.138V9.65a.8.8 0 0 0 .8.8h.9a.8.8 0 0 0 .8-.8v-.47z"
  })));
};

var _path$c8;
function _extends$cg() { return _extends$cg = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$cg.apply(null, arguments); }
var SvgBullhornFilled16 = function SvgBullhornFilled16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$cg({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$c8 || (_path$c8 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M11.89 1.715a1.933 1.933 0 0 1 2.677 1.786v6.787a1.935 1.935 0 0 1-2.678 1.789L5.846 9.56V4.233h.001zM5.846 10.919v1.948c0 .589.477 1.066 1.066 1.066h1.2c.59 0 1.067-.477 1.067-1.066v-.56zM4.346 4.233H2a.6.6 0 0 0-.6.6v4.184a.6.6 0 0 0 .6.6h2.346z"
  })));
};

var _path$c7;
function _extends$cf() { return _extends$cf = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$cf.apply(null, arguments); }
var SvgBullhornFilled18 = function SvgBullhornFilled18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$cf({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$c7 || (_path$c7 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M13.376 1.93a2.175 2.175 0 0 1 3.012 2.008 6039 6039 0 0 0 0 7.73 2.177 2.177 0 0 1-3.013 2.013L6.576 10.85V4.762h.002zM6.576 12.358v2.117a1.2 1.2 0 0 0 1.2 1.2h1.35a1.2 1.2 0 0 0 1.2-1.2v-.556zM4.976 4.762H2.25a.675.675 0 0 0-.675.675v4.794c0 .373.302.675.675.675h2.726z"
  })));
};

var _path$c6;
function _extends$ce() { return _extends$ce = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$ce.apply(null, arguments); }
var SvgBullhornFilled24 = function SvgBullhornFilled24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$ce({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$c6 || (_path$c6 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M17.835 2.573c1.91-.796 4.017.608 4.016 2.678-.002 3.487-.003 7.153 0 10.668.002 2.072-2.105 3.48-4.017 2.683l-9.065-3.774V6.35h.002q4.532-1.89 9.064-3.777M8.769 16.578V19.3a1.6 1.6 0 0 0 1.6 1.6h1.8a1.6 1.6 0 0 0 1.6-1.6v-.64zM6.969 6.35H3a.9.9 0 0 0-.9.9v6.725a.9.9 0 0 0 .9.9h3.968z"
  })));
};

var _path$c5;
function _extends$cd() { return _extends$cd = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$cd.apply(null, arguments); }
var SvgBullhornFilled32 = function SvgBullhornFilled32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$cd({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$c5 || (_path$c5 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M2.8 9.666a1.2 1.2 0 0 1 1.2-1.2h5.69v11.768H4a1.2 1.2 0 0 1-1.2-1.2zM23.78 3.43c2.547-1.061 5.355.811 5.353 3.571-.002 4.794-.003 9.84.002 14.658.002 2.762-2.807 4.64-5.357 3.578L11.69 20.204V8.466h.002zM11.69 22.237v3.496c0 1.178.956 2.133 2.134 2.133h2.4a2.133 2.133 0 0 0 2.133-2.133v-.72z"
  })));
};

var _path$c4;
function _extends$cc() { return _extends$cc = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$cc.apply(null, arguments); }
var SvgBullhornFilled48 = function SvgBullhornFilled48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$cc({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$c4 || (_path$c4 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M4.2 14.5A1.8 1.8 0 0 1 6 12.7h9.137v18.25H6a1.8 1.8 0 0 1-1.8-1.8zM35.67 5.146c3.82-1.593 8.032 1.216 8.03 5.356-.003 7.406-.005 15.213.003 22.635.005 4.144-4.21 6.961-8.036 5.368l-18.13-7.55V12.7h.003zM17.537 33.455V38.6a3.2 3.2 0 0 0 3.2 3.2h3.6a3.2 3.2 0 0 0 3.2-3.2v-.98z"
  })));
};

var BullhornFilledIcon = function BullhornFilledIcon(props) {
  var bullhornFilled = {
    12: SvgBullhornFilled12,
    16: SvgBullhornFilled16,
    18: SvgBullhornFilled18,
    24: SvgBullhornFilled24,
    32: SvgBullhornFilled32,
    48: SvgBullhornFilled48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: bullhornFilled
  }, props));
};

var _path$c3, _path2$3Q, _path3$t;
function _extends$cb() { return _extends$cb = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$cb.apply(null, arguments); }
var SvgCalculator12 = function SvgCalculator12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$cb({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$c3 || (_path$c3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8.318 2.2h-4.5a.8.8 0 0 0-.8.8v6a.8.8 0 0 0 .8.8h4.5a.8.8 0 0 0 .8-.8V3a.8.8 0 0 0-.8-.8M3.818 1a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h4.5a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2z",
    clipRule: "evenodd"
  })), _path2$3Q || (_path2$3Q = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M4.1 3.9a.6.6 0 0 1 .6-.6h2.74a.6.6 0 0 1 0 1.2H4.7a.6.6 0 0 1-.6-.6",
    clipRule: "evenodd"
  })), _path3$t || (_path3$t = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M5.72 6.15a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M7.92 6.15a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0"
  })));
};

var _path$c2, _path2$3P, _path3$s;
function _extends$ca() { return _extends$ca = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$ca.apply(null, arguments); }
var SvgCalculator16 = function SvgCalculator16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$ca({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$c2 || (_path$c2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M11 2.5H5A1.5 1.5 0 0 0 3.5 4v8.667a1.5 1.5 0 0 0 1.5 1.5h6a1.5 1.5 0 0 0 1.5-1.5V4A1.5 1.5 0 0 0 11 2.5M5 1a3 3 0 0 0-3 3v8.667a3 3 0 0 0 3 3h6a3 3 0 0 0 3-3V4a3 3 0 0 0-3-3z",
    clipRule: "evenodd"
  })), _path2$3P || (_path2$3P = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M5 5a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 0 1.5h-4.5A.75.75 0 0 1 5 5",
    clipRule: "evenodd"
  })), _path3$s || (_path3$s = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M7.4 8.25a1 1 0 1 1-2 0 1 1 0 0 1 2 0M10.6 8.25a1 1 0 1 1-2 0 1 1 0 0 1 2 0M7.4 11.45a1 1 0 1 1-2 0 1 1 0 0 1 2 0M10.6 11.45a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
  })));
};

var _path$c1, _path2$3O, _path3$r;
function _extends$c9() { return _extends$c9 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$c9.apply(null, arguments); }
var SvgCalculator18 = function SvgCalculator18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$c9({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$c1 || (_path$c1 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M12.53 2.8h-7a1.4 1.4 0 0 0-1.4 1.4v9.89a1.4 1.4 0 0 0 1.4 1.4h7a1.4 1.4 0 0 0 1.4-1.4V4.2a1.4 1.4 0 0 0-1.4-1.4m-7-1.6a3 3 0 0 0-3 3v9.89a3 3 0 0 0 3 3h7a3 3 0 0 0 3-3V4.2a3 3 0 0 0-3-3z",
    clipRule: "evenodd"
  })), _path2$3O || (_path2$3O = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M5.78 5.546a.8.8 0 0 1 .8-.8h4.9a.8.8 0 0 1 0 1.6h-4.9a.8.8 0 0 1-.8-.8",
    clipRule: "evenodd"
  })), _path3$r || (_path3$r = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M8.36 8.915a1.065 1.065 0 1 1-2.13 0 1.065 1.065 0 0 1 2.13 0M11.89 8.915a1.065 1.065 0 1 1-2.13 0 1.065 1.065 0 0 1 2.13 0M8.36 12.445a1.065 1.065 0 1 1-2.13 0 1.065 1.065 0 0 1 2.13 0M11.89 12.445a1.065 1.065 0 1 1-2.13 0 1.065 1.065 0 0 1 2.13 0"
  })));
};

var _path$c0, _path2$3N, _path3$q;
function _extends$c8() { return _extends$c8 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$c8.apply(null, arguments); }
var SvgCalculator24 = function SvgCalculator24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$c8({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$c0 || (_path$c0 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M18 2.8H6A1.2 1.2 0 0 0 4.8 4v16A1.2 1.2 0 0 0 6 21.2h12a1.2 1.2 0 0 0 1.2-1.2V4A1.2 1.2 0 0 0 18 2.8M6 1a3 3 0 0 0-3 3v16a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V4a3 3 0 0 0-3-3z",
    clipRule: "evenodd"
  })), _path2$3N || (_path2$3N = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M7.25 6.35a.9.9 0 0 1 .9-.9h7.7a.9.9 0 1 1 0 1.8h-7.7a.9.9 0 0 1-.9-.9",
    clipRule: "evenodd"
  })), _path3$q || (_path3$q = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M9.5 10.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0M13 10.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0M16.5 10.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0M9.5 14a1 1 0 1 1-2 0 1 1 0 0 1 2 0M13 14a1 1 0 1 1-2 0 1 1 0 0 1 2 0M16.5 14a1 1 0 1 1-2 0 1 1 0 0 1 2 0M9.5 17.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0M13 17.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0M16.5 17.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
  })));
};

var _path$b$, _path2$3M, _path3$p;
function _extends$c7() { return _extends$c7 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$c7.apply(null, arguments); }
var SvgCalculator32 = function SvgCalculator32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$c7({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$b$ || (_path$b$ = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M24 3.734H8a1.6 1.6 0 0 0-1.6 1.6v21.333a1.6 1.6 0 0 0 1.6 1.6h16a1.6 1.6 0 0 0 1.6-1.6V5.334a1.6 1.6 0 0 0-1.6-1.6m-16-2.4a4 4 0 0 0-4 4v21.333a4 4 0 0 0 4 4h16a4 4 0 0 0 4-4V5.334a4 4 0 0 0-4-4z",
    clipRule: "evenodd"
  })), _path2$3M || (_path2$3M = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M9.667 8.467a1.2 1.2 0 0 1 1.2-1.2h10.266a1.2 1.2 0 1 1 0 2.4H10.867a1.2 1.2 0 0 1-1.2-1.2",
    clipRule: "evenodd"
  })), _path3$p || (_path3$p = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M12.667 14A1.333 1.333 0 1 1 10 14a1.333 1.333 0 0 1 2.667 0M17.333 14a1.333 1.333 0 1 1-2.666 0 1.333 1.333 0 0 1 2.666 0M22 14a1.333 1.333 0 1 1-2.667 0A1.333 1.333 0 0 1 22 14M12.667 18.667a1.333 1.333 0 1 1-2.667 0 1.333 1.333 0 0 1 2.667 0M17.333 18.667a1.333 1.333 0 1 1-2.666 0 1.333 1.333 0 0 1 2.666 0M22 18.667a1.333 1.333 0 1 1-2.667 0 1.333 1.333 0 0 1 2.667 0M12.667 23.334a1.333 1.333 0 1 1-2.667 0 1.333 1.333 0 0 1 2.667 0M17.333 23.334a1.333 1.333 0 1 1-2.666 0 1.333 1.333 0 0 1 2.666 0M22 23.334a1.333 1.333 0 1 1-2.667 0 1.333 1.333 0 0 1 2.667 0"
  })));
};

var _path$b_, _path2$3L, _path3$o;
function _extends$c6() { return _extends$c6 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$c6.apply(null, arguments); }
var SvgCalculator48 = function SvgCalculator48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$c6({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$b_ || (_path$b_ = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M35 5.4H13A3.6 3.6 0 0 0 9.4 9v29.556a3.6 3.6 0 0 0 3.6 3.6h22a3.6 3.6 0 0 0 3.6-3.6V9A3.6 3.6 0 0 0 35 5.4M13 3a6 6 0 0 0-6 6v29.556a6 6 0 0 0 6 6h22a6 6 0 0 0 6-6V9a6 6 0 0 0-6-6z",
    clipRule: "evenodd"
  })), _path2$3L || (_path2$3L = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M15.028 12.606a1.2 1.2 0 0 1 1.2-1.2h15.544a1.2 1.2 0 1 1 0 2.4H16.228a1.2 1.2 0 0 1-1.2-1.2",
    clipRule: "evenodd"
  })), _path3$o || (_path3$o = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M19.278 20.944a1.889 1.889 0 1 1-3.778 0 1.889 1.889 0 0 1 3.778 0M25.889 20.944a1.889 1.889 0 1 1-3.778 0 1.889 1.889 0 0 1 3.778 0M32.5 20.944a1.889 1.889 0 1 1-3.778 0 1.889 1.889 0 0 1 3.778 0M19.278 27.556a1.889 1.889 0 1 1-3.778 0 1.889 1.889 0 0 1 3.778 0M25.889 27.556a1.889 1.889 0 1 1-3.778 0 1.889 1.889 0 0 1 3.778 0M32.5 27.556a1.889 1.889 0 1 1-3.778 0 1.889 1.889 0 0 1 3.778 0M19.278 34.167a1.889 1.889 0 1 1-3.778 0 1.889 1.889 0 0 1 3.778 0M25.889 34.167a1.889 1.889 0 1 1-3.778 0 1.889 1.889 0 0 1 3.778 0M32.5 34.167a1.889 1.889 0 1 1-3.778 0 1.889 1.889 0 0 1 3.778 0"
  })));
};

var CalculatorIcon = function CalculatorIcon(props) {
  var calculator = {
    12: SvgCalculator12,
    16: SvgCalculator16,
    18: SvgCalculator18,
    24: SvgCalculator24,
    32: SvgCalculator32,
    48: SvgCalculator48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: calculator
  }, props));
};

var _path$bZ;
function _extends$c5() { return _extends$c5 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$c5.apply(null, arguments); }
var SvgCalendar12 = function SvgCalendar12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$c5({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$bZ || (_path$bZ = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M4 .65a.6.6 0 0 1 .6.6v.25h2.8v-.25a.6.6 0 0 1 1.2 0v.25H9A1.5 1.5 0 0 1 10.5 3v6A1.5 1.5 0 0 1 9 10.5H3A1.5 1.5 0 0 1 1.5 9V3A1.5 1.5 0 0 1 3 1.5h.4v-.25a.6.6 0 0 1 .6-.6M7.4 2.7v.05a.6.6 0 0 0 1.2 0V2.7H9a.3.3 0 0 1 .3.3v.4H2.7V3a.3.3 0 0 1 .3-.3h.4v.05a.6.6 0 0 0 1.2 0V2.7zM2.7 4.6V9a.3.3 0 0 0 .3.3h6a.3.3 0 0 0 .3-.3V4.6z",
    clipRule: "evenodd"
  })));
};

var _path$bY;
function _extends$c4() { return _extends$c4 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$c4.apply(null, arguments); }
var SvgCalendar16 = function SvgCalendar16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$c4({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$bY || (_path$bY = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M5.333.967a.7.7 0 0 1 .7.7V2h3.934v-.333a.7.7 0 1 1 1.4 0V2H12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h.633v-.333a.7.7 0 0 1 .7-.7M9.967 3.4v.267a.7.7 0 1 0 1.4 0V3.4H12a.6.6 0 0 1 .6.6v.633H3.4V4a.6.6 0 0 1 .6-.6h.633v.267a.7.7 0 1 0 1.4 0V3.4zM3.4 6.033V12a.6.6 0 0 0 .6.6h8a.6.6 0 0 0 .6-.6V6.033z",
    clipRule: "evenodd"
  })));
};

var _path$bX;
function _extends$c3() { return _extends$c3 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$c3.apply(null, arguments); }
var SvgCalendar18 = function SvgCalendar18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$c3({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$bX || (_path$bX = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M6 1.125a.75.75 0 0 1 .75.75v.375h4.5v-.375a.75.75 0 0 1 1.5 0v.375h.75a2.25 2.25 0 0 1 2.25 2.25v9a2.25 2.25 0 0 1-2.25 2.25h-9a2.25 2.25 0 0 1-2.25-2.25v-9A2.25 2.25 0 0 1 4.5 2.25h.75v-.375a.75.75 0 0 1 .75-.75m5.25 2.625v.375a.75.75 0 0 0 1.5 0V3.75h.75a.75.75 0 0 1 .75.75v.75H3.75V4.5a.75.75 0 0 1 .75-.75h.75v.375a.75.75 0 0 0 1.5 0V3.75zm-7.5 3v6.75c0 .414.336.75.75.75h9a.75.75 0 0 0 .75-.75V6.75z",
    clipRule: "evenodd"
  })));
};

var _path$bW;
function _extends$c2() { return _extends$c2 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$c2.apply(null, arguments); }
var SvgCalendar24 = function SvgCalendar24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$c2({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$bW || (_path$bW = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8 1.6a.9.9 0 0 1 .9.9V3h6.2v-.5a.9.9 0 1 1 1.8 0V3H18a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3h1.1v-.5a.9.9 0 0 1 .9-.9m7.1 3.2v.7a.9.9 0 1 0 1.8 0v-.7H18A1.2 1.2 0 0 1 19.2 6v1.1H4.8V6A1.2 1.2 0 0 1 6 4.8h1.1v.7a.9.9 0 0 0 1.8 0v-.7zM4.8 8.9V18A1.2 1.2 0 0 0 6 19.2h12a1.2 1.2 0 0 0 1.2-1.2V8.9z",
    clipRule: "evenodd"
  })));
};

var _path$bV;
function _extends$c1() { return _extends$c1 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$c1.apply(null, arguments); }
var SvgCalendar32 = function SvgCalendar32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$c1({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$bV || (_path$bV = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M10.667 2.333a1 1 0 0 1 1 1V4h8.666v-.667a1 1 0 1 1 2 0V4H24a4 4 0 0 1 4 4v16a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4V8a4 4 0 0 1 4-4h1.667v-.667a1 1 0 0 1 1-1M20.333 6v1.333a1 1 0 1 0 2 0V6H24a2 2 0 0 1 2 2v1.666H6V8a2 2 0 0 1 2-2h1.667v1.333a1 1 0 1 0 2 0V6zM6 11.666V24a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V11.667z",
    clipRule: "evenodd"
  })));
};

var _path$bU;
function _extends$c0() { return _extends$c0 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$c0.apply(null, arguments); }
var SvgCalendar48 = function SvgCalendar48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$c0({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$bU || (_path$bU = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M16 3.8A1.2 1.2 0 0 1 17.2 5v1h13.6V5a1.2 1.2 0 0 1 2.4 0v1H36a6 6 0 0 1 6 6v24a6 6 0 0 1-6 6H12a6 6 0 0 1-6-6V12a6 6 0 0 1 6-6h2.8V5A1.2 1.2 0 0 1 16 3.8m14.8 4.6V11a1.2 1.2 0 0 0 2.4 0V8.4H36a3.6 3.6 0 0 1 3.6 3.6v2.8H8.4V12A3.6 3.6 0 0 1 12 8.4h2.8V11a1.2 1.2 0 0 0 2.4 0V8.4zM8.4 17.2V36a3.6 3.6 0 0 0 3.6 3.6h24a3.6 3.6 0 0 0 3.6-3.6V17.2z",
    clipRule: "evenodd"
  })));
};

var CalendarIcon = function CalendarIcon(props) {
  var calendar = {
    12: SvgCalendar12,
    16: SvgCalendar16,
    18: SvgCalendar18,
    24: SvgCalendar24,
    32: SvgCalendar32,
    48: SvgCalendar48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: calendar
  }, props));
};

var _path$bT;
function _extends$b$() { return _extends$b$ = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$b$.apply(null, arguments); }
var SvgCalendarFilled12 = function SvgCalendarFilled12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$b$({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$bT || (_path$bT = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M4 .65a.6.6 0 0 1 .6.6v.25h2.8v-.25a.6.6 0 0 1 1.2 0v.25H9A1.5 1.5 0 0 1 10.5 3v6A1.5 1.5 0 0 1 9 10.5H3A1.5 1.5 0 0 1 1.5 9V3A1.5 1.5 0 0 1 3 1.5h.4v-.25a.6.6 0 0 1 .6-.6M2.7 4.6V9a.3.3 0 0 0 .3.3h6a.3.3 0 0 0 .3-.3V4.6z",
    clipRule: "evenodd"
  })));
};

var _path$bS;
function _extends$b_() { return _extends$b_ = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$b_.apply(null, arguments); }
var SvgCalendarFilled16 = function SvgCalendarFilled16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$b_({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$bS || (_path$bS = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M5.333.967a.7.7 0 0 1 .7.7V2h3.934v-.333a.7.7 0 1 1 1.4 0V2H12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h.633v-.333a.7.7 0 0 1 .7-.7M3.4 6.033V12a.6.6 0 0 0 .6.6h8a.6.6 0 0 0 .6-.6V6.033z",
    clipRule: "evenodd"
  })));
};

var _path$bR;
function _extends$bZ() { return _extends$bZ = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$bZ.apply(null, arguments); }
var SvgCalendarFilled18 = function SvgCalendarFilled18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$bZ({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$bR || (_path$bR = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M6 1.125a.75.75 0 0 1 .75.75v.375h4.5v-.375a.75.75 0 0 1 1.5 0v.375h.75a2.25 2.25 0 0 1 2.25 2.25v9a2.25 2.25 0 0 1-2.25 2.25h-9a2.25 2.25 0 0 1-2.25-2.25v-9A2.25 2.25 0 0 1 4.5 2.25h.75v-.375a.75.75 0 0 1 .75-.75M3.75 6.75v6.75c0 .414.336.75.75.75h9a.75.75 0 0 0 .75-.75V6.75z",
    clipRule: "evenodd"
  })));
};

var _path$bQ;
function _extends$bY() { return _extends$bY = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$bY.apply(null, arguments); }
var SvgCalendarFilled24 = function SvgCalendarFilled24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$bY({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$bQ || (_path$bQ = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M8 1.6a.9.9 0 0 1 .9.9V3h6.2v-.5a.9.9 0 1 1 1.8 0V3H18a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3h1.1v-.5a.9.9 0 0 1 .9-.9M4.8 8.9V18A1.2 1.2 0 0 0 6 19.2h12a1.2 1.2 0 0 0 1.2-1.2V8.9z",
    clipRule: "evenodd"
  })));
};

var _path$bP;
function _extends$bX() { return _extends$bX = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$bX.apply(null, arguments); }
var SvgCalendarFilled32 = function SvgCalendarFilled32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$bX({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$bP || (_path$bP = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M10.667 2.333a1 1 0 0 1 1 1V4h8.666v-.667a1 1 0 1 1 2 0V4H24a4 4 0 0 1 4 4v16a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4V8a4 4 0 0 1 4-4h1.667v-.667a1 1 0 0 1 1-1M6 11.666V24a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V11.667z",
    clipRule: "evenodd"
  })));
};

var _path$bO;
function _extends$bW() { return _extends$bW = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$bW.apply(null, arguments); }
var SvgCalendarFilled48 = function SvgCalendarFilled48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$bW({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$bO || (_path$bO = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M16 3.8A1.2 1.2 0 0 1 17.2 5v1h13.6V5a1.2 1.2 0 0 1 2.4 0v1H36a6 6 0 0 1 6 6v24a6 6 0 0 1-6 6H12a6 6 0 0 1-6-6V12a6 6 0 0 1 6-6h2.8V5A1.2 1.2 0 0 1 16 3.8M8.4 17.2V36a3.6 3.6 0 0 0 3.6 3.6h24a3.6 3.6 0 0 0 3.6-3.6V17.2z",
    clipRule: "evenodd"
  })));
};

var CalendarFilledIcon = function CalendarFilledIcon(props) {
  var calendarFilled = {
    12: SvgCalendarFilled12,
    16: SvgCalendarFilled16,
    18: SvgCalendarFilled18,
    24: SvgCalendarFilled24,
    32: SvgCalendarFilled32,
    48: SvgCalendarFilled48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: calendarFilled
  }, props));
};

var _path$bN;
function _extends$bV() { return _extends$bV = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$bV.apply(null, arguments); }
var SvgCall12 = function SvgCall12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$bV({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$bN || (_path$bN = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M2.31 3.013q-.017.025-.015.025c-.117.304-.06.874.368 1.704.411.796 1.1 1.706 2 2.605 1.165 1.166 2.264 1.809 3.096 2.12.418.156.757.225.996.24a1 1 0 0 0 .263-.01c.181-.15.406-.374.6-.579a15 15 0 0 0 .322-.35l.019-.02.004-.006.001-.001.013-.015.011-.01-.018-.021-1.331-1.33-.006-.006-.017-.011-.627.627c-.272.271-.616.219-.787.166a2 2 0 0 1-.538-.29c-.364-.26-.874-.712-1.588-1.427-.555-.554-.851-1.058-.94-1.526-.094-.493.057-.87.234-1.109.028-.038.081-.104.112-.143l.023-.029a.5.5 0 0 0 .047-.067l.044-.09.068-.069-.018-.02L3.315 2.04l-.009-.007-.014-.01-.913.914a1 1 0 0 0-.069.076m8.546 6.532-.02.021a20 20 0 0 1-.348.379 8 8 0 0 1-.752.715c-.162.13-.353.19-.514.22a2.2 2.2 0 0 1-.543.025 4.8 4.8 0 0 1-1.34-.314c-1.009-.377-2.25-1.12-3.525-2.395-.96-.96-1.734-1.968-2.217-2.904-.465-.902-.731-1.877-.423-2.682.09-.239.245-.41.356-.522l.919-.918c.258-.258.57-.37.877-.356.385.017.683.223.837.377l1.331 1.331c.307.307.415.675.367 1.02-.036.26-.154.472-.275.618a2 2 0 0 1-.132.191c-.035.046-.054.07-.07.088l-.05.065c-.009.012-.041.055-.02.17.028.142.148.44.61.902.706.705 1.157 1.098 1.435 1.296l.021.015.393-.393c.316-.316.699-.4 1.038-.337.302.056.538.22.676.358l1.331 1.331c.307.307.415.675.367 1.02-.041.298-.191.534-.33.679",
    clipRule: "evenodd"
  })));
};

var _path$bM;
function _extends$bU() { return _extends$bU = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$bU.apply(null, arguments); }
var SvgCall16 = function SvgCall16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$bU({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$bM || (_path$bM = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M3.08 4.017a.2.2 0 0 0-.02.033c-.156.406-.08 1.165.491 2.272.548 1.061 1.467 2.275 2.665 3.474 1.555 1.554 3.02 2.412 4.13 2.827.557.208 1.01.299 1.328.32a1.4 1.4 0 0 0 .35-.015c.241-.2.54-.498.8-.77a21 21 0 0 0 .43-.467l.024-.028.006-.007.002-.002.017-.02.014-.014-.024-.027-1.774-1.775-.009-.007-.022-.014-.837.836a1.2 1.2 0 0 1-.678.337c-.29.041-.584-.019-.87-.136-.55-.226-1.252-.744-2.217-1.708-1.269-1.27-1.692-2.17-1.763-2.807-.066-.591.3-1.002.473-1.175l.623-.623-.025-.027L4.42 2.72l-.012-.01-.019-.012-1.217 1.217a1 1 0 0 0-.092.102m11.394 8.709-.025.028-.106.118c-.09.099-.215.235-.36.387-.281.297-.664.682-1.002.953-.216.174-.47.254-.684.293a3 3 0 0 1-.725.034c-.508-.032-1.117-.167-1.787-.418-1.345-.503-3-1.495-4.7-3.194-1.28-1.28-2.312-2.624-2.956-3.872-.62-1.202-.974-2.503-.564-3.576.122-.318.327-.547.475-.695l1.225-1.225c.344-.344.76-.492 1.17-.474.513.023.91.297 1.116.503l1.774 1.774c.41.41.553.9.49 1.36-.058.413-.27.736-.46.926l-.614.613c.075.241.342.8 1.276 1.734.891.89 1.406 1.23 1.664 1.346l.683-.683c.421-.422.931-.534 1.384-.45.403.076.718.295.902.479l1.774 1.774c.41.41.553.9.49 1.36a1.66 1.66 0 0 1-.44.905",
    clipRule: "evenodd"
  })));
};

var _path$bL;
function _extends$bT() { return _extends$bT = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$bT.apply(null, arguments); }
var SvgCall18 = function SvgCall18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$bT({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$bL || (_path$bL = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M3.497 4.334a.6.6 0 0 0-.149.187c-.19.498-.087 1.386.558 2.637.622 1.206 1.663 2.58 3.016 3.933 1.758 1.758 3.419 2.731 4.682 3.203.634.237 1.152.343 1.522.366.186.012.318.002.4-.013l.047-.01c.28-.23.628-.578.926-.891a23 23 0 0 0 .485-.527l.029-.032.007-.008.001-.002.018-.02.018-.018a.2.2 0 0 0 .036-.073v-.004a.3.3 0 0 0-.068-.09l-1.997-1.997a.3.3 0 0 0-.123-.069.3.3 0 0 0-.044.037l-.95.949a1.23 1.23 0 0 1-.705.35c-.304.044-.616-.018-.926-.146-.6-.246-1.38-.817-2.463-1.9-1.42-1.42-1.878-2.414-1.954-3.098-.07-.617.311-1.048.503-1.24l.705-.705a.2.2 0 0 0 .036-.073v-.004a.3.3 0 0 0-.068-.09L5.042 2.988l-.024-.02a.4.4 0 0 0-.046-.029.2.2 0 0 0-.053-.02l-.005.003a.3.3 0 0 0-.039.033zm9.415 6.569h-.002zm3.298 3.346-.03.033q-.042.049-.119.132c-.1.11-.24.264-.402.434-.317.333-.744.762-1.118 1.063a1.6 1.6 0 0 1-.726.31c-.242.044-.51.054-.79.036-.56-.036-1.235-.185-1.982-.464-1.498-.56-3.35-1.668-5.252-3.57-1.434-1.434-2.589-2.94-3.307-4.331-.695-1.347-1.076-2.776-.63-3.942.129-.338.349-.584.512-.747l1.378-1.378c.367-.368.807-.523 1.24-.504.545.024.97.317 1.19.536L8.17 3.854c.44.439.59.96.522 1.445-.06.439-.288.783-.49.985l-.704.705-.027.027c.067.261.346.917 1.478 2.049 1.047 1.047 1.643 1.43 1.939 1.552l.026.01.816-.816c.45-.45.99-.567 1.468-.477.429.08.766.314.962.51l1.996 1.996c.44.439.59.96.522 1.445-.059.424-.272.76-.468.964",
    clipRule: "evenodd"
  })));
};

var _path$bK;
function _extends$bS() { return _extends$bS = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$bS.apply(null, arguments); }
var SvgCall24 = function SvgCall24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$bS({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$bK || (_path$bK = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M4.545 5.661c-.152.152-.212.245-.236.308-.28.734-.114 1.974.751 3.652.84 1.627 2.24 3.473 4.052 5.285 2.359 2.359 4.593 3.67 6.301 4.31.857.32 1.565.465 2.078.497.258.017.447.003.573-.02a1 1 0 0 0 .115-.03c.386-.313.868-.793 1.274-1.22a31 31 0 0 0 .65-.707l.039-.043.01-.01.021-.026.021-.02a.4.4 0 0 0 .056-.08.3.3 0 0 0 .04-.113.2.2 0 0 0-.008-.082.5.5 0 0 0-.13-.185l-2.663-2.662a.56.56 0 0 0-.252-.137.15.15 0 0 0-.073 0 .33.33 0 0 0-.134.094l-1.266 1.267a1.47 1.47 0 0 1-.846.419c-.368.052-.753-.021-1.148-.184-.768-.315-1.789-1.057-3.229-2.497-1.883-1.883-2.463-3.174-2.558-4.032-.083-.74.373-1.267.623-1.517l.94-.94a.4.4 0 0 0 .056-.08.4.4 0 0 0 .04-.112.2.2 0 0 0-.008-.082.5.5 0 0 0-.13-.185L6.84 3.867a.6.6 0 0 0-.136-.095.4.4 0 0 0-.147-.046.1.1 0 0 0-.053.009.4.4 0 0 0-.123.09zm16.946 13.224-.042.047q-.056.064-.157.175c-.133.147-.32.35-.534.576-.422.443-.984 1.009-1.474 1.402-.27.217-.599.324-.893.379-.307.056-.65.069-1.014.046-.727-.047-1.61-.24-2.594-.609-1.974-.738-4.422-2.2-6.944-4.722-1.903-1.904-3.431-3.897-4.379-5.733-.92-1.786-1.4-3.635-.832-5.12.16-.418.433-.726.644-.938L5.11 2.551c.458-.458 1-.647 1.529-.623.672.03 1.202.392 1.476.666l2.662 2.662c.55.55.73 1.192.648 1.787a2.2 2.2 0 0 1-.605 1.218l-.94.94a1 1 0 0 0-.097.11c.062.335.392 1.254 2.032 2.893 1.4 1.4 2.213 1.93 2.64 2.106q.09.036.144.05l1.16-1.16c.559-.56 1.222-.701 1.81-.591.53.099.95.39 1.194.633l2.662 2.663c.55.549.73 1.19.649 1.786a2.2 2.2 0 0 1-.582 1.194",
    clipRule: "evenodd"
  })));
};

var _path$bJ;
function _extends$bR() { return _extends$bR = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$bR.apply(null, arguments); }
var SvgCall32 = function SvgCall32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$bR({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$bJ || (_path$bJ = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M5.919 7.407c-.21.209-.313.357-.36.48-.407 1.062-.15 2.783 1.01 5.032 1.131 2.193 3.012 4.67 5.44 7.097 3.162 3.163 6.165 4.929 8.472 5.792 1.157.432 2.12.63 2.828.676.355.022.625.005.813-.03.156-.028.216-.062.221-.063.53-.427 1.19-1.085 1.74-1.663a41 41 0 0 0 .871-.947l.052-.058.013-.015.025-.028.023-.024a.72.72 0 0 0 .184-.37.4.4 0 0 0-.02-.201.9.9 0 0 0-.221-.323l-3.55-3.55a.94.94 0 0 0-.44-.238.4.4 0 0 0-.192.006.64.64 0 0 0-.262.175l-1.689 1.688a1.76 1.76 0 0 1-1.015.503c-.444.063-.92-.024-1.426-.232-.987-.405-2.324-1.37-4.24-3.286-2.498-2.498-3.233-4.18-3.354-5.257-.1-.89.449-1.533.774-1.86L12.87 9.46a.72.72 0 0 0 .183-.37.4.4 0 0 0-.019-.202.9.9 0 0 0-.222-.323l-3.55-3.55a1 1 0 0 0-.231-.163.7.7 0 0 0-.278-.083.4.4 0 0 0-.153.025.7.7 0 0 0-.232.164zm22.588 17.638-.002.001-.056.064a37 37 0 0 1-.917.996c-.561.59-1.303 1.335-1.946 1.851-.325.261-.726.395-1.102.464-.389.072-.83.089-1.302.059-.945-.06-2.104-.314-3.401-.8-2.602-.972-5.843-2.905-9.187-6.25-2.528-2.528-4.551-5.168-5.802-7.594C3.57 11.467 2.965 9.069 3.69 7.173c.198-.518.539-.905.815-1.18l2.449-2.45c.572-.572 1.24-.802 1.888-.773.83.037 1.492.488 1.835.83l3.55 3.55c.689.689.908 1.483.807 2.213a2.7 2.7 0 0 1-.75 1.51l-1.253 1.253a1 1 0 0 0-.198.249c.059.443.458 1.72 2.778 4.039 1.87 1.87 2.978 2.6 3.585 2.85.169.07.276.092.333.1l1.623-1.623c.695-.696 1.513-.868 2.235-.733a2.94 2.94 0 0 1 1.488.79l3.55 3.55c.688.689.908 1.482.807 2.212a2.7 2.7 0 0 1-.725 1.485",
    clipRule: "evenodd"
  })));
};

var _path$bI;
function _extends$bQ() { return _extends$bQ = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$bQ.apply(null, arguments); }
var SvgCall48 = function SvgCall48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$bQ({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$bI || (_path$bI = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8.666 10.898c-.324.324-.515.581-.609.825-.656 1.718-.22 4.401 1.53 7.793 1.715 3.325 4.557 7.065 8.213 10.72 4.772 4.772 9.311 7.445 12.816 8.756 1.757.657 3.23.963 4.329 1.033.55.035.98.009 1.292-.049.155-.028.268-.062.347-.093.08-.032.107-.055.104-.052.814-.653 1.822-1.659 2.653-2.532a62 62 0 0 0 1.315-1.428l.078-.088.02-.023.005-.006.026-.03.028-.028c.137-.136.318-.418.36-.726.033-.237.005-.59-.446-1.04l-5.324-5.324a1.7 1.7 0 0 0-.82-.44c-.254-.048-.566-.027-.947.354l-2.532 2.533c-.29.29-.728.58-1.353.669-.598.085-1.257-.03-1.984-.329-1.422-.584-3.394-1.997-6.26-4.863-3.728-3.728-4.776-6.19-4.946-7.707-.133-1.19.598-2.066 1.076-2.543l1.88-1.88c.136-.137.317-.419.36-.726.033-.237.004-.59-.447-1.04L14.106 7.31a1.8 1.8 0 0 0-.423-.301 1.3 1.3 0 0 0-.54-.157.84.84 0 0 0-.353.058c-.12.047-.273.137-.45.313zM42.54 37.363l-.007.008-.084.095c-.073.082-.178.2-.31.345-.263.29-.633.693-1.059 1.141-.84.884-1.942 1.99-2.889 2.75-.434.349-.982.536-1.519.635-.553.102-1.188.127-1.88.083-1.383-.088-3.09-.46-5.016-1.18-3.86-1.443-8.684-4.317-13.673-9.307-3.777-3.777-6.79-7.713-8.65-11.317-1.823-3.535-2.677-7.03-1.637-9.75.274-.717.75-1.262 1.153-1.666l3.674-3.674c.799-.798 1.72-1.111 2.606-1.072 1.149.052 2.074.678 2.554 1.159l5.325 5.324c.969.969 1.265 2.066 1.126 3.066a3.78 3.78 0 0 1-1.04 2.094l-1.88 1.88a1.9 1.9 0 0 0-.34.426c-.053.1-.049.14-.047.154.08.727.688 2.708 4.256 6.276 2.813 2.812 4.51 3.943 5.477 4.34.468.193.684.18.733.173l.004-.001 2.522-2.522c.97-.97 2.095-1.202 3.086-1.017.915.171 1.651.68 2.075 1.103l5.324 5.324c.969.97 1.265 2.067 1.127 3.066a3.8 3.8 0 0 1-1.01 2.064",
    clipRule: "evenodd"
  })));
};

var CallIcon = function CallIcon(props) {
  var call = {
    12: SvgCall12,
    16: SvgCall16,
    18: SvgCall18,
    24: SvgCall24,
    32: SvgCall32,
    48: SvgCall48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: call
  }, props));
};

var _path$bH;
function _extends$bP() { return _extends$bP = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$bP.apply(null, arguments); }
var SvgCallFilled12 = function SvgCallFilled12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$bP({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$bH || (_path$bH = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M2.785 1.505 1.718 2.572l-.008.014c-.345.59-.205 1.434.237 2.343.445.919 1.216 1.944 2.202 2.93 1.232 1.232 2.417 1.936 3.356 2.287.47.175.88.263 1.204.284q.246.015.427-.018a.7.7 0 0 0 .302-.123c.227-.182.496-.451.705-.672a16 16 0 0 0 .338-.367l.021-.023.005-.006a.77.77 0 0 0 .207-.42c.027-.195-.027-.415-.232-.62l-1.33-1.33a.85.85 0 0 0-.428-.228.67.67 0 0 0-.615.206l-.634.633a.16.16 0 0 1-.097.047.54.54 0 0 1-.275-.054c-.275-.113-.719-.416-1.426-1.123-.702-.703-.97-1.18-1.067-1.471a.8.8 0 0 1-.05-.299.3.3 0 0 1 .007-.049L5.18 3.9a.77.77 0 0 0 .21-.424c.027-.194-.027-.414-.232-.618l-1.33-1.331a.83.83 0 0 0-.523-.239.68.68 0 0 0-.52.217",
    clipRule: "evenodd"
  })));
};

var _path$bG;
function _extends$bO() { return _extends$bO = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$bO.apply(null, arguments); }
var SvgCallFilled16 = function SvgCallFilled16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$bO({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$bG || (_path$bG = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M3.713 2.007 2.29 3.43l-.01.018c-.46.788-.273 1.912.316 3.125.594 1.224 1.621 2.591 2.937 3.907 1.642 1.642 3.222 2.58 4.474 3.048.625.234 1.172.352 1.605.38q.327.02.57-.025c.159-.03.3-.081.402-.164.303-.243.661-.602.94-.896.14-.147.263-.28.35-.376l.101-.113.028-.031.006-.007c.113-.115.243-.315.277-.561.036-.26-.037-.553-.31-.825l-1.774-1.775a1.14 1.14 0 0 0-.57-.303c-.259-.049-.554.008-.82.274l-.845.844a.22.22 0 0 1-.13.063c-.07.01-.185.002-.366-.072-.366-.151-.959-.555-1.901-1.498-.937-.937-1.295-1.574-1.424-1.962a1.1 1.1 0 0 1-.066-.397.4.4 0 0 1 .009-.066l.817-.817c.114-.114.246-.316.281-.565.036-.26-.037-.553-.31-.825L5.104 2.036a1.1 1.1 0 0 0-.697-.318.9.9 0 0 0-.693.29",
    clipRule: "evenodd"
  })));
};

var _path$bF;
function _extends$bN() { return _extends$bN = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$bN.apply(null, arguments); }
var SvgCallFilled18 = function SvgCallFilled18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$bN({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$bF || (_path$bF = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "m4.177 2.258-1.6 1.6-.013.021c-.517.886-.306 2.151.356 3.515.669 1.378 1.824 2.915 3.304 4.395 1.847 1.848 3.625 2.903 5.034 3.43.704.263 1.318.396 1.806.427.244.015.46.005.64-.028s.337-.091.453-.184c.34-.274.744-.677 1.058-1.008a24 24 0 0 0 .507-.55l.031-.036.007-.008c.127-.129.273-.354.312-.63.04-.292-.042-.622-.349-.93l-1.996-1.996a1.28 1.28 0 0 0-.64-.34c-.292-.055-.625.009-.924.308l-.95.95a.24.24 0 0 1-.146.07c-.079.012-.208.003-.412-.081-.412-.17-1.079-.624-2.14-1.685-1.053-1.054-1.455-1.77-1.6-2.207a1.2 1.2 0 0 1-.075-.447 1 1 0 0 1 .01-.074l.92-.92c.128-.127.277-.355.315-.635.04-.291-.041-.622-.348-.928L5.741 2.29a1.24 1.24 0 0 0-.784-.357c-.258-.012-.532.077-.78.325",
    clipRule: "evenodd"
  })));
};

var _path$bE;
function _extends$bM() { return _extends$bM = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$bM.apply(null, arguments); }
var SvgCallFilled24 = function SvgCallFilled24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$bM({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$bE || (_path$bE = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M5.569 3.01 3.435 5.145l-.016.028c-.69 1.182-.408 2.868.474 4.687.892 1.837 2.433 3.887 4.406 5.86 2.463 2.463 4.834 3.871 6.712 4.573.938.351 1.758.528 2.408.569q.49.03.854-.037c.238-.044.449-.122.604-.246.453-.364.99-.902 1.41-1.343a32 32 0 0 0 .676-.735l.041-.046.01-.01a1.54 1.54 0 0 0 .415-.842c.053-.389-.056-.829-.464-1.238l-2.663-2.662a1.7 1.7 0 0 0-.854-.455c-.388-.072-.832.013-1.23.412l-1.267 1.266a.33.33 0 0 1-.195.094c-.105.015-.277.003-.55-.108-.55-.226-1.438-.833-2.852-2.247-1.405-1.405-1.941-2.36-2.135-2.942-.096-.29-.107-.484-.1-.597a1 1 0 0 1 .014-.098l1.226-1.226c.171-.17.37-.474.421-.848.054-.388-.055-.828-.464-1.237L7.654 3.054c-.2-.2-.585-.457-1.045-.477-.343-.015-.709.103-1.04.434"
  })));
};

var _path$bD;
function _extends$bL() { return _extends$bL = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$bL.apply(null, arguments); }
var SvgCallFilled32 = function SvgCallFilled32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$bL({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$bD || (_path$bD = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M7.426 4.014 4.58 6.86l-.022.037c-.92 1.575-.545 3.824.632 6.25 1.189 2.448 3.243 5.182 5.875 7.813 3.283 3.284 6.444 5.16 8.948 6.097 1.251.468 2.344.703 3.21.758.434.028.818.01 1.14-.049.317-.058.599-.162.805-.328.605-.486 1.322-1.203 1.88-1.79a42 42 0 0 0 .902-.98l.055-.062.012-.014c.226-.23.485-.63.554-1.122.071-.518-.074-1.105-.62-1.65l-3.549-3.55a2.27 2.27 0 0 0-1.139-.606c-.517-.097-1.109.017-1.64.549l-1.69 1.688a.43.43 0 0 1-.26.126c-.139.02-.369.004-.731-.145-.734-.302-1.918-1.11-3.804-2.996-1.873-1.873-2.588-3.147-2.846-3.922-.129-.386-.143-.646-.133-.796a1 1 0 0 1 .018-.131l1.635-1.635c.227-.227.492-.632.561-1.13.072-.518-.074-1.105-.619-1.65l-3.55-3.55c-.266-.267-.78-.608-1.393-.635-.458-.02-.945.137-1.386.578",
    clipRule: "evenodd"
  })));
};

var _path$bC;
function _extends$bK() { return _extends$bK = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$bK.apply(null, arguments); }
var SvgCallFilled48 = function SvgCallFilled48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$bK({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$bC || (_path$bC = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "m11.138 6.022-4.267 4.267-.033.056c-1.38 2.362-.817 5.735.949 9.373 1.783 3.674 4.865 7.774 8.811 11.72 4.926 4.927 9.667 7.742 13.423 9.147 1.876.701 3.516 1.054 4.816 1.137.65.041 1.225.015 1.708-.074.477-.087.899-.243 1.208-.492.908-.729 1.983-1.805 2.82-2.686A64 64 0 0 0 41.926 37l.082-.092.02-.022c.338-.343.727-.944.83-1.683.107-.777-.111-1.657-.929-2.475l-5.324-5.324a3.4 3.4 0 0 0-1.709-.91c-.776-.144-1.663.026-2.462.824l-2.532 2.533a.65.65 0 0 1-.39.188c-.21.03-.555.006-1.098-.218-1.1-.452-2.877-1.665-5.705-4.493-2.81-2.81-3.883-4.72-4.27-5.884-.193-.578-.215-.969-.2-1.194q.011-.134.028-.196l2.452-2.452c.341-.341.738-.948.842-1.695.108-.777-.11-1.657-.928-2.475l-5.324-5.324c-.401-.401-1.171-.913-2.09-.954-.688-.03-1.418.205-2.08.868"
  })));
};

var CallFilledIcon = function CallFilledIcon(props) {
  var callFilled = {
    12: SvgCallFilled12,
    16: SvgCallFilled16,
    18: SvgCallFilled18,
    24: SvgCallFilled24,
    32: SvgCallFilled32,
    48: SvgCallFilled48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: callFilled
  }, props));
};

var _path$bB, _path2$3K;
function _extends$bJ() { return _extends$bJ = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$bJ.apply(null, arguments); }
var SvgCamera12 = function SvgCamera12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$bJ({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$bB || (_path$bB = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "m4.864 2.8-.487.925a.61.61 0 0 1-.539.323H2.372a.4.4 0 0 0-.404.4V8.8c0 .221.18.4.404.4h7.255c.224 0 .405-.179.405-.4V4.448c0-.22-.181-.4-.405-.4H8.136a.61.61 0 0 1-.534-.315l-.51-.933zm-1.048-.608c.191-.364.572-.592.986-.592h2.35c.408 0 .784.221.978.577l.368.671h1.13a1.61 1.61 0 0 1 1.617 1.6V8.8c0 .884-.724 1.6-1.618 1.6H2.372A1.61 1.61 0 0 1 .754 8.8V4.448c0-.884.725-1.6 1.618-1.6H3.47z",
    clipRule: "evenodd"
  })), _path2$3K || (_path2$3K = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M5.987 7.175a.805.805 0 0 0 .81-.8c0-.442-.363-.8-.81-.8a.805.805 0 0 0-.809.8c0 .442.362.8.81.8m0 1.2a2.01 2.01 0 0 0 2.023-2c0-1.104-.906-2-2.023-2a2.01 2.01 0 0 0-2.022 2c0 1.105.905 2 2.022 2",
    clipRule: "evenodd"
  })));
};

var _path$bA, _path2$3J;
function _extends$bI() { return _extends$bI = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$bI.apply(null, arguments); }
var SvgCamera16 = function SvgCamera16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$bI({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$bA || (_path$bA = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "m6.485 3.733-.65 1.234a.81.81 0 0 1-.717.43H3.163a.536.536 0 0 0-.539.534v5.802c0 .295.241.534.54.534h9.673c.298 0 .54-.24.54-.534V5.93a.536.536 0 0 0-.54-.533h-1.989a.81.81 0 0 1-.711-.42l-.681-1.244zm-1.397-.81c.256-.486.763-.79 1.315-.79h3.133c.545 0 1.046.295 1.305.77l.49.894h1.506c1.191 0 2.157.955 2.157 2.133v5.803c0 1.178-.966 2.134-2.157 2.134H3.163c-1.191 0-2.157-.956-2.157-2.134V5.931c0-1.179.966-2.134 2.157-2.134h1.464z",
    clipRule: "evenodd"
  })), _path2$3J || (_path2$3J = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M7.983 9.567c.596 0 1.079-.478 1.079-1.067 0-.59-.483-1.067-1.079-1.067-.595 0-1.078.478-1.078 1.067 0 .59.483 1.067 1.078 1.067m0 1.6c1.49 0 2.697-1.194 2.697-2.667S9.472 5.833 7.983 5.833 5.287 7.027 5.287 8.5s1.207 2.667 2.696 2.667",
    clipRule: "evenodd"
  })));
};

var _path$bz, _path2$3I;
function _extends$bH() { return _extends$bH = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$bH.apply(null, arguments); }
var SvgCamera18 = function SvgCamera18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$bH({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$bz || (_path$bz = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "m7.234 4.1-.759 1.441a.81.81 0 0 1-.717.43h-2.2a.704.704 0 0 0-.707.7V13.2c0 .387.317.7.708.7H14.44c.391 0 .708-.313.708-.7V6.672c0-.387-.317-.7-.708-.7h-2.237a.81.81 0 0 1-.712-.42L10.699 4.1zm-1.42-.766a1.57 1.57 0 0 1 1.39-.834h3.524a1.57 1.57 0 0 1 1.379.813l.58 1.059h1.754c1.285 0 2.326 1.03 2.326 2.3V13.2c0 1.27-1.041 2.3-2.326 2.3H3.56c-1.285 0-2.326-1.03-2.326-2.3V6.672c0-1.27 1.041-2.3 2.326-2.3h1.708z",
    clipRule: "evenodd"
  })), _path2$3I || (_path2$3I = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8.981 10.963c.782 0 1.416-.627 1.416-1.4 0-.774-.634-1.4-1.416-1.4s-1.416.626-1.416 1.4.634 1.4 1.416 1.4m0 1.6c1.675 0 3.034-1.344 3.034-3 0-1.657-1.359-3-3.034-3s-3.033 1.343-3.033 3c0 1.656 1.358 3 3.033 3",
    clipRule: "evenodd"
  })));
};

var _path$by, _path2$3H;
function _extends$bG() { return _extends$bG = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$bG.apply(null, arguments); }
var SvgCamera24 = function SvgCamera24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$bG({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$by || (_path$by = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M9.605 5.3a.1.1 0 0 0-.09.054l-1.03 1.958a.91.91 0 0 1-.808.484H4.745c-.614 0-1.112.492-1.112 1.1V17.6c0 .607.498 1.1 1.112 1.1h14.51c.614 0 1.112-.492 1.112-1.1V8.896c0-.608-.498-1.1-1.112-1.1h-2.983a.91.91 0 0 1-.8-.472l-1.079-1.972a.1.1 0 0 0-.089-.052zm-1.704-.778A1.92 1.92 0 0 1 9.605 3.5h4.7c.705 0 1.354.382 1.69.996l.82 1.5h2.44c1.62 0 2.933 1.298 2.933 2.9V17.6c0 1.602-1.313 2.9-2.933 2.9H4.745c-1.62 0-2.932-1.298-2.932-2.9V8.896c0-1.602 1.312-2.9 2.932-2.9h2.38z",
    clipRule: "evenodd"
  })), _path2$3H || (_path2$3H = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M11.975 14.95c1.228 0 2.224-.985 2.224-2.2s-.996-2.2-2.224-2.2-2.225.985-2.225 2.2.996 2.2 2.225 2.2m0 1.8c2.234 0 4.045-1.79 4.045-4s-1.811-4-4.045-4-4.045 1.79-4.045 4 1.811 4 4.045 4",
    clipRule: "evenodd"
  })));
};

var _path$bx, _path2$3G;
function _extends$bF() { return _extends$bF = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$bF.apply(null, arguments); }
var SvgCamera32 = function SvgCamera32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$bF({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$bx || (_path$bx = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M12.807 6.867c-.126 0-.241.069-.3.179l-1.374 2.61c-.174.331-.52.538-.897.538h-3.91c-.93 0-1.685.747-1.685 1.667v11.606c0 .92.755 1.666 1.686 1.666h19.347c.93 0 1.685-.746 1.685-1.666V11.86c0-.92-.755-1.667-1.686-1.667h-3.977c-.371 0-.713-.2-.89-.524L19.37 7.041a.34.34 0 0 0-.296-.174zm-2.093-.745a2.36 2.36 0 0 1 2.093-1.255h6.266c.866 0 1.663.47 2.075 1.223l1.15 2.104h3.376c2.047 0 3.707 1.642 3.707 3.667v11.606c0 2.025-1.66 3.666-3.707 3.666H6.326c-2.048 0-3.708-1.641-3.708-3.666V11.86c0-2.025 1.66-3.667 3.708-3.667h3.296z",
    clipRule: "evenodd"
  })), _path2$3G || (_path2$3G = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M15.966 20.333c1.862 0 3.371-1.492 3.371-3.333 0-1.84-1.51-3.333-3.37-3.333-1.862 0-3.371 1.492-3.371 3.333s1.509 3.333 3.37 3.333m0 2c2.979 0 5.393-2.387 5.393-5.333 0-2.945-2.414-5.333-5.393-5.333S10.574 14.055 10.574 17s2.414 5.333 5.392 5.333",
    clipRule: "evenodd"
  })));
};

var _path$bw, _path2$3F;
function _extends$bE() { return _extends$bE = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$bE.apply(null, arguments); }
var SvgCamera48 = function SvgCamera48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$bE({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$bw || (_path$bw = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M19.21 10a.81.81 0 0 0-.717.43l-2.062 3.916a1.22 1.22 0 0 1-1.077.646H9.49c-1.564 0-2.831 1.253-2.831 2.8V35.2c0 1.546 1.267 2.8 2.83 2.8H38.51c1.564 0 2.832-1.254 2.832-2.8V17.792c0-1.547-1.268-2.8-2.832-2.8h-5.966c-.445 0-.855-.242-1.067-.63L29.32 10.42A.81.81 0 0 0 28.61 10zm-2.87-.678A3.24 3.24 0 0 1 19.21 7.6h9.399c1.188 0 2.28.644 2.846 1.678l1.813 3.314h5.242c2.904 0 5.258 2.328 5.258 5.2V35.2c0 2.872-2.354 5.2-5.258 5.2H9.49c-2.904 0-5.258-2.328-5.258-5.2V17.792c0-2.872 2.354-5.2 5.258-5.2h5.128z",
    clipRule: "evenodd"
  })), _path2$3F || (_path2$3F = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M23.95 31.1c3.127 0 5.662-2.507 5.662-5.6s-2.535-5.6-5.662-5.6c-3.128 0-5.663 2.507-5.663 5.6s2.535 5.6 5.663 5.6m0 2.4c4.467 0 8.089-3.582 8.089-8s-3.622-8-8.09-8c-4.467 0-8.089 3.582-8.089 8s3.622 8 8.09 8",
    clipRule: "evenodd"
  })));
};

var CameraIcon = function CameraIcon(props) {
  var camera = {
    12: SvgCamera12,
    16: SvgCamera16,
    18: SvgCamera18,
    24: SvgCamera24,
    32: SvgCamera32,
    48: SvgCamera48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: camera
  }, props));
};

var _path$bv;
function _extends$bD() { return _extends$bD = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$bD.apply(null, arguments); }
var SvgCameraFilled12 = function SvgCameraFilled12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$bD({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$bv || (_path$bv = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M2 2.86h1.67l.569-1.091a.5.5 0 0 1 .443-.269h2.587a.5.5 0 0 1 .44.262l.593 1.098H10a1 1 0 0 1 1 1v5.173a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V3.86a1 1 0 0 1 1-1M7.166 6.3a1.18 1.18 0 1 1-2.36 0 1.18 1.18 0 0 1 2.36 0m1 0a2.18 2.18 0 1 1-4.36 0 2.18 2.18 0 0 1 4.36 0",
    clipRule: "evenodd"
  })));
};

var _path$bu;
function _extends$bC() { return _extends$bC = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$bC.apply(null, arguments); }
var SvgCameraFilled16 = function SvgCameraFilled16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$bC({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$bu || (_path$bu = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M2.833 3.813h2.06l.665-1.275A1 1 0 0 1 6.445 2h3.048a1 1 0 0 1 .88.524l.697 1.29h2.097a1.5 1.5 0 0 1 1.5 1.5v6.564a1.5 1.5 0 0 1-1.5 1.5H2.833a1.5 1.5 0 0 1-1.5-1.5V5.313a1.5 1.5 0 0 1 1.5-1.5m6.655 4.588a1.506 1.506 0 1 1-3.013 0 1.506 1.506 0 0 1 3.013 0m1.4 0a2.906 2.906 0 1 1-5.813 0 2.906 2.906 0 0 1 5.813 0",
    clipRule: "evenodd"
  })));
};

var _path$bt;
function _extends$bB() { return _extends$bB = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$bB.apply(null, arguments); }
var SvgCameraFilled18 = function SvgCameraFilled18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$bB({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$bt || (_path$bt = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M3 4.29h2.505l.783-1.502a1 1 0 0 1 .887-.538h3.58a1 1 0 0 1 .879.524l.82 1.516H15a1.5 1.5 0 0 1 1.5 1.5v7.76a1.5 1.5 0 0 1-1.5 1.5H3a1.5 1.5 0 0 1-1.5-1.5V5.79A1.5 1.5 0 0 1 3 4.29m7.65 5.16a1.67 1.67 0 1 1-3.34 0 1.67 1.67 0 0 1 3.34 0m1.6 0a3.27 3.27 0 1 1-6.54 0 3.27 3.27 0 0 1 6.54 0",
    clipRule: "evenodd"
  })));
};

var _path$bs;
function _extends$bA() { return _extends$bA = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$bA.apply(null, arguments); }
var SvgCameraFilled24 = function SvgCameraFilled24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$bA({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$bs || (_path$bs = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M4 5.72h3.34l1.137-2.182A1 1 0 0 1 9.364 3h5.173a1 1 0 0 1 .88.524l1.188 2.196H20a2 2 0 0 1 2 2v10.347a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V7.72a2 2 0 0 1 2-2m10.533 6.88a2.56 2.56 0 1 1-5.12 0 2.56 2.56 0 0 1 5.12 0m1.8 0a4.36 4.36 0 1 1-8.72 0 4.36 4.36 0 0 1 8.72 0",
    clipRule: "evenodd"
  })));
};

var _path$br;
function _extends$bz() { return _extends$bz = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$bz.apply(null, arguments); }
var SvgCameraFilled32 = function SvgCameraFilled32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$bz({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$br || (_path$br = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M5.167 7.627h4.62l1.469-2.82A1.5 1.5 0 0 1 12.586 4h6.698a1.5 1.5 0 0 1 1.32.786l1.536 2.84h4.693a2.5 2.5 0 0 1 2.5 2.5v14.13a2.5 2.5 0 0 1-2.5 2.5H5.167a2.5 2.5 0 0 1-2.5-2.5v-14.13a2.5 2.5 0 0 1 2.5-2.5m14.61 9.174a3.813 3.813 0 1 1-7.626 0 3.813 3.813 0 0 1 7.625 0m2 0a5.813 5.813 0 1 1-11.626 0 5.813 5.813 0 0 1 11.625 0",
    clipRule: "evenodd"
  })));
};

var _path$bq;
function _extends$by() { return _extends$by = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$by.apply(null, arguments); }
var SvgCameraFilled48 = function SvgCameraFilled48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$by({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$bq || (_path$bq = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8 11.44h6.681l2.273-4.364A2 2 0 0 1 18.728 6h10.347a2 2 0 0 1 1.76 1.048l2.375 4.392H40a4 4 0 0 1 4 4v20.694a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4V15.44a4 4 0 0 1 4-4m22.265 13.762a6.32 6.32 0 1 1-12.639 0 6.32 6.32 0 0 1 12.639 0m2.4 0a8.72 8.72 0 1 1-17.439 0 8.72 8.72 0 0 1 17.439 0",
    clipRule: "evenodd"
  })));
};

var CameraFilledIcon = function CameraFilledIcon(props) {
  var cameraFilled = {
    12: SvgCameraFilled12,
    16: SvgCameraFilled16,
    18: SvgCameraFilled18,
    24: SvgCameraFilled24,
    32: SvgCameraFilled32,
    48: SvgCameraFilled48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: cameraFilled
  }, props));
};

var _path$bp, _path2$3E;
function _extends$bx() { return _extends$bx = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$bx.apply(null, arguments); }
var SvgCard12 = function SvgCard12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$bx({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$bp || (_path$bp = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M9.5 3.2h-7a.3.3 0 0 0-.3.3v5a.3.3 0 0 0 .3.3h7a.3.3 0 0 0 .3-.3v-5a.3.3 0 0 0-.3-.3M2.5 2A1.5 1.5 0 0 0 1 3.5v5A1.5 1.5 0 0 0 2.5 10h7A1.5 1.5 0 0 0 11 8.5v-5A1.5 1.5 0 0 0 9.5 2z",
    clipRule: "evenodd"
  })), _path2$3E || (_path2$3E = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M1.5 4.9a.6.6 0 0 1 .6-.6h7.8a.6.6 0 1 1 0 1.2H2.1a.6.6 0 0 1-.6-.6M6.7 6.8a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5",
    clipRule: "evenodd"
  })));
};

var _path$bo, _path2$3D;
function _extends$bw() { return _extends$bw = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$bw.apply(null, arguments); }
var SvgCard16 = function SvgCard16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$bw({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$bo || (_path$bo = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M12.667 4.167H3.333a.5.5 0 0 0-.5.5v6.666a.5.5 0 0 0 .5.5h9.334a.5.5 0 0 0 .5-.5V4.667a.5.5 0 0 0-.5-.5m-9.334-1.5a2 2 0 0 0-2 2v6.666a2 2 0 0 0 2 2h9.334a2 2 0 0 0 2-2V4.667a2 2 0 0 0-2-2z",
    clipRule: "evenodd"
  })), _path2$3D || (_path2$3D = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M2 5.917a.75.75 0 0 1 .75-.75h10.5a.75.75 0 0 1 0 1.5H2.75a.75.75 0 0 1-.75-.75M10 8.25a.75.75 0 0 1 .75-.75h1.167a.75.75 0 0 1 0 1.5H10.75a.75.75 0 0 1-.75-.75",
    clipRule: "evenodd"
  })));
};

var _path$bn, _path2$3C;
function _extends$bv() { return _extends$bv = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$bv.apply(null, arguments); }
var SvgCard18 = function SvgCard18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$bv({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$bn || (_path$bn = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M14.25 4.6H3.75a.65.65 0 0 0-.65.65v7.5c0 .359.291.65.65.65h10.5a.65.65 0 0 0 .65-.65v-7.5a.65.65 0 0 0-.65-.65M3.75 3A2.25 2.25 0 0 0 1.5 5.25v7.5A2.25 2.25 0 0 0 3.75 15h10.5a2.25 2.25 0 0 0 2.25-2.25v-7.5A2.25 2.25 0 0 0 14.25 3z",
    clipRule: "evenodd"
  })), _path2$3C || (_path2$3C = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M2.25 6.7a.8.8 0 0 1 .8-.8h11.9a.8.8 0 0 1 0 1.6H3.05a.8.8 0 0 1-.8-.8M11.25 9.325a.8.8 0 0 1 .8-.8h1.4a.8.8 0 0 1 0 1.6h-1.4a.8.8 0 0 1-.8-.8",
    clipRule: "evenodd"
  })));
};

var _path$bm, _path2$3B;
function _extends$bu() { return _extends$bu = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$bu.apply(null, arguments); }
var SvgCard24 = function SvgCard24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$bu({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$bm || (_path$bm = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M19 5.8H5A1.2 1.2 0 0 0 3.8 7v10A1.2 1.2 0 0 0 5 18.2h14a1.2 1.2 0 0 0 1.2-1.2V7A1.2 1.2 0 0 0 19 5.8M5 4a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3z",
    clipRule: "evenodd"
  })), _path2$3B || (_path2$3B = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M3 9.1a.9.9 0 0 1 .9-.9h16.2a.9.9 0 1 1 0 1.8H3.9a.9.9 0 0 1-.9-.9M15 12.6a.9.9 0 0 1 .9-.9h2.2a.9.9 0 1 1 0 1.8h-2.2a.9.9 0 0 1-.9-.9",
    clipRule: "evenodd"
  })));
};

var _path$bl, _path2$3A;
function _extends$bt() { return _extends$bt = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$bt.apply(null, arguments); }
var SvgCard32 = function SvgCard32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$bt({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$bl || (_path$bl = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M25.333 7.334H6.667a2 2 0 0 0-2 2v13.333a2 2 0 0 0 2 2h18.666a2 2 0 0 0 2-2V9.334a2 2 0 0 0-2-2m-18.666-2a4 4 0 0 0-4 4v13.333a4 4 0 0 0 4 4h18.666a4 4 0 0 0 4-4V9.334a4 4 0 0 0-4-4z",
    clipRule: "evenodd"
  })), _path2$3A || (_path2$3A = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M4 12.334a1 1 0 0 1 1-1h22a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1M20 17a1 1 0 0 1 1-1h3.333a1 1 0 1 1 0 2H21a1 1 0 0 1-1-1",
    clipRule: "evenodd"
  })));
};

var _path$bk, _path2$3z;
function _extends$bs() { return _extends$bs = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$bs.apply(null, arguments); }
var SvgCard48 = function SvgCard48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$bs({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$bk || (_path$bk = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M38 10.4H10A3.6 3.6 0 0 0 6.4 14v20a3.6 3.6 0 0 0 3.6 3.6h28a3.6 3.6 0 0 0 3.6-3.6V14a3.6 3.6 0 0 0-3.6-3.6M10 8a6 6 0 0 0-6 6v20a6 6 0 0 0 6 6h28a6 6 0 0 0 6-6V14a6 6 0 0 0-6-6z",
    clipRule: "evenodd"
  })), _path2$3z || (_path2$3z = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M5 18.8a1.2 1.2 0 0 1 1.2-1.2h35.6a1.2 1.2 0 0 1 0 2.4H6.2A1.2 1.2 0 0 1 5 18.8M30 25.8a1.2 1.2 0 0 1 1.2-1.2h5.6a1.2 1.2 0 0 1 0 2.4h-5.6a1.2 1.2 0 0 1-1.2-1.2",
    clipRule: "evenodd"
  })));
};

var CardIcon = function CardIcon(props) {
  var card = {
    12: SvgCard12,
    16: SvgCard16,
    18: SvgCard18,
    24: SvgCard24,
    32: SvgCard32,
    48: SvgCard48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: card
  }, props));
};

var _path$bj;
function _extends$br() { return _extends$br = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$br.apply(null, arguments); }
var SvgCardFilled12 = function SvgCardFilled12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$br({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$bj || (_path$bj = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M2.5 2A1.5 1.5 0 0 0 1 3.5v.7h10v-.7A1.5 1.5 0 0 0 9.5 2zM11 5.2H1v3.3A1.5 1.5 0 0 0 2.5 10h7A1.5 1.5 0 0 0 11 8.5zM7 6.8a.5.5 0 0 1 .5-.5h1.2a.5.5 0 0 1 0 1H7.5a.5.5 0 0 1-.5-.5",
    clipRule: "evenodd"
  })));
};

var _path$bi, _path2$3y;
function _extends$bq() { return _extends$bq = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$bq.apply(null, arguments); }
var SvgCardFilled16 = function SvgCardFilled16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$bq({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$bi || (_path$bi = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M3.333 2.667a2 2 0 0 0-2 2v.8h13.334v-.8a2 2 0 0 0-2-2z"
  })), _path2$3y || (_path2$3y = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M14.667 6.667H1.333v4.666a2 2 0 0 0 2 2h9.334a2 2 0 0 0 2-2zM10.933 7.8a.6.6 0 1 0 0 1.2H12.4a.6.6 0 1 0 0-1.2z",
    clipRule: "evenodd"
  })));
};

var _path$bh, _path2$3x;
function _extends$bp() { return _extends$bp = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$bp.apply(null, arguments); }
var SvgCardFilled18 = function SvgCardFilled18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$bp({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$bh || (_path$bh = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M3.75 3A2.25 2.25 0 0 0 1.5 5.25v.875h15V5.25A2.25 2.25 0 0 0 14.25 3z"
  })), _path2$3x || (_path2$3x = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M16.5 7.525h-15v5.225A2.25 2.25 0 0 0 3.75 15h10.5a2.25 2.25 0 0 0 2.25-2.25zm-4.275 1.3a.7.7 0 1 0 0 1.4h1.8a.7.7 0 1 0 0-1.4z",
    clipRule: "evenodd"
  })));
};

var _path$bg, _path2$3w;
function _extends$bo() { return _extends$bo = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$bo.apply(null, arguments); }
var SvgCardFilled24 = function SvgCardFilled24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$bo({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$bg || (_path$bg = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M5 4a3 3 0 0 0-3 3v1.3h20V7a3 3 0 0 0-3-3z"
  })), _path2$3w || (_path2$3w = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M22 9.9H2V17a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3zm-5.7 2a.8.8 0 0 0 0 1.6h2.4a.8.8 0 0 0 0-1.6z",
    clipRule: "evenodd"
  })));
};

var _path$bf, _path2$3v;
function _extends$bn() { return _extends$bn = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$bn.apply(null, arguments); }
var SvgCardFilled32 = function SvgCardFilled32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$bn({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$bf || (_path$bf = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M6.667 5.333a4 4 0 0 0-4 4v2h26.666v-2a4 4 0 0 0-4-4z"
  })), _path2$3v || (_path2$3v = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M29.333 13.333H2.667v9.334a4 4 0 0 0 4 4h18.666a4 4 0 0 0 4-4zM20.667 17a1 1 0 0 1 1-1H25a1 1 0 1 1 0 2h-3.333a1 1 0 0 1-1-1",
    clipRule: "evenodd"
  })));
};

var _path$be, _path2$3u;
function _extends$bm() { return _extends$bm = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$bm.apply(null, arguments); }
var SvgCardFilled48 = function SvgCardFilled48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$bm({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$be || (_path$be = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M10 8a6 6 0 0 0-6 6v3.6h40V14a6 6 0 0 0-6-6z"
  })), _path2$3u || (_path2$3u = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M44 20H4v14a6 6 0 0 0 6 6h28a6 6 0 0 0 6-6zm-13 5.8a1.2 1.2 0 0 1 1.2-1.2h5.6a1.2 1.2 0 1 1 0 2.4h-5.6a1.2 1.2 0 0 1-1.2-1.2",
    clipRule: "evenodd"
  })));
};

var CardFilledIcon = function CardFilledIcon(props) {
  var cardFilled = {
    12: SvgCardFilled12,
    16: SvgCardFilled16,
    18: SvgCardFilled18,
    24: SvgCardFilled24,
    32: SvgCardFilled32,
    48: SvgCardFilled48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: cardFilled
  }, props));
};

var _path$bd, _path2$3t;
function _extends$bl() { return _extends$bl = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$bl.apply(null, arguments); }
var SvgCart12 = function SvgCart12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$bl({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$bd || (_path$bd = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M.15 1.5a.6.6 0 0 1 .6-.6h1.307a.75.75 0 0 1 .733.591l.136.625h7.165a1.1 1.1 0 0 1 1.059 1.397l-.934 3.33a2.1 2.1 0 0 1-2.022 1.534H4.998a2.1 2.1 0 0 1-2.022-1.533L1.859 2.86l-.164-.76H.75a.6.6 0 0 1-.6-.6m3.083 1.816.898 3.204a.9.9 0 0 0 .867.657h3.196a.9.9 0 0 0 .867-.657l.898-3.204z",
    clipRule: "evenodd"
  })), _path2$3t || (_path2$3t = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M5.6 9.65a.9.9 0 1 1-1.8 0 .9.9 0 0 1 1.8 0M9.457 9.65a.9.9 0 1 1-1.8 0 .9.9 0 0 1 1.8 0"
  })));
};

var _path$bc, _path2$3s;
function _extends$bk() { return _extends$bk = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$bk.apply(null, arguments); }
var SvgCart16 = function SvgCart16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$bk({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$bc || (_path$bc = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M.25 2A.75.75 0 0 1 1 1.25h1.743a.95.95 0 0 1 .929.749l.189.872h9.593c.938 0 1.617.896 1.364 1.799l-1.245 4.442a2.75 2.75 0 0 1-2.648 2.007H6.664a2.75 2.75 0 0 1-2.648-2.007l-1.488-5.31L2.3 2.75H1A.75.75 0 0 1 .25 2m3.995 2.371L5.46 8.707c.151.54.643.912 1.204.912h4.262a1.25 1.25 0 0 0 1.203-.912l1.215-4.336z",
    clipRule: "evenodd"
  })), _path2$3s || (_path2$3s = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M7.3 12.817a1.15 1.15 0 1 1-2.3 0 1.15 1.15 0 0 1 2.3 0M11.293 13.967a1.15 1.15 0 1 0 0-2.3 1.15 1.15 0 0 0 0 2.3"
  })));
};

var _path$bb, _path2$3r;
function _extends$bj() { return _extends$bj = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$bj.apply(null, arguments); }
var SvgCart18 = function SvgCart18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$bj({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$bb || (_path$bb = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M.325 2.25a.8.8 0 0 1 .8-.8h1.962c.482 0 .9.337 1.001.808l.22 1.016h10.828c1.027 0 1.77.98 1.493 1.968l-1.4 4.997a3.05 3.05 0 0 1-2.938 2.227H7.497a3.05 3.05 0 0 1-2.937-2.227L2.886 4.267 2.623 3.05H1.125a.8.8 0 0 1-.8-.8m4.393 2.624 1.383 4.933a1.45 1.45 0 0 0 1.396 1.059h4.794c.65 0 1.221-.433 1.397-1.059l1.382-4.933z",
    clipRule: "evenodd"
  })), _path2$3r || (_path2$3r = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M8.3 14.375a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0M12.836 15.625a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5"
  })));
};

var _path$ba;
function _extends$bi() { return _extends$bi = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$bi.apply(null, arguments); }
var SvgCart24 = function SvgCart24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$bi({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$ba || (_path$ba = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M.1 2.5a.9.9 0 0 1 .9-.9h2.758a1.2 1.2 0 0 1 1.173.946l.348 1.607h15.402a1.9 1.9 0 0 1 1.83 2.413l-2.01 7.168a3.9 3.9 0 0 1-3.754 2.848h-6.94a3.9 3.9 0 0 1-3.755-2.848L3.679 5.27 3.274 3.4H1a.9.9 0 0 1-.9-.9m5.64 3.453 2.045 7.296a2.1 2.1 0 0 0 2.022 1.533h6.94a2.1 2.1 0 0 0 2.022-1.533l2.009-7.169a.1.1 0 0 0-.097-.127zM9.38 22.19a2.095 2.095 0 1 0 0-4.19 2.095 2.095 0 0 0 0 4.19m0-1.6a.495.495 0 1 1 0-.99.495.495 0 0 1 0 .99M19.19 20.095a2.095 2.095 0 1 1-4.19 0 2.095 2.095 0 0 1 4.19 0m-1.6 0a.495.495 0 1 0-.99 0 .495.495 0 0 0 .99 0"
  })));
};

var _path$b9;
function _extends$bh() { return _extends$bh = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$bh.apply(null, arguments); }
var SvgCart32 = function SvgCart32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$bh({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$b9 || (_path$b9 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M1 4a1 1 0 0 1 1-1h3.487a1.4 1.4 0 0 1 1.368 1.104l.464 2.138h19.59a2.333 2.333 0 0 1 2.246 2.963l-2.49 8.883a5 5 0 0 1-4.814 3.65h-8.523a5 5 0 0 1-4.815-3.65L5.541 7.483 5.003 5H2a1 1 0 0 1-1-1m6.83 4.242 2.609 9.306a3 3 0 0 0 2.889 2.19h8.523a3 3 0 0 0 2.889-2.19l2.49-8.883a.333.333 0 0 0-.322-.423zM12.508 28.92a2.794 2.794 0 1 0 0-5.587 2.794 2.794 0 0 0 0 5.588m0-2a.794.794 0 1 0 0-1.587.794.794 0 0 0 0 1.588M25.587 26.127a2.794 2.794 0 1 1-5.587 0 2.794 2.794 0 0 1 5.587 0m-2 0a.794.794 0 1 1-1.587 0 .794.794 0 0 1 1.587 0",
    clipRule: "evenodd"
  })));
};

var _path$b8;
function _extends$bg() { return _extends$bg = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$bg.apply(null, arguments); }
var SvgCart48 = function SvgCart48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$bg({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$b8 || (_path$b8 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M1.8 6A1.2 1.2 0 0 1 3 4.8h5.23a1.8 1.8 0 0 1 1.76 1.419l.746 3.444h29.626a3.2 3.2 0 0 1 3.081 4.064L39.71 27.05a7.2 7.2 0 0 1-6.933 5.257H19.991a7.2 7.2 0 0 1-6.933-5.257L8.603 11.152 7.746 7.2H3A1.2 1.2 0 0 1 1.8 6m9.55 6.063 4.02 14.34a4.8 4.8 0 0 0 4.621 3.505h12.785a4.8 4.8 0 0 0 4.622-3.505l3.735-13.324a.8.8 0 0 0-.77-1.016zM18.762 43.38a4.19 4.19 0 1 0 0-8.38 4.19 4.19 0 0 0 0 8.38m0-2.4a1.79 1.79 0 1 0 0-3.58 1.79 1.79 0 0 0 0 3.58M38.38 39.19a4.19 4.19 0 1 1-8.38 0 4.19 4.19 0 0 1 8.38 0m-2.4 0a1.79 1.79 0 1 1-3.58 0 1.79 1.79 0 0 1 3.58 0",
    clipRule: "evenodd"
  })));
};

var CartIcon = function CartIcon(props) {
  var cart = {
    12: SvgCart12,
    16: SvgCart16,
    18: SvgCart18,
    24: SvgCart24,
    32: SvgCart32,
    48: SvgCart48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: cart
  }, props));
};

var _path$b7;
function _extends$bf() { return _extends$bf = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$bf.apply(null, arguments); }
var SvgCash12 = function SvgCash12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$bf({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$b7 || (_path$b7 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8.178 4.685a.6.6 0 0 1-.848.008 1.83 1.83 0 1 0 0 2.614.6.6 0 1 1 .84.857 3.03 3.03 0 1 1 0-4.328.6.6 0 0 1 .008.849M6 9.8a3.8 3.8 0 1 0 0-7.6 3.8 3.8 0 0 0 0 7.6M6 11A5 5 0 1 0 6 1a5 5 0 0 0 0 10",
    clipRule: "evenodd"
  })));
};

var _path$b6;
function _extends$be() { return _extends$be = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$be.apply(null, arguments); }
var SvgCash16 = function SvgCash16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$be({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$b6 || (_path$b6 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M10.87 6.211a.75.75 0 0 1-1.062.01 2.49 2.49 0 1 0 0 3.556.75.75 0 0 1 1.05 1.072 3.99 3.99 0 1 1 0-5.699c.296.29.301.766.011 1.061M8 13.167A5.167 5.167 0 1 0 8 2.833a5.167 5.167 0 0 0 0 10.334m0 1.5A6.667 6.667 0 1 0 8 1.334a6.667 6.667 0 0 0 0 13.333",
    clipRule: "evenodd"
  })));
};

var _path$b5;
function _extends$bd() { return _extends$bd = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$bd.apply(null, arguments); }
var SvgCash18 = function SvgCash18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$bd({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$b5 || (_path$b5 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M12.196 6.957a.8.8 0 0 1-1.131.011 2.845 2.845 0 1 0 0 4.063.8.8 0 0 1 1.12 1.143 4.445 4.445 0 1 1 0-6.349.8.8 0 0 1 .011 1.132M9 14.9A5.9 5.9 0 1 0 9 3.1a5.9 5.9 0 0 0 0 11.8m0 1.6a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15",
    clipRule: "evenodd"
  })));
};

var _path$b4;
function _extends$bc() { return _extends$bc = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$bc.apply(null, arguments); }
var SvgCash24 = function SvgCash24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$bc({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$b4 || (_path$b4 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M16.112 9.13a.857.857 0 0 1-1.212.011 4.003 4.003 0 1 0 0 5.717.857.857 0 0 1 1.2 1.225 5.717 5.717 0 1 1 0-8.166.857.857 0 0 1 .012 1.212M12 20.285a8.286 8.286 0 1 0 0-16.572 8.286 8.286 0 0 0 0 16.572M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10",
    clipRule: "evenodd"
  })));
};

var _path$b3;
function _extends$bb() { return _extends$bb = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$bb.apply(null, arguments); }
var SvgCash32 = function SvgCash32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$bb({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$b3 || (_path$b3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M21.38 12.072a1 1 0 0 1-1.414.014 5.48 5.48 0 1 0 0 7.827 1 1 0 0 1 1.4 1.428 7.48 7.48 0 1 1 0-10.683 1 1 0 0 1 .015 1.414M16 27.333c6.26 0 11.333-5.074 11.333-11.333S22.26 4.667 16 4.667 4.667 9.74 4.667 16 9.74 27.333 16 27.333m0 2c7.364 0 13.333-5.97 13.333-13.333S23.363 2.667 16 2.667 2.667 8.636 2.667 16 8.636 29.333 16 29.333",
    clipRule: "evenodd"
  })));
};

var _path$b2;
function _extends$ba() { return _extends$ba = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$ba.apply(null, arguments); }
var SvgCash48 = function SvgCash48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$ba({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$b2 || (_path$b2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M31.857 17.899a1.2 1.2 0 0 1-1.697.017 8.5 8.5 0 0 0-5.964-2.436 8.52 8.52 0 0 0 0 17.04 8.5 8.5 0 0 0 5.964-2.436 1.2 1.2 0 1 1 1.68 1.714 10.9 10.9 0 0 1-7.644 3.122c-6.03 0-10.92-4.89-10.92-10.92s4.89-10.92 10.92-10.92c2.976 0 5.676 1.192 7.644 3.122a1.2 1.2 0 0 1 .017 1.697M24 41.6c9.72 0 17.6-7.88 17.6-17.6S33.72 6.4 24 6.4 6.4 14.28 6.4 24 14.28 41.6 24 41.6m0 2.4c11.046 0 20-8.954 20-20S35.046 4 24 4 4 12.954 4 24s8.954 20 20 20",
    clipRule: "evenodd"
  })));
};

var CashIcon = function CashIcon(props) {
  var cash = {
    12: SvgCash12,
    16: SvgCash16,
    18: SvgCash18,
    24: SvgCash24,
    32: SvgCash32,
    48: SvgCash48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: cash
  }, props));
};

var _path$b1;
function _extends$b9() { return _extends$b9 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$b9.apply(null, arguments); }
var SvgCashFilled12 = function SvgCashFilled12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$b9({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$b1 || (_path$b1 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M6 11A5 5 0 1 0 6 1a5 5 0 0 0 0 10M4.219 6A1.83 1.83 0 0 1 7.33 4.693a.6.6 0 0 0 .84-.857 3.03 3.03 0 1 0 0 4.328.6.6 0 0 0-.84-.857A1.83 1.83 0 0 1 4.22 6",
    clipRule: "evenodd"
  })));
};

var _path$b0;
function _extends$b8() { return _extends$b8 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$b8.apply(null, arguments); }
var SvgCashFilled16 = function SvgCashFilled16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$b8({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$b0 || (_path$b0 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8 14.666A6.667 6.667 0 1 0 8 1.333a6.667 6.667 0 0 0 0 13.333M5.575 8A2.49 2.49 0 0 1 9.808 6.22a.75.75 0 1 0 1.05-1.07 3.99 3.99 0 1 0 0 5.699.75.75 0 0 0-1.05-1.072A2.49 2.49 0 0 1 5.575 8",
    clipRule: "evenodd"
  })));
};

var _path$a$;
function _extends$b7() { return _extends$b7 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$b7.apply(null, arguments); }
var SvgCashFilled18 = function SvgCashFilled18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$b7({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$a$ || (_path$a$ = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M9 16.5a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15M6.229 9a2.845 2.845 0 0 1 4.836-2.032.8.8 0 0 0 1.12-1.142 4.445 4.445 0 1 0 0 6.349.8.8 0 1 0-1.12-1.143A2.845 2.845 0 0 1 6.229 9",
    clipRule: "evenodd"
  })));
};

var _path$a_;
function _extends$b6() { return _extends$b6 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$b6.apply(null, arguments); }
var SvgCashFilled24 = function SvgCashFilled24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$b6({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$a_ || (_path$a_ = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10M8.138 12a3.96 3.96 0 0 1 6.732-2.828.9.9 0 0 0 1.26-1.285 5.76 5.76 0 1 0 0 8.227.9.9 0 1 0-1.26-1.286A3.96 3.96 0 0 1 8.138 12",
    clipRule: "evenodd"
  })));
};

var _path$aZ;
function _extends$b5() { return _extends$b5 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$b5.apply(null, arguments); }
var SvgCashFilled32 = function SvgCashFilled32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$b5({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$aZ || (_path$aZ = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M16.333 29.667c7.364 0 13.334-5.97 13.334-13.334S23.697 3 16.333 3 3 8.97 3 16.333s5.97 13.334 13.333 13.334m-5.349-13.334A5.48 5.48 0 0 1 20.3 12.42a1 1 0 1 0 1.4-1.428 7.48 7.48 0 1 0 0 10.683 1 1 0 1 0-1.4-1.428 5.48 5.48 0 0 1-9.316-3.913",
    clipRule: "evenodd"
  })));
};

var _path$aY;
function _extends$b4() { return _extends$b4 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$b4.apply(null, arguments); }
var SvgCashFilled48 = function SvgCashFilled48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$b4({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$aY || (_path$aY = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M24 44c11.046 0 20-8.954 20-20S35.046 4 24 4 4 12.954 4 24s8.954 20 20 20m-8.324-20a8.52 8.52 0 0 1 8.52-8.52c2.322 0 4.426.928 5.964 2.436a1.2 1.2 0 1 0 1.68-1.714 10.9 10.9 0 0 0-7.644-3.122c-6.03 0-10.92 4.89-10.92 10.92s4.89 10.92 10.92 10.92c2.976 0 5.676-1.192 7.644-3.122a1.2 1.2 0 1 0-1.68-1.713 8.5 8.5 0 0 1-5.964 2.435 8.52 8.52 0 0 1-8.52-8.52",
    clipRule: "evenodd"
  })));
};

var CashFilledIcon = function CashFilledIcon(props) {
  var cashFilled = {
    12: SvgCashFilled12,
    16: SvgCashFilled16,
    18: SvgCashFilled18,
    24: SvgCashFilled24,
    32: SvgCashFilled32,
    48: SvgCashFilled48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: cashFilled
  }, props));
};

var _path$aX;
function _extends$b3() { return _extends$b3 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$b3.apply(null, arguments); }
var SvgCheck12 = function SvgCheck12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$b3({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$aX || (_path$aX = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M10.424 3.243a.6.6 0 0 1 0 .848L5.091 9.424a.6.6 0 0 1-.849 0L1.576 6.758a.6.6 0 1 1 .848-.849l2.243 2.243 4.909-4.91a.6.6 0 0 1 .848 0",
    clipRule: "evenodd"
  })));
};

var _path$aW;
function _extends$b2() { return _extends$b2 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$b2.apply(null, arguments); }
var SvgCheck16 = function SvgCheck16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$b2({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$aW || (_path$aW = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M13.828 4.394a.7.7 0 0 1 0 .99l-7.11 7.111a.7.7 0 0 1-.99 0L2.171 8.94a.7.7 0 1 1 .99-.99l3.06 3.06 6.616-6.616a.7.7 0 0 1 .99 0",
    clipRule: "evenodd"
  })));
};

var _path$aV;
function _extends$b1() { return _extends$b1 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$b1.apply(null, arguments); }
var SvgCheck18 = function SvgCheck18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$b1({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$aV || (_path$aV = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M15.566 4.935a.8.8 0 0 1 0 1.13l-8 8a.8.8 0 0 1-1.132 0l-4-4a.8.8 0 0 1 1.132-1.13L7 12.369l7.434-7.434a.8.8 0 0 1 1.132 0",
    clipRule: "evenodd"
  })));
};

var _path$aU;
function _extends$b0() { return _extends$b0 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$b0.apply(null, arguments); }
var SvgCheck24 = function SvgCheck24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$b0({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$aU || (_path$aU = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M20.637 6.697a.9.9 0 0 1 0 1.273L9.97 18.636a.9.9 0 0 1-1.273 0l-5.333-5.333a.9.9 0 0 1 1.272-1.273l4.697 4.697 10.03-10.03a.9.9 0 0 1 1.274 0",
    clipRule: "evenodd"
  })));
};

var _path$aT;
function _extends$a$() { return _extends$a$ = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$a$.apply(null, arguments); }
var SvgCheck32 = function SvgCheck32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$a$({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$aT || (_path$aT = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M27.374 9.07a1 1 0 0 1 0 1.415L13.152 24.707a1 1 0 0 1-1.415 0l-7.11-7.11a1 1 0 0 1 1.413-1.415l6.404 6.404L25.96 9.07a1 1 0 0 1 1.415 0",
    clipRule: "evenodd"
  })));
};

var _path$aS;
function _extends$a_() { return _extends$a_ = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$a_.apply(null, arguments); }
var SvgCheck48 = function SvgCheck48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$a_({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$aS || (_path$aS = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M40.884 13.783a1.25 1.25 0 0 1 0 1.767L19.55 36.884a1.25 1.25 0 0 1-1.768 0L7.116 26.217a1.25 1.25 0 0 1 1.768-1.768l9.783 9.783 20.45-20.45a1.25 1.25 0 0 1 1.767 0",
    clipRule: "evenodd"
  })));
};

var CheckIcon = function CheckIcon(props) {
  var check = {
    12: SvgCheck12,
    16: SvgCheck16,
    18: SvgCheck18,
    24: SvgCheck24,
    32: SvgCheck32,
    48: SvgCheck48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: check
  }, props));
};

var _path$aR;
function _extends$aZ() { return _extends$aZ = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$aZ.apply(null, arguments); }
var SvgChevronDown12 = function SvgChevronDown12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$aZ({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$aR || (_path$aR = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M1.201 3.182a.6.6 0 0 1 .847.05l3.996 4.495 3.997-4.496a.6.6 0 1 1 .896.798l-4.07 4.58a1.1 1.1 0 0 1-1.645 0l-4.07-4.58a.6.6 0 0 1 .05-.847",
    clipRule: "evenodd"
  })));
};

var _path$aQ;
function _extends$aY() { return _extends$aY = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$aY.apply(null, arguments); }
var SvgChevronDown16 = function SvgChevronDown16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$aY({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$aQ || (_path$aQ = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M1.552 4.24a.75.75 0 0 0-.063 1.058l5.552 6.247a1.25 1.25 0 0 0 1.869 0l5.552-6.247a.75.75 0 1 0-1.12-.996l-5.366 6.036L2.61 4.302a.75.75 0 0 0-1.058-.062",
    clipRule: "evenodd"
  })));
};

var _path$aP;
function _extends$aX() { return _extends$aX = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$aX.apply(null, arguments); }
var SvgChevronDown18 = function SvgChevronDown18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$aX({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$aP || (_path$aP = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M1.809 4.782a.8.8 0 0 1 1.129.067l6.069 6.827 6.069-6.827a.8.8 0 1 1 1.195 1.063l-6.293 7.08a1.3 1.3 0 0 1-1.943 0l-6.293-7.08a.8.8 0 0 1 .067-1.13",
    clipRule: "evenodd"
  })));
};

var _path$aO;
function _extends$aW() { return _extends$aW = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$aW.apply(null, arguments); }
var SvgChevronDown24 = function SvgChevronDown24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$aW({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$aO || (_path$aO = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M2.502 6.467a.9.9 0 0 1 1.27.075l8.217 9.243 8.216-9.243a.9.9 0 0 1 1.346 1.196l-8.515 9.58a1.4 1.4 0 0 1-2.093 0l-8.515-9.58a.9.9 0 0 1 .074-1.27"
  })));
};

var _path$aN;
function _extends$aV() { return _extends$aV = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$aV.apply(null, arguments); }
var SvgChevronDown32 = function SvgChevronDown32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$aV({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$aN || (_path$aN = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M3.486 8.714a1 1 0 0 1 1.411.083L16.002 21.29 27.106 8.797a1 1 0 0 1 1.495 1.329L17.123 23.039a1.5 1.5 0 0 1-2.242 0L3.403 10.126a1 1 0 0 1 .083-1.412",
    clipRule: "evenodd"
  })));
};

var _path$aM;
function _extends$aU() { return _extends$aU = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$aU.apply(null, arguments); }
var SvgChevronDown48 = function SvgChevronDown48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$aU({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$aM || (_path$aM = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M5.423 13.453a1.2 1.2 0 0 1 1.694.1l16.88 18.99 16.882-18.99a1.2 1.2 0 1 1 1.794 1.594l-17.405 19.58a1.7 1.7 0 0 1-2.54 0L5.322 15.147a1.2 1.2 0 0 1 .1-1.694"
  })));
};

var ChevronDownIcon = function ChevronDownIcon(props) {
  var chevronDown = {
    12: SvgChevronDown12,
    16: SvgChevronDown16,
    18: SvgChevronDown18,
    24: SvgChevronDown24,
    32: SvgChevronDown32,
    48: SvgChevronDown48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: chevronDown
  }, props));
};

var _path$aL;
function _extends$aT() { return _extends$aT = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$aT.apply(null, arguments); }
var SvgChevronLeft12 = function SvgChevronLeft12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$aT({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$aL || (_path$aL = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8.449 1.151a.6.6 0 0 1-.05.847L3.903 5.994 8.4 9.99a.6.6 0 0 1-.797.897l-4.58-4.07a1.1 1.1 0 0 1 0-1.645l4.58-4.07a.6.6 0 0 1 .847.05",
    clipRule: "evenodd"
  })));
};

var _path$aK;
function _extends$aS() { return _extends$aS = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$aS.apply(null, arguments); }
var SvgChevronLeft16 = function SvgChevronLeft16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$aS({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$aK || (_path$aK = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M11.225 1.572a.75.75 0 0 0-1.06-.062L3.92 7.062a1.25 1.25 0 0 0 0 1.868l6.246 5.553a.75.75 0 1 0 .996-1.122L5.126 7.996l6.036-5.365a.75.75 0 0 0 .063-1.06",
    clipRule: "evenodd"
  })));
};

var _path$aJ;
function _extends$aR() { return _extends$aR = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$aR.apply(null, arguments); }
var SvgChevronLeft18 = function SvgChevronLeft18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$aR({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$aJ || (_path$aJ = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M12.596 1.809a.8.8 0 0 1-.067 1.129L5.702 9.007l6.827 6.069a.8.8 0 1 1-1.063 1.195l-7.08-6.293a1.3 1.3 0 0 1 0-1.943l7.08-6.293a.8.8 0 0 1 1.13.067",
    clipRule: "evenodd"
  })));
};

var _path$aI;
function _extends$aQ() { return _extends$aQ = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$aQ.apply(null, arguments); }
var SvgChevronLeft24 = function SvgChevronLeft24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$aQ({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$aI || (_path$aI = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M16.673 2.502a.9.9 0 0 1-.075 1.27L7.355 11.99l9.243 8.216a.9.9 0 0 1-1.196 1.345l-9.58-8.515a1.4 1.4 0 0 1 0-2.092l9.58-8.516a.9.9 0 0 1 1.27.075"
  })));
};

var _path$aH;
function _extends$aP() { return _extends$aP = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$aP.apply(null, arguments); }
var SvgChevronLeft32 = function SvgChevronLeft32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$aP({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$aH || (_path$aH = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M22.078 3.486a1 1 0 0 1-.083 1.411L9.503 16.002l12.492 11.104a1 1 0 1 1-1.329 1.495L7.753 17.123a1.5 1.5 0 0 1 0-2.242L20.666 3.403a1 1 0 0 1 1.412.083",
    clipRule: "evenodd"
  })));
};

var _path$aG;
function _extends$aO() { return _extends$aO = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$aO.apply(null, arguments); }
var SvgChevronLeft48 = function SvgChevronLeft48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$aO({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$aG || (_path$aG = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M32.897 5.203a1.2 1.2 0 0 1-.1 1.694l-18.99 16.88 18.99 16.882a1.2 1.2 0 1 1-1.594 1.794l-19.58-17.405a1.7 1.7 0 0 1 0-2.54l19.58-17.405a1.2 1.2 0 0 1 1.694.1"
  })));
};

var ChevronLeftIcon = function ChevronLeftIcon(props) {
  var chevronLeft = {
    12: SvgChevronLeft12,
    16: SvgChevronLeft16,
    18: SvgChevronLeft18,
    24: SvgChevronLeft24,
    32: SvgChevronLeft32,
    48: SvgChevronLeft48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: chevronLeft
  }, props));
};

var _path$aF;
function _extends$aN() { return _extends$aN = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$aN.apply(null, arguments); }
var SvgChevronRight12 = function SvgChevronRight12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$aN({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$aF || (_path$aF = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M3.551 1.151a.6.6 0 0 0 .05.847l4.496 3.996L3.6 9.99a.6.6 0 0 0 .798.897l4.58-4.07a1.1 1.1 0 0 0 0-1.645l-4.58-4.07a.6.6 0 0 0-.848.05",
    clipRule: "evenodd"
  })));
};

var _path$aE;
function _extends$aM() { return _extends$aM = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$aM.apply(null, arguments); }
var SvgChevronRight16 = function SvgChevronRight16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$aM({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$aE || (_path$aE = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M4.773 1.572a.75.75 0 0 1 1.059-.062l6.246 5.552a1.25 1.25 0 0 1 0 1.868l-6.246 5.553a.75.75 0 1 1-.997-1.122l6.036-5.365-6.036-5.365a.75.75 0 0 1-.062-1.06",
    clipRule: "evenodd"
  })));
};

var _path$aD;
function _extends$aL() { return _extends$aL = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$aL.apply(null, arguments); }
var SvgChevronRight18 = function SvgChevronRight18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$aL({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$aD || (_path$aD = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M5.402 1.809a.8.8 0 0 0 .067 1.129l6.827 6.069-6.827 6.069a.8.8 0 1 0 1.063 1.195l7.08-6.293a1.3 1.3 0 0 0 0-1.943l-7.08-6.293a.8.8 0 0 0-1.13.067",
    clipRule: "evenodd"
  })));
};

var _path$aC;
function _extends$aK() { return _extends$aK = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$aK.apply(null, arguments); }
var SvgChevronRight24 = function SvgChevronRight24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$aK({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$aC || (_path$aC = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M7.327 2.502a.9.9 0 0 0 .075 1.27l9.243 8.217-9.243 8.216a.9.9 0 1 0 1.196 1.345l9.58-8.515a1.4 1.4 0 0 0 0-2.092l-9.58-8.516a.9.9 0 0 0-1.27.075"
  })));
};

var _path$aB;
function _extends$aJ() { return _extends$aJ = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$aJ.apply(null, arguments); }
var SvgChevronRight32 = function SvgChevronRight32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$aJ({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$aB || (_path$aB = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M9.92 3.486a1 1 0 0 0 .082 1.411l12.493 11.105-12.493 11.104a1 1 0 1 0 1.329 1.495l12.913-11.478a1.5 1.5 0 0 0 0-2.242L11.33 3.403a1 1 0 0 0-1.412.083",
    clipRule: "evenodd"
  })));
};

var _path$aA;
function _extends$aI() { return _extends$aI = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$aI.apply(null, arguments); }
var SvgChevronRight48 = function SvgChevronRight48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$aI({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$aA || (_path$aA = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M15.103 5.203a1.2 1.2 0 0 0 .1 1.694l18.99 16.88-18.99 16.881a1.2 1.2 0 1 0 1.594 1.794l19.58-17.404a1.7 1.7 0 0 0 0-2.541L16.797 5.103a1.2 1.2 0 0 0-1.694.1",
    clipRule: "evenodd"
  })));
};

var ChevronRightIcon = function ChevronRightIcon(props) {
  var chevronRight = {
    12: SvgChevronRight12,
    16: SvgChevronRight16,
    18: SvgChevronRight18,
    24: SvgChevronRight24,
    32: SvgChevronRight32,
    48: SvgChevronRight48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: chevronRight
  }, props));
};

var _path$az;
function _extends$aH() { return _extends$aH = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$aH.apply(null, arguments); }
var SvgChevronUp12 = function SvgChevronUp12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$aH({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$az || (_path$az = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M10.888 8.816a.6.6 0 0 1-.848-.05L6.044 4.272 2.048 8.767a.6.6 0 0 1-.896-.798l4.07-4.58a1.1 1.1 0 0 1 1.645 0l4.07 4.58a.6.6 0 0 1-.05.847",
    clipRule: "evenodd"
  })));
};

var _path$ay;
function _extends$aG() { return _extends$aG = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$aG.apply(null, arguments); }
var SvgChevronUp16 = function SvgChevronUp16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$aG({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$ay || (_path$ay = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M14.4 11.764a.75.75 0 0 0 .063-1.06L8.91 4.46a1.25 1.25 0 0 0-1.868 0L1.49 10.705a.75.75 0 1 0 1.12.996l5.366-6.036 5.365 6.036a.75.75 0 0 0 1.06.063",
    clipRule: "evenodd"
  })));
};

var _path$ax;
function _extends$aF() { return _extends$aF = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$aF.apply(null, arguments); }
var SvgChevronUp18 = function SvgChevronUp18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$aF({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$ax || (_path$ax = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M16.205 13.228a.8.8 0 0 1-1.13-.066L9.008 6.335l-6.069 6.827a.8.8 0 1 1-1.196-1.063l6.293-7.08a1.3 1.3 0 0 1 1.943 0l6.293 7.08a.8.8 0 0 1-.066 1.13",
    clipRule: "evenodd"
  })));
};

var _path$aw;
function _extends$aE() { return _extends$aE = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$aE.apply(null, arguments); }
var SvgChevronUp24 = function SvgChevronUp24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$aE({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$aw || (_path$aw = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M21.476 17.535a.9.9 0 0 1-1.27-.075l-8.217-9.243-8.216 9.243a.9.9 0 0 1-1.346-1.195l8.516-9.58a1.4 1.4 0 0 1 2.092 0l8.515 9.58a.9.9 0 0 1-.074 1.27"
  })));
};

var _path$av;
function _extends$aD() { return _extends$aD = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$aD.apply(null, arguments); }
var SvgChevronUp32 = function SvgChevronUp32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$aD({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$av || (_path$av = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M28.518 23.29a1 1 0 0 1-1.412-.084L16.002 10.714 4.897 23.206a1 1 0 1 1-1.495-1.328L14.881 8.965a1.5 1.5 0 0 1 2.242 0L28.6 21.878a1 1 0 0 1-.083 1.412",
    clipRule: "evenodd"
  })));
};

var _path$au;
function _extends$aC() { return _extends$aC = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$aC.apply(null, arguments); }
var SvgChevronUp48 = function SvgChevronUp48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$aC({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$au || (_path$au = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M42.573 34.548a1.2 1.2 0 0 1-1.694-.1l-16.881-18.99-16.881 18.99a1.2 1.2 0 1 1-1.794-1.594l17.404-19.58a1.7 1.7 0 0 1 2.541 0l17.405 19.58a1.2 1.2 0 0 1-.1 1.694"
  })));
};

var ChevronUpIcon = function ChevronUpIcon(props) {
  var chevronUp = {
    12: SvgChevronUp12,
    16: SvgChevronUp16,
    18: SvgChevronUp18,
    24: SvgChevronUp24,
    32: SvgChevronUp32,
    48: SvgChevronUp48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: chevronUp
  }, props));
};

var _path$at;
function _extends$aB() { return _extends$aB = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$aB.apply(null, arguments); }
var SvgCircleCheckFilled12 = function SvgCircleCheckFilled12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$aB({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$at || (_path$at = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M6 11A5 5 0 1 0 6 1a5 5 0 0 0 0 10m3.038-6.462a.525.525 0 1 0-.743-.743L4.833 7.257 3.705 6.13a.525.525 0 0 0-.743.742l1.5 1.5a.525.525 0 0 0 .743 0z",
    clipRule: "evenodd"
  })));
};

var _path$as;
function _extends$aA() { return _extends$aA = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$aA.apply(null, arguments); }
var SvgCircleCheckFilled16 = function SvgCircleCheckFilled16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$aA({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$as || (_path$as = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8 14.666A6.667 6.667 0 1 0 8 1.333a6.667 6.667 0 0 0 0 13.333m4.015-8.651a.65.65 0 0 0-.92-.92l-4.65 4.652-1.541-1.54a.65.65 0 1 0-.92.919l2 2a.65.65 0 0 0 .92 0z",
    clipRule: "evenodd"
  })));
};

var _path$ar;
function _extends$az() { return _extends$az = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$az.apply(null, arguments); }
var SvgCircleCheckFilled18 = function SvgCircleCheckFilled18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$az({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$ar || (_path$ar = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M9 16.5a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15m4.53-9.72a.75.75 0 0 0-1.06-1.06l-5.22 5.22-1.72-1.72a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.06 0z",
    clipRule: "evenodd"
  })));
};

var _path$aq;
function _extends$ay() { return _extends$ay = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$ay.apply(null, arguments); }
var SvgCircleCheckFilled24 = function SvgCircleCheckFilled24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$ay({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$aq || (_path$aq = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10m5.987-13.012a.925.925 0 1 0-1.308-1.309l-7.012 7.013-2.346-2.346a.925.925 0 0 0-1.308 1.308l3 3a.925.925 0 0 0 1.308 0z",
    clipRule: "evenodd"
  })));
};

var _path$ap;
function _extends$ax() { return _extends$ax = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$ax.apply(null, arguments); }
var SvgCircleCheckFilled32 = function SvgCircleCheckFilled32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$ax({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$ap || (_path$ap = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M16 29.334c7.364 0 13.334-5.97 13.334-13.334S23.364 2.667 16 2.667 2.667 8.637 2.667 16 8.637 29.334 16 29.334m7.89-17.445a1.1 1.1 0 1 0-1.556-1.555l-9.445 9.444-3.222-3.222a1.1 1.1 0 1 0-1.556 1.555l4 4a1.1 1.1 0 0 0 1.556 0z",
    clipRule: "evenodd"
  })));
};

var _path$ao;
function _extends$aw() { return _extends$aw = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$aw.apply(null, arguments); }
var SvgCircleCheckFilled48 = function SvgCircleCheckFilled48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$aw({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$ao || (_path$ao = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M24 44c11.046 0 20-8.954 20-20S35.046 4 24 4 4 12.954 4 24s8.954 20 20 20m11.674-26.326a1.425 1.425 0 1 0-2.015-2.015L19.333 29.985l-4.992-4.993a1.425 1.425 0 0 0-2.015 2.016l6 6a1.425 1.425 0 0 0 2.015 0z",
    clipRule: "evenodd"
  })));
};

var CircleCheckFilledIcon = function CircleCheckFilledIcon(props) {
  var circleCheckFilled = {
    12: SvgCircleCheckFilled12,
    16: SvgCircleCheckFilled16,
    18: SvgCircleCheckFilled18,
    24: SvgCircleCheckFilled24,
    32: SvgCircleCheckFilled32,
    48: SvgCircleCheckFilled48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: circleCheckFilled
  }, props));
};

var _path$an;
function _extends$av() { return _extends$av = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$av.apply(null, arguments); }
var SvgCircleFilled12 = function SvgCircleFilled12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$av({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$an || (_path$an = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M10 6a4 4 0 1 1-8 0 4 4 0 0 1 8 0"
  })));
};

var _path$am;
function _extends$au() { return _extends$au = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$au.apply(null, arguments); }
var SvgCircleFilled16 = function SvgCircleFilled16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$au({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$am || (_path$am = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M13.333 8A5.333 5.333 0 1 1 2.667 8a5.333 5.333 0 0 1 10.666 0"
  })));
};

var _path$al;
function _extends$at() { return _extends$at = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$at.apply(null, arguments); }
var SvgCircleFilled18 = function SvgCircleFilled18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$at({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$al || (_path$al = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M16.5 9a7.5 7.5 0 1 1-15 0 7.5 7.5 0 0 1 15 0"
  })));
};

var _path$ak;
function _extends$as() { return _extends$as = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$as.apply(null, arguments); }
var SvgCircleFilled24 = function SvgCircleFilled24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$as({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$ak || (_path$ak = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10"
  })));
};

var _path$aj;
function _extends$ar() { return _extends$ar = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$ar.apply(null, arguments); }
var SvgCircleFilled32 = function SvgCircleFilled32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$ar({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$aj || (_path$aj = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M29.333 16c0 7.364-5.97 13.333-13.333 13.333S2.667 23.363 2.667 16 8.637 2.667 16 2.667 29.333 8.637 29.333 16"
  })));
};

var _path$ai;
function _extends$aq() { return _extends$aq = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$aq.apply(null, arguments); }
var SvgCircleFilled48 = function SvgCircleFilled48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$aq({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$ai || (_path$ai = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M44 24c0 11.046-8.954 20-20 20S4 35.046 4 24 12.954 4 24 4s20 8.954 20 20"
  })));
};

var CircleFilledIcon = function CircleFilledIcon(props) {
  var circleFilled = {
    12: SvgCircleFilled12,
    16: SvgCircleFilled16,
    18: SvgCircleFilled18,
    24: SvgCircleFilled24,
    32: SvgCircleFilled32,
    48: SvgCircleFilled48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: circleFilled
  }, props));
};

var _path$ah;
function _extends$ap() { return _extends$ap = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$ap.apply(null, arguments); }
var SvgCircleWonFilled12 = function SvgCircleWonFilled12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$ap({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$ah || (_path$ah = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M6 11A5 5 0 1 0 6 1a5 5 0 0 0 0 10M4.352 4.134a.6.6 0 1 0-1.153.333l.255.883H3.22a.6.6 0 0 0 0 1.2h.58l.511 1.767a.6.6 0 0 0 1.153 0L6 6.462l.536 1.855a.6.6 0 0 0 1.153 0l.51-1.767h.582a.6.6 0 0 0 0-1.2h-.235l.255-.883a.6.6 0 1 0-1.153-.333l-.536 1.854-.536-1.854a.6.6 0 0 0-1.152 0l-.536 1.854z",
    clipRule: "evenodd"
  })));
};

var _path$ag;
function _extends$ao() { return _extends$ao = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$ao.apply(null, arguments); }
var SvgCircleWonFilled16 = function SvgCircleWonFilled16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$ao({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$ag || (_path$ag = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14M5.567 5.064a.75.75 0 1 0-1.441.416l.399 1.38h-.466a.75.75 0 1 0 0 1.5h.899l.744 2.577a.75.75 0 0 0 1.441 0L8 7.974l.856 2.963a.75.75 0 0 0 1.441 0l.745-2.577h.9a.75.75 0 0 0 0-1.5h-.467l.399-1.38a.75.75 0 1 0-1.441-.417l-.856 2.963-.856-2.962a.75.75 0 0 0-1.441 0l-.856 2.962z",
    clipRule: "evenodd"
  })));
};

var _path$af;
function _extends$an() { return _extends$an = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$an.apply(null, arguments); }
var SvgCircleWonFilled18 = function SvgCircleWonFilled18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$an({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$af || (_path$af = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M9 17A8 8 0 1 0 9 1a8 8 0 0 0 0 16M6.128 5.965a.8.8 0 0 0-1.537.445l.485 1.677H4.45a.8.8 0 1 0 0 1.6h1.088l.873 3.023a.8.8 0 0 0 1.537 0L9 9.07l1.051 3.64a.8.8 0 0 0 1.537 0l.873-3.023h1.09a.8.8 0 1 0 0-1.6h-.627l.484-1.677a.8.8 0 0 0-1.537-.445l-1.051 3.64-1.052-3.64a.8.8 0 0 0-1.537 0l-1.052 3.64z",
    clipRule: "evenodd"
  })));
};

var _path$ae;
function _extends$am() { return _extends$am = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$am.apply(null, arguments); }
var SvgCircleWonFilled24 = function SvgCircleWonFilled24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$am({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$ae || (_path$ae = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10M8.01 8a.9.9 0 0 0-1.729.5l.708 2.45H5.934a.9.9 0 1 0 0 1.8h1.575l1.2 4.15a.9.9 0 0 0 1.728 0L12 11.493l1.562 5.407a.9.9 0 0 0 1.73 0l1.198-4.15h1.578a.9.9 0 0 0 0-1.8H17.01l.708-2.45a.9.9 0 0 0-1.73-.5l-1.562 5.407L12.864 8a.9.9 0 0 0-1.729 0l-1.562 5.407z",
    clipRule: "evenodd"
  })));
};

var _path$ad;
function _extends$al() { return _extends$al = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$al.apply(null, arguments); }
var SvgCircleWonFilled32 = function SvgCircleWonFilled32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$al({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$ad || (_path$ad = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M16 29c7.18 0 13-5.82 13-13S23.18 3 16 3 3 8.82 3 16s5.82 13 13 13m-5.51-18.278a1 1 0 0 0-1.922.556L9.586 14.8H7.912a1 1 0 1 0 0 2h2.251l1.64 5.677a1 1 0 0 0 1.922 0L16 14.604l2.275 7.874a1 1 0 0 0 1.922 0l1.64-5.677h2.254a1 1 0 0 0 0-2h-1.676l1.017-3.523a1 1 0 1 0-1.921-.555l-2.275 7.875-2.275-7.875a1 1 0 0 0-1.921 0l-2.275 7.875z",
    clipRule: "evenodd"
  })));
};

var _path$ac;
function _extends$ak() { return _extends$ak = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$ak.apply(null, arguments); }
var SvgCircleWonFilled48 = function SvgCircleWonFilled48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$ak({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$ac || (_path$ac = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M24 44c11.046 0 20-8.954 20-20S35.046 4 24 4 4 12.954 4 24s8.954 20 20 20m-8.554-27.833a1.2 1.2 0 0 0-2.306.666l1.637 5.667h-2.91a1.2 1.2 0 0 0 0 2.4h3.604l2.523 8.733a1.2 1.2 0 0 0 2.305 0L24 20.823l3.701 12.81a1.2 1.2 0 0 0 2.306 0l2.523-8.734h3.606a1.2 1.2 0 0 0 0-2.4h-2.913l1.637-5.666a1.2 1.2 0 0 0-2.305-.666l-3.701 12.81-3.7-12.81a1.2 1.2 0 0 0-2.307 0l-3.7 12.81z",
    clipRule: "evenodd"
  })));
};

var CircleWonFilledIcon = function CircleWonFilledIcon(props) {
  var circleWonFilled = {
    12: SvgCircleWonFilled12,
    16: SvgCircleWonFilled16,
    18: SvgCircleWonFilled18,
    24: SvgCircleWonFilled24,
    32: SvgCircleWonFilled32,
    48: SvgCircleWonFilled48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: circleWonFilled
  }, props));
};

var _g$7, _defs$7;
function _extends$aj() { return _extends$aj = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$aj.apply(null, arguments); }
var SvgClock12 = function SvgClock12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$aj({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _g$7 || (_g$7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clock_12_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M6 2.1a3.9 3.9 0 1 0 0 7.8 3.9 3.9 0 0 0 0-7.8M.9 6a5.1 5.1 0 1 1 10.2 0A5.1 5.1 0 0 1 .9 6m4.85-3.6a.6.6 0 0 1 .6.6v2.5c0 .22.179.4.4.4h1.5a.6.6 0 1 1 0 1.2h-1.5a1.6 1.6 0 0 1-1.6-1.6V3a.6.6 0 0 1 .6-.6",
    clipRule: "evenodd"
  }))), _defs$7 || (_defs$7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clock_12_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h12v12H0z"
  })))));
};

var _path$ab;
function _extends$ai() { return _extends$ai = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$ai.apply(null, arguments); }
var SvgClock16 = function SvgClock16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$ai({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$ab || (_path$ab = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8 2.75a5.25 5.25 0 1 0 0 10.5 5.25 5.25 0 0 0 0-10.5M1.25 8a6.75 6.75 0 1 1 13.5 0 6.75 6.75 0 0 1-13.5 0m6.417-4.75a.75.75 0 0 1 .75.75v3.333c0 .322.26.584.583.584h2a.75.75 0 0 1 0 1.5H9a2.083 2.083 0 0 1-2.083-2.084V4a.75.75 0 0 1 .75-.75",
    clipRule: "evenodd"
  })));
};

var _path$aa;
function _extends$ah() { return _extends$ah = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$ah.apply(null, arguments); }
var SvgClock18 = function SvgClock18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$ah({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$aa || (_path$aa = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M9 3.05a5.95 5.95 0 1 0 0 11.9 5.95 5.95 0 0 0 0-11.9M1.45 9a7.55 7.55 0 1 1 15.1 0 7.55 7.55 0 0 1-15.1 0m7.175-5.3a.8.8 0 0 1 .8.8v3.75a.7.7 0 0 0 .7.7h2.25a.8.8 0 0 1 0 1.6h-2.25a2.3 2.3 0 0 1-2.3-2.3V4.5a.8.8 0 0 1 .8-.8",
    clipRule: "evenodd"
  })));
};

var _path$a9;
function _extends$ag() { return _extends$ag = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$ag.apply(null, arguments); }
var SvgClock24 = function SvgClock24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$ag({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$a9 || (_path$a9 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M12 3.9a8.1 8.1 0 1 0 0 16.2 8.1 8.1 0 0 0 0-16.2M2.1 12c0-5.468 4.432-9.9 9.9-9.9s9.9 4.432 9.9 9.9-4.432 9.9-9.9 9.9-9.9-4.432-9.9-9.9m9.4-6.9a.9.9 0 0 1 .9.9v5a1.1 1.1 0 0 0 1.1 1.1h3a.9.9 0 0 1 0 1.8h-3a2.9 2.9 0 0 1-2.9-2.9V6a.9.9 0 0 1 .9-.9",
    clipRule: "evenodd"
  })));
};

var _path$a8;
function _extends$af() { return _extends$af = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$af.apply(null, arguments); }
var SvgClock32 = function SvgClock32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$af({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$a8 || (_path$a8 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M16 5C9.925 5 5 9.925 5 16s4.925 11 11 11 11-4.925 11-11S22.075 5 16 5M3 16C3 8.82 8.82 3 16 3s13 5.82 13 13-5.82 13-13 13S3 23.18 3 16m12.333-9a1 1 0 0 1 1 1v6.667c0 .92.747 1.666 1.667 1.666h4a1 1 0 1 1 0 2h-4a3.667 3.667 0 0 1-3.667-3.666V8a1 1 0 0 1 1-1",
    clipRule: "evenodd"
  })));
};

var _path$a7;
function _extends$ae() { return _extends$ae = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$ae.apply(null, arguments); }
var SvgClock48 = function SvgClock48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$ae({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$a7 || (_path$a7 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M24 7.2C14.722 7.2 7.2 14.722 7.2 24S14.722 40.8 24 40.8 40.8 33.278 40.8 24 33.278 7.2 24 7.2M4.8 24C4.8 13.396 13.396 4.8 24 4.8S43.2 13.396 43.2 24 34.604 43.2 24 43.2 4.8 34.604 4.8 24M23 10.8a1.2 1.2 0 0 1 1.2 1.2v10a2.8 2.8 0 0 0 2.8 2.8h6a1.2 1.2 0 1 1 0 2.4h-6a5.2 5.2 0 0 1-5.2-5.2V12a1.2 1.2 0 0 1 1.2-1.2",
    clipRule: "evenodd"
  })));
};

var ClockIcon = function ClockIcon(props) {
  var clock = {
    12: SvgClock12,
    16: SvgClock16,
    18: SvgClock18,
    24: SvgClock24,
    32: SvgClock32,
    48: SvgClock48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: clock
  }, props));
};

var _path$a6;
function _extends$ad() { return _extends$ad = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$ad.apply(null, arguments); }
var SvgClockFilled12 = function SvgClockFilled12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$ad({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$a6 || (_path$a6 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M6 11A5 5 0 1 0 6 1a5 5 0 0 0 0 10m.35-8a.6.6 0 0 0-1.2 0v2.5a1.6 1.6 0 0 0 1.6 1.6h1.5a.6.6 0 0 0 0-1.2h-1.5a.4.4 0 0 1-.4-.4z",
    clipRule: "evenodd"
  })));
};

var _path$a5;
function _extends$ac() { return _extends$ac = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$ac.apply(null, arguments); }
var SvgClockFilled16 = function SvgClockFilled16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$ac({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$a5 || (_path$a5 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8 14.667A6.667 6.667 0 1 0 8 1.333a6.667 6.667 0 0 0 0 13.334M8.417 4a.75.75 0 0 0-1.5 0v3.334c0 1.15.932 2.083 2.083 2.083h2a.75.75 0 0 0 0-1.5H9a.583.583 0 0 1-.583-.583z",
    clipRule: "evenodd"
  })));
};

var _path$a4;
function _extends$ab() { return _extends$ab = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$ab.apply(null, arguments); }
var SvgClockFilled18 = function SvgClockFilled18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$ab({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$a4 || (_path$a4 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M9.5 16.5a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15m.425-12a.8.8 0 1 0-1.6 0v3.75a2.3 2.3 0 0 0 2.3 2.3h2.25a.8.8 0 0 0 0-1.6h-2.25a.7.7 0 0 1-.7-.7z",
    clipRule: "evenodd"
  })));
};

var _path$a3;
function _extends$aa() { return _extends$aa = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$aa.apply(null, arguments); }
var SvgClockFilled24 = function SvgClockFilled24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$aa({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$a3 || (_path$a3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10m.4-16a.9.9 0 1 0-1.8 0v5a2.9 2.9 0 0 0 2.9 2.9h3a.9.9 0 1 0 0-1.8h-3a1.1 1.1 0 0 1-1.1-1.1z",
    clipRule: "evenodd"
  })));
};

var _path$a2;
function _extends$a9() { return _extends$a9 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$a9.apply(null, arguments); }
var SvgClockFilled32 = function SvgClockFilled32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$a9({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$a2 || (_path$a2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M16 29.333c7.364 0 13.334-5.97 13.334-13.333S23.364 2.667 16 2.667 2.667 8.637 2.667 16 8.637 29.333 16 29.333M16.334 8a1 1 0 1 0-2 0v6.667A3.666 3.666 0 0 0 18 18.333h4a1 1 0 0 0 0-2h-4c-.921 0-1.666-.745-1.666-1.666z",
    clipRule: "evenodd"
  })));
};

var _path$a1;
function _extends$a8() { return _extends$a8 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$a8.apply(null, arguments); }
var SvgClockFilled48 = function SvgClockFilled48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$a8({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$a1 || (_path$a1 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M24 44c11.046 0 20-8.954 20-20S35.046 4 24 4 4 12.954 4 24s8.954 20 20 20m.2-32a1.2 1.2 0 1 0-2.4 0v10.001A5.2 5.2 0 0 0 27 27.2h6a1.2 1.2 0 1 0 0-2.4h-6A2.8 2.8 0 0 1 24.2 22z",
    clipRule: "evenodd"
  })));
};

var ClockFilledIcon = function ClockFilledIcon(props) {
  var clockFilled = {
    12: SvgClockFilled12,
    16: SvgClockFilled16,
    18: SvgClockFilled18,
    24: SvgClockFilled24,
    32: SvgClockFilled32,
    48: SvgClockFilled48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: clockFilled
  }, props));
};

var _path$a0;
function _extends$a7() { return _extends$a7 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$a7.apply(null, arguments); }
var SvgComment12 = function SvgComment12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$a7({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$a0 || (_path$a0 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "m8.877 7.883.208-.413a3.636 3.636 0 1 0-1.577 1.595l.418-.217 1.316.363zM8.06 10.13a4.836 4.836 0 1 1 2.095-2.12l.576 2.091c.1.365-.235.7-.6.6z",
    clipRule: "evenodd"
  })));
};

var _path$9$;
function _extends$a6() { return _extends$a6 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$a6.apply(null, arguments); }
var SvgComment16 = function SvgComment16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$a6({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$9$ || (_path$9$ = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "m11.942 10.521.26-.516a4.948 4.948 0 1 0-2.145 2.17l.523-.27 1.886.519zm-1.193 2.986a6.448 6.448 0 1 1 2.794-2.827l.767 2.789a.65.65 0 0 1-.8.798z",
    clipRule: "evenodd"
  })));
};

var _path$9_;
function _extends$a5() { return _extends$a5 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$a5.apply(null, arguments); }
var SvgComment18 = function SvgComment18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$a5({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$9_ || (_path$9_ = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "m13.528 11.846.278-.55a5.654 5.654 0 1 0-2.451 2.48l.557-.29 2.237.616zm-1.436 3.35a7.254 7.254 0 1 1 3.143-3.18l.863 3.136a.73.73 0 0 1-.899.899z",
    clipRule: "evenodd"
  })));
};

var _path$9Z;
function _extends$a4() { return _extends$a4 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$a4.apply(null, arguments); }
var SvgComment24 = function SvgComment24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$a4({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$9Z || (_path$9Z = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "m18.393 15.83.313-.62a7.8 7.8 0 0 0 .838-3.538 7.872 7.872 0 1 0-7.872 7.872 7.8 7.8 0 0 0 3.621-.88l.627-.326 3.423.942zm-2.27 4.43a9.6 9.6 0 0 1-4.451 1.083C6.33 21.344 2 17.014 2 11.673 2 6.33 6.33 2 11.672 2c5.341 0 9.671 4.33 9.671 9.672a9.6 9.6 0 0 1-1.03 4.349l1.151 4.182a.974.974 0 0 1-1.198 1.198z"
  })));
};

var _path$9Y;
function _extends$a3() { return _extends$a3 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$a3.apply(null, arguments); }
var SvgComment32 = function SvgComment32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$a3({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$9Y || (_path$9Y = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "m24.95 21.149.348-.688a10.84 10.84 0 0 0 1.16-4.899c0-6.017-4.878-10.895-10.896-10.895-6.017 0-10.895 4.878-10.895 10.895 0 6.018 4.878 10.896 10.895 10.896 1.812 0 3.515-.44 5.013-1.219l.696-.361 5.092 1.401zm-3.453 5.865a12.84 12.84 0 0 1-5.935 1.444c-7.122 0-12.895-5.773-12.895-12.896 0-7.122 5.773-12.895 12.895-12.895S28.458 8.44 28.458 15.562c0 2.086-.495 4.056-1.374 5.8l1.535 5.575a1.3 1.3 0 0 1-1.598 1.598z",
    clipRule: "evenodd"
  })));
};

var _path$9X;
function _extends$a2() { return _extends$a2 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$a2.apply(null, arguments); }
var SvgComment48 = function SvgComment48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$a2({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$9X || (_path$9X = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "m38.066 31.787.417-.826a16.86 16.86 0 0 0 1.804-7.617c0-9.358-7.586-16.944-16.943-16.944S6.4 13.986 6.4 23.344s7.586 16.943 16.944 16.943c2.815 0 5.464-.685 7.795-1.895l.836-.434 8.428 2.32zm-5.82 8.734a19.26 19.26 0 0 1-8.903 2.166C12.66 42.687 4 34.027 4 23.344S12.66 4 23.344 4c10.683 0 19.343 8.66 19.343 19.344 0 3.128-.743 6.083-2.061 8.698l2.302 8.364c.401 1.458-.938 2.797-2.396 2.396z",
    clipRule: "evenodd"
  })));
};

var CommentIcon = function CommentIcon(props) {
  var comment = {
    12: SvgComment12,
    16: SvgComment16,
    18: SvgComment18,
    24: SvgComment24,
    32: SvgComment32,
    48: SvgComment48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: comment
  }, props));
};

var _path$9W;
function _extends$a1() { return _extends$a1 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$a1.apply(null, arguments); }
var SvgCommentFilled12 = function SvgCommentFilled12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$a1({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$9W || (_path$9W = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M10.156 8.01a4.836 4.836 0 1 0-2.095 2.12l2.072.57c.364.1.7-.234.599-.598z"
  })));
};

var _path$9V;
function _extends$a0() { return _extends$a0 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$a0.apply(null, arguments); }
var SvgCommentFilled16 = function SvgCommentFilled16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$a0({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$9V || (_path$9V = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M13.542 10.68a6.448 6.448 0 1 0-2.793 2.827l2.762.76a.65.65 0 0 0 .798-.798z"
  })));
};

var _path$9U;
function _extends$9$() { return _extends$9$ = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$9$.apply(null, arguments); }
var SvgCommentFilled18 = function SvgCommentFilled18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9$({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$9U || (_path$9U = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M15.235 12.016a7.254 7.254 0 1 0-3.143 3.18l3.107.855a.73.73 0 0 0 .899-.899z"
  })));
};

var _path$9T;
function _extends$9_() { return _extends$9_ = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$9_.apply(null, arguments); }
var SvgCommentFilled24 = function SvgCommentFilled24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9_({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$9T || (_path$9T = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M20.313 16.02a9.6 9.6 0 0 0 1.03-4.348C21.344 6.33 17.014 2 11.673 2 6.33 2 2 6.33 2 11.672c0 5.341 4.33 9.671 9.672 9.671a9.6 9.6 0 0 0 4.45-1.082l4.144 1.14a.974.974 0 0 0 1.198-1.198z"
  })));
};

var _path$9S;
function _extends$9Z() { return _extends$9Z = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$9Z.apply(null, arguments); }
var SvgCommentFilled32 = function SvgCommentFilled32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9Z({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$9S || (_path$9S = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M27.084 21.361a12.84 12.84 0 0 0 1.374-5.799c0-7.122-5.774-12.895-12.896-12.895S2.667 8.44 2.667 15.562c0 7.123 5.773 12.896 12.895 12.896 2.14 0 4.158-.521 5.935-1.444l5.524 1.52a1.3 1.3 0 0 0 1.598-1.597z"
  })));
};

var _path$9R;
function _extends$9Y() { return _extends$9Y = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$9Y.apply(null, arguments); }
var SvgCommentFilled48 = function SvgCommentFilled48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9Y({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$9R || (_path$9R = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M40.626 32.042a19.26 19.26 0 0 0 2.061-8.699C42.687 12.66 34.027 4 23.344 4S4 12.66 4 23.344c0 10.683 8.66 19.343 19.344 19.343 3.21 0 6.237-.782 8.901-2.166l8.287 2.281c1.458.401 2.797-.938 2.396-2.396z"
  })));
};

var CommentFilledIcon = function CommentFilledIcon(props) {
  var commentFilled = {
    12: SvgCommentFilled12,
    16: SvgCommentFilled16,
    18: SvgCommentFilled18,
    24: SvgCommentFilled24,
    32: SvgCommentFilled32,
    48: SvgCommentFilled48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: commentFilled
  }, props));
};

var _path$9Q, _path2$3q;
function _extends$9X() { return _extends$9X = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$9X.apply(null, arguments); }
var SvgContentList12 = function SvgContentList12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9X({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$9Q || (_path$9Q = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M2.95 3a.6.6 0 0 1 .6-.6h6.8a.6.6 0 1 1 0 1.2h-6.8a.6.6 0 0 1-.6-.6M2.95 6a.6.6 0 0 1 .6-.6h6.8a.6.6 0 1 1 0 1.2h-6.8a.6.6 0 0 1-.6-.6M2.95 9a.6.6 0 0 1 .6-.6h6.8a.6.6 0 1 1 0 1.2h-6.8a.6.6 0 0 1-.6-.6",
    clipRule: "evenodd"
  })), _path2$3q || (_path2$3q = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M2.2 3A.6.6 0 1 1 1 3a.6.6 0 0 1 1.2 0M2.2 6.05a.6.6 0 1 1-1.2 0 .6.6 0 0 1 1.2 0M2.2 9.05a.6.6 0 1 1-1.2 0 .6.6 0 0 1 1.2 0"
  })));
};

var _path$9P, _path2$3p;
function _extends$9W() { return _extends$9W = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$9W.apply(null, arguments); }
var SvgContentList16 = function SvgContentList16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9W({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$9P || (_path$9P = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M3.6 4a.75.75 0 0 1 .75-.75h9.5a.75.75 0 0 1 0 1.5h-9.5A.75.75 0 0 1 3.6 4M3.6 8a.75.75 0 0 1 .75-.75h9.5a.75.75 0 0 1 0 1.5h-9.5A.75.75 0 0 1 3.6 8M3.6 12a.75.75 0 0 1 .75-.75h9.5a.75.75 0 0 1 0 1.5h-9.5A.75.75 0 0 1 3.6 12",
    clipRule: "evenodd"
  })), _path2$3p || (_path2$3p = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M2.834 4.05a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M2.834 8.05a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M2.834 12.05a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0"
  })));
};

var _path$9O, _path2$3o;
function _extends$9V() { return _extends$9V = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$9V.apply(null, arguments); }
var SvgContentList18 = function SvgContentList18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9V({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$9O || (_path$9O = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M3.7 4.5a.8.8 0 0 1 .8-.8h11.25a.8.8 0 0 1 0 1.6H4.5a.8.8 0 0 1-.8-.8M3.7 9a.8.8 0 0 1 .8-.8h11.25a.8.8 0 0 1 0 1.6H4.5a.8.8 0 0 1-.8-.8M3.7 13.5a.8.8 0 0 1 .8-.8h11.25a.8.8 0 1 1 0 1.6H4.5a.8.8 0 0 1-.8-.8",
    clipRule: "evenodd"
  })), _path2$3o || (_path2$3o = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M3.1 4.55a.8.8 0 1 1-1.6 0 .8.8 0 0 1 1.6 0M3.1 8.95a.8.8 0 1 1-1.6 0 .8.8 0 0 1 1.6 0M3.1 13.45a.8.8 0 1 1-1.6 0 .8.8 0 0 1 1.6 0"
  })));
};

var _path$9N, _path2$3n;
function _extends$9U() { return _extends$9U = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$9U.apply(null, arguments); }
var SvgContentList24 = function SvgContentList24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9U({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$9N || (_path$9N = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M5.1 6a.9.9 0 0 1 .9-.9h15a.9.9 0 1 1 0 1.8H6a.9.9 0 0 1-.9-.9M5.1 12a.9.9 0 0 1 .9-.9h15a.9.9 0 1 1 0 1.8H6a.9.9 0 0 1-.9-.9M5.1 18a.9.9 0 0 1 .9-.9h15a.9.9 0 1 1 0 1.8H6a.9.9 0 0 1-.9-.9",
    clipRule: "evenodd"
  })), _path2$3n || (_path2$3n = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M4 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0M4 12a1 1 0 1 1-2 0 1 1 0 0 1 2 0M4 18a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
  })));
};

var _path$9M, _path2$3m;
function _extends$9T() { return _extends$9T = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$9T.apply(null, arguments); }
var SvgContentList32 = function SvgContentList32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9T({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$9M || (_path$9M = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M7 8a1 1 0 0 1 1-1h20a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1M7 16a1 1 0 0 1 1-1h20a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1M7 24a1 1 0 0 1 1-1h20a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1",
    clipRule: "evenodd"
  })), _path2$3m || (_path2$3m = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M5 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0M5 16a1 1 0 1 1-2 0 1 1 0 0 1 2 0M5 24a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
  })));
};

var _path$9L, _path2$3l;
function _extends$9S() { return _extends$9S = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$9S.apply(null, arguments); }
var SvgContentList48 = function SvgContentList48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9S({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$9L || (_path$9L = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8.6 12a1.2 1.2 0 0 1 1.2-1.2h33a1.2 1.2 0 0 1 0 2.4h-33A1.2 1.2 0 0 1 8.6 12M8.6 24a1.2 1.2 0 0 1 1.2-1.2h33a1.2 1.2 0 0 1 0 2.4h-33A1.2 1.2 0 0 1 8.6 24M8.6 36a1.2 1.2 0 0 1 1.2-1.2h33a1.2 1.2 0 0 1 0 2.4h-33A1.2 1.2 0 0 1 8.6 36",
    clipRule: "evenodd"
  })), _path2$3l || (_path2$3l = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M6.4 12A1.2 1.2 0 1 1 4 12a1.2 1.2 0 0 1 2.4 0M6.4 24A1.2 1.2 0 1 1 4 24a1.2 1.2 0 0 1 2.4 0M6.4 36A1.2 1.2 0 1 1 4 36a1.2 1.2 0 0 1 2.4 0"
  })));
};

var ContentListIcon = function ContentListIcon(props) {
  var contentList = {
    12: SvgContentList12,
    16: SvgContentList16,
    18: SvgContentList18,
    24: SvgContentList24,
    32: SvgContentList32,
    48: SvgContentList48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: contentList
  }, props));
};

var _path$9K, _path2$3k;
function _extends$9R() { return _extends$9R = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$9R.apply(null, arguments); }
var SvgCoupon12 = function SvgCoupon12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9R({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$9K || (_path$9K = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M7.7 5.85a.6.6 0 0 0-1.2 0v.133a.6.6 0 0 0 1.2 0z"
  })), _path2$3k || (_path2$3k = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M1.8 2h3.465c.465 0 .833.354 1.128.714.18.22.408.353.657.353s.478-.132.657-.353C8.002 2.354 8.37 2 8.835 2H10.2c.58 0 1.05.478 1.05 1.067v5.866c0 .59-.47 1.067-1.05 1.067H8.835c-.465 0-.833-.354-1.128-.714-.18-.22-.408-.353-.657-.353s-.478.132-.657.353c-.295.36-.663.714-1.128.714H1.8C1.22 10 .75 9.522.75 8.933V3.067C.75 2.477 1.22 2 1.8 2m.15 6.8V3.2h3.248a1 1 0 0 1 .108.095q.071.073.157.178c.34.417.883.794 1.587.794s1.247-.377 1.587-.794q.087-.106.157-.178a1 1 0 0 1 .108-.095h1.148v5.6H8.902a1 1 0 0 1-.108-.095 3 3 0 0 1-.157-.178c-.34-.417-.883-.794-1.587-.794s-1.247.377-1.587.794q-.087.105-.157.178a1 1 0 0 1-.108.095z",
    clipRule: "evenodd"
  })));
};

var _path$9J, _path2$3j;
function _extends$9Q() { return _extends$9Q = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$9Q.apply(null, arguments); }
var SvgCoupon16 = function SvgCoupon16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9Q({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$9J || (_path$9J = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M10.267 7.863a.8.8 0 0 0-1.6 0v.267a.8.8 0 1 0 1.6 0z"
  })), _path2$3j || (_path2$3j = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M2.4 2.667h4.885c.465 0 .845.338 1.086.736.256.422.622.686 1.029.686s.773-.264 1.029-.686c.24-.398.62-.736 1.086-.736H13.6c.773 0 1.4.637 1.4 1.422v7.822c0 .786-.627 1.422-1.4 1.422h-2.085c-.465 0-.845-.338-1.086-.735-.256-.423-.622-.687-1.029-.687s-.773.264-1.029.687c-.24.397-.62.735-1.086.735H2.4c-.773 0-1.4-.636-1.4-1.422V4.09c0-.786.627-1.422 1.4-1.422m.1 9.166V4.167h4.58l.008.013c.42.69 1.2 1.409 2.312 1.409s1.893-.718 2.312-1.41l.008-.012h1.78v7.666h-1.78l-.008-.013c-.42-.69-1.2-1.409-2.312-1.409s-1.893.718-2.312 1.41l-.008.012z",
    clipRule: "evenodd"
  })));
};

var _path$9I, _path2$3i;
function _extends$9P() { return _extends$9P = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$9P.apply(null, arguments); }
var SvgCoupon18 = function SvgCoupon18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9P({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$9I || (_path$9I = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M10.55 6.837a.8.8 0 0 1 .8.8v.1a.8.8 0 0 1-1.6 0v-.1a.8.8 0 0 1 .8-.8M10.55 9.462a.8.8 0 0 1 .8.8v.1a.8.8 0 0 1-1.6 0v-.1a.8.8 0 0 1 .8-.8"
  })), _path2$3i || (_path2$3i = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M2.7 3h5.595c.465 0 .849.334 1.073.742.289.524.722.858 1.207.858s.918-.334 1.207-.858c.225-.408.608-.742 1.073-.742H15.3c.87 0 1.575.716 1.575 1.6v8.8c0 .884-.705 1.6-1.575 1.6h-2.445c-.465 0-.848-.334-1.073-.742-.289-.524-.722-.858-1.207-.858s-.918.334-1.207.858c-.224.408-.608.742-1.073.742H2.7c-.87 0-1.575-.716-1.575-1.6V4.6c0-.884.705-1.6 1.575-1.6m.025 10.4V4.6h5.29c.462.788 1.322 1.6 2.56 1.6s2.098-.812 2.56-1.6h2.14v8.8h-2.14c-.462-.788-1.322-1.6-2.56-1.6s-2.098.812-2.56 1.6z",
    clipRule: "evenodd"
  })));
};

var _path$9H, _path2$3h;
function _extends$9O() { return _extends$9O = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$9O.apply(null, arguments); }
var SvgCoupon24 = function SvgCoupon24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9O({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$9H || (_path$9H = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M13.9 11.25a.9.9 0 0 1-.9-.9v-.2a.9.9 0 1 1 1.8 0v.2a.9.9 0 0 1-.9.9M13.9 14.75a.9.9 0 0 1-.9-.9v-.2a.9.9 0 1 1 1.8 0v.2a.9.9 0 0 1-.9.9"
  })), _path2$3h || (_path2$3h = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M10.884 5.8c.575 1.068 1.65 2.133 3.216 2.133s2.64-1.065 3.216-2.133H20.4c.14 0 .3.122.3.333v11.734c0 .21-.16.333-.3.333h-3.084c-.575-1.068-1.65-2.133-3.216-2.133s-2.64 1.065-3.216 2.133H3.6c-.14 0-.3-.122-.3-.333V6.133c0-.21.16-.333.3-.333zm.44-1.8H3.6c-1.16 0-2.1.955-2.1 2.133v11.734C1.5 19.045 2.44 20 3.6 20h7.725c.465 0 .855-.328 1.047-.752.379-.835 1.012-1.381 1.728-1.381s1.35.546 1.728 1.38c.192.425.582.753 1.047.753H20.4c1.16 0 2.1-.955 2.1-2.133V6.133C22.5 4.955 21.56 4 20.4 4h-3.525c-.465 0-.855.329-1.047.752-.379.835-1.012 1.381-1.728 1.381s-1.35-.546-1.728-1.38C12.18 4.328 11.79 4 11.325 4"
  })));
};

var _path$9G, _path2$3g;
function _extends$9N() { return _extends$9N = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$9N.apply(null, arguments); }
var SvgCoupon32 = function SvgCoupon32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9N({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$9G || (_path$9G = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M18.333 12.333a1 1 0 0 1 1 1V14a1 1 0 1 1-2 0v-.667a1 1 0 0 1 1-1M18.333 17a1 1 0 0 1 1 1v.667a1 1 0 1 1-2 0V18a1 1 0 0 1 1-1",
    clipRule: "evenodd"
  })), _path2$3g || (_path2$3g = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M14.757 7.333H4.8c-.412 0-.8.349-.8.845v15.644c0 .496.388.845.8.845h9.957c.712-1.444 2.064-2.845 4.043-2.845s3.33 1.4 4.043 2.845H27.2c.412 0 .8-.349.8-.845V8.178c0-.496-.388-.845-.8-.845h-4.357c-.712 1.444-2.064 2.845-4.043 2.845s-3.33-1.4-4.043-2.845m.608-2H4.8C3.254 5.333 2 6.607 2 8.178v15.644c0 1.571 1.254 2.845 2.8 2.845h10.565c.465 0 .859-.326 1.028-.76.488-1.248 1.384-2.085 2.407-2.085s1.919.837 2.407 2.086c.17.433.563.759 1.028.759H27.2c1.546 0 2.8-1.274 2.8-2.845V8.178c0-1.571-1.254-2.845-2.8-2.845h-4.965c-.465 0-.858.326-1.028.76-.488 1.248-1.384 2.085-2.407 2.085s-1.919-.837-2.407-2.086c-.17-.433-.563-.759-1.028-.759",
    clipRule: "evenodd"
  })));
};

var _path$9F, _path2$3f;
function _extends$9M() { return _extends$9M = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$9M.apply(null, arguments); }
var SvgCoupon48 = function SvgCoupon48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9M({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$9F || (_path$9F = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M29.4 17.7a1.2 1.2 0 0 0-2.4 0v1.6a1.2 1.2 0 0 0 2.4 0zM29.4 23.2a1.2 1.2 0 0 0-2.4 0v1.6a1.2 1.2 0 0 0 2.4 0zM28.2 27.5a1.2 1.2 0 0 1 1.2 1.2v1.6a1.2 1.2 0 0 1-2.4 0v-1.6a1.2 1.2 0 0 1 1.2-1.2"
  })), _path2$3f || (_path2$3f = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M7.2 8h16.244c.466 0 .863.324 1.01.765.694 2.078 2.111 3.502 3.746 3.502s3.052-1.424 3.746-3.502c.147-.441.544-.765 1.01-.765H40.8c2.32 0 4.2 1.91 4.2 4.267v23.466C45 38.09 43.12 40 40.8 40h-7.844c-.466 0-.863-.324-1.01-.765-.694-2.078-2.111-3.502-3.746-3.502s-3.052 1.424-3.746 3.502c-.147.441-.544.765-1.01.765H7.2C4.88 40 3 38.09 3 35.733V12.267C3 9.91 4.88 8 7.2 8m0 2.4h15.318c.982 2.202 2.893 4.267 5.682 4.267s4.7-2.065 5.682-4.267H40.8c.959 0 1.8.8 1.8 1.867v23.466c0 1.067-.841 1.867-1.8 1.867h-6.918c-.982-2.202-2.893-4.267-5.682-4.267s-4.7 2.065-5.682 4.267H7.2c-.959 0-1.8-.8-1.8-1.867V12.267c0-1.067.841-1.867 1.8-1.867",
    clipRule: "evenodd"
  })));
};

var CouponIcon = function CouponIcon(props) {
  var coupon = {
    12: SvgCoupon12,
    16: SvgCoupon16,
    18: SvgCoupon18,
    24: SvgCoupon24,
    32: SvgCoupon32,
    48: SvgCoupon48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: coupon
  }, props));
};

var _path$9E;
function _extends$9L() { return _extends$9L = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$9L.apply(null, arguments); }
var SvgCouponFilled12 = function SvgCouponFilled12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9L({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$9E || (_path$9E = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M5.662 2H1.8C1.22 2 .75 2.478.75 3.067v5.866C.75 9.523 1.22 10 1.8 10h3.862c.233 0 .428-.164.524-.376.19-.417.506-.69.864-.69s.675.273.864.69c.096.212.29.376.524.376H10.2c.58 0 1.05-.478 1.05-1.067V3.067c0-.59-.47-1.067-1.05-1.067H8.438c-.233 0-.428.164-.524.376-.19.417-.506.69-.864.69s-.675-.273-.864-.69C6.09 2.164 5.896 2 5.662 2M7.4 5.075a.45.45 0 1 0-.9 0v.1a.45.45 0 1 0 .9 0zm-.45 1.3a.45.45 0 0 1 .45.45v.1a.45.45 0 1 1-.9 0v-.1a.45.45 0 0 1 .45-.45",
    clipRule: "evenodd"
  })));
};

var _path$9D;
function _extends$9K() { return _extends$9K = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$9K.apply(null, arguments); }
var SvgCouponFilled16 = function SvgCouponFilled16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9K({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$9D || (_path$9D = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M7.55 2.667H2.4c-.773 0-1.4.637-1.4 1.422v7.822c0 .786.627 1.422 1.4 1.422h5.15c.31 0 .57-.219.698-.501.253-.556.674-.92 1.152-.92s.9.364 1.152.92c.128.282.388.501.698.501h2.35c.773 0 1.4-.636 1.4-1.422V4.09c0-.786-.627-1.422-1.4-1.422h-2.35c-.31 0-.57.219-.698.501-.253.557-.674.921-1.152.921s-.9-.364-1.152-.92c-.128-.283-.388-.502-.698-.502m2.317 4.1a.6.6 0 0 0-1.2 0V6.9a.6.6 0 0 0 1.2 0zm-.6 1.733a.6.6 0 0 1 .6.6v.133a.6.6 0 0 1-1.2 0V9.1a.6.6 0 0 1 .6-.6",
    clipRule: "evenodd"
  })));
};

var _path$9C;
function _extends$9J() { return _extends$9J = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$9J.apply(null, arguments); }
var SvgCouponFilled18 = function SvgCouponFilled18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9J({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$9C || (_path$9C = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8.494 3H2.7c-.87 0-1.575.716-1.575 1.6v8.8c0 .884.705 1.6 1.575 1.6h5.794c.349 0 .64-.246.785-.564.284-.626.759-1.036 1.296-1.036s1.012.41 1.296 1.036c.144.318.436.564.785.564H15.3c.87 0 1.575-.716 1.575-1.6V4.6c0-.884-.705-1.6-1.575-1.6h-2.644c-.349 0-.64.246-.785.564-.284.626-.759 1.036-1.296 1.036s-1.012-.41-1.296-1.036C9.135 3.246 8.843 3 8.494 3M11.1 7.613a.675.675 0 1 0-1.35 0v.15a.675.675 0 1 0 1.35 0zm-.675 1.95c.373 0 .675.302.675.675v.15a.675.675 0 1 1-1.35 0v-.15c0-.373.302-.675.675-.675",
    clipRule: "evenodd"
  })));
};

var _path$9B;
function _extends$9I() { return _extends$9I = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$9I.apply(null, arguments); }
var SvgCouponFilled24 = function SvgCouponFilled24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9I({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$9B || (_path$9B = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M11.325 4H3.6c-1.16 0-2.1.955-2.1 2.133v11.734C1.5 19.045 2.44 20 3.6 20h7.725c.465 0 .855-.328 1.047-.752.379-.835 1.012-1.381 1.728-1.381s1.35.546 1.728 1.38c.192.425.582.753 1.047.753H20.4c1.16 0 2.1-.955 2.1-2.133V6.133C22.5 4.955 21.56 4 20.4 4h-3.525c-.465 0-.855.329-1.047.752-.379.835-1.012 1.381-1.728 1.381s-1.35-.546-1.728-1.38C12.18 4.328 11.79 4 11.325 4m3.475 6.15a.9.9 0 1 0-1.8 0v.2a.9.9 0 1 0 1.8 0zm-.9 2.6a.9.9 0 0 1 .9.9v.2a.9.9 0 1 1-1.8 0v-.2a.9.9 0 0 1 .9-.9",
    clipRule: "evenodd"
  })));
};

var _path$9A;
function _extends$9H() { return _extends$9H = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$9H.apply(null, arguments); }
var SvgCouponFilled32 = function SvgCouponFilled32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9H({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$9A || (_path$9A = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M15.1 5.333H4.8C3.254 5.333 2 6.607 2 8.178v15.644c0 1.571 1.254 2.845 2.8 2.845h10.3c.62 0 1.14-.439 1.396-1.003.505-1.113 1.349-1.842 2.304-1.842s1.799.729 2.304 1.842c.257.564.776 1.003 1.396 1.003h4.7c1.546 0 2.8-1.274 2.8-2.845V8.178c0-1.571-1.254-2.845-2.8-2.845h-4.7c-.62 0-1.14.438-1.396 1.003C20.6 7.45 19.755 8.178 18.8 8.178s-1.799-.73-2.304-1.842c-.257-.565-.776-1.003-1.396-1.003m4.633 8.2a1.2 1.2 0 1 0-2.4 0v.267a1.2 1.2 0 1 0 2.4 0zM18.533 17a1.2 1.2 0 0 1 1.2 1.2v.267a1.2 1.2 0 1 1-2.4 0V18.2a1.2 1.2 0 0 1 1.2-1.2",
    clipRule: "evenodd"
  })));
};

var _path$9z;
function _extends$9G() { return _extends$9G = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$9G.apply(null, arguments); }
var SvgCouponFilled48 = function SvgCouponFilled48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9G({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$9z || (_path$9z = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M22.65 8H7.2C4.88 8 3 9.91 3 12.267v23.466C3 38.09 4.88 40 7.2 40h15.45c.93 0 1.71-.657 2.094-1.504.758-1.67 2.023-2.763 3.456-2.763s2.698 1.094 3.456 2.763C32.041 39.343 32.82 40 33.75 40h7.05c2.32 0 4.2-1.91 4.2-4.267V12.267C45 9.91 43.12 8 40.8 8h-7.05c-.93 0-1.71.657-2.094 1.504-.758 1.67-2.023 2.763-3.456 2.763s-2.698-1.094-3.456-2.763C24.359 8.657 23.58 8 22.65 8m6.95 12.3a1.8 1.8 0 0 0-3.6 0v.4a1.8 1.8 0 0 0 3.6 0zm-1.8 5.2a1.8 1.8 0 0 1 1.8 1.8v.4a1.8 1.8 0 0 1-3.6 0v-.4a1.8 1.8 0 0 1 1.8-1.8",
    clipRule: "evenodd"
  })));
};

var CouponFilledIcon = function CouponFilledIcon(props) {
  var couponFilled = {
    12: SvgCouponFilled12,
    16: SvgCouponFilled16,
    18: SvgCouponFilled18,
    24: SvgCouponFilled24,
    32: SvgCouponFilled32,
    48: SvgCouponFilled48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: couponFilled
  }, props));
};

var _path$9y;
function _extends$9F() { return _extends$9F = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$9F.apply(null, arguments); }
var SvgCrownFilled12 = function SvgCrownFilled12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9F({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$9y || (_path$9y = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M2 9.816c0-.174.149-.316.332-.316h7.336c.183 0 .332.142.332.316v.532c0 .36-.306.652-.684.652H2.684C2.306 11 2 10.708 2 10.348zm8.446-8.476A1.45 1.45 0 0 1 12 2.794a1.46 1.46 0 0 1-1.013 1.392L9.941 8.683A.36.36 0 0 1 9.587 9H2.429a.36.36 0 0 1-.354-.316L1.018 4.187A1.46 1.46 0 0 1 0 2.794c0-.841.709-1.518 1.554-1.454a1.455 1.455 0 0 1 1.263 1.903c-.06.185-.155.356-.282.504l1.65.672 1.096-.684a1.46 1.46 0 0 1-.747-1.277c0-.84.708-1.518 1.555-1.454a1.462 1.462 0 0 1 .548 2.75l1.065.665 1.734-.707a1.461 1.461 0 0 1 1.01-2.372"
  })));
};

var _path$9x;
function _extends$9E() { return _extends$9E = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$9E.apply(null, arguments); }
var SvgCrownFilled16 = function SvgCrownFilled16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9E({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$9x || (_path$9x = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M2.667 13.089c0-.234.198-.422.442-.422h9.782c.244 0 .442.188.442.422v.708c0 .48-.408.87-.912.87H3.58c-.504 0-.912-.39-.912-.87zm11.26-11.302A1.935 1.935 0 0 1 16 3.725c0 .87-.569 1.609-1.35 1.856l-1.395 5.996a.48.48 0 0 1-.473.423H3.24a.48.48 0 0 1-.472-.421l-1.41-5.996A1.945 1.945 0 0 1 0 3.725c0-1.121.945-2.024 2.073-1.939a1.95 1.95 0 0 1 1.308 3.21l2.198.896L7.04 4.98a1.95 1.95 0 0 1-.996-1.703c0-1.12.945-2.024 2.073-1.938a1.94 1.94 0 0 1 1.77 1.778A1.95 1.95 0 0 1 8.85 5.006l1.42.886 2.313-.942a1.95 1.95 0 0 1-.428-1.35 1.94 1.94 0 0 1 1.774-1.813"
  })));
};

var _path$9w;
function _extends$9D() { return _extends$9D = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$9D.apply(null, arguments); }
var SvgCrownFilled18 = function SvgCrownFilled18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9D({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$9w || (_path$9w = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M3 14.725c0-.262.223-.475.498-.475h11.004c.275 0 .498.213.498.475v.797c0 .54-.46.978-1.026.978H4.026C3.459 16.5 3 16.063 3 15.522zM15.669 2.01C16.937 1.914 18 2.93 18 4.19c0 .98-.64 1.81-1.52 2.089l-1.568 6.746a.54.54 0 0 1-.532.475H3.644a.54.54 0 0 1-.532-.474L1.527 6.281A2.19 2.19 0 0 1 0 4.191C0 2.93 1.063 1.914 2.332 2.01a2.18 2.18 0 0 1 1.991 1.993 2.2 2.2 0 0 1-.52 1.617l2.473 1.008 1.646-1.026A2.19 2.19 0 0 1 6.8 3.687c0-1.261 1.063-2.277 2.332-2.18a2.18 2.18 0 0 1 1.992 2 2.19 2.19 0 0 1-1.17 2.125l1.598.996 2.601-1.06a2.2 2.2 0 0 1-.48-1.518 2.18 2.18 0 0 1 1.995-2.04"
  })));
};

var _path$9v;
function _extends$9C() { return _extends$9C = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$9C.apply(null, arguments); }
var SvgCrownFilled24 = function SvgCrownFilled24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9C({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$9v || (_path$9v = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M4.667 19.163c0-.32.272-.58.608-.58h13.45c.336 0 .608.26.608.58v.975c0 .66-.56 1.195-1.254 1.195H5.921c-.693 0-1.254-.534-1.254-1.195zM20.15 3.623C21.7 3.508 23 4.748 23 6.29a2.675 2.675 0 0 1-1.857 2.551l-1.917 8.246a.657.657 0 0 1-.65.58H5.454a.66.66 0 0 1-.65-.579L2.866 8.843A2.675 2.675 0 0 1 1 6.29c0-1.542 1.3-2.783 2.85-2.666 1.285.097 2.326 1.139 2.434 2.436a2.68 2.68 0 0 1-.636 1.977L8.67 9.268l2.011-1.254a2.68 2.68 0 0 1-1.37-2.34c0-1.543 1.3-2.784 2.85-2.666 1.288.098 2.331 1.144 2.435 2.445a2.68 2.68 0 0 1-1.43 2.597l1.954 1.218 3.178-1.296a2.68 2.68 0 0 1-.587-1.856c.082-1.32 1.132-2.394 2.439-2.492"
  })));
};

var _path$9u;
function _extends$9B() { return _extends$9B = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$9B.apply(null, arguments); }
var SvgCrownFilled32 = function SvgCrownFilled32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9B({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$9u || (_path$9u = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M6.222 25.551c0-.427.364-.773.812-.773h17.932c.448 0 .812.346.812.773v1.3c0 .88-.748 1.594-1.672 1.594H7.894c-.923 0-1.672-.714-1.672-1.594zm20.645-20.72c2.067-.156 3.8 1.499 3.8 3.554a3.57 3.57 0 0 1-2.477 3.402l-2.556 10.994a.876.876 0 0 1-.866.775H7.272a.876.876 0 0 1-.867-.773L3.821 11.791a3.57 3.57 0 0 1-2.488-3.406c0-2.055 1.732-3.71 3.8-3.554 1.714.13 3.101 1.518 3.246 3.247a3.57 3.57 0 0 1-.849 2.636l4.031 1.643 2.682-1.672a3.57 3.57 0 0 1-1.827-3.12c0-2.057 1.732-3.711 3.8-3.555 1.718.13 3.108 1.526 3.246 3.26a3.57 3.57 0 0 1-1.905 3.463l2.604 1.624L24.4 10.63a3.57 3.57 0 0 1-.783-2.475c.11-1.76 1.51-3.192 3.251-3.324"
  })));
};

var _path$9t;
function _extends$9A() { return _extends$9A = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$9A.apply(null, arguments); }
var SvgCrownFilled48 = function SvgCrownFilled48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9A({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$9t || (_path$9t = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M8.667 39.796c0-.67.57-1.213 1.272-1.213h28.122c.702 0 1.272.544 1.272 1.213v2.039c0 1.38-1.173 2.498-2.622 2.498H11.29c-1.449 0-2.622-1.118-2.622-2.498zM41.042 7.304C44.284 7.059 47 9.654 47 12.876a5.59 5.59 0 0 1-3.883 5.336l-4.008 17.24a1.374 1.374 0 0 1-1.36 1.215H10.313a1.374 1.374 0 0 1-1.36-1.212L4.903 18.218A5.59 5.59 0 0 1 1 12.877c0-3.224 2.716-5.819 5.959-5.574 2.687.203 4.863 2.38 5.09 5.093a5.6 5.6 0 0 1-1.331 4.133l6.321 2.576 4.205-2.622a5.6 5.6 0 0 1-2.865-4.894c0-3.223 2.717-5.819 5.96-5.573 2.694.205 4.874 2.393 5.09 5.113a5.6 5.6 0 0 1-2.988 5.43l4.085 2.546 6.646-2.708a5.6 5.6 0 0 1-1.229-3.88c.173-2.762 2.367-5.007 5.1-5.213"
  })));
};

var CrownFilledIcon = function CrownFilledIcon(props) {
  var crownFilled = {
    12: SvgCrownFilled12,
    16: SvgCrownFilled16,
    18: SvgCrownFilled18,
    24: SvgCrownFilled24,
    32: SvgCrownFilled32,
    48: SvgCrownFilled48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: crownFilled
  }, props));
};

var _path$9s, _path2$3e;
function _extends$9z() { return _extends$9z = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$9z.apply(null, arguments); }
var SvgCubeBadgeSparkle12 = function SvgCubeBadgeSparkle12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9z({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 480 480"
  }, props), _path$9s || (_path$9s = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M207.813 42.559a64 64 0 0 1 64 0l122.813 70.906a64 64 0 0 1 32 55.425v132.813q-.36-.595-.686-1.21l-24.31-45.892c-4.831-9.121-14.076-13.355-23.004-12.7v-54.513l-114.608 66.265-.165 132.552 15.406-8.895 45.671 24.192a24 24 0 0 1 3.923 2.6l-57.04 32.932a64 64 0 0 1-64 0L85.001 366.128a64 64 0 0 1-32-55.426V168.89a64 64 0 0 1 32-55.425zm40 41.569a16 16 0 0 0-16 0l-106.797 61.659 114.975 66.282.011-.007.027.016 114.617-66.27zM215.852 386.25 109 324.559a16 16 0 0 1-8-13.857l.001-123.354 115.017 66.306z",
    clipRule: "evenodd"
  })), _path2$3e || (_path2$3e = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M410.543 325.442c3.073 3.072 7.133 5.828 11.803 8.274 5.366 2.81 11.538 5.209 17.942 7.208l.133.041c5.665 1.768 10.072 3.143 13.114 4.176 1.514.515 2.882 1.008 3.965 1.471.527.226 1.188.529 1.836.91l.036.021c.357.207 2.071 1.2 3.226 3.16.716 1.213 1.496 3.012 1.496 5.281 0 2.27-.78 4.069-1.496 5.282-1.155 1.96-2.869 2.953-3.226 3.16l-.036.021c-.648.381-1.309.684-1.836.91-1.083.463-2.451.957-3.965 1.471-3.042 1.033-7.448 2.408-13.114 4.176l-.133.041c-11.977 3.738-23.141 8.879-29.745 15.482-6.603 6.604-11.744 17.768-15.482 29.745l-.041.133-.002.006c-1.767 5.663-3.142 10.067-4.174 13.108-.515 1.514-1.008 2.882-1.471 3.965a16 16 0 0 1-.91 1.836l-.021.036c-.207.358-1.2 2.071-3.16 3.226-1.213.716-3.012 1.496-5.282 1.496s-4.068-.78-5.281-1.496c-1.96-1.155-2.953-2.868-3.16-3.226l-.021-.036a16 16 0 0 1-.91-1.836c-.463-1.083-.957-2.451-1.471-3.965-1.033-3.042-2.408-7.448-4.175-13.113l-.001-.002-.041-.132c-3.096-9.919-7.154-19.281-12.208-25.956a37 37 0 0 0-3.275-3.789c-6.603-6.603-17.767-11.744-29.744-15.482l-.133-.041-.008-.003c-5.662-1.766-10.066-3.141-13.106-4.173-1.514-.514-2.882-1.008-3.965-1.471a18 18 0 0 1-1.393-.662 13 13 0 0 1-.443-.248l-.036-.021c-.358-.207-2.071-1.2-3.226-3.16-.716-1.213-1.496-3.012-1.496-5.282s.78-4.068 1.496-5.281c1.155-1.96 2.868-2.953 3.226-3.16l.036-.021a16 16 0 0 1 1.836-.91c1.083-.463 2.451-.956 3.965-1.471 3.042-1.033 7.449-2.408 13.114-4.176l.133-.041c11.977-3.738 23.141-8.879 29.744-15.482 6.604-6.604 11.745-17.768 15.483-29.745l.041-.133c1.768-5.666 3.143-10.072 4.176-13.114.514-1.514 1.008-2.882 1.471-3.965.226-.527.529-1.188.91-1.836l.021-.036c.207-.358 1.2-2.071 3.16-3.226.957-.565 2.278-1.169 3.907-1.4a10 10 0 0 1 1.374-.096c2.27 0 4.069.78 5.282 1.496 1.96 1.155 2.953 2.868 3.16 3.226l.021.036c.381.648.684 1.309.91 1.836.463 1.083.956 2.451 1.471 3.965 1.033 3.042 2.408 7.448 4.176 13.114l.041.133c3.738 11.977 8.879 23.141 15.482 29.745"
  })));
};

var _path$9r, _path2$3d;
function _extends$9y() { return _extends$9y = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$9y.apply(null, arguments); }
var SvgCubeBadgeSparkle16 = function SvgCubeBadgeSparkle16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9y({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 480 480"
  }, props), _path$9r || (_path$9r = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M208.562 43.881a62.5 62.5 0 0 1 62.5 0l122.813 70.906a62.5 62.5 0 0 1 31.25 54.127v130.067l-23.496-44.357c-4.561-8.611-13.056-12.866-21.504-12.764v-57.048l-117.607 67.999-.17 136.017 18.474-10.666 44.107 23.364q1.37.726 2.627 1.616l-56.494 32.616a62.5 62.5 0 0 1-62.5 0L85.749 364.852a62.5 62.5 0 0 1-31.25-54.126V168.914a62.5 62.5 0 0 1 31.25-54.127zm40 38.971a17.5 17.5 0 0 0-17.5 0l-109.048 62.96 117.976 68.012.011-.006.027.016 117.615-68.004zM217.348 388.87l.17-136.059L99.5 184.775v125.951a17.5 17.5 0 0 0 8.75 15.155z",
    clipRule: "evenodd"
  })), _path2$3d || (_path2$3d = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M410.542 325.465c2.777 2.777 6.36 5.295 10.471 7.559 5.665 3.12 12.333 5.757 19.274 7.923l.132.041c5.666 1.768 10.073 3.144 13.115 4.177 1.514.514 2.881 1.007 3.965 1.471.527.226 1.188.529 1.836.909l.036.021c.357.208 2.071 1.201 3.226 3.16.716 1.213 1.496 3.013 1.496 5.282s-.78 4.068-1.496 5.282c-1.155 1.959-2.869 2.952-3.226 3.159l-.036.022c-.648.38-1.309.683-1.836.909-1.084.464-2.451.957-3.965 1.471-3.042 1.033-7.448 2.408-13.114 4.176l-.133.042c-11.977 3.737-23.141 8.878-29.745 15.482-6.603 6.604-11.744 17.768-15.482 29.744l-.041.133-.002.007c-1.767 5.662-3.142 10.067-4.174 13.108-.515 1.514-1.008 2.881-1.472 3.965a16 16 0 0 1-.909 1.835l-.021.037c-.207.357-1.2 2.071-3.16 3.226-1.213.715-3.012 1.496-5.282 1.496s-4.068-.781-5.281-1.496c-1.96-1.155-2.953-2.869-3.16-3.226l-.021-.037a16 16 0 0 1-.91-1.835c-.463-1.084-.957-2.451-1.471-3.965-1.033-3.042-2.408-7.448-4.176-13.113v-.002l-.042-.133c-3.284-10.524-7.652-20.421-13.144-27.147a35 35 0 0 0-2.338-2.597c-6.603-6.604-17.767-11.745-29.744-15.482l-.133-.042-.007-.002-.006-.002c-5.659-1.766-10.062-3.139-13.102-4.172-1.392-.473-2.66-.928-3.697-1.359q-.136-.056-.267-.112a17 17 0 0 1-1.836-.909l-.036-.022c-.358-.207-2.071-1.2-3.226-3.159-.716-1.214-1.496-3.013-1.496-5.282s.78-4.069 1.496-5.282c1.155-1.959 2.868-2.952 3.226-3.16l.036-.021c.648-.38 1.309-.683 1.836-.909 1.083-.464 2.451-.957 3.964-1.471 3.043-1.033 7.45-2.409 13.115-4.177l.133-.041c11.977-3.737 23.141-8.878 29.744-15.482s11.745-17.768 15.483-29.744l.041-.133c1.768-5.666 3.143-10.073 4.176-13.115.514-1.514 1.008-2.881 1.471-3.965.226-.527.529-1.188.91-1.835l.021-.037c.207-.357 1.2-2.071 3.16-3.226 1.213-.715 3.012-1.496 5.281-1.496l.126.001c2.21.028 3.965.793 5.156 1.495 1.96 1.155 2.953 2.869 3.16 3.226l.021.037c.381.647.684 1.308.909 1.835.464 1.084.957 2.451 1.472 3.965 1.033 3.042 2.408 7.449 4.176 13.114l.041.134c3.738 11.976 8.879 23.14 15.482 29.744"
  })));
};

var _path$9q, _path2$3c;
function _extends$9x() { return _extends$9x = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$9x.apply(null, arguments); }
var SvgCubeBadgeSparkle18 = function SvgCubeBadgeSparkle18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9x({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 480 480"
  }, props), _path$9q || (_path$9q = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M209.145 44.884a61.34 61.34 0 0 1 61.335 0l122.813 70.906a61.33 61.33 0 0 1 30.667 53.118l.001 127.868-22.332-42.157c-4.351-8.215-12.283-12.465-20.339-12.75v-59.083l-119.936 69.346-.173 138.709 20.856-12.041 42.892 22.721q.792.419 1.546.894l-55.995 32.329a61.34 61.34 0 0 1-61.335 0L86.332 363.838a61.34 61.34 0 0 1-30.667-53.118V168.908a61.34 61.34 0 0 1 30.667-53.118zm40 36.954a18.67 18.67 0 0 0-18.665 0l-110.797 63.969 120.308 69.356.01-.006.028.016 119.943-69.349zM218.511 390.88l-110.844-63.996a18.66 18.66 0 0 1-9.332-16.164V182.753l120.349 69.38z",
    clipRule: "evenodd"
  })), _path2$3c || (_path2$3c = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M410.543 325.46c2.543 2.543 5.762 4.869 9.443 6.982 5.879 3.373 12.936 6.202 20.301 8.5l.133.042c5.666 1.768 10.073 3.143 13.115 4.176 1.514.514 2.881 1.007 3.964 1.471.528.226 1.189.529 1.836.909l.036.022c.358.207 2.072 1.2 3.227 3.159.715 1.214 1.496 3.013 1.496 5.282s-.781 4.069-1.496 5.282c-1.155 1.959-2.869 2.952-3.227 3.16l-.036.021c-.647.38-1.308.684-1.836.909-1.083.464-2.45.957-3.964 1.471-3.042 1.033-7.449 2.409-13.115 4.176l-.133.042c-11.976 3.737-23.141 8.878-29.744 15.482s-11.745 17.768-15.482 29.744l-.042.133-.002.007c-1.767 5.662-3.141 10.067-4.174 13.108-.514 1.514-1.007 2.881-1.471 3.965a16 16 0 0 1-.91 1.835l-.021.037c-.207.357-1.2 2.071-3.159 3.226-1.214.715-3.013 1.496-5.282 1.496s-4.069-.781-5.282-1.496c-1.959-1.155-2.953-2.869-3.16-3.226l-.021-.037a16 16 0 0 1-.909-1.835c-.464-1.084-.957-2.451-1.471-3.965-1.033-3.042-2.408-7.448-4.176-13.113l-.001-.002-.041-.133c-3.435-11.007-8.055-21.328-13.907-28.053a34 34 0 0 0-1.575-1.691c-6.604-6.604-17.768-11.745-29.744-15.482l-.134-.042-.007-.002-.006-.002c-5.659-1.766-10.061-3.139-13.101-4.172a84 84 0 0 1-2.31-.816 37 37 0 0 1-1.655-.655 16 16 0 0 1-1.836-.909l-.036-.021c-.357-.208-2.071-1.201-3.226-3.16-.715-1.213-1.496-3.013-1.496-5.282s.781-4.068 1.496-5.282c1.155-1.959 2.869-2.952 3.226-3.159l.036-.022c.648-.38 1.309-.683 1.836-.909 1.084-.464 2.451-.957 3.965-1.471 3.042-1.033 7.449-2.408 13.115-4.176l.133-.042c11.976-3.737 23.14-8.878 29.744-15.482s11.745-17.768 15.482-29.744l.041-.133c1.768-5.666 3.143-10.073 4.177-13.115.514-1.514 1.007-2.881 1.471-3.965.225-.527.528-1.188.909-1.835l.021-.037c.207-.357 1.201-2.071 3.16-3.226 1.213-.715 3.013-1.496 5.282-1.496.449 0 .879.031 1.29.085 1.668.222 3.018.837 3.992 1.411 1.959 1.155 2.952 2.869 3.159 3.226l.021.037c.381.647.684 1.308.91 1.835.464 1.084.957 2.451 1.471 3.965 1.033 3.042 2.408 7.449 4.176 13.114l.042.134c3.737 11.976 8.878 23.14 15.482 29.744"
  })));
};

var _path$9p, _path2$3b;
function _extends$9w() { return _extends$9w = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$9w.apply(null, arguments); }
var SvgCubeBadgeSparkle24 = function SvgCubeBadgeSparkle24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9w({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 480 480"
  }, props), _path$9p || (_path$9p = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M210.813 47.77a58 58 0 0 1 58 0l122.813 70.907a58 58 0 0 1 29 50.229v121.571l-18.996-35.861c-3.748-7.076-10.152-11.21-17.004-12.403v-65.209l-126.604 73.201-.183 146.415 27.678-15.98 37.549 19.89-54.253 31.324a58 58 0 0 1-58 0L88 360.948a58 58 0 0 1-29-50.23V168.906a58 58 0 0 1 29-50.23zm40 31.177a22 22 0 0 0-22 0l-115.804 66.86 126.984 73.205.008-.005.029.016 126.609-73.204zM221.839 396.65l.183-146.445L95 176.979v133.739a22 22 0 0 0 11 19.053z",
    clipRule: "evenodd"
  })), _path2$3b || (_path2$3b = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M410.543 325.457c1.851 1.851 4.06 3.587 6.545 5.209 6.381 4.166 14.58 7.583 23.2 10.273l.132.042c5.666 1.768 10.073 3.143 13.115 4.176 1.514.514 2.881 1.007 3.965 1.471.527.226 1.188.529 1.836.91l.036.021c.357.207 2.071 1.2 3.226 3.159.716 1.214 1.496 3.013 1.496 5.282s-.78 4.069-1.496 5.282c-1.155 1.959-2.869 2.952-3.226 3.16l-.036.021c-.648.38-1.309.684-1.836.909-1.084.464-2.451.957-3.965 1.471-3.042 1.033-7.448 2.409-13.114 4.176l-.133.042c-11.977 3.737-23.141 8.878-29.745 15.482-6.603 6.604-11.744 17.768-15.482 29.744l-.041.134-.002.006c-1.767 5.662-3.142 10.067-4.174 13.108-.515 1.514-1.008 2.881-1.472 3.965a16 16 0 0 1-.909 1.835l-.021.037c-.207.357-1.2 2.071-3.16 3.226-1.213.715-3.013 1.496-5.282 1.496s-4.068-.781-5.281-1.496c-1.96-1.155-2.953-2.869-3.16-3.226l-.021-.037a16 16 0 0 1-.91-1.835c-.464-1.084-.957-2.451-1.471-3.965-1.033-3.042-2.408-7.448-4.176-13.113v-.002l-.042-.133c-3.737-11.976-8.878-23.14-15.482-29.744a34 34 0 0 0-.81-.782c-6.684-6.229-17.434-11.111-28.934-14.7l-.133-.041-.006-.002c-4.592-1.433-8.357-2.608-11.239-3.552a171 171 0 0 1-1.87-.623c-1.514-.514-2.881-1.007-3.964-1.471a16 16 0 0 1-1.836-.909l-.036-.021c-.358-.208-2.071-1.201-3.227-3.16-.715-1.213-1.496-3.013-1.496-5.282s.781-4.068 1.496-5.282c1.156-1.959 2.869-2.952 3.227-3.159l.036-.021a16 16 0 0 1 1.836-.91c1.083-.464 2.45-.957 3.964-1.471 3.043-1.033 7.449-2.408 13.115-4.176l.133-.042c11.977-3.737 23.141-8.878 29.744-15.482s11.745-17.768 15.482-29.744l.042-.133c1.768-5.666 3.143-10.073 4.176-13.115.514-1.514 1.007-2.881 1.471-3.964.226-.528.529-1.189.91-1.836l.021-.037c.207-.357 1.2-2.071 3.16-3.226 1.213-.715 3.012-1.496 5.281-1.496 1.891 0 3.455.542 4.626 1.136q.352.18.656.36c1.96 1.155 2.953 2.869 3.16 3.226l.021.037c.381.647.684 1.308.909 1.836.464 1.083.957 2.45 1.472 3.964 1.033 3.042 2.408 7.449 4.176 13.114l.041.134c3.738 11.976 8.879 23.14 15.482 29.744"
  })));
};

var _path$9o, _path2$3a;
function _extends$9v() { return _extends$9v = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$9v.apply(null, arguments); }
var SvgCubeBadgeSparkle32 = function SvgCubeBadgeSparkle32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9v({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 480 480"
  }, props), _path$9o || (_path$9o = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M212.312 50.376a55 55 0 0 1 55 0l122.813 70.906a55 55 0 0 1 27.5 47.632v115.908l-15.996-30.198c-3.194-6.031-8.318-9.925-14.004-11.682v-71.13l-132.602 76.669-.191 153.347 33.813-19.522 31.291 16.575-52.624 30.382a55 55 0 0 1-55 0L89.499 358.357A55 55 0 0 1 62 310.726V168.914a55 55 0 0 1 27.5-47.632zm40 25.981a25 25 0 0 0-25 0l-120.307 69.46 132.989 76.666.007-.004.029.017 132.605-76.671zm-27.48 325.494.191-153.37L92 171.794v138.932a25 25 0 0 0 12.5 21.651z",
    clipRule: "evenodd"
  })), _path2$3a || (_path2$3a = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M410.543 325.465a37 37 0 0 0 3.995 3.43c6.661 4.982 15.932 8.989 25.749 12.052l.133.041c5.666 1.768 10.072 3.144 13.115 4.177 1.514.514 2.881 1.007 3.964 1.471.527.226 1.188.529 1.836.909l.036.021c.358.208 2.071 1.201 3.227 3.16.715 1.213 1.495 3.013 1.495 5.282s-.78 4.068-1.495 5.282c-1.156 1.959-2.869 2.952-3.227 3.159l-.036.022c-.648.38-1.309.683-1.836.909-1.083.464-2.45.957-3.964 1.471-3.043 1.033-7.449 2.408-13.115 4.176l-.133.042c-11.977 3.737-23.141 8.878-29.744 15.482s-11.745 17.768-15.482 29.744l-.042.133-.002.007c-1.767 5.662-3.141 10.067-4.174 13.108-.514 1.514-1.008 2.881-1.471 3.965a16 16 0 0 1-.91 1.835l-.021.037c-.207.357-1.2 2.071-3.16 3.226-1.213.715-3.012 1.496-5.281 1.496-2.27 0-4.069-.781-5.282-1.496-1.96-1.155-2.953-2.869-3.16-3.226l-.021-.037a16 16 0 0 1-.909-1.835c-.464-1.084-.957-2.451-1.472-3.965-1.033-3.042-2.408-7.448-4.175-13.113l-.001-.002-.041-.133c-3.738-11.976-8.879-23.14-15.482-29.744a36 36 0 0 0-3.234-2.847c-6.706-5.254-16.314-9.453-26.511-12.635l-.133-.042-.005-.001c-2.765-.863-5.231-1.633-7.384-2.314a296 296 0 0 1-5.725-1.861c-1.514-.514-2.881-1.007-3.965-1.471a17 17 0 0 1-1.836-.909l-.036-.022c-.357-.207-2.071-1.2-3.226-3.159-.716-1.214-1.496-3.013-1.496-5.282s.78-4.069 1.496-5.282c1.155-1.959 2.869-2.952 3.226-3.16l.036-.021c.648-.38 1.309-.683 1.836-.909 1.084-.464 2.451-.957 3.965-1.471 3.042-1.033 7.449-2.409 13.115-4.177l.132-.041c11.977-3.737 23.141-8.878 29.745-15.482 6.603-6.604 11.744-17.768 15.482-29.744l.041-.133c1.768-5.666 3.143-10.073 4.176-13.115.515-1.514 1.008-2.881 1.472-3.965.225-.527.528-1.188.909-1.835l.021-.037c.207-.357 1.2-2.071 3.16-3.226 1.213-.715 3.012-1.496 5.282-1.496s4.068.781 5.281 1.496a8.8 8.8 0 0 1 2.344 2.042c.454.559.72 1.018.816 1.184l.021.037c.381.647.684 1.308.91 1.835.463 1.084.957 2.451 1.471 3.965 1.033 3.042 2.408 7.449 4.176 13.114l.042.134c3.737 11.976 8.878 23.14 15.482 29.744"
  })));
};

var _path$9n, _path2$39;
function _extends$9u() { return _extends$9u = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$9u.apply(null, arguments); }
var SvgCubeBadgeSparkle48 = function SvgCubeBadgeSparkle48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9u({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none",
    viewBox: "0 0 480 480"
  }, props), _path$9n || (_path$9n = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M213.813 52.963a52 52 0 0 1 52 0l122.813 70.906a52 52 0 0 1 26 45.033v110.245l-12.996-24.535c-2.621-4.948-6.541-8.457-11.004-10.529v-75.181q0-1.132-.091-2.25l-138.509 80.085-.2 160.175a28 28 0 0 0 1.987-1.043l37.962-21.918 25.033 13.261-50.995 29.441a52 52 0 0 1-52 .001L91 355.747a52 52 0 0 1-26-45.033V168.902a52 52 0 0 1 26-45.033zm40 20.784a28 28 0 0 0-28 0L103 144.653q-.983.569-1.907 1.206l138.903 80.076.005-.003.03.017 138.51-80.084a28 28 0 0 0-1.915-1.212zm-25.987 333.178.2-160.188-138.935-80.094q-.09 1.121-.09 2.259L89 310.714a28 28 0 0 0 14 24.249l122.813 70.906q.99.572 2.013 1.056",
    clipRule: "evenodd"
  })), _path2$39 || (_path2$39 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M410.543 325.453q.72.72 1.51 1.417c6.72 5.927 17.128 10.6 28.234 14.065l.133.042c5.666 1.768 10.073 3.143 13.115 4.176 1.514.514 2.881 1.007 3.965 1.471.527.226 1.188.529 1.835.91l.037.021c.357.207 2.071 1.2 3.226 3.16.715 1.213 1.496 3.012 1.496 5.281s-.781 4.069-1.496 5.282c-1.155 1.959-2.869 2.953-3.226 3.16l-.037.021c-.647.381-1.308.684-1.835.909-1.084.464-2.451.957-3.965 1.471-3.042 1.034-7.449 2.409-13.114 4.177l-.134.041c-11.976 3.737-23.14 8.879-29.744 15.482-6.604 6.604-11.745 17.768-15.482 29.744l-.041.134-.002.006c-1.767 5.663-3.142 10.067-4.175 13.108-.514 1.514-1.007 2.881-1.471 3.965a17 17 0 0 1-.909 1.836l-.021.036c-.208.357-1.201 2.071-3.16 3.226-1.213.715-3.013 1.496-5.282 1.496s-4.068-.781-5.282-1.496c-1.959-1.155-2.952-2.869-3.159-3.226l-.022-.036a17 17 0 0 1-.909-1.836c-.464-1.084-.957-2.451-1.471-3.965-1.033-3.042-2.408-7.448-4.176-13.113v-.002l-.042-.133c-3.737-11.976-8.878-23.14-15.482-29.744-1.687-1.687-3.672-3.279-5.892-4.776-6.469-4.363-14.936-7.923-23.852-10.706l-.133-.041-.006-.002-3.498-1.093c-4.007-1.253-7.228-2.272-9.611-3.082-1.514-.514-2.881-1.007-3.964-1.471a16 16 0 0 1-1.836-.909l-.037-.021c-.357-.207-2.071-1.201-3.226-3.16-.715-1.213-1.496-3.013-1.496-5.282s.781-4.068 1.496-5.281c1.155-1.96 2.869-2.953 3.226-3.16l.037-.021a16 16 0 0 1 1.836-.91c1.083-.464 2.45-.957 3.964-1.471 3.042-1.033 7.449-2.408 13.115-4.176l.133-.042c11.976-3.737 23.14-8.878 29.744-15.482s11.745-17.768 15.482-29.744l.042-.133c1.768-5.666 3.143-10.073 4.176-13.115.514-1.514 1.007-2.881 1.471-3.964.226-.528.529-1.189.909-1.836l.022-.036c.207-.358 1.2-2.072 3.159-3.227 1.214-.715 3.013-1.496 5.282-1.496s4.069.781 5.282 1.496c1.959 1.155 2.952 2.869 3.16 3.227l.021.036c.38.647.683 1.308.909 1.836.398.929.818 2.068 1.254 3.329l.217.635c1.033 3.042 2.408 7.449 4.176 13.115l.042.133c3.737 11.976 8.878 23.141 15.482 29.744"
  })));
};

var CubeBadgeSparkleIcon = function CubeBadgeSparkleIcon(props) {
  var cubeBadgeSparkle = {
    12: SvgCubeBadgeSparkle12,
    16: SvgCubeBadgeSparkle16,
    18: SvgCubeBadgeSparkle18,
    24: SvgCubeBadgeSparkle24,
    32: SvgCubeBadgeSparkle32,
    48: SvgCubeBadgeSparkle48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: cubeBadgeSparkle
  }, props));
};

var _path$9m, _path2$38, _path3$n, _path4$7;
function _extends$9t() { return _extends$9t = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$9t.apply(null, arguments); }
var SvgCubeOpen12 = function SvgCubeOpen12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9t({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 480 480"
  }, props), _path$9m || (_path$9m = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M101.406 187.569v15.602c0 13.255-10.745 24-24 24s-24-10.745-24-24v-34.077a64 64 0 0 1 32-55.425l23.902-13.8c11.479-6.627 26.157-2.694 32.784 8.785 6.628 11.479 2.695 26.157-8.784 32.785L125.407 146l20.206 11.666c11.479 6.628 15.412 21.306 8.784 32.785-6.627 11.479-21.305 15.412-32.784 8.785zm-24 71.74c-13.255 0-24 10.746-24 24v27.598a64 64 0 0 0 32 55.425l23.9 13.799c11.479 6.627 26.157 2.694 32.785-8.785s2.694-26.157-8.785-32.784l-7.9-4.561 23.671-13.667c11.479-6.627 15.412-21.305 8.784-32.784-6.627-11.479-21.305-15.412-32.784-8.785l-23.671 13.666v-9.122c0-13.254-10.745-24-24-24m98.129-169.963c6.627 11.479 21.305 15.412 32.784 8.785l7.9-4.561v25.363c0 13.255 10.745 24 24 24s24-10.745 24-24V93.57l7.9 4.56c11.479 6.628 26.157 2.695 32.785-8.784s2.694-26.157-8.785-32.785l-23.9-13.798a64 64 0 0 0-64 0l-23.9 13.798c-11.479 6.628-15.412 21.306-8.784 32.785m-11.221 294.831c-6.627 11.479-2.694 26.157 8.785 32.785l35.12 20.276a64 64 0 0 0 64 0l35.121-20.277c11.479-6.627 15.412-21.305 8.784-32.784-6.627-11.479-21.305-15.412-32.784-8.785l-19.121 11.039V361.13c0-13.254-10.745-24-24-24s-24 10.746-24 24v25.301l-19.12-11.039c-11.479-6.627-26.157-2.694-32.785 8.785m174.029-275.525c-6.627 11.479-2.694 26.158 8.785 32.785l7.904 4.564-20.206 11.666c-11.479 6.627-15.412 21.306-8.785 32.785s21.306 15.412 32.785 8.784l20.206-11.666v15.603c0 13.254 10.745 24 24 24s24-10.746 24-24v-34.079a64 64 0 0 0-32-55.425l-23.904-13.801c-11.479-6.628-26.157-2.695-32.785 8.784M322.577 287.55c-6.628 11.479-2.695 26.157 8.784 32.785l23.671 13.666-7.9 4.56c-11.479 6.628-15.412 21.306-8.785 32.785s21.306 15.412 32.785 8.785l23.9-13.799a64 64 0 0 0 32-55.426v-27.597c0-13.254-10.745-24-24-24s-24 10.746-24 24v9.123l-23.671-13.667c-11.479-6.627-26.157-2.694-32.784 8.785M216 288v-48h48v48c0 13.255-10.745 24-24 24s-24-10.745-24-24",
    clipRule: "evenodd"
  })), _path2$38 || (_path2$38 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m293.569 236.785-41.569 24-24-41.569 41.569-24c11.479-6.628 26.157-2.695 32.785 8.784s2.694 26.157-8.785 32.785",
    clipRule: "evenodd"
  })), _path3$n || (_path3$n = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m186.43 236.785 41.57 24 24-41.569-41.57-24c-11.479-6.628-26.157-2.695-32.784 8.784-6.628 11.479-2.695 26.157 8.784 32.785",
    clipRule: "evenodd"
  })), _path4$7 || (_path4$7 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M216 288v-48h48v48c0 13.255-10.745 24-24 24s-24-10.745-24-24",
    clipRule: "evenodd"
  })));
};

var _path$9l, _path2$37, _path3$m, _path4$6;
function _extends$9s() { return _extends$9s = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$9s.apply(null, arguments); }
var SvgCubeOpen16 = function SvgCubeOpen16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9s({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 480 480"
  }, props), _path$9l || (_path$9l = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M99.5 184.97v18.2c0 12.426-10.075 22.5-22.5 22.5-12.427 0-22.5-10.074-22.5-22.5v-34.077a62.5 62.5 0 0 1 31.25-54.126l23.9-13.799c10.762-6.214 24.523-2.527 30.736 8.235s2.526 24.522-8.236 30.736l-10.151 5.86 20.724 11.965c10.762 6.214 14.449 19.974 8.236 30.736s-19.974 14.449-30.736 8.236L99.499 184.97ZM77 260.808c-12.427 0-22.5 10.074-22.501 22.5v27.598a62.5 62.5 0 0 0 31.25 54.126l23.9 13.799c10.761 6.213 24.522 2.526 30.735-8.236 6.214-10.761 2.526-24.522-8.235-30.735l-10.15-5.86 25.921-14.966c10.761-6.213 14.448-19.974 8.235-30.735-6.213-10.762-19.974-14.449-30.735-8.236l-25.921 14.965v-11.72c0-12.426-10.073-22.5-22.5-22.5Zm99.427-172.213c6.213 10.762 19.974 14.449 30.735 8.236l10.15-5.86v27.961c0 12.427 10.073 22.5 22.5 22.5s22.5-10.073 22.5-22.5V90.971l10.15 5.86c10.761 6.213 24.522 2.526 30.735-8.236s2.526-24.522-8.235-30.736l-23.9-13.798a62.5 62.5 0 0 0-62.5 0l-23.9 13.798c-10.761 6.214-14.449 19.974-8.235 30.736m-11.221 296.331c-6.213 10.762-2.526 24.522 8.236 30.735l35.12 20.277a62.5 62.5 0 0 0 62.5 0l35.12-20.277c10.762-6.213 14.449-19.974 8.236-30.735-6.213-10.762-19.974-14.449-30.736-8.236l-21.37 12.338v-25.899c0-12.426-10.074-22.5-22.5-22.5s-22.5 10.074-22.5 22.5v25.9l-21.37-12.339c-10.762-6.213-24.523-2.526-30.736 8.236m174.029-275.525c-6.213 10.762-2.526 24.523 8.236 30.736L357.625 146l-20.724 11.965c-10.762 6.213-14.449 19.974-8.236 30.736 6.213 10.761 19.974 14.448 30.736 8.235l20.724-11.965v18.201c0 12.426 10.073 22.5 22.5 22.5s22.5-10.074 22.5-22.5v-34.078a62.5 62.5 0 0 0-31.25-54.127l-23.904-13.801c-10.762-6.213-24.523-2.526-30.736 8.235m-15.766 178.898c-6.214 10.762-2.527 24.522 8.235 30.736L357.624 334l-10.149 5.859c-10.762 6.214-14.449 19.974-8.236 30.736s19.974 14.449 30.736 8.236l23.9-13.799a62.5 62.5 0 0 0 31.25-54.127v-27.597c0-12.426-10.074-22.5-22.5-22.5s-22.5 10.074-22.5 22.5v11.721l-25.921-14.966c-10.762-6.213-24.522-2.526-30.735 8.236M217.5 288v-48h45v48c0 12.426-10.073 22.5-22.5 22.5s-22.5-10.074-22.5-22.5",
    clipRule: "evenodd"
  })), _path2$37 || (_path2$37 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M217.5 292v-52h45v52c0 12.426-10.073 22.5-22.5 22.5s-22.5-10.074-22.5-22.5",
    clipRule: "evenodd"
  })), _path3$m || (_path3$m = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m296.25 233.485-45.033 26-22.5-38.971 45.033-26c10.762-6.213 24.523-2.526 30.736 8.236 6.213 10.761 2.526 24.522-8.236 30.735",
    clipRule: "evenodd"
  })), _path4$6 || (_path4$6 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m183.75 233.485 45.034 26 22.5-38.971-45.034-26c-10.761-6.213-24.522-2.526-30.735 8.236-6.213 10.761-2.526 24.522 8.235 30.735",
    clipRule: "evenodd"
  })));
};

var _path$9k, _path2$36, _path3$l, _path4$5;
function _extends$9r() { return _extends$9r = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$9r.apply(null, arguments); }
var SvgCubeOpen18 = function SvgCubeOpen18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9r({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 480 480"
  }, props), _path$9k || (_path$9k = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M98.334 182.953v20.217c0 11.783-9.552 21.335-21.335 21.335s-21.335-9.552-21.335-21.335v-34.077a61.34 61.34 0 0 1 30.668-53.117l23.901-13.8c10.204-5.891 23.252-2.395 29.144 7.81s2.395 23.252-7.809 29.144l-11.899 6.869 22.472 12.974c10.204 5.892 13.701 18.94 7.809 29.145-5.891 10.204-18.94 13.7-29.144 7.809zM77 261.973c-11.783 0-21.335 9.552-21.335 21.335v27.598a61.33 61.33 0 0 0 30.668 53.117l23.899 13.799c10.205 5.891 23.253 2.395 29.144-7.809 5.892-10.205 2.396-23.253-7.809-29.144L119.669 334l27.668-15.974c10.204-5.892 13.701-18.94 7.809-29.145-5.891-10.204-18.94-13.7-29.144-7.809l-27.668 15.974v-13.738c0-11.783-9.552-21.335-21.335-21.335Zm100.436-173.96c5.892 10.204 18.94 13.7 29.145 7.809l11.897-6.87v29.98c0 11.783 9.552 21.335 21.335 21.335s21.335-9.552 21.335-21.335v-29.98l11.897 6.87c10.205 5.891 23.253 2.395 29.144-7.81 5.892-10.204 2.396-23.252-7.809-29.144l-23.9-13.798a61.34 61.34 0 0 0-61.335 0l-23.899 13.798c-10.205 5.892-13.701 18.94-7.81 29.145m-11.22 297.495c-5.892 10.205-2.395 23.253 7.809 29.145l35.12 20.276a61.33 61.33 0 0 0 61.335 0l35.121-20.277c10.204-5.891 13.701-18.939 7.809-29.144-5.891-10.204-18.94-13.7-29.144-7.809l-23.118 13.347v-27.917c0-11.783-9.552-21.335-21.335-21.335s-21.335 9.552-21.335 21.335v27.917l-23.118-13.347c-10.204-5.891-23.253-2.395-29.144 7.809m174.029-275.524c-5.891 10.204-2.395 23.253 7.809 29.144L359.955 146l-22.472 12.974c-10.204 5.891-13.701 18.94-7.809 29.144 5.891 10.204 18.94 13.701 29.144 7.809l22.472-12.974v20.219c0 11.783 9.552 21.335 21.335 21.335s21.335-9.552 21.335-21.335v-34.078a61.34 61.34 0 0 0-30.668-53.118l-23.904-13.801c-10.204-5.892-23.252-2.395-29.144 7.809Zm-15.767 178.898c-5.891 10.204-2.395 23.252 7.81 29.144L359.954 334l-11.897 6.868c-10.204 5.892-13.7 18.94-7.809 29.145 5.892 10.204 18.94 13.7 29.144 7.809l23.9-13.799a61.34 61.34 0 0 0 30.668-53.118v-27.597c0-11.783-9.552-21.335-21.335-21.335s-21.335 9.552-21.335 21.335v13.739l-27.668-15.975c-10.205-5.891-23.253-2.395-29.145 7.81ZM218.665 288v-48h42.67v48c0 11.783-9.552 21.335-21.335 21.335s-21.335-9.552-21.335-21.335",
    clipRule: "evenodd"
  })), _path2$36 || (_path2$36 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M218.665 292v-52h42.67v52c0 11.783-9.552 21.335-21.335 21.335s-21.335-9.552-21.335-21.335",
    clipRule: "evenodd"
  })), _path3$l || (_path3$l = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m295.668 232.476-45.034 26-21.335-36.953 45.034-26c10.204-5.892 23.252-2.395 29.144 7.809s2.395 23.253-7.809 29.144",
    clipRule: "evenodd"
  })), _path4$5 || (_path4$5 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m184.333 232.476 45.033 26 21.335-36.953-45.033-26c-10.204-5.892-23.253-2.395-29.144 7.809-5.892 10.205-2.395 23.253 7.809 29.144",
    clipRule: "evenodd"
  })));
};

var _path$9j, _path2$35, _path3$k, _path4$4;
function _extends$9q() { return _extends$9q = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$9q.apply(null, arguments); }
var SvgCubeOpen24 = function SvgCubeOpen24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9q({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 480 480"
  }, props), _path$9j || (_path$9j = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M95 177.177v25.994c0 9.941-8.059 18-18 18s-18-8.059-18-18v-34.077a58 58 0 0 1 29-50.229l23.901-13.799c8.61-4.971 19.618-2.021 24.589 6.588 4.97 8.609 2.021 19.618-6.589 24.589L113 146l29.207 16.863c8.609 4.97 11.559 15.979 6.588 24.588s-15.979 11.559-24.588 6.588zm-18 88.132c-9.941 0-18 8.059-18 18v27.598a58 58 0 0 0 29 50.229l23.9 13.799c8.609 4.97 19.618 2.02 24.588-6.589s2.021-19.618-6.588-24.588l-16.9-9.757 32.671-18.863c8.609-4.97 11.559-15.979 6.588-24.588s-15.979-11.559-24.588-6.589L95 302.824v-19.515c0-9.941-8.059-18-18-18M180.325 86.346c4.97 8.61 15.979 11.559 24.588 6.588l16.9-9.757v35.756c0 9.941 8.059 18 18 18s18-8.059 18-18V83.177l16.9 9.757c8.609 4.971 19.618 2.021 24.588-6.588s2.021-19.618-6.588-24.589l-23.9-13.798a58 58 0 0 0-58 0l-23.9 13.798c-8.609 4.971-11.559 15.98-6.588 24.589m-11.221 300.831c-4.97 8.609-2.021 19.618 6.589 24.588l35.12 20.277a58 58 0 0 0 58 0l35.12-20.277c8.61-4.97 11.559-15.979 6.589-24.588-4.971-8.61-15.979-11.559-24.589-6.589l-28.12 16.236V361.13c0-9.941-8.059-18-18-18s-18 8.059-18 18v35.694l-28.12-16.236c-8.61-4.97-19.618-2.02-24.589 6.589m174.029-275.525c-4.97 8.61-2.021 19.618 6.589 24.589l16.904 9.76-29.207 16.862c-8.609 4.971-11.559 15.979-6.588 24.589s15.979 11.559 24.589 6.588l29.206-16.862v25.995c0 9.941 8.058 18 18 18s18-8.059 18-18v-34.078a58 58 0 0 0-29-50.23l-23.904-13.801c-8.61-4.971-19.618-2.021-24.589 6.588M327.367 290.55c-4.971 8.609-2.021 19.618 6.588 24.588l32.67 18.863-16.899 9.757c-8.609 4.97-11.559 15.979-6.589 24.588 4.971 8.609 15.98 11.559 24.589 6.588l23.9-13.798a58 58 0 0 0 29-50.23v-27.597c0-9.941-8.059-18-18-18s-18 8.059-18 18v19.515l-32.671-18.862c-8.609-4.971-19.618-2.021-24.588 6.588M222 288v-48h36v48c0 9.942-8.059 18-18 18s-18-8.058-18-18",
    clipRule: "evenodd"
  })), _path2$35 || (_path2$35 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m290.569 231.589-41.569 24-18-31.177 41.569-24c8.609-4.971 19.618-2.021 24.589 6.588 4.97 8.609 2.02 19.618-6.589 24.589",
    clipRule: "evenodd"
  })), _path3$k || (_path3$k = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m189.43 231.589 41.57 24 18-31.177-41.57-24c-8.609-4.971-19.617-2.021-24.588 6.588s-2.021 19.618 6.588 24.589",
    clipRule: "evenodd"
  })), _path4$4 || (_path4$4 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M222 288v-48h36v48c0 9.942-8.059 18-18 18s-18-8.058-18-18",
    clipRule: "evenodd"
  })));
};

var _path$9i, _path2$34, _path3$j, _path4$3;
function _extends$9p() { return _extends$9p = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$9p.apply(null, arguments); }
var SvgCubeOpen32 = function SvgCubeOpen32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9p({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 480 480"
  }, props), _path$9i || (_path$9i = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M92 171.981v31.19c0 8.284-6.716 15-15 15s-15-6.716-15-15v-34.077a55 55 0 0 1 27.5-47.631l23.901-13.799c7.175-4.142 16.349-1.684 20.491 5.49s1.684 16.348-5.491 20.49L107 146l33.707 19.461c7.174 4.142 9.632 13.316 5.49 20.49s-13.316 9.633-20.49 5.49zm-15 96.328c-8.284 0-15 6.716-15 15v27.598a55 55 0 0 0 27.5 47.631l23.9 13.799c7.174 4.142 16.348 1.684 20.49-5.491s1.684-16.348-5.49-20.49L107 334.001l37.171-21.461c7.174-4.142 9.632-13.316 5.49-20.49-4.142-7.175-13.316-9.633-20.49-5.491L92 308.02v-24.711c0-8.284-6.716-15-15-15M182.923 84.846c4.142 7.174 13.316 9.632 20.49 5.49l21.4-12.355v40.952c0 8.285 6.716 15 15 15s15-6.715 15-15V77.981l21.4 12.355c7.174 4.142 16.348 1.684 20.49-5.49s1.684-16.348-5.49-20.49l-23.9-13.799a55 55 0 0 0-55 0l-23.9 13.799c-7.174 4.142-9.632 13.316-5.49 20.49m-11.221 303.831c-4.142 7.174-1.684 16.348 5.491 20.49l35.12 20.277a55 55 0 0 0 55 0l35.12-20.277c7.175-4.142 9.633-13.316 5.491-20.49-4.142-7.175-13.316-9.633-20.491-5.491l-32.62 18.834v-40.89c0-8.284-6.716-15-15-15s-15 6.716-15 15v40.89l-32.62-18.833c-7.175-4.143-16.349-1.684-20.491 5.49m174.029-275.525c-4.142 7.175-1.684 16.349 5.491 20.491l21.404 12.358-33.707 19.46c-7.174 4.142-9.632 13.316-5.49 20.491s13.316 9.632 20.491 5.49l33.706-19.46v31.191c0 8.284 6.715 15 15 15s15-6.716 15-15v-34.078a55 55 0 0 0-27.5-47.632l-23.904-13.801c-7.175-4.142-16.349-1.684-20.491 5.49M329.965 292.05c-4.142 7.174-1.684 16.348 5.49 20.49l37.17 21.461-21.399 12.355c-7.175 4.142-9.633 13.316-5.491 20.49 4.143 7.174 13.316 9.632 20.491 5.49l23.9-13.798a55 55 0 0 0 27.5-47.632v-27.597c0-8.284-6.716-15-15-15-8.285 0-15 6.716-15 15v24.711l-37.171-21.46c-7.174-4.143-16.348-1.684-20.49 5.49M225 288v-48h30v48c0 8.285-6.716 15-15 15s-15-6.715-15-15",
    clipRule: "evenodd"
  })), _path2$34 || (_path2$34 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m289.069 228.991-41.569 24-15-25.981 41.569-24c7.175-4.142 16.348-1.684 20.491 5.49 4.142 7.175 1.684 16.348-5.491 20.491",
    clipRule: "evenodd"
  })), _path3$j || (_path3$j = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m190.93 228.991 41.57 24 15-25.981-41.57-24c-7.174-4.142-16.348-1.684-20.49 5.49s-1.684 16.348 5.49 20.491",
    clipRule: "evenodd"
  })), _path4$3 || (_path4$3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M225 288v-48h30v48c0 8.285-6.716 15-15 15s-15-6.715-15-15",
    clipRule: "evenodd"
  })));
};

var _path$9h, _path2$33, _path3$i, _path4$2;
function _extends$9o() { return _extends$9o = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$9o.apply(null, arguments); }
var SvgCubeOpen48 = function SvgCubeOpen48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9o({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none",
    viewBox: "0 0 480 480"
  }, props), _path$9h || (_path$9h = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M101.091 146.053a28 28 0 0 1 1.909-1.207l23.901-13.8c5.74-3.313 7.706-10.652 4.393-16.392-3.314-5.739-10.653-7.706-16.393-4.392l-23.9 13.799a52 52 0 0 0-26 45.033v34.077c0 6.627 5.372 12 12 12 6.626 0 12-5.373 12-12v-34.077q0-1.136.09-2.257l38.116 22.006c5.739 3.314 13.078 1.348 16.392-4.392 3.314-5.739 1.347-13.079-4.392-16.392zM77 271.309c-6.627 0-12 5.373-12 12v27.598a52 52 0 0 0 26 45.033l23.9 13.798c5.739 3.314 13.078 1.348 16.392-4.392 3.314-5.739 1.347-13.078-4.392-16.392L103 335.155a28 28 0 0 1-1.909-1.207l41.58-24.006c5.739-3.314 7.706-10.653 4.392-16.392-3.314-5.74-10.653-7.706-16.392-4.393l-41.58 24.007q-.09-1.121-.091-2.257v-27.598c0-6.627-5.373-12-12-12M185.521 83.346c3.313 5.74 10.653 7.706 16.392 4.392l23.9-13.798a28 28 0 0 1 2-1.05v46.043c0 6.628 5.372 12 12 12 6.627 0 12-5.372 12-12V72.89q1.016.481 2 1.05l23.9 13.798c5.739 3.314 13.078 1.347 16.392-4.392s1.347-13.079-4.392-16.392l-23.9-13.799a52 52 0 0 0-52 0l-23.9 13.799c-5.739 3.313-7.706 10.653-4.392 16.392M174.3 390.177c-3.313 5.739-1.347 13.079 4.393 16.392l35.12 20.277a52 52 0 0 0 52 0l35.12-20.277c5.74-3.314 7.706-10.653 4.393-16.392-3.314-5.74-10.653-7.706-16.393-4.393l-35.12 20.277q-.984.568-2 1.05V361.13c0-6.627-5.373-12-12-12s-12 5.373-12 12v45.981a28 28 0 0 1-2-1.05l-35.12-20.276c-5.74-3.314-13.079-1.348-16.393 4.392m174.029-275.525c-3.313 5.74-1.347 13.079 4.393 16.393l23.904 13.801q.984.567 1.909 1.207l-38.116 22.006c-5.739 3.314-7.706 10.653-4.392 16.393 3.314 5.739 10.653 7.706 16.392 4.392l38.116-22.006q.09 1.12.091 2.256v34.079c0 6.627 5.372 12 12 12 6.627 0 12-5.373 12-12v-34.079a52 52 0 0 0-26-45.033l-23.904-13.801c-5.74-3.314-13.079-1.347-16.393 4.392M332.563 293.55c-3.314 5.74-1.347 13.079 4.392 16.392l41.579 24.006q-.925.64-1.908 1.207l-23.9 13.799c-5.74 3.313-7.706 10.652-4.392 16.392 3.313 5.739 10.652 7.706 16.392 4.392l23.9-13.798a52 52 0 0 0 26-45.034v-27.597c0-6.627-5.373-12-12-12-6.628 0-12 5.373-12 12v27.597q0 1.137-.091 2.258l-41.58-24.006c-5.739-3.314-13.079-1.348-16.392 4.392M228 288v-48h24v48c0 6.628-5.373 12-12 12-6.628 0-12-5.372-12-12",
    clipRule: "evenodd"
  })), _path2$33 || (_path2$33 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m287.569 226.392-41.569 24-12-20.784 41.569-24c5.74-3.314 13.079-1.347 16.393 4.392s1.347 13.079-4.393 16.392",
    clipRule: "evenodd"
  })), _path3$i || (_path3$i = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m192.43 226.392 41.57 24 12-20.784-41.57-24c-5.739-3.314-13.078-1.347-16.392 4.392s-1.347 13.079 4.392 16.392",
    clipRule: "evenodd"
  })), _path4$2 || (_path4$2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M228 288v-48h24v48c0 6.628-5.373 12-12 12-6.628 0-12-5.372-12-12",
    clipRule: "evenodd"
  })));
};

var CubeOpenIcon = function CubeOpenIcon(props) {
  var cubeOpen = {
    12: SvgCubeOpen12,
    16: SvgCubeOpen16,
    18: SvgCubeOpen18,
    24: SvgCubeOpen24,
    32: SvgCubeOpen32,
    48: SvgCubeOpen48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: cubeOpen
  }, props));
};

var _path$9g, _path2$32;
function _extends$9n() { return _extends$9n = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$9n.apply(null, arguments); }
var SvgDataList12 = function SvgDataList12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9n({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$9g || (_path$9g = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M9 2.2H3a.3.3 0 0 0-.3.3v7a.3.3 0 0 0 .3.3h3.5A2.8 2.8 0 0 0 9.3 7V2.5a.3.3 0 0 0-.3-.3M3 1a1.5 1.5 0 0 0-1.5 1.5v7A1.5 1.5 0 0 0 3 11h3.5a4 4 0 0 0 4-4V2.5A1.5 1.5 0 0 0 9 1z",
    clipRule: "evenodd"
  })), _path2$32 || (_path2$32 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M4 4.4a.6.6 0 0 1 .6-.6h2.8a.6.6 0 0 1 0 1.2H4.6a.6.6 0 0 1-.6-.6M4 6.9a.6.6 0 0 1 .6-.6h1.8a.6.6 0 0 1 0 1.2H4.6a.6.6 0 0 1-.6-.6",
    clipRule: "evenodd"
  })));
};

var _path$9f, _path2$31;
function _extends$9m() { return _extends$9m = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$9m.apply(null, arguments); }
var SvgDataList16 = function SvgDataList16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9m({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$9f || (_path$9f = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M12 2.833H4a.5.5 0 0 0-.5.5v9.334a.5.5 0 0 0 .5.5h4.667A3.833 3.833 0 0 0 12.5 9.333v-6a.5.5 0 0 0-.5-.5m-8-1.5a2 2 0 0 0-2 2v9.334a2 2 0 0 0 2 2h4.667A5.333 5.333 0 0 0 14 9.333v-6a2 2 0 0 0-2-2z",
    clipRule: "evenodd"
  })), _path2$31 || (_path2$31 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M5.333 6.25a.75.75 0 0 1 .75-.75h3.834a.75.75 0 1 1 0 1.5H6.083a.75.75 0 0 1-.75-.75M5.333 9.75a.75.75 0 0 1 .75-.75h2.5a.75.75 0 1 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75",
    clipRule: "evenodd"
  })));
};

var _path$9e, _path2$30;
function _extends$9l() { return _extends$9l = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$9l.apply(null, arguments); }
var SvgDataList18 = function SvgDataList18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9l({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$9e || (_path$9e = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M13.5 3.1h-9a.65.65 0 0 0-.65.65v10.5c0 .359.291.65.65.65h5.25a4.4 4.4 0 0 0 4.4-4.4V3.75a.65.65 0 0 0-.65-.65m-9-1.6a2.25 2.25 0 0 0-2.25 2.25v10.5A2.25 2.25 0 0 0 4.5 16.5h5.25a6 6 0 0 0 6-6V3.75A2.25 2.25 0 0 0 13.5 1.5z",
    clipRule: "evenodd"
  })), _path2$30 || (_path2$30 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M6 5.8a.8.8 0 0 1 .8-.8h4.4a.8.8 0 0 1 0 1.6H6.8a.8.8 0 0 1-.8-.8M6 8.8a.8.8 0 0 1 .8-.8h4.4a.8.8 0 0 1 0 1.6H6.8a.8.8 0 0 1-.8-.8M6 11.8a.8.8 0 0 1 .8-.8h2.9a.8.8 0 0 1 0 1.6H6.8a.8.8 0 0 1-.8-.8",
    clipRule: "evenodd"
  })));
};

var _path$9d, _path2$2$;
function _extends$9k() { return _extends$9k = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$9k.apply(null, arguments); }
var SvgDataList24 = function SvgDataList24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9k({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$9d || (_path$9d = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M18 3.8H6A1.2 1.2 0 0 0 4.8 5v14A1.2 1.2 0 0 0 6 20.2h7a6.2 6.2 0 0 0 6.2-6.2V5A1.2 1.2 0 0 0 18 3.8M6 2a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h7a8 8 0 0 0 8-8V5a3 3 0 0 0-3-3z",
    clipRule: "evenodd"
  })), _path2$2$ || (_path2$2$ = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8 7.6a.9.9 0 0 1 .9-.9h6.2a.9.9 0 1 1 0 1.8H8.9a.9.9 0 0 1-.9-.9M8 11.6a.9.9 0 0 1 .9-.9h6.2a.9.9 0 1 1 0 1.8H8.9a.9.9 0 0 1-.9-.9M8 15.6a.9.9 0 0 1 .9-.9h4.2a.9.9 0 1 1 0 1.8H8.9a.9.9 0 0 1-.9-.9",
    clipRule: "evenodd"
  })));
};

var _path$9c, _path2$2_;
function _extends$9j() { return _extends$9j = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$9j.apply(null, arguments); }
var SvgDataList32 = function SvgDataList32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9j({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$9c || (_path$9c = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M24 4.667H8a2 2 0 0 0-2 2v18.666a2 2 0 0 0 2 2h9.333A8.667 8.667 0 0 0 26 18.667v-12a2 2 0 0 0-2-2m-16-2a4 4 0 0 0-4 4v18.666a4 4 0 0 0 4 4h9.333C23.224 29.333 28 24.558 28 18.667v-12a4 4 0 0 0-4-4z",
    clipRule: "evenodd"
  })), _path2$2_ || (_path2$2_ = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M10.667 10.333a1 1 0 0 1 1-1h8.666a1 1 0 1 1 0 2h-8.666a1 1 0 0 1-1-1M10.667 15.667a1 1 0 0 1 1-1h8.666a1 1 0 0 1 0 2h-8.666a1 1 0 0 1-1-1M10.667 21a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2h-6a1 1 0 0 1-1-1",
    clipRule: "evenodd"
  })));
};

var _path$9b, _path2$2Z;
function _extends$9i() { return _extends$9i = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$9i.apply(null, arguments); }
var SvgDataList48 = function SvgDataList48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9i({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$9b || (_path$9b = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M36 6.4H12A3.6 3.6 0 0 0 8.4 10v28a3.6 3.6 0 0 0 3.6 3.6h14c7.511 0 13.6-6.089 13.6-13.6V10A3.6 3.6 0 0 0 36 6.4M12 4a6 6 0 0 0-6 6v28a6 6 0 0 0 6 6h14c8.837 0 16-7.163 16-16V10a6 6 0 0 0-6-6z",
    clipRule: "evenodd"
  })), _path2$2Z || (_path2$2Z = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M16 15.8a1.2 1.2 0 0 1 1.2-1.2h13.6a1.2 1.2 0 0 1 0 2.4H17.2a1.2 1.2 0 0 1-1.2-1.2M16 23.8a1.2 1.2 0 0 1 1.2-1.2h13.6a1.2 1.2 0 0 1 0 2.4H17.2a1.2 1.2 0 0 1-1.2-1.2M16 31.8a1.2 1.2 0 0 1 1.2-1.2h9.6a1.2 1.2 0 0 1 0 2.4h-9.6a1.2 1.2 0 0 1-1.2-1.2",
    clipRule: "evenodd"
  })));
};

var DataListIcon = function DataListIcon(props) {
  var dataList = {
    12: SvgDataList12,
    16: SvgDataList16,
    18: SvgDataList18,
    24: SvgDataList24,
    32: SvgDataList32,
    48: SvgDataList48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: dataList
  }, props));
};

var _path$9a;
function _extends$9h() { return _extends$9h = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$9h.apply(null, arguments); }
var SvgDataListFilled12 = function SvgDataListFilled12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9h({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$9a || (_path$9a = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M1.5 2a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v5a4 4 0 0 1-4 4h-4a1 1 0 0 1-1-1zM4 4.4a.6.6 0 0 1 .6-.6h2.8a.6.6 0 0 1 0 1.2H4.6a.6.6 0 0 1-.6-.6m.6 2a.6.6 0 0 0 0 1.2h1.8a.6.6 0 0 0 0-1.2z",
    clipRule: "evenodd"
  })));
};

var _path$99;
function _extends$9g() { return _extends$9g = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$9g.apply(null, arguments); }
var SvgDataListFilled16 = function SvgDataListFilled16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9g({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$99 || (_path$99 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M2 2.667c0-.737.597-1.334 1.333-1.334h9.334c.736 0 1.333.597 1.333 1.334v6.666a5.333 5.333 0 0 1-5.333 5.334H3.333A1.333 1.333 0 0 1 2 13.333zM5.334 6.25a.75.75 0 0 1 .75-.75h3.833a.75.75 0 0 1 0 1.5H6.084a.75.75 0 0 1-.75-.75m.75 2.85a.75.75 0 1 0 0 1.5h2.5a.75.75 0 0 0 0-1.5z",
    clipRule: "evenodd"
  })));
};

var _path$98;
function _extends$9f() { return _extends$9f = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$9f.apply(null, arguments); }
var SvgDataListFilled18 = function SvgDataListFilled18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9f({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$98 || (_path$98 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M4 1.5a1.75 1.75 0 0 0-1.75 1.75v11.5c0 .966.784 1.75 1.75 1.75h5.75a6 6 0 0 0 6-6V3.25A1.75 1.75 0 0 0 14 1.5zm2.7 3.475a.7.7 0 1 0 0 1.4h4.6a.7.7 0 1 0 0-1.4zm-.7 3.7a.7.7 0 0 1 .7-.7h4.6a.7.7 0 1 1 0 1.4H6.7a.7.7 0 0 1-.7-.7m.7 2.3a.7.7 0 1 0 0 1.4h3.1a.7.7 0 1 0 0-1.4z",
    clipRule: "evenodd"
  })));
};

var _path$97;
function _extends$9e() { return _extends$9e = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$9e.apply(null, arguments); }
var SvgDataListFilled24 = function SvgDataListFilled24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9e({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$97 || (_path$97 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M5 2a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h8a8 8 0 0 0 8-8V4a2 2 0 0 0-2-2zm3.9 4.7a.9.9 0 1 0 0 1.8h6.2a.9.9 0 1 0 0-1.8zM8 11.6a.9.9 0 0 1 .9-.9h6.2a.9.9 0 1 1 0 1.8H8.9a.9.9 0 0 1-.9-.9m.9 3.1a.9.9 0 1 0 0 1.8h4.2a.9.9 0 1 0 0-1.8z",
    clipRule: "evenodd"
  })));
};

var _path$96;
function _extends$9d() { return _extends$9d = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$9d.apply(null, arguments); }
var SvgDataListFilled32 = function SvgDataListFilled32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9d({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$96 || (_path$96 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M6.667 2.667A2.667 2.667 0 0 0 4 5.333v21.334a2.667 2.667 0 0 0 2.667 2.666h10.666C23.224 29.333 28 24.558 28 18.667V5.333a2.667 2.667 0 0 0-2.667-2.666zm5 6.666a1 1 0 1 0 0 2h8.666a1 1 0 1 0 0-2zm-1 6.334a1 1 0 0 1 1-1h8.666a1 1 0 0 1 0 2h-8.666a1 1 0 0 1-1-1m1 4.333a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2z",
    clipRule: "evenodd"
  })));
};

var _path$95;
function _extends$9c() { return _extends$9c = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$9c.apply(null, arguments); }
var SvgDataListFilled48 = function SvgDataListFilled48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9c({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$95 || (_path$95 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M10 4a4 4 0 0 0-4 4v32a4 4 0 0 0 4 4h16c8.837 0 16-7.163 16-16V8a4 4 0 0 0-4-4zm7.2 10.6a1.2 1.2 0 0 0 0 2.4h13.6a1.2 1.2 0 0 0 0-2.4zM16 23.8a1.2 1.2 0 0 1 1.2-1.2h13.6a1.2 1.2 0 0 1 0 2.4H17.2a1.2 1.2 0 0 1-1.2-1.2m1.2 6.8a1.2 1.2 0 0 0 0 2.4h9.6a1.2 1.2 0 0 0 0-2.4z",
    clipRule: "evenodd"
  })));
};

var DataListFilledIcon = function DataListFilledIcon(props) {
  var dataListFilled = {
    12: SvgDataListFilled12,
    16: SvgDataListFilled16,
    18: SvgDataListFilled18,
    24: SvgDataListFilled24,
    32: SvgDataListFilled32,
    48: SvgDataListFilled48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: dataListFilled
  }, props));
};

var _path$94, _path2$2Y;
function _extends$9b() { return _extends$9b = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$9b.apply(null, arguments); }
var SvgDelete12 = function SvgDelete12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9b({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$94 || (_path$94 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M4.5.9a.6.6 0 1 0 0 1.2h3a.6.6 0 0 0 0-1.2z"
  })), _path2$2Y || (_path2$2Y = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M.9 3.5a.6.6 0 0 1 .6-.6h9a.6.6 0 1 1 0 1.2H10v5.4A1.5 1.5 0 0 1 8.5 11h-5A1.5 1.5 0 0 1 2 9.5V4.1h-.5a.6.6 0 0 1-.6-.6m2.3.6h5.6v5.4a.3.3 0 0 1-.3.3h-5a.3.3 0 0 1-.3-.3z",
    clipRule: "evenodd"
  })));
};

var _path$93, _path2$2X;
function _extends$9a() { return _extends$9a = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$9a.apply(null, arguments); }
var SvgDelete16 = function SvgDelete16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9a({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$93 || (_path$93 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M6 1.25a.75.75 0 0 0 0 1.5h4a.75.75 0 0 0 0-1.5zM6.333 6.361a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0v-4a.75.75 0 0 1 .75-.75M10.417 7.111a.75.75 0 1 0-1.5 0v4a.75.75 0 0 0 1.5 0z"
  })), _path2$2X || (_path2$2X = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M1.25 4.333a.75.75 0 0 1 .75-.75h12a.75.75 0 0 1 0 1.5h-.667v7.584a2 2 0 0 1-2 2H4.667a2 2 0 0 1-2-2V5.083H2a.75.75 0 0 1-.75-.75m10.583.9H4.167v7.434a.5.5 0 0 0 .5.5h6.666a.5.5 0 0 0 .5-.5z",
    clipRule: "evenodd"
  })));
};

var _path$92, _path2$2W;
function _extends$99() { return _extends$99 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$99.apply(null, arguments); }
var SvgDelete18 = function SvgDelete18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$99({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$92 || (_path$92 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M6.75 1.45a.8.8 0 1 0 0 1.6h4.5a.8.8 0 0 0 0-1.6zM7.125 7.2a.8.8 0 0 1 .8.8v4.5a.8.8 0 0 1-1.6 0V8a.8.8 0 0 1 .8-.8M11.675 8a.8.8 0 0 0-1.6 0v4.5a.8.8 0 1 0 1.6 0z"
  })), _path2$2W || (_path2$2W = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M1.45 4.875a.8.8 0 0 1 .8-.8h13.5a.8.8 0 0 1 0 1.6H15v8.575a2.25 2.25 0 0 1-2.25 2.25h-7.5A2.25 2.25 0 0 1 3 14.25V5.675h-.75a.8.8 0 0 1-.8-.8M13.4 5.8H4.6v8.45c0 .359.291.65.65.65h7.5a.65.65 0 0 0 .65-.65z",
    clipRule: "evenodd"
  })));
};

var _path$91, _path2$2V;
function _extends$98() { return _extends$98 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$98.apply(null, arguments); }
var SvgDelete24 = function SvgDelete24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$98({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$91 || (_path$91 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M9 2.1a.9.9 0 1 0 0 1.8h6a.9.9 0 1 0 0-1.8zM9.5 9.1a.9.9 0 0 1 .9.9v7.5a.9.9 0 1 1-1.8 0V10a.9.9 0 0 1 .9-.9M15.4 10a.9.9 0 1 0-1.8 0v7.5a.9.9 0 1 0 1.8 0z"
  })), _path2$2V || (_path2$2V = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M2.1 6.5a.9.9 0 0 1 .9-.9h18a.9.9 0 1 1 0 1.8h-1V19a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V7.4H3a.9.9 0 0 1-.9-.9m3.7.9h12.4V19a1.2 1.2 0 0 1-1.2 1.2H7A1.2 1.2 0 0 1 5.8 19z",
    clipRule: "evenodd"
  })));
};

var _path$90, _path2$2U;
function _extends$97() { return _extends$97 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$97.apply(null, arguments); }
var SvgDelete32 = function SvgDelete32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$97({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$90 || (_path$90 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M12 3a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2zM12.667 12.333a1 1 0 0 1 1 1v10a1 1 0 1 1-2 0v-10a1 1 0 0 1 1-1M20.333 13.333a1 1 0 0 0-2 0v10a1 1 0 1 0 2 0z"
  })), _path2$2U || (_path2$2U = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M3 8.5a1 1 0 0 1 1-1h24a1 1 0 1 1 0 2h-1.333v15.833a4 4 0 0 1-4 4H9.333a4 4 0 0 1-4-4V9.5H4a1 1 0 0 1-1-1m4.333 1h17.334v15.833a2 2 0 0 1-2 2H9.333a2 2 0 0 1-2-2z",
    clipRule: "evenodd"
  })));
};

var _path$8$, _path2$2T;
function _extends$96() { return _extends$96 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$96.apply(null, arguments); }
var SvgDelete48 = function SvgDelete48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$96({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$8$ || (_path$8$ = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M18 4.8a1.2 1.2 0 0 0 0 2.4h12a1.2 1.2 0 1 0 0-2.4zM19 18.8a1.2 1.2 0 0 1 1.2 1.2v15a1.2 1.2 0 1 1-2.4 0V20a1.2 1.2 0 0 1 1.2-1.2M30.2 20a1.2 1.2 0 1 0-2.4 0v15a1.2 1.2 0 1 0 2.4 0z"
  })), _path2$2T || (_path2$2T = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M4.8 12A1.2 1.2 0 0 1 6 10.8h36a1.2 1.2 0 1 1 0 2.4h-2V38a6 6 0 0 1-6 6H14a6 6 0 0 1-6-6V13.2H6A1.2 1.2 0 0 1 4.8 12m32.8 1.3H10.4V38a3.6 3.6 0 0 0 3.6 3.6h20a3.6 3.6 0 0 0 3.6-3.6z",
    clipRule: "evenodd"
  })));
};

var DeleteIcon = function DeleteIcon(props) {
  var deleteIcon = {
    12: SvgDelete12,
    16: SvgDelete16,
    18: SvgDelete18,
    24: SvgDelete24,
    32: SvgDelete32,
    48: SvgDelete48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: deleteIcon
  }, props));
};

var _path$8_;
function _extends$95() { return _extends$95 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$95.apply(null, arguments); }
var SvgDeleteFilled12 = function SvgDeleteFilled12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$95({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$8_ || (_path$8_ = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M4.5.9a.6.6 0 1 0 0 1.2h3a.6.6 0 0 0 0-1.2zM.9 3.5a.6.6 0 0 1 .6-.6h9a.6.6 0 1 1 0 1.2H10v5.4A1.5 1.5 0 0 1 8.5 11h-5A1.5 1.5 0 0 1 2 9.5V4.1h-.5a.6.6 0 0 1-.6-.6"
  })));
};

var _path$8Z, _path2$2S;
function _extends$94() { return _extends$94 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$94.apply(null, arguments); }
var SvgDeleteFilled16 = function SvgDeleteFilled16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$94({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$8Z || (_path$8Z = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M5.25 2A.75.75 0 0 1 6 1.25h4a.75.75 0 0 1 0 1.5H6A.75.75 0 0 1 5.25 2"
  })), _path2$2S || (_path2$2S = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M1.25 4.333a.75.75 0 0 1 .75-.75h12a.75.75 0 0 1 0 1.5h-.667v7.584a2 2 0 0 1-2 2H4.667a2 2 0 0 1-2-2V5.083H2a.75.75 0 0 1-.75-.75m5.833 2.778a.75.75 0 1 0-1.5 0v4a.75.75 0 0 0 1.5 0zm2.584-.75a.75.75 0 0 1 .75.75v4a.75.75 0 1 1-1.5 0v-4a.75.75 0 0 1 .75-.75",
    clipRule: "evenodd"
  })));
};

var _path$8Y, _path2$2R;
function _extends$93() { return _extends$93 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$93.apply(null, arguments); }
var SvgDeleteFilled18 = function SvgDeleteFilled18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$93({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$8Y || (_path$8Y = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M5.95 2.25a.8.8 0 0 1 .8-.8h4.5a.8.8 0 0 1 0 1.6h-4.5a.8.8 0 0 1-.8-.8"
  })), _path2$2R || (_path2$2R = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M1.45 4.875a.8.8 0 0 1 .8-.8h13.5a.8.8 0 0 1 0 1.6H15v8.575a2.25 2.25 0 0 1-2.25 2.25h-7.5A2.25 2.25 0 0 1 3 14.25V5.675h-.75a.8.8 0 0 1-.8-.8M7.925 8a.8.8 0 0 0-1.6 0v4.5a.8.8 0 0 0 1.6 0zm2.95-.8a.8.8 0 0 1 .8.8v4.5a.8.8 0 0 1-1.6 0V8a.8.8 0 0 1 .8-.8",
    clipRule: "evenodd"
  })));
};

var _path$8X, _path2$2Q;
function _extends$92() { return _extends$92 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$92.apply(null, arguments); }
var SvgDeleteFilled24 = function SvgDeleteFilled24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$92({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$8X || (_path$8X = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M9 2.1a.9.9 0 1 0 0 1.8h6a.9.9 0 1 0 0-1.8z"
  })), _path2$2Q || (_path2$2Q = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M2.1 6.5a.9.9 0 0 1 .9-.9h18a.9.9 0 1 1 0 1.8h-1V19a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V7.4H3a.9.9 0 0 1-.9-.9m7.4 2.6a.9.9 0 0 1 .9.9v7.5a.9.9 0 1 1-1.8 0V10a.9.9 0 0 1 .9-.9m5.9.9a.9.9 0 1 0-1.8 0v7.5a.9.9 0 1 0 1.8 0z",
    clipRule: "evenodd"
  })));
};

var _path$8W, _path2$2P;
function _extends$91() { return _extends$91 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$91.apply(null, arguments); }
var SvgDeleteFilled32 = function SvgDeleteFilled32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$91({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$8W || (_path$8W = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M12 3a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2z"
  })), _path2$2P || (_path2$2P = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M3 8.5a1 1 0 0 1 1-1h24a1 1 0 1 1 0 2h-1.333v15.833a4 4 0 0 1-4 4H9.333a4 4 0 0 1-4-4V9.5H4a1 1 0 0 1-1-1m9.667 3.833a1 1 0 0 1 1 1v10a1 1 0 1 1-2 0v-10a1 1 0 0 1 1-1m7.666 1a1 1 0 0 0-2 0v10a1 1 0 1 0 2 0z",
    clipRule: "evenodd"
  })));
};

var _path$8V, _path2$2O;
function _extends$90() { return _extends$90 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$90.apply(null, arguments); }
var SvgDeleteFilled48 = function SvgDeleteFilled48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$90({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$8V || (_path$8V = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M18 4.8a1.2 1.2 0 0 0 0 2.4h12a1.2 1.2 0 0 0 0-2.4z"
  })), _path2$2O || (_path2$2O = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M4.8 12A1.2 1.2 0 0 1 6 10.8h36a1.2 1.2 0 0 1 0 2.4h-2V38a6 6 0 0 1-6 6H14a6 6 0 0 1-6-6V13.2H6A1.2 1.2 0 0 1 4.8 12M19 18.8a1.2 1.2 0 0 1 1.2 1.2v15a1.2 1.2 0 1 1-2.4 0V20a1.2 1.2 0 0 1 1.2-1.2M30.2 20a1.2 1.2 0 0 0-2.4 0v15a1.2 1.2 0 1 0 2.4 0z",
    clipRule: "evenodd"
  })));
};

var DeleteFilledIcon = function DeleteFilledIcon(props) {
  var deleteFilled = {
    12: SvgDeleteFilled12,
    16: SvgDeleteFilled16,
    18: SvgDeleteFilled18,
    24: SvgDeleteFilled24,
    32: SvgDeleteFilled32,
    48: SvgDeleteFilled48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: deleteFilled
  }, props));
};

var _g$6, _defs$6;
function _extends$8$() { return _extends$8$ = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$8$.apply(null, arguments); }
var SvgDismiss12 = function SvgDismiss12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8$({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _g$6 || (_g$6 = /*#__PURE__*/React.createElement("g", {
    fill: "#2F3438",
    fillRule: "evenodd",
    clipPath: "url(#dismiss_12_svg__a)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.076 1.076a.6.6 0 0 1 .848 0l9 9a.6.6 0 0 1-.848.848l-9-9a.6.6 0 0 1 0-.848"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.924 1.076a.6.6 0 0 0-.848 0l-9 9a.6.6 0 0 0 .848.848l9-9a.6.6 0 0 0 0-.848"
  }))), _defs$6 || (_defs$6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "dismiss_12_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h12v12H0z"
  })))));
};

var _path$8U, _path2$2N;
function _extends$8_() { return _extends$8_ = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$8_.apply(null, arguments); }
var SvgDismiss16 = function SvgDismiss16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8_({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$8U || (_path$8U = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M1.47 1.47a.75.75 0 0 1 1.06 0l12 12a.75.75 0 1 1-1.06 1.06l-12-12a.75.75 0 0 1 0-1.06",
    clipRule: "evenodd"
  })), _path2$2N || (_path2$2N = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M14.53 1.47a.75.75 0 0 0-1.06 0l-12 12a.75.75 0 1 0 1.06 1.06l12-12a.75.75 0 0 0 0-1.06",
    clipRule: "evenodd"
  })));
};

var _path$8T, _path2$2M;
function _extends$8Z() { return _extends$8Z = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$8Z.apply(null, arguments); }
var SvgDismiss18 = function SvgDismiss18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8Z({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$8T || (_path$8T = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M1.684 1.684a.8.8 0 0 1 1.132 0l13.5 13.5a.8.8 0 1 1-1.132 1.132l-13.5-13.5a.8.8 0 0 1 0-1.132",
    clipRule: "evenodd"
  })), _path2$2M || (_path2$2M = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M16.316 1.684a.8.8 0 0 0-1.132 0l-13.5 13.5a.8.8 0 1 0 1.132 1.132l13.5-13.5a.8.8 0 0 0 0-1.132",
    clipRule: "evenodd"
  })));
};

var _path$8S, _path2$2L;
function _extends$8Y() { return _extends$8Y = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$8Y.apply(null, arguments); }
var SvgDismiss24 = function SvgDismiss24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8Y({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$8S || (_path$8S = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M2.364 2.364a.9.9 0 0 1 1.272 0l18 18a.9.9 0 1 1-1.272 1.273l-18-18a.9.9 0 0 1 0-1.273",
    clipRule: "evenodd"
  })), _path2$2L || (_path2$2L = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M21.637 2.364a.9.9 0 0 0-1.273 0l-18 18a.9.9 0 0 0 1.272 1.273l18-18a.9.9 0 0 0 0-1.273",
    clipRule: "evenodd"
  })));
};

var _path$8R, _path2$2K;
function _extends$8X() { return _extends$8X = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$8X.apply(null, arguments); }
var SvgDismiss32 = function SvgDismiss32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8X({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$8R || (_path$8R = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M3.293 3.293a1 1 0 0 1 1.414 0l24 24a1 1 0 0 1-1.414 1.414l-24-24a1 1 0 0 1 0-1.414",
    clipRule: "evenodd"
  })), _path2$2K || (_path2$2K = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M28.707 3.293a1 1 0 0 0-1.414 0l-24 24a1 1 0 1 0 1.414 1.414l24-24a1 1 0 0 0 0-1.414",
    clipRule: "evenodd"
  })));
};

var _path$8Q, _path2$2J;
function _extends$8W() { return _extends$8W = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$8W.apply(null, arguments); }
var SvgDismiss48 = function SvgDismiss48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8W({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$8Q || (_path$8Q = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M5.152 5.152a1.2 1.2 0 0 1 1.697 0l36 36a1.2 1.2 0 0 1-1.697 1.697l-36-36a1.2 1.2 0 0 1 0-1.697",
    clipRule: "evenodd"
  })), _path2$2J || (_path2$2J = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M42.849 5.152a1.2 1.2 0 0 0-1.697 0l-36 36a1.2 1.2 0 0 0 1.697 1.697l36-36a1.2 1.2 0 0 0 0-1.697",
    clipRule: "evenodd"
  })));
};

var DismissIcon = function DismissIcon(props) {
  var dismiss = {
    12: SvgDismiss12,
    16: SvgDismiss16,
    18: SvgDismiss18,
    24: SvgDismiss24,
    32: SvgDismiss32,
    48: SvgDismiss48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: dismiss
  }, props));
};

var _path$8P;
function _extends$8V() { return _extends$8V = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$8V.apply(null, arguments); }
var SvgDismissCircle12 = function SvgDismissCircle12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8V({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$8P || (_path$8P = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M6 1a5 5 0 1 0 0 10A5 5 0 0 0 6 1M4.674 3.826a.6.6 0 1 0-.848.848L5.15 6 3.826 7.326a.6.6 0 1 0 .848.848L6 6.85l1.326 1.325a.6.6 0 1 0 .848-.848L6.85 6l1.325-1.326a.6.6 0 1 0-.848-.848L6 5.15z",
    clipRule: "evenodd"
  })));
};

var _path$8O;
function _extends$8U() { return _extends$8U = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$8U.apply(null, arguments); }
var SvgDismissCircle16 = function SvgDismissCircle16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8U({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$8O || (_path$8O = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8 1.334a6.667 6.667 0 1 0 0 13.333A6.667 6.667 0 0 0 8 1.334M6.197 5.136a.75.75 0 0 0-1.06 1.06L6.938 8 5.136 9.803a.75.75 0 1 0 1.061 1.06L8 9.06l1.803 1.803a.75.75 0 1 0 1.06-1.06L9.062 8l1.803-1.803a.75.75 0 0 0-1.06-1.06L8 6.938z",
    clipRule: "evenodd"
  })));
};

var _path$8N;
function _extends$8T() { return _extends$8T = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$8T.apply(null, arguments); }
var SvgDismissCircle18 = function SvgDismissCircle18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8T({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$8N || (_path$8N = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M9 1.5a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15M6.94 5.81a.8.8 0 0 0-1.13 1.13L7.868 9l-2.06 2.06a.8.8 0 0 0 1.132 1.13L9 10.132l2.06 2.06a.8.8 0 0 0 1.13-1.132L10.132 9l2.06-2.06a.8.8 0 0 0-1.132-1.13L9 7.868z",
    clipRule: "evenodd"
  })));
};

var _path$8M;
function _extends$8S() { return _extends$8S = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$8S.apply(null, arguments); }
var SvgDismissCircle24 = function SvgDismissCircle24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8S({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$8M || (_path$8M = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2M9.136 7.864a.9.9 0 0 0-1.272 1.272L10.727 12l-2.863 2.864a.9.9 0 0 0 1.272 1.272L12 13.273l2.864 2.863a.9.9 0 1 0 1.272-1.272L13.273 12l2.863-2.864a.9.9 0 1 0-1.272-1.272L12 10.727z",
    clipRule: "evenodd"
  })));
};

var _path$8L;
function _extends$8R() { return _extends$8R = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$8R.apply(null, arguments); }
var SvgDismissCircle32 = function SvgDismissCircle32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8R({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$8L || (_path$8L = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M16 2.667C8.636 2.667 2.667 8.636 2.667 16S8.637 29.333 16 29.333 29.333 23.363 29.333 16 23.363 2.667 16 2.667m-3.96 7.96a1 1 0 0 0-1.414 1.414l3.96 3.96-3.96 3.959a1 1 0 0 0 1.414 1.414l3.96-3.96 3.96 3.96a1 1 0 1 0 1.414-1.414L17.414 16l3.96-3.96a1 1 0 0 0-1.415-1.414L16 14.586z",
    clipRule: "evenodd"
  })));
};

var _path$8K;
function _extends$8Q() { return _extends$8Q = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$8Q.apply(null, arguments); }
var SvgDismissCircle48 = function SvgDismissCircle48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8Q({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$8K || (_path$8K = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M24 4C12.954 4 4 12.954 4 24s8.954 20 20 20 20-8.954 20-20S35.046 4 24 4m-6.151 12.151a1.2 1.2 0 1 0-1.698 1.698L22.304 24l-6.152 6.151a1.2 1.2 0 1 0 1.698 1.698L24 25.697l6.151 6.152a1.2 1.2 0 1 0 1.698-1.698L25.697 24l6.152-6.151a1.2 1.2 0 1 0-1.698-1.698L24 22.304z",
    clipRule: "evenodd"
  })));
};

var DismissCircleIcon = function DismissCircleIcon(props) {
  var dismissCircle = {
    12: SvgDismissCircle12,
    16: SvgDismissCircle16,
    18: SvgDismissCircle18,
    24: SvgDismissCircle24,
    32: SvgDismissCircle32,
    48: SvgDismissCircle48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: dismissCircle
  }, props));
};

var _path$8J;
function _extends$8P() { return _extends$8P = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$8P.apply(null, arguments); }
var SvgDownload12 = function SvgDownload12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8P({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$8J || (_path$8J = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M7.826 5.076a.6.6 0 1 1 .848.848l-2.25 2.25a.6.6 0 0 1-.848 0l-2.25-2.25a.6.6 0 0 1 .848-.848L5.4 6.3V2a.6.6 0 0 1 1.2 0V6.3zM2.1 8A.6.6 0 0 0 .9 8v1a1.6 1.6 0 0 0 1.6 1.6h7A1.6 1.6 0 0 0 11.1 9V8a.6.6 0 1 0-1.2 0v1a.4.4 0 0 1-.4.4h-7a.4.4 0 0 1-.4-.4z",
    clipRule: "evenodd"
  })));
};

var _path$8I;
function _extends$8O() { return _extends$8O = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$8O.apply(null, arguments); }
var SvgDownload16 = function SvgDownload16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8O({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$8I || (_path$8I = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M10.47 6.803a.75.75 0 1 1 1.06 1.06l-3 3a.75.75 0 0 1-1.06 0l-3-3a.75.75 0 0 1 1.06-1.06l1.72 1.72V2.667a.75.75 0 0 1 1.5 0v5.856zm-7.72 3.863a.75.75 0 0 0-1.5 0v1.267a2.15 2.15 0 0 0 2.15 2.15h9.2a2.15 2.15 0 0 0 2.15-2.15v-1.267a.75.75 0 0 0-1.5 0v1.267a.65.65 0 0 1-.65.65H3.4a.65.65 0 0 1-.65-.65z",
    clipRule: "evenodd"
  })));
};

var _path$8H;
function _extends$8N() { return _extends$8N = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$8N.apply(null, arguments); }
var SvgDownload18 = function SvgDownload18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8N({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$8H || (_path$8H = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M11.81 7.685a.8.8 0 0 1 1.13 1.13l-3.375 3.376a.8.8 0 0 1-1.13 0L5.058 8.816A.8.8 0 1 1 6.19 7.685L8.2 9.694V3a.8.8 0 0 1 1.6 0v6.694zM3.05 12a.8.8 0 0 0-1.6 0v1.6a2.2 2.2 0 0 0 2.2 2.2h10.7a2.2 2.2 0 0 0 2.2-2.2V12a.8.8 0 0 0-1.6 0v1.6a.6.6 0 0 1-.6.6H3.65a.6.6 0 0 1-.6-.6z",
    clipRule: "evenodd"
  })));
};

var _path$8G;
function _extends$8M() { return _extends$8M = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$8M.apply(null, arguments); }
var SvgDownload24 = function SvgDownload24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8M({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$8G || (_path$8G = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M15.864 10.364a.9.9 0 1 1 1.272 1.272l-4.5 4.5a.9.9 0 0 1-1.272 0l-4.5-4.5a.9.9 0 1 1 1.272-1.272l2.964 2.963V4a.9.9 0 1 1 1.8 0v9.327zM3.9 16a.9.9 0 0 0-1.8 0v2.2a2.7 2.7 0 0 0 2.7 2.7h14.4a2.7 2.7 0 0 0 2.7-2.7V16a.9.9 0 0 0-1.8 0v2.2a.9.9 0 0 1-.9.9H4.8a.9.9 0 0 1-.9-.9z",
    clipRule: "evenodd"
  })));
};

var _path$8F;
function _extends$8L() { return _extends$8L = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$8L.apply(null, arguments); }
var SvgDownload32 = function SvgDownload32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8L({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$8F || (_path$8F = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M21.293 13.96a1 1 0 0 1 1.414 1.414l-6 6a1 1 0 0 1-1.414 0l-6-6a1 1 0 1 1 1.414-1.414L15 18.253V5.333a1 1 0 1 1 2 0v12.92zM5 21.334a1 1 0 1 0-2 0v3.333a3 3 0 0 0 3 3h20a3 3 0 0 0 3-3v-3.334a1 1 0 1 0-2 0v3.334a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1z",
    clipRule: "evenodd"
  })));
};

var _path$8E;
function _extends$8K() { return _extends$8K = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$8K.apply(null, arguments); }
var SvgDownload48 = function SvgDownload48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8K({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$8E || (_path$8E = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M32.152 21.151a1.2 1.2 0 1 1 1.697 1.697l-9 9a1.2 1.2 0 0 1-1.697 0l-9-9a1.2 1.2 0 1 1 1.697-1.697l6.951 6.952V8a1.2 1.2 0 0 1 2.4 0v20.103zM7.2 32a1.2 1.2 0 1 0-2.4 0v5A4.2 4.2 0 0 0 9 41.2h30a4.2 4.2 0 0 0 4.2-4.2v-5a1.2 1.2 0 1 0-2.4 0v5a1.8 1.8 0 0 1-1.8 1.8H9A1.8 1.8 0 0 1 7.2 37z",
    clipRule: "evenodd"
  })));
};

var DownloadIcon = function DownloadIcon(props) {
  var download = {
    12: SvgDownload12,
    16: SvgDownload16,
    18: SvgDownload18,
    24: SvgDownload24,
    32: SvgDownload32,
    48: SvgDownload48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: download
  }, props));
};

var _path$8D;
function _extends$8J() { return _extends$8J = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$8J.apply(null, arguments); }
var SvgDropdownDown12 = function SvgDropdownDown12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8J({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$8D || (_path$8D = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M8.5 5h-5L6 7.5z"
  })));
};

var _path$8C;
function _extends$8I() { return _extends$8I = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$8I.apply(null, arguments); }
var SvgDropdownDown16 = function SvgDropdownDown16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8I({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$8C || (_path$8C = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M11.333 6.667H4.667L8 10z"
  })));
};

var _path$8B;
function _extends$8H() { return _extends$8H = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$8H.apply(null, arguments); }
var SvgDropdownDown18 = function SvgDropdownDown18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8H({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$8B || (_path$8B = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M12.75 7.5h-7.5L9 11.25z"
  })));
};

var _path$8A;
function _extends$8G() { return _extends$8G = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$8G.apply(null, arguments); }
var SvgDropdownDown24 = function SvgDropdownDown24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8G({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$8A || (_path$8A = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M17 10H7l5 5z"
  })));
};

var _path$8z;
function _extends$8F() { return _extends$8F = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$8F.apply(null, arguments); }
var SvgDropdownDown32 = function SvgDropdownDown32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8F({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$8z || (_path$8z = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M22.667 13.334H9.333L16 20z"
  })));
};

var _path$8y;
function _extends$8E() { return _extends$8E = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$8E.apply(null, arguments); }
var SvgDropdownDown48 = function SvgDropdownDown48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8E({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$8y || (_path$8y = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M34 20H14l10 10z"
  })));
};

var DropdownDownIcon = function DropdownDownIcon(props) {
  var dropdownDown = {
    12: SvgDropdownDown12,
    16: SvgDropdownDown16,
    18: SvgDropdownDown18,
    24: SvgDropdownDown24,
    32: SvgDropdownDown32,
    48: SvgDropdownDown48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: dropdownDown
  }, props));
};

var _path$8x;
function _extends$8D() { return _extends$8D = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$8D.apply(null, arguments); }
var SvgDropdownRight12 = function SvgDropdownRight12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8D({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$8x || (_path$8x = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M5 3.5v5L7.5 6z"
  })));
};

var _path$8w;
function _extends$8C() { return _extends$8C = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$8C.apply(null, arguments); }
var SvgDropdownRight16 = function SvgDropdownRight16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8C({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$8w || (_path$8w = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M6.667 4.667v6.667L10 8z"
  })));
};

var _path$8v;
function _extends$8B() { return _extends$8B = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$8B.apply(null, arguments); }
var SvgDropdownRight18 = function SvgDropdownRight18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8B({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$8v || (_path$8v = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M7.5 5.25v7.5L11.25 9z"
  })));
};

var _path$8u;
function _extends$8A() { return _extends$8A = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$8A.apply(null, arguments); }
var SvgDropdownRight24 = function SvgDropdownRight24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8A({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$8u || (_path$8u = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M10 7v10l5-5z"
  })));
};

var _path$8t;
function _extends$8z() { return _extends$8z = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$8z.apply(null, arguments); }
var SvgDropdownRight32 = function SvgDropdownRight32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8z({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$8t || (_path$8t = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M13.333 9.333v13.333L20 16z"
  })));
};

var _path$8s;
function _extends$8y() { return _extends$8y = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$8y.apply(null, arguments); }
var SvgDropdownRight48 = function SvgDropdownRight48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8y({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$8s || (_path$8s = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M20 14v20l10-10z"
  })));
};

var DropdownRightIcon = function DropdownRightIcon(props) {
  var dropdownRight = {
    12: SvgDropdownRight12,
    16: SvgDropdownRight16,
    18: SvgDropdownRight18,
    24: SvgDropdownRight24,
    32: SvgDropdownRight32,
    48: SvgDropdownRight48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: dropdownRight
  }, props));
};

var _path$8r;
function _extends$8x() { return _extends$8x = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$8x.apply(null, arguments); }
var SvgDropdownUp12 = function SvgDropdownUp12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8x({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$8r || (_path$8r = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M3.5 7h5L6 4.5z"
  })));
};

var _path$8q;
function _extends$8w() { return _extends$8w = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$8w.apply(null, arguments); }
var SvgDropdownUp16 = function SvgDropdownUp16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8w({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$8q || (_path$8q = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M4.667 9.334h6.666L8 6z"
  })));
};

var _path$8p;
function _extends$8v() { return _extends$8v = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$8v.apply(null, arguments); }
var SvgDropdownUp18 = function SvgDropdownUp18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8v({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$8p || (_path$8p = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M5.25 10.5h7.5L9 6.75z"
  })));
};

var _path$8o;
function _extends$8u() { return _extends$8u = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$8u.apply(null, arguments); }
var SvgDropdownUp24 = function SvgDropdownUp24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8u({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$8o || (_path$8o = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M7 14h10l-5-5z"
  })));
};

var _path$8n;
function _extends$8t() { return _extends$8t = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$8t.apply(null, arguments); }
var SvgDropdownUp32 = function SvgDropdownUp32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8t({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$8n || (_path$8n = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M9.333 18.667h13.334L16 12z"
  })));
};

var _path$8m;
function _extends$8s() { return _extends$8s = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$8s.apply(null, arguments); }
var SvgDropdownUp48 = function SvgDropdownUp48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8s({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$8m || (_path$8m = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M14 28h20L24 18z"
  })));
};

var DropdownUpIcon = function DropdownUpIcon(props) {
  var dropdownUp = {
    12: SvgDropdownUp12,
    16: SvgDropdownUp16,
    18: SvgDropdownUp18,
    24: SvgDropdownUp24,
    32: SvgDropdownUp32,
    48: SvgDropdownUp48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: dropdownUp
  }, props));
};

var _path$8l;
function _extends$8r() { return _extends$8r = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$8r.apply(null, arguments); }
var SvgExpand12 = function SvgExpand12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8r({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$8l || (_path$8l = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M6.355 2.133a.6.6 0 0 1 .6-.6h2.678a.6.6 0 0 1 .6.6v2.679a.6.6 0 1 1-1.2 0V2.733H6.955a.6.6 0 0 1-.6-.6M2.133 6.355a.6.6 0 0 1 .6.6v2.078h2.079a.6.6 0 0 1 0 1.2H2.133a.6.6 0 0 1-.6-.6V6.955a.6.6 0 0 1 .6-.6",
    clipRule: "evenodd"
  })));
};

var _path$8k;
function _extends$8q() { return _extends$8q = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$8q.apply(null, arguments); }
var SvgExpand16 = function SvgExpand16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8q({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$8k || (_path$8k = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8.871 2.5a.7.7 0 0 1 .7-.7H13.5a.7.7 0 0 1 .7.7v3.928a.7.7 0 1 1-1.4 0V3.2H9.571a.7.7 0 0 1-.7-.7M2.5 8.87a.7.7 0 0 1 .7.7V12.8H6.43a.7.7 0 1 1 0 1.4H2.5a.7.7 0 0 1-.7-.7V9.57a.7.7 0 0 1 .7-.7",
    clipRule: "evenodd"
  })));
};

var _path$8j;
function _extends$8p() { return _extends$8p = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$8p.apply(null, arguments); }
var SvgExpand18 = function SvgExpand18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8p({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$8j || (_path$8j = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M10.107 2.5a.75.75 0 0 1 .75-.75H15.5a.75.75 0 0 1 .75.75v4.643a.75.75 0 0 1-1.5 0V3.25h-3.893a.75.75 0 0 1-.75-.75M2.5 10.107a.75.75 0 0 1 .75.75v3.893h3.893a.75.75 0 0 1 0 1.5H2.5a.75.75 0 0 1-.75-.75v-4.643a.75.75 0 0 1 .75-.75",
    clipRule: "evenodd"
  })));
};

var _path$8i;
function _extends$8o() { return _extends$8o = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$8o.apply(null, arguments); }
var SvgExpand24 = function SvgExpand24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8o({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$8i || (_path$8i = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M13.529 3.5a.9.9 0 0 1 .9-.9H20.5a.9.9 0 0 1 .9.9v6.072a.9.9 0 1 1-1.8 0V4.4H14.43a.9.9 0 0 1-.9-.9M3.5 13.53a.9.9 0 0 1 .9.9V19.6h5.172a.9.9 0 1 1 0 1.8H3.5a.9.9 0 0 1-.9-.9V14.43a.9.9 0 0 1 .9-.9",
    clipRule: "evenodd"
  })));
};

var _path$8h;
function _extends$8n() { return _extends$8n = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$8n.apply(null, arguments); }
var SvgExpand32 = function SvgExpand32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8n({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$8h || (_path$8h = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M18.238 4.667a1 1 0 0 1 1-1h8.095a1 1 0 0 1 1 1v8.095a1 1 0 1 1-2 0V5.667h-7.095a1 1 0 0 1-1-1M4.667 18.237a1 1 0 0 1 1 1v7.096h7.095a1 1 0 1 1 0 2H4.667a1 1 0 0 1-1-1v-8.095a1 1 0 0 1 1-1",
    clipRule: "evenodd"
  })));
};

var _path$8g;
function _extends$8m() { return _extends$8m = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$8m.apply(null, arguments); }
var SvgExpand48 = function SvgExpand48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8m({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$8g || (_path$8g = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M27.657 7a1.2 1.2 0 0 1 1.2-1.2H41A1.2 1.2 0 0 1 42.2 7v12.143a1.2 1.2 0 0 1-2.4 0V8.2H28.857a1.2 1.2 0 0 1-1.2-1.2M7 27.657a1.2 1.2 0 0 1 1.2 1.2V39.8h10.943a1.2 1.2 0 0 1 0 2.4H7A1.2 1.2 0 0 1 5.8 41V28.857a1.2 1.2 0 0 1 1.2-1.2",
    clipRule: "evenodd"
  })));
};

var ExpandIcon = function ExpandIcon(props) {
  var expand = {
    12: SvgExpand12,
    16: SvgExpand16,
    18: SvgExpand18,
    24: SvgExpand24,
    32: SvgExpand32,
    48: SvgExpand48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: expand
  }, props));
};

var _path$8f, _path2$2I;
function _extends$8l() { return _extends$8l = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$8l.apply(null, arguments); }
var SvgExport12 = function SvgExport12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8l({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$8f || (_path$8f = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M2 4.778a.6.6 0 0 1 .6.6v3.389a.9.9 0 0 0 .9.9h5a.9.9 0 0 0 .9-.9v-3.39a.6.6 0 0 1 1.2 0v3.39a2.1 2.1 0 0 1-2.1 2.1h-5a2.1 2.1 0 0 1-2.1-2.1v-3.39a.6.6 0 0 1 .6-.6M6 .885l2.557 2.557a.6.6 0 1 1-.848.849l-1.71-1.71-1.708 1.71a.6.6 0 1 1-.849-.849z",
    clipRule: "evenodd"
  })), _path2$2I || (_path2$2I = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M6 1.85a.6.6 0 0 1 .6.6v3.9a.6.6 0 0 1-1.2 0v-3.9a.6.6 0 0 1 .6-.6",
    clipRule: "evenodd"
  })));
};

var _path$8e, _path2$2H;
function _extends$8k() { return _extends$8k = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$8k.apply(null, arguments); }
var SvgExport16 = function SvgExport16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8k({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$8e || (_path$8e = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M2.667 6.42a.75.75 0 0 1 .75.75v4.519c0 .69.56 1.25 1.25 1.25h6.666c.69 0 1.25-.56 1.25-1.25V7.17a.75.75 0 0 1 1.5 0v4.519a2.75 2.75 0 0 1-2.75 2.75H4.667a2.75 2.75 0 0 1-2.75-2.75V7.17a.75.75 0 0 1 .75-.75M8 1.25l3.375 3.375a.75.75 0 1 1-1.06 1.06L8 3.373 5.686 5.686a.75.75 0 1 1-1.06-1.06z",
    clipRule: "evenodd"
  })), _path2$2H || (_path2$2H = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8 2.517a.75.75 0 0 1 .75.75v5.2a.75.75 0 1 1-1.5 0v-5.2a.75.75 0 0 1 .75-.75",
    clipRule: "evenodd"
  })));
};

var _path$8d, _path2$2G;
function _extends$8j() { return _extends$8j = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$8j.apply(null, arguments); }
var SvgExport18 = function SvgExport18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8j({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$8d || (_path$8d = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M3 7.267a.8.8 0 0 1 .8.8v5.083c0 .801.65 1.45 1.45 1.45h7.5c.8 0 1.45-.649 1.45-1.45V8.067a.8.8 0 1 1 1.6 0v5.083a3.05 3.05 0 0 1-3.05 3.05h-7.5a3.05 3.05 0 0 1-3.05-3.05V8.067a.8.8 0 0 1 .8-.8M9 1.469l3.766 3.765a.8.8 0 0 1-1.132 1.132L9 3.73 6.366 6.366a.8.8 0 1 1-1.132-1.132z",
    clipRule: "evenodd"
  })), _path2$2G || (_path2$2G = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M9 2.875a.8.8 0 0 1 .8.8v5.85a.8.8 0 0 1-1.6 0v-5.85a.8.8 0 0 1 .8-.8",
    clipRule: "evenodd"
  })));
};

var _path$8c, _path2$2F;
function _extends$8i() { return _extends$8i = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$8i.apply(null, arguments); }
var SvgExport24 = function SvgExport24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8i({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$8c || (_path$8c = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M4 9.856a.9.9 0 0 1 .9.9v6.777c0 1.16.94 2.1 2.1 2.1h10a2.1 2.1 0 0 0 2.1-2.1v-6.778a.9.9 0 0 1 1.8 0v6.778a3.9 3.9 0 0 1-3.9 3.9H7a3.9 3.9 0 0 1-3.9-3.9v-6.778a.9.9 0 0 1 .9-.9M12 2.194l4.903 4.903A.9.9 0 0 1 15.63 8.37L12 4.74 8.37 8.37a.9.9 0 0 1-1.273-1.273z",
    clipRule: "evenodd"
  })), _path2$2F || (_path2$2F = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M12 4a.9.9 0 0 1 .9.9v7.8a.9.9 0 0 1-1.8 0V4.9A.9.9 0 0 1 12 4",
    clipRule: "evenodd"
  })));
};

var _path$8b, _path2$2E;
function _extends$8h() { return _extends$8h = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$8h.apply(null, arguments); }
var SvgExport32 = function SvgExport32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8h({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$8b || (_path$8b = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M5.333 13.24a1.1 1.1 0 0 1 1.1 1.1v9.038a2.9 2.9 0 0 0 2.9 2.9h13.334a2.9 2.9 0 0 0 2.9-2.9V14.34a1.1 1.1 0 0 1 2.2 0v9.037a5.1 5.1 0 0 1-5.1 5.1H9.333a5.1 5.1 0 0 1-5.1-5.1V14.34a1.1 1.1 0 0 1 1.1-1.1M16 3.066l6.467 6.467a1.1 1.1 0 1 1-1.556 1.556L16 6.178l-4.911 4.91a1.1 1.1 0 0 1-1.556-1.555z",
    clipRule: "evenodd"
  })), _path2$2E || (_path2$2E = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M16 5.433a1.1 1.1 0 0 1 1.1 1.1v10.4a1.1 1.1 0 0 1-2.2 0v-10.4a1.1 1.1 0 0 1 1.1-1.1",
    clipRule: "evenodd"
  })));
};

var _path$8a, _path2$2D;
function _extends$8g() { return _extends$8g = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$8g.apply(null, arguments); }
var SvgExport48 = function SvgExport48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8g({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$8a || (_path$8a = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8.3 22.116a1.3 1.3 0 0 1 1.3 1.3v13.556a4.7 4.7 0 0 0 4.7 4.7h20a4.7 4.7 0 0 0 4.7-4.7V23.416a1.3 1.3 0 0 1 2.6 0v13.556a7.3 7.3 0 0 1-7.3 7.3h-20a7.3 7.3 0 0 1-7.3-7.3V23.416a1.3 1.3 0 0 1 1.3-1.3M24.3 7l9.452 9.453a1.3 1.3 0 1 1-1.838 1.838L24.3 10.677l-7.614 7.614a1.3 1.3 0 0 1-1.839-1.838z",
    clipRule: "evenodd"
  })), _path2$2D || (_path2$2D = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M24.3 10.405a1.3 1.3 0 0 1 1.3 1.3v15.6a1.3 1.3 0 0 1-2.6 0v-15.6a1.3 1.3 0 0 1 1.3-1.3",
    clipRule: "evenodd"
  })));
};

var ExportIcon = function ExportIcon(props) {
  var exportIcon = {
    12: SvgExport12,
    16: SvgExport16,
    18: SvgExport18,
    24: SvgExport24,
    32: SvgExport32,
    48: SvgExport48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: exportIcon
  }, props));
};

var _path$89;
function _extends$8f() { return _extends$8f = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$8f.apply(null, arguments); }
var SvgFaceSmilingSafetyHelmet12 = function SvgFaceSmilingSafetyHelmet12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8f({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 480 480"
  }, props), _path$89 || (_path$89 = /*#__PURE__*/React.createElement("path", {
    d: "M180 343.3c-7.4-11-4.4-25.9 6.6-33.3s25.9-4.4 33.3 6.6c3.8 5.7 11.7 9.3 20 9.3s16.3-3.7 20-9.3c7.4-11 22.3-14 33.3-6.6s14 22.3 6.6 33.3c-12.8 19.2-35.2 30.7-60 30.7s-47.1-11.5-60-30.7zM464 232c0 13.3-10.7 24-24 24h-24v14c0 97-79 176-176 176S64 367 64 270v-14H40c-13.3 0-24-10.7-24-24s10.7-24 24-24h6.1c2.7-76.8 57.2-140.6 129.6-157.6C183.3 37 197.6 28 214 28h52c16.4 0 30.8 9 38.3 22.4 72.4 16.9 126.9 80.8 129.6 157.6h6.1c13.3 0 24 10.7 24 24M94.1 208h291.7c-2.4-48.1-33.2-88.8-75.9-105.6V162c0 13.3-10.7 24-24 24s-24-10.7-24-24V76h-44v86c0 13.3-10.7 24-24 24s-24-10.7-24-24v-59.6C127.2 119.3 96.4 160 94 208ZM368 256H112v14c0 70.6 57.4 128 128 128s128-57.4 128-128z"
  })));
};

var _path$88;
function _extends$8e() { return _extends$8e = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$8e.apply(null, arguments); }
var SvgFaceSmilingSafetyHelmet16 = function SvgFaceSmilingSafetyHelmet16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8e({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 480 480"
  }, props), _path$88 || (_path$88 = /*#__PURE__*/React.createElement("path", {
    d: "M240 372.5c24.2 0 46.2-11.2 58.7-30 6.9-10.3 4.1-24.3-6.2-31.2s-24.3-4.1-31.2 6.2c-4.1 6.2-12.3 10-21.3 10s-17.2-3.9-21.3-10c-6.9-10.3-20.9-13.1-31.2-6.2s-13.1 20.9-6.2 31.2c12.5 18.8 34.5 30 58.7 30m200-163h-7.6c-2-76.2-55.5-139.7-126.8-157.2-7.1-13.5-21.3-22.8-37.6-22.8h-56c-16.3 0-30.5 9.3-37.6 22.8-71.3 17.5-124.8 81.1-126.8 157.2H40c-12.4 0-22.5 10.1-22.5 22.5s10.1 22.5 22.5 22.5h25.5V270c0 96.2 78.3 174.5 174.5 174.5S414.5 366.2 414.5 270v-15.5H440c12.4 0 22.5-10.1 22.5-22.5s-10.1-22.5-22.5-22.5M169.5 100.9V163c0 12.4 10.1 22.5 22.5 22.5s22.5-10.1 22.5-22.5V74.5h51V163c0 12.4 10.1 22.5 22.5 22.5s22.5-10.1 22.5-22.5v-62.1c43.7 17.3 75.1 59.2 76.9 108.6H92.6c1.8-49.4 33.2-91.3 76.9-108.6m200 169.1c0 71.4-58.1 129.5-129.5 129.5S110.5 341.4 110.5 270v-15.5h259z"
  })));
};

var _path$87;
function _extends$8d() { return _extends$8d = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$8d.apply(null, arguments); }
var SvgFaceSmilingSafetyHelmet18 = function SvgFaceSmilingSafetyHelmet18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8d({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 480 480"
  }, props), _path$87 || (_path$87 = /*#__PURE__*/React.createElement("path", {
    d: "M182.3 341.8c-6.5-9.8-3.9-23 5.9-29.6 9.8-6.5 23-3.9 29.6 5.9 4.3 6.5 12.9 10.5 22.3 10.5s17.9-4 22.3-10.5c6.5-9.8 19.8-12.4 29.6-5.9s12.4 19.8 5.9 29.6c-12.3 18.5-33.9 29.5-57.7 29.5s-45.4-11-57.7-29.5Zm279-109.8c0 11.8-9.6 21.3-21.3 21.3h-26.7V270c0 95.6-77.8 173.3-173.3 173.3S66.7 365.5 66.7 270v-16.7H40c-11.8 0-21.3-9.6-21.3-21.3s9.6-21.3 21.3-21.3h8.7c1.5-76.3 55-140.1 126.5-157.4C182 39.9 196 30.7 212 30.7h56c16.1 0 30 9.2 36.8 22.6 71.5 17.3 124.9 81.1 126.5 157.4h8.7c11.8 0 21.3 9.6 21.3 21.3M91.4 210.7h297.2c-1.4-51-34-94.2-79.3-111.4v65.8c0 11.8-9.6 21.3-21.3 21.3s-21.3-9.6-21.3-21.3V73.4h-53.3v91.7c0 11.8-9.6 21.3-21.3 21.3s-21.3-9.6-21.3-21.3V99.3c-45.3 17.2-77.9 60.5-79.3 111.4Zm279.3 42.6H109.3V270c0 72 58.6 130.7 130.7 130.7S370.7 342.1 370.7 270z"
  })));
};

var _path$86;
function _extends$8c() { return _extends$8c = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$8c.apply(null, arguments); }
var SvgFaceSmilingSafetyHelmet24 = function SvgFaceSmilingSafetyHelmet24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8c({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 480 480"
  }, props), _path$86 || (_path$86 = /*#__PURE__*/React.createElement("path", {
    d: "M185 340c-5.5-8.3-3.3-19.4 5-25 8.3-5.5 19.4-3.3 25 5 4.9 7.4 14.5 12 25 12s20.1-4.6 25-12c5.5-8.3 16.7-10.5 25-5s10.5 16.7 5 25c-11.7 17.5-32.3 28-55 28s-43.3-10.5-55-28m273-108c0 9.9-8.1 18-18 18h-30v20c0 93.7-76.3 170-170 170S70 363.7 70 270v-20H40c-9.9 0-18-8.1-18-18s8.1-18 18-18h12c0-76.8 53.7-141.2 125.5-157.8 6-13.1 19.2-22.2 34.5-22.2h56c15.3 0 28.5 9.1 34.5 22.2C374.3 72.8 428 137.3 428 214h12c9.9 0 18 8.1 18 18M88 214h304c0-55.5-36.1-102.7-86-119.5V168c0 9.9-8.1 18-18 18s-18-8.1-18-18V72c0-1.1-.9-2-2-2h-56c-1.1 0-2 .9-2 2v96c0 9.9-8.1 18-18 18s-18-8.1-18-18V94.5c-49.9 16.8-86 64-86 119.5m286 36H106v20c0 73.9 60.1 134 134 134s134-60.1 134-134z"
  })));
};

var _path$85;
function _extends$8b() { return _extends$8b = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$8b.apply(null, arguments); }
var SvgFaceSmilingSafetyHelmet32 = function SvgFaceSmilingSafetyHelmet32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8b({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 480 480"
  }, props), _path$85 || (_path$85 = /*#__PURE__*/React.createElement("path", {
    d: "M187.5 338.3c-4.6-6.9-2.7-16.2 4.1-20.8 6.9-4.6 16.2-2.7 20.8 4.1 5.5 8.2 16 13.3 27.5 13.3s22-5.1 27.5-13.3c4.6-6.9 13.9-8.7 20.8-4.1s8.7 13.9 4.1 20.8c-11 16.5-31.1 26.7-52.5 26.7s-41.5-10.2-52.5-26.7ZM455 232c0 8.3-6.7 15-15 15h-33.3q.3 1.5.3 3v20c0 92.1-74.9 167-167 167S73 362.1 73 270v-20q0-1.5.3-3H40c-8.3 0-15-6.7-15-15s6.7-15 15-15h15.1c2.3-72.8 53.8-133.5 122.2-149.7 2.3-17.1 17-30.3 34.7-30.3h56c17.7 0 32.4 13.2 34.7 30.3 68.5 16.2 120 76.9 122.2 149.7H440c8.3 0 15 6.7 15 15M85.1 217h309.8c-2.2-56.1-40.3-103.1-91.9-118.6V168c0 8.3-6.7 15-15 15s-15-6.7-15-15V72c0-2.8-2.2-5-5-5h-56c-2.8 0-5 2.2-5 5v96c0 8.3-6.7 15-15 15s-15-6.7-15-15V98.4c-51.6 15.5-89.8 62.5-91.9 118.6m292.2 30H102.7q.3 1.5.3 3v20c0 75.5 61.5 137 137 137s137-61.5 137-137v-20q0-1.5.3-3"
  })));
};

var _path$84;
function _extends$8a() { return _extends$8a = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$8a.apply(null, arguments); }
var SvgFaceSmilingSafetyHelmet48 = function SvgFaceSmilingSafetyHelmet48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8a({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 480 480"
  }, props), _path$84 || (_path$84 = /*#__PURE__*/React.createElement("path", {
    d: "M190 336.7c-3.7-5.5-2.2-13 3.3-16.6 5.5-3.7 13-2.2 16.6 3.3 6 9 17.5 14.7 30 14.7s24-5.6 30-14.7c3.7-5.5 11.1-7 16.6-3.3s7 11.1 3.3 16.6c-10.4 15.6-29.6 25.3-50 25.3s-39.5-9.7-50-25.3ZM452 232c0 6.6-5.4 12-12 12h-36v26c0 90.4-73.6 164-164 164S76 360.4 76 270v-26H40c-6.6 0-12-5.4-12-12s5.4-12 12-12h18c.9-73.5 52.9-134.9 122.1-150.3 1.2-16.6 15-29.7 31.9-29.7h56c16.9 0 30.7 13.1 31.9 29.7C369 85.1 421 146.5 422 220h18c6.6 0 12 5.4 12 12M82 220h316c-.9-60.2-42.2-110.7-98-125.6V168c0 6.6-5.4 12-12 12s-12-5.4-12-12V72c0-2.3-1-4.4-2.5-5.8-1.4-1.3-3.4-2.2-5.5-2.2h-56c-2.1 0-4 .8-5.5 2.2-1.6 1.5-2.5 3.5-2.5 5.8v96c0 6.6-5.4 12-12 12s-12-5.4-12-12V94.4c-55.7 14.9-97.1 65.4-98 125.6m298 24H100v26c0 77.2 62.8 140 140 140s140-62.8 140-140z"
  })));
};

var FaceSmilingSafetyHelmetIcon = function FaceSmilingSafetyHelmetIcon(props) {
  var faceSmilingSafetyHelmet = {
    12: SvgFaceSmilingSafetyHelmet12,
    16: SvgFaceSmilingSafetyHelmet16,
    18: SvgFaceSmilingSafetyHelmet18,
    24: SvgFaceSmilingSafetyHelmet24,
    32: SvgFaceSmilingSafetyHelmet32,
    48: SvgFaceSmilingSafetyHelmet48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: faceSmilingSafetyHelmet
  }, props));
};

var _path$83, _path2$2C;
function _extends$89() { return _extends$89 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$89.apply(null, arguments); }
var SvgFaceSmilingSafetyHelmetFilled12 = function SvgFaceSmilingSafetyHelmetFilled12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$89({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 480 480"
  }, props), _path$83 || (_path$83 = /*#__PURE__*/React.createElement("path", {
    d: "M240 374c24.7 0 47.1-11.5 60-30.7 7.4-11 4.4-25.9-6.6-33.3s-25.9-4.4-33.3 6.6c-3.8 5.7-11.7 9.3-20 9.3s-16.3-3.7-20-9.3c-7.4-11-22.3-14-33.3-6.6s-14 22.3-6.6 33.3c12.8 19.2 35.2 30.7 60 30.7Z"
  })), _path2$2C || (_path2$2C = /*#__PURE__*/React.createElement("path", {
    d: "M440 208h-6c-.8-69.2-44.7-128.1-106-151.4V148c0 9.9-8.1 18-18 18s-18-8.1-18-18V47.5c-.3-13-10.9-23.5-24-23.5h-56c-13.1 0-23.7 10.5-24 23.5V148c0 9.9-8.1 18-18 18s-18-8.1-18-18V56.6C90.7 79.9 46.9 138.8 46 208h-6c-13.3 0-24 10.7-24 24s10.7 24 24 24h24v14c0 97 79 176 176 176s176-79 176-176v-14h24c13.3 0 24-10.7 24-24s-10.7-24-24-24m-72 62c0 70.6-57.4 128-128 128s-128-57.4-128-128v-14h256z"
  })));
};

var _path$82;
function _extends$88() { return _extends$88 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$88.apply(null, arguments); }
var SvgFaceSmilingSafetyHelmetFilled16 = function SvgFaceSmilingSafetyHelmetFilled16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$88({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 480 480"
  }, props), _path$82 || (_path$82 = /*#__PURE__*/React.createElement("path", {
    d: "M180.9 342.8c-7.1-10.6-4.2-24.8 6.4-31.9s24.8-4.2 31.9 6.4c4 5.9 12.2 9.8 20.9 9.8s16.9-3.8 20.9-9.8c7.1-10.6 21.3-13.4 31.9-6.4 10.6 7.1 13.4 21.3 6.4 31.9-12.6 18.9-34.7 30.2-59.1 30.2s-46.5-11.3-59.1-30.2ZM462.5 232c0 12.4-10.1 22.5-22.5 22.5h-25.5V270c0 96.2-78.3 174.5-174.5 174.5S65.5 366.2 65.5 270v-15.5H40c-12.4 0-22.5-10.1-22.5-22.5s10.1-22.5 22.5-22.5h7.5c.2-68.8 43.4-127.6 104-151.1V152c0 9.9 8.1 18 18 18s18-8.1 18-18V52c0-1 0-2 .2-3 1.5-11 10.9-19.5 22.3-19.5h60c11.4 0 20.8 8.5 22.3 19.5.1 1 .2 2 .2 3v100c0 9.9 8.1 18 18 18s18-8.1 18-18V58.4c60.6 23.5 103.8 82.3 104 151.1h7.5c12.4 0 22.5 10.1 22.5 22.5m-93 22.5h-259V270c0 71.4 58.1 129.5 129.5 129.5S369.5 341.4 369.5 270z"
  })));
};

var _path$81;
function _extends$87() { return _extends$87 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$87.apply(null, arguments); }
var SvgFaceSmilingSafetyHelmetFilled18 = function SvgFaceSmilingSafetyHelmetFilled18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$87({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 480 480"
  }, props), _path$81 || (_path$81 = /*#__PURE__*/React.createElement("path", {
    d: "M182.3 341.8c-6.5-9.8-3.9-23 5.9-29.6 9.8-6.5 23-3.9 29.6 5.9 4.3 6.5 12.9 10.5 22.3 10.5s17.9-4 22.3-10.5c6.5-9.8 19.8-12.4 29.6-5.9s12.4 19.8 5.9 29.6c-12.3 18.5-33.9 29.5-57.7 29.5s-45.4-11-57.7-29.5Zm279-109.8c0 11.8-9.6 21.3-21.3 21.3h-26.7V270c0 95.6-77.8 173.3-173.3 173.3S66.7 365.5 66.7 270v-16.7H40c-11.8 0-21.3-9.6-21.3-21.3s9.6-21.3 21.3-21.3h8.7v-.7c0-68.4 42.8-127 103-150.4V154c0 9.9 8.1 18 18 18s18-8.1 18-18V50.2c.9-10.9 10.1-19.5 21.2-19.5h62c11.2 0 20.3 8.6 21.2 19.5v104.5c.4 9.6 8.3 17.3 18 17.3s18-8.1 18-18V59.6c60.2 23.4 103 82 103 150.4v.7h8.7c11.8 0 21.3 9.6 21.3 21.3Zm-90.6 21.3H109.3V270c0 72 58.6 130.7 130.7 130.7S370.7 342.1 370.7 270z"
  })));
};

var _path$80;
function _extends$86() { return _extends$86 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$86.apply(null, arguments); }
var SvgFaceSmilingSafetyHelmetFilled24 = function SvgFaceSmilingSafetyHelmetFilled24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$86({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 480 480"
  }, props), _path$80 || (_path$80 = /*#__PURE__*/React.createElement("path", {
    d: "M185 340c-5.5-8.3-3.3-19.4 5-25 8.3-5.5 19.4-3.3 25 5 4.9 7.4 14.5 12 25 12s20.1-4.6 25-12c5.5-8.3 16.7-10.5 25-5s10.5 16.7 5 25c-11.7 17.5-32.3 28-55 28s-43.3-10.5-55-28m273-108c0 9.9-8.1 18-18 18h-30v20c0 93.7-76.3 170-170 170S70 363.7 70 270v-20H40c-9.9 0-18-8.1-18-18s8.1-18 18-18h12v-4c0-67 42-124.4 101-147.4V160c0 9.9 8.1 18 18 18s18-8.1 18-18V52c0-9.9 8.1-18 18-18h66c9.9 0 18 8.1 18 18v108c0 9.9 8.1 18 18 18s18-8.1 18-18V62.6c59 22.9 101 80.3 101 147.4v4h12c9.9 0 18 8.1 18 18m-84 18H106v20c0 73.9 60.1 134 134 134s134-60.1 134-134z"
  })));
};

var _path$7$;
function _extends$85() { return _extends$85 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$85.apply(null, arguments); }
var SvgFaceSmilingSafetyHelmetFilled32 = function SvgFaceSmilingSafetyHelmetFilled32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$85({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 480 480"
  }, props), _path$7$ || (_path$7$ = /*#__PURE__*/React.createElement("path", {
    d: "M187.5 338.3c-4.6-6.9-2.7-16.2 4.1-20.8 6.9-4.6 16.2-2.7 20.8 4.1 5.5 8.2 16 13.3 27.5 13.3s22-5.1 27.5-13.3c4.6-6.9 13.9-8.7 20.8-4.1s8.7 13.9 4.1 20.8c-11 16.5-31.1 26.7-52.5 26.7s-41.5-10.2-52.5-26.7ZM455 232c0 8.3-6.7 15-15 15h-33v23c0 92.1-74.9 167-167 167S73 362.1 73 270v-23H40c-8.3 0-15-6.7-15-15s6.7-15 15-15h15c.4-67.9 44.8-125.6 106-146.1V163c0 8.3 6.7 15 15 15s15-6.7 15-15V52c0-8.3 6.7-15 15-15h68c8.3 0 15 6.7 15 15v111c0 8.3 6.7 15 15 15s15-6.7 15-15V70.9C380.2 91.4 424.6 149 425 217h15c8.3 0 15 6.7 15 15m-78 15H103v23c0 75.5 61.5 137 137 137s137-61.5 137-137z"
  })));
};

var _path$7_;
function _extends$84() { return _extends$84 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$84.apply(null, arguments); }
var SvgFaceSmilingSafetyHelmetFilled48 = function SvgFaceSmilingSafetyHelmetFilled48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$84({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 480 480"
  }, props), _path$7_ || (_path$7_ = /*#__PURE__*/React.createElement("path", {
    d: "M190 336.7c-3.7-5.5-2.2-13 3.3-16.6 5.5-3.7 13-2.2 16.6 3.3 6 9 17.5 14.7 30 14.7s24-5.6 30-14.7c3.7-5.5 11.1-7 16.6-3.3s7 11.1 3.3 16.6c-10.4 15.6-29.6 25.3-50 25.3s-39.5-9.7-50-25.3ZM452 232c0 6.6-5.4 12-12 12h-36v26c0 90.4-73.6 164-164 164S76 360.4 76 270v-26H40c-6.6 0-12-5.4-12-12s5.4-12 12-12h18v-2c0-69.2 46.5-127.8 110-146.1V166c0 6.6 5.4 12 12 12s12-5.4 12-12V52c0-6.6 5.4-12 12-12h72c6.6 0 12 5.4 12 12v114c0 6.6 5.4 12 12 12s12-5.4 12-12V71.9c63.5 18.3 110 76.8 110 146.1v2h18c6.6 0 12 5.4 12 12m-72 12H100v26c0 77.2 62.8 140 140 140s140-62.8 140-140z"
  })));
};

var FaceSmilingSafetyHelmetFilledIcon = function FaceSmilingSafetyHelmetFilledIcon(props) {
  var faceSmilingSafetyHelmetFilled = {
    12: SvgFaceSmilingSafetyHelmetFilled12,
    16: SvgFaceSmilingSafetyHelmetFilled16,
    18: SvgFaceSmilingSafetyHelmetFilled18,
    24: SvgFaceSmilingSafetyHelmetFilled24,
    32: SvgFaceSmilingSafetyHelmetFilled32,
    48: SvgFaceSmilingSafetyHelmetFilled48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: faceSmilingSafetyHelmetFilled
  }, props));
};

var _path$7Z, _path2$2B;
function _extends$83() { return _extends$83 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$83.apply(null, arguments); }
var SvgFastForwardFilled12 = function SvgFastForwardFilled12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$83({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$7Z || (_path$7Z = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M1.696 2.983a.6.6 0 0 1 .595-.008l4.5 2.5a.6.6 0 0 1 0 1.05l-4.5 2.5A.6.6 0 0 1 1.4 8.5v-5a.6.6 0 0 1 .296-.517",
    clipRule: "evenodd"
  })), _path2$2B || (_path2$2B = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M5.696 2.983a.6.6 0 0 1 .595-.008l4.5 2.5a.6.6 0 0 1 0 1.05l-4.5 2.5A.6.6 0 0 1 5.4 8.5v-5a.6.6 0 0 1 .296-.517",
    clipRule: "evenodd"
  })));
};

var _path$7Y, _path2$2A;
function _extends$82() { return _extends$82 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$82.apply(null, arguments); }
var SvgFastForwardFilled16 = function SvgFastForwardFilled16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$82({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$7Y || (_path$7Y = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M2.376 3.85a.75.75 0 0 1 .752.002l6 3.5a.75.75 0 0 1 0 1.296l-6 3.5A.75.75 0 0 1 2 11.5v-7a.75.75 0 0 1 .376-.65",
    clipRule: "evenodd"
  })), _path2$2A || (_path2$2A = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M7.626 3.85a.75.75 0 0 1 .752.002l6 3.5a.75.75 0 0 1 0 1.296l-6 3.5A.75.75 0 0 1 7.25 11.5v-7a.75.75 0 0 1 .376-.65",
    clipRule: "evenodd"
  })));
};

var _path$7X, _path2$2z;
function _extends$81() { return _extends$81 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$81.apply(null, arguments); }
var SvgFastForwardFilled18 = function SvgFastForwardFilled18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$81({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$7X || (_path$7X = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M2.594 4.56a.8.8 0 0 1 .794-.01l6.75 3.75a.8.8 0 0 1 0 1.4l-6.75 3.75a.8.8 0 0 1-1.188-.7v-7.5a.8.8 0 0 1 .394-.69",
    clipRule: "evenodd"
  })), _path2$2z || (_path2$2z = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8.594 4.56a.8.8 0 0 1 .794-.01l6.75 3.75a.8.8 0 0 1 0 1.4l-6.75 3.75a.8.8 0 0 1-1.188-.7v-7.5a.8.8 0 0 1 .394-.69",
    clipRule: "evenodd"
  })));
};

var _path$7W, _path2$2y;
function _extends$80() { return _extends$80 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$80.apply(null, arguments); }
var SvgFastForwardFilled24 = function SvgFastForwardFilled24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$80({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$7W || (_path$7W = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M3.544 6.224a.9.9 0 0 1 .893-.01l9 5a.9.9 0 0 1 0 1.573l-9 5A.9.9 0 0 1 3.1 17V7a.9.9 0 0 1 .444-.776",
    clipRule: "evenodd"
  })), _path2$2y || (_path2$2y = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M11.544 6.224a.9.9 0 0 1 .893-.01l9 5a.9.9 0 0 1 0 1.573l-9 5A.9.9 0 0 1 11.1 17V7a.9.9 0 0 1 .444-.776",
    clipRule: "evenodd"
  })));
};

var _path$7V, _path2$2x;
function _extends$7$() { return _extends$7$ = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$7$.apply(null, arguments); }
var SvgFastForwardFilled32 = function SvgFastForwardFilled32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7$({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$7V || (_path$7V = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M4.752 8.133a1 1 0 0 1 1.002.003l12 7a1 1 0 0 1 0 1.728l-12 7A1 1 0 0 1 4.25 23V9a1 1 0 0 1 .502-.867",
    clipRule: "evenodd"
  })), _path2$2x || (_path2$2x = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M15.752 8.133a1 1 0 0 1 1.002.003l12 7a1 1 0 0 1 0 1.728l-12 7A1 1 0 0 1 15.25 23V9a1 1 0 0 1 .502-.867",
    clipRule: "evenodd"
  })));
};

var _path$7U, _path2$2w;
function _extends$7_() { return _extends$7_ = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$7_.apply(null, arguments); }
var SvgFastForwardFilled48 = function SvgFastForwardFilled48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7_({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$7U || (_path$7U = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M6.902 12.46a1.2 1.2 0 0 1 1.203.003l18 10.5a1.2 1.2 0 0 1 0 2.074l-18 10.5A1.2 1.2 0 0 1 6.3 34.5v-21c0-.43.23-.826.602-1.04",
    clipRule: "evenodd"
  })), _path2$2w || (_path2$2w = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M23.902 12.46a1.2 1.2 0 0 1 1.203.003l18 10.5a1.2 1.2 0 0 1 0 2.074l-18 10.5A1.2 1.2 0 0 1 23.3 34.5v-21c0-.43.23-.826.602-1.04",
    clipRule: "evenodd"
  })));
};

var FastForwardFilledIcon = function FastForwardFilledIcon(props) {
  var fastForwardFilled = {
    12: SvgFastForwardFilled12,
    16: SvgFastForwardFilled16,
    18: SvgFastForwardFilled18,
    24: SvgFastForwardFilled24,
    32: SvgFastForwardFilled32,
    48: SvgFastForwardFilled48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: fastForwardFilled
  }, props));
};

var _path$7T;
function _extends$7Z() { return _extends$7Z = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$7Z.apply(null, arguments); }
var SvgFilter12 = function SvgFilter12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7Z({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$7T || (_path$7T = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "m6.675 6.247 2.414-2.628a.8.8 0 0 0 .211-.541V2.2H2.7v.878a.8.8 0 0 0 .21.541l2.415 2.628V9.8h1.35zM9.973 4.43a2 2 0 0 0 .527-1.353V2a1 1 0 0 0-1-1h-7a1 1 0 0 0-1 1v1.078a2 2 0 0 0 .527 1.353l2.098 2.283V10a1 1 0 0 0 1 1h1.75a1 1 0 0 0 1-1V6.714z",
    clipRule: "evenodd"
  })));
};

var _path$7S;
function _extends$7Y() { return _extends$7Y = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$7Y.apply(null, arguments); }
var SvgFilter16 = function SvgFilter16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7Y({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$7S || (_path$7S = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "m8.896 8.326 3.22-3.44a.5.5 0 0 0 .134-.341V3.25h-8.5v1.295a.5.5 0 0 0 .135.341l3.22 3.44v4.47h1.79zm1.5.593L13.21 5.91a2 2 0 0 0 .54-1.366V3.25a1.5 1.5 0 0 0-1.5-1.5h-8.5a1.5 1.5 0 0 0-1.5 1.5v1.295a2 2 0 0 0 .54 1.366L5.604 8.92v3.877a1.5 1.5 0 0 0 1.5 1.5h1.792a1.5 1.5 0 0 0 1.5-1.5z",
    clipRule: "evenodd"
  })));
};

var _path$7R;
function _extends$7X() { return _extends$7X = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$7X.apply(null, arguments); }
var SvgFilter18 = function SvgFilter18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7X({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$7R || (_path$7R = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "m10.108 9.362 3.682-3.884a.4.4 0 0 0 .11-.275V3.6H4.1v1.603c0 .102.04.2.11.275l3.682 3.884V14.4h2.216zm1.6.638 3.243-3.421a2 2 0 0 0 .549-1.376V3.5A1.5 1.5 0 0 0 14 2H4a1.5 1.5 0 0 0-1.5 1.5v1.703a2 2 0 0 0 .548 1.376L6.292 10v4.5a1.5 1.5 0 0 0 1.5 1.5h2.416a1.5 1.5 0 0 0 1.5-1.5z",
    clipRule: "evenodd"
  })));
};

var _path$7Q;
function _extends$7W() { return _extends$7W = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$7W.apply(null, arguments); }
var SvgFilter24 = function SvgFilter24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7W({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$7Q || (_path$7Q = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "m13.575 13.691 5.567-5.656a.2.2 0 0 0 .058-.14V5a.2.2 0 0 0-.2-.2H5a.2.2 0 0 0-.2.2v2.895a.2.2 0 0 0 .057.14l5.568 5.656V21c0 .11.09.2.2.2h2.75a.2.2 0 0 0 .2-.2zm1.8.738 5.05-5.13A2 2 0 0 0 21 7.894V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v2.895a2 2 0 0 0 .575 1.403l5.05 5.13V21a2 2 0 0 0 2 2h2.75a2 2 0 0 0 2-2z",
    clipRule: "evenodd"
  })));
};

var _path$7P;
function _extends$7V() { return _extends$7V = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$7V.apply(null, arguments); }
var SvgFilter32 = function SvgFilter32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7V({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$7P || (_path$7P = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "m18.1 18.255 7.423-7.541a.27.27 0 0 0 .077-.187v-3.86a.267.267 0 0 0-.267-.267H6.667a.267.267 0 0 0-.267.267v3.86c0 .07.028.137.077.187l7.423 7.541V28c0 .147.12.267.267.267h3.666c.148 0 .267-.12.267-.267zm2.4.983 6.734-6.84c.49-.5.766-1.171.766-1.871v-3.86A2.667 2.667 0 0 0 25.333 4H6.667A2.667 2.667 0 0 0 4 6.667v3.86c0 .7.275 1.372.766 1.87l6.734 6.841V28a2.667 2.667 0 0 0 2.667 2.667h3.666A2.667 2.667 0 0 0 20.5 28z",
    clipRule: "evenodd"
  })));
};

var _path$7O;
function _extends$7U() { return _extends$7U = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$7U.apply(null, arguments); }
var SvgFilter48 = function SvgFilter48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7U({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$7O || (_path$7O = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M28.35 25.874 39.6 14.446V7a.6.6 0 0 0-.6-.6H9a.6.6 0 0 0-.6.6v7.445l11.25 11.43V41a.6.6 0 0 0 .6.6h7.5a.6.6 0 0 0 .6-.6zm2.4.983 10.675-10.845A2 2 0 0 0 42 14.61V7a3 3 0 0 0-3-3H9a3 3 0 0 0-3 3v7.61a2 2 0 0 0 .575 1.402L17.25 26.857V41a3 3 0 0 0 3 3h7.5a3 3 0 0 0 3-3z",
    clipRule: "evenodd"
  })));
};

var FilterIcon = function FilterIcon(props) {
  var filter = {
    12: SvgFilter12,
    16: SvgFilter16,
    18: SvgFilter18,
    24: SvgFilter24,
    32: SvgFilter32,
    48: SvgFilter48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: filter
  }, props));
};

var _path$7N, _path2$2v;
function _extends$7T() { return _extends$7T = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$7T.apply(null, arguments); }
var SvgFilterFilled12 = function SvgFilterFilled12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7T({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$7N || (_path$7N = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M9.5 1h-7a1 1 0 0 0-1 1v1.078a2 2 0 0 0 .527 1.353l2.098 2.283V10a1 1 0 0 0 1 1h1.75a1 1 0 0 0 1-1V6.714l2.098-2.283a2 2 0 0 0 .527-1.353V2a1 1 0 0 0-1-1"
  })), _path2$2v || (_path2$2v = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "m6.675 6.247 2.414-2.628a.8.8 0 0 0 .211-.541V2.2H2.7v.878a.8.8 0 0 0 .21.541l2.415 2.628V9.8h1.35zM9.973 4.43a2 2 0 0 0 .527-1.353V2a1 1 0 0 0-1-1h-7a1 1 0 0 0-1 1v1.078a2 2 0 0 0 .527 1.353l2.098 2.283V10a1 1 0 0 0 1 1h1.75a1 1 0 0 0 1-1V6.714z",
    clipRule: "evenodd"
  })));
};

var _path$7M, _path2$2u;
function _extends$7S() { return _extends$7S = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$7S.apply(null, arguments); }
var SvgFilterFilled16 = function SvgFilterFilled16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7S({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$7M || (_path$7M = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M12.25 1.75h-8.5a1.5 1.5 0 0 0-1.5 1.5v1.295a2 2 0 0 0 .54 1.366L5.604 8.92v3.877a1.5 1.5 0 0 0 1.5 1.5h1.792a1.5 1.5 0 0 0 1.5-1.5V8.919L13.21 5.91a2 2 0 0 0 .54-1.366V3.25a1.5 1.5 0 0 0-1.5-1.5"
  })), _path2$2u || (_path2$2u = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "m8.896 8.326 3.22-3.44a.5.5 0 0 0 .134-.341V3.25h-8.5v1.295a.5.5 0 0 0 .135.341l3.22 3.44v4.47h1.79zm1.5.593L13.21 5.91a2 2 0 0 0 .54-1.366V3.25a1.5 1.5 0 0 0-1.5-1.5h-8.5a1.5 1.5 0 0 0-1.5 1.5v1.295a2 2 0 0 0 .54 1.366L5.604 8.92v3.877a1.5 1.5 0 0 0 1.5 1.5h1.792a1.5 1.5 0 0 0 1.5-1.5z",
    clipRule: "evenodd"
  })));
};

var _path$7L, _path2$2t;
function _extends$7R() { return _extends$7R = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$7R.apply(null, arguments); }
var SvgFilterFilled18 = function SvgFilterFilled18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7R({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$7L || (_path$7L = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M14 2H4a1.5 1.5 0 0 0-1.5 1.5v1.703a2 2 0 0 0 .548 1.376L6.292 10v4.5a1.5 1.5 0 0 0 1.5 1.5h2.416a1.5 1.5 0 0 0 1.5-1.5V10l3.243-3.421a2 2 0 0 0 .549-1.376V3.5A1.5 1.5 0 0 0 14 2"
  })), _path2$2t || (_path2$2t = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "m10.108 9.362 3.682-3.884a.4.4 0 0 0 .11-.275V3.6H4.1v1.603c0 .102.04.2.11.275l3.682 3.884V14.4h2.216zm1.6.638 3.243-3.421a2 2 0 0 0 .549-1.376V3.5A1.5 1.5 0 0 0 14 2H4a1.5 1.5 0 0 0-1.5 1.5v1.703a2 2 0 0 0 .548 1.376L6.292 10v4.5a1.5 1.5 0 0 0 1.5 1.5h2.416a1.5 1.5 0 0 0 1.5-1.5z",
    clipRule: "evenodd"
  })));
};

var _path$7K, _path2$2s;
function _extends$7Q() { return _extends$7Q = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$7Q.apply(null, arguments); }
var SvgFilterFilled24 = function SvgFilterFilled24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7Q({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$7K || (_path$7K = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M19 3H5a2 2 0 0 0-2 2v2.895a2 2 0 0 0 .575 1.403l5.05 5.13V21a2 2 0 0 0 2 2h2.75a2 2 0 0 0 2-2v-6.571l5.05-5.13A2 2 0 0 0 21 7.894V5a2 2 0 0 0-2-2"
  })), _path2$2s || (_path2$2s = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "m13.575 13.691 5.567-5.656a.2.2 0 0 0 .058-.14V5a.2.2 0 0 0-.2-.2H5a.2.2 0 0 0-.2.2v2.895a.2.2 0 0 0 .057.14l5.568 5.656V21c0 .11.09.2.2.2h2.75a.2.2 0 0 0 .2-.2zm1.8.738 5.05-5.13A2 2 0 0 0 21 7.894V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v2.895a2 2 0 0 0 .575 1.403l5.05 5.13V21a2 2 0 0 0 2 2h2.75a2 2 0 0 0 2-2z",
    clipRule: "evenodd"
  })));
};

var _path$7J, _path2$2r;
function _extends$7P() { return _extends$7P = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$7P.apply(null, arguments); }
var SvgFilterFilled32 = function SvgFilterFilled32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7P({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$7J || (_path$7J = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M25.333 4H6.667A2.667 2.667 0 0 0 4 6.667v3.86c0 .7.275 1.372.766 1.87l6.734 6.841V28a2.667 2.667 0 0 0 2.667 2.667h3.666A2.667 2.667 0 0 0 20.5 28v-8.762l6.734-6.84c.49-.5.766-1.171.766-1.871v-3.86A2.667 2.667 0 0 0 25.333 4"
  })), _path2$2r || (_path2$2r = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "m18.1 18.255 7.423-7.541a.27.27 0 0 0 .077-.187v-3.86a.267.267 0 0 0-.267-.267H6.667a.267.267 0 0 0-.267.267v3.86c0 .07.028.137.077.187l7.423 7.541V28c0 .147.12.267.267.267h3.666c.148 0 .267-.12.267-.267zm2.4.983 6.734-6.84c.49-.5.766-1.171.766-1.871v-3.86A2.667 2.667 0 0 0 25.333 4H6.667A2.667 2.667 0 0 0 4 6.667v3.86c0 .7.275 1.372.766 1.87l6.734 6.841V28a2.667 2.667 0 0 0 2.667 2.667h3.666A2.667 2.667 0 0 0 20.5 28z",
    clipRule: "evenodd"
  })));
};

var _path$7I, _path2$2q;
function _extends$7O() { return _extends$7O = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$7O.apply(null, arguments); }
var SvgFilterFilled48 = function SvgFilterFilled48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7O({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$7I || (_path$7I = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M39 4H9a3 3 0 0 0-3 3v7.61a2 2 0 0 0 .575 1.402L17.25 26.857V41a3 3 0 0 0 3 3h7.5a3 3 0 0 0 3-3V26.857l10.675-10.845A2 2 0 0 0 42 14.61V7a3 3 0 0 0-3-3"
  })), _path2$2q || (_path2$2q = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M28.35 25.874 39.6 14.446V7a.6.6 0 0 0-.6-.6H9a.6.6 0 0 0-.6.6v7.445l11.25 11.43V41a.6.6 0 0 0 .6.6h7.5a.6.6 0 0 0 .6-.6zm2.4.983 10.675-10.845A2 2 0 0 0 42 14.61V7a3 3 0 0 0-3-3H9a3 3 0 0 0-3 3v7.61a2 2 0 0 0 .575 1.402L17.25 26.857V41a3 3 0 0 0 3 3h7.5a3 3 0 0 0 3-3z",
    clipRule: "evenodd"
  })));
};

var FilterFilledIcon = function FilterFilledIcon(props) {
  var filterFilled = {
    12: SvgFilterFilled12,
    16: SvgFilterFilled16,
    18: SvgFilterFilled18,
    24: SvgFilterFilled24,
    32: SvgFilterFilled32,
    48: SvgFilterFilled48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: filterFilled
  }, props));
};

var _path$7H, _path2$2p, _path3$h;
function _extends$7N() { return _extends$7N = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$7N.apply(null, arguments); }
var SvgFilterNew12 = function SvgFilterNew12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7N({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$7H || (_path$7H = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M11.15 4.25a.6.6 0 0 1-.6.6H5.8a.6.6 0 0 1 0-1.2h4.75a.6.6 0 0 1 .6.6M3.85 4.25a.6.6 0 0 1-.6.6h-1.8a.6.6 0 0 1 0-1.2h1.8a.6.6 0 0 1 .6.6",
    clipRule: "evenodd"
  })), _path2$2p || (_path2$2p = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M4.65 4.8a.55.55 0 1 0 0-1.1.55.55 0 0 0 0 1.1m0 1.2a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5M11.15 7.75a.6.6 0 0 1-.6.6H9a.6.6 0 0 1 0-1.2h1.55a.6.6 0 0 1 .6.6M6.85 7.75a.6.6 0 0 1-.6.6h-4.8a.6.6 0 0 1 0-1.2h4.8a.6.6 0 0 1 .6.6",
    clipRule: "evenodd"
  })), _path3$h || (_path3$h = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M7.45 8.3a.55.55 0 1 0 0-1.1.55.55 0 0 0 0 1.1m0 1.2a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5",
    clipRule: "evenodd"
  })));
};

var _path$7G, _path2$2o, _path3$g;
function _extends$7M() { return _extends$7M = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$7M.apply(null, arguments); }
var SvgFilterNew16 = function SvgFilterNew16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7M({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$7G || (_path$7G = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M14.867 5.667a.8.8 0 0 1-.8.8H7.733a.8.8 0 0 1 0-1.6h6.334a.8.8 0 0 1 .8.8M5.133 5.667a.8.8 0 0 1-.8.8h-2.4a.8.8 0 0 1 0-1.6h2.4a.8.8 0 0 1 .8.8",
    clipRule: "evenodd"
  })), _path2$2o || (_path2$2o = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M6.03 6.3a.7.7 0 1 0 0-1.4.7.7 0 0 0 0 1.4m0 1.6a2.3 2.3 0 1 0 0-4.6 2.3 2.3 0 0 0 0 4.6M14.867 10.333a.8.8 0 0 1-.8.8H12a.8.8 0 1 1 0-1.6h2.067a.8.8 0 0 1 .8.8M9.133 10.333a.8.8 0 0 1-.8.8h-6.4a.8.8 0 1 1 0-1.6h6.4a.8.8 0 0 1 .8.8",
    clipRule: "evenodd"
  })), _path3$g || (_path3$g = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M9.97 11a.7.7 0 1 0 0-1.4.7.7 0 0 0 0 1.4m0 1.6a2.3 2.3 0 1 0 0-4.6 2.3 2.3 0 0 0 0 4.6",
    clipRule: "evenodd"
  })));
};

var _path$7F;
function _extends$7L() { return _extends$7L = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$7L.apply(null, arguments); }
var SvgFilterNew18 = function SvgFilterNew18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7L({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$7F || (_path$7F = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M9.092 7.175a2.438 2.438 0 0 1-4.459 0H2.175a.8.8 0 0 1 0-1.6h2.328a2.439 2.439 0 0 1 4.72 0h6.602a.8.8 0 0 1 0 1.6zM7.7 6.188a.837.837 0 1 1-1.675 0 .837.837 0 0 1 1.675 0M13.428 12.422a2.438 2.438 0 0 1-4.58.003H2.175a.8.8 0 0 1 0-1.6H8.82a2.439 2.439 0 0 1 4.633.002l.046-.002h2.325a.8.8 0 1 1 0 1.6H13.5zm-1.453-.835a.838.838 0 1 1-1.675 0 .838.838 0 0 1 1.675 0",
    clipRule: "evenodd"
  })));
};

var _path$7E, _path2$2n, _path3$f;
function _extends$7K() { return _extends$7K = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$7K.apply(null, arguments); }
var SvgFilterNew24 = function SvgFilterNew24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7K({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$7E || (_path$7E = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M22 8.5a.9.9 0 0 1-.9.9h-9.5a.9.9 0 1 1 0-1.8h9.5a.9.9 0 0 1 .9.9M7.4 8.5a.9.9 0 0 1-.9.9H2.9a.9.9 0 1 1 0-1.8h3.6a.9.9 0 0 1 .9.9",
    clipRule: "evenodd"
  })), _path2$2n || (_path2$2n = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M9.15 9.7a1.45 1.45 0 1 0 0-2.9 1.45 1.45 0 0 0 0 2.9m0 1.8a3.25 3.25 0 1 0 0-6.5 3.25 3.25 0 0 0 0 6.5M22 15.5a.9.9 0 0 1-.9.9H18a.9.9 0 1 1 0-1.8h3.1a.9.9 0 0 1 .9.9M13.4 15.5a.9.9 0 0 1-.9.9H2.9a.9.9 0 1 1 0-1.8h9.6a.9.9 0 0 1 .9.9",
    clipRule: "evenodd"
  })), _path3$f || (_path3$f = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M14.85 16.9a1.45 1.45 0 1 0 0-2.9 1.45 1.45 0 0 0 0 2.9m0 1.8a3.25 3.25 0 1 0 0-6.5 3.25 3.25 0 0 0 0 6.5",
    clipRule: "evenodd"
  })));
};

var _path$7D, _path2$2m, _path3$e;
function _extends$7J() { return _extends$7J = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$7J.apply(null, arguments); }
var SvgFilterNew32 = function SvgFilterNew32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7J({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$7D || (_path$7D = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M29.134 11.333a1 1 0 0 1-1 1H15.467a1 1 0 1 1 0-2h12.667a1 1 0 0 1 1 1M9.667 11.333a1 1 0 0 1-1 1h-4.8a1 1 0 1 1 0-2h4.8a1 1 0 0 1 1 1",
    clipRule: "evenodd"
  })), _path2$2m || (_path2$2m = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M12.2 13.333a2.333 2.333 0 1 0 0-4.666 2.333 2.333 0 0 0 0 4.666m0 2a4.333 4.333 0 1 0 0-8.666 4.333 4.333 0 0 0 0 8.666M29.133 20.667a1 1 0 0 1-1 1H24a1 1 0 1 1 0-2h4.133a1 1 0 0 1 1 1M17.667 20.667a1 1 0 0 1-1 1h-12.8a1 1 0 1 1 0-2h12.8a1 1 0 0 1 1 1",
    clipRule: "evenodd"
  })), _path3$e || (_path3$e = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M19.8 22.933a2.333 2.333 0 1 0 0-4.666 2.333 2.333 0 0 0 0 4.666m0 2a4.333 4.333 0 1 0 0-8.666 4.333 4.333 0 0 0 0 8.666",
    clipRule: "evenodd"
  })));
};

var _path$7C, _path2$2l, _path3$d;
function _extends$7I() { return _extends$7I = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$7I.apply(null, arguments); }
var SvgFilterNew48 = function SvgFilterNew48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7I({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$7C || (_path$7C = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M43.4 17a1.2 1.2 0 0 1-1.2 1.2H24a1.2 1.2 0 0 1 0-2.4h18.2a1.2 1.2 0 0 1 1.2 1.2M14.2 17a1.2 1.2 0 0 1-1.2 1.2H5.8a1.2 1.2 0 0 1 0-2.4H13a1.2 1.2 0 0 1 1.2 1.2",
    clipRule: "evenodd"
  })), _path2$2l || (_path2$2l = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M18.3 20.6a4.1 4.1 0 1 0 0-8.2 4.1 4.1 0 0 0 0 8.2m0 2.4a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13M43.4 31a1.2 1.2 0 0 1-1.2 1.2H36a1.2 1.2 0 0 1 0-2.4h6.2a1.2 1.2 0 0 1 1.2 1.2M24.7 31a1.2 1.2 0 0 1-1.2 1.2H5.8a1.2 1.2 0 0 1 0-2.4h17.7a1.2 1.2 0 0 1 1.2 1.2",
    clipRule: "evenodd"
  })), _path3$d || (_path3$d = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M29.7 35a4.1 4.1 0 1 0 0-8.2 4.1 4.1 0 0 0 0 8.2m0 2.4a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13",
    clipRule: "evenodd"
  })));
};

var FilterNewIcon = function FilterNewIcon(props) {
  var filterNew = {
    12: SvgFilterNew12,
    16: SvgFilterNew16,
    18: SvgFilterNew18,
    24: SvgFilterNew24,
    32: SvgFilterNew32,
    48: SvgFilterNew48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: filterNew
  }, props));
};

var _path$7B;
function _extends$7H() { return _extends$7H = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$7H.apply(null, arguments); }
var SvgGlobe12 = function SvgGlobe12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7H({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$7B || (_path$7B = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M1.036 5.4a5 5 0 0 0 0 1.2 5 5 0 0 0 3.426 4.16c.485.155 1.001.24 1.538.24s1.053-.085 1.538-.24a5.005 5.005 0 0 0 3.426-5.36A4.997 4.997 0 0 0 6 1a4.997 4.997 0 0 0-4.964 4.4m2.532-2.32a3.8 3.8 0 0 0-1.32 2.32h.945c.042-.84.173-1.63.375-2.32M3.193 6.6h-.946c.147.928.63 1.745 1.321 2.32a10 10 0 0 1-.375-2.32m2.002 3.115a4 4 0 0 1-.218-.423c-.305-.686-.522-1.623-.583-2.692h3.212c-.06 1.069-.278 2.006-.583 2.692q-.105.237-.218.423a3.8 3.8 0 0 1-1.61 0m3.237-.795a3.8 3.8 0 0 0 1.32-2.32h-.945c-.042.84-.173 1.63-.375 2.32m.375-3.52h.946a3.8 3.8 0 0 0-1.321-2.32c.202.69.333 1.48.375 2.32M5.195 2.285a3.8 3.8 0 0 1 1.61 0q.113.186.218.423c.305.686.522 1.623.583 2.692H4.395c.06-1.069.277-2.006.582-2.692q.105-.237.218-.423",
    clipRule: "evenodd"
  })));
};

var _path$7A;
function _extends$7G() { return _extends$7G = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$7G.apply(null, arguments); }
var SvgGlobe16 = function SvgGlobe16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7G({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$7A || (_path$7A = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M1.372 7.245a6.7 6.7 0 0 0 0 1.5 6.67 6.67 0 0 0 4.66 5.621c.62.191 1.28.294 1.963.294s1.342-.103 1.963-.294a6.67 6.67 0 0 0 4.66-7.12 6.67 6.67 0 0 0-4.66-5.622 6.7 6.7 0 0 0-1.963-.294c-.683 0-1.342.103-1.963.294a6.67 6.67 0 0 0-4.66 5.621M4.874 3.88a5.16 5.16 0 0 0-1.99 3.366h1.417c.058-1.23.259-2.381.573-3.366m-.573 4.866H2.884c.2 1.37.937 2.566 1.99 3.366-.314-.984-.515-2.135-.573-3.366m2.626 4.304a5 5 0 0 1-.341-.646c-.414-.932-.708-2.207-.784-3.658h4.386c-.076 1.451-.37 2.726-.784 3.658a5 5 0 0 1-.34.646 5.2 5.2 0 0 1-2.137 0m4.189-.938a5.16 5.16 0 0 0 1.99-3.366H11.69c-.059 1.23-.26 2.382-.574 3.366m.574-4.866h1.416a5.16 5.16 0 0 0-1.99-3.366c.315.985.515 2.135.574 3.366M6.927 2.941a5.2 5.2 0 0 1 2.136 0q.176.277.341.646c.415.932.708 2.207.784 3.658H5.802c.076-1.451.37-2.726.784-3.658q.166-.369.34-.646",
    clipRule: "evenodd"
  })));
};

var _path$7z;
function _extends$7F() { return _extends$7F = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$7F.apply(null, arguments); }
var SvgGlobe18 = function SvgGlobe18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7F({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$7z || (_path$7z = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M1.542 8.2a7.6 7.6 0 0 0 0 1.6 7.51 7.51 0 0 0 5.327 6.393c.675.2 1.39.307 2.131.307s1.456-.107 2.131-.307A7.51 7.51 0 0 0 16.458 8.2a7.51 7.51 0 0 0-5.327-6.393A7.5 7.5 0 0 0 9 1.5c-.74 0-1.456.107-2.131.307A7.51 7.51 0 0 0 1.542 8.2m4.055-4.02A5.9 5.9 0 0 0 3.154 8.2h1.73c.067-1.483.318-2.863.713-4.02M4.885 9.8H3.154a5.9 5.9 0 0 0 2.443 4.02c-.395-1.157-.646-2.537-.712-4.02m2.92 4.979a5.6 5.6 0 0 1-.431-.8c-.473-1.065-.806-2.522-.888-4.179h5.028c-.082 1.657-.415 3.114-.888 4.178a5.6 5.6 0 0 1-.43.8 5.9 5.9 0 0 1-2.392 0m4.598-.959a5.9 5.9 0 0 0 2.443-4.02h-1.73c-.067 1.483-.318 2.863-.713 4.02m.712-5.62h1.731a5.9 5.9 0 0 0-2.443-4.02c.395 1.157.646 2.537.712 4.02m-5.31-4.979a5.9 5.9 0 0 1 2.39 0q.225.338.431.8c.473 1.065.806 2.522.888 4.179H6.486c.082-1.657.415-3.114.888-4.178q.207-.464.43-.8",
    clipRule: "evenodd"
  })));
};

var _path$7y;
function _extends$7E() { return _extends$7E = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$7E.apply(null, arguments); }
var SvgGlobe24 = function SvgGlobe24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7E({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$7y || (_path$7y = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M2.04 11.1a10 10 0 0 0 0 1.8c.378 4.243 3.407 7.723 7.418 8.774.812.213 1.664.326 2.542.326s1.73-.113 2.542-.326c4.011-1.051 7.04-4.531 7.418-8.774a10 10 0 0 0 0-1.8c-.378-4.243-3.407-7.723-7.418-8.774A10 10 0 0 0 12 2c-.878 0-1.73.113-2.542.326-4.011 1.05-7.04 4.531-7.418 8.774m5.85-6.197A8.2 8.2 0 0 0 3.85 11.1h2.824c.09-2.347.526-4.502 1.218-6.197M6.674 12.9H3.849a8.2 8.2 0 0 0 4.042 6.198c-.692-1.696-1.129-3.85-1.218-6.198m3.772 7.153a7 7 0 0 1-.765-1.348c-.658-1.479-1.111-3.508-1.206-5.805h7.052c-.095 2.297-.548 4.326-1.206 5.806a7 7 0 0 1-.765 1.347 8.2 8.2 0 0 1-3.11 0m5.665-.956A8.2 8.2 0 0 0 20.15 12.9h-2.824c-.09 2.347-.526 4.502-1.218 6.198m1.217-7.997h2.824a8.2 8.2 0 0 0-4.041-6.197c.69 1.695 1.128 3.85 1.217 6.197m-6.882-7.153a8.2 8.2 0 0 1 3.11 0c.266.359.526.808.765 1.347.658 1.48 1.111 3.509 1.206 5.806H8.474c.095-2.297.548-4.326 1.206-5.806.24-.539.499-.988.765-1.347",
    clipRule: "evenodd"
  })));
};

var _path$7x;
function _extends$7D() { return _extends$7D = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$7D.apply(null, arguments); }
var SvgGlobe32 = function SvgGlobe32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7D({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$7x || (_path$7x = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M2.707 15.005a13.5 13.5 0 0 0 0 2c.436 5.88 4.684 10.698 10.282 11.992.969.224 1.979.343 3.016.343s2.047-.119 3.016-.343c5.598-1.294 9.846-6.113 10.282-11.992a13.5 13.5 0 0 0 0-2c-.436-5.88-4.684-10.698-10.282-11.993a13.4 13.4 0 0 0-3.016-.342c-1.037 0-2.047.118-3.016.342C7.39 4.307 3.143 9.125 2.707 15.005m8.365-9.208a11.34 11.34 0 0 0-6.359 9.208h4.381c.109-3.399.766-6.495 1.806-8.835q.085-.19.172-.373M9.094 17.005h-4.38a11.34 11.34 0 0 0 6.358 9.208 14 14 0 0 1-.172-.373c-1.04-2.34-1.697-5.437-1.806-8.835m4.916 10.16c-.452-.536-.888-1.251-1.282-2.137-.909-2.045-1.525-4.854-1.633-8.023h9.82c-.108 3.169-.724 5.978-1.633 8.023-.394.886-.83 1.601-1.282 2.137a11.4 11.4 0 0 1-3.99 0m6.927-.952a11.34 11.34 0 0 0 6.36-9.208h-4.381c-.109 3.398-.766 6.495-1.806 8.835q-.084.19-.173.373m1.979-11.208h4.38a11.34 11.34 0 0 0-6.359-9.208q.089.183.172.373c1.04 2.34 1.698 5.437 1.807 8.835M14.01 4.845a11.4 11.4 0 0 1 3.99 0c.452.536.888 1.251 1.282 2.137.909 2.045 1.525 4.854 1.633 8.023h-9.82c.108-3.169.724-5.978 1.633-8.023.394-.886.83-1.601 1.282-2.137",
    clipRule: "evenodd"
  })));
};

var _path$7w;
function _extends$7C() { return _extends$7C = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$7C.apply(null, arguments); }
var SvgGlobe48 = function SvgGlobe48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7C({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$7w || (_path$7w = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M4.035 22.8a20 20 0 0 0 0 2.4c.542 9.159 7.247 16.659 16.026 18.412 1.274.255 2.59.388 3.939.388 1.348 0 2.665-.133 3.939-.388 8.779-1.753 15.484-9.254 16.026-18.412a20 20 0 0 0 0-2.4c-.542-9.158-7.247-16.659-16.026-18.412A20 20 0 0 0 24 4c-1.348 0-2.665.133-3.939.388C11.282 6.14 4.577 13.642 4.035 22.8m13.45-15.155C11.342 10.095 6.904 15.903 6.44 22.8h7.486c.133-5.18 1.121-9.895 2.692-13.43q.404-.91.866-1.725M13.925 25.2H6.44c.465 6.897 4.903 12.706 11.044 15.155a20 20 0 0 1-.866-1.725c-1.57-3.535-2.559-8.25-2.692-13.43m7.256 16.176c-.848-.868-1.66-2.12-2.37-3.721-1.413-3.177-2.352-7.546-2.485-12.455h15.346c-.133 4.909-1.072 9.278-2.484 12.455-.712 1.601-1.523 2.853-2.37 3.72a17.7 17.7 0 0 1-5.637 0m9.334-1.021c6.141-2.45 10.58-8.258 11.044-15.155h-7.486c-.133 5.18-1.121 9.895-2.692 13.43q-.404.91-.866 1.724M34.074 22.8h7.486c-.465-6.897-4.903-12.706-11.044-15.155.308.542.597 1.12.866 1.726 1.57 3.534 2.559 8.248 2.692 13.429M21.182 6.624a17.7 17.7 0 0 1 5.637 0c.847.868 1.658 2.12 2.37 3.721 1.412 3.177 2.351 7.546 2.484 12.455H16.327c.133-4.909 1.072-9.278 2.484-12.455.712-1.601 1.523-2.853 2.37-3.72",
    clipRule: "evenodd"
  })));
};

var GlobeIcon = function GlobeIcon(props) {
  var globe = {
    12: SvgGlobe12,
    16: SvgGlobe16,
    18: SvgGlobe18,
    24: SvgGlobe24,
    32: SvgGlobe32,
    48: SvgGlobe48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: globe
  }, props));
};

var _path$7v;
function _extends$7B() { return _extends$7B = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$7B.apply(null, arguments); }
var SvgHandler12 = function SvgHandler12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7B({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$7v || (_path$7v = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M4.333 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2M4.333 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2M5.333 10a1 1 0 1 1-2 0 1 1 0 0 1 2 0M7.667 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2M8.667 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0M7.667 11a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
  })));
};

var _path$7u;
function _extends$7A() { return _extends$7A = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$7A.apply(null, arguments); }
var SvgHandler16 = function SvgHandler16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7A({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$7u || (_path$7u = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M5.778 4a1.333 1.333 0 1 0 0-2.666 1.333 1.333 0 0 0 0 2.666M5.778 9.334a1.333 1.333 0 1 0 0-2.667 1.333 1.333 0 0 0 0 2.667M7.111 13.334a1.333 1.333 0 1 1-2.667 0 1.333 1.333 0 0 1 2.667 0M10.222 4a1.333 1.333 0 1 0 0-2.666 1.333 1.333 0 0 0 0 2.666M11.555 8A1.333 1.333 0 1 1 8.89 8a1.333 1.333 0 0 1 2.666 0M10.222 14.667a1.333 1.333 0 1 0 0-2.667 1.333 1.333 0 0 0 0 2.667"
  })));
};

var _path$7t;
function _extends$7z() { return _extends$7z = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$7z.apply(null, arguments); }
var SvgHandler18 = function SvgHandler18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7z({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$7t || (_path$7t = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M6.5 4.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M6.5 10.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M8 15a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M11.5 4.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M13 9a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M11.5 16.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"
  })));
};

var _path$7s;
function _extends$7y() { return _extends$7y = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$7y.apply(null, arguments); }
var SvgHandler24 = function SvgHandler24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7y({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$7s || (_path$7s = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M8.667 6a2 2 0 1 0 0-4 2 2 0 0 0 0 4M8.667 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4M10.667 20a2 2 0 1 1-4 0 2 2 0 0 1 4 0M15.333 6a2 2 0 1 0 0-4 2 2 0 0 0 0 4M17.333 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0M15.333 22a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
  })));
};

var _path$7r;
function _extends$7x() { return _extends$7x = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$7x.apply(null, arguments); }
var SvgHandler32 = function SvgHandler32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7x({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$7r || (_path$7r = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M11.556 8a2.667 2.667 0 1 0 0-5.333 2.667 2.667 0 0 0 0 5.333M11.556 18.667a2.667 2.667 0 1 0 0-5.334 2.667 2.667 0 0 0 0 5.333M14.222 26.667a2.667 2.667 0 1 1-5.333 0 2.667 2.667 0 0 1 5.333 0M20.445 8a2.667 2.667 0 1 0 0-5.333 2.667 2.667 0 0 0 0 5.333M23.111 16a2.667 2.667 0 1 1-5.333 0 2.667 2.667 0 0 1 5.333 0M20.445 29.333a2.667 2.667 0 1 0 0-5.333 2.667 2.667 0 0 0 0 5.333"
  })));
};

var _path$7q;
function _extends$7w() { return _extends$7w = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$7w.apply(null, arguments); }
var SvgHandler48 = function SvgHandler48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7w({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$7q || (_path$7q = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M17.333 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8M17.333 28a4 4 0 1 0 0-8 4 4 0 0 0 0 8M21.333 40a4 4 0 1 1-8 0 4 4 0 0 1 8 0M30.667 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8M34.667 24a4 4 0 1 1-8 0 4 4 0 0 1 8 0M30.667 44a4 4 0 1 0 0-8 4 4 0 0 0 0 8"
  })));
};

var HandlerIcon = function HandlerIcon(props) {
  var handler = {
    12: SvgHandler12,
    16: SvgHandler16,
    18: SvgHandler18,
    24: SvgHandler24,
    32: SvgHandler32,
    48: SvgHandler48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: handler
  }, props));
};

var _path$7p;
function _extends$7v() { return _extends$7v = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$7v.apply(null, arguments); }
var SvgHeart12 = function SvgHeart12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7v({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$7p || (_path$7p = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M2.296 3.274c-.257.296-.446.736-.446 1.36 0 .592.234 1.196.639 1.794.404.596.954 1.151 1.523 1.632A14.5 14.5 0 0 0 6 9.459q.172-.1.421-.257c.43-.272 1-.663 1.567-1.142.57-.48 1.12-1.036 1.523-1.632.404-.598.639-1.202.639-1.794 0-.624-.189-1.064-.447-1.36a1.7 1.7 0 0 0-1.025-.55 1.99 1.99 0 0 0-2.13 1.17.6.6 0 0 1-1.096 0 1.99 1.99 0 0 0-2.13-1.17c-.402.062-.765.25-1.026.55M6 10.148l-.28.53h-.002l-.004-.003-.012-.006-.044-.024-.16-.09a15.656 15.656 0 0 1-2.26-1.578C2.62 8.455 1.982 7.82 1.495 7.1 1.01 6.382.65 5.545.65 4.634c0-.88.273-1.61.74-2.148a2.9 2.9 0 0 1 1.747-.948A3.2 3.2 0 0 1 6 2.555a3.2 3.2 0 0 1 2.863-1.017 2.9 2.9 0 0 1 1.746.948c.468.538.74 1.268.74 2.148 0 .911-.358 1.748-.844 2.466-.487.72-1.125 1.355-1.743 1.877a15.7 15.7 0 0 1-2.42 1.668l-.044.024-.013.006-.003.002H6.28s-.001.001-.281-.53m0 0 .28.53a.6.6 0 0 1-.56 0z",
    clipRule: "evenodd"
  })));
};

var _path$7o;
function _extends$7u() { return _extends$7u = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$7u.apply(null, arguments); }
var SvgHeart16 = function SvgHeart16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7u({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$7o || (_path$7o = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M3.024 4.332c-.352.405-.607 1.004-.607 1.846 0 .803.317 1.618.86 2.42.542.8 1.279 1.544 2.04 2.187A19.3 19.3 0 0 0 8 12.67a19.32 19.32 0 0 0 2.683-1.885c.76-.643 1.498-1.386 2.04-2.187.542-.802.86-1.617.86-2.42 0-.842-.255-1.44-.607-1.846a2.3 2.3 0 0 0-1.397-.75A2.705 2.705 0 0 0 8.684 5.17a.75.75 0 0 1-1.368 0A2.705 2.705 0 0 0 4.42 3.582a2.3 2.3 0 0 0-1.397.75M8 13.53l-.35.663h-.003l-.004-.003-.017-.01a11 11 0 0 1-.271-.15 20.809 20.809 0 0 1-3.006-2.098c-.822-.695-1.668-1.539-2.314-2.493C1.39 8.487.917 7.38.917 6.18c0-1.164.36-2.124.975-2.831A3.8 3.8 0 0 1 4.19 2.1 4.22 4.22 0 0 1 8 3.481a4.22 4.22 0 0 1 3.81-1.383 3.8 3.8 0 0 1 2.297 1.249c.616.707.976 1.667.976 2.83 0 1.202-.474 2.309-1.118 3.261-.646.954-1.493 1.798-2.315 2.492a21 21 0 0 1-3.277 2.25l-.016.009-.005.002h-.001s-.001.001-.351-.662m0 0 .35.663a.75.75 0 0 1-.7 0z",
    clipRule: "evenodd"
  })));
};

var _path$7n;
function _extends$7t() { return _extends$7t = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$7t.apply(null, arguments); }
var SvgHeart18 = function SvgHeart18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7t({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$7n || (_path$7n = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M3.37 4.845c-.404.464-.695 1.149-.695 2.106 0 .914.362 1.84.976 2.747.613.905 1.445 1.744 2.303 2.468A22 22 0 0 0 9 14.304a21.774 21.774 0 0 0 3.046-2.138c.859-.724 1.69-1.563 2.303-2.468.614-.907.976-1.833.976-2.747 0-.957-.29-1.642-.694-2.106a2.63 2.63 0 0 0-1.598-.859A3.09 3.09 0 0 0 9.73 5.8a.8.8 0 0 1-1.46 0 3.09 3.09 0 0 0-3.303-1.813 2.63 2.63 0 0 0-1.597.859M9 15.22l-.374.708-.002-.002-.005-.002-.018-.01a11 11 0 0 1-.305-.17 23.368 23.368 0 0 1-3.375-2.356c-.922-.78-1.872-1.726-2.595-2.795-.722-1.067-1.25-2.303-1.25-3.643 0-1.3.402-2.369 1.086-3.156a4.23 4.23 0 0 1 2.559-1.39A4.7 4.7 0 0 1 9 3.985a4.7 4.7 0 0 1 4.279-1.58 4.23 4.23 0 0 1 2.558 1.39c.685.787 1.087 1.857 1.087 3.156 0 1.34-.528 2.576-1.25 3.644-.724 1.068-1.673 2.015-2.596 2.794a23.4 23.4 0 0 1-3.68 2.526l-.018.01-.005.002-.001.001zm0 0 .374.708a.8.8 0 0 1-.748 0z",
    clipRule: "evenodd"
  })));
};

var _path$7m;
function _extends$7s() { return _extends$7s = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$7s.apply(null, arguments); }
var SvgHeart24 = function SvgHeart24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7s({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$7m || (_path$7m = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M4.367 6.35c-.568.653-.967 1.606-.967 2.917 0 1.265.5 2.531 1.33 3.757.828 1.223 1.95 2.353 3.1 3.325A29 29 0 0 0 12 19.265c.248-.143.592-.348 1.003-.608.867-.549 2.02-1.34 3.166-2.308 1.151-.972 2.273-2.102 3.101-3.325.83-1.226 1.33-2.492 1.33-3.757 0-1.311-.399-2.264-.966-2.917-.573-.659-1.364-1.065-2.231-1.2a4.28 4.28 0 0 0-4.582 2.513.9.9 0 0 1-1.642 0A4.28 4.28 0 0 0 6.597 5.15c-.867.135-1.657.541-2.23 1.2M12 20.295l-.42.796-.003-.002-.007-.003-.024-.013a14 14 0 0 1-.401-.224 31.003 31.003 0 0 1-4.475-3.124c-1.225-1.034-2.478-2.285-3.43-3.692-.953-1.407-1.64-3.022-1.64-4.766 0-1.696.525-3.082 1.408-4.098.879-1.01 2.068-1.603 3.312-1.798 2.022-.315 4.256.419 5.68 2.203 1.424-1.784 3.658-2.518 5.68-2.203 1.245.195 2.433.788 3.312 1.798.883 1.016 1.408 2.402 1.408 4.098 0 1.744-.687 3.36-1.639 4.766-.953 1.407-2.206 2.658-3.43 3.691a31 31 0 0 1-4.877 3.35l-.024.012-.007.003-.002.001zm0 0 .42.796a.9.9 0 0 1-.84 0z"
  })));
};

var _path$7l;
function _extends$7r() { return _extends$7r = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$7r.apply(null, arguments); }
var SvgHeart32 = function SvgHeart32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7r({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$7l || (_path$7l = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M4.942 7.873C4.086 8.857 3.5 10.278 3.5 12.2c0 1.87.74 3.725 1.938 5.494 1.196 1.768 2.81 3.392 4.457 4.783a42 42 0 0 0 4.53 3.302A40 40 0 0 0 16 26.73l.083-.047c.358-.206.873-.51 1.491-.901a42 42 0 0 0 4.53-3.303c1.648-1.39 3.262-3.015 4.459-4.783 1.197-1.77 1.937-3.623 1.937-5.494 0-1.923-.586-3.344-1.442-4.328-.862-.991-2.047-1.597-3.337-1.799-2.597-.405-5.51.838-6.809 3.734a1 1 0 0 1-1.824 0c-1.3-2.896-4.212-4.139-6.809-3.734-1.29.202-2.475.808-3.337 1.799M16 27.872l-.467.884-.004-.002-.009-.005-.032-.017-.12-.066q-.159-.085-.445-.25c-.38-.217-.92-.536-1.567-.946a44 44 0 0 1-4.751-3.464c-1.728-1.459-3.489-3.218-4.824-5.19-1.333-1.97-2.281-4.212-2.281-6.615 0-2.35.726-4.253 1.933-5.64 1.2-1.382 2.828-2.196 4.538-2.463 2.887-.45 6.086.654 8.029 3.315 1.943-2.661 5.142-3.765 8.03-3.315 1.709.267 3.336 1.081 4.537 2.462 1.207 1.388 1.933 3.29 1.933 5.641 0 2.403-.948 4.645-2.281 6.615-1.335 1.972-3.096 3.731-4.824 5.19a44 44 0 0 1-4.75 3.464 42 42 0 0 1-2.012 1.197l-.12.065-.033.017-.01.005-.003.002zm0 0 .467.884a1 1 0 0 1-.934 0z"
  })));
};

var _path$7k;
function _extends$7q() { return _extends$7q = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$7q.apply(null, arguments); }
var SvgHeart48 = function SvgHeart48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7q({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$7k || (_path$7k = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8.28 12.307c-1.24 1.427-2.08 3.477-2.08 6.228 0 2.688 1.063 5.337 2.763 7.848 1.698 2.51 3.985 4.81 6.311 6.774 2.322 1.96 4.65 3.557 6.4 4.665A56 56 0 0 0 24 39.22l.22-.125c.506-.29 1.233-.72 2.107-1.273 1.75-1.108 4.077-2.705 6.399-4.665 2.326-1.964 4.613-4.265 6.312-6.774 1.7-2.51 2.762-5.16 2.762-7.848 0-2.751-.84-4.801-2.08-6.228-1.248-1.435-2.962-2.31-4.822-2.6-3.738-.583-7.933 1.206-9.803 5.374a1.2 1.2 0 0 1-2.19 0c-1.87-4.168-6.065-5.957-9.803-5.374-1.86.29-3.574 1.165-4.821 2.6M24 40.59l-.56 1.061-.006-.003-.012-.006-.045-.024-.168-.091q-.22-.12-.622-.35a59 59 0 0 1-2.198-1.328c-1.812-1.147-4.235-2.808-6.663-4.858-2.424-2.047-4.887-4.508-6.751-7.262C5.112 24.977 3.8 21.862 3.8 18.535c0-3.264 1.008-5.892 2.67-7.803 1.654-1.903 3.9-3.027 6.262-3.396 4.076-.636 8.601.969 11.268 4.818 2.667-3.85 7.192-5.454 11.268-4.818 2.363.369 4.608 1.493 6.263 3.396 1.661 1.911 2.67 4.539 2.67 7.803 0 3.327-1.313 6.442-3.176 9.194-1.864 2.754-4.327 5.215-6.75 7.262-2.43 2.05-4.852 3.711-6.664 4.858a59 59 0 0 1-2.198 1.328 39 39 0 0 1-.79.44l-.045.025-.012.006-.005.003zm0 0 .56 1.061c-.35.185-.77.185-1.12 0z",
    clipRule: "evenodd"
  })));
};

var HeartIcon = function HeartIcon(props) {
  var heart = {
    12: SvgHeart12,
    16: SvgHeart16,
    18: SvgHeart18,
    24: SvgHeart24,
    32: SvgHeart32,
    48: SvgHeart48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: heart
  }, props));
};

var _path$7j;
function _extends$7p() { return _extends$7p = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$7p.apply(null, arguments); }
var SvgHeartFilled12 = function SvgHeartFilled12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7p({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$7j || (_path$7j = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "m6 10.148-.21.397h-.002l-.003-.002-.012-.006a5 5 0 0 1-.2-.113 15.503 15.503 0 0 1-2.237-1.562c-.613-.516-1.24-1.142-1.716-1.846C1.144 6.313.8 5.506.8 4.634c0-.848.262-1.541.704-2.05a2.74 2.74 0 0 1 1.656-.898A3.05 3.05 0 0 1 6 2.787a3.05 3.05 0 0 1 2.84-1.101 2.74 2.74 0 0 1 1.656.899c.442.508.704 1.2.704 2.049 0 .871-.344 1.68-.82 2.382-.476.704-1.103 1.33-1.715 1.846a15.5 15.5 0 0 1-2.438 1.675l-.012.006-.003.002H6.21zm0 0 .21.398a.45.45 0 0 1-.42 0z"
  })));
};

var _path$7i;
function _extends$7o() { return _extends$7o = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$7o.apply(null, arguments); }
var SvgHeartFilled16 = function SvgHeartFilled16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7o({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$7i || (_path$7i = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "m8 13.53-.28.53h-.002l-.005-.003-.015-.008-.058-.031-.21-.119a20.661 20.661 0 0 1-2.983-2.083c-.817-.689-1.652-1.522-2.288-2.461-.634-.937-1.092-2.015-1.092-3.177 0-1.13.35-2.055.939-2.732a3.65 3.65 0 0 1 2.207-1.198A4.06 4.06 0 0 1 8 3.716a4.06 4.06 0 0 1 3.787-1.468c.83.13 1.622.525 2.207 1.198.59.677.94 1.602.94 2.732 0 1.162-.459 2.24-1.093 3.177-.636.939-1.471 1.772-2.287 2.461a20.7 20.7 0 0 1-3.252 2.233l-.015.008-.005.002-.001.001zm0 0 .28.53a.6.6 0 0 1-.56 0z"
  })));
};

var _path$7h;
function _extends$7n() { return _extends$7n = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$7n.apply(null, arguments); }
var SvgHeartFilled18 = function SvgHeartFilled18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7n({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$7h || (_path$7h = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "m9 15.221-.315.597-.002-.001-.005-.003-.018-.01-.065-.034-.236-.133a23.266 23.266 0 0 1-3.356-2.343c-.919-.776-1.859-1.714-2.574-2.77C1.716 9.47 1.2 8.258 1.2 6.95c0-1.272.394-2.311 1.056-3.073A4.1 4.1 0 0 1 4.74 2.529 4.57 4.57 0 0 1 9 4.18a4.57 4.57 0 0 1 4.26-1.652c.934.145 1.825.59 2.484 1.348.663.762 1.056 1.801 1.056 3.073 0 1.308-.515 2.52-1.23 3.574-.714 1.056-1.654 1.994-2.572 2.77a23.3 23.3 0 0 1-3.658 2.51l-.017.01-.005.003h-.002zm0 0 .315.597a.68.68 0 0 1-.63 0z"
  })));
};

var _path$7g;
function _extends$7m() { return _extends$7m = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$7m.apply(null, arguments); }
var SvgHeartFilled24 = function SvgHeartFilled24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7m({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$7g || (_path$7g = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "m12 20.295-.42.796-.003-.002-.007-.003-.024-.013a14 14 0 0 1-.401-.224 31.003 31.003 0 0 1-4.475-3.124c-1.225-1.034-2.478-2.285-3.43-3.692-.953-1.407-1.64-3.022-1.64-4.766 0-1.696.525-3.082 1.408-4.098.879-1.01 2.068-1.603 3.312-1.798 2.022-.315 4.256.419 5.68 2.203 1.424-1.784 3.658-2.518 5.68-2.203 1.245.195 2.433.788 3.312 1.798.883 1.016 1.408 2.402 1.408 4.098 0 1.744-.687 3.36-1.639 4.766-.953 1.407-2.206 2.658-3.43 3.691a31 31 0 0 1-4.877 3.35l-.024.012-.007.003-.002.001zm0 0 .42.796a.9.9 0 0 1-.84 0z"
  })));
};

var _path$7f;
function _extends$7l() { return _extends$7l = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$7l.apply(null, arguments); }
var SvgHeartFilled32 = function SvgHeartFilled32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7l({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$7f || (_path$7f = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "m16 27.872-.467.884-.004-.002-.009-.005-.032-.017-.12-.066q-.159-.085-.445-.25c-.38-.217-.92-.536-1.567-.946a44 44 0 0 1-4.751-3.464c-1.728-1.459-3.489-3.218-4.824-5.19-1.333-1.97-2.281-4.212-2.281-6.615 0-2.35.726-4.253 1.933-5.64 1.2-1.382 2.828-2.196 4.538-2.463 2.887-.45 6.086.654 8.029 3.315 1.943-2.661 5.142-3.765 8.03-3.315 1.709.267 3.336 1.081 4.537 2.462 1.207 1.388 1.933 3.29 1.933 5.641 0 2.403-.948 4.645-2.281 6.615-1.335 1.972-3.096 3.731-4.824 5.19a44 44 0 0 1-4.75 3.464 42 42 0 0 1-2.012 1.197l-.12.065-.033.017-.01.005-.003.002zm0 0 .467.884a1 1 0 0 1-.934 0z",
    clipRule: "evenodd"
  })));
};

var _path$7e;
function _extends$7k() { return _extends$7k = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$7k.apply(null, arguments); }
var SvgHeartFilled48 = function SvgHeartFilled48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7k({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$7e || (_path$7e = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "m24 41.808-.7 1.326-.006-.003-.014-.007-.049-.026-.18-.098a41 41 0 0 1-.667-.375 63 63 0 0 1-2.35-1.42c-1.938-1.226-4.528-3.003-7.127-5.196-2.592-2.188-5.233-4.826-7.235-7.785-2-2.955-3.422-6.318-3.422-9.922 0-3.526 1.09-6.38 2.9-8.461 1.8-2.072 4.242-3.293 6.806-3.693 4.331-.676 9.13.98 12.044 4.971 2.914-3.99 7.713-5.647 12.044-4.971 2.564.4 5.005 1.621 6.807 3.693 1.81 2.081 2.899 4.935 2.899 8.46 0 3.605-1.422 6.968-3.422 9.923-2.002 2.959-4.643 5.597-7.235 7.785-2.599 2.193-5.19 3.97-7.127 5.196a63 63 0 0 1-2.35 1.42 41 41 0 0 1-.847.473l-.05.026-.013.007-.005.003zm0 0 .7 1.326a1.5 1.5 0 0 1-1.4 0z",
    clipRule: "evenodd"
  })));
};

var HeartFilledIcon = function HeartFilledIcon(props) {
  var heartFilled = {
    12: SvgHeartFilled12,
    16: SvgHeartFilled16,
    18: SvgHeartFilled18,
    24: SvgHeartFilled24,
    32: SvgHeartFilled32,
    48: SvgHeartFilled48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: heartFilled
  }, props));
};

var _path$7d;
function _extends$7j() { return _extends$7j = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$7j.apply(null, arguments); }
var SvgHome12 = function SvgHome12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7j({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$7d || (_path$7d = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M6.375.782a.6.6 0 0 0-.75 0l-4.75 3.8a.6.6 0 0 0 .725.955V8.85c0 1.118.907 2.025 2.025 2.025H5.05a.6.6 0 0 0 .6-.6v-2.85a.35.35 0 1 1 .7 0v2.85a.6.6 0 0 0 .6.6h1.425A2.025 2.025 0 0 0 10.4 8.85V5.537a.6.6 0 0 0 .725-.955zM9.2 4.578 6 2.018l-3.2 2.56V8.85c0 .456.37.825.825.825h.825v-2.25a1.55 1.55 0 0 1 3.1 0v2.25h.825c.456 0 .825-.37.825-.825z",
    clipRule: "evenodd"
  })));
};

var _path$7c;
function _extends$7i() { return _extends$7i = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$7i.apply(null, arguments); }
var SvgHome16 = function SvgHome16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7i({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$7c || (_path$7c = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8.469 1.081a.75.75 0 0 0-.937 0L1.198 6.148a.75.75 0 0 0 .937 1.17l.048-.038v4.52a2.65 2.65 0 0 0 2.65 2.65h1.9a.75.75 0 0 0 .75-.75V9.9a.517.517 0 1 1 1.034 0v3.8c0 .414.336.75.75.75h1.9a2.65 2.65 0 0 0 2.65-2.65V7.28l.048.039a.75.75 0 0 0 .937-1.171zm3.848 5L8 2.626 3.683 6.08v5.72c0 .635.515 1.15 1.15 1.15h1.15V9.9a2.017 2.017 0 0 1 4.034 0v3.05h1.15a1.15 1.15 0 0 0 1.15-1.15z",
    clipRule: "evenodd"
  })));
};

var _path$7b;
function _extends$7h() { return _extends$7h = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$7h.apply(null, arguments); }
var SvgHome18 = function SvgHome18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7h({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$7b || (_path$7b = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M9.5 1.25a.8.8 0 0 0-1 0l-7.125 5.7a.8.8 0 0 0 1 1.25l.125-.1v5.175a2.937 2.937 0 0 0 2.937 2.937h2.138a.8.8 0 0 0 .8-.8v-4.275a.625.625 0 0 1 1.25 0v4.275a.8.8 0 0 0 .8.8h2.137a2.937 2.937 0 0 0 2.938-2.937V8.099l.125.1a.8.8 0 0 0 1-1.249zm4.4 5.57L9 2.9 4.1 6.82v6.455c0 .739.599 1.337 1.337 1.337h1.338v-3.475a2.225 2.225 0 0 1 4.45 0v3.475h1.338c.738 0 1.337-.598 1.337-1.337z",
    clipRule: "evenodd"
  })));
};

var _path$7a;
function _extends$7g() { return _extends$7g = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$7g.apply(null, arguments); }
var SvgHome24 = function SvgHome24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7g({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$7a || (_path$7a = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M12.562 1.797a.9.9 0 0 0-1.125 0l-9.5 7.6a.9.9 0 1 0 1.125 1.406l.438-.35V17.7a3.75 3.75 0 0 0 3.75 3.75h2.85a.9.9 0 0 0 .9-.9v-5.7a1 1 0 1 1 2 0v5.7a.9.9 0 0 0 .9.9h2.85a3.75 3.75 0 0 0 3.75-3.75v-7.248l.437.35a.9.9 0 0 0 1.125-1.405zM18.7 9.012 12 3.652l-6.7 5.36V17.7a1.95 1.95 0 0 0 1.95 1.95H9.2v-4.8a2.8 2.8 0 1 1 5.6 0v4.8h1.95a1.95 1.95 0 0 0 1.95-1.95z",
    clipRule: "evenodd"
  })));
};

var _path$79;
function _extends$7f() { return _extends$7f = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$7f.apply(null, arguments); }
var SvgHome32 = function SvgHome32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7f({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$79 || (_path$79 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M16.625 2.553a1 1 0 0 0-1.25 0L2.71 12.686a1 1 0 0 0 1.249 1.562l.909-.727V23.6a4.8 4.8 0 0 0 4.8 4.8h3.8a1 1 0 0 0 1-1v-7.6a1.533 1.533 0 0 1 3.066 0v7.6a1 1 0 0 0 1 1h3.8a4.8 4.8 0 0 0 4.8-4.8V13.52l.909.728a1 1 0 1 0 1.25-1.562zm8.508 9.368L16 4.614l-9.133 7.307V23.6a2.8 2.8 0 0 0 2.8 2.8h2.8v-6.6a3.533 3.533 0 1 1 7.066 0v6.6h2.8a2.8 2.8 0 0 0 2.8-2.8z",
    clipRule: "evenodd"
  })));
};

var _path$78;
function _extends$7e() { return _extends$7e = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$7e.apply(null, arguments); }
var SvgHome48 = function SvgHome48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7e({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$78 || (_path$78 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M24.75 4.063a1.2 1.2 0 0 0-1.5 0l-19 15.2a1.2 1.2 0 0 0 1.5 1.874l1.85-1.48V35.4a6.9 6.9 0 0 0 6.9 6.9h5.7a1.2 1.2 0 0 0 1.2-1.2V29.7a2.6 2.6 0 1 1 5.2 0v11.4a1.2 1.2 0 0 0 1.2 1.2h5.7a6.9 6.9 0 0 0 6.9-6.9V19.657l1.85 1.48a1.2 1.2 0 1 0 1.5-1.874zM38 17.737l-14-11.2-14 11.2V35.4a4.5 4.5 0 0 0 4.5 4.5H19V29.7a5 5 0 1 1 10 0v10.2h4.5a4.5 4.5 0 0 0 4.5-4.5z",
    clipRule: "evenodd"
  })));
};

var HomeIcon = function HomeIcon(props) {
  var home = {
    12: SvgHome12,
    16: SvgHome16,
    18: SvgHome18,
    24: SvgHome24,
    32: SvgHome32,
    48: SvgHome48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: home
  }, props));
};

var _path$77;
function _extends$7d() { return _extends$7d = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$7d.apply(null, arguments); }
var SvgHomeFilled12 = function SvgHomeFilled12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7d({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$77 || (_path$77 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M6.375.782a.6.6 0 0 0-.75 0l-4.75 3.8a.6.6 0 0 0 .725.955V8.85c0 1.118.907 2.025 2.025 2.025H5.05a.6.6 0 0 0 .6-.6v-2.85a.35.35 0 1 1 .7 0v2.85a.6.6 0 0 0 .6.6h1.425A2.025 2.025 0 0 0 10.4 8.85V5.537a.6.6 0 0 0 .725-.955z"
  })));
};

var _path$76;
function _extends$7c() { return _extends$7c = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$7c.apply(null, arguments); }
var SvgHomeFilled16 = function SvgHomeFilled16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7c({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$76 || (_path$76 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8.469 1.081a.75.75 0 0 0-.937 0L1.198 6.148a.75.75 0 0 0 .937 1.17l.048-.038v4.52a2.65 2.65 0 0 0 2.65 2.65h1.9a.75.75 0 0 0 .75-.75V9.9a.517.517 0 1 1 1.034 0v3.8c0 .414.336.75.75.75h1.9a2.65 2.65 0 0 0 2.65-2.65V7.28l.048.039a.75.75 0 0 0 .937-1.171z",
    clipRule: "evenodd"
  })));
};

var _path$75;
function _extends$7b() { return _extends$7b = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$7b.apply(null, arguments); }
var SvgHomeFilled18 = function SvgHomeFilled18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7b({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$75 || (_path$75 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M9.5 1.25a.8.8 0 0 0-1 0l-7.125 5.7a.8.8 0 1 0 1 1.25l.125-.1v5.175a2.937 2.937 0 0 0 2.938 2.937h2.137a.8.8 0 0 0 .8-.8v-4.275a.625.625 0 0 1 1.25 0v4.275a.8.8 0 0 0 .8.8h2.138a2.937 2.937 0 0 0 2.937-2.937V8.099l.126.1a.8.8 0 1 0 .999-1.249z"
  })));
};

var _path$74;
function _extends$7a() { return _extends$7a = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$7a.apply(null, arguments); }
var SvgHomeFilled24 = function SvgHomeFilled24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7a({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$74 || (_path$74 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M12.562 1.798a.9.9 0 0 0-1.125 0l-9.5 7.6a.9.9 0 0 0 1.125 1.405l.438-.35v7.098a3.9 3.9 0 0 0 3.9 3.9H10a.9.9 0 0 0 .9-.9V15a1.1 1.1 0 0 1 2.2 0v5.55a.9.9 0 0 0 .9.9h2.6a3.9 3.9 0 0 0 3.9-3.9v-7.098l.437.35a.9.9 0 0 0 1.125-1.405z"
  })));
};

var _path$73;
function _extends$79() { return _extends$79 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$79.apply(null, arguments); }
var SvgHomeFilled32 = function SvgHomeFilled32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$79({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$73 || (_path$73 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M16.625 2.553a1 1 0 0 0-1.25 0L2.71 12.686a1 1 0 0 0 1.25 1.562l.908-.727V23.6a4.8 4.8 0 0 0 4.8 4.8h3.8a1 1 0 0 0 1-1v-7.6a1.533 1.533 0 1 1 3.066 0v7.6a1 1 0 0 0 1 1h3.8a4.8 4.8 0 0 0 4.8-4.8V13.52l.91.728a1 1 0 1 0 1.249-1.562z"
  })));
};

var _path$72;
function _extends$78() { return _extends$78 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$78.apply(null, arguments); }
var SvgHomeFilled48 = function SvgHomeFilled48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$78({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$72 || (_path$72 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M24.75 4.063a1.2 1.2 0 0 0-1.5 0l-19 15.2a1.2 1.2 0 0 0 1.5 1.874l1.85-1.48V35.4a6.9 6.9 0 0 0 6.9 6.9h5.7a1.2 1.2 0 0 0 1.2-1.2V29.7a2.6 2.6 0 0 1 5.2 0v11.4a1.2 1.2 0 0 0 1.2 1.2h5.7a6.9 6.9 0 0 0 6.9-6.9V19.657l1.85 1.48a1.2 1.2 0 0 0 1.5-1.874z"
  })));
};

var HomeFilledIcon = function HomeFilledIcon(props) {
  var homeFilled = {
    12: SvgHomeFilled12,
    16: SvgHomeFilled16,
    18: SvgHomeFilled18,
    24: SvgHomeFilled24,
    32: SvgHomeFilled32,
    48: SvgHomeFilled48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: homeFilled
  }, props));
};

var _path$71;
function _extends$77() { return _extends$77 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$77.apply(null, arguments); }
var SvgInfoFilled12 = function SvgInfoFilled12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$77({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$71 || (_path$71 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M6 11A5 5 0 1 0 6 1a5 5 0 0 0 0 10m0-2.3a.6.6 0 0 1-.6-.6v-2a.6.6 0 0 1 1.2 0v2a.6.6 0 0 1-.6.6m0-3.8a.6.6 0 0 1-.6-.6v-.05a.6.6 0 0 1 1.2 0v.05a.6.6 0 0 1-.6.6",
    clipRule: "evenodd"
  })));
};

var _path$70;
function _extends$76() { return _extends$76 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$76.apply(null, arguments); }
var SvgInfoFilled16 = function SvgInfoFilled16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$76({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$70 || (_path$70 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8 14.667A6.667 6.667 0 1 0 8 1.334a6.667 6.667 0 0 0 0 13.333M7.25 10.4a.75.75 0 0 0 1.5 0V7.6a.75.75 0 1 0-1.5 0zm0-4.8a.75.75 0 0 0 1.5 0v-.067a.75.75 0 1 0-1.5 0z",
    clipRule: "evenodd"
  })));
};

var _path$6$;
function _extends$75() { return _extends$75 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$75.apply(null, arguments); }
var SvgInfoFilled18 = function SvgInfoFilled18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$75({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$6$ || (_path$6$ = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M9 16.5a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15m-.8-4.7a.8.8 0 0 0 1.6 0V8.65a.8.8 0 1 0-1.6 0zm0-5.4a.8.8 0 1 0 1.6 0v-.075a.8.8 0 1 0-1.6 0z",
    clipRule: "evenodd"
  })));
};

var _path$6_;
function _extends$74() { return _extends$74 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$74.apply(null, arguments); }
var SvgInfoFilled24 = function SvgInfoFilled24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$74({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$6_ || (_path$6_ = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10m-.9-6.5a.9.9 0 0 0 1.8 0v-4.2a.9.9 0 0 0-1.8 0zm0-6.7a.9.9 0 0 0 1.8 0v-.1a.9.9 0 1 0-1.8 0z",
    clipRule: "evenodd"
  })));
};

var _path$6Z;
function _extends$73() { return _extends$73 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$73.apply(null, arguments); }
var SvgInfoFilled32 = function SvgInfoFilled32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$73({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$6Z || (_path$6Z = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M16 29.333c7.363 0 13.333-5.97 13.333-13.333S23.363 2.667 15.999 2.667 2.666 8.636 2.666 16s5.97 13.333 13.333 13.333m0-7.666a1 1 0 0 1-1-1v-5.6a1 1 0 1 1 2 0v5.6a1 1 0 0 1-1 1m0-8.934a1 1 0 0 1-1-1V11.6a1 1 0 1 1 2 0v.133a1 1 0 0 1-1 1",
    clipRule: "evenodd"
  })));
};

var _path$6Y;
function _extends$72() { return _extends$72 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$72.apply(null, arguments); }
var SvgInfoFilled48 = function SvgInfoFilled48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$72({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$6Y || (_path$6Y = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M24 44c11.046 0 20-8.954 20-20S35.046 4 24 4 4 12.954 4 24s8.954 20 20 20m0-12.35c-.69 0-1.25-.56-1.25-1.25V22a1.25 1.25 0 1 1 2.5 0v8.4c0 .69-.56 1.25-1.25 1.25m0-12.8c-.69 0-1.25-.56-1.25-1.25v-.2a1.25 1.25 0 0 1 2.5 0v.2c0 .69-.56 1.25-1.25 1.25",
    clipRule: "evenodd"
  })));
};

var InfoFilledIcon = function InfoFilledIcon(props) {
  var infoFilled = {
    12: SvgInfoFilled12,
    16: SvgInfoFilled16,
    18: SvgInfoFilled18,
    24: SvgInfoFilled24,
    32: SvgInfoFilled32,
    48: SvgInfoFilled48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: infoFilled
  }, props));
};

var _path$6X, _path2$2k;
function _extends$71() { return _extends$71 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$71.apply(null, arguments); }
var SvgLaunch12 = function SvgLaunch12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$71({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$6X || (_path$6X = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M4 2.6A1.4 1.4 0 0 0 2.6 4v4A1.4 1.4 0 0 0 4 9.4h4A1.4 1.4 0 0 0 9.4 8V6.25a.6.6 0 1 1 1.2 0V8A2.6 2.6 0 0 1 8 10.6H4A2.6 2.6 0 0 1 1.4 8V4A2.6 2.6 0 0 1 4 1.4h1.75a.6.6 0 0 1 0 1.2z",
    clipRule: "evenodd"
  })), _path2$2k || (_path2$2k = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M7.15 1.5a.6.6 0 0 1 .6-.6h2.75a.6.6 0 0 1 .6.6v2.75a.6.6 0 1 1-1.2 0V2.949L6.674 6.174a.6.6 0 0 1-.848-.848L9.052 2.1H7.75a.6.6 0 0 1-.6-.6",
    clipRule: "evenodd"
  })));
};

var _path$6W, _path2$2j;
function _extends$70() { return _extends$70 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$70.apply(null, arguments); }
var SvgLaunch16 = function SvgLaunch16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$70({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$6W || (_path$6W = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M5.167 3.417a1.75 1.75 0 0 0-1.75 1.75v5.666c0 .967.783 1.75 1.75 1.75h5.666a1.75 1.75 0 0 0 1.75-1.75v-2.5a.75.75 0 0 1 1.5 0v2.5a3.25 3.25 0 0 1-3.25 3.25H5.167a3.25 3.25 0 0 1-3.25-3.25V5.167a3.25 3.25 0 0 1 3.25-3.25h2.5a.75.75 0 1 1 0 1.5z",
    clipRule: "evenodd"
  })), _path2$2j || (_path2$2j = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M9.583 2a.75.75 0 0 1 .75-.75H14a.75.75 0 0 1 .75.75v3.667a.75.75 0 0 1-1.5 0V3.81L8.864 8.197a.75.75 0 0 1-1.06-1.06l4.385-4.387h-1.856a.75.75 0 0 1-.75-.75",
    clipRule: "evenodd"
  })));
};

var _path$6V, _path2$2i;
function _extends$6$() { return _extends$6$ = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$6$.apply(null, arguments); }
var SvgLaunch18 = function SvgLaunch18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6$({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$6V || (_path$6V = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M6 3.8A2.2 2.2 0 0 0 3.8 6v6A2.2 2.2 0 0 0 6 14.2h6a2.2 2.2 0 0 0 2.2-2.2V9.375a.8.8 0 1 1 1.6 0V12a3.8 3.8 0 0 1-3.8 3.8H6A3.8 3.8 0 0 1 2.2 12V6A3.8 3.8 0 0 1 6 2.2h2.625a.8.8 0 1 1 0 1.6z",
    clipRule: "evenodd"
  })), _path2$2i || (_path2$2i = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M11.625 3.05a.8.8 0 1 1 0-1.6h4.125a.8.8 0 0 1 .8.8v4.125a.8.8 0 0 1-1.6 0V4.181l-5.01 5.01a.8.8 0 1 1-1.13-1.132l5.009-5.009z",
    clipRule: "evenodd"
  })));
};

var _path$6U, _path2$2h;
function _extends$6_() { return _extends$6_ = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$6_.apply(null, arguments); }
var SvgLaunch24 = function SvgLaunch24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6_({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$6U || (_path$6U = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8 4.9A3.1 3.1 0 0 0 4.9 8v8A3.1 3.1 0 0 0 8 19.1h8a3.1 3.1 0 0 0 3.1-3.1v-3.5a.9.9 0 1 1 1.8 0V16a4.9 4.9 0 0 1-4.9 4.9H8A4.9 4.9 0 0 1 3.1 16V8A4.9 4.9 0 0 1 8 3.1h3.5a.9.9 0 1 1 0 1.8z",
    clipRule: "evenodd"
  })), _path2$2h || (_path2$2h = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M14.6 3a.9.9 0 0 1 .9-.9H21a.9.9 0 0 1 .9.9v5.5a.9.9 0 1 1-1.8 0V5.173l-6.964 6.963a.9.9 0 0 1-1.272-1.272L18.827 3.9H15.5a.9.9 0 0 1-.9-.9",
    clipRule: "evenodd"
  })));
};

var _path$6T, _path2$2g;
function _extends$6Z() { return _extends$6Z = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$6Z.apply(null, arguments); }
var SvgLaunch32 = function SvgLaunch32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6Z({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$6T || (_path$6T = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M10.333 6.333a4 4 0 0 0-4 4v11.334a4 4 0 0 0 4 4h11.334a4 4 0 0 0 4-4v-5a1 1 0 1 1 2 0v5a6 6 0 0 1-6 6H10.333a6 6 0 0 1-6-6V10.333a6 6 0 0 1 6-6h5a1 1 0 0 1 0 2z",
    clipRule: "evenodd"
  })), _path2$2g || (_path2$2g = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M19.667 4a1 1 0 0 1 1-1H28a1 1 0 0 1 1 1v7.333a1 1 0 1 1-2 0V6.414l-9.626 9.626a1 1 0 1 1-1.414-1.414L25.586 5h-4.92a1 1 0 0 1-1-1",
    clipRule: "evenodd"
  })));
};

var _path$6S, _path2$2f;
function _extends$6Y() { return _extends$6Y = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$6Y.apply(null, arguments); }
var SvgLaunch48 = function SvgLaunch48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6Y({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$6S || (_path$6S = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M14 9.2A4.8 4.8 0 0 0 9.2 14v20a4.8 4.8 0 0 0 4.8 4.8h20a4.8 4.8 0 0 0 4.8-4.8v-9a1.2 1.2 0 0 1 2.4 0v9a7.2 7.2 0 0 1-7.2 7.2H14A7.2 7.2 0 0 1 6.8 34V14A7.2 7.2 0 0 1 14 6.8h9a1.2 1.2 0 1 1 0 2.4z",
    clipRule: "evenodd"
  })), _path2$2f || (_path2$2f = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M31 7.2a1.2 1.2 0 0 1 0-2.4h11A1.2 1.2 0 0 1 43.2 6v11a1.2 1.2 0 0 1-2.4 0V8.897L25.849 23.85a1.2 1.2 0 0 1-1.698-1.698l14.952-14.95z",
    clipRule: "evenodd"
  })));
};

var LaunchIcon = function LaunchIcon(props) {
  var launch = {
    12: SvgLaunch12,
    16: SvgLaunch16,
    18: SvgLaunch18,
    24: SvgLaunch24,
    32: SvgLaunch32,
    48: SvgLaunch48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: launch
  }, props));
};

var _path$6R;
function _extends$6X() { return _extends$6X = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$6X.apply(null, arguments); }
var SvgLink12 = function SvgLink12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6X({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$6R || (_path$6R = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M.9 6a2.6 2.6 0 0 1 2.6-2.6H5a.6.6 0 0 1 0 1.2H3.5a1.4 1.4 0 0 0 0 2.8H5a.6.6 0 0 1 0 1.2H3.5A2.6 2.6 0 0 1 .9 6m5.5-2a.6.6 0 0 1 .6-.6h1.5a2.6 2.6 0 0 1 0 5.2H7a.6.6 0 1 1 0-1.2h1.5a1.4 1.4 0 1 0 0-2.8H7a.6.6 0 0 1-.6-.6M3 6a.6.6 0 0 1 .6-.6h4.8a.6.6 0 0 1 0 1.2H3.6A.6.6 0 0 1 3 6",
    clipRule: "evenodd"
  })));
};

var _path$6Q;
function _extends$6W() { return _extends$6W = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$6W.apply(null, arguments); }
var SvgLink16 = function SvgLink16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6W({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$6Q || (_path$6Q = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M1.25 8a3.417 3.417 0 0 1 3.417-3.417h2a.75.75 0 0 1 0 1.5h-2a1.917 1.917 0 1 0 0 3.834h2a.75.75 0 0 1 0 1.5h-2A3.417 3.417 0 0 1 1.25 8m7.333-2.667a.75.75 0 0 1 .75-.75h2a3.417 3.417 0 1 1 0 6.834h-2a.75.75 0 0 1 0-1.5h2a1.917 1.917 0 1 0 0-3.834h-2a.75.75 0 0 1-.75-.75M3.917 8a.75.75 0 0 1 .75-.75h6.666a.75.75 0 0 1 0 1.5H4.667a.75.75 0 0 1-.75-.75",
    clipRule: "evenodd"
  })));
};

var _path$6P;
function _extends$6V() { return _extends$6V = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$6V.apply(null, arguments); }
var SvgLink18 = function SvgLink18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6V({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$6P || (_path$6P = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M1.45 9a3.8 3.8 0 0 1 3.8-3.8H7.5a.8.8 0 1 1 0 1.6H5.25a2.2 2.2 0 1 0 0 4.4H7.5a.8.8 0 1 1 0 1.6H5.25A3.8 3.8 0 0 1 1.45 9M9.7 6a.8.8 0 0 1 .8-.8h2.25a3.8 3.8 0 0 1 0 7.6H10.5a.8.8 0 1 1 0-1.6h2.25a2.2 2.2 0 0 0 0-4.4H10.5a.8.8 0 0 1-.8-.8M4.45 9a.8.8 0 0 1 .8-.8h7.5a.8.8 0 0 1 0 1.6h-7.5a.8.8 0 0 1-.8-.8",
    clipRule: "evenodd"
  })));
};

var _path$6O;
function _extends$6U() { return _extends$6U = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$6U.apply(null, arguments); }
var SvgLink24 = function SvgLink24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6U({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$6O || (_path$6O = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M2.1 12A4.9 4.9 0 0 1 7 7.1h3a.9.9 0 1 1 0 1.8H7a3.1 3.1 0 0 0 0 6.2h3a.9.9 0 1 1 0 1.8H7A4.9 4.9 0 0 1 2.1 12m11-4a.9.9 0 0 1 .9-.9h3a4.9 4.9 0 1 1 0 9.8h-3a.9.9 0 0 1 0-1.8h3a3.1 3.1 0 1 0 0-6.2h-3a.9.9 0 0 1-.9-.9m-7 4a.9.9 0 0 1 .9-.9h10a.9.9 0 1 1 0 1.8H7a.9.9 0 0 1-.9-.9",
    clipRule: "evenodd"
  })));
};

var _path$6N;
function _extends$6T() { return _extends$6T = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$6T.apply(null, arguments); }
var SvgLink32 = function SvgLink32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6T({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$6N || (_path$6N = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M3 16a6.333 6.333 0 0 1 6.333-6.333h4a1 1 0 1 1 0 2h-4a4.333 4.333 0 0 0 0 8.666h4a1 1 0 1 1 0 2h-4A6.333 6.333 0 0 1 3 16m14.667-5.333a1 1 0 0 1 1-1h4a6.333 6.333 0 0 1 0 12.666h-4a1 1 0 1 1 0-2h4a4.333 4.333 0 0 0 0-8.666h-4a1 1 0 0 1-1-1M8.333 16a1 1 0 0 1 1-1h13.334a1 1 0 1 1 0 2H9.333a1 1 0 0 1-1-1",
    clipRule: "evenodd"
  })));
};

var _path$6M;
function _extends$6S() { return _extends$6S = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$6S.apply(null, arguments); }
var SvgLink48 = function SvgLink48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6S({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$6M || (_path$6M = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M5 24a9.2 9.2 0 0 1 9.2-9.2h6a1.2 1.2 0 0 1 0 2.4h-6a6.8 6.8 0 0 0 0 13.6h6a1.2 1.2 0 0 1 0 2.4h-6A9.2 9.2 0 0 1 5 24m22-8a1.2 1.2 0 0 1 1.2-1.2h6a9.2 9.2 0 0 1 0 18.4h-6a1.2 1.2 0 0 1 0-2.4h6a6.8 6.8 0 1 0 0-13.6h-6A1.2 1.2 0 0 1 27 16m-14 8a1.2 1.2 0 0 1 1.2-1.2h20a1.2 1.2 0 0 1 0 2.4h-20A1.2 1.2 0 0 1 13 24",
    clipRule: "evenodd"
  })));
};

var LinkIcon = function LinkIcon(props) {
  var link = {
    12: SvgLink12,
    16: SvgLink16,
    18: SvgLink18,
    24: SvgLink24,
    32: SvgLink32,
    48: SvgLink48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: link
  }, props));
};

var _path$6L, _path2$2e;
function _extends$6R() { return _extends$6R = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$6R.apply(null, arguments); }
var SvgLocation12 = function SvgLocation12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6R({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$6L || (_path$6L = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M6 5.55a.3.3 0 1 0 0-.6.3.3 0 0 0 0 .6m0 1.2a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3",
    clipRule: "evenodd"
  })), _path2$2e || (_path2$2e = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8.043 7.368C8.686 6.508 9.05 5.69 9.05 5c0-1.479-1.296-2.8-3.05-2.8S2.95 3.521 2.95 5c0 .69.364 1.508 1.007 2.368.624.835 1.403 1.567 1.987 2.06.023.02.043.024.056.024a.1.1 0 0 0 .056-.023c.584-.494 1.363-1.226 1.987-2.061m-1.212 2.977C8.068 9.3 10.25 7.15 10.25 5c0-2.21-1.903-4-4.25-4S1.75 2.79 1.75 5c0 2.15 2.182 4.3 3.419 5.345.485.41 1.177.41 1.662 0",
    clipRule: "evenodd"
  })));
};

var _path$6K, _path2$2d;
function _extends$6Q() { return _extends$6Q = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$6Q.apply(null, arguments); }
var SvgLocation16 = function SvgLocation16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6Q({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$6K || (_path$6K = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8 7.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1M8 9a2 2 0 1 0 0-4 2 2 0 0 0 0 4",
    clipRule: "evenodd"
  })), _path2$2d || (_path2$2d = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M10.804 9.884c.862-1.153 1.363-2.265 1.363-3.217 0-2.033-1.779-3.834-4.167-3.834S3.833 4.634 3.833 6.667c0 .952.501 2.064 1.363 3.217.838 1.122 1.883 2.104 2.664 2.764.05.042.099.055.14.055s.09-.013.14-.055c.78-.66 1.826-1.642 2.664-2.764m-1.696 3.91c1.65-1.395 4.559-4.261 4.559-7.127 0-2.946-2.537-5.334-5.667-5.334S2.333 3.721 2.333 6.667c0 2.866 2.91 5.732 4.559 7.127.646.546 1.57.546 2.216 0",
    clipRule: "evenodd"
  })));
};

var _path$6J, _path2$2c;
function _extends$6P() { return _extends$6P = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$6P.apply(null, arguments); }
var SvgLocation18 = function SvgLocation18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6P({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$6J || (_path$6J = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M9 8.525a.65.65 0 1 0 0-1.3.65.65 0 0 0 0 1.3m0 1.6a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5",
    clipRule: "evenodd"
  })), _path2$2c || (_path2$2c = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M12.225 11.172c.973-1.303 1.55-2.572 1.55-3.672 0-2.34-2.045-4.4-4.775-4.4S4.225 5.16 4.225 7.5c0 1.1.577 2.37 1.55 3.672.949 1.27 2.13 2.379 3.012 3.124.071.06.146.083.213.083a.33.33 0 0 0 .213-.083c.882-.745 2.063-1.855 3.012-3.124m-1.979 4.346c1.856-1.57 5.129-4.794 5.129-8.018 0-3.314-2.854-6-6.375-6s-6.375 2.686-6.375 6c0 3.224 3.273 6.449 5.129 8.018a1.915 1.915 0 0 0 2.492 0",
    clipRule: "evenodd"
  })));
};

var _path$6I, _path2$2b;
function _extends$6O() { return _extends$6O = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$6O.apply(null, arguments); }
var SvgLocation24 = function SvgLocation24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6O({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$6I || (_path$6I = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M12 11.7a1.2 1.2 0 1 0 0-2.4 1.2 1.2 0 0 0 0 2.4m0 1.8a3 3 0 1 0 0-6 3 3 0 0 0 0 6",
    clipRule: "evenodd"
  })), _path2$2b || (_path2$2b = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M16.567 15.095C17.881 13.337 18.7 11.573 18.7 10c0-3.323-2.895-6.2-6.7-6.2S5.3 6.677 5.3 10c0 1.573.82 3.337 2.133 5.095 1.286 1.721 2.883 3.22 4.067 4.22a.754.754 0 0 0 1 0c1.184-1 2.78-2.499 4.067-4.22m-2.905 5.595C16.136 18.598 20.5 14.3 20.5 10c0-4.418-3.806-8-8.5-8s-8.5 3.582-8.5 8c0 4.3 4.364 8.598 6.838 10.69.97.82 2.355.82 3.324 0",
    clipRule: "evenodd"
  })));
};

var _path$6H, _path2$2a;
function _extends$6N() { return _extends$6N = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$6N.apply(null, arguments); }
var SvgLocation32 = function SvgLocation32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6N({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$6H || (_path$6H = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M16 16a2 2 0 1 0 0-4 2 2 0 0 0 0 4m0 2a4 4 0 1 0 0-8 4 4 0 0 0 0 8",
    clipRule: "evenodd"
  })), _path2$2a || (_path2$2a = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M22.41 20.366c1.77-2.37 2.923-4.807 2.923-7.033 0-4.674-4.062-8.666-9.333-8.666-5.27 0-9.333 3.992-9.333 8.666 0 2.226 1.152 4.664 2.923 7.033 1.74 2.329 3.894 4.348 5.485 5.694a1.406 1.406 0 0 0 1.85 0c1.59-1.346 3.745-3.365 5.485-5.694m-4.194 7.22c3.299-2.788 9.117-8.52 9.117-14.253 0-5.89-5.074-10.666-11.333-10.666S4.667 7.442 4.667 13.333c0 5.732 5.818 11.465 9.117 14.254a3.405 3.405 0 0 0 4.432 0",
    clipRule: "evenodd"
  })));
};

var _path$6G, _path2$29;
function _extends$6M() { return _extends$6M = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$6M.apply(null, arguments); }
var SvgLocation48 = function SvgLocation48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6M({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$6G || (_path$6G = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M24 24.6a3.6 3.6 0 1 0 0-7.2 3.6 3.6 0 0 0 0 7.2m0 2.4a6 6 0 1 0 0-12 6 6 0 0 0 0 12",
    clipRule: "evenodd"
  })), _path2$29 || (_path2$29 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M34.095 30.909C36.78 27.316 38.6 23.53 38.6 20c0-7.376-6.398-13.6-14.6-13.6S9.4 12.624 9.4 20c0 3.53 1.82 7.316 4.505 10.909 2.648 3.544 5.917 6.606 8.32 8.639a2.71 2.71 0 0 0 3.55 0c2.404-2.033 5.672-5.096 8.32-8.64M27.324 41.38C32.272 37.196 41 28.598 41 20c0-8.837-7.611-16-17-16S7 11.163 7 20c0 8.598 8.728 17.196 13.676 21.38a5.11 5.11 0 0 0 6.648 0",
    clipRule: "evenodd"
  })));
};

var LocationIcon = function LocationIcon(props) {
  var location = {
    12: SvgLocation12,
    16: SvgLocation16,
    18: SvgLocation18,
    24: SvgLocation24,
    32: SvgLocation32,
    48: SvgLocation48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: location
  }, props));
};

var _path$6F;
function _extends$6L() { return _extends$6L = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$6L.apply(null, arguments); }
var SvgLocationFilled12 = function SvgLocationFilled12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6L({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$6F || (_path$6F = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M6.831 10.519c-.485.41-1.177.41-1.662 0C3.932 9.473 1.75 7.323 1.75 5.174c0-2.21 1.903-4 4.25-4s4.25 1.79 4.25 4c0 2.15-2.182 4.299-3.419 5.345M6 6.924a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"
  })));
};

var _path$6E;
function _extends$6K() { return _extends$6K = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$6K.apply(null, arguments); }
var SvgLocationFilled16 = function SvgLocationFilled16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6K({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$6E || (_path$6E = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M8 1.333c-3.13 0-5.667 2.388-5.667 5.334 0 2.866 2.91 5.732 4.559 7.127.646.546 1.57.546 2.216 0 1.65-1.395 4.559-4.261 4.559-7.127 0-2.946-2.537-5.334-5.667-5.334M8 9a2 2 0 1 1 0-4 2 2 0 0 1 0 4"
  })));
};

var _path$6D;
function _extends$6J() { return _extends$6J = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$6J.apply(null, arguments); }
var SvgLocationFilled18 = function SvgLocationFilled18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6J({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$6D || (_path$6D = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M10.247 15.518a1.915 1.915 0 0 1-2.493 0c-1.856-1.57-5.129-4.794-5.129-8.018 0-3.314 2.854-6 6.375-6s6.375 2.686 6.375 6c0 3.224-3.273 6.449-5.129 8.018M9 10.125a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5"
  })));
};

var _path$6C;
function _extends$6I() { return _extends$6I = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$6I.apply(null, arguments); }
var SvgLocationFilled24 = function SvgLocationFilled24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6I({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$6C || (_path$6C = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M13.662 20.69c-.97.82-2.355.82-3.324 0C7.864 18.598 3.5 14.3 3.5 10c0-4.418 3.806-8 8.5-8s8.5 3.582 8.5 8c0 4.3-4.364 8.598-6.838 10.69M12 13.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6"
  })));
};

var _path$6B;
function _extends$6H() { return _extends$6H = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$6H.apply(null, arguments); }
var SvgLocationFilled32 = function SvgLocationFilled32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6H({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$6B || (_path$6B = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M18.216 27.587a3.405 3.405 0 0 1-4.432 0c-3.299-2.79-9.117-8.522-9.117-14.254C4.667 7.443 9.74 2.667 16 2.667s11.333 4.775 11.333 10.666c0 5.732-5.818 11.465-9.117 14.254M16 18a4 4 0 1 0 0-8 4 4 0 0 0 0 8"
  })));
};

var _path$6A;
function _extends$6G() { return _extends$6G = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$6G.apply(null, arguments); }
var SvgLocationFilled48 = function SvgLocationFilled48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6G({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$6A || (_path$6A = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M27.324 41.38a5.11 5.11 0 0 1-6.648 0C15.728 37.196 7 28.598 7 20c0-8.837 7.611-16 17-16s17 7.163 17 16c0 8.598-8.728 17.196-13.676 21.38M24 27a6 6 0 1 0 0-12 6 6 0 0 0 0 12"
  })));
};

var LocationFilledIcon = function LocationFilledIcon(props) {
  var locationFilled = {
    12: SvgLocationFilled12,
    16: SvgLocationFilled16,
    18: SvgLocationFilled18,
    24: SvgLocationFilled24,
    32: SvgLocationFilled32,
    48: SvgLocationFilled48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: locationFilled
  }, props));
};

var _path$6z, _path2$28;
function _extends$6F() { return _extends$6F = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$6F.apply(null, arguments); }
var SvgLock12 = function SvgLock12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6F({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$6z || (_path$6z = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M6 8.25a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
  })), _path2$28 || (_path2$28 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M6 .9A2.1 2.1 0 0 0 3.9 3v.4h-.4a2.1 2.1 0 0 0-2.1 2.1V9c0 1.16.94 2.1 2.1 2.1h5A2.1 2.1 0 0 0 10.6 9V5.5a2.1 2.1 0 0 0-2.1-2.1h-.4V3A2.1 2.1 0 0 0 6 .9M6.9 3v.4H5.1V3a.9.9 0 0 1 1.8 0M2.6 5.5a.9.9 0 0 1 .9-.9h5a.9.9 0 0 1 .9.9V9a.9.9 0 0 1-.9.9h-5a.9.9 0 0 1-.9-.9z",
    clipRule: "evenodd"
  })));
};

var _path$6y, _path2$27;
function _extends$6E() { return _extends$6E = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$6E.apply(null, arguments); }
var SvgLock16 = function SvgLock16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6E({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$6y || (_path$6y = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M8 11a1.333 1.333 0 1 0 0-2.667A1.333 1.333 0 0 0 8 11"
  })), _path2$27 || (_path2$27 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8 1.25A2.75 2.75 0 0 0 5.25 4v.583h-.583a2.75 2.75 0 0 0-2.75 2.75V12a2.75 2.75 0 0 0 2.75 2.75h6.667a2.75 2.75 0 0 0 2.75-2.75V7.333a2.75 2.75 0 0 0-2.75-2.75h-.584V4A2.75 2.75 0 0 0 8 1.25M9.25 4v.583h-2.5V4a1.25 1.25 0 1 1 2.5 0M3.417 7.333c0-.69.56-1.25 1.25-1.25h6.667c.69 0 1.25.56 1.25 1.25V12c0 .69-.56 1.25-1.25 1.25H4.667c-.69 0-1.25-.56-1.25-1.25z",
    clipRule: "evenodd"
  })));
};

var _path$6x, _path2$26;
function _extends$6D() { return _extends$6D = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$6D.apply(null, arguments); }
var SvgLock18 = function SvgLock18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6D({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$6x || (_path$6x = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M9 12.375a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"
  })), _path2$26 || (_path2$26 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M9 1.45A3.05 3.05 0 0 0 5.95 4.5v.7h-.7A3.05 3.05 0 0 0 2.2 8.25v5.25a3.05 3.05 0 0 0 3.05 3.05h7.5a3.05 3.05 0 0 0 3.05-3.05V8.25a3.05 3.05 0 0 0-3.05-3.05h-.7v-.7A3.05 3.05 0 0 0 9 1.45m1.45 3.05v.7h-2.9v-.7a1.45 1.45 0 1 1 2.9 0M3.8 8.25c0-.8.65-1.45 1.45-1.45h7.5c.801 0 1.45.65 1.45 1.45v5.25c0 .801-.649 1.45-1.45 1.45h-7.5c-.8 0-1.45-.649-1.45-1.45z",
    clipRule: "evenodd"
  })));
};

var _path$6w, _path2$25;
function _extends$6C() { return _extends$6C = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$6C.apply(null, arguments); }
var SvgLock24 = function SvgLock24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6C({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$6w || (_path$6w = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M12 16.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
  })), _path2$25 || (_path2$25 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M12 2.1A3.9 3.9 0 0 0 8.1 6v1.1H7A3.9 3.9 0 0 0 3.1 11v7A3.9 3.9 0 0 0 7 21.9h10a3.9 3.9 0 0 0 3.9-3.9v-7A3.9 3.9 0 0 0 17 7.1h-1.1V6A3.9 3.9 0 0 0 12 2.1M14.1 6v1.1H9.9V6a2.1 2.1 0 1 1 4.2 0m-9.2 5c0-1.16.94-2.1 2.1-2.1h10c1.16 0 2.1.94 2.1 2.1v7a2.1 2.1 0 0 1-2.1 2.1H7A2.1 2.1 0 0 1 4.9 18z",
    clipRule: "evenodd"
  })));
};

var _path$6v, _path2$24;
function _extends$6B() { return _extends$6B = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$6B.apply(null, arguments); }
var SvgLock32 = function SvgLock32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6B({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$6v || (_path$6v = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M16 22a2.667 2.667 0 1 0 0-5.333A2.667 2.667 0 0 0 16 22"
  })), _path2$24 || (_path2$24 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M16 3a5 5 0 0 0-5 5v1.667H9.333a5 5 0 0 0-5 5V24a5 5 0 0 0 5 5h13.333a5 5 0 0 0 5-5v-9.333a5 5 0 0 0-5-5H21V8a5 5 0 0 0-5-5m3 5v1.667h-6V8a3 3 0 1 1 6 0M6.333 14.667a3 3 0 0 1 3-3h13.333a3 3 0 0 1 3 3V24a3 3 0 0 1-3 3H9.333a3 3 0 0 1-3-3z",
    clipRule: "evenodd"
  })));
};

var _path$6u, _path2$23;
function _extends$6A() { return _extends$6A = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$6A.apply(null, arguments); }
var SvgLock48 = function SvgLock48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6A({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$6u || (_path$6u = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M24 33a4 4 0 1 0 0-8 4 4 0 0 0 0 8"
  })), _path2$23 || (_path2$23 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M24 4.8a7.2 7.2 0 0 0-7.2 7.2v2.8H14A7.2 7.2 0 0 0 6.8 22v14a7.2 7.2 0 0 0 7.2 7.2h20a7.2 7.2 0 0 0 7.2-7.2V22a7.2 7.2 0 0 0-7.2-7.2h-2.8V12A7.2 7.2 0 0 0 24 4.8m4.8 7.2v2.8h-9.6V12a4.8 4.8 0 1 1 9.6 0M9.2 22a4.8 4.8 0 0 1 4.8-4.8h20a4.8 4.8 0 0 1 4.8 4.8v14a4.8 4.8 0 0 1-4.8 4.8H14A4.8 4.8 0 0 1 9.2 36z",
    clipRule: "evenodd"
  })));
};

var LockIcon = function LockIcon(props) {
  var lock = {
    12: SvgLock12,
    16: SvgLock16,
    18: SvgLock18,
    24: SvgLock24,
    32: SvgLock32,
    48: SvgLock48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: lock
  }, props));
};

var _path$6t;
function _extends$6z() { return _extends$6z = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$6z.apply(null, arguments); }
var SvgLockFilled12 = function SvgLockFilled12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6z({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$6t || (_path$6t = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M6 .9A2.1 2.1 0 0 0 3.9 3v.55h-.4A1.95 1.95 0 0 0 1.55 5.5V9a1.95 1.95 0 0 0 1.95 1.95h5A1.95 1.95 0 0 0 10.45 9V5.5A1.95 1.95 0 0 0 8.5 3.55h-.4V3A2.1 2.1 0 0 0 6 .9M5.1 3a.9.9 0 0 1 1.8 0v.4H5.1zM6 8.25a1 1 0 1 0 0-2 1 1 0 0 0 0 2",
    clipRule: "evenodd"
  })));
};

var _path$6s;
function _extends$6y() { return _extends$6y = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$6y.apply(null, arguments); }
var SvgLockFilled16 = function SvgLockFilled16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6y({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$6s || (_path$6s = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8 1.25A2.75 2.75 0 0 0 5.25 4v.733h-.584a2.6 2.6 0 0 0-2.6 2.6V12a2.6 2.6 0 0 0 2.6 2.6h6.667a2.6 2.6 0 0 0 2.6-2.6V7.333a2.6 2.6 0 0 0-2.6-2.6h-.583V4A2.75 2.75 0 0 0 8 1.25M6.75 4a1.25 1.25 0 1 1 2.5 0v.583h-2.5zM8 11a1.333 1.333 0 1 0 0-2.667A1.333 1.333 0 0 0 8 11",
    clipRule: "evenodd"
  })));
};

var _path$6r;
function _extends$6x() { return _extends$6x = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$6x.apply(null, arguments); }
var SvgLockFilled18 = function SvgLockFilled18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6x({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$6r || (_path$6r = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M9 1.45A3.05 3.05 0 0 0 5.95 4.5v.825h-.7A2.925 2.925 0 0 0 2.325 8.25v5.25a2.925 2.925 0 0 0 2.925 2.925h7.5a2.925 2.925 0 0 0 2.925-2.925V8.25a2.925 2.925 0 0 0-2.925-2.925h-.7V4.5A3.05 3.05 0 0 0 9 1.45M7.55 4.5a1.45 1.45 0 1 1 2.9 0v.7h-2.9zM9 12.375a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3",
    clipRule: "evenodd"
  })));
};

var _path$6q;
function _extends$6w() { return _extends$6w = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$6w.apply(null, arguments); }
var SvgLockFilled24 = function SvgLockFilled24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6w({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$6q || (_path$6q = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M12 2.1A3.9 3.9 0 0 0 8.1 6v1.1H7A3.9 3.9 0 0 0 3.1 11v7A3.9 3.9 0 0 0 7 21.9h10a3.9 3.9 0 0 0 3.9-3.9v-7A3.9 3.9 0 0 0 17 7.1h-1.1V6A3.9 3.9 0 0 0 12 2.1m2.1 5V6a2.1 2.1 0 1 0-4.2 0v1.1zM12 16.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4",
    clipRule: "evenodd"
  })));
};

var _path$6p;
function _extends$6v() { return _extends$6v = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$6v.apply(null, arguments); }
var SvgLockFilled32 = function SvgLockFilled32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6v({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$6p || (_path$6p = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M16 3a5 5 0 0 0-5 5v1.467H9.334a5.2 5.2 0 0 0-5.2 5.2V24a5.2 5.2 0 0 0 5.2 5.2h13.333a5.2 5.2 0 0 0 5.2-5.2v-9.333a5.2 5.2 0 0 0-5.2-5.2H21V8a5 5 0 0 0-5-5m3 6.467V8a3 3 0 1 0-6 0v1.467zM16 22a2.667 2.667 0 1 0 0-5.333A2.667 2.667 0 0 0 16 22",
    clipRule: "evenodd"
  })));
};

var _path$6o;
function _extends$6u() { return _extends$6u = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$6u.apply(null, arguments); }
var SvgLockFilled48 = function SvgLockFilled48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6u({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$6o || (_path$6o = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M24 4.8a7.2 7.2 0 0 0-7.2 7.2v2.2H14A7.8 7.8 0 0 0 6.2 22v14a7.8 7.8 0 0 0 7.8 7.8h20a7.8 7.8 0 0 0 7.8-7.8V22a7.8 7.8 0 0 0-7.8-7.8h-2.8V12A7.2 7.2 0 0 0 24 4.8m4.8 9.4V12a4.8 4.8 0 1 0-9.6 0v2.2zM24 33a4 4 0 1 0 0-8 4 4 0 0 0 0 8",
    clipRule: "evenodd"
  })));
};

var LockFilledIcon = function LockFilledIcon(props) {
  var lockFilled = {
    12: SvgLockFilled12,
    16: SvgLockFilled16,
    18: SvgLockFilled18,
    24: SvgLockFilled24,
    32: SvgLockFilled32,
    48: SvgLockFilled48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: lockFilled
  }, props));
};

var _path$6n, _path2$22;
function _extends$6t() { return _extends$6t = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$6t.apply(null, arguments); }
var SvgMedal12 = function SvgMedal12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6t({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$6n || (_path$6n = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "m9.74 6.485 1.627 1.626a.797.797 0 0 1-.294 1.313l-.81.292-.243.736a.797.797 0 0 1-1.32.313l-1.9-1.9.848-.85 1.438 1.439.1-.302a.8.8 0 0 1 .486-.499l.397-.143-1.177-1.177zM1.932 8.51l.397.143c.23.083.41.267.487.5l.1.3 1.437-1.437.849.848-1.9 1.9a.797.797 0 0 1-1.32-.312l-.244-.736-.81-.292A.797.797 0 0 1 .634 8.11L2.26 6.485l.848.848z",
    clipRule: "evenodd"
  })), _path2$22 || (_path2$22 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M6 7.982A2.89 2.89 0 1 0 6 2.2a2.89 2.89 0 0 0 0 5.782m0 1.2A4.09 4.09 0 1 0 6 1a4.09 4.09 0 0 0 0 8.182",
    clipRule: "evenodd"
  })));
};

var _path$6m, _path2$21;
function _extends$6s() { return _extends$6s = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$6s.apply(null, arguments); }
var SvgMedal16 = function SvgMedal16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6s({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$6m || (_path$6m = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M7.588 4.147a.5.5 0 0 1 .824 0l.61.89a.5.5 0 0 0 .27.196l1.034.305a.5.5 0 0 1 .255.784l-.657.854a.5.5 0 0 0-.103.319l.03 1.077a.5.5 0 0 1-.668.485l-1.015-.361a.5.5 0 0 0-.335 0l-1.016.361a.5.5 0 0 1-.667-.485l.03-1.077a.5.5 0 0 0-.104-.319l-.657-.854a.5.5 0 0 1 .255-.784l1.033-.305a.5.5 0 0 0 .271-.197zm.38 1.568L8 5.668l.032.047a1.7 1.7 0 0 0 .921.67l.054.015-.034.045a1.7 1.7 0 0 0-.352 1.083l.002.056-.053-.019a1.7 1.7 0 0 0-1.14 0l-.053.02.002-.057a1.7 1.7 0 0 0-.352-1.083L6.993 6.4l.054-.016a1.7 1.7 0 0 0 .921-.67",
    clipRule: "evenodd"
  })), _path2$21 || (_path2$21 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8 12.455c.517 0 1.018-.069 1.494-.197l2.35 2.35c.539.539 1.458.32 1.698-.404l.355-1.072 1.175-.423a1.025 1.025 0 0 0 .378-1.69l-2.14-2.14a5.727 5.727 0 1 0-10.619 0l-2.14 2.14a1.025 1.025 0 0 0 .377 1.69l1.175.423.355 1.072c.24.725 1.16.943 1.699.403l2.35-2.35c.475.13.976.197 1.493.197m0-1.5A4.227 4.227 0 1 0 8 2.5a4.227 4.227 0 0 0 0 8.455m4.36 2.047-1.382-1.382c.6-.366 1.129-.84 1.557-1.394l1.325 1.325-.689.248a1.02 1.02 0 0 0-.626.642zM2.14 11.551l1.325-1.325a5.8 5.8 0 0 0 1.557 1.394L3.64 13.002l-.185-.56a1.02 1.02 0 0 0-.626-.643z",
    clipRule: "evenodd"
  })));
};

var _path$6l, _path2$20;
function _extends$6r() { return _extends$6r = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$6r.apply(null, arguments); }
var SvgMedal18 = function SvgMedal18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6r({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$6l || (_path$6l = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8.588 4.636a.5.5 0 0 1 .824 0l.77 1.123a.5.5 0 0 0 .271.197l1.306.384a.5.5 0 0 1 .255.785l-.83 1.079a.5.5 0 0 0-.104.318l.037 1.361a.5.5 0 0 1-.667.485l-1.282-.456a.5.5 0 0 0-.336 0l-1.282.456a.5.5 0 0 1-.667-.485l.037-1.36a.5.5 0 0 0-.103-.32l-.83-1.078a.5.5 0 0 1 .254-.785l1.306-.384a.5.5 0 0 0 .271-.197zm.302 1.858.11-.16.11.16a1.8 1.8 0 0 0 .975.709l.186.054-.118.154a1.8 1.8 0 0 0-.373 1.147l.006.194-.183-.065a1.8 1.8 0 0 0-1.206 0l-.183.065.006-.194a1.8 1.8 0 0 0-.373-1.147l-.118-.154.186-.054a1.8 1.8 0 0 0 .975-.71",
    clipRule: "evenodd"
  })), _path2$20 || (_path2$20 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M9 14.216c.614 0 1.208-.084 1.77-.242l2.663 2.662c.586.586 1.585.35 1.846-.438l.414-1.252 1.37-.494c.769-.276.988-1.259.41-1.836l-2.429-2.43a6.545 6.545 0 1 0-12.089 0l-2.428 2.43a1.115 1.115 0 0 0 .41 1.837l1.37.493.414 1.252a1.115 1.115 0 0 0 1.846.438l2.662-2.662A6.6 6.6 0 0 0 9 14.216m0-1.6a4.945 4.945 0 1 0 0-9.891 4.945 4.945 0 0 0 0 9.89m5.008 2.332-1.655-1.655a6.6 6.6 0 0 0 1.865-1.67l1.583 1.583-.872.314a1.12 1.12 0 0 0-.68.699zm-11.81-1.742 1.584-1.583a6.6 6.6 0 0 0 1.865 1.67l-1.654 1.655-.242-.73a1.12 1.12 0 0 0-.68-.697z",
    clipRule: "evenodd"
  })));
};

var _path$6k, _path2$1$, _path3$c;
function _extends$6q() { return _extends$6q = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$6q.apply(null, arguments); }
var SvgMedal24 = function SvgMedal24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6q({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$6k || (_path$6k = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "m19.932 13.864 3.578 3.577c.69.69.428 1.865-.491 2.196l-1.975.711-.6 1.814a1.333 1.333 0 0 1-2.207.524l-4.181-4.181 1.272-1.273 3.645 3.645.434-1.31c.128-.389.428-.696.813-.835l1.496-.539-3.057-3.057zm-17.648 4.33 1.496.538c.385.139.685.447.813.835l.434 1.31 3.645-3.645 1.272 1.273-4.18 4.18a1.332 1.332 0 0 1-2.208-.523l-.6-1.814-1.975-.71a1.333 1.333 0 0 1-.49-2.197l3.577-3.577 1.273 1.272z"
  })), _path2$1$ || (_path2$1$ = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M12 17.7a7.2 7.2 0 1 0 0-14.4 7.2 7.2 0 0 0 0 14.4m0 1.8a9 9 0 1 1 0-18 9 9 0 0 1 0 18"
  })), _path3$c || (_path3$c = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "m12 8.33-.243.354a2.6 2.6 0 0 1-1.41 1.024l-.41.122.261.34a2.6 2.6 0 0 1 .538 1.656l-.011.43.404-.144c.563-.2 1.179-.2 1.742 0l.404.143-.011-.429a2.6 2.6 0 0 1 .538-1.657l.261-.34-.411-.12a2.6 2.6 0 0 1-1.41-1.025zm.825-1.626.737 1.076a1 1 0 0 0 .542.394l1.252.368a1 1 0 0 1 .51 1.57l-.796 1.033a1 1 0 0 0-.207.638l.036 1.303a1 1 0 0 1-1.335.97l-1.229-.437a1 1 0 0 0-.67 0l-1.23.437a1 1 0 0 1-1.334-.97l.036-1.303a1 1 0 0 0-.207-.638l-.796-1.034a1 1 0 0 1 .51-1.569l1.252-.368a1 1 0 0 0 .542-.394l.737-1.076a1 1 0 0 1 1.65 0"
  })));
};

var _path$6j, _path2$1_;
function _extends$6p() { return _extends$6p = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$6p.apply(null, arguments); }
var SvgMedal32 = function SvgMedal32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6p({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$6j || (_path$6j = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M15.01 8.778a1.2 1.2 0 0 1 1.98 0l1.12 1.634a1.2 1.2 0 0 0 .65.473l1.9.56a1.2 1.2 0 0 1 .613 1.883l-1.209 1.57a1.2 1.2 0 0 0-.248.765l.055 1.98a1.2 1.2 0 0 1-1.602 1.164l-1.867-.664a1.2 1.2 0 0 0-.804 0l-1.867.664a1.2 1.2 0 0 1-1.601-1.164l.054-1.98a1.2 1.2 0 0 0-.248-.765l-1.209-1.57a1.2 1.2 0 0 1 .612-1.883l1.9-.56a1.2 1.2 0 0 0 .651-.473zm.53 2.765.46-.672.46.672a3.2 3.2 0 0 0 1.735 1.26l.78.23-.496.645a3.2 3.2 0 0 0-.662 2.04l.022.813-.767-.272a3.2 3.2 0 0 0-2.144 0l-.767.272.022-.813a3.2 3.2 0 0 0-.662-2.04l-.497-.645.781-.23a3.2 3.2 0 0 0 1.735-1.26",
    clipRule: "evenodd"
  })), _path2$1_ || (_path2$1_ = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M16 26c1.31 0 2.572-.21 3.752-.598l4.705 4.704c.83.83 2.243.495 2.612-.62l.83-2.51 2.725-.982a1.577 1.577 0 0 0 .58-2.598l-4.325-4.325C27.6 17.53 28 15.812 28 14c0-6.627-5.372-12-12-12C9.373 2 4 7.373 4 14c0 1.812.402 3.53 1.12 5.07L.796 23.397a1.577 1.577 0 0 0 .581 2.599l2.725.981.83 2.51a1.577 1.577 0 0 0 2.612.62l4.705-4.704C13.428 25.79 14.69 26 16 26m0-2c5.523 0 10-4.477 10-10S21.523 4 16 4 6 8.477 6 14s4.477 10 10 10m9.386 4.206-3.659-3.658a12.06 12.06 0 0 0 4.117-3.684l3.475 3.475-2.29.825c-.456.164-.811.528-.963.988zM2.68 24.34l3.475-3.475a12.06 12.06 0 0 0 4.117 3.684l-3.659 3.659-.68-2.055a1.58 1.58 0 0 0-.962-.988z",
    clipRule: "evenodd"
  })));
};

var _path$6i, _path2$1Z;
function _extends$6o() { return _extends$6o = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$6o.apply(null, arguments); }
var SvgMedal48 = function SvgMedal48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6o({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$6i || (_path$6i = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M22.35 13.407a2 2 0 0 1 3.3 0l1.475 2.152a2 2 0 0 0 1.084.788l2.502.738a2 2 0 0 1 1.02 3.138L30.14 22.29a2 2 0 0 0-.414 1.275l.072 2.608a2 2 0 0 1-2.67 1.94l-2.458-.875a2 2 0 0 0-1.34 0l-2.458.874a2 2 0 0 1-2.67-1.939l.072-2.608a2 2 0 0 0-.414-1.275l-1.591-2.067a2 2 0 0 1 1.02-3.138l2.502-.738a2 2 0 0 0 1.084-.788zm.505 3.509L24 15.246l1.145 1.67a4.4 4.4 0 0 0 2.385 1.733l1.943.573-1.235 1.605a4.4 4.4 0 0 0-.911 2.804l.055 2.025-1.908-.679a4.4 4.4 0 0 0-2.948 0l-1.908.679.055-2.025a4.4 4.4 0 0 0-.91-2.804l-1.236-1.605 1.943-.573a4.4 4.4 0 0 0 2.385-1.733",
    clipRule: "evenodd"
  })), _path2$1Z || (_path2$1Z = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M24 39a18 18 0 0 0 5.945-1.005l6.952 6.952c1.087 1.087 2.938.648 3.421-.811l1.292-3.905 4.224-1.521a2.065 2.065 0 0 0 .76-3.404l-6.412-6.413A17.9 17.9 0 0 0 42 21c0-9.941-8.059-18-18-18S6 11.059 6 21c0 2.831.654 5.51 1.818 7.893l-6.413 6.414a2.065 2.065 0 0 0 .76 3.403L6.39 40.23l1.292 3.905c.483 1.46 2.334 1.898 3.42.811l6.953-6.952A18 18 0 0 0 24 39m0-2.4c8.616 0 15.6-6.984 15.6-15.6S32.616 5.4 24 5.4 8.4 12.384 8.4 21 15.384 36.6 24 36.6m14.21 6.266-5.896-5.897a18.1 18.1 0 0 0 6.625-5.924l5.586 5.585-3.881 1.398a2.07 2.07 0 0 0-1.261 1.294zM3.475 36.63l5.586-5.585a18.1 18.1 0 0 0 6.626 5.924L9.79 42.866l-1.173-3.544a2.07 2.07 0 0 0-1.26-1.294z",
    clipRule: "evenodd"
  })));
};

var MedalIcon = function MedalIcon(props) {
  var medal = {
    12: SvgMedal12,
    16: SvgMedal16,
    18: SvgMedal18,
    24: SvgMedal24,
    32: SvgMedal32,
    48: SvgMedal48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: medal
  }, props));
};

var _g$5, _defs$5;
function _extends$6n() { return _extends$6n = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$6n.apply(null, arguments); }
var SvgMedalFilled12 = function SvgMedalFilled12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6n({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _g$5 || (_g$5 = /*#__PURE__*/React.createElement("g", {
    fill: "#2F3438",
    clipPath: "url(#medalFilled_12_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.264 7.631.21 8.685a.716.716 0 0 0 .264 1.18l.964.348.293.884a.716.716 0 0 0 1.186.281l1.18-1.18a5.32 5.32 0 0 1-2.833-2.567M7.903 10.198l1.18 1.18a.716.716 0 0 0 1.187-.281l.292-.884.965-.347a.716.716 0 0 0 .263-1.18L10.736 7.63a5.32 5.32 0 0 1-2.833 2.567"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6 9.75a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m.713-5.71-.383-.559a.4.4 0 0 0-.66 0l-.383.56a.4.4 0 0 1-.217.157l-.65.192a.4.4 0 0 0-.204.627l.413.537a.4.4 0 0 1 .083.255l-.018.678a.4.4 0 0 0 .533.388l.639-.227a.4.4 0 0 1 .268 0l.639.227a.4.4 0 0 0 .533-.388l-.018-.678a.4.4 0 0 1 .083-.255l.413-.537a.4.4 0 0 0-.204-.627l-.65-.192a.4.4 0 0 1-.217-.158",
    clipRule: "evenodd"
  }))), _defs$5 || (_defs$5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "medalFilled_12_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h12v12H0z"
  })))));
};

var _path$6h, _path2$1Y, _path3$b;
function _extends$6m() { return _extends$6m = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$6m.apply(null, arguments); }
var SvgMedalFilled16 = function SvgMedalFilled16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6m({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$6h || (_path$6h = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "m1.766 10.188-1.44 1.44a.888.888 0 0 0 .328 1.463l1.317.475.4 1.209a.888.888 0 0 0 1.471.349l1.604-1.604a7.03 7.03 0 0 1-3.68-3.332m.706 3.052.02-.007-.011-.029z",
    clipRule: "evenodd"
  })), _path2$1Y || (_path2$1Y = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "m10.554 13.52 1.604 1.604a.888.888 0 0 0 1.471-.35l.4-1.208 1.317-.475a.888.888 0 0 0 .327-1.464l-1.44-1.439a7.03 7.03 0 0 1-3.68 3.332"
  })), _path3$b || (_path3$b = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8 13A6 6 0 1 0 8 1a6 6 0 0 0 0 12m.937-7.632-.442-.646a.6.6 0 0 0-.99 0l-.442.646a.6.6 0 0 1-.326.236l-.75.221a.6.6 0 0 0-.306.942l.477.62a.6.6 0 0 1 .124.383l-.021.782a.6.6 0 0 0 .8.582L7.8 8.87a.6.6 0 0 1 .402 0l.737.263a.6.6 0 0 0 .801-.582l-.021-.782a.6.6 0 0 1 .124-.383l.477-.62a.6.6 0 0 0-.306-.942l-.75-.22a.6.6 0 0 1-.326-.237",
    clipRule: "evenodd"
  })));
};

var _path$6g, _path2$1X, _path3$a;
function _extends$6l() { return _extends$6l = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$6l.apply(null, arguments); }
var SvgMedalFilled18 = function SvgMedalFilled18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6l({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$6g || (_path$6g = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M1.994 11.42.35 13.063c-.53.531-.329 1.434.377 1.688l1.47.53.446 1.348c.24.724 1.158.942 1.697.403L6.172 15.2a7.88 7.88 0 0 1-4.178-3.78",
    clipRule: "evenodd"
  })), _path2$1X || (_path2$1X = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "m11.828 15.2 1.832 1.832c.539.539 1.457.321 1.697-.403l.446-1.348 1.47-.53a1.024 1.024 0 0 0 .377-1.688l-1.644-1.644a7.88 7.88 0 0 1-4.178 3.781"
  })), _path3$a || (_path3$a = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M9 14.625a6.75 6.75 0 1 0 0-13.5 6.75 6.75 0 0 0 0 13.5m1.05-8.594-.473-.688a.7.7 0 0 0-1.154 0l-.473.688a.7.7 0 0 1-.379.276l-.801.236a.7.7 0 0 0-.357 1.099l.51.661a.7.7 0 0 1 .144.447l-.023.834a.7.7 0 0 0 .935.68l.786-.28a.7.7 0 0 1 .47 0l.786.28a.7.7 0 0 0 .935-.68l-.023-.834a.7.7 0 0 1 .145-.447l.509-.661a.7.7 0 0 0-.357-1.099l-.801-.236a.7.7 0 0 1-.38-.276",
    clipRule: "evenodd"
  })));
};

var _path$6f, _path2$1W;
function _extends$6k() { return _extends$6k = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$6k.apply(null, arguments); }
var SvgMedalFilled24 = function SvgMedalFilled24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6k({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$6f || (_path$6f = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M2.724 15.208.49 17.44c-.69.69-.428 1.865.491 2.196l1.975.711.6 1.814a1.333 1.333 0 0 0 2.207.524l2.484-2.484a10.44 10.44 0 0 1-5.523-4.995M15.753 20.202l2.483 2.484a1.333 1.333 0 0 0 2.208-.524l.6-1.814 1.975-.711a1.332 1.332 0 0 0 .49-2.196l-2.233-2.233a10.44 10.44 0 0 1-5.523 4.994"
  })), _path2$1W || (_path2$1W = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M12 19.5a9 9 0 1 0 0-18 9 9 0 0 0 0 18m1.386-11.478-.561-.818a1 1 0 0 0-1.65 0l-.561.818a1 1 0 0 1-.542.394l-.952.28a1 1 0 0 0-.51 1.57l.605.787a1 1 0 0 1 .207.637l-.027.992a1 1 0 0 0 1.335.97l.935-.333a1 1 0 0 1 .67 0l.935.333a1 1 0 0 0 1.335-.97l-.027-.992a1 1 0 0 1 .207-.637l.605-.787a1 1 0 0 0-.51-1.57l-.952-.28a1 1 0 0 1-.542-.394",
    clipRule: "evenodd"
  })));
};

var _path$6e, _path2$1V;
function _extends$6j() { return _extends$6j = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$6j.apply(null, arguments); }
var SvgMedalFilled32 = function SvgMedalFilled32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6j({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$6e || (_path$6e = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "m3.827 20.506-2.96 2.961a1.477 1.477 0 0 0 .543 2.434l2.77.997.846 2.557a1.477 1.477 0 0 0 2.447.58l3.271-3.271a13.85 13.85 0 0 1-6.917-6.258M21.256 26.764l3.272 3.271c.777.778 2.1.464 2.446-.58l.846-2.557 2.77-.997a1.477 1.477 0 0 0 .544-2.434l-2.96-2.96a13.85 13.85 0 0 1-6.918 6.257"
  })), _path2$1V || (_path2$1V = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M16 26c6.627 0 12-5.373 12-12S22.627 2 16 2 4 7.373 4 14s5.373 12 12 12m1.875-15.264-.885-1.292a1.2 1.2 0 0 0-1.98 0l-.885 1.291a1.2 1.2 0 0 1-.65.473l-1.502.443a1.2 1.2 0 0 0-.612 1.883l.955 1.24a1.2 1.2 0 0 1 .248.765l-.043 1.565a1.2 1.2 0 0 0 1.602 1.163l1.475-.524a1.2 1.2 0 0 1 .804 0l1.475.524a1.2 1.2 0 0 0 1.602-1.163l-.043-1.565a1.2 1.2 0 0 1 .248-.765l.955-1.24a1.2 1.2 0 0 0-.612-1.883l-1.502-.443a1.2 1.2 0 0 1-.65-.473",
    clipRule: "evenodd"
  })));
};

var _path$6d, _path2$1U;
function _extends$6i() { return _extends$6i = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$6i.apply(null, arguments); }
var SvgMedalFilled48 = function SvgMedalFilled48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6i({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$6d || (_path$6d = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "m6.187 30.95-4.57 4.569a1.765 1.765 0 0 0 .65 2.909l4.362 1.57 1.338 4.044a1.765 1.765 0 0 0 2.923.693l5.008-5.007a20.48 20.48 0 0 1-9.711-8.779M32.102 39.728l5.007 5.007a1.765 1.765 0 0 0 2.924-.694l1.338-4.043 4.362-1.57a1.765 1.765 0 0 0 .65-2.91l-4.57-4.568a20.48 20.48 0 0 1-9.71 8.778"
  })), _path2$1U || (_path2$1U = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M24 39c9.941 0 18-8.059 18-18S33.941 3 24 3 6 11.059 6 21s8.059 18 18 18m2.852-22.838-1.532-2.236a1.6 1.6 0 0 0-2.64 0l-1.532 2.236a1.6 1.6 0 0 1-.868.63l-2.6.767a1.6 1.6 0 0 0-.816 2.51l1.653 2.149c.225.291.342.652.332 1.02l-.075 2.71a1.6 1.6 0 0 0 2.136 1.551l2.554-.908a1.6 1.6 0 0 1 1.072 0l2.554.908a1.6 1.6 0 0 0 2.136-1.552l-.075-2.71a1.6 1.6 0 0 1 .332-1.02l1.653-2.148a1.6 1.6 0 0 0-.816-2.51l-2.6-.767a1.6 1.6 0 0 1-.868-.63",
    clipRule: "evenodd"
  })));
};

var MedalFilledIcon = function MedalFilledIcon(props) {
  var medalFilled = {
    12: SvgMedalFilled12,
    16: SvgMedalFilled16,
    18: SvgMedalFilled18,
    24: SvgMedalFilled24,
    32: SvgMedalFilled32,
    48: SvgMedalFilled48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: medalFilled
  }, props));
};

var _g$4, _defs$4;
function _extends$6h() { return _extends$6h = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$6h.apply(null, arguments); }
var SvgMenu12 = function SvgMenu12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6h({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _g$4 || (_g$4 = /*#__PURE__*/React.createElement("g", {
    stroke: "#2F3438",
    strokeLinecap: "round",
    strokeWidth: 1.2,
    clipPath: "url(#menu_12_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.25 2.75h9.5M1.25 6h9.5M1.25 9.25h9.5"
  }))), _defs$4 || (_defs$4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "menu_12_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h12v12H0z"
  })))));
};

var _path$6c;
function _extends$6g() { return _extends$6g = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$6g.apply(null, arguments); }
var SvgMenu16 = function SvgMenu16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6g({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$6c || (_path$6c = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M.917 3.667a.75.75 0 0 1 .75-.75h12.666a.75.75 0 0 1 0 1.5H1.667a.75.75 0 0 1-.75-.75M.917 8a.75.75 0 0 1 .75-.75h12.666a.75.75 0 0 1 0 1.5H1.667A.75.75 0 0 1 .917 8M.917 12.333a.75.75 0 0 1 .75-.75h12.666a.75.75 0 1 1 0 1.5H1.667a.75.75 0 0 1-.75-.75",
    clipRule: "evenodd"
  })));
};

var _path$6b;
function _extends$6f() { return _extends$6f = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$6f.apply(null, arguments); }
var SvgMenu18 = function SvgMenu18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6f({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$6b || (_path$6b = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M1.075 4.125a.8.8 0 0 1 .8-.8h14.25a.8.8 0 0 1 0 1.6H1.875a.8.8 0 0 1-.8-.8M1.075 9a.8.8 0 0 1 .8-.8h14.25a.8.8 0 0 1 0 1.6H1.875a.8.8 0 0 1-.8-.8M1.075 13.875a.8.8 0 0 1 .8-.8h14.25a.8.8 0 0 1 0 1.6H1.875a.8.8 0 0 1-.8-.8",
    clipRule: "evenodd"
  })));
};

var _path$6a;
function _extends$6e() { return _extends$6e = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$6e.apply(null, arguments); }
var SvgMenu24 = function SvgMenu24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6e({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$6a || (_path$6a = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M1.6 5.5a.9.9 0 0 1 .9-.9h19a.9.9 0 0 1 0 1.8h-19a.9.9 0 0 1-.9-.9M1.6 12a.9.9 0 0 1 .9-.9h19a.9.9 0 0 1 0 1.8h-19a.9.9 0 0 1-.9-.9M1.6 18.5a.9.9 0 0 1 .9-.9h19a.9.9 0 0 1 0 1.8h-19a.9.9 0 0 1-.9-.9",
    clipRule: "evenodd"
  })));
};

var _path$69;
function _extends$6d() { return _extends$6d = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$6d.apply(null, arguments); }
var SvgMenu32 = function SvgMenu32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6d({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$69 || (_path$69 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M2.333 7.333a1 1 0 0 1 1-1h25.334a1 1 0 1 1 0 2H3.333a1 1 0 0 1-1-1m0 8.667a1 1 0 0 1 1-1h25.334a1 1 0 1 1 0 2H3.333a1 1 0 0 1-1-1m0 8.667a1 1 0 0 1 1-1h25.334a1 1 0 0 1 0 2H3.333a1 1 0 0 1-1-1",
    clipRule: "evenodd"
  })));
};

var _path$68;
function _extends$6c() { return _extends$6c = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$6c.apply(null, arguments); }
var SvgMenu48 = function SvgMenu48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6c({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$68 || (_path$68 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M3.8 11A1.2 1.2 0 0 1 5 9.8h38a1.2 1.2 0 0 1 0 2.4H5A1.2 1.2 0 0 1 3.8 11m0 13A1.2 1.2 0 0 1 5 22.8h38a1.2 1.2 0 1 1 0 2.4H5A1.2 1.2 0 0 1 3.8 24m0 13A1.2 1.2 0 0 1 5 35.8h38a1.2 1.2 0 0 1 0 2.4H5A1.2 1.2 0 0 1 3.8 37",
    clipRule: "evenodd"
  })));
};

var MenuIcon = function MenuIcon(props) {
  var menu = {
    12: SvgMenu12,
    16: SvgMenu16,
    18: SvgMenu18,
    24: SvgMenu24,
    32: SvgMenu32,
    48: SvgMenu48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: menu
  }, props));
};

var _path$67;
function _extends$6b() { return _extends$6b = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$6b.apply(null, arguments); }
var SvgMenuFold12 = function SvgMenuFold12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6b({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$67 || (_path$67 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M5.339 2.667a.6.6 0 0 1 .6-.6h4.394a.6.6 0 1 1 0 1.2H5.94a.6.6 0 0 1-.6-.6m-1.037.872a.6.6 0 0 1-.029.849L3.19 5.4h7.144a.6.6 0 1 1 0 1.2H3.19l1.084 1.013a.6.6 0 0 1-.819.877L1.257 6.44a.6.6 0 0 1 0-.877L3.454 3.51a.6.6 0 0 1 .848.03m6.031 6.395H5.94a.6.6 0 0 1 0-1.2h4.394a.6.6 0 1 1 0 1.2",
    clipRule: "evenodd"
  })));
};

var _path$66;
function _extends$6a() { return _extends$6a = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$6a.apply(null, arguments); }
var SvgMenuFold16 = function SvgMenuFold16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6a({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$66 || (_path$66 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M7.219 3.555a.7.7 0 0 1 .7-.7h5.859a.7.7 0 1 1 0 1.4h-5.86a.7.7 0 0 1-.7-.7M5.663 4.787a.7.7 0 0 1-.034.99L3.998 7.3h9.78a.7.7 0 1 1 0 1.4h-9.78l1.631 1.523a.7.7 0 0 1-.955 1.024l-2.93-2.735a.7.7 0 0 1 0-1.024l2.93-2.735a.7.7 0 0 1 .99.034m8.115 8.357h-5.86a.7.7 0 1 1 0-1.4h5.86a.7.7 0 1 1 0 1.4",
    clipRule: "evenodd"
  })));
};

var _path$65;
function _extends$69() { return _extends$69 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$69.apply(null, arguments); }
var SvgMenuFold18 = function SvgMenuFold18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$69({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$65 || (_path$65 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8.108 4a.8.8 0 0 1 .8-.8H15.5a.8.8 0 0 1 0 1.6H8.908a.8.8 0 0 1-.8-.8M6.38 5.377a.8.8 0 0 1-.038 1.131L4.529 8.2H15.5a.8.8 0 0 1 0 1.6H4.53l1.812 1.692a.8.8 0 1 1-1.092 1.17L1.954 9.585a.8.8 0 0 1 0-1.17L5.25 5.34a.8.8 0 0 1 1.13.038M8.108 14a.8.8 0 0 1 .8-.8H15.5a.8.8 0 0 1 0 1.6H8.908a.8.8 0 0 1-.8-.8",
    clipRule: "evenodd"
  })));
};

var _path$64;
function _extends$68() { return _extends$68 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$68.apply(null, arguments); }
var SvgMenuFold24 = function SvgMenuFold24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$68({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$64 || (_path$64 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M10.978 5.333a.9.9 0 0 1 .9-.9h8.789a.9.9 0 0 1 0 1.8h-8.789a.9.9 0 0 1-.9-.9m-2.592 1.95a.9.9 0 0 1-.044 1.272L5.616 11.1h15.05a.9.9 0 0 1 0 1.8H5.617l2.726 2.544a.9.9 0 1 1-1.228 1.316l-4.395-4.102a.9.9 0 0 1 0-1.316l4.395-4.103a.9.9 0 0 1 1.272.044m12.28 12.283h-8.788a.9.9 0 1 1 0-1.8h8.789a.9.9 0 0 1 0 1.8",
    clipRule: "evenodd"
  })));
};

var _path$63;
function _extends$67() { return _extends$67 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$67.apply(null, arguments); }
var SvgMenuFold32 = function SvgMenuFold32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$67({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$63 || (_path$63 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M14.837 7.111a1 1 0 0 1 1-1h11.718a1 1 0 1 1 0 2H15.837a1 1 0 0 1-1-1m-3.802 2.737a1 1 0 0 1-.05 1.413l-4.004 3.74h20.574a1 1 0 1 1 0 2H6.981l4.005 3.738a1 1 0 0 1-1.365 1.462l-5.86-5.47a1 1 0 0 1 0-1.462l5.86-5.47a1 1 0 0 1 1.413.049m16.52 16.041H15.837a1 1 0 0 1 0-2h11.718a1 1 0 1 1 0 2",
    clipRule: "evenodd"
  })));
};

var _path$62;
function _extends$66() { return _extends$66 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$66.apply(null, arguments); }
var SvgMenuFold48 = function SvgMenuFold48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$66({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$62 || (_path$62 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M22.506 10.667c0-.69.56-1.25 1.25-1.25h17.577a1.25 1.25 0 1 1 0 2.5H23.756c-.69 0-1.25-.56-1.25-1.25m-6.137 4.275a1.25 1.25 0 0 1-.06 1.766L9.836 22.75h31.496a1.25 1.25 0 0 1 0 2.5H9.837l6.471 6.041a1.25 1.25 0 0 1-1.706 1.828l-8.788-8.205a1.25 1.25 0 0 1 0-1.828l8.789-8.205a1.25 1.25 0 0 1 1.766.06m24.964 23.641H23.756a1.25 1.25 0 0 1 0-2.5h17.577a1.25 1.25 0 1 1 0 2.5",
    clipRule: "evenodd"
  })));
};

var MenuFoldIcon = function MenuFoldIcon(props) {
  var menuFold = {
    12: SvgMenuFold12,
    16: SvgMenuFold16,
    18: SvgMenuFold18,
    24: SvgMenuFold24,
    32: SvgMenuFold32,
    48: SvgMenuFold48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: menuFold
  }, props));
};

var _path$61;
function _extends$65() { return _extends$65 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$65.apply(null, arguments); }
var SvgMenuOpen12 = function SvgMenuOpen12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$65({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$61 || (_path$61 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M6.661 9.333a.6.6 0 0 1-.6.6H1.667a.6.6 0 0 1 0-1.2H6.06a.6.6 0 0 1 .6.6m1.037-.872a.6.6 0 0 1 .029-.849L8.81 6.6H1.667a.6.6 0 0 1 0-1.2H8.81L7.727 4.387a.6.6 0 0 1 .819-.877l2.197 2.051a.6.6 0 0 1 0 .877L8.546 8.49a.6.6 0 0 1-.848-.03M1.667 2.066H6.06a.6.6 0 0 1 0 1.2H1.667a.6.6 0 0 1 0-1.2",
    clipRule: "evenodd"
  })));
};

var _path$60;
function _extends$64() { return _extends$64 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$64.apply(null, arguments); }
var SvgMenuOpen16 = function SvgMenuOpen16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$64({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$60 || (_path$60 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8.781 12.445a.7.7 0 0 1-.7.7H2.222a.7.7 0 1 1 0-1.4h5.86a.7.7 0 0 1 .7.7m1.555-1.232a.7.7 0 0 1 .034-.99L12.003 8.7h-9.78a.7.7 0 1 1 0-1.4h9.78L10.37 5.777a.7.7 0 1 1 .956-1.024l2.93 2.735a.7.7 0 0 1 0 1.024l-2.93 2.735a.7.7 0 0 1-.99-.034M2.222 2.856h5.86a.7.7 0 1 1 0 1.4h-5.86a.7.7 0 1 1 0-1.4",
    clipRule: "evenodd"
  })));
};

var _path$5$;
function _extends$63() { return _extends$63 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$63.apply(null, arguments); }
var SvgMenuOpen18 = function SvgMenuOpen18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$63({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$5$ || (_path$5$ = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M9.892 14a.8.8 0 0 1-.8.8H2.5a.8.8 0 0 1 0-1.6h6.592a.8.8 0 0 1 .8.8m1.728-1.377a.8.8 0 0 1 .038-1.131L13.471 9.8H2.5a.8.8 0 1 1-.001-1.6h10.97l-1.812-1.692a.8.8 0 0 1 1.092-1.17l3.296 3.077a.8.8 0 0 1 0 1.17L12.75 12.66a.8.8 0 0 1-1.13-.038M9.892 4a.8.8 0 0 1-.8.8H2.5a.8.8 0 1 1 0-1.6h6.592a.8.8 0 0 1 .8.8",
    clipRule: "evenodd"
  })));
};

var _path$5_;
function _extends$62() { return _extends$62 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$62.apply(null, arguments); }
var SvgMenuOpen24 = function SvgMenuOpen24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$62({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$5_ || (_path$5_ = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M13.022 18.667a.9.9 0 0 1-.9.9H3.333a.9.9 0 0 1 0-1.8h8.79a.9.9 0 0 1 .9.9m2.592-1.95a.9.9 0 0 1 .044-1.272l2.726-2.545H3.334a.9.9 0 1 1 0-1.8h15.05l-2.726-2.544a.9.9 0 0 1 1.229-1.316l4.394 4.102a.9.9 0 0 1 0 1.316l-4.394 4.103a.9.9 0 0 1-1.273-.044M3.334 4.434h8.788a.9.9 0 0 1 0 1.8H3.333a.9.9 0 1 1 0-1.8",
    clipRule: "evenodd"
  })));
};

var _path$5Z;
function _extends$61() { return _extends$61 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$61.apply(null, arguments); }
var SvgMenuOpen32 = function SvgMenuOpen32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$61({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$5Z || (_path$5Z = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M17.163 24.889a1 1 0 0 1-1 1H4.445a1 1 0 1 1 0-2h11.718a1 1 0 0 1 1 1m3.803-2.737a1 1 0 0 1 .048-1.413l4.005-3.74H4.445a1 1 0 1 1 0-2h20.574l-4.005-3.738a1 1 0 0 1 1.365-1.462l5.86 5.47a1 1 0 0 1 0 1.462l-5.86 5.47a1 1 0 0 1-1.413-.049M4.445 6.111h11.718a1 1 0 0 1 0 2H4.445a1 1 0 1 1 0-2",
    clipRule: "evenodd"
  })));
};

var _path$5Y;
function _extends$60() { return _extends$60 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$60.apply(null, arguments); }
var SvgMenuOpen48 = function SvgMenuOpen48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$60({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$5Y || (_path$5Y = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M25.494 37.334c0 .69-.56 1.25-1.25 1.25H6.667a1.25 1.25 0 1 1 0-2.5h17.577c.69 0 1.25.56 1.25 1.25m6.137-4.276a1.25 1.25 0 0 1 .06-1.766l6.472-6.042H6.667a1.25 1.25 0 0 1 0-2.5h31.496l-6.471-6.041a1.25 1.25 0 0 1 1.706-1.828l8.788 8.206a1.25 1.25 0 0 1 0 1.827l-8.788 8.205a1.25 1.25 0 0 1-1.767-.06M6.667 9.417h17.577a1.25 1.25 0 0 1 0 2.5H6.667a1.25 1.25 0 1 1 0-2.5",
    clipRule: "evenodd"
  })));
};

var MenuOpenIcon = function MenuOpenIcon(props) {
  var menuOpen = {
    12: SvgMenuOpen12,
    16: SvgMenuOpen16,
    18: SvgMenuOpen18,
    24: SvgMenuOpen24,
    32: SvgMenuOpen32,
    48: SvgMenuOpen48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: menuOpen
  }, props));
};

var _path$5X;
function _extends$5$() { return _extends$5$ = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$5$.apply(null, arguments); }
var SvgMoreHorizontal12 = function SvgMoreHorizontal12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5$({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$5X || (_path$5X = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M3.5 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0M7 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0M10.5 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
  })));
};

var _path$5W;
function _extends$5_() { return _extends$5_ = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$5_.apply(null, arguments); }
var SvgMoreHorizontal16 = function SvgMoreHorizontal16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5_({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$5W || (_path$5W = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M4.667 8A1.333 1.333 0 1 1 2 8a1.333 1.333 0 0 1 2.667 0M9.333 8a1.333 1.333 0 1 1-2.666 0 1.333 1.333 0 0 1 2.666 0M14 8a1.333 1.333 0 1 1-2.667 0A1.333 1.333 0 0 1 14 8"
  })));
};

var _path$5V;
function _extends$5Z() { return _extends$5Z = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$5Z.apply(null, arguments); }
var SvgMoreHorizontal18 = function SvgMoreHorizontal18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5Z({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$5V || (_path$5V = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M5.25 9a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M10.5 9a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M15.75 9a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
  })));
};

var _path$5U;
function _extends$5Y() { return _extends$5Y = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$5Y.apply(null, arguments); }
var SvgMoreHorizontal24 = function SvgMoreHorizontal24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5Y({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$5U || (_path$5U = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M7 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0M14 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0M21 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
  })));
};

var _path$5T;
function _extends$5X() { return _extends$5X = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$5X.apply(null, arguments); }
var SvgMoreHorizontal32 = function SvgMoreHorizontal32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5X({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$5T || (_path$5T = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M9.5 16a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0M18.5 16a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0M27.5 16a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0"
  })));
};

var _path$5S;
function _extends$5W() { return _extends$5W = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$5W.apply(null, arguments); }
var SvgMoreHorizontal48 = function SvgMoreHorizontal48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5W({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$5S || (_path$5S = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M15 24a3 3 0 1 1-6 0 3 3 0 0 1 6 0M27 24a3 3 0 1 1-6 0 3 3 0 0 1 6 0M39 24a3 3 0 1 1-6 0 3 3 0 0 1 6 0"
  })));
};

var MoreHorizontalIcon = function MoreHorizontalIcon(props) {
  var moreHorizontal = {
    12: SvgMoreHorizontal12,
    16: SvgMoreHorizontal16,
    18: SvgMoreHorizontal18,
    24: SvgMoreHorizontal24,
    32: SvgMoreHorizontal32,
    48: SvgMoreHorizontal48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: moreHorizontal
  }, props));
};

var _path$5R;
function _extends$5V() { return _extends$5V = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$5V.apply(null, arguments); }
var SvgMoreVertical12 = function SvgMoreVertical12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5V({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$5R || (_path$5R = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M6 8.5a1 1 0 1 1 0 2 1 1 0 0 1 0-2M6 5a1 1 0 1 1 0 2 1 1 0 0 1 0-2M6 1.5a1 1 0 1 1 0 2 1 1 0 0 1 0-2"
  })));
};

var _path$5Q;
function _extends$5U() { return _extends$5U = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$5U.apply(null, arguments); }
var SvgMoreVertical16 = function SvgMoreVertical16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5U({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$5Q || (_path$5Q = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M8 11.334A1.333 1.333 0 1 1 8 14a1.333 1.333 0 0 1 0-2.666M8 6.667a1.333 1.333 0 1 1 0 2.667 1.333 1.333 0 0 1 0-2.667M8 2a1.333 1.333 0 1 1 0 2.667A1.333 1.333 0 0 1 8 2"
  })));
};

var _path$5P;
function _extends$5T() { return _extends$5T = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$5T.apply(null, arguments); }
var SvgMoreVertical18 = function SvgMoreVertical18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5T({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$5P || (_path$5P = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M9 12.75a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3M9 7.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3M9 2.25a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3"
  })));
};

var _path$5O;
function _extends$5S() { return _extends$5S = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$5S.apply(null, arguments); }
var SvgMoreVertical24 = function SvgMoreVertical24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5S({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$5O || (_path$5O = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M12 17a2 2 0 1 1 0 4 2 2 0 0 1 0-4M12 10a2 2 0 1 1 0 4 2 2 0 0 1 0-4M12 3a2 2 0 1 1 0 4 2 2 0 0 1 0-4"
  })));
};

var _path$5N;
function _extends$5R() { return _extends$5R = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$5R.apply(null, arguments); }
var SvgMoreVertical32 = function SvgMoreVertical32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5R({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$5N || (_path$5N = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M16 22.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5M16 13.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5M16 4.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5"
  })));
};

var _path$5M;
function _extends$5Q() { return _extends$5Q = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$5Q.apply(null, arguments); }
var SvgMoreVertical48 = function SvgMoreVertical48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5Q({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$5M || (_path$5M = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M24 33a3 3 0 1 1 0 6 3 3 0 0 1 0-6M24 21a3 3 0 1 1 0 6 3 3 0 0 1 0-6M24 9a3 3 0 1 1 0 6 3 3 0 0 1 0-6"
  })));
};

var MoreVerticalIcon = function MoreVerticalIcon(props) {
  var moreVertical = {
    12: SvgMoreVertical12,
    16: SvgMoreVertical16,
    18: SvgMoreVertical18,
    24: SvgMoreVertical24,
    32: SvgMoreVertical32,
    48: SvgMoreVertical48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: moreVertical
  }, props));
};

var _path$5L;
function _extends$5P() { return _extends$5P = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$5P.apply(null, arguments); }
var SvgNotification12 = function SvgNotification12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5P({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$5L || (_path$5L = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M6 2a2.99 2.99 0 0 0-2.987 2.988v1.907c0 .25-.1.49-.277.667l-.2.2L2.5 7.8v.176h7v-.176l-.036-.037-.2-.2a.94.94 0 0 1-.276-.667V4.988A2.99 2.99 0 0 0 6 2M1.813 4.988a4.188 4.188 0 0 1 8.375 0v1.801l.124.125.013.012a1.113 1.113 0 0 1 .375.906v.062c0 .147.002.346-.058.524-.111.329-.368.588-.698.699-.178.06-.377.059-.523.058H8.136a2.138 2.138 0 0 1-4.272 0H2.58c-.146 0-.345.002-.523-.058a1.11 1.11 0 0 1-.699-.699c-.06-.178-.059-.377-.058-.524v-.062c0-.066 0-.158.015-.25.027-.168.094-.329.194-.468.054-.076.12-.14.167-.188l.012-.012.125-.125zm3.254 4.187a.938.938 0 0 0 1.867 0z",
    clipRule: "evenodd"
  })));
};

var _path$5K;
function _extends$5O() { return _extends$5O = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$5O.apply(null, arguments); }
var SvgNotification16 = function SvgNotification16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5O({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$5K || (_path$5K = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8 2.617A4.033 4.033 0 0 0 3.967 6.65v2.544c0 .32-.128.628-.354.854l-.266.266-.05.05-.013.014v.304l.213.002h9.007c.098 0 .163 0 .211-.002.002-.049.002-.115.002-.215v-.09l-.013-.012-.05-.05-.267-.267a1.2 1.2 0 0 1-.354-.854V6.65A4.033 4.033 0 0 0 8 2.617M2.467 6.65a5.533 5.533 0 0 1 11.067 0v2.423l.18.18.017.018a1.433 1.433 0 0 1 .466.847c.02.118.02.236.02.326v.081c0 .197.002.454-.075.683a1.43 1.43 0 0 1-.9.9c-.229.078-.485.077-.681.076h-1.762a2.8 2.8 0 0 1-5.598 0H3.439c-.195 0-.451.002-.68-.075a1.43 1.43 0 0 1-.9-.9c-.078-.23-.077-.487-.076-.684v-.082c0-.089 0-.207.02-.325.035-.217.12-.424.25-.604.07-.097.153-.18.216-.244l.017-.017.18-.18zm4.235 5.534a1.3 1.3 0 0 0 2.596 0z",
    clipRule: "evenodd"
  })));
};

var _path$5J;
function _extends$5N() { return _extends$5N = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$5N.apply(null, arguments); }
var SvgNotification18 = function SvgNotification18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5N({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$5J || (_path$5J = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M9 2.9a4.58 4.58 0 0 0-4.581 4.581v2.862c0 .35-.14.684-.386.93l-.3.3-.082.084-.001.119c0 .141 0 .224.003.284.059.002.14.003.28.003h10.134c.139 0 .22 0 .28-.003a8 8 0 0 0 .002-.404l-.083-.084-.3-.299a1.32 1.32 0 0 1-.385-.93V7.481A4.58 4.58 0 0 0 9 2.9M2.819 7.481a6.181 6.181 0 0 1 12.362 0v2.744l.216.216.02.02c.07.07.163.162.239.268.142.198.234.425.273.66.021.13.021.26.021.36v.091c.001.224.002.505-.082.755-.157.463-.52.829-.985.986-.25.084-.53.083-.752.082h-2.024a3.106 3.106 0 0 1-6.213 0H3.869c-.221 0-.502.002-.751-.082a1.57 1.57 0 0 1-.986-.986c-.084-.25-.083-.531-.082-.755v-.092c0-.1 0-.23.02-.358.04-.238.133-.465.274-.661.077-.107.168-.198.24-.27l.019-.018.216-.216zm4.675 6.182a1.506 1.506 0 0 0 3.012 0z",
    clipRule: "evenodd"
  })));
};

var _path$5I;
function _extends$5M() { return _extends$5M = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$5M.apply(null, arguments); }
var SvgNotification24 = function SvgNotification24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5M({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$5I || (_path$5I = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M12 3.7a6.275 6.275 0 0 0-6.275 6.275v3.816c0 .421-.168.825-.465 1.122l-.4.4-.139.142a.1.1 0 0 0-.019.046v.023l-.002.177c0 .208 0 .326.005.413l.006.061a.13.13 0 0 0 .064.065l.06.005c.086.005.204.005.41.005h13.51c.207 0 .324 0 .411-.005l.06-.005a.12.12 0 0 0 .064-.064l.005-.061c.005-.088.005-.206.005-.414l-.001-.176-.001-.024a.1.1 0 0 0-.019-.046l-.016-.017-.124-.126-.399-.4a1.59 1.59 0 0 1-.465-1.121V9.975A6.275 6.275 0 0 0 12 3.7M3.925 9.975a8.075 8.075 0 0 1 16.15 0v3.727l.337.337.025.025c.096.096.209.209.302.338.175.243.288.521.335.811.026.159.026.317.026.455v.117c.001.304.002.65-.101.956a1.92 1.92 0 0 1-1.208 1.209c-.305.102-.65.101-.952.1h-2.863v.125a3.975 3.975 0 1 1-7.95 0v-.125H5.16c-.301.001-.646.002-.95-.1A1.93 1.93 0 0 1 3 16.74c-.103-.305-.102-.651-.101-.955v-.12c0-.136 0-.294.025-.452.048-.292.163-.57.336-.81.094-.131.206-.243.303-.34l.024-.024.337-.337zm5.9 8.075v.125a2.175 2.175 0 0 0 4.35 0v-.125z",
    clipRule: "evenodd"
  })));
};

var _path$5H;
function _extends$5L() { return _extends$5L = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$5L.apply(null, arguments); }
var SvgNotification32 = function SvgNotification32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5L({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$5H || (_path$5H = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M16 4.733A8.567 8.567 0 0 0 7.433 13.3v5.088c0 .508-.202.995-.56 1.354l-.533.533a8 8 0 0 0-.2.205l-.004.005v.001a.37.37 0 0 0-.067.207c-.002.052-.002.12-.002.241 0 .275 0 .44.007.563a1 1 0 0 0 .013.123c.037.106.12.19.227.227.007.002.04.008.121.013.122.007.285.007.558.007h18.015c.272 0 .436 0 .558-.007a1 1 0 0 0 .122-.013.37.37 0 0 0 .225-.225s.008-.031.013-.125c.007-.123.007-.288.007-.563a9 9 0 0 0-.003-.271v-.014l-.002-.007v-.001a.4.4 0 0 0-.063-.155c.002.003-.003-.005-.035-.04l-.17-.171-.532-.533a1.92 1.92 0 0 1-.56-1.355V13.3A8.567 8.567 0 0 0 16 4.733M5.433 13.3C5.433 7.464 10.164 2.733 16 2.733S26.567 7.464 26.567 13.3v5.053l.508.507.032.032c.13.13.269.269.383.428.214.298.353.64.412.997.032.194.032.389.031.576v.15c.002.413.003.84-.124 1.214a2.37 2.37 0 0 1-1.485 1.486c-.373.126-.8.125-1.21.124H21.1v.367a5.1 5.1 0 1 1-10.2 0v-.367H6.886c-.41.001-.835.002-1.209-.124a2.37 2.37 0 0 1-1.486-1.486c-.126-.375-.125-.801-.124-1.214v-.154c0-.184 0-.379.031-.572.059-.36.2-.7.413-.997a3.5 3.5 0 0 1 .415-.46l.507-.508zM12.9 23.867v.367a3.1 3.1 0 0 0 6.2 0v-.367z",
    clipRule: "evenodd"
  })));
};

var _path$5G;
function _extends$5K() { return _extends$5K = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$5K.apply(null, arguments); }
var SvgNotification48 = function SvgNotification48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5K({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$5G || (_path$5G = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M24 6.8c-7.262 0-13.15 5.888-13.15 13.15v7.631c0 .684-.272 1.338-.754 1.82l-.799.799c-.27.27-.31.316-.338.354a.85.85 0 0 0-.148.358c-.007.046-.011.105-.011.49 0 .887.016 1.035.045 1.12a.85.85 0 0 0 .534.534c.084.029.23.044 1.11.044h27.022c.88 0 1.028-.015 1.112-.044a.85.85 0 0 0 .532-.533c.03-.086.045-.234.045-1.121 0-.383-.004-.443-.012-.49a.85.85 0 0 0-.147-.358c-.026-.037-.066-.082-.338-.354l-.799-.799a2.57 2.57 0 0 1-.754-1.82v-7.63C37.15 12.687 31.264 6.8 24 6.8M8.45 19.95C8.45 11.362 15.412 4.4 24 4.4s15.55 6.962 15.55 15.55v7.631c0 .046.019.09.052.123l.798.799.044.044c.2.2.39.39.547.607.294.41.485.88.566 1.37.043.266.043.534.043.822v.207c.001.636.002 1.225-.17 1.737a3.25 3.25 0 0 1-2.04 2.04c-.51.173-1.098.172-1.729.17h-6.31v.85a7.35 7.35 0 0 1-14.7 0v-.85H10.34c-.631.002-1.217.003-1.728-.17a3.25 3.25 0 0 1-2.042-2.04c-.172-.512-.171-1.101-.17-1.737v-.214c0-.284 0-.551.043-.815.08-.494.274-.962.567-1.37.157-.218.347-.408.55-.61l.04-.041.799-.799a.17.17 0 0 0 .051-.123zm10.6 15.55v.85a4.95 4.95 0 0 0 9.9 0v-.85z",
    clipRule: "evenodd"
  })));
};

var NotificationIcon = function NotificationIcon(props) {
  var notification = {
    12: SvgNotification12,
    16: SvgNotification16,
    18: SvgNotification18,
    24: SvgNotification24,
    32: SvgNotification32,
    48: SvgNotification48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: notification
  }, props));
};

var _path$5F;
function _extends$5J() { return _extends$5J = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$5J.apply(null, arguments); }
var SvgNotificationFilled12 = function SvgNotificationFilled12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5J({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$5F || (_path$5F = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M5.997.95a4.144 4.144 0 0 0-4.144 4.144V7.02l-.19.19c-.05.05-.107.107-.155.173a1 1 0 0 0-.17.412c-.013.08-.013.16-.013.23v.062c0 .157-.001.332.051.488.098.29.325.516.614.614.155.052.33.051.486.051h1.488v.001H8.03v-.001h1.488c.156 0 .331.001.486-.051a.98.98 0 0 0 .614-.614c.052-.156.052-.331.051-.488v-.06c0-.071 0-.152-.013-.232a1 1 0 0 0-.17-.412 1.4 1.4 0 0 0-.154-.173l-.19-.19V5.094A4.144 4.144 0 0 0 5.997.95M7.933 9.94H4.061a2.034 2.034 0 0 0 3.872 0"
  })));
};

var _path$5E;
function _extends$5I() { return _extends$5I = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$5I.apply(null, arguments); }
var SvgNotificationFilled16 = function SvgNotificationFilled16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5I({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$5E || (_path$5E = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M7.996 1.267A5.526 5.526 0 0 0 2.47 6.793v2.566l-.252.252c-.067.067-.143.143-.207.231a1.3 1.3 0 0 0-.227.55 2 2 0 0 0-.017.307v.082c-.001.21-.002.444.068.65.13.387.433.69.819.82.206.069.44.068.647.068h1.984v.001h5.422v-.002h1.984c.208.001.442.002.648-.068.387-.13.688-.434.818-.818.07-.207.07-.442.069-.65V10.7c0-.095 0-.202-.018-.31a1.3 1.3 0 0 0-.227-.549c-.063-.087-.14-.164-.205-.23l-.254-.253V6.793a5.526 5.526 0 0 0-5.526-5.526M10.578 13.253H5.415a2.712 2.712 0 0 0 5.163 0"
  })));
};

var _path$5D;
function _extends$5H() { return _extends$5H = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$5H.apply(null, arguments); }
var SvgNotificationFilled18 = function SvgNotificationFilled18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5H({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$5D || (_path$5D = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M8.995 1.425A6.217 6.217 0 0 0 2.78 7.642v2.887l-.284.284c-.076.075-.161.16-.233.26-.132.184-.22.395-.256.617-.02.12-.02.241-.019.347v.092c0 .235-.002.499.077.732.146.434.487.774.921.92.233.079.495.078.729.077h2.231v.002h6.1v-.002h2.232c.234.001.497.002.73-.076.434-.147.774-.488.92-.921.078-.233.077-.497.077-.732v-.09c0-.107 0-.228-.02-.348a1.5 1.5 0 0 0-.255-.618c-.071-.1-.157-.185-.232-.26l-.285-.284V7.642a6.217 6.217 0 0 0-6.217-6.217M11.9 14.91H6.09a3.051 3.051 0 0 0 5.808 0"
  })));
};

var _path$5C;
function _extends$5G() { return _extends$5G = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$5G.apply(null, arguments); }
var SvgNotificationFilled24 = function SvgNotificationFilled24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5G({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$5C || (_path$5C = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M11.994 1.9a8.29 8.29 0 0 0-8.289 8.289v3.85l-.379.378c-.1.1-.214.214-.31.347a1.96 1.96 0 0 0-.34.823c-.027.16-.026.322-.026.462v.123c-.001.313-.002.665.102.975.196.58.65 1.033 1.229 1.228.31.105.66.104.97.103h2.9770000000000003v.002h8.133v-.002h2.976c.31 0 .662.002.972-.103a1.95 1.95 0 0 0 1.227-1.227c.104-.311.104-.663.102-.976v-.12c0-.143 0-.304-.026-.465a1.95 1.95 0 0 0-.34-.823 3 3 0 0 0-.309-.345l-.38-.38v-3.85A8.29 8.29 0 0 0 11.994 1.9M15.866 19.88H8.122a4.068 4.068 0 0 0 7.744 0"
  })));
};

var _path$5B;
function _extends$5F() { return _extends$5F = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$5F.apply(null, arguments); }
var SvgNotificationFilled32 = function SvgNotificationFilled32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5F({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$5B || (_path$5B = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M15.992 2.533c-6.103 0-11.051 4.948-11.051 11.052v5.133l-.506.505a4 4 0 0 0-.413.462c-.234.327-.39.703-.454 1.098a4 4 0 0 0-.035.616v.163c-.001.418-.003.887.137 1.301.26.772.867 1.378 1.638 1.638.413.139.88.138 1.295.136h3.967v.003h10.845v-.003h3.967c.415.002.883.003 1.296-.136a2.6 2.6 0 0 0 1.636-1.638c.14-.414.139-.883.137-1.3v-.161c0-.19 0-.404-.034-.619a2.6 2.6 0 0 0-.454-1.098c-.127-.176-.28-.328-.412-.46l-.507-.507v-5.133c0-6.104-4.948-11.052-11.052-11.052M21.155 26.507H10.83a5.425 5.425 0 0 0 10.325 0"
  })));
};

var _path$5A;
function _extends$5E() { return _extends$5E = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$5E.apply(null, arguments); }
var SvgNotificationFilled48 = function SvgNotificationFilled48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5E({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$5A || (_path$5A = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M23.988 3.8c-9.155 0-16.577 7.422-16.577 16.578v7.698l-.758.758c-.202.201-.43.428-.62.693a3.9 3.9 0 0 0-.682 1.648c-.052.32-.052.642-.052.923v.245c-.002.627-.004 1.33.206 1.952A3.91 3.91 0 0 0 7.96 36.75c.62.209 1.32.207 1.943.205h5.9510000000000005v.004h16.267v-.004h5.9510000000000005c.623.002 1.325.004 1.944-.205a3.91 3.91 0 0 0 2.455-2.456c.209-.621.207-1.325.205-1.952v-.24c0-.285 0-.606-.052-.928a3.9 3.9 0 0 0-.681-1.648c-.19-.263-.419-.492-.617-.69l-.76-.76v-7.7c0-9.155-7.423-16.577-16.579-16.577M31.733 39.76H16.244a8.137 8.137 0 0 0 15.489 0"
  })));
};

var NotificationFilledIcon = function NotificationFilledIcon(props) {
  var notificationFilled = {
    12: SvgNotificationFilled12,
    16: SvgNotificationFilled16,
    18: SvgNotificationFilled18,
    24: SvgNotificationFilled24,
    32: SvgNotificationFilled32,
    48: SvgNotificationFilled48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: notificationFilled
  }, props));
};

var _path$5z;
function _extends$5D() { return _extends$5D = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$5D.apply(null, arguments); }
var SvgPause12 = function SvgPause12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5D({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$5z || (_path$5z = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M3.55 1.875a1.1 1.1 0 0 0-1.1 1.1v6.05a1.1 1.1 0 0 0 1.1 1.1h.5a1.1 1.1 0 0 0 1.1-1.1v-6.05a1.1 1.1 0 0 0-1.1-1.1zm4.4 0a1.1 1.1 0 0 0-1.1 1.1v6.05a1.1 1.1 0 0 0 1.1 1.1h.5a1.1 1.1 0 0 0 1.1-1.1v-6.05a1.1 1.1 0 0 0-1.1-1.1z"
  })));
};

var _path$5y;
function _extends$5C() { return _extends$5C = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$5C.apply(null, arguments); }
var SvgPause16 = function SvgPause16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5C({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$5y || (_path$5y = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M4.733 2.55c-.782 0-1.416.634-1.416 1.416v8.067c0 .783.634 1.417 1.416 1.417H5.4c.782 0 1.417-.634 1.417-1.417V3.966c0-.782-.635-1.416-1.417-1.416zm5.867 0c-.782 0-1.417.634-1.417 1.416v8.067c0 .783.635 1.417 1.417 1.417h.667c.782 0 1.416-.634 1.416-1.417V3.966c0-.782-.634-1.416-1.416-1.416z"
  })));
};

var _path$5x;
function _extends$5B() { return _extends$5B = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$5B.apply(null, arguments); }
var SvgPause18 = function SvgPause18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5B({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$5x || (_path$5x = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M5.325 2.912a1.55 1.55 0 0 0-1.55 1.55v9.075c0 .856.694 1.55 1.55 1.55h.75a1.55 1.55 0 0 0 1.55-1.55V4.462a1.55 1.55 0 0 0-1.55-1.55zm6.6 0a1.55 1.55 0 0 0-1.55 1.55v9.075c0 .856.694 1.55 1.55 1.55h.75a1.55 1.55 0 0 0 1.55-1.55V4.462a1.55 1.55 0 0 0-1.55-1.55z"
  })));
};

var _path$5w;
function _extends$5A() { return _extends$5A = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$5A.apply(null, arguments); }
var SvgPause24 = function SvgPause24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5A({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$5w || (_path$5w = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M7.1 4.05a1.9 1.9 0 0 0-1.9 1.9v12.1c0 1.05.85 1.9 1.9 1.9h1a1.9 1.9 0 0 0 1.9-1.9V5.95a1.9 1.9 0 0 0-1.9-1.9zm8.8 0a1.9 1.9 0 0 0-1.9 1.9v12.1c0 1.05.85 1.9 1.9 1.9h1a1.9 1.9 0 0 0 1.9-1.9V5.95a1.9 1.9 0 0 0-1.9-1.9z"
  })));
};

var _path$5v, _path2$1T;
function _extends$5z() { return _extends$5z = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$5z.apply(null, arguments); }
var SvgPause32 = function SvgPause32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5z({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$5v || (_path$5v = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M7.133 7.933A2.333 2.333 0 0 1 9.467 5.6H10.8a2.333 2.333 0 0 1 2.333 2.333v16.133A2.333 2.333 0 0 1 10.8 26.4H9.467a2.333 2.333 0 0 1-2.334-2.334z",
    clipRule: "evenodd"
  })), _path2$1T || (_path2$1T = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M21.2 5.6a2.333 2.333 0 0 0-2.333 2.333v16.133A2.333 2.333 0 0 0 21.2 26.4h1.333a2.333 2.333 0 0 0 2.334-2.334V7.933A2.333 2.333 0 0 0 22.533 5.6z"
  })));
};

var _path$5u, _path2$1S;
function _extends$5y() { return _extends$5y = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$5y.apply(null, arguments); }
var SvgPause48 = function SvgPause48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5y({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$5u || (_path$5u = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M11 11.9a3.2 3.2 0 0 1 3.2-3.2h2a3.2 3.2 0 0 1 3.2 3.2v24.2a3.2 3.2 0 0 1-3.2 3.2h-2a3.2 3.2 0 0 1-3.2-3.2z",
    clipRule: "evenodd"
  })), _path2$1S || (_path2$1S = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M31.8 8.7a3.2 3.2 0 0 0-3.2 3.2v24.2a3.2 3.2 0 0 0 3.2 3.2h2a3.2 3.2 0 0 0 3.2-3.2V11.9a3.2 3.2 0 0 0-3.2-3.2z"
  })));
};

var PauseIcon = function PauseIcon(props) {
  var pause = {
    12: SvgPause12,
    16: SvgPause16,
    18: SvgPause18,
    24: SvgPause24,
    32: SvgPause32,
    48: SvgPause48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: pause
  }, props));
};

var _path$5t, _path2$1R;
function _extends$5x() { return _extends$5x = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$5x.apply(null, arguments); }
var SvgPhoto12 = function SvgPhoto12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5x({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$5t || (_path$5t = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M1.5 3.5a2 2 0 0 1 2-2h5a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-5a2 2 0 0 1-2-2zm2-.8h5a.8.8 0 0 1 .8.8v2.973l-.527-.517a.6.6 0 0 0-.764-.063l-1.239.868-2.232-2.19a.6.6 0 0 0-.84 0L2.7 5.55V3.5a.8.8 0 0 1 .8-.8m-.8 4.527V8.5a.8.8 0 0 0 .8.8h5a.8.8 0 0 0 .8-.8v-.365a.6.6 0 0 1-.099-.078l-.912-.895-1.239.868a.6.6 0 0 1-.764-.063L4.118 5.84 2.743 7.19z",
    clipRule: "evenodd"
  })), _path2$1R || (_path2$1R = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M8 4.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0"
  })));
};

var _path$5s, _path2$1Q;
function _extends$5w() { return _extends$5w = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$5w.apply(null, arguments); }
var SvgPhoto16 = function SvgPhoto16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5w({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$5s || (_path$5s = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M11.5 3.5h-7a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1v-7a1 1 0 0 0-1-1M4.5 2A2.5 2.5 0 0 0 2 4.5v7A2.5 2.5 0 0 0 4.5 14h7a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 11.5 2z",
    clipRule: "evenodd"
  })), _path2$1Q || (_path2$1Q = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M5.647 6.25c.205 0 .4.084.542.232l2.777 2.904 1.526-1.14a.75.75 0 0 1 .991.082l2.06 2.154a.75.75 0 1 1-1.085 1.036l-1.6-1.673-1.527 1.14a.75.75 0 0 1-.99-.082L5.646 8.085l-2.105 2.202a.75.75 0 0 1-1.084-1.036l2.647-2.77a.75.75 0 0 1 .542-.231M9.5 5.8a.3.3 0 1 0 0-.6.3.3 0 0 0 0 .6m0 1.2a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3",
    clipRule: "evenodd"
  })));
};

var _path$5r, _path2$1P;
function _extends$5v() { return _extends$5v = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$5v.apply(null, arguments); }
var SvgPhoto18 = function SvgPhoto18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5v({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$5r || (_path$5r = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M13.25 3.85h-8.5a.9.9 0 0 0-.9.9v8.5a.9.9 0 0 0 .9.9h8.5a.9.9 0 0 0 .9-.9v-8.5a.9.9 0 0 0-.9-.9m-8.5-1.6a2.5 2.5 0 0 0-2.5 2.5v8.5a2.5 2.5 0 0 0 2.5 2.5h8.5a2.5 2.5 0 0 0 2.5-2.5v-8.5a2.5 2.5 0 0 0-2.5-2.5z",
    clipRule: "evenodd"
  })), _path2$1P || (_path2$1P = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M5.434 6.934a.8.8 0 0 1 1.13-.002l3.559 3.535 1.915-1.49a.8.8 0 0 1 1.11.124l2.203 2.692a.8.8 0 0 1-1.239 1.014l-1.707-2.088-1.855 1.443a.8.8 0 0 1-1.055-.064L6.002 8.63l-2.236 2.237a.8.8 0 0 1-1.132-1.132zM10.688 6.575a.388.388 0 1 0 0-.775.388.388 0 0 0 0 .775m0 1.3a1.687 1.687 0 1 0 0-3.375 1.687 1.687 0 0 0 0 3.375",
    clipRule: "evenodd"
  })));
};

var _path$5q, _path2$1O;
function _extends$5u() { return _extends$5u = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$5u.apply(null, arguments); }
var SvgPhoto24 = function SvgPhoto24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5u({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$5q || (_path$5q = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M18 4.8H6A1.2 1.2 0 0 0 4.8 6v12A1.2 1.2 0 0 0 6 19.2h12a1.2 1.2 0 0 0 1.2-1.2V6A1.2 1.2 0 0 0 18 4.8M6 3a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3z",
    clipRule: "evenodd"
  })), _path2$1O || (_path2$1O = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M7.605 9.357a.9.9 0 0 1 1.26 0l4.643 4.554 2.682-1.879a.9.9 0 0 1 1.146.095l3.294 3.23a.9.9 0 1 1-1.26 1.285l-2.76-2.706-2.682 1.878a.9.9 0 0 1-1.146-.095l-4.547-4.458-3.605 3.535a.9.9 0 0 1-1.26-1.285zM14.25 8.8a.55.55 0 1 0 0-1.1.55.55 0 0 0 0 1.1m0 1.7a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5",
    clipRule: "evenodd"
  })));
};

var _path$5p, _path2$1N;
function _extends$5t() { return _extends$5t = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$5t.apply(null, arguments); }
var SvgPhoto32 = function SvgPhoto32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5t({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$5p || (_path$5p = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M24 6H8a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2M8 4a4 4 0 0 0-4 4v16a4 4 0 0 0 4 4h16a4 4 0 0 0 4-4V8a4 4 0 0 0-4-4z",
    clipRule: "evenodd"
  })), _path2$1N || (_path2$1N = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M10.28 12.62a1 1 0 0 1 1.4 0l6.31 6.187 3.71-2.6a1 1 0 0 1 1.275.105l4.392 4.307a1 1 0 0 1-1.4 1.428l-3.8-3.726-3.711 2.6a1 1 0 0 1-1.274-.104l-6.202-6.083-4.947 4.852a1 1 0 1 1-1.4-1.428zM19 12a1 1 0 1 0 0-2 1 1 0 0 0 0 2m0 2a3 3 0 1 0 0-6 3 3 0 0 0 0 6",
    clipRule: "evenodd"
  })));
};

var _path$5o, _path2$1M;
function _extends$5s() { return _extends$5s = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$5s.apply(null, arguments); }
var SvgPhoto48 = function SvgPhoto48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5s({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$5o || (_path$5o = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M37 8.4H11A2.6 2.6 0 0 0 8.4 11v26a2.6 2.6 0 0 0 2.6 2.6h26a2.6 2.6 0 0 0 2.6-2.6V11A2.6 2.6 0 0 0 37 8.4M11 6a5 5 0 0 0-5 5v26a5 5 0 0 0 5 5h26a5 5 0 0 0 5-5V11a5 5 0 0 0-5-5z",
    clipRule: "evenodd"
  })), _path2$1M || (_path2$1M = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M15.152 19.152a1.2 1.2 0 0 1 1.697 0l10.28 10.28 6.174-4.408a1.2 1.2 0 0 1 1.546.127l6.5 6.5a1.2 1.2 0 1 1-1.697 1.698l-5.782-5.782-6.172 4.41a1.2 1.2 0 0 1-1.547-.128L16 21.697 8.349 29.35A1.2 1.2 0 1 1 6.65 27.65zM28.5 18.6a2.1 2.1 0 1 0 0-4.2 2.1 2.1 0 0 0 0 4.2m0 2.4a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9",
    clipRule: "evenodd"
  })));
};

var PhotoIcon = function PhotoIcon(props) {
  var photo = {
    12: SvgPhoto12,
    16: SvgPhoto16,
    18: SvgPhoto18,
    24: SvgPhoto24,
    32: SvgPhoto32,
    48: SvgPhoto48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: photo
  }, props));
};

var _path$5n;
function _extends$5r() { return _extends$5r = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$5r.apply(null, arguments); }
var SvgPin12 = function SvgPin12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5r({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$5n || (_path$5n = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1.2,
    d: "M6 10.8V7.5M4.543 5.34c.37-.124.763-.19 1.165-.19h.525c.424 0 .837.072 1.226.206M4.543 5.34c-.862.29-1.6.894-2.05 1.716a.3.3 0 0 0 .263.444H6M4.543 5.34l.214-2.322c-.823-.398-1.28-1.131-1.44-1.433-.034-.063.013-.135.085-.135h5.192c.073 0 .12.074.083.138-.168.294-.631.994-1.437 1.398l.219 2.37m0 0a3.75 3.75 0 0 1 2.03 1.686.307.307 0 0 1-.267.458H6"
  })));
};

var _path$5m;
function _extends$5q() { return _extends$5q = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$5q.apply(null, arguments); }
var SvgPin16 = function SvgPin16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5q({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$5m || (_path$5m = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M8 14.4V10M6.057 7.12a4.9 4.9 0 0 1 1.554-.253h.7c.565 0 1.116.095 1.634.275M6.057 7.12a4.9 4.9 0 0 0-2.733 2.287.4.4 0 0 0 .35.592H8M6.057 7.12l.286-3.095c-1.098-.532-1.707-1.51-1.921-1.911-.045-.085.018-.18.113-.18h6.923c.097 0 .16.098.111.183-.223.393-.841 1.326-1.916 1.864l.292 3.16m0 0a5 5 0 0 1 2.707 2.248.41.41 0 0 1-.356.611H8"
  })));
};

var _path$5l;
function _extends$5p() { return _extends$5p = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$5p.apply(null, arguments); }
var SvgPin18 = function SvgPin18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5p({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$5l || (_path$5l = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1.6,
    d: "M9 16.2v-4.95M6.814 8.01a5.5 5.5 0 0 1 1.749-.285h.787c.636 0 1.256.107 1.838.309M6.814 8.01a5.5 5.5 0 0 0-3.075 2.574.45.45 0 0 0 .395.666H9M6.814 8.01l.322-3.483c-1.235-.598-1.92-1.697-2.16-2.15-.051-.095.019-.202.127-.202h7.787c.11 0 .18.11.126.206-.252.442-.947 1.492-2.156 2.098l.328 3.555m0 0a5.62 5.62 0 0 1 3.045 2.528.46.46 0 0 1-.4.688H9"
  })));
};

var _path$5k;
function _extends$5o() { return _extends$5o = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$5o.apply(null, arguments); }
var SvgPin24 = function SvgPin24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5o({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$5k || (_path$5k = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1.8,
    d: "M12 21.6V15m-2.915-4.32a7.3 7.3 0 0 1 2.332-.38h1.05c.847 0 1.674.143 2.45.412m-5.832-.031a7.33 7.33 0 0 0-4.1 3.432.6.6 0 0 0 .527.887H12m-2.915-4.32.43-4.643c-1.647-.798-2.56-2.263-2.882-2.866-.067-.127.027-.27.17-.27h10.384c.146 0 .24.147.168.274-.336.59-1.263 1.99-2.876 2.797l.438 4.74m0 0a7.5 7.5 0 0 1 4.06 3.372.613.613 0 0 1-.532.916H12"
  })));
};

var _path$5j;
function _extends$5n() { return _extends$5n = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$5n.apply(null, arguments); }
var SvgPin32 = function SvgPin32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5n({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$5j || (_path$5j = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M16 28.8V20m-3.886-5.76a9.8 9.8 0 0 1 3.109-.507h1.4c1.13 0 2.231.19 3.267.55m-7.776-.043a9.77 9.77 0 0 0-5.466 4.576A.8.8 0 0 0 7.349 20H16m-3.886-5.76.572-6.192c-2.195-1.063-3.413-3.017-3.841-3.821-.09-.17.035-.36.226-.36h13.845c.195 0 .32.196.224.365-.448.787-1.684 2.653-3.834 3.73l.584 6.32m0 0a10 10 0 0 1 5.413 4.495.817.817 0 0 1-.71 1.223H16"
  })));
};

var _path$5i;
function _extends$5m() { return _extends$5m = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$5m.apply(null, arguments); }
var SvgPin48 = function SvgPin48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5m({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$5i || (_path$5i = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 2.4,
    d: "M24 43.2V30m-5.83-8.64a14.7 14.7 0 0 1 4.664-.76h2.1c1.694 0 3.347.286 4.9.824m-11.663-.063a14.66 14.66 0 0 0-8.2 6.863A1.2 1.2 0 0 0 11.024 30H24m-5.83-8.64.86-9.287c-3.294-1.595-5.122-4.526-5.764-5.733-.134-.253.053-.54.34-.54h20.768c.292 0 .48.295.335.55-.672 1.179-2.525 3.978-5.75 5.593l.876 9.48m0 0a15 15 0 0 1 8.12 6.743A1.226 1.226 0 0 1 36.89 30H24"
  })));
};

var PinIcon = function PinIcon(props) {
  var pin = {
    12: SvgPin12,
    16: SvgPin16,
    18: SvgPin18,
    24: SvgPin24,
    32: SvgPin32,
    48: SvgPin48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: pin
  }, props));
};

var _path$5h, _path2$1L;
function _extends$5l() { return _extends$5l = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$5l.apply(null, arguments); }
var SvgPlayCircle12 = function SvgPlayCircle12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5l({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$5h || (_path$5h = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M6 9.8a3.8 3.8 0 1 0 0-7.6 3.8 3.8 0 0 0 0 7.6M6 11A5 5 0 1 0 6 1a5 5 0 0 0 0 10",
    clipRule: "evenodd"
  })), _path2$1L || (_path2$1L = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M7.6 5.48a.6.6 0 0 1 0 1.04L5.65 7.645a.6.6 0 0 1-.9-.52v-2.25a.6.6 0 0 1 .9-.52z"
  })));
};

var _path$5g, _path2$1K;
function _extends$5k() { return _extends$5k = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$5k.apply(null, arguments); }
var SvgPlayCircle16 = function SvgPlayCircle16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5k({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$5g || (_path$5g = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8 13.167A5.167 5.167 0 1 0 8 2.833a5.167 5.167 0 0 0 0 10.334m0 1.5A6.667 6.667 0 1 0 8 1.333a6.667 6.667 0 0 0 0 13.334",
    clipRule: "evenodd"
  })), _path2$1K || (_path2$1K = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M10.433 7.48a.6.6 0 0 1 0 1.04l-3.2 1.847a.6.6 0 0 1-.9-.52V6.154a.6.6 0 0 1 .9-.52z"
  })));
};

var _path$5f, _path2$1J;
function _extends$5j() { return _extends$5j = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$5j.apply(null, arguments); }
var SvgPlayCircle18 = function SvgPlayCircle18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5j({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$5f || (_path$5f = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M9 14.9A5.9 5.9 0 1 0 9 3.1a5.9 5.9 0 0 0 0 11.8m0 1.6a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15",
    clipRule: "evenodd"
  })), _path2$1J || (_path2$1J = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M11.55 8.307a.8.8 0 0 1 0 1.386l-3.225 1.862a.8.8 0 0 1-1.2-.693V7.138a.8.8 0 0 1 1.2-.693z"
  })));
};

var _path$5e, _path2$1I;
function _extends$5i() { return _extends$5i = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$5i.apply(null, arguments); }
var SvgPlayCircle24 = function SvgPlayCircle24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5i({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$5e || (_path$5e = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M12 20.2a8.2 8.2 0 1 0 0-16.4 8.2 8.2 0 0 0 0 16.4m0 1.8c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10",
    clipRule: "evenodd"
  })), _path2$1I || (_path2$1I = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M15.5 11.134a1 1 0 0 1 0 1.732L11 15.464a1 1 0 0 1-1.5-.866V9.402a1 1 0 0 1 1.5-.866z"
  })));
};

var _path$5d, _path2$1H;
function _extends$5h() { return _extends$5h = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$5h.apply(null, arguments); }
var SvgPlayCircle32 = function SvgPlayCircle32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5h({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$5d || (_path$5d = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M16 27.333c6.26 0 11.333-5.074 11.333-11.333S22.26 4.667 16 4.667 4.667 9.74 4.667 16 9.74 27.333 16 27.333m0 2c7.364 0 13.333-5.97 13.333-13.333S23.363 2.667 16 2.667 2.667 8.637 2.667 16 8.637 29.333 16 29.333",
    clipRule: "evenodd"
  })), _path2$1H || (_path2$1H = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M20.417 14.7c1 .578 1 2.022 0 2.599l-5.5 3.175a1.5 1.5 0 0 1-2.25-1.299v-6.35a1.5 1.5 0 0 1 2.25-1.3z"
  })));
};

var _path$5c, _path2$1G;
function _extends$5g() { return _extends$5g = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$5g.apply(null, arguments); }
var SvgPlayCircle48 = function SvgPlayCircle48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5g({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$5c || (_path$5c = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M24 41.6c9.72 0 17.6-7.88 17.6-17.6S33.72 6.4 24 6.4 6.4 14.28 6.4 24 14.28 41.6 24 41.6m0 2.4c11.046 0 20-8.954 20-20S35.046 4 24 4 4 12.954 4 24s8.954 20 20 20",
    clipRule: "evenodd"
  })), _path2$1G || (_path2$1G = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M31 22.268c1.333.77 1.333 2.694 0 3.464l-9 5.196c-1.333.77-3-.192-3-1.732V18.804c0-1.54 1.667-2.502 3-1.732z"
  })));
};

var PlayCircleIcon = function PlayCircleIcon(props) {
  var playCircle = {
    12: SvgPlayCircle12,
    16: SvgPlayCircle16,
    18: SvgPlayCircle18,
    24: SvgPlayCircle24,
    32: SvgPlayCircle32,
    48: SvgPlayCircle48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: playCircle
  }, props));
};

var _path$5b;
function _extends$5f() { return _extends$5f = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$5f.apply(null, arguments); }
var SvgPlayCircleFilled12 = function SvgPlayCircleFilled12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5f({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$5b || (_path$5b = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M6 11A5 5 0 1 0 6 1a5 5 0 0 0 0 10m1.6-4.48a.6.6 0 0 0 0-1.04L5.65 4.356a.6.6 0 0 0-.9.52v2.251c0 .462.5.75.9.52z",
    clipRule: "evenodd"
  })));
};

var _path$5a;
function _extends$5e() { return _extends$5e = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$5e.apply(null, arguments); }
var SvgPlayCircleFilled16 = function SvgPlayCircleFilled16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5e({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$5a || (_path$5a = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M7.83 14.33a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13m2.603-5.81a.6.6 0 0 0 0-1.04l-3.2-1.847a.6.6 0 0 0-.9.52v3.695c0 .462.5.75.9.52z",
    clipRule: "evenodd"
  })));
};

var _path$59;
function _extends$5d() { return _extends$5d = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$5d.apply(null, arguments); }
var SvgPlayCircleFilled18 = function SvgPlayCircleFilled18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5d({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$59 || (_path$59 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M9 16.5a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15m2.55-6.807a.8.8 0 0 0 0-1.386L8.325 6.445a.8.8 0 0 0-1.2.693v3.724a.8.8 0 0 0 1.2.693z",
    clipRule: "evenodd"
  })));
};

var _path$58;
function _extends$5c() { return _extends$5c = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$5c.apply(null, arguments); }
var SvgPlayCircleFilled24 = function SvgPlayCircleFilled24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5c({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$58 || (_path$58 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10m3.5-9.134a1 1 0 0 0 0-1.732L11 8.536a1 1 0 0 0-1.5.866v5.196a1 1 0 0 0 1.5.866z",
    clipRule: "evenodd"
  })));
};

var _path$57;
function _extends$5b() { return _extends$5b = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$5b.apply(null, arguments); }
var SvgPlayCircleFilled32 = function SvgPlayCircleFilled32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5b({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$57 || (_path$57 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M16.005 29.34c7.365 0 13.335-5.97 13.335-13.335S23.37 2.67 16.005 2.67 2.67 8.64 2.67 16.005 8.64 29.34 16.005 29.34m4.412-12.041c1-.577 1-2.02 0-2.598l-5.5-3.176a1.5 1.5 0 0 0-2.25 1.3v6.35a1.5 1.5 0 0 0 2.25 1.3z",
    clipRule: "evenodd"
  })));
};

var _path$56;
function _extends$5a() { return _extends$5a = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$5a.apply(null, arguments); }
var SvgPlayCircleFilled48 = function SvgPlayCircleFilled48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5a({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$56 || (_path$56 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M24 44c11.046 0 20-8.954 20-20S35.046 4 24 4 4 12.954 4 24s8.954 20 20 20m7-18.269c1.333-.77 1.333-2.694 0-3.464l-9-5.196c-1.333-.77-3 .192-3 1.732v10.392c0 1.54 1.667 2.502 3 1.732z",
    clipRule: "evenodd"
  })));
};

var PlayCircleFilledIcon = function PlayCircleFilledIcon(props) {
  var playCircleFilled = {
    12: SvgPlayCircleFilled12,
    16: SvgPlayCircleFilled16,
    18: SvgPlayCircleFilled18,
    24: SvgPlayCircleFilled24,
    32: SvgPlayCircleFilled32,
    48: SvgPlayCircleFilled48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: playCircleFilled
  }, props));
};

var _path$55;
function _extends$59() { return _extends$59 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$59.apply(null, arguments); }
var SvgPlayFilled12 = function SvgPlayFilled12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$59({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$55 || (_path$55 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M2.25 8.814V3.185a1.25 1.25 0 0 1 1.884-1.077l5.15 3.03a1 1 0 0 1 0 1.724l-5.15 3.03A1.25 1.25 0 0 1 2.25 8.814"
  })));
};

var _path$54;
function _extends$58() { return _extends$58 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$58.apply(null, arguments); }
var SvgPlayFilled16 = function SvgPlayFilled16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$58({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$54 || (_path$54 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M3 11.753V4.247c0-1.289 1.4-2.09 2.512-1.436l6.868 4.04a1.333 1.333 0 0 1 0 2.298l-6.868 4.04C4.4 13.843 3 13.042 3 11.753"
  })));
};

var _path$53;
function _extends$57() { return _extends$57 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$57.apply(null, arguments); }
var SvgPlayFilled18 = function SvgPlayFilled18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$57({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$53 || (_path$53 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M3.375 13.222V4.778c0-1.45 1.576-2.351 2.826-1.616l7.726 4.545a1.5 1.5 0 0 1 0 2.586l-7.726 4.545c-1.25.735-2.826-.166-2.826-1.616"
  })));
};

var _path$52;
function _extends$56() { return _extends$56 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$56.apply(null, arguments); }
var SvgPlayFilled24 = function SvgPlayFilled24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$56({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$52 || (_path$52 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M4.5 17.629V6.371c0-1.934 2.101-3.135 3.768-2.155l10.301 6.06c1.315.773 1.315 2.675 0 3.448l-10.301 6.06c-1.667.98-3.768-.221-3.768-2.155"
  })));
};

var _path$51;
function _extends$55() { return _extends$55 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$55.apply(null, arguments); }
var SvgPlayFilled32 = function SvgPlayFilled32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$55({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$51 || (_path$51 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M6 23.505V8.495c0-2.578 2.801-4.18 5.023-2.873l13.736 8.08c1.753 1.03 1.753 3.565 0 4.596l-13.736 8.08C8.801 27.685 6 26.083 6 23.505"
  })));
};

var _path$50;
function _extends$54() { return _extends$54 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$54.apply(null, arguments); }
var SvgPlayFilled48 = function SvgPlayFilled48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$54({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$50 || (_path$50 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M9 35.258V12.742c0-3.867 4.202-6.27 7.535-4.31l20.604 12.12c2.63 1.547 2.63 5.349 0 6.896l-20.604 12.12C13.202 41.528 9 39.125 9 35.258"
  })));
};

var PlayFilledIcon = function PlayFilledIcon(props) {
  var playFilled = {
    12: SvgPlayFilled12,
    16: SvgPlayFilled16,
    18: SvgPlayFilled18,
    24: SvgPlayFilled24,
    32: SvgPlayFilled32,
    48: SvgPlayFilled48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: playFilled
  }, props));
};

var _path$4$, _path2$1F;
function _extends$53() { return _extends$53 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$53.apply(null, arguments); }
var SvgPoint12 = function SvgPoint12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$53({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$4$ || (_path$4$ = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M5.05 3.55h1.3a1.8 1.8 0 1 1 0 3.6h-.7v1a.6.6 0 0 1-1.2 0v-4a.6.6 0 0 1 .6-.6m.6 2.4v-1.2h.7a.6.6 0 0 1 0 1.2z",
    clipRule: "evenodd"
  })), _path2$1F || (_path2$1F = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M11 6A5 5 0 1 1 1 6a5 5 0 0 1 10 0M9.8 6a3.8 3.8 0 1 1-7.6 0 3.8 3.8 0 0 1 7.6 0",
    clipRule: "evenodd"
  })));
};

var _path$4_, _path2$1E;
function _extends$52() { return _extends$52 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$52.apply(null, arguments); }
var SvgPoint16 = function SvgPoint16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$52({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$4_ || (_path$4_ = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M5.983 5.533a.75.75 0 0 1 .807-.75h1.677a2.35 2.35 0 1 1 0 4.7h-.984v1.384a.75.75 0 0 1-1.5 0zm1.5.75v1.7h.984a.85.85 0 0 0 0-1.7z",
    clipRule: "evenodd"
  })), _path2$1E || (_path2$1E = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8 14.667A6.667 6.667 0 1 0 8 1.333a6.667 6.667 0 0 0 0 13.334m0-1.5A5.167 5.167 0 1 0 8 2.833a5.167 5.167 0 0 0 0 10.334",
    clipRule: "evenodd"
  })));
};

var _path$4Z, _path2$1D;
function _extends$51() { return _extends$51 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$51.apply(null, arguments); }
var SvgPoint18 = function SvgPoint18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$51({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$4Z || (_path$4Z = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M6.775 6.225a.8.8 0 0 1 .831-.8h1.919a2.6 2.6 0 0 1 0 5.2h-1.15v1.6a.8.8 0 1 1-1.6 0zm1.6.8v2h1.15a1 1 0 1 0 0-2z",
    clipRule: "evenodd"
  })), _path2$1D || (_path2$1D = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M9 16.5a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15m0-1.6A5.9 5.9 0 1 0 9 3.1a5.9 5.9 0 0 0 0 11.8",
    clipRule: "evenodd"
  })));
};

var _path$4Y, _path2$1C, _path3$9;
function _extends$50() { return _extends$50 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$50.apply(null, arguments); }
var SvgPoint24 = function SvgPoint24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$50({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$4Y || (_path$4Y = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M12 20.2a8.2 8.2 0 1 0 0-16.4 8.2 8.2 0 0 0 0 16.4m0 1.8C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10"
  })), _path2$1C || (_path2$1C = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M10.1 7.4a.9.9 0 0 1 .9.9v8a.9.9 0 1 1-1.8 0v-8a.9.9 0 0 1 .9-.9"
  })), _path3$9 || (_path3$9 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M9.2 8.385c0-.544.44-.985.985-.985H12.7a3.3 3.3 0 0 1 0 6.6H9.2zM11 9.2v3h1.7a1.5 1.5 0 1 0 0-3z"
  })));
};

var _path$4X, _path2$1B;
function _extends$4$() { return _extends$4$ = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$4$.apply(null, arguments); }
var SvgPoint32 = function SvgPoint32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4$({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$4X || (_path$4X = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "m13.467 10.067.055.001.058-.001h3.353a4.2 4.2 0 1 1 0 8.4h-2.466v3.266a1 1 0 1 1-2 0V11.067a1 1 0 0 1 1-1m1 6.4v-4.4h2.466a2.2 2.2 0 1 1 0 4.4z",
    clipRule: "evenodd"
  })), _path2$1B || (_path2$1B = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M29.333 16c0 7.364-5.97 13.333-13.333 13.333S2.667 23.363 2.667 16 8.637 2.667 16 2.667 29.333 8.637 29.333 16m-2 0c0 6.26-5.074 11.333-11.333 11.333S4.667 22.26 4.667 16 9.74 4.667 16 4.667 27.333 9.74 27.333 16",
    clipRule: "evenodd"
  })));
};

var _path$4W, _path2$1A;
function _extends$4_() { return _extends$4_ = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$4_.apply(null, arguments); }
var SvgPoint48 = function SvgPoint48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4_({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$4W || (_path$4W = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M19 16.6a1.2 1.2 0 0 1 1.282-1.197l.087-.003H25.4a6 6 0 0 1 0 12h-4v5.2a1.2 1.2 0 0 1-2.4 0zm2.4 1.2V25h4a3.6 3.6 0 0 0 0-7.2z",
    clipRule: "evenodd"
  })), _path2$1A || (_path2$1A = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M24 44c11.046 0 20-8.954 20-20S35.046 4 24 4 4 12.954 4 24s8.954 20 20 20m0-2.4c9.72 0 17.6-7.88 17.6-17.6S33.72 6.4 24 6.4 6.4 14.28 6.4 24 14.28 41.6 24 41.6",
    clipRule: "evenodd"
  })));
};

var PointIcon = function PointIcon(props) {
  var point = {
    12: SvgPoint12,
    16: SvgPoint16,
    18: SvgPoint18,
    24: SvgPoint24,
    32: SvgPoint32,
    48: SvgPoint48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: point
  }, props));
};

var _path$4V;
function _extends$4Z() { return _extends$4Z = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$4Z.apply(null, arguments); }
var SvgPointFilled12 = function SvgPointFilled12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4Z({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$4V || (_path$4V = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M6 11A5 5 0 1 0 6 1a5 5 0 0 0 0 10m-.95-7.45h1.3a1.8 1.8 0 1 1 0 3.6h-.7v1a.6.6 0 0 1-1.2 0v-4a.6.6 0 0 1 .6-.6m.6 2.4v-1.2h.7a.6.6 0 1 1 0 1.2z",
    clipRule: "evenodd"
  })));
};

var _path$4U;
function _extends$4Y() { return _extends$4Y = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$4Y.apply(null, arguments); }
var SvgPointFilled16 = function SvgPointFilled16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4Y({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$4U || (_path$4U = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8 14.666A6.667 6.667 0 1 0 8 1.333a6.667 6.667 0 0 0 0 13.333M6.733 4.783h1.734a2.35 2.35 0 0 1 0 4.7h-.984v1.383a.75.75 0 1 1-1.5 0V5.534a.75.75 0 0 1 .75-.75m.75 3.2v-1.7h.984a.85.85 0 0 1 0 1.7z",
    clipRule: "evenodd"
  })));
};

var _path$4T;
function _extends$4X() { return _extends$4X = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$4X.apply(null, arguments); }
var SvgPointFilled18 = function SvgPointFilled18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4X({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$4T || (_path$4T = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M9 16.5a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15M7.575 5.425h1.95a2.6 2.6 0 0 1 0 5.2h-1.15v1.6a.8.8 0 1 1-1.6 0v-6a.8.8 0 0 1 .8-.8m.8 3.6v-2h1.15a1 1 0 1 1 0 2z",
    clipRule: "evenodd"
  })));
};

var _path$4S;
function _extends$4W() { return _extends$4W = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$4W.apply(null, arguments); }
var SvgPointFilled24 = function SvgPointFilled24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4W({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$4S || (_path$4S = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10M10.1 7.4l.042.001H12.7a3.3 3.3 0 0 1 0 6.6H11v2.3a.9.9 0 1 1-1.8 0v-8a.9.9 0 0 1 .9-.9m.9 4.8v-3h1.7a1.5 1.5 0 0 1 0 3z",
    clipRule: "evenodd"
  })));
};

var _path$4R;
function _extends$4V() { return _extends$4V = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$4V.apply(null, arguments); }
var SvgPointFilled32 = function SvgPointFilled32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4V({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$4R || (_path$4R = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M16 29.334c7.364 0 13.333-5.97 13.333-13.334S23.363 2.667 16 2.667 2.667 8.637 2.667 16 8.636 29.334 16 29.334m-2.533-19.267.055.001.058-.001h3.353a4.2 4.2 0 1 1 0 8.4h-2.466v3.267a1 1 0 0 1-2 0V11.067a1 1 0 0 1 1-1m1 6.4v-4.4h2.466a2.2 2.2 0 0 1 0 4.4z",
    clipRule: "evenodd"
  })));
};

var _path$4Q;
function _extends$4U() { return _extends$4U = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$4U.apply(null, arguments); }
var SvgPointFilled48 = function SvgPointFilled48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4U({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$4Q || (_path$4Q = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M24 44c11.046 0 20-8.954 20-20S35.046 4 24 4 4 12.954 4 24s8.954 20 20 20m-3.8-28.6q.041 0 .082.003l.087-.003H25.4a6 6 0 0 1 0 12h-4v5.2a1.2 1.2 0 1 1-2.4 0v-16a1.2 1.2 0 0 1 1.2-1.2m1.2 9.6v-7.2h4a3.6 3.6 0 0 1 0 7.2z",
    clipRule: "evenodd"
  })));
};

var PointFilledIcon = function PointFilledIcon(props) {
  var pointFilled = {
    12: SvgPointFilled12,
    16: SvgPointFilled16,
    18: SvgPointFilled18,
    24: SvgPointFilled24,
    32: SvgPointFilled32,
    48: SvgPointFilled48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: pointFilled
  }, props));
};

var _g$3, _defs$3;
function _extends$4T() { return _extends$4T = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$4T.apply(null, arguments); }
var SvgPresent12 = function SvgPresent12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4T({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _g$3 || (_g$3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#present_12_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M2.9 2.75A1.85 1.85 0 0 1 6 1.386 1.85 1.85 0 0 1 8.983 3.4H10.5a.6.6 0 0 1 .6.6v2a.6.6 0 0 1-.5.592V9a2.1 2.1 0 0 1-2.1 2.1h-5A2.1 2.1 0 0 1 1.4 9V6.592A.6.6 0 0 1 .9 6V4a.6.6 0 0 1 .6-.6h1.517a1.9 1.9 0 0 1-.117-.65m1.85.65h.65v-.65a.65.65 0 1 0-.65.65m1.85-.65v.65h.65a.65.65 0 1 0-.65-.65M5.4 4.6H2.1v.8h3.3zm1.2.8v-.8h3.3v.8zM5.4 6.6H2.6V9a.9.9 0 0 0 .9.9h1.9zm1.2 3.3V6.6h2.8V9a.9.9 0 0 1-.9.9z",
    clipRule: "evenodd"
  }))), _defs$3 || (_defs$3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "present_12_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h12v12H0z"
  })))));
};

var _path$4P;
function _extends$4S() { return _extends$4S = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$4S.apply(null, arguments); }
var SvgPresent16 = function SvgPresent16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4S({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$4P || (_path$4P = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M3.917 3.667A2.417 2.417 0 0 1 8 1.917a2.417 2.417 0 0 1 3.903 2.667H14a.75.75 0 0 1 .75.75V8a.75.75 0 0 1-.667.745V12a2.75 2.75 0 0 1-2.75 2.75H4.667A2.75 2.75 0 0 1 1.917 12V8.745A.75.75 0 0 1 1.25 8V5.333a.75.75 0 0 1 .75-.75h2.097a2.4 2.4 0 0 1-.18-.916m2.416.916h.917v-.916a.917.917 0 1 0-.917.916m2.417-.916v.916h.917a.917.917 0 1 0-.917-.916m-1.5 2.416h-4.5V7.25h4.5zm1.5 1.167V6.083h4.5V7.25zm-1.5 1.5H3.417V12c0 .69.56 1.25 1.25 1.25H7.25zm1.5 4.5v-4.5h3.833V12c0 .69-.56 1.25-1.25 1.25z",
    clipRule: "evenodd"
  })));
};

var _path$4O;
function _extends$4R() { return _extends$4R = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$4R.apply(null, arguments); }
var SvgPresent18 = function SvgPresent18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4R({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$4O || (_path$4O = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M4.45 4.125A2.675 2.675 0 0 1 9 2.217 2.675 2.675 0 0 1 13.325 5.2h2.425a.8.8 0 0 1 .8.8v3a.8.8 0 0 1-.75.798V13.5a3.05 3.05 0 0 1-3.05 3.05h-7.5A3.05 3.05 0 0 1 2.2 13.5V9.798A.8.8 0 0 1 1.45 9V6a.8.8 0 0 1 .8-.8h2.425a2.7 2.7 0 0 1-.225-1.075M7.125 5.2H8.2V4.125A1.075 1.075 0 1 0 7.125 5.2M9.8 4.125V5.2h1.075A1.075 1.075 0 1 0 9.8 4.125M8.2 6.8H3.05v1.4H8.2zm1.6 1.4V6.8h5.15v1.4zM8.2 9.8H3.8v3.7c0 .8.65 1.45 1.45 1.45H8.2zm1.6 5.15V9.8h4.4v3.7c0 .8-.65 1.45-1.45 1.45z",
    clipRule: "evenodd"
  })));
};

var _path$4N, _path2$1z, _path3$8, _path4$1;
function _extends$4Q() { return _extends$4Q = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$4Q.apply(null, arguments); }
var SvgPresent24 = function SvgPresent24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4Q({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$4N || (_path$4N = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M2.1 8a.9.9 0 0 1 .9-.9h18a.9.9 0 0 1 .9.9v4a.9.9 0 0 1-.9.9H3a.9.9 0 0 1-.9-.9zm1.8.9v2.2h16.2V8.9z",
    clipRule: "evenodd"
  })), _path2$1z || (_path2$1z = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M6.1 5.5a3.4 3.4 0 1 1 6.8 0v3.4H9.5a3.4 3.4 0 0 1-3.4-3.4m3.4-1.6a1.6 1.6 0 1 0 0 3.2h1.6V5.5a1.6 1.6 0 0 0-1.6-1.6",
    clipRule: "evenodd"
  })), _path3$8 || (_path3$8 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M17.9 5.5a3.4 3.4 0 1 0-6.8 0v3.4h3.4a3.4 3.4 0 0 0 3.4-3.4m-3.4-1.6a1.6 1.6 0 1 1 0 3.2h-1.6V5.5a1.6 1.6 0 0 1 1.6-1.6M3.1 12a.9.9 0 0 1 .9-.9h16a.9.9 0 0 1 .9.9v6a3.9 3.9 0 0 1-3.9 3.9H7A3.9 3.9 0 0 1 3.1 18zm1.8.9V18c0 1.16.94 2.1 2.1 2.1h10a2.1 2.1 0 0 0 2.1-2.1v-5.1z",
    clipRule: "evenodd"
  })), _path4$1 || (_path4$1 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M12 7.1a.9.9 0 0 1 .9.9v13a.9.9 0 1 1-1.8 0V8a.9.9 0 0 1 .9-.9",
    clipRule: "evenodd"
  })));
};

var _path$4M;
function _extends$4P() { return _extends$4P = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$4P.apply(null, arguments); }
var SvgPresent32 = function SvgPresent32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4P({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$4M || (_path$4M = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8.333 7.333A4.333 4.333 0 0 1 16 4.564a4.333 4.333 0 0 1 6.985 5.102H28a1 1 0 0 1 1 1V16a1 1 0 0 1-1 1h-.333v7a5 5 0 0 1-5 5H9.333a5 5 0 0 1-5-5v-7H4a1 1 0 0 1-1-1v-5.333a1 1 0 0 1 1-1h5.015a4.3 4.3 0 0 1-.682-2.334m4.334 2.334H15V7.333a2.333 2.333 0 1 0-2.333 2.334M17 7.333v2.334h2.333A2.333 2.333 0 1 0 17 7.333m-2 4.334H5V15h10zM17 15v-3.333h10V15zm-2 2H6.333v7a3 3 0 0 0 3 3H15zm2 10V17h8.667v7a3 3 0 0 1-3 3z",
    clipRule: "evenodd"
  })));
};

var _path$4L;
function _extends$4O() { return _extends$4O = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$4O.apply(null, arguments); }
var SvgPresent48 = function SvgPresent48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4O({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$4L || (_path$4L = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M12.8 11A6.2 6.2 0 0 1 24 7.333a6.2 6.2 0 1 1 9.9 7.467H42a1.2 1.2 0 0 1 1.2 1.2v8a1.2 1.2 0 0 1-1.2 1.2h-.8V36a7.2 7.2 0 0 1-7.2 7.2H14A7.2 7.2 0 0 1 6.8 36V25.2H6A1.2 1.2 0 0 1 4.8 24v-8A1.2 1.2 0 0 1 6 14.8h8.1a6.17 6.17 0 0 1-1.3-3.8m6.2 3.8h3.8V11a3.8 3.8 0 1 0-3.8 3.8m6.2-3.8v3.8H29a3.8 3.8 0 1 0-3.8-3.8m-2.4 6.2H7.2v5.6h15.6zm2.4 5.6v-5.6h15.6v5.6zm-2.4 2.4H9.2V36a4.8 4.8 0 0 0 4.8 4.8h8.8zm2.4 15.6V25.2h13.6V36a4.8 4.8 0 0 1-4.8 4.8z",
    clipRule: "evenodd"
  })));
};

var PresentIcon = function PresentIcon(props) {
  var present = {
    12: SvgPresent12,
    16: SvgPresent16,
    18: SvgPresent18,
    24: SvgPresent24,
    32: SvgPresent32,
    48: SvgPresent48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: present
  }, props));
};

var _path$4K, _path2$1y;
function _extends$4N() { return _extends$4N = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$4N.apply(null, arguments); }
var SvgPresentFilled12 = function SvgPresentFilled12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4N({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$4K || (_path$4K = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M4.75.9A1.85 1.85 0 0 0 3.08 3.55H1.5a.45.45 0 0 0-.45.45v2a.45.45 0 0 0 .438.45H5.4V3.4h1.2v3.05h3.911A.45.45 0 0 0 10.95 6V4a.45.45 0 0 0-.45-.45H8.919A1.85 1.85 0 0 0 6 1.386 1.84 1.84 0 0 0 4.75.9m.65 2.5v-.65a.65.65 0 1 0-.65.65zm2.5-.65a.65.65 0 0 0-1.3 0v.65h.65a.65.65 0 0 0 .65-.65",
    clipRule: "evenodd"
  })), _path2$1y || (_path2$1y = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M10.45 7.65H6.6v3.3h1.9A1.95 1.95 0 0 0 10.45 9zM5.4 10.95v-3.3H1.55V9a1.95 1.95 0 0 0 1.95 1.95z"
  })));
};

var _path$4J, _path2$1x;
function _extends$4M() { return _extends$4M = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$4M.apply(null, arguments); }
var SvgPresentFilled16 = function SvgPresentFilled16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4M({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$4J || (_path$4J = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M6.333 1.25a2.417 2.417 0 0 0-2.169 3.483H2a.6.6 0 0 0-.6.6V8a.6.6 0 0 0 .6.6h5.25V4.583h1.5V8.6H14a.6.6 0 0 0 .6-.6V5.333a.6.6 0 0 0-.6-.6h-2.164A2.417 2.417 0 0 0 8 1.916a2.4 2.4 0 0 0-1.667-.666m-.917 2.417a.917.917 0 0 1 1.834 0v.916h-.917a.917.917 0 0 1-.917-.916m5.168 0a.917.917 0 1 0-1.834 0v.916h.917c.506 0 .917-.41.917-.916",
    clipRule: "evenodd"
  })), _path2$1x || (_path2$1x = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M13.934 10.1H8.75v4.5h2.584a2.6 2.6 0 0 0 2.6-2.6zM7.25 14.6v-4.5H2.067V12a2.6 2.6 0 0 0 2.6 2.6z"
  })));
};

var _path$4I;
function _extends$4L() { return _extends$4L = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$4L.apply(null, arguments); }
var SvgPresentFilled18 = function SvgPresentFilled18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4L({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$4I || (_path$4I = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M15.675 11.3H9.8v5.125h2.95a2.925 2.925 0 0 0 2.925-2.925zM8.2 16.425V11.3H2.325v2.2a2.925 2.925 0 0 0 2.925 2.925zM7.125 1.45a2.675 2.675 0 0 0-2.391 3.875H2.25A.675.675 0 0 0 1.575 6v3c0 .373.302.675.675.675h.075L8.2 9.7V5.2H7.125A1.075 1.075 0 1 1 8.2 4.1v1.0999999999999999h1.6V4.1a1.075 1.075 0 1 1 1.075 1.1H9.8v4.5l5.875-.025h.075A.675.675 0 0 0 16.425 9V6a.675.675 0 0 0-.675-.675h-2.484A2.675 2.675 0 0 0 9 2.217a2.67 2.67 0 0 0-1.875-.767"
  })));
};

var _path$4H;
function _extends$4K() { return _extends$4K = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$4K.apply(null, arguments); }
var SvgPresentFilled24 = function SvgPresentFilled24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4K({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$4H || (_path$4H = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M9.5 2.1a3.4 3.4 0 0 0-3 5H3a.9.9 0 0 0-.9.9v4a.9.9 0 0 0 .9.9h8.1V7.1h1.8v5.8H21a.9.9 0 0 0 .9-.9V8a.9.9 0 0 0-.9-.9h-3.5A3.4 3.4 0 0 0 12 3.196 3.4 3.4 0 0 0 9.5 2.1m11.4 12.6h-8v7.2H17a3.9 3.9 0 0 0 3.9-3.9zm-9.8 7.2v-7.2h-8V18A3.9 3.9 0 0 0 7 21.9zm1.8-14.8V5.48a1.6 1.6 0 1 1 1.6 1.62zm-1.8 0H9.5a1.6 1.6 0 1 1 1.6-1.62V7.1",
    clipRule: "evenodd"
  })));
};

var _path$4G, _path2$1w;
function _extends$4J() { return _extends$4J = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$4J.apply(null, arguments); }
var SvgPresentFilled32 = function SvgPresentFilled32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4J({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$4G || (_path$4G = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M12.667 2.8a4.333 4.333 0 0 0-3.652 6.667H4a1.2 1.2 0 0 0-1.2 1.2V16A1.2 1.2 0 0 0 4 17.2h11V9.46h2v7.74h11a1.2 1.2 0 0 0 1.2-1.2v-5.333a1.2 1.2 0 0 0-1.2-1.2h-5.015A4.333 4.333 0 0 0 16 4.365 4.32 4.32 0 0 0 12.667 2.8m-.028 6.667h2.36V7.133L15 7.102a2.333 2.333 0 1 0-2.361 2.365m4.361 0h2.361A2.333 2.333 0 1 0 17 7.102v2.365",
    clipRule: "evenodd"
  })), _path2$1w || (_path2$1w = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M27.867 19.2H17v10h-2v-10H4.133V24a5.2 5.2 0 0 0 5.2 5.2h13.334a5.2 5.2 0 0 0 5.2-5.2z"
  })));
};

var _path$4F, _path2$1v;
function _extends$4I() { return _extends$4I = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$4I.apply(null, arguments); }
var SvgPresentFilled48 = function SvgPresentFilled48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4I({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$4F || (_path$4F = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M19 4.2a6.2 6.2 0 0 0-4.9 10H6A1.8 1.8 0 0 0 4.2 16v8A1.8 1.8 0 0 0 6 25.8h16.8V14.2h2.4v11.6H42a1.8 1.8 0 0 0 1.8-1.8v-8a1.8 1.8 0 0 0-1.8-1.8h-8.1A6.2 6.2 0 1 0 24 6.733 6.19 6.19 0 0 0 19 4.2m3.8 10v-3.8a3.8 3.8 0 1 0-3.8 3.8zm6.2 0h-3.8v-3.8a3.8 3.8 0 1 1 3.8 3.8",
    clipRule: "evenodd"
  })), _path2$1v || (_path2$1v = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M41.8 28.2H25.2v15.6H34a7.8 7.8 0 0 0 7.8-7.8zM22.8 43.8V28.2H6.2V36a7.8 7.8 0 0 0 7.8 7.8z"
  })));
};

var PresentFilledIcon = function PresentFilledIcon(props) {
  var presentFilled = {
    12: SvgPresentFilled12,
    16: SvgPresentFilled16,
    18: SvgPresentFilled18,
    24: SvgPresentFilled24,
    32: SvgPresentFilled32,
    48: SvgPresentFilled48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: presentFilled
  }, props));
};

var _path$4E;
function _extends$4H() { return _extends$4H = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$4H.apply(null, arguments); }
var SvgProfile12 = function SvgProfile12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4H({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$4E || (_path$4E = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M6 2.1a1.4 1.4 0 1 0 0 2.8 1.4 1.4 0 0 0 0-2.8M3.4 3.5a2.6 2.6 0 1 1 5.2 0 2.6 2.6 0 0 1-5.2 0M6 7.8c-1.823 0-2.919.833-3.268 1.82-.01.024-.007.035-.006.04a.1.1 0 0 0 .026.043A.34.34 0 0 0 3 9.8h6c.115 0 .205-.05.25-.098a.1.1 0 0 0 .028-.048c.001-.005.004-.017-.005-.043C8.93 8.61 7.843 7.8 6 7.8M1.6 9.218C2.165 7.629 3.816 6.6 6 6.6s3.852.993 4.409 2.623c.167.49.023.961-.27 1.284a1.54 1.54 0 0 1-1.14.493H3c-.437 0-.856-.181-1.138-.494a1.26 1.26 0 0 1-.26-1.288",
    clipRule: "evenodd"
  })));
};

var _path$4D;
function _extends$4G() { return _extends$4G = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$4G.apply(null, arguments); }
var SvgProfile16 = function SvgProfile16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4G({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$4D || (_path$4D = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M6.083 4.667a1.917 1.917 0 1 1 3.834 0 1.917 1.917 0 0 1-3.834 0M8 1.25a3.417 3.417 0 1 0 0 6.833A3.417 3.417 0 0 0 8 1.25M3.573 12.896c.46-1.566 1.976-2.813 4.427-2.813 2.477 0 3.983 1.21 4.434 2.803.022.078.008.143-.056.213a.52.52 0 0 1-.378.151H4a.52.52 0 0 1-.375-.15c-.062-.067-.075-.129-.052-.204M8 8.583c-3.002 0-5.187 1.582-5.866 3.89a1.69 1.69 0 0 0 .386 1.64c.368.403.91.637 1.48.637h8c.57 0 1.112-.234 1.48-.635.38-.412.576-1.006.397-1.636-.67-2.37-2.873-3.896-5.877-3.896",
    clipRule: "evenodd"
  })));
};

var _path$4C;
function _extends$4F() { return _extends$4F = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$4F.apply(null, arguments); }
var SvgProfile18 = function SvgProfile18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4F({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$4C || (_path$4C = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M6.8 5.25a2.2 2.2 0 1 1 4.4 0 2.2 2.2 0 0 1-4.4 0M9 1.45a3.8 3.8 0 1 0 0 7.6 3.8 3.8 0 0 0 0-7.6M3.977 14.496C4.502 12.712 6.227 11.3 9 11.3c2.801 0 4.517 1.37 5.03 3.185.03.104.008.193-.073.28a.63.63 0 0 1-.457.185h-9a.62.62 0 0 1-.454-.183c-.08-.086-.099-.17-.07-.271M9 9.7c-3.361 0-5.8 1.77-6.558 4.344-.204.694.007 1.35.425 1.805a2.22 2.22 0 0 0 1.633.701h9c.63 0 1.227-.259 1.633-.7a1.87 1.87 0 0 0 .437-1.8C14.823 11.408 12.364 9.7 9 9.7",
    clipRule: "evenodd"
  })));
};

var _path$4B;
function _extends$4E() { return _extends$4E = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$4E.apply(null, arguments); }
var SvgProfile24 = function SvgProfile24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4E({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$4B || (_path$4B = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8.9 7a3.1 3.1 0 1 1 6.2 0 3.1 3.1 0 0 1-6.2 0M12 2.1a4.9 4.9 0 1 0 0 9.8 4.9 4.9 0 0 0 0-9.8M5.143 19.28C5.867 16.82 8.24 14.9 12 14.9c3.794 0 6.159 1.861 6.867 4.368a.53.53 0 0 1-.135.533c-.157.17-.422.3-.732.3H6a1 1 0 0 1-.728-.299.51.51 0 0 1-.13-.521M12 13.1c-4.42 0-7.597 2.322-8.584 5.672a2.31 2.31 0 0 0 .529 2.247c.508.554 1.26.881 2.055.881h12c.794 0 1.546-.327 2.055-.88a2.33 2.33 0 0 0 .544-2.241c-.971-3.437-4.172-5.679-8.6-5.679",
    clipRule: "evenodd"
  })));
};

var _path$4A;
function _extends$4D() { return _extends$4D = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$4D.apply(null, arguments); }
var SvgProfile32 = function SvgProfile32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4D({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$4A || (_path$4A = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M16 5a4.333 4.333 0 1 0 0 8.667A4.333 4.333 0 0 0 16 5M9.667 9.333a6.333 6.333 0 1 1 12.666 0 6.333 6.333 0 0 1-12.666 0M16 19.667c-5.085 0-8.34 2.605-9.335 5.984-.099.335-.013.637.217.887.244.267.65.462 1.118.462h16c.467 0 .875-.195 1.123-.464.233-.253.322-.56.226-.9-.974-3.445-4.22-5.97-9.35-5.97M4.747 25.086c1.286-4.368 5.433-7.42 11.253-7.42 5.832 0 10.007 2.947 11.273 7.427.305 1.077-.025 2.089-.68 2.799C25.953 28.586 25.005 29 24 29H8c-1.006 0-1.954-.414-2.592-1.11-.654-.713-.978-1.727-.661-2.804",
    clipRule: "evenodd"
  })));
};

var _path$4z;
function _extends$4C() { return _extends$4C = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$4C.apply(null, arguments); }
var SvgProfile48 = function SvgProfile48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4C({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$4z || (_path$4z = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M24 4.8a9.2 9.2 0 1 0 0 18.4 9.2 9.2 0 0 0 0-18.4M17.2 14a6.8 6.8 0 1 1 13.6 0 6.8 6.8 0 0 1-13.6 0M24 26.8c-8.62 0-14.706 4.51-16.592 10.913-.443 1.504.009 2.92.925 3.919.898.98 2.24 1.568 3.667 1.568h24c1.428 0 2.769-.588 3.67-1.566.918-.997 1.377-2.408.952-3.913C38.766 31.157 32.642 26.8 24 26.8M9.71 38.39C11.247 33.174 16.262 29.2 24 29.2c7.8 0 12.807 3.85 14.312 9.174.176.62.006 1.185-.407 1.633-.43.467-1.123.793-1.905.793H12c-.782 0-1.473-.326-1.898-.79-.408-.445-.573-1.004-.392-1.619",
    clipRule: "evenodd"
  })));
};

var ProfileIcon = function ProfileIcon(props) {
  var profile = {
    12: SvgProfile12,
    16: SvgProfile16,
    18: SvgProfile18,
    24: SvgProfile24,
    32: SvgProfile32,
    48: SvgProfile48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: profile
  }, props));
};

var _path$4y;
function _extends$4B() { return _extends$4B = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$4B.apply(null, arguments); }
var SvgProfileFilled12 = function SvgProfileFilled12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4B({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$4y || (_path$4y = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M6 .9a2.6 2.6 0 1 0 0 5.2A2.6 2.6 0 0 0 6 .9M6 6.6c-2.185 0-3.835 1.03-4.399 2.618-.174.49-.033.963.26 1.288.282.313.702.494 1.139.494h6c.437 0 .857-.18 1.139-.493.293-.323.437-.793.27-1.284C9.852 7.593 8.186 6.6 6 6.6"
  })));
};

var _path$4x;
function _extends$4A() { return _extends$4A = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$4A.apply(null, arguments); }
var SvgProfileFilled16 = function SvgProfileFilled16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4A({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$4x || (_path$4x = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M8 1.25a3.417 3.417 0 1 0 0 6.833A3.417 3.417 0 0 0 8 1.25M8 8.583c-3.002 0-5.187 1.582-5.866 3.89a1.69 1.69 0 0 0 .386 1.64c.368.403.91.637 1.48.637h8c.57 0 1.112-.234 1.48-.635.38-.412.576-1.006.397-1.636-.67-2.37-2.873-3.896-5.877-3.896"
  })));
};

var _path$4w;
function _extends$4z() { return _extends$4z = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$4z.apply(null, arguments); }
var SvgProfileFilled18 = function SvgProfileFilled18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4z({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$4w || (_path$4w = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M9 1.45a3.8 3.8 0 1 0 0 7.6 3.8 3.8 0 0 0 0-7.6M9 9.7c-3.36 0-5.8 1.77-6.558 4.344-.204.694.007 1.35.425 1.805a2.22 2.22 0 0 0 1.633.701h9c.63 0 1.227-.259 1.634-.7a1.87 1.87 0 0 0 .436-1.8C14.823 11.408 12.364 9.7 9 9.7"
  })));
};

var _path$4v;
function _extends$4y() { return _extends$4y = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$4y.apply(null, arguments); }
var SvgProfileFilled24 = function SvgProfileFilled24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4y({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$4v || (_path$4v = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M12 2.1a4.9 4.9 0 1 0 0 9.8 4.9 4.9 0 0 0 0-9.8M12 13.1c-4.42 0-7.597 2.322-8.584 5.672a2.31 2.31 0 0 0 .529 2.247c.508.554 1.26.881 2.055.881h12c.794 0 1.546-.327 2.055-.88a2.33 2.33 0 0 0 .544-2.241c-.971-3.437-4.172-5.679-8.6-5.679"
  })));
};

var _path$4u;
function _extends$4x() { return _extends$4x = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$4x.apply(null, arguments); }
var SvgProfileFilled32 = function SvgProfileFilled32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4x({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$4u || (_path$4u = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M9.667 9.333a6.333 6.333 0 1 1 12.666 0 6.333 6.333 0 0 1-12.666 0M4.747 25.086c1.286-4.368 5.433-7.42 11.253-7.42 5.832 0 10.007 2.947 11.273 7.427.305 1.077-.025 2.089-.68 2.799C25.953 28.586 25.005 29 24 29H8c-1.006 0-1.954-.414-2.592-1.11-.654-.713-.978-1.727-.661-2.804"
  })));
};

var _path$4t;
function _extends$4w() { return _extends$4w = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$4w.apply(null, arguments); }
var SvgProfileFilled48 = function SvgProfileFilled48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4w({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$4t || (_path$4t = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M14.8 14a9.2 9.2 0 1 1 18.4 0 9.2 9.2 0 0 1-18.4 0M7.408 37.713C9.294 31.31 15.38 26.8 24 26.8c8.643 0 14.766 4.357 16.622 10.92.425 1.506-.034 2.917-.952 3.914-.901.978-2.242 1.566-3.67 1.566H12c-1.427 0-2.769-.589-3.667-1.568-.916-1-1.368-2.415-.925-3.919"
  })));
};

var ProfileFilledIcon = function ProfileFilledIcon(props) {
  var profileFilled = {
    12: SvgProfileFilled12,
    16: SvgProfileFilled16,
    18: SvgProfileFilled18,
    24: SvgProfileFilled24,
    32: SvgProfileFilled32,
    48: SvgProfileFilled48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: profileFilled
  }, props));
};

var _path$4s, _path2$1u;
function _extends$4v() { return _extends$4v = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$4v.apply(null, arguments); }
var SvgQuestion12 = function SvgQuestion12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4v({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$4s || (_path$4s = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M6.386 6.824c-.055.245-.198.388-.458.388-.311 0-.495-.212-.495-.513v-.051c0-.432.224-.718.656-.97.472-.282.615-.466.615-.803 0-.358-.278-.607-.68-.607-.36 0-.602.175-.719.501-.091.235-.256.337-.48.337-.289 0-.468-.18-.468-.458 0-.157.036-.296.11-.435.234-.484.82-.795 1.607-.795 1.04 0 1.74.571 1.74 1.425 0 .553-.267.93-.784 1.234-.487.282-.597.44-.644.747M6.536 8.267a.584.584 0 0 1-.6.575.583.583 0 0 1-.598-.575c0-.323.268-.575.597-.575.333 0 .6.252.6.575"
  })), _path2$1u || (_path2$1u = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M11 6A5 5 0 1 1 1 6a5 5 0 0 1 10 0M9.9 6a3.9 3.9 0 1 1-7.8 0 3.9 3.9 0 0 1 7.8 0",
    clipRule: "evenodd"
  })));
};

var _path$4r, _path2$1t;
function _extends$4u() { return _extends$4u = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$4u.apply(null, arguments); }
var SvgQuestion16 = function SvgQuestion16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4u({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$4r || (_path$4r = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M8.422 8.956c-.049.322-.215.522-.547.522-.371 0-.576-.263-.576-.62v-.093c0-.605.303-1.005.913-1.367.605-.366.81-.635.81-1.103 0-.533-.415-.904-1.015-.904-.542 0-.903.269-1.06.762-.107.303-.288.425-.556.425-.337 0-.537-.205-.537-.532 0-.21.043-.391.136-.577.303-.664 1.065-1.074 2.07-1.074 1.324 0 2.232.752 2.232 1.856 0 .747-.371 1.26-1.035 1.655-.64.371-.796.605-.835 1.05M8.593 10.904a.696.696 0 0 1-.708.693.7.7 0 0 1-.713-.693c0-.386.317-.688.713-.688s.708.302.708.688"
  })), _path2$1t || (_path2$1t = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M14.666 8A6.667 6.667 0 1 1 1.333 8a6.667 6.667 0 0 1 13.333 0m-1.35 0A5.317 5.317 0 1 1 2.683 8a5.317 5.317 0 0 1 10.633 0",
    clipRule: "evenodd"
  })));
};

var _path$4q, _path2$1s;
function _extends$4t() { return _extends$4t = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$4t.apply(null, arguments); }
var SvgQuestion18 = function SvgQuestion18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4t({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$4q || (_path$4q = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M9.563 10.138c-.055.363-.242.588-.616.588-.417 0-.648-.297-.648-.698v-.104c0-.681.34-1.132 1.027-1.538.681-.412.912-.714.912-1.242 0-.599-.467-1.016-1.142-1.016-.61 0-1.017.302-1.192.857-.121.34-.325.478-.627.478-.379 0-.604-.23-.604-.599 0-.236.05-.44.154-.648.34-.747 1.197-1.209 2.329-1.209 1.489 0 2.51.846 2.51 2.088 0 .84-.417 1.417-1.164 1.862-.72.417-.896.681-.94 1.18M9.755 12.33c0 .434-.352.78-.797.78a.79.79 0 0 1-.802-.78c0-.434.357-.775.802-.775s.797.34.797.775"
  })), _path2$1s || (_path2$1s = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M16.5 9a7.5 7.5 0 1 1-15 0 7.5 7.5 0 0 1 15 0m-1.45 0a6.05 6.05 0 1 1-12.1 0 6.05 6.05 0 0 1 12.1 0",
    clipRule: "evenodd"
  })));
};

var _path$4p, _path2$1r;
function _extends$4s() { return _extends$4s = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$4s.apply(null, arguments); }
var SvgQuestion24 = function SvgQuestion24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4s({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$4p || (_path$4p = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M12.733 13.684c-.073.484-.322.784-.82.784-.557 0-.864-.396-.864-.93v-.14c0-.908.454-1.508 1.37-2.05.908-.55 1.215-.953 1.215-1.656 0-.798-.622-1.355-1.523-1.355-.813 0-1.355.403-1.59 1.143-.16.454-.432.637-.834.637-.506 0-.806-.307-.806-.798 0-.315.066-.586.205-.864.454-.997 1.597-1.612 3.105-1.612 1.985 0 3.348 1.128 3.348 2.783 0 1.121-.557 1.89-1.553 2.483-.96.557-1.194.909-1.253 1.575M12.99 16.606c0 .58-.469 1.04-1.062 1.04s-1.07-.46-1.07-1.04c0-.578.476-1.032 1.07-1.032.593 0 1.062.454 1.062 1.032"
  })), _path2$1r || (_path2$1r = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10m-1.8 0a8.2 8.2 0 1 1-16.4 0 8.2 8.2 0 0 1 16.4 0",
    clipRule: "evenodd"
  })));
};

var _path$4o, _path2$1q;
function _extends$4r() { return _extends$4r = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$4r.apply(null, arguments); }
var SvgQuestion32 = function SvgQuestion32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4r({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$4o || (_path$4o = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M16.788 18.294c-.05.625-.342 1.036-.977 1.036-.684 0-1.025-.498-1.025-1.143v-.225c0-1.25.605-2.08 1.874-2.841 1.182-.713 1.602-1.3 1.602-2.256 0-1.153-.889-1.944-2.187-1.944-1.182 0-1.963.586-2.276 1.65-.195.606-.498.821-.986.821-.606 0-.947-.361-.947-.957 0-.42.088-.762.263-1.142.596-1.348 2.08-2.168 4.034-2.168 2.548 0 4.316 1.494 4.316 3.652 0 1.514-.762 2.549-2.05 3.32-1.26.742-1.593 1.24-1.641 2.197M17.1 22.22c0 .713-.557 1.26-1.29 1.26-.712 0-1.278-.547-1.278-1.26s.566-1.26 1.279-1.26c.732 0 1.289.547 1.289 1.26"
  })), _path2$1q || (_path2$1q = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M29.334 16c0 7.364-5.97 13.334-13.334 13.334S2.667 23.364 2.667 16 8.637 2.667 16 2.667 29.334 8.637 29.334 16m-2 0c0 6.26-5.074 11.334-11.334 11.334S4.667 22.26 4.667 16 9.741 4.667 16 4.667 27.334 9.741 27.334 16",
    clipRule: "evenodd"
  })));
};

var _path$4n, _path2$1p;
function _extends$4q() { return _extends$4q = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$4q.apply(null, arguments); }
var SvgQuestion48 = function SvgQuestion48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4q({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$4n || (_path$4n = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M25.056 27.441c-.074.938-.513 1.553-1.465 1.553-1.026 0-1.538-.747-1.538-1.714v-.337c0-1.875.908-3.12 2.812-4.262 1.773-1.07 2.403-1.949 2.403-3.384 0-1.729-1.333-2.915-3.282-2.915-1.772 0-2.944.879-3.413 2.475-.293.909-.747 1.23-1.48 1.23-.907 0-1.42-.541-1.42-1.435 0-.63.132-1.142.395-1.713.894-2.022 3.12-3.252 6.05-3.252 3.823 0 6.475 2.24 6.475 5.478 0 2.27-1.143 3.823-3.076 4.98-1.89 1.114-2.388 1.86-2.461 3.296M25.524 33.33c0 1.07-.835 1.89-1.933 1.89-1.07 0-1.92-.82-1.92-1.89s.85-1.89 1.92-1.89c1.098 0 1.933.82 1.933 1.89"
  })), _path2$1p || (_path2$1p = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M44 24c0 11.046-8.954 20-20 20S4 35.046 4 24 12.954 4 24 4s20 8.954 20 20m-2.4 0c0 9.72-7.88 17.6-17.6 17.6S6.4 33.72 6.4 24 14.28 6.4 24 6.4 41.6 14.28 41.6 24",
    clipRule: "evenodd"
  })));
};

var QuestionIcon = function QuestionIcon(props) {
  var question = {
    12: SvgQuestion12,
    16: SvgQuestion16,
    18: SvgQuestion18,
    24: SvgQuestion24,
    32: SvgQuestion32,
    48: SvgQuestion48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: question
  }, props));
};

var _path$4m;
function _extends$4p() { return _extends$4p = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$4p.apply(null, arguments); }
var SvgQuestionFilled12 = function SvgQuestionFilled12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4p({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$4m || (_path$4m = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    stroke: "#2F3438",
    strokeWidth: 0.65,
    d: "M6.626 6.886a.8.8 0 0 1-.181.47.62.62 0 0 1-.332.198.79.79 0 0 1 .63.779c0 .453-.36.797-.808.797a.796.796 0 0 1-.805-.797c0-.392.272-.702.63-.78a.66.66 0 0 1-.363-.22.8.8 0 0 1-.171-.513v-.084c0-.292.072-.552.228-.784.153-.225.372-.404.632-.56m.54 1.494L6.254 5.67m.372 1.216v-.01c.007-.14.032-.208.075-.266.052-.071.154-.16.38-.294h.003c.555-.333.927-.816.927-1.525 0-.5-.208-.933-.566-1.236-.355-.3-.838-.458-1.378-.458-.816 0-1.517.346-1.809 1.004m2.368 2.785L4.555 4.235m1.531 1.157.168.278m-.168-.278.168.278m-.168-.278c.208-.125.313-.22.37-.299a.43.43 0 0 0 .073-.269.36.36 0 0 0-.118-.283.56.56 0 0 0-.377-.12c-.167 0-.28.04-.357.097a.52.52 0 0 0-.184.288l-.003.008a.8.8 0 0 1-.25.393.67.67 0 0 1-.43.14.68.68 0 0 1-.494-.193.7.7 0 0 1-.185-.49c0-.211.046-.385.127-.563m1.996 1.57c.443-.268.6-.488.6-.847 0-.432-.333-.729-.82-.729-.443 0-.736.22-.853.62-.073.226-.187.307-.37.307-.227 0-.355-.136-.355-.359 0-.157.033-.286.099-.428M4.258 4.1v.002l.297.132M4.258 4.1l.001-.003.296.137M10.675 6a4.675 4.675 0 1 1-9.35 0 4.675 4.675 0 0 1 9.35 0Z"
  })));
};

var _path$4l;
function _extends$4o() { return _extends$4o = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$4o.apply(null, arguments); }
var SvgQuestionFilled16 = function SvgQuestionFilled16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4o({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$4l || (_path$4l = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    stroke: "#2F3438",
    strokeWidth: 0.867,
    d: "M8.8 9.014v-.012c.01-.188.044-.278.1-.355.07-.095.206-.214.508-.392l.003-.002c.74-.443 1.236-1.086 1.236-2.032 0-.666-.277-1.244-.754-1.648-.473-.4-1.117-.611-1.837-.611-1.088 0-2.023.462-2.412 1.339a1.7 1.7 0 0 0-.17.75c0 .23.067.47.247.653.18.185.422.258.66.258a.9.9 0 0 0 .573-.187c.172-.138.27-.33.332-.523l.004-.011a.7.7 0 0 1 .246-.385c.102-.074.253-.129.476-.129.237 0 .402.072.502.16a.48.48 0 0 1 .158.378.57.57 0 0 1-.098.359c-.076.106-.216.231-.493.398-.347.209-.639.447-.842.748a1.8 1.8 0 0 0-.305 1.044v.113c0 .232.061.483.228.683.127.152.294.251.483.295a1.056 1.056 0 0 0-.838 1.038 1.06 1.06 0 0 0 1.073 1.063c.597 0 1.078-.458 1.078-1.063 0-.522-.36-.935-.842-1.038a.83.83 0 0 0 .443-.263c.164-.186.225-.42.241-.628ZM14.233 8A6.233 6.233 0 1 1 1.766 8a6.233 6.233 0 0 1 12.467 0Z"
  })));
};

var _path$4k;
function _extends$4n() { return _extends$4n = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$4n.apply(null, arguments); }
var SvgQuestionFilled18 = function SvgQuestionFilled18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4n({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$4k || (_path$4k = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    stroke: "#2F3438",
    strokeWidth: 0.975,
    d: "M9.988 10.203v-.013c.012-.211.05-.313.114-.4.078-.107.23-.24.57-.44l.003-.002c.834-.499 1.391-1.223 1.391-2.286 0-.75-.312-1.4-.849-1.855-.531-.45-1.257-.687-2.066-.687-1.224 0-2.276.52-2.713 1.506a1.9 1.9 0 0 0-.192.844c0 .259.076.529.278.735.203.208.475.29.742.29.211 0 .442-.047.645-.21.194-.156.304-.371.374-.589l.004-.012c.063-.215.163-.35.277-.433s.284-.145.535-.145c.267 0 .453.08.565.18a.54.54 0 0 1 .178.425c0 .188-.038.301-.11.404-.086.119-.244.26-.555.447-.39.235-.719.503-.947.841a2.04 2.04 0 0 0-.344 1.176v.126c0 .262.07.544.258.77.142.17.33.281.543.33a1.19 1.19 0 0 0-.943 1.169c0 .68.546 1.196 1.207 1.196.671 0 1.212-.516 1.212-1.196 0-.588-.403-1.053-.946-1.169a.94.94 0 0 0 .498-.295c.185-.21.253-.472.271-.707ZM16.013 9A7.012 7.012 0 1 1 1.987 9a7.012 7.012 0 0 1 14.025 0Z"
  })));
};

var _path$4j;
function _extends$4m() { return _extends$4m = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$4m.apply(null, arguments); }
var SvgQuestionFilled24 = function SvgQuestionFilled24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4m({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$4j || (_path$4j = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    stroke: "#2F3438",
    strokeWidth: 1.3,
    d: "m13.3 13.771.002-.008v-.01c.014-.281.065-.416.15-.533.104-.142.308-.32.761-.587l.004-.002c1.111-.665 1.854-1.63 1.854-3.048 0-1-.415-1.867-1.132-2.473-.708-.6-1.675-.917-2.755-.917-1.631 0-3.033.694-3.617 2.009a2.6 2.6 0 0 0-.256 1.124c0 .346.101.706.37.981.272.277.634.387.99.387.282 0 .59-.064.86-.28.258-.208.406-.495.5-.786l.002-.008.002-.008c.085-.287.217-.466.37-.577.153-.112.379-.194.713-.194.357 0 .604.107.754.24a.72.72 0 0 1 .237.567c0 .251-.051.402-.148.538-.113.159-.324.347-.739.597-.52.313-.958.67-1.263 1.122-.313.463-.458.983-.458 1.567v.168c0 .35.093.725.343 1.026.19.227.44.376.724.442a1.58 1.58 0 0 0-1.257 1.557c0 .907.729 1.595 1.61 1.595.895 0 1.616-.688 1.616-1.595 0-.783-.538-1.403-1.262-1.558.253-.059.483-.186.665-.393.246-.28.337-.63.36-.943ZM21.35 12a9.35 9.35 0 1 1-18.7 0 9.35 9.35 0 0 1 18.7 0Z"
  })));
};

var _path$4i;
function _extends$4l() { return _extends$4l = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$4l.apply(null, arguments); }
var SvgQuestionFilled32 = function SvgQuestionFilled32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4l({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$4i || (_path$4i = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    stroke: "#2F3438",
    strokeWidth: 1.733,
    d: "M17.652 18.362v-.012l.001-.011c.02-.377.086-.557.2-.712.14-.19.41-.427 1.015-.783l.005-.003c1.482-.887 2.473-2.173 2.473-4.064 0-1.334-.554-2.489-1.51-3.297-.944-.8-2.234-1.222-3.673-1.222-2.176 0-4.045.925-4.824 2.678a3.44 3.44 0 0 0-.34 1.5c0 .46.135.94.493 1.307.362.37.845.516 1.32.516.376 0 .787-.085 1.147-.374.344-.277.54-.66.665-1.047l.003-.011.004-.011c.112-.382.289-.62.492-.77.204-.149.506-.258.952-.258.475 0 .805.143 1.005.32.19.17.315.417.315.757 0 .334-.068.535-.197.717-.15.211-.431.462-.984.796-.695.417-1.279.893-1.685 1.495-.418.618-.61 1.312-.61 2.09v.224c0 .465.123.966.457 1.368.253.303.586.5.966.589a2.11 2.11 0 0 0-1.677 2.076c0 1.21.972 2.127 2.146 2.127 1.193 0 2.156-.918 2.156-2.127a2.104 2.104 0 0 0-1.683-2.077c.337-.079.644-.249.886-.525.328-.373.449-.84.481-1.256ZM28.466 16c0 6.886-5.581 12.467-12.467 12.467-6.885 0-12.466-5.581-12.466-12.467C3.534 9.115 9.115 3.534 16 3.534c6.886 0 12.467 5.581 12.467 12.466Z"
  })));
};

var _path$4h;
function _extends$4k() { return _extends$4k = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$4k.apply(null, arguments); }
var SvgQuestionFilled48 = function SvgQuestionFilled48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4k({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$4h || (_path$4h = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    stroke: "#2F3438",
    strokeWidth: 2.6,
    d: "m26.352 27.543.001-.018.001-.017c.029-.564.13-.835.3-1.068.209-.285.616-.64 1.523-1.174l.007-.005c2.223-1.33 3.709-3.26 3.709-6.096 0-2-.83-3.733-2.264-4.946-1.417-1.198-3.351-1.832-5.51-1.832-3.264 0-6.068 1.387-7.235 4.016-.328.712-.511 1.407-.511 2.25 0 .69.202 1.41.74 1.961.543.555 1.267.774 1.98.774.563 0 1.18-.128 1.72-.561.516-.415.81-.99.998-1.57l.005-.017.005-.016c.168-.574.433-.931.737-1.154.308-.225.76-.388 1.428-.388.713 0 1.209.215 1.508.48.287.256.474.625.474 1.135 0 .502-.102.803-.296 1.076-.226.317-.648.693-1.477 1.194-1.042.625-1.918 1.34-2.527 2.243-.627.927-.915 1.967-.915 3.133v.337c0 .698.184 1.45.686 2.052.378.454.88.752 1.448.884a3.17 3.17 0 0 0-2.515 3.114c0 1.814 1.458 3.19 3.219 3.19 1.79 0 3.233-1.376 3.233-3.19 0-1.566-1.077-2.806-2.524-3.115a2.5 2.5 0 0 0 1.33-.788c.491-.56.673-1.26.722-1.884ZM42.7 24c0 10.328-8.372 18.7-18.7 18.7S5.3 34.328 5.3 24 13.672 5.3 24 5.3 42.7 13.672 42.7 24Z"
  })));
};

var QuestionFilledIcon = function QuestionFilledIcon(props) {
  var questionFilled = {
    12: SvgQuestionFilled12,
    16: SvgQuestionFilled16,
    18: SvgQuestionFilled18,
    24: SvgQuestionFilled24,
    32: SvgQuestionFilled32,
    48: SvgQuestionFilled48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: questionFilled
  }, props));
};

var _path$4g;
function _extends$4j() { return _extends$4j = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$4j.apply(null, arguments); }
var SvgScrap12 = function SvgScrap12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4j({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$4g || (_path$4g = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8.5 2.3h-5a.3.3 0 0 0-.3.3v6.435l1.635-1.021a2.2 2.2 0 0 1 2.332 0L8.8 9.034V2.6a.3.3 0 0 0-.3-.3m-5-1.2A1.5 1.5 0 0 0 2 2.6v7.698a.5.5 0 0 0 .765.424l2.706-1.69a1 1 0 0 1 1.06 0l2.704 1.69a.5.5 0 0 0 .765-.424V2.6a1.5 1.5 0 0 0-1.5-1.5z",
    clipRule: "evenodd"
  })));
};

var _path$4f;
function _extends$4i() { return _extends$4i = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$4i.apply(null, arguments); }
var SvgScrap16 = function SvgScrap16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4i({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$4f || (_path$4f = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M11.333 2.967H4.667a.5.5 0 0 0-.5.5v8.76l2.332-1.457a2.83 2.83 0 0 1 3.004 0l2.33 1.457v-8.76a.5.5 0 0 0-.5-.5m-6.666-1.5a2 2 0 0 0-2 2V13.73c0 .523.576.842 1.02.565l3.607-2.254c.433-.27.981-.27 1.414 0l3.605 2.254a.667.667 0 0 0 1.02-.566V3.467a2 2 0 0 0-2-2z",
    clipRule: "evenodd"
  })));
};

var _path$4e;
function _extends$4h() { return _extends$4h = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$4h.apply(null, arguments); }
var SvgScrap18 = function SvgScrap18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4h({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$4e || (_path$4e = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M12.75 3.25h-7.5a.65.65 0 0 0-.65.65v10.014l2.758-1.724a3.1 3.1 0 0 1 3.286 0l2.756 1.723V3.9a.65.65 0 0 0-.65-.65m-7.5-1.6A2.25 2.25 0 0 0 3 3.9v11.547a.75.75 0 0 0 1.147.636l4.059-2.536a1.5 1.5 0 0 1 1.59 0l4.057 2.536A.75.75 0 0 0 15 15.447V3.9a2.25 2.25 0 0 0-2.25-2.25z",
    clipRule: "evenodd"
  })));
};

var _path$4d;
function _extends$4g() { return _extends$4g = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$4g.apply(null, arguments); }
var SvgScrap24 = function SvgScrap24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4g({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$4d || (_path$4d = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M17 4H7a1.2 1.2 0 0 0-1.2 1.2v13.953l4.187-2.617a3.8 3.8 0 0 1 4.028 0l4.185 2.616V5.2A1.2 1.2 0 0 0 17 4M7 2.2a3 3 0 0 0-3 3v15.396a1 1 0 0 0 1.53.848l5.411-3.382a2 2 0 0 1 2.12 0l5.409 3.381a1 1 0 0 0 1.53-.848V5.2a3 3 0 0 0-3-3z",
    clipRule: "evenodd"
  })));
};

var _path$4c;
function _extends$4f() { return _extends$4f = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$4f.apply(null, arguments); }
var SvgScrap32 = function SvgScrap32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4f({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$4c || (_path$4c = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M22.667 4.933H9.333a2 2 0 0 0-2 2V26.26l6.195-3.872a4.67 4.67 0 0 1 4.947 0l6.192 3.87V6.934a2 2 0 0 0-2-2m-13.334-2a4 4 0 0 0-4 4v20.528a1.333 1.333 0 0 0 2.04 1.131l7.215-4.509a2.67 2.67 0 0 1 2.827 0l7.212 4.508a1.333 1.333 0 0 0 2.04-1.13V6.933a4 4 0 0 0-4-4z",
    clipRule: "evenodd"
  })));
};

var _path$4b;
function _extends$4e() { return _extends$4e = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$4e.apply(null, arguments); }
var SvgScrap48 = function SvgScrap48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4e({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$4b || (_path$4b = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M34 6.8H14a3.6 3.6 0 0 0-3.6 3.6v30.07l10.21-6.38a6.4 6.4 0 0 1 6.785 0L37.6 40.47V10.4A3.6 3.6 0 0 0 34 6.8M14 4.4a6 6 0 0 0-6 6v30.792c0 1.57 1.728 2.528 3.06 1.696l10.823-6.763a4 4 0 0 1 4.24 0l10.817 6.762c1.332.833 3.06-.125 3.06-1.696V10.4a6 6 0 0 0-6-6z",
    clipRule: "evenodd"
  })));
};

var ScrapIcon = function ScrapIcon(props) {
  var scrap = {
    12: SvgScrap12,
    16: SvgScrap16,
    18: SvgScrap18,
    24: SvgScrap24,
    32: SvgScrap32,
    48: SvgScrap48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: scrap
  }, props));
};

var _path$4a;
function _extends$4d() { return _extends$4d = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$4d.apply(null, arguments); }
var SvgScrapFilled12 = function SvgScrapFilled12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4d({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$4a || (_path$4a = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M3.5 1.1A1.5 1.5 0 0 0 2 2.6v7.698a.5.5 0 0 0 .765.424l2.706-1.69a1 1 0 0 1 1.06 0l2.704 1.69a.5.5 0 0 0 .765-.424V2.6a1.5 1.5 0 0 0-1.5-1.5z",
    clipRule: "evenodd"
  })));
};

var _path$49;
function _extends$4c() { return _extends$4c = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$4c.apply(null, arguments); }
var SvgScrapFilled16 = function SvgScrapFilled16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4c({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$49 || (_path$49 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M4.667 1.467a2 2 0 0 0-2 2V13.73c0 .523.576.842 1.02.565l3.607-2.254c.433-.27.981-.27 1.414 0l3.605 2.254a.667.667 0 0 0 1.02-.566V3.467a2 2 0 0 0-2-2z",
    clipRule: "evenodd"
  })));
};

var _path$48;
function _extends$4b() { return _extends$4b = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$4b.apply(null, arguments); }
var SvgScrapFilled18 = function SvgScrapFilled18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4b({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$48 || (_path$48 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M5.25 1.65A2.25 2.25 0 0 0 3 3.9v11.547a.75.75 0 0 0 1.147.636l4.059-2.536a1.5 1.5 0 0 1 1.59 0l4.057 2.536A.75.75 0 0 0 15 15.447V3.9a2.25 2.25 0 0 0-2.25-2.25z",
    clipRule: "evenodd"
  })));
};

var _path$47;
function _extends$4a() { return _extends$4a = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$4a.apply(null, arguments); }
var SvgScrapFilled24 = function SvgScrapFilled24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4a({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$47 || (_path$47 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M7 2.2a3 3 0 0 0-3 3v15.396a1 1 0 0 0 1.53.848l5.411-3.382a2 2 0 0 1 2.12 0l5.409 3.381a1 1 0 0 0 1.53-.848V5.2a3 3 0 0 0-3-3z",
    clipRule: "evenodd"
  })));
};

var _path$46;
function _extends$49() { return _extends$49 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$49.apply(null, arguments); }
var SvgScrapFilled32 = function SvgScrapFilled32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$49({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$46 || (_path$46 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M9.334 2.933a4 4 0 0 0-4 4v20.528a1.333 1.333 0 0 0 2.04 1.13l7.215-4.508a2.67 2.67 0 0 1 2.826 0l7.212 4.508a1.333 1.333 0 0 0 2.04-1.13V6.933a4 4 0 0 0-4-4z",
    clipRule: "evenodd"
  })));
};

var _path$45;
function _extends$48() { return _extends$48 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$48.apply(null, arguments); }
var SvgScrapFilled48 = function SvgScrapFilled48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$48({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$45 || (_path$45 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M14 4.4a6 6 0 0 0-6 6v30.792c0 1.57 1.728 2.528 3.06 1.696l10.823-6.763a4 4 0 0 1 4.24 0l10.817 6.762c1.332.833 3.06-.125 3.06-1.696V10.4a6 6 0 0 0-6-6z",
    clipRule: "evenodd"
  })));
};

var ScrapFilledIcon = function ScrapFilledIcon(props) {
  var scrapFilled = {
    12: SvgScrapFilled12,
    16: SvgScrapFilled16,
    18: SvgScrapFilled18,
    24: SvgScrapFilled24,
    32: SvgScrapFilled32,
    48: SvgScrapFilled48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: scrapFilled
  }, props));
};

var _path$44;
function _extends$47() { return _extends$47 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$47.apply(null, arguments); }
var SvgSearch12 = function SvgSearch12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$47({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$44 || (_path$44 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M7.443 8.292a3.75 3.75 0 1 1 .849-.849l2.632 2.633a.6.6 0 0 1-.848.848zM7.8 5.25a2.55 2.55 0 1 1-5.1 0 2.55 2.55 0 0 1 5.1 0",
    clipRule: "evenodd"
  })));
};

var _path$43;
function _extends$46() { return _extends$46 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$46.apply(null, arguments); }
var SvgSearch16 = function SvgSearch16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$46({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$43 || (_path$43 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M9.965 11.026a5 5 0 1 1 1.06-1.06l3.505 3.504a.75.75 0 1 1-1.06 1.06zM10.5 7a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0",
    clipRule: "evenodd"
  })));
};

var _path$42;
function _extends$45() { return _extends$45 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$45.apply(null, arguments); }
var SvgSearch18 = function SvgSearch18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$45({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$42 || (_path$42 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M11.247 12.378a5.625 5.625 0 1 1 1.131-1.131l3.938 3.937a.8.8 0 0 1-1.132 1.132zm.653-4.503a4.025 4.025 0 1 1-8.05 0 4.025 4.025 0 0 1 8.05 0",
    clipRule: "evenodd"
  })));
};

var _path$41;
function _extends$44() { return _extends$44 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$44.apply(null, arguments); }
var SvgSearch24 = function SvgSearch24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$44({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$41 || (_path$41 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M15.129 16.402a7.5 7.5 0 1 1 1.273-1.273l5.235 5.235a.9.9 0 1 1-1.273 1.272zM16.2 10.5a5.7 5.7 0 1 1-11.4 0 5.7 5.7 0 0 1 11.4 0",
    clipRule: "evenodd"
  })));
};

var _path$40;
function _extends$43() { return _extends$43 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$43.apply(null, arguments); }
var SvgSearch32 = function SvgSearch32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$43({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$40 || (_path$40 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M20.329 21.743A9.96 9.96 0 0 1 14 24C8.477 24 4 19.523 4 14S8.477 4 14 4s10 4.477 10 10a9.96 9.96 0 0 1-2.257 6.329l6.964 6.964a1 1 0 0 1-1.414 1.414zM22 14a8 8 0 1 1-16 0 8 8 0 0 1 16 0",
    clipRule: "evenodd"
  })));
};

var _circle, _path$3$;
function _extends$42() { return _extends$42 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$42.apply(null, arguments); }
var SvgSearch48 = function SvgSearch48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$42({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 13.8,
    stroke: "#2F3438",
    strokeWidth: 2.4
  })), _path$3$ || (_path$3$ = /*#__PURE__*/React.createElement("path", {
    stroke: "#2F3438",
    strokeLinecap: "round",
    strokeWidth: 2.4,
    d: "m31 31 11 11"
  })));
};

var SearchIcon = function SearchIcon(props) {
  var search = {
    12: SvgSearch12,
    16: SvgSearch16,
    18: SvgSearch18,
    24: SvgSearch24,
    32: SvgSearch32,
    48: SvgSearch48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: search
  }, props));
};

var _path$3_, _path2$1o;
function _extends$41() { return _extends$41 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$41.apply(null, arguments); }
var SvgSearchImage12 = function SvgSearchImage12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$41({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$3_ || (_path$3_ = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M2.6 3.5a.9.9 0 0 1 .9-.9h1a.6.6 0 0 0 0-1.2h-1a2.1 2.1 0 0 0-2.1 2.1v1a.6.6 0 0 0 1.2 0zM9.4 3.5a.9.9 0 0 0-.9-.9H7.55a.6.6 0 0 1 0-1.2H8.5c1.16 0 2.1.94 2.1 2.1v1a.6.6 0 1 1-1.2 0zM3.5 9.4a.9.9 0 0 1-.9-.9v-1a.6.6 0 0 0-1.2 0v1c0 1.16.94 2.1 2.1 2.1h1a.6.6 0 1 0 0-1.2zM9.4 8.5a.9.9 0 0 1-.9.9H8a.6.6 0 0 0 0 1.2h.5a2.1 2.1 0 0 0 2.1-2.1V8a.6.6 0 1 0-1.2 0z"
  })), _path2$1o || (_path2$1o = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M7.57 6.722a2.25 2.25 0 1 0-.876.82l.733.734a.6.6 0 1 0 .849-.849zM5.65 6.6a1.05 1.05 0 1 0 0-2.1 1.05 1.05 0 0 0 0 2.1",
    clipRule: "evenodd"
  })));
};

var _path$3Z, _path2$1n;
function _extends$40() { return _extends$40 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$40.apply(null, arguments); }
var SvgSearchImage16 = function SvgSearchImage16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$40({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$3Z || (_path$3Z = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M3.5 2.75a.75.75 0 0 0-.75.75v1.833a.75.75 0 1 1-1.5 0V3.5A2.25 2.25 0 0 1 3.5 1.25h1.833a.75.75 0 1 1 0 1.5zM12.432 2.75a.75.75 0 0 1 .75.75v1.833a.75.75 0 0 0 1.5 0V3.5a2.25 2.25 0 0 0-2.25-2.25h-1.765a.75.75 0 0 0 0 1.5zM3.5 13.25a.75.75 0 0 1-.75-.75v-1.833a.75.75 0 0 0-1.5 0V12.5a2.25 2.25 0 0 0 2.25 2.25h1.833a.75.75 0 0 0 0-1.5zM12.432 13.25a.75.75 0 0 0 .75-.75v-1.833a.75.75 0 0 1 1.5 0V12.5a2.25 2.25 0 0 1-2.25 2.25h-1.765a.75.75 0 0 1 0-1.5z",
    clipRule: "evenodd"
  })), _path2$1n || (_path2$1n = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M9.292 10.255a3.53 3.53 0 1 1 1.112-1.01l1.373 1.374a.75.75 0 1 1-1.06 1.06zm.267-3.059a2.03 2.03 0 1 1-4.059 0 2.03 2.03 0 0 1 4.059 0",
    clipRule: "evenodd"
  })));
};

var _path$3Y, _path2$1m;
function _extends$3$() { return _extends$3$ = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$3$.apply(null, arguments); }
var SvgSearchImage18 = function SvgSearchImage18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3$({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$3Y || (_path$3Y = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M4.25 3.05a1.2 1.2 0 0 0-1.2 1.2V6a.8.8 0 1 1-1.6 0V4.25a2.8 2.8 0 0 1 2.8-2.8H6a.8.8 0 1 1 0 1.6zM13.673 3.05a1.2 1.2 0 0 1 1.2 1.2V6a.8.8 0 0 0 1.6 0V4.25a2.8 2.8 0 0 0-2.8-2.8H12a.8.8 0 0 0 0 1.6zM4.25 14.95a1.2 1.2 0 0 1-1.2-1.2V12a.8.8 0 0 0-1.6 0v1.75a2.8 2.8 0 0 0 2.8 2.8H6a.8.8 0 0 0 0-1.6zM13.673 14.95a1.2 1.2 0 0 0 1.2-1.2V12a.8.8 0 0 1 1.6 0v1.75a2.8 2.8 0 0 1-2.8 2.8H12a.8.8 0 0 1 0-1.6z",
    clipRule: "evenodd"
  })), _path2$1m || (_path2$1m = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M10.493 11.514a3.97 3.97 0 1 1 1.186-1.077l1.74 1.74a.8.8 0 1 1-1.132 1.131zm.348-3.418a2.37 2.37 0 1 1-4.741 0 2.37 2.37 0 0 1 4.741 0",
    clipRule: "evenodd"
  })));
};

var _path$3X, _path2$1l;
function _extends$3_() { return _extends$3_ = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$3_.apply(null, arguments); }
var SvgSearchImage24 = function SvgSearchImage24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3_({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$3X || (_path$3X = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M6 3.9A2.1 2.1 0 0 0 3.9 6v2a.9.9 0 0 1-1.8 0V6A3.9 3.9 0 0 1 6 2.1h2a.9.9 0 0 1 0 1.8zM17.898 3.9c1.16 0 2.1.94 2.1 2.1v2a.9.9 0 1 0 1.8 0V6a3.9 3.9 0 0 0-3.9-3.9H16a.9.9 0 1 0 0 1.8zM6 20.1A2.1 2.1 0 0 1 3.9 18v-2a.9.9 0 1 0-1.8 0v2A3.9 3.9 0 0 0 6 21.9h2a.9.9 0 0 0 0-1.8zM17.898 20.1a2.1 2.1 0 0 0 2.1-2.1v-2a.9.9 0 1 1 1.8 0v2a3.9 3.9 0 0 1-3.9 3.9H16a.9.9 0 0 1 0-1.8z",
    clipRule: "evenodd"
  })), _path2$1l || (_path2$1l = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M14.788 10.794a3.494 3.494 0 1 1-6.988 0 3.494 3.494 0 0 1 6.988 0m-.652 4.468a5.294 5.294 0 1 1 1.333-1.212l2.638 2.637a.9.9 0 1 1-1.273 1.273z",
    clipRule: "evenodd"
  })));
};

var _path$3W, _path2$1k;
function _extends$3Z() { return _extends$3Z = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$3Z.apply(null, arguments); }
var SvgSearchImage32 = function SvgSearchImage32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3Z({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$3W || (_path$3W = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M5 8a3 3 0 0 1 3-3h2.667a1 1 0 1 0 0-2H8a5 5 0 0 0-5 5v2.667a1 1 0 1 0 2 0zM26.864 8a3 3 0 0 0-3-3h-2.53a1 1 0 1 1 0-2h2.53a5 5 0 0 1 5 5v2.667a1 1 0 0 1-2 0zM8 27a3 3 0 0 1-3-3v-2.667a1 1 0 1 0-2 0V24a5 5 0 0 0 5 5h2.667a1 1 0 1 0 0-2zM26.864 24a3 3 0 0 1-3 3h-2.53a1 1 0 1 0 0 2h2.53a5 5 0 0 0 5-5v-2.667a1 1 0 0 0-2 0z"
  })), _path2$1k || (_path2$1k = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M20.5 18.89a7.059 7.059 0 1 0-1.481 1.347l3.568 3.568A1 1 0 0 0 24 22.391zm-5.441.561a5.059 5.059 0 1 0 0-10.117 5.059 5.059 0 0 0 0 10.117",
    clipRule: "evenodd"
  })));
};

var _path$3V, _path2$1j;
function _extends$3Y() { return _extends$3Y = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$3Y.apply(null, arguments); }
var SvgSearchImage48 = function SvgSearchImage48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3Y({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$3V || (_path$3V = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M7.2 12A4.8 4.8 0 0 1 12 7.2h4a1.2 1.2 0 0 0 0-2.4h-4A7.2 7.2 0 0 0 4.8 12v4a1.2 1.2 0 0 0 2.4 0zM40.596 12a4.8 4.8 0 0 0-4.8-4.8H32a1.2 1.2 0 0 1 0-2.4h3.796a7.2 7.2 0 0 1 7.2 7.2v4a1.2 1.2 0 0 1-2.4 0zM12 40.8A4.8 4.8 0 0 1 7.2 36v-4a1.2 1.2 0 0 0-2.4 0v4a7.2 7.2 0 0 0 7.2 7.2h4a1.2 1.2 0 0 0 0-2.4zM40.596 36a4.8 4.8 0 0 1-4.8 4.8H32a1.2 1.2 0 0 0 0 2.4h3.796a7.2 7.2 0 0 0 7.2-7.2v-4a1.2 1.2 0 0 0-2.4 0z"
  })), _path2$1j || (_path2$1j = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M30.554 28.563a10.55 10.55 0 0 0 2.622-6.975c0-5.847-4.74-10.588-10.588-10.588S12 15.74 12 21.588s4.74 10.588 10.588 10.588c2.31 0 4.448-.74 6.19-1.996l5.315 5.316a1.2 1.2 0 1 0 1.697-1.697zm-7.966 1.213a8.188 8.188 0 1 0 0-16.376 8.188 8.188 0 0 0 0 16.377",
    clipRule: "evenodd"
  })));
};

var SearchImageIcon = function SearchImageIcon(props) {
  var searchImage = {
    12: SvgSearchImage12,
    16: SvgSearchImage16,
    18: SvgSearchImage18,
    24: SvgSearchImage24,
    32: SvgSearchImage32,
    48: SvgSearchImage48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: searchImage
  }, props));
};

var _g$2, _defs$2;
function _extends$3X() { return _extends$3X = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$3X.apply(null, arguments); }
var SvgSendFilled12 = function SvgSendFilled12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3X({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _g$2 || (_g$2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#sendFilled_12_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M2.325 1.003a.97.97 0 0 0-1.053.117l-.006.005a.98.98 0 0 0-.322.975l.004.017L2.002 5.6H6a.4.4 0 1 1 0 .8H2L.935 9.861l-.002.01A.976.976 0 0 0 1.9 11.1a1 1 0 0 0 .427-.106l8.238-4.125.005-.002a.974.974 0 0 0 0-1.736z",
    clipRule: "evenodd"
  }))), _defs$2 || (_defs$2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "sendFilled_12_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h12v12H0z"
  })))));
};

var _path$3U;
function _extends$3W() { return _extends$3W = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$3W.apply(null, arguments); }
var SvgSendFilled16 = function SvgSendFilled16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3W({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$3U || (_path$3U = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M3.06 1.417a1.21 1.21 0 0 0-1.308.145l-.007.006a1.21 1.21 0 0 0-.4 1.21l.006.02L2.803 7.6h5.42a.4.4 0 1 1 0 .8H2.8l-1.466 4.773-.003.011a1.212 1.212 0 0 0 1.2 1.527 1.2 1.2 0 0 0 .531-.132l10.985-5.5.006-.002a1.21 1.21 0 0 0 0-2.156z",
    clipRule: "evenodd"
  })));
};

var _path$3T;
function _extends$3V() { return _extends$3V = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$3V.apply(null, arguments); }
var SvgSendFilled18 = function SvgSendFilled18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3V({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$3T || (_path$3T = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M3.442 1.594a1.36 1.36 0 0 0-1.471.164l-.008.006a1.36 1.36 0 0 0-.45 1.362l.006.023L3.153 8.55H9.25a.45.45 0 1 1 0 .9h-6.1L1.5 14.82l-.003.013a1.363 1.363 0 0 0 1.35 1.716 1.36 1.36 0 0 0 .598-.147l12.358-6.187.006-.004a1.362 1.362 0 0 0 0-2.425z",
    clipRule: "evenodd"
  })));
};

var _path$3S;
function _extends$3U() { return _extends$3U = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$3U.apply(null, arguments); }
var SvgSendFilled24 = function SvgSendFilled24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3U({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$3S || (_path$3S = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M4.515 2.274a1.65 1.65 0 0 0-1.782.199l-.008.007a1.65 1.65 0 0 0-.544 1.65l.006.025L4.378 11.4H12.5a.6.6 0 1 1 0 1.2H4.374l-2.213 7.205-.004.015a1.65 1.65 0 0 0 1.636 2.08c.252-.004.5-.065.725-.18l16.478-8.25.007-.004a1.65 1.65 0 0 0 .655-2.328 1.65 1.65 0 0 0-.655-.608z",
    clipRule: "evenodd"
  })));
};

var _path$3R;
function _extends$3T() { return _extends$3T = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$3T.apply(null, arguments); }
var SvgSendFilled32 = function SvgSendFilled32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3T({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$3R || (_path$3R = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M5.93 3.211a2 2 0 0 0-2.16.24l-.009.009a2 2 0 0 0-.659 2l.007.027 2.953 9.763h10.855a.75.75 0 0 1 0 1.5H6.057l-2.984 9.712-.004.017a2.002 2.002 0 0 0 1.985 2.52 2 2 0 0 0 .88-.217l21.97-11 .01-.005a2 2 0 0 0 0-3.56z",
    clipRule: "evenodd"
  })));
};

var _path$3Q;
function _extends$3S() { return _extends$3S = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$3S.apply(null, arguments); }
var SvgSendFilled48 = function SvgSendFilled48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3S({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$3Q || (_path$3Q = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M7.256 4.817a2.7 2.7 0 0 1 1.505.268l32.972 16.508a2.7 2.7 0 0 1 0 4.806l-.01.005-32.957 16.5c-.37.19-.777.29-1.192.295a2.696 2.696 0 0 1-2.718-2.154 2.7 2.7 0 0 1 .037-1.248l.006-.02L9.345 25.3H25.5a1.3 1.3 0 1 0 0-2.6H9.353l-4.4-14.547-.008-.034a2.7 2.7 0 0 1 .89-2.7l.005-.005.006-.004c.403-.33.893-.536 1.41-.593"
  })));
};

var SendFilledIcon = function SendFilledIcon(props) {
  var sendFilled = {
    12: SvgSendFilled12,
    16: SvgSendFilled16,
    18: SvgSendFilled18,
    24: SvgSendFilled24,
    32: SvgSendFilled32,
    48: SvgSendFilled48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: sendFilled
  }, props));
};

var _g$1, _defs$1;
function _extends$3R() { return _extends$3R = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$3R.apply(null, arguments); }
var SvgSetting12 = function SvgSetting12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3R({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _g$1 || (_g$1 = /*#__PURE__*/React.createElement("g", {
    fill: "#2F3438",
    fillRule: "evenodd",
    clipPath: "url(#setting_12_svg__a)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4m.8-2a.8.8 0 1 1-1.6 0 .8.8 0 0 1 1.6 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.564 10.555-.138-.447-1.351-.748-.513.119c-.338.078-.699-.02-.915-.292a5.2 5.2 0 0 1-.684-1.12c-.151-.338-.05-.728.212-.99l.326-.329V5.253l-.326-.329c-.262-.262-.364-.651-.213-.99.18-.401.41-.777.684-1.12.217-.272.578-.37.917-.292l.512.118 1.351-.747.137-.446c.106-.343.386-.61.742-.654a5.7 5.7 0 0 1 1.392 0c.355.045.634.311.74.653l.137.447 1.351.747.512-.118c.339-.079.7.02.917.292.273.343.504.719.683 1.12.151.339.05.728-.212.99l-.326.329V6.75l.326.328c.262.263.364.652.212.99q-.272.604-.683 1.12c-.217.271-.578.37-.917.292l-.512-.119-1.351.748-.137.444c-.105.343-.386.61-.742.654a5.7 5.7 0 0 1-1.392 0c-.355-.043-.634-.31-.74-.652m4.183-2.467L6.57 9.293l-.229.744a4.4 4.4 0 0 1-.68 0l-.229-.745-2.178-1.205-.795.184a4 4 0 0 1-.298-.483l.541-.545V4.758l-.541-.545q.131-.252.298-.484l.795.184L5.43 2.708l.229-.745a4.5 4.5 0 0 1 .68 0l.23.745 2.177 1.205.795-.184q.165.233.298.485l-.541.544v2.487l.54.544q-.13.251-.297.483z"
  }))), _defs$1 || (_defs$1 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "setting_12_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h12v12H0z"
  })))));
};

var _path$3P, _path2$1i;
function _extends$3Q() { return _extends$3Q = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$3Q.apply(null, arguments); }
var SvgSetting16 = function SvgSetting16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3Q({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$3P || (_path$3P = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8 10.667a2.667 2.667 0 1 0 0-5.334 2.667 2.667 0 0 0 0 5.334M9.167 8a1.167 1.167 0 1 1-2.334 0 1.167 1.167 0 0 1 2.334 0",
    clipRule: "evenodd"
  })), _path2$1i || (_path2$1i = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "m1.425 9.578.577-.58V7.004l-.577-.58c-.262-.263-.362-.651-.22-.993a7 7 0 0 1 1.108-1.824.93.93 0 0 1 .923-.287l.864.2 1.802-.997.239-.779a.93.93 0 0 1 .74-.66 7.6 7.6 0 0 1 2.24 0 .93.93 0 0 1 .738.66l.24.78 1.801.996.864-.2a.92.92 0 0 1 .923.287c.46.547.835 1.16 1.109 1.823.14.343.04.731-.22.994l-.578.58V9l.577.58c.262.262.362.65.22.993a7 7 0 0 1-1.108 1.821.93.93 0 0 1-.923.288l-.864-.2-1.802.996-.239.778a.93.93 0 0 1-.74.66 7.6 7.6 0 0 1-2.24.001.93.93 0 0 1-.737-.66l-.24-.78L4.1 12.48l-.865.2a.92.92 0 0 1-.921-.287 7 7 0 0 1-1.11-1.822c-.14-.342-.04-.73.22-.993m10.253 1.312-2.835 1.569-.313 1.018a6 6 0 0 1-1.059 0l-.313-1.02-2.836-1.569-1.087.252a5.4 5.4 0 0 1-.477-.776l.744-.747V6.385l-.744-.748q.205-.407.477-.777l1.087.252 2.836-1.57.313-1.019a6 6 0 0 1 1.058 0l.314 1.02 2.835 1.569 1.086-.252q.272.37.478.777l-.744.748v3.233l.744.748q-.206.406-.477.776z",
    clipRule: "evenodd"
  })));
};

var _path$3O, _path2$1h;
function _extends$3P() { return _extends$3P = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$3P.apply(null, arguments); }
var SvgSetting18 = function SvgSetting18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3P({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$3O || (_path$3O = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M9 12a3 3 0 1 0 0-6 3 3 0 0 0 0 6m1.4-3a1.4 1.4 0 1 1-2.8 0 1.4 1.4 0 0 1 2.8 0",
    clipRule: "evenodd"
  })), _path2$1h || (_path2$1h = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "m1.55 10.828.702-.705V7.879l-.703-.706a.93.93 0 0 1-.223-.994 7.8 7.8 0 0 1 1.322-2.174.93.93 0 0 1 .924-.286l1.04.241L6.64 2.84l.29-.946a.94.94 0 0 1 .741-.663 8.6 8.6 0 0 1 2.662 0c.353.057.632.32.738.663l.29.946 2.027 1.121 1.04-.24a.93.93 0 0 1 .925.285 7.8 7.8 0 0 1 1.321 2.174.93.93 0 0 1-.223.994l-.702.706v2.246l.702.705c.262.263.361.651.223.995a7.8 7.8 0 0 1-1.321 2.172.93.93 0 0 1-.924.286l-1.04-.242-2.027 1.122-.29.944a.94.94 0 0 1-.741.663 8.6 8.6 0 0 1-2.662.001.94.94 0 0 1-.738-.662l-.29-.948-2.028-1.121-1.04.24a.93.93 0 0 1-.924-.284 7.8 7.8 0 0 1-1.321-2.173.93.93 0 0 1 .223-.995m11.6 1.516-3.129 1.732-.359 1.167a7 7 0 0 1-1.324 0l-.359-1.17-3.13-1.73-1.246.288a6 6 0 0 1-.607-.988l.856-.86V7.219l-.856-.86q.256-.523.608-.99l1.246.289 3.129-1.732.36-1.17a7 7 0 0 1 1.323.001l.36 1.17 3.128 1.73 1.246-.288q.35.468.607.99l-.855.86v3.566l.855.86a6 6 0 0 1-.607.988z",
    clipRule: "evenodd"
  })));
};

var _path$3N, _path2$1g;
function _extends$3O() { return _extends$3O = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$3O.apply(null, arguments); }
var SvgSetting24 = function SvgSetting24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3O({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$3N || (_path$3N = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M12 14.2a2.2 2.2 0 1 0 0-4.4 2.2 2.2 0 0 0 0 4.4m4-2.2a4 4 0 1 1-8 0 4 4 0 0 1 8 0",
    clipRule: "evenodd"
  })), _path2$1g || (_path2$1g = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "m13.64 18.994 3.943-2.182 1.746.405a8.6 8.6 0 0 0 1.077-1.76l-1.208-1.215V9.763l1.208-1.215a8.6 8.6 0 0 0-1.078-1.762l-1.745.404-3.942-2.182-.505-1.64a9.5 9.5 0 0 0-2.272 0l-.504 1.64L6.417 7.19l-1.745-.404a8.6 8.6 0 0 0-1.078 1.762l1.208 1.215v4.476l-1.208 1.215a8.6 8.6 0 0 0 1.077 1.76l1.746-.404 3.943 2.182.504 1.64a9.6 9.6 0 0 0 2.273 0zm4.21-.272-2.702 1.495-.444 1.444a.95.95 0 0 1-.74.668 11.5 11.5 0 0 1-3.93 0 .95.95 0 0 1-.737-.666l-.445-1.448-2.702-1.496-1.57.364a.95.95 0 0 1-.927-.281 10.4 10.4 0 0 1-1.957-3.225.94.94 0 0 1 .229-.997l1.077-1.083v-2.991L1.925 9.422a.94.94 0 0 1-.23-.996 10.4 10.4 0 0 1 1.958-3.227c.231-.26.59-.36.928-.282l1.569.364 2.702-1.496.445-1.446a.95.95 0 0 1 .74-.668 11.335 11.335 0 0 1 3.93.002.95.95 0 0 1 .736.666l.445 1.446 2.702 1.496 1.57-.364a.95.95 0 0 1 .927.282c.84.947 1.507 2.037 1.957 3.227a.94.94 0 0 1-.229.996l-1.077 1.084v2.993l1.077 1.084c.262.263.36.65.229.996a10.4 10.4 0 0 1-1.957 3.224.95.95 0 0 1-.928.283z",
    clipRule: "evenodd"
  })));
};

var _path$3M, _path2$1f;
function _extends$3N() { return _extends$3N = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$3N.apply(null, arguments); }
var SvgSetting32 = function SvgSetting32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3N({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$3M || (_path$3M = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M16 19.533a3.533 3.533 0 1 0 0-7.066 3.533 3.533 0 0 0 0 7.066M21.333 16a5.333 5.333 0 1 1-10.666 0 5.333 5.333 0 0 1 10.666 0",
    clipRule: "evenodd"
  })), _path2$1f || (_path2$1f = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "m18.69 25.733 4.843-2.68 2.467.572a12 12 0 0 0 1.92-3.15l-1.723-1.733v-5.477l1.724-1.733A12 12 0 0 0 26 8.379l-2.467.571-4.843-2.68-.714-2.322a13.3 13.3 0 0 0-3.952 0L13.31 6.27 8.467 8.95 6 8.38a12 12 0 0 0-1.921 3.152l1.724 1.734v5.473l-1.724 1.734A12 12 0 0 0 6 23.622l2.468-.572 4.843 2.68.714 2.324a13.4 13.4 0 0 0 3.952-.001zm5.11-.77-3.603 1.994-.65 2.11a.96.96 0 0 1-.738.67 15.192 15.192 0 0 1-5.62 0 .96.96 0 0 1-.736-.669l-.65-2.115L8.2 24.96l-2.275.527a.96.96 0 0 1-.93-.279 13.8 13.8 0 0 1-2.803-4.626.96.96 0 0 1 .233-.998l1.578-1.587v-3.988L2.424 12.42a.96.96 0 0 1-.233-.997c.62-1.721 1.581-3.287 2.805-4.63a.96.96 0 0 1 .93-.28l2.274.528 3.603-1.994.65-2.113a.96.96 0 0 1 .738-.672 15.131 15.131 0 0 1 5.62.002c.352.067.631.33.736.671l.65 2.112L23.8 7.04l2.274-.527a.96.96 0 0 1 .93.28 13.9 13.9 0 0 1 2.804 4.629.96.96 0 0 1-.233.998l-1.578 1.587v3.991l1.578 1.587c.262.263.359.65.233.998a13.9 13.9 0 0 1-2.804 4.626.96.96 0 0 1-.93.28z",
    clipRule: "evenodd"
  })));
};

var _path$3L, _path2$1e;
function _extends$3M() { return _extends$3M = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$3M.apply(null, arguments); }
var SvgSetting48 = function SvgSetting48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3M({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$3L || (_path$3L = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M24 32a8 8 0 1 0 0-16 8 8 0 0 0 0 16m5.6-8a5.6 5.6 0 1 1-11.2 0 5.6 5.6 0 0 1 11.2 0",
    clipRule: "evenodd"
  })), _path2$1e || (_path2$1e = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "m30.295 40.435 5.405-2.991 3.684.854a.97.97 0 0 0 .933-.278 20.8 20.8 0 0 0 4.496-7.428.97.97 0 0 0-.238-1L41.995 27v-5.987l2.58-2.595a.97.97 0 0 0 .237-1 20.8 20.8 0 0 0-4.495-7.432.97.97 0 0 0-.933-.278l-3.684.854-5.405-2.99-1.06-3.445a.98.98 0 0 0-.734-.674 22.7 22.7 0 0 0-9-.004.98.98 0 0 0-.737.675l-1.06 3.447-5.404 2.991-3.683-.854a.97.97 0 0 0-.933.278 20.8 20.8 0 0 0-4.497 7.433.97.97 0 0 0 .238 1l2.58 2.594v5.982l-2.58 2.594a.97.97 0 0 0-.237 1 20.8 20.8 0 0 0 4.496 7.428.97.97 0 0 0 .932.277l3.684-.854 5.405 2.99 1.06 3.45a.98.98 0 0 0 .735.674 22.8 22.8 0 0 0 8.999-.001.98.98 0 0 0 .738-.675zm5.05-5.537-7.059 3.906-1.09 3.543a20.5 20.5 0 0 1-6.39.002l-1.091-3.55-7.06-3.906-3.766.873a18.4 18.4 0 0 1-3.123-5.13l2.639-2.652V20.02l-2.64-2.653a18.4 18.4 0 0 1 3.125-5.134l3.766.873 7.059-3.906 1.09-3.548a20.242 20.242 0 0 1 6.39.002L28.286 9.2l7.058 3.906 3.766-.873a18.4 18.4 0 0 1 3.124 5.134l-2.639 2.653v7.968l2.639 2.653a18.4 18.4 0 0 1-3.124 5.129z",
    clipRule: "evenodd"
  })));
};

var SettingIcon = function SettingIcon(props) {
  var setting = {
    12: SvgSetting12,
    16: SvgSetting16,
    18: SvgSetting18,
    24: SvgSetting24,
    32: SvgSetting32,
    48: SvgSetting48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: setting
  }, props));
};

var _path$3K;
function _extends$3L() { return _extends$3L = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$3L.apply(null, arguments); }
var SvgShare12 = function SvgShare12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3L({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$3K || (_path$3K = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8.257 4.566a2.143 2.143 0 1 0-1.984-1.333L4.18 4.374a2.143 2.143 0 1 0-.177 2.95l-.082.15 2.35 1.281a2.143 2.143 0 1 0 .763-.95L4.569 6.457a2.14 2.14 0 0 0 .1-.983l2.368-1.291c.346.24.767.381 1.221.381m0-1.2a.943.943 0 1 0 0-1.886.943.943 0 0 0 0 1.886M2.543 6.699a.943.943 0 1 0 0-1.886.943.943 0 0 0 0 1.886M9.2 9.565a.943.943 0 1 1-1.886 0 .943.943 0 0 1 1.886 0",
    clipRule: "evenodd"
  })));
};

var _path$3J;
function _extends$3K() { return _extends$3K = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$3K.apply(null, arguments); }
var SvgShare16 = function SvgShare16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3K({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$3J || (_path$3J = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M10.976 6.38A2.857 2.857 0 1 0 8.37 4.697L5.605 6.204a2.857 2.857 0 1 0-.3 3.853l-.06.113 3.125 1.705a2.857 2.857 0 1 0 .888-1.11L6.022 9a2.85 2.85 0 0 0 .152-1.511l3.084-1.682c.478.36 1.073.574 1.718.574m0-1.4a1.457 1.457 0 1 0 0-2.914 1.457 1.457 0 0 0 0 2.915M3.357 9.426a1.457 1.457 0 1 0 0-2.914 1.457 1.457 0 0 0 0 2.914m9.076 3.622a1.457 1.457 0 1 1-2.914 0 1.457 1.457 0 0 1 2.914 0",
    clipRule: "evenodd"
  })));
};

var _path$3I;
function _extends$3J() { return _extends$3J = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$3J.apply(null, arguments); }
var SvgShare18 = function SvgShare18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3J({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$3I || (_path$3I = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M12.586 6.828a3.214 3.214 0 1 0-2.917-1.86L6.566 6.66a3.214 3.214 0 1 0-.36 4.305l-.05.093 3.513 1.917a3.214 3.214 0 1 0 .95-1.19L7 9.81a3.2 3.2 0 0 0 .177-1.774l3.444-1.878a3.2 3.2 0 0 0 1.966.67m0-1.5a1.714 1.714 0 1 0 0-3.428 1.714 1.714 0 0 0 0 3.428m-8.572 5a1.714 1.714 0 1 0 0-3.428 1.714 1.714 0 0 0 0 3.428m10.286 4a1.714 1.714 0 1 1-3.429 0 1.714 1.714 0 0 1 3.429 0",
    clipRule: "evenodd"
  })));
};

var _path$3H;
function _extends$3I() { return _extends$3I = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$3I.apply(null, arguments); }
var SvgShare24 = function SvgShare24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3I({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$3H || (_path$3H = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M16.714 9.071a4.286 4.286 0 1 0-3.845-2.39L8.75 8.927a4.286 4.286 0 1 0-.54 5.659l-.02.037 4.68 2.553a4.286 4.286 0 1 0 1.14-1.429l-4.782-2.609a4.27 4.27 0 0 0 .255-2.56l4.526-2.47c.738.602 1.68.962 2.706.962m0-1.8a2.486 2.486 0 1 0 0-4.971 2.486 2.486 0 0 0 0 4.971M5.286 13.938a2.486 2.486 0 1 0 0-4.972 2.486 2.486 0 0 0 0 4.972M19.2 19.07a2.486 2.486 0 1 1-4.971 0 2.486 2.486 0 0 1 4.971 0",
    clipRule: "evenodd"
  })));
};

var _path$3G;
function _extends$3H() { return _extends$3H = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$3H.apply(null, arguments); }
var SvgShare32 = function SvgShare32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3H({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$3G || (_path$3G = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M28.267 6.514a5.714 5.714 0 0 1-9.486 4.293l-5.917 3.228a5.73 5.73 0 0 1-.377 3.8l6.294 3.434a5.714 5.714 0 1 1-1.264 1.589l-6.196-3.38a5.714 5.714 0 1 1 .728-7.276l5.468-2.984a5.714 5.714 0 1 1 10.75-2.704M7.314 19.117a3.714 3.714 0 1 0 0-7.429 3.714 3.714 0 0 0 0 7.43m15.238-8.889a3.714 3.714 0 1 0 0-7.428 3.714 3.714 0 0 0 0 7.428m0 19.048a3.714 3.714 0 1 0 0-7.429 3.714 3.714 0 0 0 0 7.429",
    clipRule: "evenodd"
  })));
};

var _path$3F;
function _extends$3G() { return _extends$3G = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$3G.apply(null, arguments); }
var SvgShare48 = function SvgShare48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3G({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$3F || (_path$3F = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M42 9.672a8.571 8.571 0 0 1-14.463 6.225l-8.72 4.757c.212.747.326 1.535.326 2.35a8.5 8.5 0 0 1-.946 3.919l9.34 5.094a8.571 8.571 0 1 1-1.514 1.908l-9.224-5.031a8.571 8.571 0 1 1 1.038-10.44l8.186-4.465A8.571 8.571 0 1 1 42 9.672M10.571 29.176a6.171 6.171 0 1 0 0-12.343 6.171 6.171 0 0 0 0 12.343M33.43 15.843a6.171 6.171 0 1 0 0-12.343 6.171 6.171 0 0 0 0 12.343m0 28.571a6.171 6.171 0 1 0 0-12.342 6.171 6.171 0 0 0 0 12.342",
    clipRule: "evenodd"
  })));
};

var ShareIcon = function ShareIcon(props) {
  var share = {
    12: SvgShare12,
    16: SvgShare16,
    18: SvgShare18,
    24: SvgShare24,
    32: SvgShare32,
    48: SvgShare48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: share
  }, props));
};

var _path$3E;
function _extends$3F() { return _extends$3F = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$3F.apply(null, arguments); }
var SvgShield12 = function SvgShield12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3F({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$3E || (_path$3E = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M10.5 6V2.985a.505.505 0 0 0-.485-.5c-1.843-.1-3.052-.767-3.626-1.172a.69.69 0 0 0-.778 0c-.574.405-1.783 1.072-3.626 1.172a.505.505 0 0 0-.485.5V6s0 3.251 4.029 4.83c.302.118.64.118.942 0C10.5 9.25 10.5 6 10.5 6m-7.8-.012.003.053c.005.054.016.146.039.267.046.24.14.59.336.98.377.756 1.164 1.749 2.888 2.424.021.008.047.008.068 0 1.724-.675 2.511-1.668 2.888-2.424.195-.39.29-.74.336-.98a3 3 0 0 0 .042-.32V3.626C7.789 3.439 6.687 2.923 6 2.494c-.687.429-1.789.945-3.3 1.132z",
    clipRule: "evenodd"
  })));
};

var _path$3D;
function _extends$3E() { return _extends$3E = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$3E.apply(null, arguments); }
var SvgShield16 = function SvgShield16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3E({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$3D || (_path$3D = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M14 8V3.98a.674.674 0 0 0-.647-.667C10.897 3.18 9.284 2.291 8.52 1.751a.925.925 0 0 0-1.038 0c-.765.54-2.378 1.43-4.834 1.562A.674.674 0 0 0 2 3.98V8s0 4.335 5.371 6.44c.403.157.855.157 1.258 0C14 12.334 14 8 14 8M3.714 7.982l.005.062c.005.07.019.188.049.344.06.314.184.768.438 1.278.49.984 1.519 2.287 3.79 3.177h.007c2.272-.89 3.3-2.193 3.791-3.177.255-.51.378-.964.438-1.278a3 3 0 0 0 .054-.406V4.935C10.346 4.679 8.916 4.02 8 3.46c-.915.561-2.346 1.219-4.286 1.475z",
    clipRule: "evenodd"
  })));
};

var _path$3C;
function _extends$3D() { return _extends$3D = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$3D.apply(null, arguments); }
var SvgShield18 = function SvgShield18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3D({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$3C || (_path$3C = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M15.75 9V4.478a.76.76 0 0 0-.727-.75c-2.764-.15-4.578-1.15-5.44-1.759a1.04 1.04 0 0 0-1.167 0c-.861.609-2.675 1.609-5.438 1.759a.76.76 0 0 0-.728.75V9s0 4.877 6.043 7.244c.453.178.96.178 1.414 0C15.75 13.877 15.75 9 15.75 9m-11.9-.014v.004l.006.088c.008.088.024.233.06.42.072.378.22.918.521 1.522.587 1.178 1.804 2.702 4.44 3.735.078.03.168.03.246 0 2.636-1.033 3.853-2.557 4.44-3.735.301-.604.449-1.144.521-1.521a4 4 0 0 0 .066-.509V5.261C11.745 4.995 10.025 4.163 9 3.505c-1.025.658-2.745 1.49-5.15 1.756z",
    clipRule: "evenodd"
  })));
};

var _path$3B;
function _extends$3C() { return _extends$3C = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$3C.apply(null, arguments); }
var SvgShield24 = function SvgShield24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3C({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$3B || (_path$3B = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M21 12V5.97c0-.54-.43-.97-.97-1-3.685-.2-6.103-1.533-7.252-2.344a1.39 1.39 0 0 0-1.556 0c-1.149.81-3.567 2.144-7.252 2.344-.54.03-.97.46-.97 1V12s0 6.502 8.057 9.659a2.6 2.6 0 0 0 1.886 0C21 18.502 21 12 21 12m-16.2-.014v.015q.001.035.01.131c.01.128.034.333.084.595.1.527.306 1.277.724 2.115.818 1.64 2.502 3.733 6.096 5.14.182.072.39.072.572 0 3.594-1.407 5.278-3.5 6.096-5.14a8.3 8.3 0 0 0 .724-2.115 6 6 0 0 0 .093-.726l.001-.015V6.713c-3.452-.325-5.857-1.543-7.2-2.438-1.343.895-3.748 2.113-7.2 2.438z",
    clipRule: "evenodd"
  })));
};

var _path$3A;
function _extends$3B() { return _extends$3B = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$3B.apply(null, arguments); }
var SvgShield32 = function SvgShield32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3B({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$3A || (_path$3A = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M28 16V7.96c0-.72-.573-1.293-1.293-1.333-4.914-.267-8.138-2.045-9.67-3.126a1.85 1.85 0 0 0-2.075 0c-1.53 1.081-4.755 2.86-9.669 3.126C4.573 6.667 4 7.24 4 7.96V16s0 8.67 10.743 12.878a3.46 3.46 0 0 0 2.514 0C28 24.67 28 16 28 16m-22-.012.001.03q.001.053.013.192c.015.184.049.47.118.835a11.4 11.4 0 0 0 1 2.923c1.133 2.272 3.452 5.133 8.34 7.048.337.132.719.132 1.055 0 4.889-1.915 7.208-4.776 8.34-7.047.576-1.156.86-2.192 1-2.924A8 8 0 0 0 26 16.017v-.026l.001-.003V8.584c-4.922-.388-8.262-2.166-10-3.368-1.738 1.202-5.078 2.98-10 3.368z",
    clipRule: "evenodd"
  })));
};

var _path$3z;
function _extends$3A() { return _extends$3A = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$3A.apply(null, arguments); }
var SvgShield48 = function SvgShield48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3A({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$3z || (_path$3z = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M42 24V11.94c0-1.08-.86-1.94-1.94-2-7.37-.4-12.207-3.067-14.503-4.688-.902-.637-2.211-.637-3.114 0C20.147 6.873 15.31 9.54 7.94 9.94c-1.08.06-1.94.92-1.94 2V24s0 13.004 16.115 19.318a5.18 5.18 0 0 0 3.77 0C42 37.004 42 24 42 24m-33.6-.011.002.061q.003.096.02.316c.026.294.078.744.187 1.314.218 1.142.66 2.75 1.553 4.54 1.762 3.534 5.35 7.934 12.828 10.863a2.78 2.78 0 0 0 2.02 0c7.478-2.93 11.066-7.329 12.828-10.862a17.7 17.7 0 0 0 1.553-4.54c.109-.57.161-1.02.186-1.315a7 7 0 0 0 .023-.376V12.317c-7.729-.49-12.88-3.307-15.427-5.105A.33.33 0 0 0 24 7.174a.33.33 0 0 0-.173.038C21.281 9.01 16.13 11.828 8.4 12.317z",
    clipRule: "evenodd"
  })));
};

var ShieldIcon = function ShieldIcon(props) {
  var shield = {
    12: SvgShield12,
    16: SvgShield16,
    18: SvgShield18,
    24: SvgShield24,
    32: SvgShield32,
    48: SvgShield48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: shield
  }, props));
};

var _path$3y;
function _extends$3z() { return _extends$3z = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$3z.apply(null, arguments); }
var SvgShieldFilled12 = function SvgShieldFilled12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3z({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$3y || (_path$3y = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M1.5 6V2.985c0-.27.215-.485.485-.5 1.843-.1 3.052-.767 3.626-1.172a.69.69 0 0 1 .778 0c.574.405 1.783 1.072 3.626 1.172.27.015.485.23.485.5V6s0 3.251-4.029 4.83c-.302.118-.64.118-.942 0C1.5 9.25 1.5 6 1.5 6"
  })));
};

var _path$3x;
function _extends$3y() { return _extends$3y = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$3y.apply(null, arguments); }
var SvgShieldFilled16 = function SvgShieldFilled16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3y({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$3x || (_path$3x = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M2 8V3.98c0-.36.287-.647.647-.667C5.103 3.18 6.716 2.291 7.48 1.751a.925.925 0 0 1 1.038 0c.765.54 2.378 1.43 4.834 1.562.36.02.647.307.647.667V8s0 4.335-5.371 6.44a1.73 1.73 0 0 1-1.258 0C2 12.334 2 8 2 8"
  })));
};

var _path$3w;
function _extends$3x() { return _extends$3x = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$3x.apply(null, arguments); }
var SvgShieldFilled18 = function SvgShieldFilled18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3x({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$3w || (_path$3w = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M2.25 9V4.477c0-.405.322-.727.728-.75 2.763-.15 4.577-1.15 5.438-1.758a1.04 1.04 0 0 1 1.168 0c.861.608 2.675 1.609 5.439 1.758a.76.76 0 0 1 .727.75V9s0 4.877-6.043 7.244c-.453.178-.96.178-1.414 0C2.25 13.877 2.25 9 2.25 9"
  })));
};

var _path$3v;
function _extends$3w() { return _extends$3w = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$3w.apply(null, arguments); }
var SvgShieldFilled24 = function SvgShieldFilled24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3w({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$3v || (_path$3v = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M3 12V5.97c0-.54.43-.97.97-1 3.685-.2 6.103-1.533 7.252-2.344a1.39 1.39 0 0 1 1.556 0c1.149.81 3.567 2.144 7.252 2.344.54.03.97.46.97 1V12s0 6.502-8.057 9.659a2.6 2.6 0 0 1-1.886 0C3 18.502 3 12 3 12"
  })));
};

var _path$3u;
function _extends$3v() { return _extends$3v = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$3v.apply(null, arguments); }
var SvgShieldFilled32 = function SvgShieldFilled32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3v({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$3u || (_path$3u = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M4 16V7.96c0-.72.573-1.293 1.293-1.333 4.914-.267 8.138-2.045 9.67-3.126a1.85 1.85 0 0 1 2.075 0c1.53 1.081 4.755 2.86 9.669 3.126.72.04 1.293.613 1.293 1.333V16s0 8.67-10.743 12.878a3.46 3.46 0 0 1-2.514 0C4 24.67 4 16 4 16"
  })));
};

var _path$3t;
function _extends$3u() { return _extends$3u = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$3u.apply(null, arguments); }
var SvgShieldFilled48 = function SvgShieldFilled48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3u({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$3t || (_path$3t = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M6 24V11.94c0-1.08.86-1.94 1.94-2 7.37-.4 12.207-3.067 14.503-4.688.902-.637 2.211-.637 3.114 0C27.853 6.873 32.69 9.54 40.06 9.94c1.08.06 1.94.92 1.94 2V24s0 13.004-16.114 19.318a5.18 5.18 0 0 1-3.771 0C6 37.004 6 24 6 24"
  })));
};

var ShieldFilledIcon = function ShieldFilledIcon(props) {
  var shieldFilled = {
    12: SvgShieldFilled12,
    16: SvgShieldFilled16,
    18: SvgShieldFilled18,
    24: SvgShieldFilled24,
    32: SvgShieldFilled32,
    48: SvgShieldFilled48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: shieldFilled
  }, props));
};

var _path$3s;
function _extends$3t() { return _extends$3t = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$3t.apply(null, arguments); }
var SvgSignOut12 = function SvgSignOut12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3t({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$3s || (_path$3s = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M.9 3.25c0-1.16.94-2.1 2.1-2.1h3.5c1.16 0 2.1.94 2.1 2.1v.153a.6.6 0 0 1-1.2 0V3.25a.9.9 0 0 0-.9-.9H3a.9.9 0 0 0-.9.9v5.5a.9.9 0 0 0 .9.9h3.5a.9.9 0 0 0 .9-.9v-.153a.6.6 0 0 1 1.2 0v.153a2.1 2.1 0 0 1-2.1 2.1H3a2.1 2.1 0 0 1-2.1-2.1zm8.176.826a.6.6 0 0 1 .848 0l1.5 1.5a.6.6 0 0 1 0 .848l-1.5 1.5a.6.6 0 0 1-.848-.848L9.55 6.6H5.5a.6.6 0 1 1 0-1.2H9.55l-.475-.476a.6.6 0 0 1 0-.848",
    clipRule: "evenodd"
  })));
};

var _path$3r;
function _extends$3s() { return _extends$3s = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$3s.apply(null, arguments); }
var SvgSignOut16 = function SvgSignOut16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3s({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$3r || (_path$3r = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M1.25 4.333A2.75 2.75 0 0 1 4 1.583h4.667a2.75 2.75 0 0 1 2.75 2.75v.204a.75.75 0 0 1-1.5 0v-.204c0-.69-.56-1.25-1.25-1.25H4c-.69 0-1.25.56-1.25 1.25v7.334c0 .69.56 1.25 1.25 1.25h4.667c.69 0 1.25-.56 1.25-1.25v-.204a.75.75 0 0 1 1.5 0v.204a2.75 2.75 0 0 1-2.75 2.75H4a2.75 2.75 0 0 1-2.75-2.75zM12.136 5.47a.75.75 0 0 1 1.061 0l2 2a.75.75 0 0 1 0 1.06l-2 2a.75.75 0 0 1-1.06-1.06l.719-.72H7.333a.75.75 0 0 1 0-1.5h5.523l-.72-.72a.75.75 0 0 1 0-1.06",
    clipRule: "evenodd"
  })));
};

var _path$3q;
function _extends$3r() { return _extends$3r = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$3r.apply(null, arguments); }
var SvgSignOut18 = function SvgSignOut18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3r({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$3q || (_path$3q = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M1.45 4.875a3.05 3.05 0 0 1 3.05-3.05h5.25a3.05 3.05 0 0 1 3.05 3.05v.23a.8.8 0 1 1-1.6 0v-.23c0-.8-.65-1.45-1.45-1.45H4.5c-.8 0-1.45.65-1.45 1.45v8.25c0 .8.65 1.45 1.45 1.45h5.25c.8 0 1.45-.65 1.45-1.45v-.23a.8.8 0 0 1 1.6 0v.23a3.05 3.05 0 0 1-3.05 3.05H4.5a3.05 3.05 0 0 1-3.05-3.05zm12.234 1.31a.8.8 0 0 1 1.132 0l2.25 2.25a.8.8 0 0 1 0 1.13l-2.25 2.25a.8.8 0 1 1-1.132-1.13l.885-.885h-6.32a.8.8 0 1 1 0-1.6h6.32l-.885-.884a.8.8 0 0 1 0-1.132",
    clipRule: "evenodd"
  })));
};

var _path$3p;
function _extends$3q() { return _extends$3q = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$3q.apply(null, arguments); }
var SvgSignOut24 = function SvgSignOut24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3q({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$3p || (_path$3p = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M2.1 6.5A3.9 3.9 0 0 1 6 2.6h7a3.9 3.9 0 0 1 3.9 3.9v.306a.9.9 0 1 1-1.8 0V6.5A2.1 2.1 0 0 0 13 4.4H6a2.1 2.1 0 0 0-2.1 2.1v11c0 1.16.94 2.1 2.1 2.1h7a2.1 2.1 0 0 0 2.1-2.1v-.306a.9.9 0 0 1 1.8 0v.306a3.9 3.9 0 0 1-3.9 3.9H6a3.9 3.9 0 0 1-3.9-3.9zm16.264 1.864a.9.9 0 0 1 1.273 0l3 3a.9.9 0 0 1 0 1.272l-3 3a.9.9 0 0 1-1.273-1.272l1.463-1.464H11a.9.9 0 0 1 0-1.8h8.827l-1.463-1.464a.9.9 0 0 1 0-1.272",
    clipRule: "evenodd"
  })));
};

var _path$3o;
function _extends$3p() { return _extends$3p = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$3p.apply(null, arguments); }
var SvgSignOut32 = function SvgSignOut32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3p({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$3o || (_path$3o = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M3 8.667a5 5 0 0 1 5-5h9.333a5 5 0 0 1 5 5v.407a1 1 0 1 1-2 0v-.407a3 3 0 0 0-3-3H8a3 3 0 0 0-3 3v14.666a3 3 0 0 0 3 3h9.333a3 3 0 0 0 3-3v-.407a1 1 0 1 1 2 0v.407a5 5 0 0 1-5 5H8a5 5 0 0 1-5-5zm21.626 2.626a1 1 0 0 1 1.414 0l4 4a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414-1.414L26.92 17H14.667a1 1 0 0 1 0-2h12.252l-2.293-2.293a1 1 0 0 1 0-1.414",
    clipRule: "evenodd"
  })));
};

var _path$3n;
function _extends$3o() { return _extends$3o = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$3o.apply(null, arguments); }
var SvgSignOut48 = function SvgSignOut48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3o({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$3n || (_path$3n = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M4.8 13A7.2 7.2 0 0 1 12 5.8h14a7.2 7.2 0 0 1 7.2 7.2v.611a1.2 1.2 0 1 1-2.4 0v-.61A4.8 4.8 0 0 0 26 8.2H12A4.8 4.8 0 0 0 7.2 13v22a4.8 4.8 0 0 0 4.8 4.8h14a4.8 4.8 0 0 0 4.8-4.8v-.611a1.2 1.2 0 0 1 2.4 0V35a7.2 7.2 0 0 1-7.2 7.2H12A7.2 7.2 0 0 1 4.8 35zm32.352 4.151a1.2 1.2 0 0 1 1.697 0l6 6a1.2 1.2 0 0 1 0 1.698l-6 6a1.2 1.2 0 0 1-1.697-1.698l3.951-3.95H22a1.2 1.2 0 0 1 0-2.401h19.103l-3.952-3.951a1.2 1.2 0 0 1 0-1.698",
    clipRule: "evenodd"
  })));
};

var SignOutIcon = function SignOutIcon(props) {
  var signOut = {
    12: SvgSignOut12,
    16: SvgSignOut16,
    18: SvgSignOut18,
    24: SvgSignOut24,
    32: SvgSignOut32,
    48: SvgSignOut48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: signOut
  }, props));
};

var _path$3m, _path2$1d;
function _extends$3n() { return _extends$3n = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$3n.apply(null, arguments); }
var SvgSigned12 = function SvgSigned12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3n({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$3m || (_path$3m = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M6.68 8.84a1.2 1.2 0 0 1 .85-.351h.959v-.96a1.2 1.2 0 0 1 .351-.848l.679-.679-.679-.678a1.2 1.2 0 0 1-.351-.849v-.96h-.96a1.2 1.2 0 0 1-.848-.35l-.679-.68-.678.68a1.2 1.2 0 0 1-.849.35h-.96v.96a1.2 1.2 0 0 1-.35.849l-.68.678.68.679a1.2 1.2 0 0 1 .35.848v.96h.96a1.2 1.2 0 0 1 .849.351l.678.679zM1.497 6.71l.82.82v1.159a1 1 0 0 0 1 1h1.16l.82.82a1 1 0 0 0 1.413 0l.82-.82h1.16a1 1 0 0 0 1-1v-1.16l.82-.82a1 1 0 0 0 0-1.414l-.82-.82v-1.16a1 1 0 0 0-1-1h-1.16l-.82-.82a1 1 0 0 0-1.414 0l-.82.82h-1.16a1 1 0 0 0-1 1v1.16l-.82.82a1 1 0 0 0 0 1.414",
    clipRule: "evenodd"
  })), _path2$1d || (_path2$1d = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M7.822 4.574a.6.6 0 0 1 .004.848l-1.98 2a.6.6 0 0 1-.869-.016l-.919-1a.6.6 0 0 1 .884-.812l.493.537 1.539-1.553a.6.6 0 0 1 .848-.004",
    clipRule: "evenodd"
  })));
};

var _path$3l, _path2$1c;
function _extends$3m() { return _extends$3m = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$3m.apply(null, arguments); }
var SvgSigned16 = function SvgSigned16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3m({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$3l || (_path$3l = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8.978 11.858a1.5 1.5 0 0 1 1.061-.44h1.38V10.04c0-.398.158-.78.439-1.06l.975-.976-.975-.975a1.5 1.5 0 0 1-.44-1.061v-1.38H10.04a1.5 1.5 0 0 1-1.06-.439l-.976-.975-.975.975a1.5 1.5 0 0 1-1.061.44h-1.38v1.379a1.5 1.5 0 0 1-.439 1.06l-.975.976.975.975a1.5 1.5 0 0 1 .44 1.061v1.38h1.38a1.5 1.5 0 0 1 1.06.439l.975.975zm-1.682-10.1a1 1 0 0 1 1.414 0l1.33 1.33h1.879a1 1 0 0 1 1 1v1.879l1.328 1.329a1 1 0 0 1 0 1.414L12.92 10.04v1.88a1 1 0 0 1-1 1h-1.88L8.71 14.247a1 1 0 0 1-1.414 0L5.967 12.92h-1.88a1 1 0 0 1-1-1v-1.88L1.76 8.71a1 1 0 0 1 0-1.414l1.329-1.33V4.089a1 1 0 0 1 1-1h1.879z",
    clipRule: "evenodd"
  })), _path2$1c || (_path2$1c = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M10.395 6.134a.75.75 0 0 1 .005 1.06L7.758 9.861a.75.75 0 0 1-1.085-.02L5.448 8.507a.75.75 0 0 1 1.104-1.014l.694.754 2.088-2.108a.75.75 0 0 1 1.06-.005",
    clipRule: "evenodd"
  })));
};

var _path$3k, _path2$1b;
function _extends$3l() { return _extends$3l = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$3l.apply(null, arguments); }
var SvgSigned18 = function SvgSigned18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3l({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$3k || (_path$3k = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M12.916 6.215a1.6 1.6 0 0 1-1.131-1.131l-.166-.62-.62.166a1.6 1.6 0 0 1-1.545-.414L9 3.763l-.453.453A1.6 1.6 0 0 1 7 4.63l-.62-.166-.166.62a1.6 1.6 0 0 1-1.13 1.131l-.62.166.166.62a1.6 1.6 0 0 1-.415 1.545L3.763 9l.453.454a1.6 1.6 0 0 1 .415 1.545l-.167.62.62.166a1.6 1.6 0 0 1 1.131 1.131l.166.62.62-.166a1.6 1.6 0 0 1 1.546.414l.453.453.454-.453a1.6 1.6 0 0 1 1.545-.414l.62.166.166-.62a1.6 1.6 0 0 1 1.131-1.131l.62-.166-.166-.62a1.6 1.6 0 0 1 .414-1.545L14.237 9l-.453-.454a1.6 1.6 0 0 1-.414-1.545l.166-.62zm-2.331-3.13-.878-.878a1 1 0 0 0-1.414 0l-.878.878-1.199-.321a1 1 0 0 0-1.225.707L4.67 4.67l-1.489.399a.7.7 0 0 0-.495.857l.399 1.489-.878.878a1 1 0 0 0 0 1.414l.878.878-.321 1.199a1 1 0 0 0 .707 1.225l1.199.321.399 1.489a.7.7 0 0 0 .857.495l1.49-.399.877.878a1 1 0 0 0 1.414 0l.878-.878 1.2.321a1 1 0 0 0 1.224-.707l.321-1.199 1.49-.399a.7.7 0 0 0 .494-.857l-.399-1.49.878-.877a1 1 0 0 0 0-1.414l-.878-.878.322-1.2a1 1 0 0 0-.708-1.224L13.33 4.67l-.399-1.49a.7.7 0 0 0-.857-.494z",
    clipRule: "evenodd"
  })), _path2$1b || (_path2$1b = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M11.663 6.932a.8.8 0 0 1 .005 1.131l-2.971 3a.8.8 0 0 1-1.158-.022l-1.378-1.5A.8.8 0 0 1 7.339 8.46l.811.882 2.382-2.404a.8.8 0 0 1 1.131-.005",
    clipRule: "evenodd"
  })));
};

var _path$3j, _path2$1a;
function _extends$3k() { return _extends$3k = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$3k.apply(null, arguments); }
var SvgSigned24 = function SvgSigned24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3k({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$3j || (_path$3j = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M17.308 7.965a1.8 1.8 0 0 1-1.273-1.273l-.308-1.148-1.148.308a1.8 1.8 0 0 1-1.738-.466l-.84-.84-.841.84a1.8 1.8 0 0 1-1.739.466l-1.148-.308-.308 1.148a1.8 1.8 0 0 1-1.273 1.273l-1.148.308.308 1.148a1.8 1.8 0 0 1-.466 1.739l-.84.84.84.84a1.8 1.8 0 0 1 .466 1.74l-.308 1.147 1.148.308a1.8 1.8 0 0 1 1.273 1.273l.308 1.148 1.148-.308a1.8 1.8 0 0 1 1.739.466l.84.84.84-.84a1.8 1.8 0 0 1 1.74-.466l1.147.308.308-1.148a1.8 1.8 0 0 1 1.273-1.273l1.148-.308-.308-1.148a1.8 1.8 0 0 1 .466-1.739l.84-.84-.84-.84a1.8 1.8 0 0 1-.466-1.74l.308-1.147zm.466-1.739-.515-1.92a1 1 0 0 0-1.225-.707l-1.92.514-1.407-1.406a1 1 0 0 0-1.414 0L9.887 4.113 7.966 3.6a1 1 0 0 0-1.225.707l-.514 1.92-1.921.515a1 1 0 0 0-.707 1.225l.514 1.92-1.406 1.407a1 1 0 0 0 0 1.414l1.406 1.406-.514 1.921a1 1 0 0 0 .707 1.225l1.92.514.515 1.921a1 1 0 0 0 1.225.707l1.92-.514 1.407 1.406a1 1 0 0 0 1.414 0l1.406-1.406 1.921.514a1 1 0 0 0 1.225-.707l.515-1.92 1.92-.515a1 1 0 0 0 .707-1.225l-.514-1.92 1.406-1.407a1 1 0 0 0 0-1.414l-1.406-1.406.514-1.921a1 1 0 0 0-.707-1.225z",
    clipRule: "evenodd"
  })), _path2$1a || (_path2$1a = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M15.434 9.36a.9.9 0 0 1 .006 1.273l-3.963 4a.9.9 0 0 1-1.302-.024l-1.838-2a.9.9 0 0 1 1.326-1.218l1.2 1.305 3.298-3.33a.9.9 0 0 1 1.273-.005",
    clipRule: "evenodd"
  })));
};

var _path$3i, _path2$19;
function _extends$3j() { return _extends$3j = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$3j.apply(null, arguments); }
var SvgSigned32 = function SvgSigned32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3j({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$3i || (_path$3i = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M22.961 10.015A2 2 0 0 1 21.547 8.6l-.514-1.917-1.917.513a2 2 0 0 1-1.931-.517L15.78 5.276 14.378 6.68a2 2 0 0 1-1.932.517l-1.917-.513-.514 1.917A2 2 0 0 1 8.6 10.015l-1.917.514.513 1.917a2 2 0 0 1-.517 1.932L5.276 15.78l1.404 1.403a2 2 0 0 1 .517 1.932l-.513 1.918 1.917.513a2 2 0 0 1 1.414 1.414l.514 1.918 1.917-.514a2 2 0 0 1 1.932.518l1.403 1.403 1.403-1.404a2 2 0 0 1 1.932-.517l1.918.514.513-1.918a2 2 0 0 1 1.414-1.414l1.918-.514-.514-1.917a2 2 0 0 1 .518-1.931l1.403-1.404-1.404-1.403a2 2 0 0 1-.517-1.932l.514-1.917zm-6.708 16.742h-.002zm2.346-21.492-1.875-1.874a1.333 1.333 0 0 0-1.886 0l-1.875 1.874-2.56-.686a1.333 1.333 0 0 0-1.634.943l-.686 2.561-2.561.686a1.333 1.333 0 0 0-.943 1.633l.686 2.561-1.874 1.875c-.521.52-.521 1.365 0 1.886l1.874 1.875-.686 2.56c-.19.712.232 1.443.943 1.634l2.561.686.686 2.561c.19.711.922 1.134 1.633.943l2.561-.686 1.875 1.875c.52.52 1.365.52 1.886 0l1.875-1.875 2.56.686a1.333 1.333 0 0 0 1.634-.943l.686-2.56 2.561-.687a1.333 1.333 0 0 0 .943-1.633l-.686-2.561 1.875-1.875c.52-.52.52-1.365 0-1.886l-1.875-1.875.686-2.56a1.333 1.333 0 0 0-.943-1.634l-2.561-.686-.686-2.561a1.333 1.333 0 0 0-1.633-.943z",
    clipRule: "evenodd"
  })), _path2$19 || (_path2$19 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M20.455 12.641a1 1 0 0 1-.03 1.414l-5.558 5.333a1 1 0 0 1-1.384 0l-2.175-2.087a1 1 0 1 1 1.384-1.443l1.483 1.423 4.866-4.67a1 1 0 0 1 1.414.03",
    clipRule: "evenodd"
  })));
};

var _path$3h, _path2$18;
function _extends$3i() { return _extends$3i = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$3i.apply(null, arguments); }
var SvgSigned48 = function SvgSigned48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3i({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$3h || (_path$3h = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M34.926 14.771a2.4 2.4 0 0 1-1.697-1.697l-.9-3.359a.1.1 0 0 0-.123-.07l-3.358.9a2.4 2.4 0 0 1-2.318-.621l-2.46-2.46a.1.1 0 0 0-.14 0l-2.46 2.46a2.4 2.4 0 0 1-2.318.62l-3.358-.9a.1.1 0 0 0-.123.071l-.9 3.36a2.4 2.4 0 0 1-1.697 1.696l-3.358.9a.1.1 0 0 0-.071.123l.9 3.358a2.4 2.4 0 0 1-.621 2.319l-2.46 2.458a.1.1 0 0 0 0 .142l2.46 2.458a2.4 2.4 0 0 1 .62 2.319l-.9 3.358a.1.1 0 0 0 .072.123l3.358.9a2.4 2.4 0 0 1 1.697 1.697l.9 3.358a.1.1 0 0 0 .123.071l3.358-.9a2.4 2.4 0 0 1 2.319.621l2.458 2.46a.1.1 0 0 0 .142 0l2.459-2.46a2.4 2.4 0 0 1 2.318-.62l3.358.9a.1.1 0 0 0 .123-.072l.9-3.358a2.4 2.4 0 0 1 1.697-1.697l3.359-.9a.1.1 0 0 0 .07-.123l-.9-3.358a2.4 2.4 0 0 1 .622-2.319l2.458-2.458a.1.1 0 0 0 0-.142l-2.458-2.458a2.4 2.4 0 0 1-.622-2.319l.9-3.358a.1.1 0 0 0-.07-.123zM19.774 8.226l-3.36-.9a2.5 2.5 0 0 0-3.06 1.768l-.9 3.359-3.36.9a2.5 2.5 0 0 0-1.767 3.062l.9 3.358-2.46 2.46a2.5 2.5 0 0 0 0 3.535l2.46 2.459-.9 3.358a2.5 2.5 0 0 0 1.767 3.062l3.36.9.9 3.359a2.5 2.5 0 0 0 3.06 1.767l3.36-.9 2.458 2.46a2.5 2.5 0 0 0 3.536 0l2.459-2.46 3.358.9a2.5 2.5 0 0 0 3.062-1.767l.9-3.359 3.359-.9a2.5 2.5 0 0 0 1.768-3.062l-.9-3.358 2.458-2.46a2.5 2.5 0 0 0 0-3.535l-2.458-2.459.9-3.358a2.5 2.5 0 0 0-1.768-3.062l-3.359-.9-.9-3.359a2.5 2.5 0 0 0-3.062-1.767l-3.358.9-2.46-2.46a2.5 2.5 0 0 0-3.535 0z",
    clipRule: "evenodd"
  })), _path2$18 || (_path2$18 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M30.445 19.148a1.2 1.2 0 0 1 .008 1.697l-7.925 8a1.2 1.2 0 0 1-1.736-.033l-3.676-4a1.2 1.2 0 0 1 1.768-1.624l2.824 3.074 7.04-7.107a1.2 1.2 0 0 1 1.697-.008",
    clipRule: "evenodd"
  })));
};

var SignedIcon = function SignedIcon(props) {
  var signed = {
    12: SvgSigned12,
    16: SvgSigned16,
    18: SvgSigned18,
    24: SvgSigned24,
    32: SvgSigned32,
    48: SvgSigned48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: signed
  }, props));
};

var _path$3g;
function _extends$3h() { return _extends$3h = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$3h.apply(null, arguments); }
var SvgSignedFilled12 = function SvgSignedFilled12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3h({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$3g || (_path$3g = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M6.71 10.509a1 1 0 0 1-1.415 0l-.82-.82h-1.16a1 1 0 0 1-1-1v-1.16l-.82-.82a1 1 0 0 1 0-1.414l.82-.82v-1.16a1 1 0 0 1 1-1h1.16l.82-.82a1 1 0 0 1 1.414 0l.82.82h1.16a1 1 0 0 1 1 1v1.16l.82.82a1 1 0 0 1 0 1.414l-.82.82v1.16a1 1 0 0 1-1 1h-1.16zm1.116-5.087a.6.6 0 1 0-.852-.844L5.435 6.13l-.493-.537a.6.6 0 0 0-.884.812l.919 1a.6.6 0 0 0 .868.016z",
    clipRule: "evenodd"
  })));
};

var _path$3f;
function _extends$3g() { return _extends$3g = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$3g.apply(null, arguments); }
var SvgSignedFilled16 = function SvgSignedFilled16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3g({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$3f || (_path$3f = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8.71 14.247a1 1 0 0 1-1.414 0L5.967 12.92h-1.88a1 1 0 0 1-1-1v-1.88L1.76 8.71a1 1 0 0 1 0-1.414l1.329-1.33V4.089a1 1 0 0 1 1-1h1.879l1.329-1.33a1 1 0 0 1 1.414 0l1.33 1.33h1.879a1 1 0 0 1 1 1v1.879l1.328 1.329a1 1 0 0 1 0 1.414L12.92 10.04v1.88a1 1 0 0 1-1 1h-1.88zm1.69-7.053A.75.75 0 0 0 9.334 6.14L7.246 8.247l-.694-.754a.75.75 0 0 0-1.104 1.014l1.225 1.334a.75.75 0 0 0 1.085.02z",
    clipRule: "evenodd"
  })));
};

var _path$3e;
function _extends$3f() { return _extends$3f = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$3f.apply(null, arguments); }
var SvgSignedFilled18 = function SvgSignedFilled18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3f({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$3e || (_path$3e = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M9.707 2.207a1 1 0 0 0-1.414 0l-.878.878-1.2-.321a1 1 0 0 0-1.224.707L4.67 4.67l-1.2.321a1 1 0 0 0-.707 1.225l.322 1.199-.878.878a1 1 0 0 0 0 1.414l.878.878-.322 1.199a1 1 0 0 0 .708 1.225l1.199.321.321 1.2a1 1 0 0 0 1.225.706l1.199-.321.878.878a1 1 0 0 0 1.414 0l.878-.878 1.199.321a1 1 0 0 0 1.225-.707l.321-1.199 1.2-.321a1 1 0 0 0 .706-1.225l-.321-1.2.878-.877a1 1 0 0 0 0-1.414l-.878-.878.321-1.2a1 1 0 0 0-.707-1.224L13.33 4.67l-.321-1.2a1 1 0 0 0-1.225-.706l-1.2.32zm1.961 5.856a.8.8 0 0 0-1.136-1.126L8.15 9.341l-.811-.882A.8.8 0 0 0 6.16 9.54l1.378 1.5a.8.8 0 0 0 1.157.022z",
    clipRule: "evenodd"
  })));
};

var _path$3d;
function _extends$3e() { return _extends$3e = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$3e.apply(null, arguments); }
var SvgSignedFilled24 = function SvgSignedFilled24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3e({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$3d || (_path$3d = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M12.707 2.707a1 1 0 0 0-1.414 0L9.887 4.113 7.966 3.6a1 1 0 0 0-1.225.707l-.515 1.92-1.92.515a1 1 0 0 0-.708 1.225l.515 1.92-1.406 1.407a1 1 0 0 0 0 1.414l1.406 1.406-.515 1.921a1 1 0 0 0 .708 1.225l1.92.514.515 1.921a1 1 0 0 0 1.225.707l1.92-.514 1.407 1.406a1 1 0 0 0 1.414 0l1.406-1.406 1.92.514a1 1 0 0 0 1.226-.707l.514-1.92 1.921-.515a1 1 0 0 0 .707-1.225l-.514-1.92 1.406-1.407a1 1 0 0 0 0-1.414l-1.406-1.406.514-1.921a1 1 0 0 0-.707-1.225l-1.92-.515-.515-1.92a1 1 0 0 0-1.225-.707l-1.92.514zm2.732 7.926a.9.9 0 1 0-1.278-1.266l-3.299 3.33-1.2-1.306a.9.9 0 0 0-1.325 1.218l1.838 2a.9.9 0 0 0 1.302.024z",
    clipRule: "evenodd"
  })));
};

var _path$3c;
function _extends$3d() { return _extends$3d = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$3d.apply(null, arguments); }
var SvgSignedFilled32 = function SvgSignedFilled32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3d({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$3c || (_path$3c = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M16.94 3.607a1.33 1.33 0 0 0-1.88 0l-1.878 1.877-2.564-.687a1.33 1.33 0 0 0-1.629.94l-.687 2.565-2.564.687c-.71.19-1.13.92-.94 1.629l.687 2.564-1.878 1.877a1.33 1.33 0 0 0 0 1.881l1.878 1.878-.688 2.564c-.19.71.231 1.439.94 1.629l2.565.687.687 2.564c.19.71.92 1.13 1.63.94l2.563-.686 1.878 1.877c.52.52 1.361.52 1.88 0l1.878-1.877 2.564.687a1.33 1.33 0 0 0 1.63-.94l.686-2.565 2.564-.687c.71-.19 1.131-.92.941-1.629l-.687-2.564 1.877-1.878a1.33 1.33 0 0 0 0-1.88l-1.877-1.878.687-2.564a1.33 1.33 0 0 0-.94-1.629l-2.565-.687-.687-2.564a1.33 1.33 0 0 0-1.629-.94l-2.564.686zm3.504 10.43a1 1 0 0 0-1.42-1.408l-4.546 4.59-1.741-1.896a1 1 0 0 0-1.473 1.354l2.45 2.666a1 1 0 0 0 1.447.027z",
    clipRule: "evenodd"
  })));
};

var _path$3b;
function _extends$3c() { return _extends$3c = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$3c.apply(null, arguments); }
var SvgSignedFilled48 = function SvgSignedFilled48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3c({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$3b || (_path$3b = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M25.768 5.768a2.5 2.5 0 0 0-3.536 0l-2.458 2.458-3.36-.9a2.5 2.5 0 0 0-3.06 1.768l-.9 3.359-3.36.9a2.5 2.5 0 0 0-1.767 3.062l.9 3.358-2.46 2.46a2.5 2.5 0 0 0 0 3.535l2.46 2.459-.9 3.358a2.5 2.5 0 0 0 1.767 3.062l3.36.9.9 3.359a2.5 2.5 0 0 0 3.06 1.767l3.36-.9 2.458 2.46a2.5 2.5 0 0 0 3.536 0l2.459-2.46 3.358.9a2.5 2.5 0 0 0 3.062-1.767l.9-3.359 3.359-.9a2.5 2.5 0 0 0 1.768-3.062l-.9-3.358 2.458-2.46a2.5 2.5 0 0 0 0-3.535l-2.458-2.459.9-3.358a2.5 2.5 0 0 0-1.768-3.062l-3.359-.9-.9-3.359a2.5 2.5 0 0 0-3.062-1.767l-3.358.9zm4.685 15.077a1.2 1.2 0 1 0-1.705-1.69l-7.04 7.107-2.824-3.074a1.2 1.2 0 1 0-1.768 1.624l3.676 4a1.2 1.2 0 0 0 1.736.032z",
    clipRule: "evenodd"
  })));
};

var SignedFilledIcon = function SignedFilledIcon(props) {
  var signedFilled = {
    12: SvgSignedFilled12,
    16: SvgSignedFilled16,
    18: SvgSignedFilled18,
    24: SvgSignedFilled24,
    32: SvgSignedFilled32,
    48: SvgSignedFilled48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: signedFilled
  }, props));
};

var _path$3a;
function _extends$3b() { return _extends$3b = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$3b.apply(null, arguments); }
var SvgSorting12 = function SvgSorting12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3b({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$3a || (_path$3a = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M3.576 2.576a.6.6 0 0 1 .848 0l1.75 1.75a.6.6 0 0 1-.848.848L4.6 4.448V9a.6.6 0 0 1-1.2 0V4.448l-.726.726a.6.6 0 0 1-.848-.848zM8.424 9.424a.6.6 0 0 1-.848 0l-1.75-1.75a.6.6 0 1 1 .848-.848l.726.725V3a.6.6 0 0 1 1.2 0V7.55l.726-.725a.6.6 0 0 1 .848.848z",
    clipRule: "evenodd"
  })));
};

var _path$39;
function _extends$3a() { return _extends$3a = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$3a.apply(null, arguments); }
var SvgSorting16 = function SvgSorting16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3a({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$39 || (_path$39 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M5.333 3.25a.75.75 0 0 1 .53.22l2.334 2.333a.75.75 0 0 1-1.06 1.06L6.082 5.812V12a.75.75 0 0 1-1.5 0V5.81L3.53 6.865a.75.75 0 1 1-1.06-1.061L4.803 3.47a.75.75 0 0 1 .53-.22M10.667 12.75a.75.75 0 0 1-.53-.22l-2.334-2.333a.75.75 0 0 1 1.06-1.06l1.054 1.052V4a.75.75 0 0 1 1.5 0v6.19l1.053-1.054a.75.75 0 1 1 1.06 1.061l-2.333 2.333a.75.75 0 0 1-.53.22",
    clipRule: "evenodd"
  })));
};

var _path$38;
function _extends$39() { return _extends$39 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$39.apply(null, arguments); }
var SvgSorting18 = function SvgSorting18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$39({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$38 || (_path$38 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M5.435 3.935a.8.8 0 0 1 1.13 0L9.192 6.56A.8.8 0 1 1 8.06 7.69L6.8 6.433V13.5a.8.8 0 0 1-1.6 0V6.432L3.94 7.69A.8.8 0 1 1 2.81 6.56zM12.566 14.066a.8.8 0 0 1-1.132 0L8.81 11.44a.8.8 0 0 1 1.13-1.132l1.26 1.26V4.5a.8.8 0 0 1 1.6 0v7.069l1.26-1.26a.8.8 0 0 1 1.13 1.132z",
    clipRule: "evenodd"
  })));
};

var _path$37;
function _extends$38() { return _extends$38 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$38.apply(null, arguments); }
var SvgSorting24 = function SvgSorting24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$38({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$37 || (_path$37 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M7.364 5.364a.9.9 0 0 1 1.272 0l3.5 3.5a.9.9 0 1 1-1.272 1.272L8.9 8.174V18a.9.9 0 1 1-1.8 0V8.173l-1.964 1.963a.9.9 0 1 1-1.272-1.272zM16.637 18.637a.9.9 0 0 1-1.273 0l-3.5-3.5a.9.9 0 1 1 1.272-1.273l1.964 1.963V6a.9.9 0 1 1 1.8 0v9.827l1.964-1.963a.9.9 0 1 1 1.273 1.272z",
    clipRule: "evenodd"
  })));
};

var _path$36;
function _extends$37() { return _extends$37 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$37.apply(null, arguments); }
var SvgSorting32 = function SvgSorting32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$37({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$36 || (_path$36 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M10.667 7a1 1 0 0 1 .707.293l4.666 4.667a1 1 0 1 1-1.414 1.414l-2.96-2.96V24a1 1 0 1 1-2 0V10.414l-2.959 2.96a1 1 0 0 1-1.414-1.414L9.96 7.293A1 1 0 0 1 10.667 7M21.333 25a1 1 0 0 1-.707-.293L15.96 20.04a1 1 0 1 1 1.414-1.414l2.96 2.96V8a1 1 0 0 1 2 0v13.586l2.959-2.96a1 1 0 0 1 1.414 1.414l-4.667 4.667a1 1 0 0 1-.707.293",
    clipRule: "evenodd"
  })));
};

var _path$35;
function _extends$36() { return _extends$36 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$36.apply(null, arguments); }
var SvgSorting48 = function SvgSorting48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$36({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$35 || (_path$35 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M15.151 11.151a1.2 1.2 0 0 1 1.697 0l7 7a1.2 1.2 0 1 1-1.697 1.697L17.2 14.897V36a1.2 1.2 0 0 1-2.4 0V14.897l-4.952 4.951a1.2 1.2 0 1 1-1.697-1.697zM32.848 36.848a1.2 1.2 0 0 1-1.697 0l-7-7a1.2 1.2 0 1 1 1.697-1.697l4.952 4.952V12a1.2 1.2 0 0 1 2.4 0v21.103l4.951-4.952a1.2 1.2 0 1 1 1.697 1.697z",
    clipRule: "evenodd"
  })));
};

var SortingIcon = function SortingIcon(props) {
  var sorting = {
    12: SvgSorting12,
    16: SvgSorting16,
    18: SvgSorting18,
    24: SvgSorting24,
    32: SvgSorting32,
    48: SvgSorting48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: sorting
  }, props));
};

var _path$34;
function _extends$35() { return _extends$35 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$35.apply(null, arguments); }
var SvgSoundMuteFilled12 = function SvgSoundMuteFilled12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$35({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$34 || (_path$34 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M6.175 1.708 3.5 4H2.25C1.56 4 1 4.56 1 5.25v1.5C1 7.44 1.56 8 2.25 8H3.5l2.675 2.293A.5.5 0 0 0 7 9.913V2.087a.5.5 0 0 0-.825-.38M8.283 7.245a.4.4 0 0 1 0-.565l.832-.832-.832-.832a.4.4 0 0 1 .566-.566l.831.832.832-.832a.4.4 0 0 1 .566.566l-.832.832.832.832a.4.4 0 0 1-.566.565l-.832-.831-.831.831a.4.4 0 0 1-.566 0"
  })));
};

var _path$33;
function _extends$34() { return _extends$34 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$34.apply(null, arguments); }
var SvgSoundMuteFilled16 = function SvgSoundMuteFilled16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$34({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$33 || (_path$33 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "m4.667 5.333 3.566-3.056a.667.667 0 0 1 1.1.506v10.434c0 .57-.668.877-1.1.506l-3.566-3.056H3c-.92 0-1.667-.746-1.667-1.667V7c0-.92.746-1.667 1.667-1.667zM11.798 5.934a.533.533 0 0 0-.754.754l1.109 1.11-1.11 1.109a.533.533 0 0 0 .755.754l1.11-1.11 1.108 1.11a.533.533 0 0 0 .755-.754l-1.11-1.11 1.11-1.109a.533.533 0 1 0-.755-.754l-1.109 1.11z"
  })));
};

var _path$32;
function _extends$33() { return _extends$33 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$33.apply(null, arguments); }
var SvgSoundMuteFilled18 = function SvgSoundMuteFilled18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$33({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$32 || (_path$32 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M5.25 6 9.262 2.56a.75.75 0 0 1 1.238.57v11.738a.75.75 0 0 1-1.238.57L5.25 12H3.375A1.875 1.875 0 0 1 1.5 10.125v-2.25C1.5 6.839 2.34 6 3.375 6zM13.273 6.676a.6.6 0 1 0-.849.848l1.248 1.248-1.248 1.248a.6.6 0 0 0 .849.848l1.248-1.247 1.247 1.247a.6.6 0 0 0 .849-.848l-1.248-1.248 1.248-1.248a.6.6 0 0 0-.849-.848l-1.247 1.247z"
  })));
};

var _path$31;
function _extends$32() { return _extends$32 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$32.apply(null, arguments); }
var SvgSoundMuteFilled24 = function SvgSoundMuteFilled24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$32({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$31 || (_path$31 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "m7 8 5.35-4.585a1 1 0 0 1 1.65.76v15.65a1 1 0 0 1-1.65.76L7 16H4.5A2.5 2.5 0 0 1 2 13.5v-3A2.5 2.5 0 0 1 4.5 8zM17.697 8.901a.8.8 0 0 0-1.131 1.131l1.663 1.664-1.663 1.664a.8.8 0 0 0 1.131 1.131l1.664-1.664 1.663 1.664a.8.8 0 1 0 1.132-1.131l-1.664-1.664 1.664-1.664a.8.8 0 1 0-1.131-1.131l-1.664 1.664z"
  })));
};

var _path$30;
function _extends$31() { return _extends$31 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$31.apply(null, arguments); }
var SvgSoundMuteFilled32 = function SvgSoundMuteFilled32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$31({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$30 || (_path$30 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "m9.333 10.667 7.133-6.114c.865-.741 2.2-.127 2.2 1.013v20.868c0 1.14-1.335 1.754-2.2 1.013l-7.133-6.114H6A3.333 3.333 0 0 1 2.667 18v-4A3.333 3.333 0 0 1 6 10.667zM22.088 17.813a1.067 1.067 0 1 0 1.508 1.508l2.218-2.218 2.219 2.218a1.067 1.067 0 1 0 1.508-1.508l-2.218-2.218 2.218-2.219a1.067 1.067 0 0 0-1.508-1.508l-2.219 2.218-2.218-2.218a1.067 1.067 0 0 0-1.508 1.508l2.218 2.219z"
  })));
};

var _path$2$;
function _extends$30() { return _extends$30 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$30.apply(null, arguments); }
var SvgSoundMuteFilled48 = function SvgSoundMuteFilled48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$30({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$2$ || (_path$2$ = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "m14 16 10.698-9.17C25.996 5.718 28 6.64 28 8.348v31.304c0 1.708-2.004 2.63-3.302 1.518L14 32H9a5 5 0 0 1-5-5v-6a5 5 0 0 1 5-5zM33.132 26.72a1.6 1.6 0 0 0 2.262 2.262l3.328-3.327 3.327 3.327a1.6 1.6 0 1 0 2.263-2.262l-3.328-3.328 3.328-3.327a1.6 1.6 0 0 0-2.263-2.263l-3.327 3.327-3.328-3.327a1.6 1.6 0 1 0-2.262 2.263l3.327 3.327z"
  })));
};

var SoundMuteFilledIcon = function SoundMuteFilledIcon(props) {
  var soundMuteFilled = {
    12: SvgSoundMuteFilled12,
    16: SvgSoundMuteFilled16,
    18: SvgSoundMuteFilled18,
    24: SvgSoundMuteFilled24,
    32: SvgSoundMuteFilled32,
    48: SvgSoundMuteFilled48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: soundMuteFilled
  }, props));
};

var _path$2_, _path2$17;
function _extends$2$() { return _extends$2$ = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2$.apply(null, arguments); }
var SvgSoundOffFilled12 = function SvgSoundOffFilled12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2$({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$2_ || (_path$2_ = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M1.842.824a.6.6 0 0 1 .849 0l7.825 7.825a.6.6 0 1 1-.848.849L1.842 1.673a.6.6 0 0 1 0-.849M2.485 4H2.25C1.56 4 1 4.56 1 5.25v1.5C1 7.44 1.56 8 2.25 8H3.5l2.675 2.293A.5.5 0 0 0 7 9.913V8.515z"
  })), _path2$17 || (_path2$17 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M7 6.818v-4.73a.5.5 0 0 0-.825-.38L3.867 3.684z"
  })));
};

var _path$2Z, _path2$16;
function _extends$2_() { return _extends$2_ = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2_.apply(null, arguments); }
var SvgSoundOffFilled16 = function SvgSoundOffFilled16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2_({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$2Z || (_path$2Z = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M2.456 1.1a.8.8 0 0 1 1.132 0L14.02 11.532a.8.8 0 0 1-1.131 1.131L2.456 2.23a.8.8 0 0 1 0-1.13M3.313 5.333H3c-.92 0-1.667.747-1.667 1.667v2c0 .92.746 1.667 1.667 1.667h1.667l3.566 3.056a.667.667 0 0 0 1.1-.506v-1.863z"
  })), _path2$16 || (_path2$16 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M9.333 9.09V2.784a.667.667 0 0 0-1.1-.506L5.156 4.914z"
  })));
};

var _path$2Y, _path2$15;
function _extends$2Z() { return _extends$2Z = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2Z.apply(null, arguments); }
var SvgSoundOffFilled18 = function SvgSoundOffFilled18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2Z({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$2Y || (_path$2Y = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M2.764 1.236a.9.9 0 0 1 1.272 0l11.738 11.738a.9.9 0 1 1-1.273 1.273L2.764 2.509a.9.9 0 0 1 0-1.273M3.727 6h-.352C2.339 6 1.5 6.84 1.5 7.875v2.25C1.5 11.161 2.34 12 3.375 12H5.25l4.012 3.439a.75.75 0 0 0 1.238-.57v-2.096z"
  })), _path2$15 || (_path2$15 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M10.5 10.227V3.131a.75.75 0 0 0-1.238-.57L5.8 5.528z"
  })));
};

var _path$2X, _path2$14;
function _extends$2Y() { return _extends$2Y = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2Y.apply(null, arguments); }
var SvgSoundOffFilled24 = function SvgSoundOffFilled24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2Y({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$2X || (_path$2X = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M3.685 1.648a1.2 1.2 0 0 1 1.697 0l15.65 15.65a1.2 1.2 0 1 1-1.697 1.698L3.685 3.346a1.2 1.2 0 0 1 0-1.698M4.97 8H4.5A2.5 2.5 0 0 0 2 10.5v3A2.5 2.5 0 0 0 4.5 16H7l5.35 4.585a1 1 0 0 0 1.65-.76V17.03z"
  })), _path2$14 || (_path2$14 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M14 13.636V4.174a1 1 0 0 0-1.65-.76L7.733 7.37z"
  })));
};

var _path$2W, _path2$13;
function _extends$2X() { return _extends$2X = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2X.apply(null, arguments); }
var SvgSoundOffFilled32 = function SvgSoundOffFilled32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2X({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$2W || (_path$2W = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M4.913 2.198a1.6 1.6 0 0 1 2.263 0l20.867 20.867a1.6 1.6 0 1 1-2.263 2.263L4.913 4.46a1.6 1.6 0 0 1 0-2.263M6.626 10.667H6A3.333 3.333 0 0 0 2.667 14v4A3.333 3.333 0 0 0 6 21.333h3.333l7.133 6.114c.865.741 2.2.126 2.2-1.013v-3.727z"
  })), _path2$13 || (_path2$13 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M18.667 18.182V5.566c0-1.14-1.336-1.754-2.201-1.013l-6.154 5.274z"
  })));
};

var _path$2V, _path2$12;
function _extends$2W() { return _extends$2W = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2W.apply(null, arguments); }
var SvgSoundOffFilled48 = function SvgSoundOffFilled48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2W({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$2V || (_path$2V = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M7.37 3.297a2.4 2.4 0 0 1 3.394 0l31.3 31.3a2.4 2.4 0 1 1-3.394 3.395l-31.3-31.3a2.4 2.4 0 0 1 0-3.395M9.94 16H9a5 5 0 0 0-5 5v6a5 5 0 0 0 5 5h5l10.698 9.17c1.298 1.112 3.302.19 3.302-1.519v-5.59z"
  })), _path2$12 || (_path2$12 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M28 27.273V8.348c0-1.708-2.004-2.63-3.302-1.518l-9.23 7.911z"
  })));
};

var SoundOffFilledIcon = function SoundOffFilledIcon(props) {
  var soundOffFilled = {
    12: SvgSoundOffFilled12,
    16: SvgSoundOffFilled16,
    18: SvgSoundOffFilled18,
    24: SvgSoundOffFilled24,
    32: SvgSoundOffFilled32,
    48: SvgSoundOffFilled48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: soundOffFilled
  }, props));
};

var _path$2U, _path2$11;
function _extends$2V() { return _extends$2V = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2V.apply(null, arguments); }
var SvgSoundOnFilled12 = function SvgSoundOnFilled12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2V({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$2U || (_path$2U = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "m3.5 4 2.675-2.293a.5.5 0 0 1 .825.38v7.826a.5.5 0 0 1-.825.38L3.5 8H2.25C1.56 8 1 7.44 1 6.75v-1.5C1 4.56 1.56 4 2.25 4z"
  })), _path2$11 || (_path2$11 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M9.432 3.182a.45.45 0 0 1 .636 0 3.983 3.983 0 0 1 0 5.636.45.45 0 0 1-.636-.636 3.083 3.083 0 0 0 0-4.364.45.45 0 0 1 0-.636m-1.25 1.34a.45.45 0 0 1 .636 0 2.09 2.09 0 0 1 0 2.956.45.45 0 0 1-.636-.637 1.19 1.19 0 0 0 0-1.682.45.45 0 0 1 0-.637",
    clipRule: "evenodd"
  })));
};

var _path$2T, _path2$10;
function _extends$2U() { return _extends$2U = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2U.apply(null, arguments); }
var SvgSoundOnFilled16 = function SvgSoundOnFilled16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2U({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$2T || (_path$2T = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "m4.667 5.333 3.566-3.056a.667.667 0 0 1 1.1.506v10.434c0 .57-.668.877-1.1.506l-3.566-3.056H3c-.92 0-1.667-.747-1.667-1.667V7c0-.92.746-1.667 1.667-1.667z"
  })), _path2$10 || (_path2$10 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M12.576 4.242a.6.6 0 0 1 .848 0 5.31 5.31 0 0 1 0 7.516.6.6 0 1 1-.848-.85 4.11 4.11 0 0 0 0-5.817.6.6 0 0 1 0-.849M10.909 6.03a.6.6 0 0 1 .848 0 2.787 2.787 0 0 1 0 3.941.6.6 0 1 1-.848-.848c.62-.62.62-1.625 0-2.244a.6.6 0 0 1 0-.849",
    clipRule: "evenodd"
  })));
};

var _path$2S, _path2$$;
function _extends$2T() { return _extends$2T = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2T.apply(null, arguments); }
var SvgSoundOnFilled18 = function SvgSoundOnFilled18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2T({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$2S || (_path$2S = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M5.25 6 9.262 2.56a.75.75 0 0 1 1.238.57v11.738a.75.75 0 0 1-1.238.57L5.25 12H3.375A1.875 1.875 0 0 1 1.5 10.125v-2.25C1.5 6.839 2.34 6 3.375 6z"
  })), _path2$$ || (_path2$$ = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M14.148 4.773a.675.675 0 0 1 .954 0 5.974 5.974 0 0 1 0 8.454.675.675 0 0 1-.954-.954 4.624 4.624 0 0 0 0-6.546.675.675 0 0 1 0-.954m-1.875 2.01a.675.675 0 0 1 .954 0 3.136 3.136 0 0 1 0 4.434.675.675 0 0 1-.954-.955 1.786 1.786 0 0 0 0-2.524.675.675 0 0 1 0-.955",
    clipRule: "evenodd"
  })));
};

var _path$2R, _path2$_;
function _extends$2S() { return _extends$2S = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2S.apply(null, arguments); }
var SvgSoundOnFilled24 = function SvgSoundOnFilled24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2S({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$2R || (_path$2R = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "m7 8 5.35-4.585a1 1 0 0 1 1.65.76v15.65a1 1 0 0 1-1.65.76L7 16H4.5A2.5 2.5 0 0 1 2 13.5v-3A2.5 2.5 0 0 1 4.5 8z"
  })), _path2$_ || (_path2$_ = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M18.864 6.364a.9.9 0 0 1 1.272 0 7.966 7.966 0 0 1 0 11.272.9.9 0 1 1-1.272-1.273 6.166 6.166 0 0 0 0-8.727.9.9 0 0 1 0-1.272m-2.5 2.68a.9.9 0 0 1 1.272 0 4.18 4.18 0 0 1 0 5.911.9.9 0 0 1-1.272-1.272 2.38 2.38 0 0 0 0-3.366.9.9 0 0 1 0-1.273",
    clipRule: "evenodd"
  })));
};

var _path$2Q, _path2$Z;
function _extends$2R() { return _extends$2R = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2R.apply(null, arguments); }
var SvgSoundOnFilled32 = function SvgSoundOnFilled32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2R({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$2Q || (_path$2Q = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "m9.333 10.667 7.133-6.114c.865-.741 2.2-.127 2.2 1.013v20.868c0 1.14-1.335 1.754-2.2 1.013l-7.133-6.114H6A3.333 3.333 0 0 1 2.667 18v-4A3.333 3.333 0 0 1 6 10.667z"
  })), _path2$Z || (_path2$Z = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M25.152 8.485a1.2 1.2 0 0 1 1.697 0 10.62 10.62 0 0 1 0 15.03 1.2 1.2 0 1 1-1.697-1.697 8.22 8.22 0 0 0 0-11.636 1.2 1.2 0 0 1 0-1.697m-3.334 3.574a1.2 1.2 0 0 1 1.697 0 5.574 5.574 0 0 1 0 7.881 1.2 1.2 0 1 1-1.697-1.697 3.174 3.174 0 0 0 0-4.487 1.2 1.2 0 0 1 0-1.697",
    clipRule: "evenodd"
  })));
};

var _path$2P, _path2$Y;
function _extends$2Q() { return _extends$2Q = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2Q.apply(null, arguments); }
var SvgSoundOnFilled48 = function SvgSoundOnFilled48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2Q({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$2P || (_path$2P = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "m14 16 10.698-9.17C25.996 5.718 28 6.64 28 8.348v31.303c0 1.71-2.004 2.63-3.302 1.519L14 32H9a5 5 0 0 1-5-5v-6a5 5 0 0 1 5-5z"
  })), _path2$Y || (_path2$Y = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M37.727 12.727a1.8 1.8 0 0 1 2.546 0c6.231 6.232 6.231 16.314 0 22.546a1.8 1.8 0 0 1-2.546-2.546 12.33 12.33 0 0 0 0-17.454 1.8 1.8 0 0 1 0-2.546m-5 5.362a1.8 1.8 0 0 1 2.546 0 8.36 8.36 0 0 1 0 11.822 1.8 1.8 0 0 1-2.546-2.546 4.76 4.76 0 0 0 0-6.73 1.8 1.8 0 0 1 0-2.546",
    clipRule: "evenodd"
  })));
};

var SoundOnFilledIcon = function SoundOnFilledIcon(props) {
  var soundOnFilled = {
    12: SvgSoundOnFilled12,
    16: SvgSoundOnFilled16,
    18: SvgSoundOnFilled18,
    24: SvgSoundOnFilled24,
    32: SvgSoundOnFilled32,
    48: SvgSoundOnFilled48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: soundOnFilled
  }, props));
};

var _path$2O, _path2$X;
function _extends$2P() { return _extends$2P = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2P.apply(null, arguments); }
var SvgSquareAndPencil12 = function SvgSquareAndPencil12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2P({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$2O || (_path$2O = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M3.4 2.55a.85.85 0 0 0-.85.85v5.2c0 .47.38.85.85.85h5.2c.47 0 .85-.38.85-.85V6a.6.6 0 0 1 1.2 0v2.6a2.05 2.05 0 0 1-2.05 2.05H3.4A2.05 2.05 0 0 1 1.35 8.6V3.4A2.05 2.05 0 0 1 3.4 1.35H6a.6.6 0 0 1 0 1.2z",
    clipRule: "evenodd"
  })), _path2$X || (_path2$X = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M4.42 5.637a.6.6 0 0 1 .176-.425l4.143-4.144a1.55 1.55 0 1 1 2.192 2.192L6.789 7.404a.6.6 0 0 1-.425.176L5.02 7.578a.6.6 0 0 1-.6-.6zm1.2.247.001.495h.494l2.872-2.871-.495-.495zm3.72-3.72.496.495.247-.247a.35.35 0 1 0-.495-.495z",
    clipRule: "evenodd"
  })));
};

var _path$2N, _path2$W;
function _extends$2O() { return _extends$2O = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2O.apply(null, arguments); }
var SvgSquareAndPencil16 = function SvgSquareAndPencil16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2O({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$2N || (_path$2N = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M4.533 3.35c-.653 0-1.183.53-1.183 1.183v6.933c0 .654.53 1.184 1.183 1.184h6.934c.653 0 1.183-.53 1.183-1.184V8a.75.75 0 0 1 1.5 0v3.466a2.683 2.683 0 0 1-2.683 2.684H4.533a2.683 2.683 0 0 1-2.683-2.684V4.533A2.683 2.683 0 0 1 4.533 1.85H8a.75.75 0 0 1 0 1.5z",
    clipRule: "evenodd"
  })), _path2$W || (_path2$W = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M5.943 7.516c0-.2.08-.39.22-.531l5.525-5.525a2.017 2.017 0 1 1 2.852 2.852L9.015 9.837a.75.75 0 0 1-.531.22l-1.79-.003a.75.75 0 0 1-.748-.749zm1.5.31.002.729h.73L12.12 4.61l-.73-.73zm5.007-5.007.73.73.3-.298a.517.517 0 1 0-.732-.73z",
    clipRule: "evenodd"
  })));
};

var _path$2M, _path2$V;
function _extends$2N() { return _extends$2N = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2N.apply(null, arguments); }
var SvgSquareAndPencil18 = function SvgSquareAndPencil18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2N({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$2M || (_path$2M = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M5.1 3.725c-.76 0-1.375.615-1.375 1.375v7.8c0 .759.616 1.375 1.375 1.375h7.8c.76 0 1.375-.616 1.375-1.375V9a.8.8 0 0 1 1.6 0v3.9a2.975 2.975 0 0 1-2.975 2.975H5.1A2.975 2.975 0 0 1 2.125 12.9V5.1A2.975 2.975 0 0 1 5.1 2.125H9a.8.8 0 0 1 0 1.6z",
    clipRule: "evenodd"
  })), _path2$V || (_path2$V = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M6.73 8.455a.8.8 0 0 1 .234-.566l6.216-6.216a2.225 2.225 0 1 1 3.146 3.147l-6.215 6.215a.8.8 0 0 1-.567.235l-2.012-.003a.8.8 0 0 1-.8-.799zm1.6.33.002.883.882.001 4.558-4.558-.884-.883zm5.69-5.689.884.884.291-.292a.625.625 0 1 0-.884-.883z",
    clipRule: "evenodd"
  })));
};

var _path$2L, _path2$U;
function _extends$2M() { return _extends$2M = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2M.apply(null, arguments); }
var SvgSquareAndPencil24 = function SvgSquareAndPencil24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2M({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$2L || (_path$2L = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M6.8 4.8a2 2 0 0 0-2 2v10.4a2 2 0 0 0 2 2h10.4a2 2 0 0 0 2-2V12a.9.9 0 0 1 1.8 0v5.2a3.8 3.8 0 0 1-3.8 3.8H6.8A3.8 3.8 0 0 1 3 17.2V6.8A3.8 3.8 0 0 1 6.8 3H12a.9.9 0 1 1 0 1.8z",
    clipRule: "evenodd"
  })), _path2$U || (_path2$U = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M9.14 11.274a.9.9 0 0 1 .264-.637l8.287-8.288a2.8 2.8 0 1 1 3.96 3.96l-8.287 8.287a.9.9 0 0 1-.638.264l-2.684-.003a.9.9 0 0 1-.899-.9zm1.8.371.002 1.413 1.413.002 6.343-6.344-1.414-1.414zm7.617-7.616 1.414 1.414.407-.407a1 1 0 0 0-1.414-1.414z",
    clipRule: "evenodd"
  })));
};

var _path$2K, _path2$T;
function _extends$2L() { return _extends$2L = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2L.apply(null, arguments); }
var SvgSquareAndPencil32 = function SvgSquareAndPencil32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2L({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$2K || (_path$2K = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M9.067 6.2A2.867 2.867 0 0 0 6.2 9.067v13.867A2.867 2.867 0 0 0 9.067 25.8h13.866a2.867 2.867 0 0 0 2.867-2.866V16a1 1 0 0 1 2 0v6.934a4.867 4.867 0 0 1-4.867 4.866H9.067A4.867 4.867 0 0 1 4.2 22.934V9.067A4.867 4.867 0 0 1 9.067 4.2H16a1 1 0 0 1 0 2z",
    clipRule: "evenodd"
  })), _path2$T || (_path2$T = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M12.387 15.032a1 1 0 0 1 .293-.708l11.05-11.05a3.533 3.533 0 0 1 4.996 4.997l-11.05 11.05a1 1 0 0 1-.708.292l-3.578-.004a1 1 0 0 1-.999-.999zm2 .412.003 2.166 2.166.003 8.658-8.658-2.168-2.169zM24.46 5.373l2.168 2.168.684-.683a1.533 1.533 0 0 0-2.169-2.169z",
    clipRule: "evenodd"
  })));
};

var _path$2J, _path2$S;
function _extends$2K() { return _extends$2K = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2K.apply(null, arguments); }
var SvgSquareAndPencil48 = function SvgSquareAndPencil48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2K({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$2J || (_path$2J = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M13.6 9A4.6 4.6 0 0 0 9 13.6v20.8a4.6 4.6 0 0 0 4.6 4.6h20.8a4.6 4.6 0 0 0 4.6-4.6V24a1.2 1.2 0 0 1 2.4 0v10.4a7 7 0 0 1-7 7H13.6a7 7 0 0 1-7-7V13.6a7 7 0 0 1 7-7H24A1.2 1.2 0 0 1 24 9z",
    clipRule: "evenodd"
  })), _path2$S || (_path2$S = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M18.88 22.547a1.2 1.2 0 0 1 .352-.85L35.806 5.123a5 5 0 0 1 7.071 7.07L26.303 28.769a1.2 1.2 0 0 1-.85.352l-5.368-.007a1.2 1.2 0 0 1-1.198-1.199zm2.4.495.005 3.672 3.673.005 13.288-13.288-3.677-3.677zM36.267 8.057l3.677 3.677 1.237-1.237a2.6 2.6 0 1 0-3.677-3.677z",
    clipRule: "evenodd"
  })));
};

var SquareAndPencilIcon = function SquareAndPencilIcon(props) {
  var squareAndPencil = {
    12: SvgSquareAndPencil12,
    16: SvgSquareAndPencil16,
    18: SvgSquareAndPencil18,
    24: SvgSquareAndPencil24,
    32: SvgSquareAndPencil32,
    48: SvgSquareAndPencil48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: squareAndPencil
  }, props));
};

var _path$2I, _path2$R;
function _extends$2J() { return _extends$2J = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2J.apply(null, arguments); }
var SvgStackedImages12 = function SvgStackedImages12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2J({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$2I || (_path$2I = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M7.6 2.4H3a.3.3 0 0 0-.3.3v4.6a.3.3 0 0 0 .3.3h4.6a.3.3 0 0 0 .3-.3V2.7a.3.3 0 0 0-.3-.3M3 1.2a1.5 1.5 0 0 0-1.5 1.5v4.6A1.5 1.5 0 0 0 3 8.8h4.6a1.5 1.5 0 0 0 1.5-1.5V2.7a1.5 1.5 0 0 0-1.5-1.5z",
    clipRule: "evenodd"
  })), _path2$R || (_path2$R = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M10.5 2.6a.6.6 0 0 1 .6.6v4.45a3.15 3.15 0 0 1-3.15 3.15H3.5a.6.6 0 0 1 0-1.2h4.45A1.95 1.95 0 0 0 9.9 7.65V3.2a.6.6 0 0 1 .6-.6",
    clipRule: "evenodd"
  })));
};

var _path$2H, _path2$Q;
function _extends$2I() { return _extends$2I = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2I.apply(null, arguments); }
var SvgStackedImages16 = function SvgStackedImages16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2I({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$2H || (_path$2H = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M10.5 3.125H4a.5.5 0 0 0-.5.5v6.5a.5.5 0 0 0 .5.5h6.5a.5.5 0 0 0 .5-.5v-6.5a.5.5 0 0 0-.5-.5M4 1.625a2 2 0 0 0-2 2v6.5a2 2 0 0 0 2 2h6.5a2 2 0 0 0 2-2v-6.5a2 2 0 0 0-2-2z",
    clipRule: "evenodd"
  })), _path2$Q || (_path2$Q = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M14 3.875a.75.75 0 0 1 .75.75v6a3.75 3.75 0 0 1-3.75 3.75H5a.75.75 0 0 1 0-1.5h6a2.25 2.25 0 0 0 2.25-2.25v-6a.75.75 0 0 1 .75-.75",
    clipRule: "evenodd"
  })));
};

var _path$2G, _path2$P;
function _extends$2H() { return _extends$2H = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2H.apply(null, arguments); }
var SvgStackedImages18 = function SvgStackedImages18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2H({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$2G || (_path$2G = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M11.55 3.45h-6.8a.9.9 0 0 0-.9.9v6.8a.9.9 0 0 0 .9.9h6.8a.9.9 0 0 0 .9-.9v-6.8a.9.9 0 0 0-.9-.9m-6.8-1.6a2.5 2.5 0 0 0-2.5 2.5v6.8a2.5 2.5 0 0 0 2.5 2.5h6.8a2.5 2.5 0 0 0 2.5-2.5v-6.8a2.5 2.5 0 0 0-2.5-2.5z",
    clipRule: "evenodd"
  })), _path2$P || (_path2$P = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M15.75 4.05a.8.8 0 0 1 .8.8v7a4.3 4.3 0 0 1-4.3 4.3h-7a.8.8 0 0 1 0-1.6h7a2.7 2.7 0 0 0 2.7-2.7v-7a.8.8 0 0 1 .8-.8",
    clipRule: "evenodd"
  })));
};

var _path$2F, _path2$O;
function _extends$2G() { return _extends$2G = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2G.apply(null, arguments); }
var SvgStackedImages24 = function SvgStackedImages24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2G({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$2F || (_path$2F = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M16 4.35H6a1.2 1.2 0 0 0-1.2 1.2v10a1.2 1.2 0 0 0 1.2 1.2h10a1.2 1.2 0 0 0 1.2-1.2v-10a1.2 1.2 0 0 0-1.2-1.2M6 2.55a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3v-10a3 3 0 0 0-3-3z",
    clipRule: "evenodd"
  })), _path2$O || (_path2$O = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M21 5.65a.9.9 0 0 1 .9.9v9.5a5.4 5.4 0 0 1-5.4 5.4H7a.9.9 0 1 1 0-1.8h9.5a3.6 3.6 0 0 0 3.6-3.6v-9.5a.9.9 0 0 1 .9-.9",
    clipRule: "evenodd"
  })));
};

var _path$2E, _path2$N;
function _extends$2F() { return _extends$2F = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2F.apply(null, arguments); }
var SvgStackedImages32 = function SvgStackedImages32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2F({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$2E || (_path$2E = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M21.5 5.5H8a2 2 0 0 0-2 2V21a2 2 0 0 0 2 2h13.5a2 2 0 0 0 2-2V7.5a2 2 0 0 0-2-2M8 3.5a4 4 0 0 0-4 4V21a4 4 0 0 0 4 4h13.5a4 4 0 0 0 4-4V7.5a4 4 0 0 0-4-4z",
    clipRule: "evenodd"
  })), _path2$N || (_path2$N = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M28 8.5a1 1 0 0 1 1 1v12a7 7 0 0 1-7 7H10a1 1 0 1 1 0-2h12a5 5 0 0 0 5-5v-12a1 1 0 0 1 1-1",
    clipRule: "evenodd"
  })));
};

var _path$2D, _path2$M;
function _extends$2E() { return _extends$2E = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2E.apply(null, arguments); }
var SvgStackedImages48 = function SvgStackedImages48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2E({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$2D || (_path$2D = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M32 8.3H12a3.6 3.6 0 0 0-3.6 3.6v20a3.6 3.6 0 0 0 3.6 3.6h20a3.6 3.6 0 0 0 3.6-3.6v-20A3.6 3.6 0 0 0 32 8.3M12 5.9a6 6 0 0 0-6 6v20a6 6 0 0 0 6 6h20a6 6 0 0 0 6-6v-20a6 6 0 0 0-6-6z",
    clipRule: "evenodd"
  })), _path2$M || (_path2$M = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M41 11.7a1.2 1.2 0 0 1 1.2 1.2v20a9.2 9.2 0 0 1-9.2 9.2H13a1.2 1.2 0 1 1 0-2.4h20a6.8 6.8 0 0 0 6.8-6.8v-20a1.2 1.2 0 0 1 1.2-1.2",
    clipRule: "evenodd"
  })));
};

var StackedImagesIcon = function StackedImagesIcon(props) {
  var stackedImages = {
    12: SvgStackedImages12,
    16: SvgStackedImages16,
    18: SvgStackedImages18,
    24: SvgStackedImages24,
    32: SvgStackedImages32,
    48: SvgStackedImages48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: stackedImages
  }, props));
};

var _path$2C, _path2$L;
function _extends$2D() { return _extends$2D = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2D.apply(null, arguments); }
var SvgStackedImagesFilled12 = function SvgStackedImagesFilled12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2D({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$2C || (_path$2C = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M1.5 2.7A1.5 1.5 0 0 1 3 1.2h4.6a1.5 1.5 0 0 1 1.5 1.5v4.6a1.5 1.5 0 0 1-1.5 1.5H3a1.5 1.5 0 0 1-1.5-1.5z"
  })), _path2$L || (_path2$L = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M10.5 2.6a.6.6 0 0 1 .6.6v4.5A3.1 3.1 0 0 1 8 10.8H3.5a.6.6 0 0 1 0-1.2H8a1.9 1.9 0 0 0 1.9-1.9V3.2a.6.6 0 0 1 .6-.6",
    clipRule: "evenodd"
  })));
};

var _path$2B, _path2$K;
function _extends$2C() { return _extends$2C = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2C.apply(null, arguments); }
var SvgStackedImagesFilled16 = function SvgStackedImagesFilled16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2C({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$2B || (_path$2B = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M2 3.625a2 2 0 0 1 2-2h6.5a2 2 0 0 1 2 2v6.5a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2z"
  })), _path2$K || (_path2$K = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M14 3.875a.75.75 0 0 1 .75.75v6a3.75 3.75 0 0 1-3.75 3.75H5a.75.75 0 0 1 0-1.5h6a2.25 2.25 0 0 0 2.25-2.25v-6a.75.75 0 0 1 .75-.75",
    clipRule: "evenodd"
  })));
};

var _path$2A, _path2$J;
function _extends$2B() { return _extends$2B = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2B.apply(null, arguments); }
var SvgStackedImagesFilled18 = function SvgStackedImagesFilled18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2B({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$2A || (_path$2A = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M2.25 4.35a2.5 2.5 0 0 1 2.5-2.5h6.8a2.5 2.5 0 0 1 2.5 2.5v6.8a2.5 2.5 0 0 1-2.5 2.5h-6.8a2.5 2.5 0 0 1-2.5-2.5z"
  })), _path2$J || (_path2$J = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M15.75 4.05a.8.8 0 0 1 .8.8v7a4.3 4.3 0 0 1-4.3 4.3h-7a.8.8 0 0 1 0-1.6h7a2.7 2.7 0 0 0 2.7-2.7v-7a.8.8 0 0 1 .8-.8",
    clipRule: "evenodd"
  })));
};

var _path$2z, _path2$I;
function _extends$2A() { return _extends$2A = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2A.apply(null, arguments); }
var SvgStackedImagesFilled24 = function SvgStackedImagesFilled24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2A({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$2z || (_path$2z = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M3 5.55a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3z"
  })), _path2$I || (_path2$I = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M21 5.65a.9.9 0 0 1 .9.9v9.5a5.4 5.4 0 0 1-5.4 5.4H7a.9.9 0 1 1 0-1.8h9.5a3.6 3.6 0 0 0 3.6-3.6v-9.5a.9.9 0 0 1 .9-.9",
    clipRule: "evenodd"
  })));
};

var _path$2y, _path2$H;
function _extends$2z() { return _extends$2z = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2z.apply(null, arguments); }
var SvgStackedImagesFilled32 = function SvgStackedImagesFilled32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2z({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$2y || (_path$2y = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M4 7.5a4 4 0 0 1 4-4h13.5a4 4 0 0 1 4 4V21a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4z"
  })), _path2$H || (_path2$H = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M28 8.5a1 1 0 0 1 1 1v12a7 7 0 0 1-7 7H10a1 1 0 1 1 0-2h12a5 5 0 0 0 5-5v-12a1 1 0 0 1 1-1",
    clipRule: "evenodd"
  })));
};

var _path$2x, _path2$G;
function _extends$2y() { return _extends$2y = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2y.apply(null, arguments); }
var SvgStackedImagesFilled48 = function SvgStackedImagesFilled48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2y({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$2x || (_path$2x = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M6 11.9a6 6 0 0 1 6-6h20a6 6 0 0 1 6 6v20a6 6 0 0 1-6 6H12a6 6 0 0 1-6-6z"
  })), _path2$G || (_path2$G = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M41 11.7a1.2 1.2 0 0 1 1.2 1.2v20a9.2 9.2 0 0 1-9.2 9.2H13a1.2 1.2 0 0 1 0-2.4h20a6.8 6.8 0 0 0 6.8-6.8v-20a1.2 1.2 0 0 1 1.2-1.2",
    clipRule: "evenodd"
  })));
};

var StackedImagesFilledIcon = function StackedImagesFilledIcon(props) {
  var stackedImagesFilled = {
    12: SvgStackedImagesFilled12,
    16: SvgStackedImagesFilled16,
    18: SvgStackedImagesFilled18,
    24: SvgStackedImagesFilled24,
    32: SvgStackedImagesFilled32,
    48: SvgStackedImagesFilled48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: stackedImagesFilled
  }, props));
};

var _path$2w;
function _extends$2x() { return _extends$2x = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2x.apply(null, arguments); }
var SvgStar12 = function SvgStar12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2x({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$2w || (_path$2w = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M4.987 1.852c.38-.895 1.647-.895 2.026 0l.855 2.016 2.127.236c.931.104 1.315 1.248.636 1.892L9.004 7.538l.449 2.226c.19.94-.83 1.655-1.649 1.158L6 9.828l-1.804 1.094c-.82.497-1.838-.219-1.649-1.158l.45-2.226-1.628-1.542c-.68-.644-.295-1.788.636-1.892l2.127-.236zM6 2.537l-.786 1.854a1.1 1.1 0 0 1-.891.664l-1.972.218 1.51 1.432a1.1 1.1 0 0 1 .322 1.016L3.77 9.778l1.66-1.008a1.1 1.1 0 0 1 1.141 0l1.662 1.008-.415-2.057a1.1 1.1 0 0 1 .321-1.016l1.51-1.432-1.97-.218a1.1 1.1 0 0 1-.892-.664z",
    clipRule: "evenodd"
  })));
};

var _path$2v;
function _extends$2w() { return _extends$2w = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2w.apply(null, arguments); }
var SvgStar16 = function SvgStar16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2w({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$2v || (_path$2v = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M6.617 2.334c.546-1.225 2.285-1.225 2.832 0l1.153 2.587a.05.05 0 0 0 .04.03l2.818.297c1.334.14 1.871 1.795.875 2.693L12.23 9.837a.05.05 0 0 0-.015.048l.588 2.771c.278 1.313-1.129 2.335-2.291 1.665l-2.454-1.416a.05.05 0 0 0-.05 0l-2.454 1.416c-1.162.67-2.57-.352-2.29-1.665l.587-2.771a.05.05 0 0 0-.015-.048L1.73 7.941c-.996-.898-.459-2.552.875-2.693l2.817-.297a.05.05 0 0 0 .04-.03zm1.38.593-.01.018-1.153 2.587a1.55 1.55 0 0 1-1.253.91l-2.817.298-.02.004-.007.004a.1.1 0 0 0-.016.026.1.1 0 0 0-.002.03q0 .004.003.007l.013.016L4.84 8.723c.41.37.593.932.478 1.473l-.587 2.771-.002.021.001.007a.1.1 0 0 0 .02.023.1.1 0 0 0 .028.012h.007l.02-.009 2.454-1.415a1.55 1.55 0 0 1 1.548 0l2.454 1.415.02.008.007.001a.1.1 0 0 0 .028-.012.1.1 0 0 0 .02-.023l.001-.007-.002-.02-.588-2.772a1.55 1.55 0 0 1 .48-1.473l2.104-1.896.013-.016.003-.007a.1.1 0 0 0-.002-.03.1.1 0 0 0-.016-.026l-.006-.004-.02-.004-2.818-.298a1.55 1.55 0 0 1-1.253-.91L8.079 2.945l-.011-.018-.006-.005a.1.1 0 0 0-.03-.007.1.1 0 0 0-.028.007z",
    clipRule: "evenodd"
  })));
};

var _path$2u;
function _extends$2v() { return _extends$2v = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2v.apply(null, arguments); }
var SvgStar18 = function SvgStar18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2v({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$2u || (_path$2u = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M7.356 2.723c.634-1.422 2.654-1.422 3.288 0l1.2 2.693a.2.2 0 0 0 .162.117l2.93.31c1.55.163 2.174 2.084 1.017 3.127l-2.19 1.973a.2.2 0 0 0-.061.19l.611 2.883c.323 1.524-1.31 2.711-2.66 1.933L9.1 14.476a.2.2 0 0 0-.2 0L6.347 15.95c-1.35.778-2.984-.409-2.66-1.933l.611-2.883a.2.2 0 0 0-.061-.19L2.047 8.97C.89 7.927 1.514 6.006 3.063 5.842l2.931-.309a.2.2 0 0 0 .162-.117zm1.827.652a.2.2 0 0 0-.366 0l-1.2 2.692a1.8 1.8 0 0 1-1.455 1.057l-2.931.31a.2.2 0 0 0-.113.347l2.19 1.973a1.8 1.8 0 0 1 .555 1.71l-.611 2.884a.2.2 0 0 0 .295.215l2.554-1.473a1.8 1.8 0 0 1 1.798 0l2.554 1.473a.2.2 0 0 0 .295-.215l-.611-2.883a1.8 1.8 0 0 1 .555-1.71l2.19-1.974a.2.2 0 0 0-.113-.347l-2.931-.31a1.8 1.8 0 0 1-1.455-1.057z",
    clipRule: "evenodd"
  })));
};

var _path$2t;
function _extends$2u() { return _extends$2u = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2u.apply(null, arguments); }
var SvgStar24 = function SvgStar24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2u({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$2t || (_path$2t = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M10.265 3.933c.67-1.502 2.801-1.502 3.47 0l1.753 3.931a.1.1 0 0 0 .08.059l4.282.452c1.635.172 2.294 2.2 1.072 3.3l-3.198 2.882a.1.1 0 0 0-.03.095l.893 4.211c.34 1.609-1.384 2.862-2.808 2.04l-3.729-2.15a.1.1 0 0 0-.1 0l-3.729 2.15c-1.424.822-3.149-.431-2.808-2.04l.894-4.21a.1.1 0 0 0-.031-.096l-3.198-2.881c-1.222-1.101-.563-3.129 1.073-3.301l4.28-.452a.1.1 0 0 0 .081-.059zm1.679.687c-.009.005-.022.015-.035.045l-1.753 3.932A1.9 1.9 0 0 1 8.62 9.713l-4.28.452c-.033.003-.047.013-.054.02a.1.1 0 0 0-.031.048.1.1 0 0 0-.004.058c.002.01.008.025.032.048l3.198 2.881a1.9 1.9 0 0 1 .586 1.806l-.893 4.21c-.007.033-.002.049.002.058q.007.021.037.044.031.022.054.022c.01 0 .026 0 .055-.016l3.729-2.15a1.9 1.9 0 0 1 1.898 0l3.73 2.15c.028.017.044.017.054.016a.1.1 0 0 0 .054-.022.1.1 0 0 0 .037-.044c.004-.01.009-.025.002-.057l-.893-4.211a1.9 1.9 0 0 1 .587-1.806l3.197-2.881c.025-.023.03-.038.032-.048a.1.1 0 0 0-.004-.058.1.1 0 0 0-.03-.049c-.008-.006-.022-.016-.054-.02l-4.281-.451a1.9 1.9 0 0 1-1.536-1.116L12.09 4.665c-.013-.03-.026-.04-.034-.045A.1.1 0 0 0 12 4.606a.1.1 0 0 0-.056.014",
    clipRule: "evenodd"
  })));
};

var _path$2s;
function _extends$2t() { return _extends$2t = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2t.apply(null, arguments); }
var SvgStar32 = function SvgStar32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2t({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$2s || (_path$2s = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M13.686 5.244c.893-2.003 3.735-2.003 4.628 0l2.337 5.242c.019.043.06.073.107.078l5.708.602c2.18.23 3.059 2.934 1.43 4.402l-4.264 3.842a.13.13 0 0 0-.04.127l1.19 5.614c.455 2.145-1.844 3.816-3.744 2.72l-4.971-2.867a.13.13 0 0 0-.134 0l-4.971 2.867c-1.9 1.096-4.2-.575-3.744-2.72l1.19-5.614a.13.13 0 0 0-.04-.127l-4.264-3.842c-1.629-1.468-.75-4.171 1.43-4.402l5.708-.602a.13.13 0 0 0 .107-.078zm2.239.917c-.011.006-.029.02-.047.06l-2.337 5.242a2.53 2.53 0 0 1-2.048 1.488l-5.707.602c-.044.005-.062.017-.072.026a.15.15 0 0 0-.041.066.14.14 0 0 0-.005.077c.003.013.01.033.042.063l4.264 3.842c.672.605.97 1.523.782 2.408l-1.19 5.614c-.01.043-.003.064.002.076.007.017.023.04.05.06.026.02.053.027.072.029.012 0 .034 0 .072-.022l4.972-2.867a2.53 2.53 0 0 1 2.532 0l4.971 2.867c.038.022.06.022.073.021a.15.15 0 0 0 .072-.028.14.14 0 0 0 .05-.06c.005-.012.012-.033.002-.076l-1.19-5.614a2.53 2.53 0 0 1 .782-2.408l4.263-3.842c.033-.03.04-.05.043-.063a.14.14 0 0 0-.005-.077.15.15 0 0 0-.042-.066c-.01-.009-.027-.021-.07-.026l-5.709-.602a2.53 2.53 0 0 1-2.048-1.488L16.122 6.22c-.018-.04-.036-.054-.047-.06A.15.15 0 0 0 16 6.14c-.033 0-.06.01-.075.02",
    clipRule: "evenodd"
  })));
};

var _path$2r;
function _extends$2s() { return _extends$2s = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2s.apply(null, arguments); }
var SvgStar48 = function SvgStar48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2s({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$2r || (_path$2r = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M21.077 5.11c1.128-2.53 4.718-2.53 5.846 0l4.334 9.722a.8.8 0 0 0 .646.47l10.586 1.117c2.755.291 3.864 3.706 1.807 5.56l-7.908 7.126a.8.8 0 0 0-.247.76l2.209 10.413c.575 2.71-2.33 4.82-4.73 3.436l-9.22-5.318a.8.8 0 0 0-.8 0l-9.22 5.318c-2.4 1.384-5.304-.727-4.73-3.436l2.209-10.413a.8.8 0 0 0-.247-.76l-7.908-7.126c-2.057-1.854-.947-5.269 1.807-5.56l10.586-1.117a.8.8 0 0 0 .646-.47zm3.654.977a.8.8 0 0 0-1.462 0l-4.333 9.722a3.2 3.2 0 0 1-2.587 1.88L5.763 18.806a.8.8 0 0 0-.452 1.39l7.908 7.126a3.2 3.2 0 0 1 .988 3.041l-2.209 10.413a.8.8 0 0 0 1.182.86l9.221-5.32a3.2 3.2 0 0 1 3.198 0l9.22 5.32a.8.8 0 0 0 1.183-.86l-2.209-10.413a3.2 3.2 0 0 1 .989-3.04l7.907-7.127a.8.8 0 0 0-.452-1.39l-10.586-1.117a3.2 3.2 0 0 1-2.586-1.88z",
    clipRule: "evenodd"
  })));
};

var StarIcon = function StarIcon(props) {
  var star = {
    12: SvgStar12,
    16: SvgStar16,
    18: SvgStar18,
    24: SvgStar24,
    32: SvgStar32,
    48: SvgStar48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: star
  }, props));
};

var _path$2q, _path2$F;
function _extends$2r() { return _extends$2r = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2r.apply(null, arguments); }
var SvgStarFilled12 = function SvgStarFilled12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2r({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$2q || (_path$2q = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M5.54 2.086a.5.5 0 0 1 .92 0l.878 2.07a.5.5 0 0 0 .405.302l2.186.243a.5.5 0 0 1 .289.86L8.551 7.14a.5.5 0 0 0-.146.461l.46 2.28a.5.5 0 0 1-.75.527L6.26 9.283a.5.5 0 0 0-.518 0L3.885 10.41a.5.5 0 0 1-.75-.526l.46-2.28a.5.5 0 0 0-.146-.463L1.782 5.56a.5.5 0 0 1 .289-.86l2.186-.242a.5.5 0 0 0 .405-.301z"
  })), _path2$F || (_path2$F = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M4.987 1.852c.38-.894 1.647-.894 2.026 0l.855 2.016 2.127.237c.931.103 1.315 1.247.636 1.891L9.004 7.538l.449 2.226c.19.94-.83 1.655-1.649 1.158L6 9.828l-1.804 1.094c-.82.497-1.838-.219-1.649-1.158l.45-2.226-1.628-1.542c-.68-.644-.295-1.788.636-1.891l2.127-.237zM6 2.537l-.786 1.854a1.1 1.1 0 0 1-.891.664l-1.972.219 1.51 1.43a1.1 1.1 0 0 1 .322 1.017L3.77 9.778l1.66-1.008a1.1 1.1 0 0 1 1.141 0l1.662 1.008-.415-2.057a1.1 1.1 0 0 1 .321-1.016l1.51-1.431-1.97-.22a1.1 1.1 0 0 1-.892-.663z",
    clipRule: "evenodd"
  })));
};

var _path$2p, _path2$E;
function _extends$2q() { return _extends$2q = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2q.apply(null, arguments); }
var SvgStarFilled16 = function SvgStarFilled16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2q({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$2p || (_path$2p = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M7.302 2.64a.8.8 0 0 1 1.462 0l1.153 2.587a.8.8 0 0 0 .647.47l2.817.297a.8.8 0 0 1 .452 1.39L11.728 9.28a.8.8 0 0 0-.247.76l.588 2.772a.8.8 0 0 1-1.182.859l-2.454-1.415a.8.8 0 0 0-.8 0L5.18 13.67a.8.8 0 0 1-1.182-.859l.588-2.771a.8.8 0 0 0-.247-.76L2.233 7.383a.8.8 0 0 1 .452-1.39l2.817-.297a.8.8 0 0 0 .647-.47z"
  })), _path2$E || (_path2$E = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M6.617 2.334c.546-1.225 2.285-1.225 2.832 0l1.153 2.588a.05.05 0 0 0 .04.029l2.818.297c1.334.141 1.871 1.795.875 2.693L12.23 9.838a.05.05 0 0 0-.015.047l.588 2.771c.278 1.313-1.129 2.335-2.291 1.665l-2.454-1.416a.05.05 0 0 0-.05 0l-2.454 1.416c-1.162.67-2.57-.352-2.29-1.665l.587-2.77a.05.05 0 0 0-.015-.048L1.73 7.94c-.996-.898-.459-2.552.875-2.693l2.817-.297a.05.05 0 0 0 .04-.03zm1.38.593-.01.018-1.153 2.587a1.55 1.55 0 0 1-1.253.91l-2.817.298-.02.005-.007.003a.1.1 0 0 0-.016.026.1.1 0 0 0-.002.03q0 .004.003.007l.013.016L4.84 8.723c.41.37.593.932.478 1.473l-.587 2.772-.002.02.001.008a.1.1 0 0 0 .02.022.1.1 0 0 0 .028.012h.007l.02-.009 2.454-1.415a1.55 1.55 0 0 1 1.548 0l2.454 1.415.02.009h.007a.1.1 0 0 0 .028-.011.1.1 0 0 0 .02-.023l.001-.008-.002-.02-.588-2.772a1.55 1.55 0 0 1 .48-1.473l2.104-1.896.013-.016.003-.007a.1.1 0 0 0-.002-.03.1.1 0 0 0-.016-.026l-.006-.003-.02-.005-2.818-.297a1.55 1.55 0 0 1-1.253-.91L8.079 2.944l-.011-.018-.006-.005a.1.1 0 0 0-.03-.007.1.1 0 0 0-.028.007z",
    clipRule: "evenodd"
  })));
};

var _path$2o, _path2$D;
function _extends$2p() { return _extends$2p = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2p.apply(null, arguments); }
var SvgStarFilled18 = function SvgStarFilled18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2p({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$2o || (_path$2o = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M8.087 3.05c.352-.791 1.474-.791 1.826 0l1.2 2.691a1 1 0 0 0 .809.588l2.931.309c.86.09 1.207 1.158.565 1.737l-2.19 1.973a1 1 0 0 0-.309.95l.612 2.884c.18.847-.728 1.506-1.478 1.074L9.5 13.783a1 1 0 0 0-1 0l-2.553 1.473c-.75.432-1.657-.227-1.478-1.074l.612-2.883a1 1 0 0 0-.309-.95l-2.19-1.974c-.642-.58-.296-1.646.565-1.737l2.931-.31a1 1 0 0 0 .809-.587z"
  })), _path2$D || (_path2$D = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M7.356 2.723c.634-1.422 2.654-1.422 3.288 0l1.2 2.693a.2.2 0 0 0 .162.117l2.93.31c1.55.163 2.174 2.084 1.017 3.127l-2.19 1.973a.2.2 0 0 0-.061.19l.611 2.883c.323 1.524-1.31 2.711-2.66 1.933L9.1 14.476a.2.2 0 0 0-.2 0L6.347 15.95c-1.35.778-2.984-.409-2.66-1.933l.611-2.883a.2.2 0 0 0-.061-.19L2.047 8.97C.89 7.927 1.514 6.006 3.063 5.842l2.931-.309a.2.2 0 0 0 .162-.117zm1.827.652a.2.2 0 0 0-.366 0l-1.2 2.692a1.8 1.8 0 0 1-1.455 1.057l-2.931.31a.2.2 0 0 0-.113.347l2.19 1.973a1.8 1.8 0 0 1 .555 1.71l-.611 2.884a.2.2 0 0 0 .295.215l2.554-1.473a1.8 1.8 0 0 1 1.798 0l2.554 1.473a.2.2 0 0 0 .295-.215l-.611-2.883a1.8 1.8 0 0 1 .555-1.71l2.19-1.974a.2.2 0 0 0-.113-.347l-2.931-.31a1.8 1.8 0 0 1-1.455-1.057z",
    clipRule: "evenodd"
  })));
};

var _path$2n, _path2$C;
function _extends$2o() { return _extends$2o = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2o.apply(null, arguments); }
var SvgStarFilled24 = function SvgStarFilled24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2o({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$2n || (_path$2n = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M11.087 4.299c.352-.79 1.474-.79 1.826 0l1.753 3.932a1 1 0 0 0 .808.587l4.281.452c.86.09 1.207 1.158.565 1.737l-3.198 2.882a1 1 0 0 0-.309.95l.893 4.211c.18.847-.728 1.506-1.477 1.074l-3.73-2.15a1 1 0 0 0-.999 0l-3.728 2.15c-.75.432-1.658-.227-1.478-1.074l.893-4.21a1 1 0 0 0-.309-.951L3.68 11.007c-.642-.58-.296-1.646.565-1.737l4.28-.452a1 1 0 0 0 .81-.587z"
  })), _path2$C || (_path2$C = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M10.265 3.933c.67-1.502 2.801-1.502 3.47 0l1.753 3.931a.1.1 0 0 0 .08.059l4.282.452c1.635.172 2.294 2.2 1.072 3.3l-3.198 2.882a.1.1 0 0 0-.03.095l.893 4.211c.34 1.609-1.384 2.862-2.808 2.04l-3.729-2.15a.1.1 0 0 0-.1 0l-3.729 2.15c-1.424.822-3.149-.431-2.808-2.04l.894-4.21a.1.1 0 0 0-.031-.096l-3.198-2.881c-1.222-1.101-.563-3.129 1.073-3.301l4.28-.452a.1.1 0 0 0 .081-.059zm1.679.687c-.009.005-.022.015-.035.045l-1.753 3.932A1.9 1.9 0 0 1 8.62 9.713l-4.28.452c-.033.003-.047.013-.054.02a.1.1 0 0 0-.031.048.1.1 0 0 0-.004.058c.002.01.008.025.032.048l3.198 2.881a1.9 1.9 0 0 1 .586 1.806l-.893 4.21c-.007.033-.002.049.002.058q.007.021.037.044.031.022.054.022c.01 0 .026 0 .055-.016l3.729-2.15a1.9 1.9 0 0 1 1.898 0l3.73 2.15c.028.017.044.017.054.016a.1.1 0 0 0 .054-.022.1.1 0 0 0 .037-.044c.004-.01.009-.025.002-.057l-.893-4.211a1.9 1.9 0 0 1 .587-1.806l3.197-2.881c.025-.023.03-.038.032-.048a.1.1 0 0 0-.004-.058.1.1 0 0 0-.03-.049c-.008-.006-.022-.016-.054-.02l-4.281-.451a1.9 1.9 0 0 1-1.536-1.116L12.09 4.665c-.013-.03-.026-.04-.034-.045A.1.1 0 0 0 12 4.606a.1.1 0 0 0-.056.014",
    clipRule: "evenodd"
  })));
};

var _path$2m, _path2$B;
function _extends$2n() { return _extends$2n = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2n.apply(null, arguments); }
var SvgStarFilled32 = function SvgStarFilled32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2n({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$2m || (_path$2m = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M14.782 5.732c.47-1.054 1.966-1.054 2.436 0l2.336 5.242c.194.435.605.733 1.078.784l5.708.602c1.148.121 1.61 1.544.753 2.316l-4.264 3.843c-.353.318-.51.801-.412 1.267l1.191 5.614c.24 1.13-.97 2.008-1.97 1.432l-4.972-2.868a1.33 1.33 0 0 0-1.332 0l-4.972 2.868c-1 .576-2.21-.303-1.97-1.432l1.19-5.614a1.33 1.33 0 0 0-.411-1.267l-4.264-3.843c-.857-.772-.395-2.195.753-2.316l5.708-.602c.473-.05.884-.349 1.077-.784z"
  })), _path2$B || (_path2$B = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M13.686 5.244c.893-2.003 3.735-2.003 4.628 0l2.337 5.242c.019.043.06.073.107.078l5.708.602c2.18.23 3.059 2.934 1.43 4.402l-4.264 3.842a.13.13 0 0 0-.04.127l1.19 5.614c.455 2.145-1.844 3.816-3.744 2.72l-4.971-2.867a.13.13 0 0 0-.134 0l-4.971 2.867c-1.9 1.096-4.2-.575-3.744-2.72l1.19-5.614a.13.13 0 0 0-.04-.127l-4.264-3.842c-1.629-1.468-.75-4.171 1.43-4.401l5.708-.603a.13.13 0 0 0 .107-.078zm2.239.917c-.011.007-.029.02-.047.06l-2.337 5.242a2.53 2.53 0 0 1-2.048 1.488l-5.707.602c-.044.005-.062.018-.072.026a.14.14 0 0 0-.041.066.14.14 0 0 0-.005.077c.003.013.01.034.042.063l4.264 3.842c.672.606.97 1.523.782 2.408l-1.19 5.614c-.01.043-.003.064.002.076.007.017.023.04.05.06.026.02.053.027.072.029.012 0 .034 0 .072-.022l4.972-2.867a2.53 2.53 0 0 1 2.532 0l4.971 2.867c.038.022.06.023.073.022a.14.14 0 0 0 .072-.03.14.14 0 0 0 .05-.059c.005-.012.012-.033.002-.076l-1.19-5.614a2.53 2.53 0 0 1 .782-2.408l4.263-3.842c.033-.03.04-.05.043-.063a.14.14 0 0 0-.005-.077.14.14 0 0 0-.042-.066c-.01-.008-.027-.021-.07-.026l-5.709-.602a2.53 2.53 0 0 1-2.048-1.488L16.122 6.22c-.018-.04-.036-.053-.047-.06A.14.14 0 0 0 16 6.14c-.033 0-.06.01-.075.02",
    clipRule: "evenodd"
  })));
};

var _path$2l, _path2$A;
function _extends$2m() { return _extends$2m = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2m.apply(null, arguments); }
var SvgStarFilled48 = function SvgStarFilled48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2m({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$2l || (_path$2l = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M22.173 5.598c.705-1.58 2.95-1.58 3.654 0l4.334 9.723a2 2 0 0 0 1.616 1.174l10.586 1.118c1.722.181 2.415 2.316 1.13 3.474l-7.908 7.127a2 2 0 0 0-.618 1.9l2.209 10.413c.36 1.694-1.456 3.012-2.956 2.148L25 37.356a2 2 0 0 0-2 0l-9.22 5.319c-1.5.864-3.315-.454-2.956-2.148l2.209-10.413a2 2 0 0 0-.618-1.9l-7.907-7.127c-1.286-1.158-.593-3.293 1.129-3.474l10.586-1.118a2 2 0 0 0 1.617-1.174z"
  })), _path2$A || (_path2$A = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M21.077 5.11c1.128-2.53 4.718-2.53 5.846 0l4.334 9.722a.8.8 0 0 0 .646.47l10.586 1.117c2.755.291 3.864 3.706 1.807 5.56l-7.908 7.126a.8.8 0 0 0-.247.76l2.209 10.413c.575 2.71-2.33 4.82-4.73 3.436l-9.22-5.318a.8.8 0 0 0-.8 0l-9.22 5.318c-2.4 1.384-5.304-.727-4.73-3.436l2.209-10.413a.8.8 0 0 0-.247-.76l-7.908-7.126c-2.057-1.854-.947-5.269 1.807-5.56l10.586-1.117a.8.8 0 0 0 .646-.47zm3.654.977a.8.8 0 0 0-1.462 0l-4.333 9.722a3.2 3.2 0 0 1-2.587 1.88L5.763 18.806a.8.8 0 0 0-.452 1.39l7.908 7.126a3.2 3.2 0 0 1 .988 3.041l-2.209 10.413a.8.8 0 0 0 1.182.86l9.221-5.32a3.2 3.2 0 0 1 3.198 0l9.22 5.32a.8.8 0 0 0 1.183-.86l-2.209-10.413a3.2 3.2 0 0 1 .989-3.04l7.907-7.127a.8.8 0 0 0-.452-1.39l-10.586-1.117a3.2 3.2 0 0 1-2.586-1.88z",
    clipRule: "evenodd"
  })));
};

var StarFilledIcon = function StarFilledIcon(props) {
  var starFilled = {
    12: SvgStarFilled12,
    16: SvgStarFilled16,
    18: SvgStarFilled18,
    24: SvgStarFilled24,
    32: SvgStarFilled32,
    48: SvgStarFilled48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: starFilled
  }, props));
};

var _path$2k;
function _extends$2l() { return _extends$2l = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2l.apply(null, arguments); }
var SvgStat12 = function SvgStat12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2l({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$2k || (_path$2k = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M3 5.9a.6.6 0 0 1 .6.6v3a.6.6 0 0 1-1.2 0v-3a.6.6 0 0 1 .6-.6M6 3.9a.6.6 0 0 1 .6.6v5a.6.6 0 0 1-1.2 0v-5a.6.6 0 0 1 .6-.6M9 1.9a.6.6 0 0 1 .6.6v7a.6.6 0 0 1-1.2 0v-7a.6.6 0 0 1 .6-.6",
    clipRule: "evenodd"
  })));
};

var _path$2j;
function _extends$2k() { return _extends$2k = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2k.apply(null, arguments); }
var SvgStat16 = function SvgStat16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2k({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$2j || (_path$2j = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M4 7.917a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0v-4a.75.75 0 0 1 .75-.75M8 5.25a.75.75 0 0 1 .75.75v6.667a.75.75 0 0 1-1.5 0V6A.75.75 0 0 1 8 5.25M12 2.584a.75.75 0 0 1 .75.75v9.333a.75.75 0 0 1-1.5 0V3.334a.75.75 0 0 1 .75-.75",
    clipRule: "evenodd"
  })));
};

var _path$2i;
function _extends$2j() { return _extends$2j = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2j.apply(null, arguments); }
var SvgStat18 = function SvgStat18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2j({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$2i || (_path$2i = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M4.5 8.95a.8.8 0 0 1 .8.8v4.5a.8.8 0 0 1-1.6 0v-4.5a.8.8 0 0 1 .8-.8M9 5.95a.8.8 0 0 1 .8.8v7.5a.8.8 0 0 1-1.6 0v-7.5a.8.8 0 0 1 .8-.8M13.5 2.95a.8.8 0 0 1 .8.8v10.5a.8.8 0 0 1-1.6 0V3.75a.8.8 0 0 1 .8-.8",
    clipRule: "evenodd"
  })));
};

var _path$2h;
function _extends$2i() { return _extends$2i = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2i.apply(null, arguments); }
var SvgStat24 = function SvgStat24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2i({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$2h || (_path$2h = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M6 12.1a.9.9 0 0 1 .9.9v6a.9.9 0 1 1-1.8 0v-6a.9.9 0 0 1 .9-.9M12 8.1a.9.9 0 0 1 .9.9v10a.9.9 0 1 1-1.8 0V9a.9.9 0 0 1 .9-.9M18 4.1a.9.9 0 0 1 .9.9v14a.9.9 0 1 1-1.8 0V5a.9.9 0 0 1 .9-.9",
    clipRule: "evenodd"
  })));
};

var _path$2g;
function _extends$2h() { return _extends$2h = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2h.apply(null, arguments); }
var SvgStat32 = function SvgStat32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2h({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$2g || (_path$2g = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8 16.333a1 1 0 0 1 1 1v8a1 1 0 1 1-2 0v-8a1 1 0 0 1 1-1M16 11a1 1 0 0 1 1 1v13.333a1 1 0 1 1-2 0V12a1 1 0 0 1 1-1M24 5.667a1 1 0 0 1 1 1v18.666a1 1 0 1 1-2 0V6.667a1 1 0 0 1 1-1",
    clipRule: "evenodd"
  })));
};

var _path$2f;
function _extends$2g() { return _extends$2g = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2g.apply(null, arguments); }
var SvgStat48 = function SvgStat48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2g({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$2f || (_path$2f = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M12 24.797a1.2 1.2 0 0 1 1.2 1.2v12a1.2 1.2 0 0 1-2.4 0v-12a1.2 1.2 0 0 1 1.2-1.2M24 16.799a1.2 1.2 0 0 1 1.2 1.2v20a1.2 1.2 0 1 1-2.4 0v-20a1.2 1.2 0 0 1 1.2-1.2M36 8.8a1.2 1.2 0 0 1 1.2 1.2v28a1.2 1.2 0 0 1-2.4 0V10A1.2 1.2 0 0 1 36 8.8",
    clipRule: "evenodd"
  })));
};

var StatIcon = function StatIcon(props) {
  var stat = {
    12: SvgStat12,
    16: SvgStat16,
    18: SvgStat18,
    24: SvgStat24,
    32: SvgStat32,
    48: SvgStat48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: stat
  }, props));
};

var _path$2e;
function _extends$2f() { return _extends$2f = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2f.apply(null, arguments); }
var SvgStore12 = function SvgStore12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2f({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$2e || (_path$2e = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M1.528 1.3a.727.727 0 0 0-.728.728V5c0 .772.398 1.452 1 1.844V8a2.7 2.7 0 0 0 2.7 2.7h3A2.7 2.7 0 0 0 10.2 8V6.844c.602-.392 1-1.072 1-1.844V2a.7.7 0 0 0-.7-.7H1.528M8.8 7.191a2.2 2.2 0 0 1-1.3-.582c-.393.367-.92.591-1.5.591s-1.107-.224-1.5-.59c-.347.323-.8.536-1.3.581V8a1.3 1.3 0 0 0 1.3 1.3h3A1.3 1.3 0 0 0 8.8 8zm-2-4.49V5a.8.8 0 1 1-1.6 0V2.7zM8.2 5V2.7h1.6V5a.8.8 0 1 1-1.6 0M3.8 2.7H2.2V5a.8.8 0 1 0 1.6 0z",
    clipRule: "evenodd"
  })));
};

var _path$2d;
function _extends$2e() { return _extends$2e = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2e.apply(null, arguments); }
var SvgStore16 = function SvgStore16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2e({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$2d || (_path$2d = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M2.037 1.867a.837.837 0 0 0-.837.836v3.964c0 1.008.533 1.892 1.333 2.385v1.615A3.467 3.467 0 0 0 6 14.133h4a3.467 3.467 0 0 0 3.467-3.466V9.052A2.8 2.8 0 0 0 14.8 6.667v-4a.8.8 0 0 0-.8-.8zm9.83 7.597A2.8 2.8 0 0 1 10 8.626a2.8 2.8 0 0 1-2 .84 2.8 2.8 0 0 1-2-.84 2.8 2.8 0 0 1-1.867.838v1.203c0 1.03.836 1.866 1.867 1.866h4a1.867 1.867 0 0 0 1.867-1.866zM12 7.867a1.2 1.2 0 0 1-1.2-1.2v-3.2h2.4v3.2a1.2 1.2 0 0 1-1.2 1.2m-5.2-4.4h2.4v3.2a1.2 1.2 0 0 1-2.4 0zm-1.6 0H2.8v3.2a1.2 1.2 0 0 0 2.4 0z",
    clipRule: "evenodd"
  })));
};

var _path$2c;
function _extends$2d() { return _extends$2d = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2d.apply(null, arguments); }
var SvgStore18 = function SvgStore18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2d({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$2c || (_path$2c = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M2.291 2.2a.84.84 0 0 0-.841.841V7.5c0 1.119.602 2.096 1.5 2.627V12a3.8 3.8 0 0 0 3.8 3.8h4.5a3.8 3.8 0 0 0 3.8-3.8v-1.873a3.05 3.05 0 0 0 1.5-2.627V3a.8.8 0 0 0-.8-.8zm11.159 8.35a3.04 3.04 0 0 1-2.2-.99c-.558.608-1.36.99-2.25.99s-1.692-.382-2.25-.99a3.04 3.04 0 0 1-2.2.99V12a2.2 2.2 0 0 0 2.2 2.2h4.5a2.2 2.2 0 0 0 2.2-2.2zm-3-6.75v3.7a1.45 1.45 0 0 1-2.9 0V3.8zm1.6 3.7V3.8h2.9v3.7a1.45 1.45 0 0 1-2.9 0m-6.1-3.7h-2.9v3.7a1.45 1.45 0 0 0 2.9 0z",
    clipRule: "evenodd"
  })));
};

var _path$2b;
function _extends$2c() { return _extends$2c = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2c.apply(null, arguments); }
var SvgStore24 = function SvgStore24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2c({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$2b || (_path$2b = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M3.055 3.1a.955.955 0 0 0-.955.955V10c0 1.464.807 2.74 2 3.407V17A3.9 3.9 0 0 0 8 20.9h8a3.9 3.9 0 0 0 3.9-3.9v-3.593a3.9 3.9 0 0 0 2-3.407V4a.9.9 0 0 0-.9-.9zM18.1 13.9l-.1.001a3.9 3.9 0 0 1-3-1.408 3.9 3.9 0 0 1-3 1.408 3.9 3.9 0 0 1-3-1.408A3.9 3.9 0 0 1 5.9 13.9V17c0 1.16.94 2.1 2.1 2.1h8a2.1 2.1 0 0 0 2.1-2.1zM18 12.1a2.1 2.1 0 0 1-2.1-2.1V4.9h4.2V10a2.1 2.1 0 0 1-2.1 2.1M9.9 4.9h4.2V10a2.1 2.1 0 1 1-4.2 0zm-1.8 0H3.9V10a2.1 2.1 0 1 0 4.2 0z",
    clipRule: "evenodd"
  })));
};

var _path$2a;
function _extends$2b() { return _extends$2b = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2b.apply(null, arguments); }
var SvgStore32 = function SvgStore32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2b({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$2a || (_path$2a = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M4.073 4.334C3.481 4.334 3 4.813 3 5.406v7.927a5 5 0 0 0 2.667 4.423v5.91a4 4 0 0 0 4 4h12.666a4 4 0 0 0 4-4v-5.91A5 5 0 0 0 29 13.333v-8a1 1 0 0 0-1-1zm20.26 13.989q-.165.01-.333.01a5 5 0 0 1-4-1.999 5 5 0 0 1-4 2 5 5 0 0 1-4-2 4.99 4.99 0 0 1-4.333 1.989v5.344a2 2 0 0 0 2 2h12.666a2 2 0 0 0 2-2zM19 6.333v7a3 3 0 1 1-6 0v-7zm2 7v-7h6v7a3 3 0 1 1-6 0m-10-7H5v7a3 3 0 1 0 6 0z",
    clipRule: "evenodd"
  })));
};

var _path$29;
function _extends$2a() { return _extends$2a = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2a.apply(null, arguments); }
var SvgStore48 = function SvgStore48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2a({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$29 || (_path$29 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M6.11 6.85a1.26 1.26 0 0 0-1.26 1.26V20a7.15 7.15 0 0 0 4 6.42V37A4.15 4.15 0 0 0 13 41.15h22A4.15 4.15 0 0 0 39.15 37V26.42a7.15 7.15 0 0 0 4-6.42V8A1.15 1.15 0 0 0 42 6.85zM36.85 27.1q-.418.05-.85.05a7.14 7.14 0 0 1-6-3.26 7.14 7.14 0 0 1-6 3.26 7.14 7.14 0 0 1-6-3.26 7.14 7.14 0 0 1-6.85 3.21V37A1.85 1.85 0 0 0 13 38.85h22A1.85 1.85 0 0 0 36.85 37zM36 24.85A4.85 4.85 0 0 1 31.15 20V9.15h9.7V20A4.85 4.85 0 0 1 36 24.85M19.15 9.15h9.7V20a4.85 4.85 0 1 1-9.7 0zm-2.3 0h-9.7V20a4.85 4.85 0 1 0 9.7 0z",
    clipRule: "evenodd"
  })));
};

var StoreIcon = function StoreIcon(props) {
  var store = {
    12: SvgStore12,
    16: SvgStore16,
    18: SvgStore18,
    24: SvgStore24,
    32: SvgStore32,
    48: SvgStore48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: store
  }, props));
};

var _path$28;
function _extends$29() { return _extends$29 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$29.apply(null, arguments); }
var SvgStoreFilled12 = function SvgStoreFilled12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$29({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$28 || (_path$28 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "m9.422 6.435-.022.003h-.003zM2 2.1h2.076v2.562a1.238 1.238 0 1 1-2.476 0V2.5c0-.22.18-.4.4-.4m2.762 0h2.476v2.562a1.238 1.238 0 0 1-2.476 0zm3.162 0H10c.221 0 .4.18.4.4v2.162a1.238 1.238 0 0 1-2.476 0zm1.238 4.455q.12 0 .238-.016V8.63a1.4 1.4 0 0 1-1.4 1.4H4a1.4 1.4 0 0 1-1.4-1.4V6.54q.117.015.238.015c.693 0 1.293-.4 1.58-.982a1.763 1.763 0 0 0 3.163 0c.288.582.888.982 1.581.982",
    clipRule: "evenodd"
  })));
};

var _path$27, _path2$z;
function _extends$28() { return _extends$28 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$28.apply(null, arguments); }
var SvgStoreFilled16 = function SvgStoreFilled16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$28({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$27 || (_path$27 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M2.1 3.333c0-.313.254-.566.567-.566h2.8v3.45a1.684 1.684 0 0 1-3.367 0zM6.316 6.216v-3.45h3.368v3.45a1.684 1.684 0 0 1-3.368 0M10.532 6.216v-3.45h2.801c.313 0 .567.254.567.567v2.883a1.684 1.684 0 0 1-3.368 0"
  })), _path2$z || (_path2$z = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M8 8.707c.936 0 1.742-.555 2.108-1.354a2.32 2.32 0 0 0 2.458 1.328v2.826a1.9 1.9 0 0 1-1.9 1.9H5.333a1.9 1.9 0 0 1-1.9-1.9V8.68q.171.026.35.026c.937 0 1.743-.555 2.108-1.354A2.32 2.32 0 0 0 8 8.707"
  })));
};

var _path$26, _path2$y;
function _extends$27() { return _extends$27 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$27.apply(null, arguments); }
var SvgStoreFilled18 = function SvgStoreFilled18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$27({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$26 || (_path$26 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M2.4 3.75a.6.6 0 0 1 .6-.6h3.113v3.843a1.857 1.857 0 0 1-3.713 0zM7.143 6.993V3.15h3.714v3.843a1.857 1.857 0 0 1-3.714 0M11.886 6.993V3.15H15a.6.6 0 0 1 .6.6v3.243a1.857 1.857 0 0 1-3.714 0"
  })), _path2$y || (_path2$y = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M9 9.833c1.04 0 1.94-.6 2.371-1.474A2.64 2.64 0 0 0 14.1 9.81v3.136a2.1 2.1 0 0 1-2.1 2.1H6a2.1 2.1 0 0 1-2.1-2.1V9.81q.176.024.356.024c1.04 0 1.94-.6 2.372-1.474A2.64 2.64 0 0 0 9 9.833"
  })));
};

var _path$25, _path2$x;
function _extends$26() { return _extends$26 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$26.apply(null, arguments); }
var SvgStoreFilled24 = function SvgStoreFilled24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$26({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$25 || (_path$25 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M15.334 12.11A4.13 4.13 0 0 1 12 13.8a4.13 4.13 0 0 1-3.333-1.689A4.13 4.13 0 0 1 4.1 13.613v3.386A3.9 3.9 0 0 0 8 20.9h8a3.9 3.9 0 0 0 3.9-3.9v-3.386a4.128 4.128 0 0 1-4.567-1.502M21.125 10.282a2.54 2.54 0 0 1-2.458 1.918 2.533 2.533 0 0 1-2.533-2.534V3.8H20.2a1 1 0 0 1 1 1v4.866q0 .32-.075.616M4.1 11.88a2.533 2.533 0 0 0 3.767-2.19V3.8H3.8a1 1 0 0 0-1 1v4.866c0 .951.525 1.78 1.3 2.214"
  })), _path2$x || (_path2$x = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M9.467 9.69a2.533 2.533 0 0 0 5.066-.024V3.8H9.467v5.889"
  })));
};

var _path$24, _path2$w, _path3$7, _path4;
function _extends$25() { return _extends$25 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$25.apply(null, arguments); }
var SvgStoreFilled32 = function SvgStoreFilled32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$25({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$24 || (_path$24 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M4 6.667c0-.737.597-1.334 1.333-1.334h5.802v7.1a3.567 3.567 0 1 1-7.135 0zM12.432 5.333h7.136v7.1a3.568 3.568 0 0 1-7.136 0zM28 6.667c0-.737-.597-1.334-1.333-1.334h-5.802v7.1a3.567 3.567 0 1 0 7.135 0z"
  })), _path2$w || (_path2$w = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M24.432 17.214q.464-.001.901-.092v5.892a4 4 0 0 1-4 4H10.667a4 4 0 0 1-4-4v-5.892q.437.091.9.092a4.44 4.44 0 0 0 4.216-3.057 4.436 4.436 0 0 0 8.433 0 4.44 4.44 0 0 0 4.216 3.057"
  })), _path3$7 || (_path3$7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 0.5,
    d: "M4 6.667c0-.737.597-1.334 1.333-1.334h5.802v7.1a3.567 3.567 0 1 1-7.135 0zM12.432 5.333h7.136v7.1a3.568 3.568 0 0 1-7.136 0zM28 6.667c0-.737-.597-1.334-1.333-1.334h-5.802v7.1a3.567 3.567 0 1 0 7.135 0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 0.5,
    d: "M24.432 17.214q.464-.001.901-.092v5.892a4 4 0 0 1-4 4H10.667a4 4 0 0 1-4-4v-5.892q.437.091.9.092a4.44 4.44 0 0 0 4.216-3.057 4.436 4.436 0 0 0 8.433 0 4.44 4.44 0 0 0 4.216 3.057Z"
  })));
};

var _path$23, _path2$v;
function _extends$24() { return _extends$24 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$24.apply(null, arguments); }
var SvgStoreFilled48 = function SvgStoreFilled48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$24({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$23 || (_path$23 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M6 10a2 2 0 0 1 2-2h8.703v10.649a5.351 5.351 0 0 1-10.703 0zM18.649 8H29.35v10.649a5.351 5.351 0 0 1-10.702 0zM42 10a2 2 0 0 0-2-2h-8.703v10.649a5.351 5.351 0 0 0 10.703 0z"
  })), _path2$v || (_path2$v = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M36.648 25.82q.696-.001 1.352-.137v8.838a6 6 0 0 1-6 6H16a6 6 0 0 1-6-6v-8.837q.656.136 1.35.137a6.65 6.65 0 0 0 6.325-4.586 6.654 6.654 0 0 0 12.648 0 6.65 6.65 0 0 0 6.325 4.586"
  })));
};

var StoreFilledIcon = function StoreFilledIcon(props) {
  var storeFilled = {
    12: SvgStoreFilled12,
    16: SvgStoreFilled16,
    18: SvgStoreFilled18,
    24: SvgStoreFilled24,
    32: SvgStoreFilled32,
    48: SvgStoreFilled48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: storeFilled
  }, props));
};

var _path$22;
function _extends$23() { return _extends$23 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$23.apply(null, arguments); }
var SvgSubtract12 = function SvgSubtract12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$23({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$22 || (_path$22 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M11.1 6a.6.6 0 0 1-.6.6h-9a.6.6 0 1 1 0-1.2h9a.6.6 0 0 1 .6.6",
    clipRule: "evenodd"
  })));
};

var _path$21;
function _extends$22() { return _extends$22 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$22.apply(null, arguments); }
var SvgSubtract16 = function SvgSubtract16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$22({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$21 || (_path$21 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M14.75 8a.75.75 0 0 1-.75.75H2a.75.75 0 0 1 0-1.5h12a.75.75 0 0 1 .75.75",
    clipRule: "evenodd"
  })));
};

var _path$20;
function _extends$21() { return _extends$21 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$21.apply(null, arguments); }
var SvgSubtract18 = function SvgSubtract18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$21({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$20 || (_path$20 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M16.55 9a.8.8 0 0 1-.8.8H2.25a.8.8 0 1 1 0-1.6h13.5a.8.8 0 0 1 .8.8",
    clipRule: "evenodd"
  })));
};

var _path$1$;
function _extends$20() { return _extends$20 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$20.apply(null, arguments); }
var SvgSubtract24 = function SvgSubtract24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$20({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$1$ || (_path$1$ = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M21.9 12a.9.9 0 0 1-.9.9H3a.9.9 0 0 1 0-1.8h18a.9.9 0 0 1 .9.9",
    clipRule: "evenodd"
  })));
};

var _path$1_;
function _extends$1$() { return _extends$1$ = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1$.apply(null, arguments); }
var SvgSubtract32 = function SvgSubtract32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1$({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$1_ || (_path$1_ = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M29 16a1 1 0 0 1-1 1H4a1 1 0 1 1 0-2h24a1 1 0 0 1 1 1",
    clipRule: "evenodd"
  })));
};

var _path$1Z;
function _extends$1_() { return _extends$1_ = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1_.apply(null, arguments); }
var SvgSubtract48 = function SvgSubtract48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1_({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$1Z || (_path$1Z = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M43.2 24a1.2 1.2 0 0 1-1.2 1.2H6a1.2 1.2 0 1 1 0-2.4h36a1.2 1.2 0 0 1 1.2 1.2",
    clipRule: "evenodd"
  })));
};

var SubtractIcon = function SubtractIcon(props) {
  var subtract = {
    12: SvgSubtract12,
    16: SvgSubtract16,
    18: SvgSubtract18,
    24: SvgSubtract24,
    32: SvgSubtract32,
    48: SvgSubtract48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: subtract
  }, props));
};

var _path$1Y, _path2$u;
function _extends$1Z() { return _extends$1Z = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1Z.apply(null, arguments); }
var SvgTag12 = function SvgTag12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1Z({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$1Y || (_path$1Y = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M1.44 6.44A1.5 1.5 0 0 1 1 5.378V2.5A1.5 1.5 0 0 1 2.5 1h2.879a1.5 1.5 0 0 1 1.06.44l3.5 3.5a1.5 1.5 0 0 1 0 2.12L7.061 9.94a1.5 1.5 0 0 1-2.122 0zM2.2 2.5v2.879a.3.3 0 0 0 .088.212l3.5 3.5a.3.3 0 0 0 .424 0l2.879-2.879a.3.3 0 0 0 0-.424l-3.5-3.5a.3.3 0 0 0-.212-.088H2.5a.3.3 0 0 0-.3.3",
    clipRule: "evenodd"
  })), _path2$u || (_path2$u = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M4.5 3.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0"
  })));
};

var _path$1X, _path2$t;
function _extends$1Y() { return _extends$1Y = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1Y.apply(null, arguments); }
var SvgTag16 = function SvgTag16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1Y({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$1X || (_path$1X = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M2.834 3.332V7.17a.5.5 0 0 0 .146.354l4.667 4.667a.5.5 0 0 0 .707 0l3.838-3.839a.5.5 0 0 0 0-.707L7.525 2.978a.5.5 0 0 0-.353-.146H3.333a.5.5 0 0 0-.5.5m-.915 5.252a2 2 0 0 1-.586-1.414V3.332a2 2 0 0 1 2-2h3.839a2 2 0 0 1 1.414.586l4.667 4.666a2 2 0 0 1 0 2.829L9.414 13.25a2 2 0 0 1-2.828 0z",
    clipRule: "evenodd"
  })), _path2$t || (_path2$t = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M6 5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
  })));
};

var _path$1W, _path2$s;
function _extends$1X() { return _extends$1X = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1X.apply(null, arguments); }
var SvgTag18 = function SvgTag18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1X({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$1W || (_path$1W = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M3.1 3.75v4.318a.65.65 0 0 0 .19.46l5.25 5.25a.65.65 0 0 0 .92 0l4.318-4.318a.65.65 0 0 0 0-.92l-5.25-5.25a.65.65 0 0 0-.46-.19H3.75a.65.65 0 0 0-.65.65M1.5 8.068V3.75A2.25 2.25 0 0 1 3.75 1.5h4.318a2.25 2.25 0 0 1 1.591.659l5.25 5.25a2.25 2.25 0 0 1 0 3.182l-4.318 4.318a2.25 2.25 0 0 1-3.182 0l-5.25-5.25A2.25 2.25 0 0 1 1.5 8.068",
    clipRule: "evenodd"
  })), _path2$s || (_path2$s = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M6.75 5.625a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0"
  })));
};

var _path$1V, _path2$r;
function _extends$1W() { return _extends$1W = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1W.apply(null, arguments); }
var SvgTag24 = function SvgTag24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1W({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$1V || (_path$1V = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M3.8 5v5.757c0 .319.126.624.351.849l7 7a1.2 1.2 0 0 0 1.697 0l5.758-5.758a1.2 1.2 0 0 0 0-1.697l-7-7a1.2 1.2 0 0 0-.849-.351H5A1.2 1.2 0 0 0 3.8 5m9.079-2.121 7 7a3 3 0 0 1 0 4.242L14.12 19.88a3 3 0 0 1-4.242 0l-7-7A3 3 0 0 1 2 10.757V5a3 3 0 0 1 3-3h5.757a3 3 0 0 1 2.122.879",
    clipRule: "evenodd"
  })), _path2$r || (_path2$r = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M8.5 7a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
  })));
};

var _path$1U, _path2$q;
function _extends$1V() { return _extends$1V = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1V.apply(null, arguments); }
var SvgTag32 = function SvgTag32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1V({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$1U || (_path$1U = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M4.667 6.668v7.676a2 2 0 0 0 .585 1.415l9.334 9.333a2 2 0 0 0 2.828 0l7.676-7.676a2 2 0 0 0 0-2.829l-9.333-9.333a2 2 0 0 0-1.414-.586H6.667a2 2 0 0 0-2 2m-2 7.676V6.668a4 4 0 0 1 4-4h7.676a4 4 0 0 1 2.828 1.172l9.334 9.333a4 4 0 0 1 0 5.657l-7.677 7.676a4 4 0 0 1-5.657 0l-9.333-9.333a4 4 0 0 1-1.171-2.829",
    clipRule: "evenodd"
  })), _path2$q || (_path2$q = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M11 9a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
  })));
};

var _path$1T, _path2$p;
function _extends$1U() { return _extends$1U = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1U.apply(null, arguments); }
var SvgTag48 = function SvgTag48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1U({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$1T || (_path$1T = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M6.4 10v11.515a3.6 3.6 0 0 0 1.054 2.545l14 14a3.6 3.6 0 0 0 5.092 0L38.06 26.546a3.6 3.6 0 0 0 0-5.092l-14-14A3.6 3.6 0 0 0 21.515 6.4H10A3.6 3.6 0 0 0 6.4 10M4 21.515V10a6 6 0 0 1 6-6h11.515a6 6 0 0 1 4.242 1.757l14 14a6 6 0 0 1 0 8.486L28.243 39.757a6 6 0 0 1-8.486 0l-14-14A6 6 0 0 1 4 21.515",
    clipRule: "evenodd"
  })), _path2$p || (_path2$p = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M15.5 12.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0"
  })));
};

var TagIcon = function TagIcon(props) {
  var tag = {
    12: SvgTag12,
    16: SvgTag16,
    18: SvgTag18,
    24: SvgTag24,
    32: SvgTag32,
    48: SvgTag48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: tag
  }, props));
};

var _path$1S;
function _extends$1T() { return _extends$1T = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1T.apply(null, arguments); }
var SvgTagFilled12 = function SvgTagFilled12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1T({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$1S || (_path$1S = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M1 2.5v2.879c0 .398.158.779.44 1.06l3.5 3.5a1.5 1.5 0 0 0 2.12 0l2.88-2.878a1.5 1.5 0 0 0 0-2.122l-3.5-3.5A1.5 1.5 0 0 0 5.378 1H2.5A1.5 1.5 0 0 0 1 2.5m1.75 1a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5",
    clipRule: "evenodd"
  })));
};

var _path$1R;
function _extends$1S() { return _extends$1S = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1S.apply(null, arguments); }
var SvgTagFilled16 = function SvgTagFilled16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1S({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$1R || (_path$1R = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M1.334 3.334v3.838a2 2 0 0 0 .585 1.414l4.667 4.667a2 2 0 0 0 2.828 0l3.839-3.839a2 2 0 0 0 0-2.828L8.586 1.919a2 2 0 0 0-1.414-.586H3.333a2 2 0 0 0-2 2m2.333 1.333a1 1 0 1 0 0-2 1 1 0 0 0 0 2",
    clipRule: "evenodd"
  })));
};

var _path$1Q;
function _extends$1R() { return _extends$1R = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1R.apply(null, arguments); }
var SvgTagFilled18 = function SvgTagFilled18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1R({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$1Q || (_path$1Q = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M1.5 3.75v4.318c0 .597.237 1.17.659 1.591l5.25 5.25a2.25 2.25 0 0 0 3.182 0l4.318-4.318a2.25 2.25 0 0 0 0-3.182l-5.25-5.25A2.25 2.25 0 0 0 8.068 1.5H3.75A2.25 2.25 0 0 0 1.5 3.75m2.625 1.5a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25",
    clipRule: "evenodd"
  })));
};

var _path$1P;
function _extends$1Q() { return _extends$1Q = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1Q.apply(null, arguments); }
var SvgTagFilled24 = function SvgTagFilled24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1Q({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$1P || (_path$1P = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M2 5v5.757a3 3 0 0 0 .879 2.122l7 7a3 3 0 0 0 4.242 0l5.758-5.758a3 3 0 0 0 0-4.242l-7-7A3 3 0 0 0 10.757 2H5a3 3 0 0 0-3 3m3.5 2a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3",
    clipRule: "evenodd"
  })));
};

var _path$1O;
function _extends$1P() { return _extends$1P = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1P.apply(null, arguments); }
var SvgTagFilled32 = function SvgTagFilled32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1P({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$1O || (_path$1O = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M2.667 6.667v7.676a4 4 0 0 0 1.171 2.828l9.333 9.334a4 4 0 0 0 5.657 0l7.677-7.677a4 4 0 0 0 0-5.657L17.17 3.838a4 4 0 0 0-2.828-1.171H6.667a4 4 0 0 0-4 4m4.667 2.667a2 2 0 1 0 0-4 2 2 0 0 0 0 4",
    clipRule: "evenodd"
  })));
};

var _path$1N;
function _extends$1O() { return _extends$1O = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1O.apply(null, arguments); }
var SvgTagFilled48 = function SvgTagFilled48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1O({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$1N || (_path$1N = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M4 10v11.515a6 6 0 0 0 1.757 4.242l14 14a6 6 0 0 0 8.486 0l11.514-11.514a6 6 0 0 0 0-8.486l-14-14A6 6 0 0 0 21.515 4H10a6 6 0 0 0-6 6m7 4a3 3 0 1 0 0-6 3 3 0 0 0 0 6",
    clipRule: "evenodd"
  })));
};

var TagFilledIcon = function TagFilledIcon(props) {
  var tagFilled = {
    12: SvgTagFilled12,
    16: SvgTagFilled16,
    18: SvgTagFilled18,
    24: SvgTagFilled24,
    32: SvgTagFilled32,
    48: SvgTagFilled48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: tagFilled
  }, props));
};

var _path$1M;
function _extends$1N() { return _extends$1N = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1N.apply(null, arguments); }
var SvgTextBold12 = function SvgTextBold12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1N({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$1M || (_path$1M = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M2.4 2.79c0-.768.622-1.39 1.39-1.39H6a2.6 2.6 0 0 1 2.037 4.215A2.6 2.6 0 0 1 7 10.6H3.947A1.547 1.547 0 0 1 2.4 9.053zM3.6 6.6v2.453c0 .191.155.347.347.347H7a1.4 1.4 0 1 0 0-2.8zm0-1.2H6a1.4 1.4 0 1 0 0-2.8H3.79a.19.19 0 0 0-.19.19z",
    clipRule: "evenodd"
  })));
};

var _path$1L;
function _extends$1M() { return _extends$1M = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1M.apply(null, arguments); }
var SvgTextBold16 = function SvgTextBold16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1M({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$1L || (_path$1L = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M3.25 3.72c0-.996.807-1.803 1.803-1.803H8a3.417 3.417 0 0 1 2.636 5.59 3.418 3.418 0 0 1-1.303 6.576h-4.07A2.013 2.013 0 0 1 3.25 12.07zm1.5 5.03v3.32c0 .284.23.513.513.513h4.07a1.917 1.917 0 1 0 0-3.833zm0-1.5H8a1.917 1.917 0 1 0 0-3.833H5.053a.303.303 0 0 0-.303.302z",
    clipRule: "evenodd"
  })));
};

var _path$1K;
function _extends$1L() { return _extends$1L = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1L.apply(null, arguments); }
var SvgTextBold18 = function SvgTextBold18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1L({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$1K || (_path$1K = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M3.7 4.184c0-1.096.888-1.984 1.984-1.984H9a3.8 3.8 0 0 1 2.893 6.264A3.801 3.801 0 0 1 10.5 15.8H5.921A2.22 2.22 0 0 1 3.7 13.579zM5.3 9.8v3.779c0 .343.278.621.621.621H10.5a2.2 2.2 0 0 0 0-4.4zm0-1.6H9a2.2 2.2 0 1 0 0-4.4H5.684a.384.384 0 0 0-.384.384z",
    clipRule: "evenodd"
  })));
};

var _path$1J;
function _extends$1K() { return _extends$1K = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1K.apply(null, arguments); }
var SvgTextBold24 = function SvgTextBold24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1K({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$1J || (_path$1J = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M5.1 5.579C5.1 4.21 6.21 3.1 7.58 3.1H12a4.9 4.9 0 0 1 3.57 8.257A4.902 4.902 0 0 1 14 20.9H7.895A2.795 2.795 0 0 1 5.1 18.105zM6.9 12.9v5.205c0 .55.445.995.995.995H14a3.1 3.1 0 1 0 0-6.2zm0-1.8H12a3.1 3.1 0 1 0 0-6.2H7.58a.68.68 0 0 0-.679.679z",
    clipRule: "evenodd"
  })));
};

var _path$1I;
function _extends$1J() { return _extends$1J = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1J.apply(null, arguments); }
var SvgTextBold32 = function SvgTextBold32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1J({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$1I || (_path$1I = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M7 7.439a3.105 3.105 0 0 1 3.105-3.106H16a6.333 6.333 0 0 1 4.386 10.903 6.333 6.333 0 0 1-1.719 12.43h-8.14A3.526 3.526 0 0 1 7 24.14zm2 9.56v7.141c0 .843.683 1.527 1.526 1.527h8.14a4.333 4.333 0 0 0 0-8.667zm0-2h7a4.333 4.333 0 0 0 0-8.666h-5.895C9.495 6.333 9 6.828 9 7.44z",
    clipRule: "evenodd"
  })));
};

var _path$1H;
function _extends$1I() { return _extends$1I = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1I.apply(null, arguments); }
var SvgTextBold48 = function SvgTextBold48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1I({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$1H || (_path$1H = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M10.8 11.158A4.36 4.36 0 0 1 15.158 6.8H24a9.2 9.2 0 0 1 5.96 16.21c4.14.897 7.24 4.581 7.24 8.99a9.2 9.2 0 0 1-9.2 9.2H15.79a4.99 4.99 0 0 1-4.99-4.99zM13.2 25.2v11.01a2.59 2.59 0 0 0 2.59 2.59H28a6.8 6.8 0 1 0 0-13.6zm0-2.4H24a6.8 6.8 0 1 0 0-13.6h-8.842a1.96 1.96 0 0 0-1.958 1.958z",
    clipRule: "evenodd"
  })));
};

var TextBoldIcon = function TextBoldIcon(props) {
  var textBold = {
    12: SvgTextBold12,
    16: SvgTextBold16,
    18: SvgTextBold18,
    24: SvgTextBold24,
    32: SvgTextBold32,
    48: SvgTextBold48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: textBold
  }, props));
};

var _path$1G;
function _extends$1H() { return _extends$1H = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1H.apply(null, arguments); }
var SvgTextItalic12 = function SvgTextItalic12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1H({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$1G || (_path$1G = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M6.986 1.9H4.5a.6.6 0 0 0 0 1.2h1.704L4.547 8.9H2.5a.6.6 0 0 0 0 1.2h5a.6.6 0 0 0 0-1.2H5.795l1.657-5.8H9.5a.6.6 0 0 0 0-1.2H6.986",
    clipRule: "evenodd"
  })));
};

var _path$1F;
function _extends$1G() { return _extends$1G = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1G.apply(null, arguments); }
var SvgTextItalic16 = function SvgTextItalic16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1G({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$1F || (_path$1F = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M9.315 2.583H6a.75.75 0 1 0 0 1.5h2.339l-2.238 7.834H3.333a.75.75 0 1 0 0 1.5H10a.75.75 0 0 0 0-1.5H7.66L9.9 4.083h2.768a.75.75 0 0 0 0-1.5H9.315",
    clipRule: "evenodd"
  })));
};

var _path$1E;
function _extends$1F() { return _extends$1F = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1F.apply(null, arguments); }
var SvgTextItalic18 = function SvgTextItalic18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1F({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$1E || (_path$1E = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M10.48 2.95H6.75a.8.8 0 1 0 0 1.6h2.69l-2.543 8.9H3.75a.8.8 0 0 0 0 1.6h7.5a.8.8 0 1 0 0-1.6H8.56l2.543-8.9h3.147a.8.8 0 1 0 0-1.6H10.48",
    clipRule: "evenodd"
  })));
};

var _path$1D;
function _extends$1E() { return _extends$1E = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1E.apply(null, arguments); }
var SvgTextItalic24 = function SvgTextItalic24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1E({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$1D || (_path$1D = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M13.978 4.1H9a.9.9 0 1 0 0 1.8h3.807L9.32 18.1h-4.32a.9.9 0 0 0 0 1.8H15a.9.9 0 1 0 0-1.8h-3.807L14.68 5.9H19a.9.9 0 1 0 0-1.8h-5.022",
    clipRule: "evenodd"
  })));
};

var _path$1C;
function _extends$1D() { return _extends$1D = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1D.apply(null, arguments); }
var SvgTextItalic32 = function SvgTextItalic32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1D({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$1C || (_path$1C = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M18.642 5.667H12a1 1 0 1 0 0 2h5.341l-4.762 16.666H6.667a1 1 0 1 0 0 2H20a1 1 0 1 0 0-2h-5.34L19.42 7.667h5.912a1 1 0 1 0 0-2h-6.691",
    clipRule: "evenodd"
  })));
};

var _path$1B;
function _extends$1C() { return _extends$1C = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1C.apply(null, arguments); }
var SvgTextItalic48 = function SvgTextItalic48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1C({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$1B || (_path$1B = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M27.97 8.8H18a1.2 1.2 0 0 0 0 2.4h8.41l-7.315 25.6H10a1.2 1.2 0 0 0 0 2.4h20a1.2 1.2 0 1 0 0-2.4h-8.41l7.315-25.6H38a1.2 1.2 0 1 0 0-2.4H27.97",
    clipRule: "evenodd"
  })));
};

var TextItalicIcon = function TextItalicIcon(props) {
  var textItalic = {
    12: SvgTextItalic12,
    16: SvgTextItalic16,
    18: SvgTextItalic18,
    24: SvgTextItalic24,
    32: SvgTextItalic32,
    48: SvgTextItalic48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: textItalic
  }, props));
};

var _path$1A;
function _extends$1B() { return _extends$1B = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1B.apply(null, arguments); }
var SvgTextRectangleOnRectangleAngled12 = function SvgTextRectangleOnRectangleAngled12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1B({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 480 480"
  }, props), _path$1A || (_path$1A = /*#__PURE__*/React.createElement("path", {
    d: "m380.7 119.8-16.7-3v-.8c0-45.2-36.8-82-82-82H116c-45.2 0-82 36.8-82 82v166c0 36.5 24 67.5 57 78.1 5.1 26.4 26 48.3 54 53.2l178.4 31.5c4.8.8 9.6 1.3 14.3 1.3 39 0 73.7-28 80.7-67.8l28.8-163.5c7.8-44.5-22-87.1-66.5-95M82 116c0-18.7 15.3-34 34-34h166c18.7 0 34 15.3 34 34v166c0 18.7-15.3 34-34 34H116c-18.7 0-34-15.3-34-34zm318 90.4-28.8 163.5c-3.3 18.5-20.9 30.8-39.4 27.6L153.4 366c-2.1-.4-4-1.1-5.7-2h134.4c45.2 0 82-36.8 82-82V165.6l8.4 1.5c18.5 3.3 30.8 20.9 27.6 39.4ZM117 139c0-13.3 10.7-24 24-24h116c13.3 0 24 10.7 24 24s-10.7 24-24 24H141c-13.3 0-24-10.7-24-24m0 68c0-13.3 10.7-24 24-24h76c13.3 0 24 10.7 24 24s-10.7 24-24 24h-76c-13.3 0-24-10.7-24-24"
  })));
};

var _path$1z;
function _extends$1A() { return _extends$1A = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1A.apply(null, arguments); }
var SvgTextRectangleOnRectangleAngled16 = function SvgTextRectangleOnRectangleAngled16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1A({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 480 480"
  }, props), _path$1z || (_path$1z = /*#__PURE__*/React.createElement("path", {
    d: "m380.5 121.2-18-3.2v-2.1c0-44.4-36.1-80.5-80.5-80.5H116c-44.4 0-80.5 36.1-80.5 80.5v166c0 36.1 23.9 66.8 56.8 76.9 4.7 26.2 25.3 48 53 52.9l178.4 31.5c4.7.8 9.4 1.2 14 1.2 38.3 0 72.4-27.5 79.2-66.5l28.8-163.5c7.7-43.7-21.6-85.5-65.3-93.3ZM80.5 282V116c0-19.6 15.9-35.5 35.5-35.5h166c19.6 0 35.5 15.9 35.5 35.5v166c0 19.6-15.9 35.5-35.5 35.5H116c-19.6 0-35.5-15.9-35.5-35.5m321-75.3-28.8 163.5c-3.4 19.3-21.8 32.2-41.1 28.8l-178.4-31.5c-3.9-.7-7.4-2.5-10.1-5h139c44.4 0 80.5-36.1 80.5-80.5V163.8l10.2 1.8c19.3 3.4 32.2 21.8 28.8 41.1Zm-284-66.7c0-12.4 10.1-22.5 22.5-22.5h118c12.4 0 22.5 10.1 22.5 22.5s-10.1 22.5-22.5 22.5H140c-12.4 0-22.5-10.1-22.5-22.5m0 66c0-12.4 10.1-22.5 22.5-22.5h78c12.4 0 22.5 10.1 22.5 22.5s-10.1 22.5-22.5 22.5h-78c-12.4 0-22.5-10.1-22.5-22.5"
  })));
};

var _path$1y;
function _extends$1z() { return _extends$1z = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1z.apply(null, arguments); }
var SvgTextRectangleOnRectangleAngled18 = function SvgTextRectangleOnRectangleAngled18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1z({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 480 480"
  }, props), _path$1y || (_path$1y = /*#__PURE__*/React.createElement("path", {
    d: "m380.3 122.4-18.9-3.3v-3c0-43.7-35.6-79.3-79.3-79.3H116c-43.7 0-79.3 35.6-79.3 79.3v166c0 35.9 23.9 66.2 56.7 76 4.4 26.1 24.7 47.8 52.2 52.7L324 442.2c4.6.8 9.3 1.2 13.8 1.2 37.8 0 71.3-27.1 78.1-65.6l28.8-163.5c7.6-43.1-21.3-84.3-64.4-91.9M79.3 282V116c0-20.2 16.4-36.7 36.7-36.7h166c20.2 0 36.7 16.4 36.7 36.7v166c0 20.2-16.4 36.7-36.7 36.7H116c-20.2 0-36.7-16.4-36.7-36.7m323.3-75.1-28.8 163.5c-3.5 19.9-22.6 33.2-42.5 29.7l-178.4-31.4c-5.2-.9-9.6-3.6-12.7-7.3H282c43.7 0 79.3-35.6 79.3-79.3V162.5l11.5 2c19.9 3.5 33.3 22.6 29.7 42.5ZM118.2 141c0-11.8 9.6-21.3 21.3-21.3h119c11.8 0 21.3 9.6 21.3 21.3s-9.6 21.3-21.3 21.3h-119c-11.8 0-21.3-9.6-21.3-21.3m0 64c0-11.8 9.6-21.3 21.3-21.3h79c11.8 0 21.3 9.6 21.3 21.3s-9.6 21.3-21.3 21.3h-79c-11.8 0-21.3-9.6-21.3-21.3"
  })));
};

var _path$1x;
function _extends$1y() { return _extends$1y = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1y.apply(null, arguments); }
var SvgTextRectangleOnRectangleAngled24 = function SvgTextRectangleOnRectangleAngled24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1y({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 480 480"
  }, props), _path$1x || (_path$1x = /*#__PURE__*/React.createElement("path", {
    d: "m379.7 125.7-21.7-3.8v-5.8c0-41.9-34.1-76-76-76H116c-41.9 0-76 34.1-76 76v166c0 35.1 23.9 64.7 56.3 73.4 3.4 25.6 23 47.3 49.8 52L324.5 439c4.4.8 8.9 1.2 13.2 1.2 36.2 0 68.3-26 74.8-62.8l28.8-163.5c7.3-41.3-20.4-80.8-61.6-88ZM76 282V116c0-22.1 17.9-40 40-40h166c22.1 0 40 17.9 40 40v166c0 22.1-17.9 40-40 40H116c-22.1 0-40-17.9-40-40m329.9-74.5L377.1 371c-3.8 21.7-24.6 36.3-46.3 32.4l-178.4-31.5c-8.3-1.5-14.9-6.9-18.2-13.9H282c41.9 0 76-34.1 76-76V158.4l15.4 2.7c21.7 3.8 36.3 24.6 32.4 46.3ZM121 142c0-9.9 8.1-18 18-18h120c9.9 0 18 8.1 18 18s-8.1 18-18 18H139c-9.9 0-18-8.1-18-18m0 62c0-9.9 8.1-18 18-18h80c9.9 0 18 8.1 18 18s-8.1 18-18 18h-80c-9.9 0-18-8.1-18-18"
  })));
};

var _path$1w;
function _extends$1x() { return _extends$1x = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1x.apply(null, arguments); }
var SvgTextRectangleOnRectangleAngled32 = function SvgTextRectangleOnRectangleAngled32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1x({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 480 480"
  }, props), _path$1w || (_path$1w = /*#__PURE__*/React.createElement("path", {
    d: "m379.2 128.6-24.2-4.3v-8.4c0-40.3-32.7-73-73-73H116c-40.3 0-73 32.7-73 73v166c0 34.4 24 63.3 56.1 71 2.4 25.2 21.4 46.8 47.5 51.4L325 435.8c4.3.8 8.5 1.1 12.7 1.1 34.7 0 65.6-25 71.9-60.3l28.8-163.5c7-39.6-19.6-77.6-59.2-84.6ZM73 282V116c0-23.7 19.3-43 43-43h166c23.7 0 43 19.3 43 43v166c0 23.7-19.3 43-43 43H116c-23.7 0-43-19.3-43-43m335.8-74L380 371.5c-4.1 23.3-26.5 39-49.8 34.9l-178.4-31.5c-10.9-1.9-19.2-9.9-22-19.9H282c40.3 0 73-32.7 73-73V154.8l19 3.3c23.3 4.1 39 26.5 34.9 49.8ZM274 142c0 8.3-6.7 15-15 15H139c-8.3 0-15-6.7-15-15s6.7-15 15-15h120c8.3 0 15 6.7 15 15m-40 62c0 8.3-6.7 15-15 15h-80c-8.3 0-15-6.7-15-15s6.7-15 15-15h80c8.3 0 15 6.7 15 15"
  })));
};

var _path$1v;
function _extends$1w() { return _extends$1w = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1w.apply(null, arguments); }
var SvgTextRectangleOnRectangleAngled48 = function SvgTextRectangleOnRectangleAngled48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1w({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 480 480"
  }, props), _path$1v || (_path$1v = /*#__PURE__*/React.createElement("path", {
    d: "m378.7 131.6-26.7-4.7V116c0-38.6-31.4-70-70-70H116c-38.6 0-70 31.4-70 70v166c0 33.8 24 62 55.9 68.6 1.4 24.8 19.7 46.4 45.2 50.9L325.5 433c4.1.7 8.2 1.1 12.2 1.1 33.3 0 62.9-23.9 68.9-57.9l28.8-163.5c6.7-38-18.8-74.4-56.8-81.1ZM70 282V116c0-25.4 20.6-46 46-46h166c25.4 0 46 20.6 46 46v166c0 25.4-20.6 46-46 46H116c-25.4 0-46-20.6-46-46m341.8-73.5L383 372c-4.4 25-28.3 41.7-53.3 37.3l-178.4-31.5c-13.4-2.4-23.2-13.1-25.2-25.8H282c38.6 0 70-31.4 70-70V151.3l22.5 4c25 4.4 41.7 28.3 37.3 53.3ZM127 142c0-6.6 5.4-12 12-12h120c6.6 0 12 5.4 12 12s-5.4 12-12 12H139c-6.6 0-12-5.4-12-12m0 62c0-6.6 5.4-12 12-12h80c6.6 0 12 5.4 12 12s-5.4 12-12 12h-80c-6.6 0-12-5.4-12-12"
  })));
};

var TextRectangleOnRectangleAngledIcon = function TextRectangleOnRectangleAngledIcon(props) {
  var textRectangleOnRectangleAngled = {
    12: SvgTextRectangleOnRectangleAngled12,
    16: SvgTextRectangleOnRectangleAngled16,
    18: SvgTextRectangleOnRectangleAngled18,
    24: SvgTextRectangleOnRectangleAngled24,
    32: SvgTextRectangleOnRectangleAngled32,
    48: SvgTextRectangleOnRectangleAngled48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: textRectangleOnRectangleAngled
  }, props));
};

var _path$1u, _path2$o;
function _extends$1v() { return _extends$1v = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1v.apply(null, arguments); }
var SvgTextRectangleOnRectangleAngledFilled12 = function SvgTextRectangleOnRectangleAngledFilled12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1v({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 480 480"
  }, props), _path$1u || (_path$1u = /*#__PURE__*/React.createElement("path", {
    d: "M402 126.6V282c0 29.9-11 57.3-29.2 78.3-13.8 16-31.7 28.2-52 35.2-12.2 4.2-25.2 6.5-38.8 6.5H126.6c9.8 7 21.1 11.8 33.3 13.9l163.5 28.8c4.8.8 9.6 1.3 14.4 1.3 16.7 0 32.9-5.1 46.9-14.9 17.9-12.6 29.9-31.4 33.7-52.9l28.8-163.5c6.5-37-13-72.6-45.2-88.1"
  })), _path2$o || (_path2$o = /*#__PURE__*/React.createElement("path", {
    d: "M282 364c45.2 0 82-36.8 82-82V116c0-45.2-36.8-82-82-82H116c-45.2 0-82 36.8-82 82v166c0 38.5 26.7 70.9 62.6 79.7 6.2 1.5 12.7 2.3 19.4 2.3zM111 215c0-4.4 1.2-8.5 3.2-12 4.2-7.2 11.9-12 20.8-12h84c13.3 0 24 10.7 24 24s-10.7 24-24 24h-84c-.9 0-1.8 0-2.7-.2-10.6-1.2-19.1-9.3-20.9-19.6-.2-1.4-.4-2.8-.4-4.2m148-106c11.1 0 20.4 7.5 23.2 17.8.5 2 .8 4.1.8 6.2 0 6.7-2.7 12.7-7.1 17-4.3 4.3-10.3 7-16.9 7H135c-4.4 0-8.5-1.2-12-3.2-7.2-4.1-12-11.9-12-20.8 0-13.3 10.7-24 24-24z"
  })));
};

var _path$1t;
function _extends$1u() { return _extends$1u = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1u.apply(null, arguments); }
var SvgTextRectangleOnRectangleAngledFilled16 = function SvgTextRectangleOnRectangleAngledFilled16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1u({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 480 480"
  }, props), _path$1t || (_path$1t = /*#__PURE__*/React.createElement("path", {
    d: "M445.8 214.5 417 378c-3.7 21.2-15.5 39.6-33.1 52-13.7 9.6-29.6 14.6-46 14.6q-7.05 0-14.1-1.2l-163.5-28.8c-12.9-2.3-24.5-7.5-34.4-14.9h156.6c10.4 0 20.4-1.4 30-3.9 25.5-6.8 47.6-21.9 63.1-42.3 15-19.7 23.9-44.2 23.9-70.8V127.1c32.8 14.8 52.8 50.4 46.3 87.4M282 362.5H116c-44.4 0-80.5-36.1-80.5-80.5V116c0-44.4 36.1-80.5 80.5-80.5h166c44.4 0 80.5 36.1 80.5 80.5v166c0 44.4-36.1 80.5-80.5 80.5M112.5 214c0 12.4 10.1 22.5 22.5 22.5h84c12.4 0 22.5-10.1 22.5-22.5s-10.1-22.5-22.5-22.5h-84c-12.4 0-22.5 10.1-22.5 22.5m22.5-57.5h124c12.4 0 22.5-10.1 22.5-22.5s-10.1-22.5-22.5-22.5H135c-12.4 0-22.5 10.1-22.5 22.5s10.1 22.5 22.5 22.5"
  })));
};

var _path$1s;
function _extends$1t() { return _extends$1t = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1t.apply(null, arguments); }
var SvgTextRectangleOnRectangleAngledFilled18 = function SvgTextRectangleOnRectangleAngledFilled18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1t({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 480 480"
  }, props), _path$1s || (_path$1s = /*#__PURE__*/React.createElement("path", {
    d: "m444.6 214.3-28.8 163.5c-3.7 20.9-15.3 39.1-32.6 51.2-13.5 9.4-29.2 14.4-45.3 14.4-4.6 0-9.3-.4-13.9-1.2l-163.5-28.8c-13.6-2.4-25.8-8.2-35.9-16.3h157.5c7.1 0 14.1-.7 20.9-1.9 31.5-5.8 58.5-24.4 75.4-50.3 11.8-18.1 18.7-39.7 18.7-62.8V127.3c33.5 14 54.2 49.8 47.6 87ZM361.3 116v166c0 43.7-35.6 79.3-79.3 79.3H116c-43.7 0-79.3-35.6-79.3-79.3V116c0-43.7 35.6-79.3 79.3-79.3h166c43.7 0 79.3 35.6 79.3 79.3M259 156c11.8 0 21.3-9.6 21.3-21.3s-9.6-21.3-21.3-21.3H135c-11.8 0-21.3 9.6-21.3 21.3S123.3 156 135 156zm-40 36h-84c-11.8 0-21.3 9.6-21.3 21.3s9.6 21.3 21.3 21.3h84c11.8 0 21.3-9.6 21.3-21.3S230.7 192 219 192"
  })));
};

var _path$1r;
function _extends$1s() { return _extends$1s = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1s.apply(null, arguments); }
var SvgTextRectangleOnRectangleAngledFilled24 = function SvgTextRectangleOnRectangleAngledFilled24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1s({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 480 480"
  }, props), _path$1r || (_path$1r = /*#__PURE__*/React.createElement("path", {
    d: "m441.3 213.7-28.8 163.5c-3.5 20-14.6 37.4-31.3 49.1-12.9 9-28 13.8-43.4 13.8-4.4 0-8.9-.4-13.4-1.2l-163.5-28.8c-13-2.3-25-7.8-34.9-16h155.9c46.1 0 85.8-28 103-68 5.8-13.5 9-28.4 9-44V129.8c33.1 12.8 53.7 47.8 47.3 84ZM282 358H116c-41.9 0-76-34.1-76-76V116c0-41.9 34.1-76 76-76h166c41.9 0 76 34.1 76 76v166c0 41.9-34.1 76-76 76M117 212c0 9.9 8.1 18 18 18h84c9.9 0 18-8.1 18-18s-8.1-18-18-18h-84c-9.9 0-18 8.1-18 18m18-58h124c9.9 0 18-8.1 18-18s-8.1-18-18-18H135c-9.9 0-18 8.1-18 18s8.1 18 18 18"
  })));
};

var _path$1q;
function _extends$1r() { return _extends$1r = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1r.apply(null, arguments); }
var SvgTextRectangleOnRectangleAngledFilled32 = function SvgTextRectangleOnRectangleAngledFilled32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1r({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 480 480"
  }, props), _path$1q || (_path$1q = /*#__PURE__*/React.createElement("path", {
    d: "m438.4 213.2-28.8 163.5c-3.4 19.2-14 35.9-30 47.1-12.4 8.7-26.9 13.2-41.7 13.2-4.3 0-8.5-.4-12.8-1.1l-163.5-28.8c-16.4-2.9-30.6-11.1-41.1-22.6 3.5.4 7 .5 10.6.5h151c56.8 0 103-46.2 103-103V129.9c36.4 9.5 60 45.6 53.4 83.3ZM282 355H116c-40.3 0-73-32.7-73-73V116c0-40.3 32.7-73 73-73h166c40.3 0 73 32.7 73 73v166c0 40.3-32.7 73-73 73M119 209c0 8.3 6.7 15 15 15h86c8.3 0 15-6.7 15-15s-6.7-15-15-15h-86c-8.3 0-15 6.7-15 15m15-59h126c8.3 0 15-6.7 15-15s-6.7-15-15-15H134c-8.3 0-15 6.7-15 15s6.7 15 15 15"
  })));
};

var _path$1p;
function _extends$1q() { return _extends$1q = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1q.apply(null, arguments); }
var SvgTextRectangleOnRectangleAngledFilled48 = function SvgTextRectangleOnRectangleAngledFilled48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1q({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 480 480"
  }, props), _path$1p || (_path$1p = /*#__PURE__*/React.createElement("path", {
    d: "m435.4 212.7-28.8 163.5c-3.2 18.4-13.5 34.5-28.8 45.2-11.9 8.3-25.8 12.7-40 12.7s-8.2-.4-12.3-1.1L162 404.2c-18.4-3.2-34.5-13.5-45.2-28.8 0 0-.1-.2-.2-.3 4.4.6 8.8.9 13.3.9h152c51.8 0 94-42.2 94-94V131.1l2.7.5c38 6.7 63.5 43.1 56.8 81.1M282 352H116c-38.6 0-70-31.4-70-70V116c0-38.6 31.4-70 70-70h166c38.6 0 70 31.4 70 70v166c0 38.6-31.4 70-70 70M121 211c0 6.6 5.4 12 12 12h88c6.6 0 12-5.4 12-12s-5.4-12-12-12h-88c-6.6 0-12 5.4-12 12m12-60h128c6.6 0 12-5.4 12-12s-5.4-12-12-12H133c-6.6 0-12 5.4-12 12s5.4 12 12 12"
  })));
};

var TextRectangleOnRectangleAngledFilledIcon = function TextRectangleOnRectangleAngledFilledIcon(props) {
  var textRectangleOnRectangleAngledFilled = {
    12: SvgTextRectangleOnRectangleAngledFilled12,
    16: SvgTextRectangleOnRectangleAngledFilled16,
    18: SvgTextRectangleOnRectangleAngledFilled18,
    24: SvgTextRectangleOnRectangleAngledFilled24,
    32: SvgTextRectangleOnRectangleAngledFilled32,
    48: SvgTextRectangleOnRectangleAngledFilled48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: textRectangleOnRectangleAngledFilled
  }, props));
};

var _path$1o;
function _extends$1p() { return _extends$1p = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1p.apply(null, arguments); }
var SvgTextUnderline12 = function SvgTextUnderline12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1p({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$1o || (_path$1o = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M3 1.9a.6.6 0 0 1 .6.6V6a2.4 2.4 0 1 0 4.8 0V2.5a.6.6 0 0 1 1.2 0V6a3.6 3.6 0 1 1-7.2 0V2.5a.6.6 0 0 1 .6-.6m-.6 8.6a.6.6 0 0 1 .6-.6h6a.6.6 0 1 1 0 1.2H3a.6.6 0 0 1-.6-.6",
    clipRule: "evenodd"
  })));
};

var _path$1n;
function _extends$1o() { return _extends$1o = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1o.apply(null, arguments); }
var SvgTextUnderline16 = function SvgTextUnderline16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1o({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$1n || (_path$1n = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M4 2.583a.75.75 0 0 1 .75.75V8a3.25 3.25 0 0 0 6.5 0V3.333a.75.75 0 0 1 1.5 0V8a4.75 4.75 0 1 1-9.5 0V3.333a.75.75 0 0 1 .75-.75M3.25 14a.75.75 0 0 1 .75-.75h8a.75.75 0 0 1 0 1.5H4a.75.75 0 0 1-.75-.75",
    clipRule: "evenodd"
  })));
};

var _path$1m;
function _extends$1n() { return _extends$1n = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1n.apply(null, arguments); }
var SvgTextUnderline18 = function SvgTextUnderline18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1n({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$1m || (_path$1m = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M4.5 2.95a.8.8 0 0 1 .8.8V9a3.7 3.7 0 1 0 7.4 0V3.75a.8.8 0 1 1 1.6 0V9A5.3 5.3 0 1 1 3.7 9V3.75a.8.8 0 0 1 .8-.8m-.8 12.8a.8.8 0 0 1 .8-.8h9a.8.8 0 1 1 0 1.6h-9a.8.8 0 0 1-.8-.8",
    clipRule: "evenodd"
  })));
};

var _path$1l;
function _extends$1m() { return _extends$1m = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1m.apply(null, arguments); }
var SvgTextUnderline24 = function SvgTextUnderline24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1m({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$1l || (_path$1l = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M6 4.1a.9.9 0 0 1 .9.9v7a5.1 5.1 0 0 0 10.2 0V5a.9.9 0 1 1 1.8 0v7a6.9 6.9 0 1 1-13.8 0V5a.9.9 0 0 1 .9-.9M5.1 21a.9.9 0 0 1 .9-.9h12a.9.9 0 0 1 0 1.8H6a.9.9 0 0 1-.9-.9",
    clipRule: "evenodd"
  })));
};

var _path$1k;
function _extends$1l() { return _extends$1l = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1l.apply(null, arguments); }
var SvgTextUnderline32 = function SvgTextUnderline32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1l({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$1k || (_path$1k = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8 5.667a1 1 0 0 1 1 1V16a7 7 0 1 0 14 0V6.667a1 1 0 1 1 2 0V16a9 9 0 0 1-18 0V6.667a1 1 0 0 1 1-1M7 28a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1",
    clipRule: "evenodd"
  })));
};

var _path$1j;
function _extends$1k() { return _extends$1k = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1k.apply(null, arguments); }
var SvgTextUnderline48 = function SvgTextUnderline48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1k({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$1j || (_path$1j = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M12 8.8a1.2 1.2 0 0 1 1.2 1.2v14c0 5.965 4.835 10.8 10.8 10.8S34.8 29.965 34.8 24V10a1.2 1.2 0 0 1 2.4 0v14c0 7.29-5.91 13.2-13.2 13.2S10.8 31.29 10.8 24V10A1.2 1.2 0 0 1 12 8.8M10.8 42a1.2 1.2 0 0 1 1.2-1.2h24a1.2 1.2 0 1 1 0 2.4H12a1.2 1.2 0 0 1-1.2-1.2",
    clipRule: "evenodd"
  })));
};

var TextUnderlineIcon = function TextUnderlineIcon(props) {
  var textUnderline = {
    12: SvgTextUnderline12,
    16: SvgTextUnderline16,
    18: SvgTextUnderline18,
    24: SvgTextUnderline24,
    32: SvgTextUnderline32,
    48: SvgTextUnderline48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: textUnderline
  }, props));
};

var _g, _defs;
function _extends$1j() { return _extends$1j = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1j.apply(null, arguments); }
var SvgThumbsUp12 = function SvgThumbsUp12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1j({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#2F3438",
    fillRule: "evenodd",
    clipPath: "url(#thumbsUp_12_svg__a)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.158 2.125a.3.3 0 0 0-.254.135L4.17 4.832a.9.9 0 0 0-.153.5v4.531H8.4a.91.91 0 0 0 .894-.732l.551-2.865a.903.903 0 0 0-.894-1.068H8.1c-1.212 0-2.089-1.146-1.759-2.3l.111-.388a.303.303 0 0 0-.294-.385m-1.264-.53a1.52 1.52 0 0 1 1.264-.67c1.008 0 1.736.952 1.462 1.911l-.111.389a.61.61 0 0 0 .59.773h.852c1.332 0 2.335 1.198 2.086 2.492l-.55 2.866A2.12 2.12 0 0 1 8.4 11.063H2.803V5.331c0-.415.124-.82.357-1.165z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.138 6.225v3.65h.606v-3.65zm-.203-1.2c-.558 0-1.01.448-1.01 1v4.05c0 .552.452 1 1.01 1h2.023v-6.05z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "thumbsUp_12_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h12v12H0z"
  })))));
};

var _path$1i, _path2$n;
function _extends$1i() { return _extends$1i = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1i.apply(null, arguments); }
var SvgThumbsUp16 = function SvgThumbsUp16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1i({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$1i || (_path$1i = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8.213 2.84a.41.41 0 0 0-.34.18L5.561 6.45a1.2 1.2 0 0 0-.203.665v6.043h5.844a1.21 1.21 0 0 0 1.192-.976l.735-3.821a1.204 1.204 0 0 0-1.192-1.424h-1.135c-1.617 0-2.785-1.528-2.345-3.066l.148-.518a.404.404 0 0 0-.392-.513m-1.686-.708a2.03 2.03 0 0 1 1.686-.892c1.343 0 2.314 1.27 1.949 2.548l-.148.518a.812.812 0 0 0 .788 1.03h1.135c1.775 0 3.113 1.598 2.781 3.324l-.734 3.82a2.82 2.82 0 0 1-2.782 2.278H3.74V7.115c0-.553.165-1.093.475-1.553z",
    clipRule: "evenodd"
  })), _path2$n || (_path2$n = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M2.849 7.811v5.349h.88V7.811zm-.27-1.6a1.34 1.34 0 0 0-1.348 1.333v5.883a1.34 1.34 0 0 0 1.348 1.333h2.769V6.211z",
    clipRule: "evenodd"
  })));
};

var _path$1h, _path2$m;
function _extends$1h() { return _extends$1h = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1h.apply(null, arguments); }
var SvgThumbsUp18 = function SvgThumbsUp18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1h({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$1h || (_path$1h = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M9.339 3.096a.56.56 0 0 0-.466.247L6.272 7.2c-.16.238-.246.518-.246.804v6.899h6.676c.704 0 1.309-.495 1.44-1.18l.827-4.298a1.455 1.455 0 0 0-1.44-1.72h-1.277c-1.752 0-3.018-1.656-2.541-3.323l.166-.582a.555.555 0 0 0-.538-.705m-1.812-.64a2.18 2.18 0 0 1 1.812-.96c1.444 0 2.488 1.366 2.095 2.74l-.166.582a1.014 1.014 0 0 0 .984 1.287h1.276c1.935 0 3.391 1.74 3.03 3.62l-.826 4.298a3.075 3.075 0 0 1-3.03 2.48H4.408V8.006c0-.602.18-1.19.518-1.691z",
    clipRule: "evenodd"
  })), _path2$m || (_path2$m = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M3.005 8.589v6.307H4.39V8.59zm-.101-1.6c-.838 0-1.517.672-1.517 1.5v6.507c0 .829.68 1.5 1.517 1.5h3.104V6.99z",
    clipRule: "evenodd"
  })));
};

var _path$1g, _path2$l;
function _extends$1g() { return _extends$1g = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1g.apply(null, arguments); }
var SvgThumbsUp24 = function SvgThumbsUp24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1g({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$1g || (_path$1g = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M12.367 3.96a.92.92 0 0 0-.761.403L8.138 9.507c-.233.345-.357.75-.357 1.165v9.365h9.07c1.02 0 1.896-.717 2.087-1.708l1.101-5.732c.25-1.294-.754-2.492-2.086-2.492h-1.702c-2.223 0-3.83-2.102-3.226-4.217l.222-.777a.907.907 0 0 0-.88-1.151m-2.276-.596a2.74 2.74 0 0 1 2.276-1.204c1.814 0 3.125 1.715 2.632 3.44l-.222.777c-.277.967.458 1.928 1.474 1.928h1.702c2.474 0 4.336 2.225 3.875 4.628l-1.102 5.732c-.354 1.84-1.98 3.172-3.874 3.172H5.962V10.672c0-.77.23-1.523.662-2.163z",
    clipRule: "evenodd"
  })), _path2$l || (_path2$l = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M5.93 11.117H4.125a.2.2 0 0 0-.202.2v8.523c0 .11.09.2.202.2h1.807zm-1.806-1.8a2.01 2.01 0 0 0-2.022 2v8.523c0 1.105.905 2 2.022 2h3.627V9.317z",
    clipRule: "evenodd"
  })));
};

var _path$1f, _path2$k;
function _extends$1f() { return _extends$1f = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1f.apply(null, arguments); }
var SvgThumbsUp32 = function SvgThumbsUp32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1f({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$1f || (_path$1f = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M16.59 5.075c-.475 0-.919.235-1.183.626l-4.624 6.86a2.98 2.98 0 0 0-.509 1.663v12.687H22.57a3.025 3.025 0 0 0 2.98-2.44l1.469-7.642c.355-1.849-1.078-3.56-2.98-3.56h-2.27c-2.83 0-4.877-2.676-4.106-5.37l.296-1.035c.257-.898-.425-1.789-1.369-1.789m-2.865-.483a3.46 3.46 0 0 1 2.865-1.517c2.285 0 3.937 2.16 3.315 4.333l-.296 1.036c-.406 1.417.671 2.824 2.16 2.824h2.27c3.17 0 5.559 2.853 4.967 5.934l-1.47 7.642c-.453 2.36-2.538 4.067-4.966 4.067H8.252V14.224c0-.987.295-1.952.849-2.773z",
    clipRule: "evenodd"
  })), _path2$k || (_path2$k = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8.413 14.417H5.6a.67.67 0 0 0-.674.667v11.174a.67.67 0 0 0 .674.667h2.813zm-2.813-2c-1.489 0-2.696 1.194-2.696 2.667v11.174c0 1.473 1.207 2.667 2.696 2.667h4.836V12.417z",
    clipRule: "evenodd"
  })));
};

var _path$1e, _path2$j;
function _extends$1e() { return _extends$1e = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1e.apply(null, arguments); }
var SvgThumbsUp48 = function SvgThumbsUp48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1e({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$1e || (_path$1e = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M25.29 7.323c-.814 0-1.575.403-2.027 1.073l-6.936 10.289a4.76 4.76 0 0 0-.815 2.663v19.329H34.26c2.331 0 4.333-1.64 4.769-3.904L41.23 25.31c.568-2.957-1.724-5.696-4.768-5.696h-3.405c-4.044 0-6.968-3.823-5.867-7.672l.444-1.553c.44-1.538-.729-3.066-2.345-3.066m-4.046-.258a4.88 4.88 0 0 1 4.046-2.142c3.226 0 5.558 3.05 4.68 6.119l-.444 1.553c-.663 2.317 1.097 4.619 3.532 4.619h3.405c4.566 0 8.005 4.108 7.152 8.544l-2.203 11.463c-.653 3.397-3.656 5.856-7.153 5.856H13.085v-21.73c0-1.42.426-2.81 1.223-3.993z",
    clipRule: "evenodd"
  })), _path2$j || (_path2$j = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M13.126 21.037H8.299a1.61 1.61 0 0 0-1.618 1.6v16.436c0 .884.725 1.6 1.618 1.6h4.827zm-4.827-2.4c-2.233 0-4.044 1.79-4.044 4v16.436c0 2.21 1.81 4 4.044 4h7.253V18.637z",
    clipRule: "evenodd"
  })));
};

var ThumbsUpIcon = function ThumbsUpIcon(props) {
  var thumbsUp = {
    12: SvgThumbsUp12,
    16: SvgThumbsUp16,
    18: SvgThumbsUp18,
    24: SvgThumbsUp24,
    32: SvgThumbsUp32,
    48: SvgThumbsUp48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: thumbsUp
  }, props));
};

var _path$1d;
function _extends$1d() { return _extends$1d = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1d.apply(null, arguments); }
var SvgThumbsUpFilled12 = function SvgThumbsUpFilled12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1d({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$1d || (_path$1d = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M6.288 1.179c-.483 0-.933.238-1.2.635L3.946 3.506a1 1 0 0 0-.17.559V9.81a1 1 0 0 0 1 1h3.641c.969 0 1.801-.681 1.982-1.622l.523-2.723c.236-1.229-.716-2.367-1.982-2.367h-.808a.58.58 0 0 1-.562-.735l.106-.369c.26-.91-.432-1.815-1.389-1.815M2.576 10.81V5.062h-.574c-.53 0-.961.426-.961.95V9.86c0 .525.43.95.96.95z"
  })));
};

var _path$1c;
function _extends$1c() { return _extends$1c = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1c.apply(null, arguments); }
var SvgThumbsUpFilled16 = function SvgThumbsUpFilled16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1c({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$1c || (_path$1c = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M8.402 1.578a1.93 1.93 0 0 0-1.602.848L5.397 4.508c-.149.22-.228.48-.228.745v7.834c0 .736.597 1.333 1.333 1.333h4.74a2.68 2.68 0 0 0 2.642-2.163l.698-3.63c.315-1.64-.956-3.157-2.643-3.157h-1.078a.77.77 0 0 1-.748-.98l.14-.49c.348-1.216-.575-2.422-1.851-2.422M3.669 6.3v8.122h-.986c-.707 0-1.28-.567-1.28-1.267V7.568c0-.7.573-1.266 1.28-1.266z"
  })));
};

var _path$1b;
function _extends$1b() { return _extends$1b = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1b.apply(null, arguments); }
var SvgThumbsUpFilled18 = function SvgThumbsUpFilled18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1b({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$1b || (_path$1b = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M9.546 1.886c-.691 0-1.337.342-1.72.91L6.068 5.404a1.5 1.5 0 0 0-.257.838v8.402a1.5 1.5 0 0 0 1.5 1.5h5.43c1.407 0 2.615-.99 2.878-2.357l.785-4.083c.343-1.785-1.04-3.439-2.878-3.439h-1.213a.963.963 0 0 1-.935-1.222l.158-.554c.374-1.305-.618-2.602-1.99-2.602M4.212 7.104v9.032H3.021c-.796 0-1.44-.638-1.44-1.425V8.529c0-.787.644-1.425 1.44-1.425z"
  })));
};

var _path$1a;
function _extends$1a() { return _extends$1a = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1a.apply(null, arguments); }
var SvgThumbsUpFilled24 = function SvgThumbsUpFilled24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1a({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$1a || (_path$1a = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M10.487 3.815a2.6 2.6 0 0 1 2.161-1.144c1.724 0 2.97 1.629 2.5 3.269l-.21.738c-.263.918.435 1.83 1.4 1.83h1.617c2.35 0 4.12 2.115 3.68 4.398L20.59 18.35c-.336 1.748-1.881 3.013-3.68 3.013H9.392a2 2 0 0 1-2-2V9.017a2 2 0 0 1 .342-1.118zM5.592 9.47H4.268a1.91 1.91 0 0 0-1.921 1.9v8.097c0 1.05.86 1.9 1.92 1.9h1.325z"
  })));
};

var _path$19;
function _extends$19() { return _extends$19 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$19.apply(null, arguments); }
var SvgThumbsUpFilled32 = function SvgThumbsUpFilled32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$19({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$19 || (_path$19 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M14.239 5.163a3.28 3.28 0 0 1 2.722-1.441c2.17 0 3.74 2.051 3.149 4.116l-.281.984c-.385 1.346.637 2.684 2.052 2.684h2.156c3.012 0 5.281 2.71 4.719 5.636l-1.396 7.26c-.43 2.242-2.411 3.863-4.718 3.863h-10.38A2.667 2.667 0 0 1 9.596 25.6V12.865c0-.531.158-1.05.455-1.49zM7.596 12.597H5.787c-1.415 0-2.561 1.134-2.561 2.533v10.616c0 1.399 1.146 2.533 2.561 2.533h1.809z"
  })));
};

var _path$18;
function _extends$18() { return _extends$18 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$18.apply(null, arguments); }
var SvgThumbsUpFilled48 = function SvgThumbsUpFilled48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$18({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$18 || (_path$18 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M21.982 7.912a4.63 4.63 0 0 1 3.844-2.035c3.064 0 5.28 2.896 4.446 5.813l-.422 1.475c-.63 2.201 1.042 4.388 3.355 4.388h3.235c4.337 0 7.605 3.903 6.794 8.117l-2.093 10.89c-.62 3.227-3.473 5.563-6.794 5.563H18.703a4 4 0 0 1-4-4V19.93a4 4 0 0 1 .684-2.236zM12.304 18.905h-3.72c-2.121 0-3.842 1.701-3.842 3.8V38.32c0 2.098 1.72 3.8 3.843 3.8h3.718z"
  })));
};

var ThumbsUpFilledIcon = function ThumbsUpFilledIcon(props) {
  var thumbsUpFilled = {
    12: SvgThumbsUpFilled12,
    16: SvgThumbsUpFilled16,
    18: SvgThumbsUpFilled18,
    24: SvgThumbsUpFilled24,
    32: SvgThumbsUpFilled32,
    48: SvgThumbsUpFilled48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: thumbsUpFilled
  }, props));
};

var _path$17;
function _extends$17() { return _extends$17 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$17.apply(null, arguments); }
var SvgTruck12 = function SvgTruck12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$17({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$17 || (_path$17 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M1.4 3A1.6 1.6 0 0 1 3 1.4h3.333a1.6 1.6 0 0 1 1.578 1.333h.05A2.1 2.1 0 0 1 9.84 3.894l.538 1.076a2.1 2.1 0 0 1 .222.94v1.756a1.6 1.6 0 0 1-1.498 1.597 1.334 1.334 0 0 1-2.649.004H5.102a1.334 1.334 0 0 1-2.656-.1 1.6 1.6 0 0 1-1.046-1.5zm7.207 5.066H9a.4.4 0 0 0 .4-.4v-.91H7.95v1.033c.246.031.471.13.657.277m-1.124 1.2a.333.333 0 1 0 .59-.31.333.333 0 0 0-.59.31M4.11 9.111a.333.333 0 1 0-.667 0 .333.333 0 0 0 .667 0m2.622-1.044V3a.4.4 0 0 0-.4-.4H3a.4.4 0 0 0-.4.4v4.667a.4.4 0 0 0 .352.397c.227-.18.514-.286.826-.286.313 0 .601.108.829.289zm2.594-2.512-.022-.048-.538-1.076a.9.9 0 0 0-.805-.498H7.95v1.622z"
  })));
};

var _path$16;
function _extends$16() { return _extends$16 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$16.apply(null, arguments); }
var SvgTruck16 = function SvgTruck16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$16({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$16 || (_path$16 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M1.25 3.667c0-.967.784-1.75 1.75-1.75h7.333c.967 0 1.75.783 1.75 1.75v.25h.299a1.75 1.75 0 0 1 1.565.967l1.285 2.57c.121.243.185.51.185.782v3.43a1.75 1.75 0 0 1-1.75 1.75h-.39a2.084 2.084 0 0 1-3.888 0H7.278a2.084 2.084 0 0 1-3.889 0H3a1.75 1.75 0 0 1-1.75-1.75zM12.083 7.25h1.37l-.848-1.695a.25.25 0 0 0-.223-.138h-.299zm0 1.5v1.973a2.1 2.1 0 0 1 1.195 1.194h.389a.25.25 0 0 0 .25-.25V8.75zm-1.5-5.083a.25.25 0 0 0-.25-.25H3a.25.25 0 0 0-.25.25v8c0 .138.112.25.25.25h.39a2.084 2.084 0 0 1 3.888 0h2.111a2.1 2.1 0 0 1 1.194-1.194V3.665m-5.25 8.416a.583.583 0 1 0 0 1.167.583.583 0 0 0 0-1.167m6 0a.583.583 0 1 0 0 1.167.583.583 0 0 0 0-1.167"
  })));
};

var _path$15;
function _extends$15() { return _extends$15 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$15.apply(null, arguments); }
var SvgTruck18 = function SvgTruck18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$15({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$15 || (_path$15 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M1.45 4.125c0-1.063.862-1.925 1.925-1.925h8.25c1.063 0 1.925.862 1.925 1.925v.325h.38c.729 0 1.395.412 1.721 1.064l1.446 2.89c.133.268.203.563.203.862v3.859a1.925 1.925 0 0 1-1.925 1.925h-.468a2.3 2.3 0 0 1-4.314 0H8.157a2.3 2.3 0 0 1-4.314 0h-.468a1.925 1.925 0 0 1-1.925-1.925zm12.1 1.925V8.2h1.656l-.986-1.97a.33.33 0 0 0-.29-.18zm2.15 7.075V9.8h-2.15v2.293c.627.232 1.124.73 1.357 1.357h.468c.18 0 .325-.146.325-.325M11.625 3.8h-8.25a.325.325 0 0 0-.325.325v9c0 .18.145.325.325.325h.468a2.3 2.3 0 0 1 4.314 0h2.436a2.3 2.3 0 0 1 1.357-1.357V4.125a.325.325 0 0 0-.325-.325M6 13.55a.7.7 0 1 0 0 1.4.7.7 0 0 0 0-1.4m6.75 0a.7.7 0 1 0 0 1.4.7.7 0 0 0 0-1.4"
  })));
};

var _path$14;
function _extends$14() { return _extends$14 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$14.apply(null, arguments); }
var SvgTruck24 = function SvgTruck24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$14({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$14 || (_path$14 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M2.1 5.5a2.4 2.4 0 0 1 2.4-2.4h11a2.4 2.4 0 0 1 2.4 2.4v.6h.673a2.4 2.4 0 0 1 2.147 1.327l1.927 3.854c.166.333.253.7.253 1.073V17.5a2.4 2.4 0 0 1-2.4 2.4h-.742a2.901 2.901 0 0 1-5.516 0h-3.484a2.901 2.901 0 0 1-5.516 0H4.5a2.4 2.4 0 0 1-2.4-2.4zm15.8 2.4v3.2h2.644L19.11 8.232a.6.6 0 0 0-.537-.332zm3.2 9.6v-4.6h-3.2v3.342c.878.287 1.571.98 1.858 1.858h.742a.6.6 0 0 0 .6-.6M15.5 4.9h-11a.6.6 0 0 0-.6.6v12a.6.6 0 0 0 .6.6h.742a2.901 2.901 0 0 1 5.516 0h3.484a2.9 2.9 0 0 1 1.858-1.858V5.5a.6.6 0 0 0-.6-.6m1.5 13a1.1 1.1 0 1 0 0 2.2 1.1 1.1 0 0 0 0-2.2M6.9 19a1.099 1.099 0 1 0 2.2 0 1.099 1.099 0 0 0-1.733-.9c-.282.2-.467.528-.467.9"
  })));
};

var _path$13;
function _extends$13() { return _extends$13 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$13.apply(null, arguments); }
var SvgTruck32 = function SvgTruck32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$13({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$13 || (_path$13 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M3 7.333a3 3 0 0 1 3-3h14.667a3 3 0 0 1 3 3v1h1.097a3 3 0 0 1 2.683 1.659l2.57 5.138a3 3 0 0 1 .316 1.342v6.861a3 3 0 0 1-3 3h-1.138a3.668 3.668 0 0 1-7.057 0h-4.943a3.668 3.668 0 0 1-7.057 0H6a3 3 0 0 1-3-3zm20.667 3V15h4.048l-2.057-4.114a1 1 0 0 0-.894-.553zm-1 13.334a1.667 1.667 0 1 0 0 3.333 1.667 1.667 0 0 0 0-3.333m-12 0A1.664 1.664 0 0 0 9 25.333a1.664 1.664 0 0 0 3 1c.21-.278.333-.624.333-1a1.664 1.664 0 0 0-1.667-1.667M6 6.333a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h1.138a3.668 3.668 0 0 1 7.057 0h4.943a3.67 3.67 0 0 1 2.529-2.528V7.333a1 1 0 0 0-1-1zM23.667 17v4.805a3.67 3.67 0 0 1 2.528 2.528h1.138a1 1 0 0 0 1-1V17z"
  })));
};

var _path$12;
function _extends$12() { return _extends$12 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$12.apply(null, arguments); }
var SvgTruck48 = function SvgTruck48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$12({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$12 || (_path$12 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M9 6.8A4.2 4.2 0 0 0 4.8 11v24A4.2 4.2 0 0 0 9 39.2h1.94a5.202 5.202 0 0 0 10.12 0h7.88a5.202 5.202 0 0 0 10.12 0H41a4.2 4.2 0 0 0 4.2-4.2V24.708a4.2 4.2 0 0 0-.443-1.878l-3.854-7.708a4.2 4.2 0 0 0-3.757-2.322H35.2V11A4.2 4.2 0 0 0 31 6.8zm30.06 30a5.21 5.21 0 0 0-3.86-3.86V25.2h7.6V35a1.8 1.8 0 0 1-1.8 1.8zm-6.26-3.86a5.21 5.21 0 0 0-3.86 3.86h-7.88a5.202 5.202 0 0 0-10.12 0H9A1.8 1.8 0 0 1 7.2 35V11A1.8 1.8 0 0 1 9 9.2h22a1.8 1.8 0 0 1 1.8 1.8zm2.4-17.74h1.946a1.8 1.8 0 0 1 1.61.995l3.302 6.605H35.2zM16 35.2a2.8 2.8 0 1 1 0 5.6 2.8 2.8 0 0 1 0-5.6M31.2 38a2.8 2.8 0 1 1 5.6 0 2.8 2.8 0 0 1-5.6 0"
  })));
};

var TruckIcon = function TruckIcon(props) {
  var truck = {
    12: SvgTruck12,
    16: SvgTruck16,
    18: SvgTruck18,
    24: SvgTruck24,
    32: SvgTruck32,
    48: SvgTruck48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: truck
  }, props));
};

var _path$11;
function _extends$11() { return _extends$11 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$11.apply(null, arguments); }
var SvgTruckFilled12 = function SvgTruckFilled12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$11({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$11 || (_path$11 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M3 1.4A1.6 1.6 0 0 0 1.4 3v4.667a1.6 1.6 0 0 0 1.046 1.5 1.333 1.333 0 0 0 2.656.1h1.351a1.334 1.334 0 0 0 2.65-.004A1.6 1.6 0 0 0 10.6 7.666V5.91a2.1 2.1 0 0 0-.222-.939l-.61-1.222a1.84 1.84 0 0 0-1.855-1.003A1.6 1.6 0 0 0 6.333 1.4zm6.327 4.155H7.933V3.963a.635.635 0 0 1 .76.322l.612 1.222z",
    clipRule: "evenodd"
  })));
};

var _path$10;
function _extends$10() { return _extends$10 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$10.apply(null, arguments); }
var SvgTruckFilled16 = function SvgTruckFilled16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$10({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$10 || (_path$10 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M1.25 3.667c0-.967.784-1.75 1.75-1.75h6.6c.966 0 1.75.783 1.75 1.75v.4h.52c.511 0 .979.289 1.207.746l1.38 2.76c.094.188.143.395.143.604v3.74a1.35 1.35 0 0 1-1.27 1.347 2.084 2.084 0 0 1-3.941.152H7.498a.8.8 0 0 1-.21-.029 2.084 2.084 0 0 1-3.899.03H3a1.75 1.75 0 0 1-1.75-1.75zM13.33 8l-1.326-2.65a.15.15 0 0 0-.134-.083h-.52V8zM4.75 12.703a.583.583 0 1 0 .058-.292 1 1 0 0 0-.058.292m5.999-.036a.583.583 0 1 1 1.167 0 .583.583 0 0 1-1.167 0",
    clipRule: "evenodd"
  })));
};

var _path$$;
function _extends$$() { return _extends$$ = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$$.apply(null, arguments); }
var SvgTruckFilled18 = function SvgTruckFilled18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$$({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$$ || (_path$$ = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M1.45 4a1.8 1.8 0 0 1 1.8-1.8H11A1.8 1.8 0 0 1 12.8 4v.45h.457a1.8 1.8 0 0 1 1.61.995l1.493 2.986c.125.25.19.526.19.805v4.014a1.8 1.8 0 0 1-1.64 1.793 2.301 2.301 0 0 1-4.317.007H8.157a2.301 2.301 0 0 1-4.314 0H3.25a1.8 1.8 0 0 1-1.8-1.8zm13.406 5-1.42-2.84a.2.2 0 0 0-.18-.11H12.8V9zM5.3 14.25a.7.7 0 1 1 1.4 0 .7.7 0 0 1-1.4 0m6.75 0a.7.7 0 1 1 1.4 0 .7.7 0 0 1-1.4 0",
    clipRule: "evenodd"
  })));
};

var _path$_;
function _extends$_() { return _extends$_ = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$_.apply(null, arguments); }
var SvgTruckFilled24 = function SvgTruckFilled24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$_({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$_ || (_path$_ = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M2.35 5.5A2.15 2.15 0 0 1 4.5 3.35h11a2.15 2.15 0 0 1 2.15 2.15v.601a2.4 2.4 0 0 1 2.07 1.326l1.927 3.854c.166.333.253.7.253 1.073V17.5a2.4 2.4 0 0 1-2.138 2.386 2.901 2.901 0 0 1-5.589-.236h-3.346a2.901 2.901 0 0 1-5.654 0H4.5a2.15 2.15 0 0 1-2.15-2.15zM19.994 12 18.11 8.232a.6.6 0 0 0-.46-.327V12zM6.9 19a1.1 1.1 0 1 1 2.2 0 1.1 1.1 0 0 1-2.2 0m9 0a1.1 1.1 0 1 1 2.2 0 1.1 1.1 0 0 1-2.2 0",
    clipRule: "evenodd"
  })));
};

var _path$Z;
function _extends$Z() { return _extends$Z = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$Z.apply(null, arguments); }
var SvgTruckFilled32 = function SvgTruckFilled32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$Z({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$Z || (_path$Z = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M3.133 7.333A2.867 2.867 0 0 1 6 4.467h14.667a2.867 2.867 0 0 1 2.866 2.866v1.002a3 3 0 0 1 2.58 1.657l2.57 5.139A3 3 0 0 1 29 16.472v6.861a3 3 0 0 1-2.803 2.994 3.668 3.668 0 0 1-7.094-.127H14.23a3.668 3.668 0 0 1-7.127 0H6a2.867 2.867 0 0 1-2.867-2.866zM26.882 16l-2.557-5.114a1 1 0 0 0-.792-.547V16zM9 25.334a1.667 1.667 0 1 1 3.333 0 1.667 1.667 0 0 1-3.333 0m12 0a1.667 1.667 0 1 1 3.333 0 1.667 1.667 0 0 1-3.333 0",
    clipRule: "evenodd"
  })));
};

var _path$Y;
function _extends$Y() { return _extends$Y = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$Y.apply(null, arguments); }
var SvgTruckFilled48 = function SvgTruckFilled48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$Y({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$Y || (_path$Y = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M9 6.7A4.3 4.3 0 0 0 4.7 11v24A4.3 4.3 0 0 0 9 39.3h1.964a5.202 5.202 0 0 0 10.072 0h7.928a5.202 5.202 0 0 0 10.097-.1H40a4.19 4.19 0 0 0 2.94-1.2H43v-.06A4.19 4.19 0 0 0 44.2 35V24.708a4.2 4.2 0 0 0-.443-1.878l-3.854-7.708a4.2 4.2 0 0 0-3.757-2.322H35.3V11A4.3 4.3 0 0 0 31 6.7zm32.61 17.203q.023.048.045.097H35.3v-8.8h.846a1.8 1.8 0 0 1 1.61.995zM16 35.2a2.8 2.8 0 1 0 0 5.6 2.8 2.8 0 0 0 0-5.6m18 0a2.8 2.8 0 1 0 0 5.6 2.8 2.8 0 0 0 0-5.6",
    clipRule: "evenodd"
  })));
};

var TruckFilledIcon = function TruckFilledIcon(props) {
  var truckFilled = {
    12: SvgTruckFilled12,
    16: SvgTruckFilled16,
    18: SvgTruckFilled18,
    24: SvgTruckFilled24,
    32: SvgTruckFilled32,
    48: SvgTruckFilled48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: truckFilled
  }, props));
};

var _path$X;
function _extends$X() { return _extends$X = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$X.apply(null, arguments); }
var SvgTv12 = function SvgTv12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$X({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$X || (_path$X = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M3.225 9.9a.6.6 0 0 1 .6-.6h4.35a.6.6 0 0 1 0 1.2h-4.35a.6.6 0 0 1-.6-.6M.85 3.106a1.6 1.6 0 0 1 1.6-1.6h7.1a1.6 1.6 0 0 1 1.6 1.6v3.95a1.6 1.6 0 0 1-1.6 1.6h-7.1a1.6 1.6 0 0 1-1.6-1.6zm1.6-.4a.4.4 0 0 0-.4.4v3.95c0 .22.18.4.4.4h7.1a.4.4 0 0 0 .4-.4v-3.95a.4.4 0 0 0-.4-.4z",
    clipRule: "evenodd"
  })));
};

var _path$W;
function _extends$W() { return _extends$W = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$W.apply(null, arguments); }
var SvgTv16 = function SvgTv16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$W({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$W || (_path$W = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M4.383 13.166a.75.75 0 0 1 .75-.75h5.734a.75.75 0 0 1 0 1.5H5.133a.75.75 0 0 1-.75-.75M1.183 4.173c0-1.15.933-2.083 2.084-2.083h9.466c1.15 0 2.084.933 2.084 2.083V9.44c0 1.15-.933 2.083-2.084 2.083H3.267A2.083 2.083 0 0 1 1.183 9.44zm2.084-.583a.583.583 0 0 0-.584.583V9.44c0 .322.262.583.584.583h9.466a.583.583 0 0 0 .584-.583V4.173a.583.583 0 0 0-.584-.583z",
    clipRule: "evenodd"
  })));
};

var _path$V;
function _extends$V() { return _extends$V = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$V.apply(null, arguments); }
var SvgTv18 = function SvgTv18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$V({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$V || (_path$V = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M5.013 14.776a.8.8 0 0 1 .8-.8h6.375a.8.8 0 0 1 0 1.6H5.813a.8.8 0 0 1-.8-.8M1.375 4.734a2.3 2.3 0 0 1 2.3-2.3h10.65a2.3 2.3 0 0 1 2.3 2.3v6a2.3 2.3 0 0 1-2.3 2.3H3.675a2.3 2.3 0 0 1-2.3-2.3zm2.3-.7a.7.7 0 0 0-.7.7v6a.7.7 0 0 0 .7.7h10.65a.7.7 0 0 0 .7-.7v-6a.7.7 0 0 0-.7-.7z",
    clipRule: "evenodd"
  })));
};

var _path$U;
function _extends$U() { return _extends$U = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$U.apply(null, arguments); }
var SvgTv24 = function SvgTv24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$U({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$U || (_path$U = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M6.9 19.7a.9.9 0 0 1 .9-.9h8.4a.9.9 0 1 1 0 1.8H7.8a.9.9 0 0 1-.9-.9M2 6.31a2.9 2.9 0 0 1 2.9-2.9h14.2a2.9 2.9 0 0 1 2.9 2.9v8.2a2.9 2.9 0 0 1-2.9 2.9H4.9a2.9 2.9 0 0 1-2.9-2.9zm2.9-1.1a1.1 1.1 0 0 0-1.1 1.1v8.2a1.1 1.1 0 0 0 1.1 1.1h14.2a1.1 1.1 0 0 0 1.1-1.1v-8.2a1.1 1.1 0 0 0-1.1-1.1z",
    clipRule: "evenodd"
  })));
};

var _path$T;
function _extends$T() { return _extends$T = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$T.apply(null, arguments); }
var SvgTv32 = function SvgTv32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$T({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$T || (_path$T = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M9.4 26.2a1 1 0 0 1 1-1h11.2a1 1 0 1 1 0 2H10.4a1 1 0 0 1-1-1M2.867 8.58a3.667 3.667 0 0 1 3.666-3.666h18.934a3.667 3.667 0 0 1 3.666 3.667v11.2a3.667 3.667 0 0 1-3.666 3.666H6.533a3.667 3.667 0 0 1-3.666-3.666zm3.666-1.666c-.92 0-1.666.746-1.666 1.667v11.2c0 .92.746 1.666 1.666 1.666h18.934c.92 0 1.666-.746 1.666-1.666V8.58c0-.92-.746-1.667-1.666-1.667z",
    clipRule: "evenodd"
  })));
};

var _path$S;
function _extends$S() { return _extends$S = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$S.apply(null, arguments); }
var SvgTv48 = function SvgTv48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$S({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$S || (_path$S = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M14.4 39a1.2 1.2 0 0 1 1.2-1.2h16.8a1.2 1.2 0 0 1 0 2.4H15.6a1.2 1.2 0 0 1-1.2-1.2M4.6 13.02a5.2 5.2 0 0 1 5.2-5.2h28.4a5.2 5.2 0 0 1 5.2 5.2v17a5.2 5.2 0 0 1-5.2 5.2H9.8a5.2 5.2 0 0 1-5.2-5.2zm5.2-2.8a2.8 2.8 0 0 0-2.8 2.8v17a2.8 2.8 0 0 0 2.8 2.8h28.4a2.8 2.8 0 0 0 2.8-2.8v-17a2.8 2.8 0 0 0-2.8-2.8z",
    clipRule: "evenodd"
  })));
};

var TvIcon = function TvIcon(props) {
  var tv = {
    12: SvgTv12,
    16: SvgTv16,
    18: SvgTv18,
    24: SvgTv24,
    32: SvgTv32,
    48: SvgTv48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: tv
  }, props));
};

var _path$R;
function _extends$R() { return _extends$R = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$R.apply(null, arguments); }
var SvgUndo12 = function SvgUndo12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$R({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$R || (_path$R = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M4.424 1.576a.6.6 0 0 1 0 .848L2.95 3.9H7.5a3.1 3.1 0 1 1 0 6.2H6.25a.6.6 0 0 1 0-1.2H7.5a1.9 1.9 0 0 0 0-3.8H2.95l1.475 1.476a.6.6 0 1 1-.848.848L1.429 5.278a1.1 1.1 0 0 1 0-1.556l2.147-2.146a.6.6 0 0 1 .848 0",
    clipRule: "evenodd"
  })));
};

var _path$Q;
function _extends$Q() { return _extends$Q = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$Q.apply(null, arguments); }
var SvgUndo16 = function SvgUndo16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$Q({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$Q || (_path$Q = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M5.864 2.136a.75.75 0 0 1 0 1.061L3.81 5.25H10a4.083 4.083 0 0 1 0 8.167H8.333a.75.75 0 1 1 0-1.5H10a2.583 2.583 0 1 0 0-5.167H3.81l2.054 2.053a.75.75 0 1 1-1.061 1.06L1.941 7.003a1.417 1.417 0 0 1 0-2.004l2.862-2.862a.75.75 0 0 1 1.06 0",
    clipRule: "evenodd"
  })));
};

var _path$P;
function _extends$P() { return _extends$P = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$P.apply(null, arguments); }
var SvgUndo18 = function SvgUndo18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$P({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$P || (_path$P = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M6.566 2.434a.8.8 0 0 1 0 1.132L4.18 5.95h7.07a4.55 4.55 0 0 1 0 9.1H9.374a.8.8 0 0 1 0-1.6h1.875a2.95 2.95 0 0 0 0-5.9H4.181l2.385 2.384a.8.8 0 1 1-1.132 1.132l-3.22-3.22a1.55 1.55 0 0 1 0-2.192l3.22-3.22a.8.8 0 0 1 1.132 0",
    clipRule: "evenodd"
  })));
};

var _path$O;
function _extends$O() { return _extends$O = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$O.apply(null, arguments); }
var SvgUndo24 = function SvgUndo24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$O({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$O || (_path$O = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M8.636 3.364a.9.9 0 0 1 0 1.272L5.173 8.1H15a5.9 5.9 0 1 1 0 11.8h-2.5a.9.9 0 0 1 0-1.8H15a4.1 4.1 0 1 0 0-8.2H5.173l3.463 3.464a.9.9 0 0 1-1.272 1.272L3.07 10.345a1.9 1.9 0 0 1 0-2.687l4.293-4.293a.9.9 0 0 1 1.272 0",
    clipRule: "evenodd"
  })));
};

var _path$N;
function _extends$N() { return _extends$N = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$N.apply(null, arguments); }
var SvgUndo32 = function SvgUndo32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$N({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$N || (_path$N = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M11.374 4.626a1 1 0 0 1 0 1.414L6.414 11H20a7.667 7.667 0 0 1 0 15.333h-3.333a1 1 0 0 1 0-2H20A5.667 5.667 0 0 0 20 13H6.414l4.96 4.96a1 1 0 1 1-1.414 1.414L4.236 13.65a2.333 2.333 0 0 1 0-3.3L9.96 4.626a1 1 0 0 1 1.414 0",
    clipRule: "evenodd"
  })));
};

var _path$M;
function _extends$M() { return _extends$M = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$M.apply(null, arguments); }
var SvgUndo48 = function SvgUndo48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$M({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$M || (_path$M = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M16.849 7.152a1.2 1.2 0 0 1 0 1.697L8.897 16.8H30c6.186 0 11.2 5.014 11.2 11.2S36.186 39.2 30 39.2h-5a1.2 1.2 0 0 1 0-2.4h5a8.8 8.8 0 1 0 0-17.6H8.897l7.952 7.951a1.2 1.2 0 0 1-1.697 1.698l-8.586-8.586a3.2 3.2 0 0 1 0-4.526l8.586-8.585a1.2 1.2 0 0 1 1.697 0",
    clipRule: "evenodd"
  })));
};

var UndoIcon = function UndoIcon(props) {
  var undo = {
    12: SvgUndo12,
    16: SvgUndo16,
    18: SvgUndo18,
    24: SvgUndo24,
    32: SvgUndo32,
    48: SvgUndo48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: undo
  }, props));
};

var _path$L, _path2$i;
function _extends$L() { return _extends$L = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$L.apply(null, arguments); }
var SvgUpload12 = function SvgUpload12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$L({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$L || (_path$L = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M6 4a.7.7 0 0 1 .7.7v.6h.6a.7.7 0 1 1 0 1.4h-.6v.6a.7.7 0 1 1-1.4 0v-.6h-.6a.7.7 0 1 1 0-1.4h.6v-.6A.7.7 0 0 1 6 4"
  })), _path2$i || (_path2$i = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M3.5 1.5a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h5a2 2 0 0 0 2-2v-5a2 2 0 0 0-2-2zm5 1.4h-5a.6.6 0 0 0-.6.6v5a.6.6 0 0 0 .6.6h5a.6.6 0 0 0 .6-.6v-5a.6.6 0 0 0-.6-.6",
    clipRule: "evenodd"
  })));
};

var _path$K, _path2$h;
function _extends$K() { return _extends$K = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$K.apply(null, arguments); }
var SvgUpload16 = function SvgUpload16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$K({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$K || (_path$K = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M8 5.333a.8.8 0 0 1 .8.8V7.2h1.067a.8.8 0 0 1 0 1.6H8.8v1.067a.8.8 0 0 1-1.6 0V8.8H6.133a.8.8 0 0 1 0-1.6H7.2V6.133a.8.8 0 0 1 .8-.8"
  })), _path2$h || (_path2$h = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M4.667 2A2.667 2.667 0 0 0 2 4.667v6.666A2.667 2.667 0 0 0 4.667 14h6.666A2.667 2.667 0 0 0 14 11.333V4.667A2.667 2.667 0 0 0 11.333 2zm6.666 1.6H4.667c-.59 0-1.067.478-1.067 1.067v6.666c0 .59.478 1.067 1.067 1.067h6.666c.59 0 1.067-.478 1.067-1.067V4.667c0-.59-.478-1.067-1.067-1.067",
    clipRule: "evenodd"
  })));
};

var _path$J, _path2$g;
function _extends$J() { return _extends$J = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$J.apply(null, arguments); }
var SvgUpload18 = function SvgUpload18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$J({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$J || (_path$J = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M9 6a.8.8 0 0 1 .8.8v1.4h1.4a.8.8 0 0 1 0 1.6H9.8v1.4a.8.8 0 0 1-1.6 0V9.8H6.8a.8.8 0 1 1 0-1.6h1.4V6.8A.8.8 0 0 1 9 6"
  })), _path2$g || (_path2$g = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M5.25 2.25a3 3 0 0 0-3 3v7.5a3 3 0 0 0 3 3h7.5a3 3 0 0 0 3-3v-7.5a3 3 0 0 0-3-3zm7.5 1.6h-7.5a1.4 1.4 0 0 0-1.4 1.4v7.5a1.4 1.4 0 0 0 1.4 1.4h7.5a1.4 1.4 0 0 0 1.4-1.4v-7.5a1.4 1.4 0 0 0-1.4-1.4",
    clipRule: "evenodd"
  })));
};

var _path$I, _path2$f;
function _extends$I() { return _extends$I = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$I.apply(null, arguments); }
var SvgUpload24 = function SvgUpload24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$I({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$I || (_path$I = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M12.2 8a.9.9 0 0 1 .9.9v2.2h2a.9.9 0 0 1 0 1.8h-2v2.2a.9.9 0 0 1-1.8 0v-2.2H8.9a.9.9 0 1 1 0-1.8h2.4V8.9a.9.9 0 0 1 .9-.9"
  })), _path2$f || (_path2$f = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M7 3a4 4 0 0 0-4 4v10a4 4 0 0 0 4 4h10a4 4 0 0 0 4-4V7a4 4 0 0 0-4-4zm10 1.8H7A2.2 2.2 0 0 0 4.8 7v10A2.2 2.2 0 0 0 7 19.2h10a2.2 2.2 0 0 0 2.2-2.2V7A2.2 2.2 0 0 0 17 4.8",
    clipRule: "evenodd"
  })));
};

var _path$H, _path2$e;
function _extends$H() { return _extends$H = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$H.apply(null, arguments); }
var SvgUpload32 = function SvgUpload32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$H({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$H || (_path$H = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M16 10.667a1 1 0 0 1 1 1V15h3.333a1 1 0 1 1 0 2H17v3.333a1 1 0 1 1-2 0V17h-3.333a1 1 0 0 1 0-2H15v-3.333a1 1 0 0 1 1-1"
  })), _path2$e || (_path2$e = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M9.333 4A5.333 5.333 0 0 0 4 9.333v13.334A5.333 5.333 0 0 0 9.333 28h13.334A5.333 5.333 0 0 0 28 22.667V9.333A5.333 5.333 0 0 0 22.667 4zm13.334 2H9.333A3.333 3.333 0 0 0 6 9.333v13.334A3.333 3.333 0 0 0 9.333 26h13.334A3.333 3.333 0 0 0 26 22.667V9.333A3.333 3.333 0 0 0 22.667 6",
    clipRule: "evenodd"
  })));
};

var _path$G, _path2$d, _path3$6;
function _extends$G() { return _extends$G = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$G.apply(null, arguments); }
var SvgUpload48 = function SvgUpload48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$G({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$G || (_path$G = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M34 8.4H14A5.6 5.6 0 0 0 8.4 14v20a5.6 5.6 0 0 0 5.6 5.6h20a5.6 5.6 0 0 0 5.6-5.6V14A5.6 5.6 0 0 0 34 8.4M14 6a8 8 0 0 0-8 8v20a8 8 0 0 0 8 8h20a8 8 0 0 0 8-8V14a8 8 0 0 0-8-8z",
    clipRule: "evenodd"
  })), _path2$d || (_path2$d = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M24 16a1.2 1.2 0 0 1 1.2 1.2v13.6a1.2 1.2 0 0 1-2.4 0V17.2A1.2 1.2 0 0 1 24 16",
    clipRule: "evenodd"
  })), _path3$6 || (_path3$6 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M32 24a1.2 1.2 0 0 1-1.2 1.2H17.2a1.2 1.2 0 0 1 0-2.4h13.6A1.2 1.2 0 0 1 32 24",
    clipRule: "evenodd"
  })));
};

var UploadIcon = function UploadIcon(props) {
  var upload = {
    12: SvgUpload12,
    16: SvgUpload16,
    18: SvgUpload18,
    24: SvgUpload24,
    32: SvgUpload32,
    48: SvgUpload48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: upload
  }, props));
};

var _path$F;
function _extends$F() { return _extends$F = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$F.apply(null, arguments); }
var SvgViewListFilled12 = function SvgViewListFilled12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$F({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$F || (_path$F = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M1.5 3A1.5 1.5 0 0 1 3 1.5h6A1.5 1.5 0 0 1 10.5 3v1A1.5 1.5 0 0 1 9 5.5H3A1.5 1.5 0 0 1 1.5 4zM1.5 8A1.5 1.5 0 0 1 3 6.5h6A1.5 1.5 0 0 1 10.5 8v1A1.5 1.5 0 0 1 9 10.5H3A1.5 1.5 0 0 1 1.5 9z"
  })));
};

var _path$E;
function _extends$E() { return _extends$E = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$E.apply(null, arguments); }
var SvgViewListFilled16 = function SvgViewListFilled16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$E({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$E || (_path$E = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M2 4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v1.333a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2zM2 10.667a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2V12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2z"
  })));
};

var _path$D;
function _extends$D() { return _extends$D = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$D.apply(null, arguments); }
var SvgViewListFilled18 = function SvgViewListFilled18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$D({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$D || (_path$D = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M2.25 4.5A2.25 2.25 0 0 1 4.5 2.25h9a2.25 2.25 0 0 1 2.25 2.25V6a2.25 2.25 0 0 1-2.25 2.25h-9A2.25 2.25 0 0 1 2.25 6zM2.25 12A2.25 2.25 0 0 1 4.5 9.75h9A2.25 2.25 0 0 1 15.75 12v1.5a2.25 2.25 0 0 1-2.25 2.25h-9a2.25 2.25 0 0 1-2.25-2.25z"
  })));
};

var _path$C;
function _extends$C() { return _extends$C = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$C.apply(null, arguments); }
var SvgViewListFilled24 = function SvgViewListFilled24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$C({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$C || (_path$C = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M3 6a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v2a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3zM3 16a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v2a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3z"
  })));
};

var _path$B;
function _extends$B() { return _extends$B = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$B.apply(null, arguments); }
var SvgViewListFilled32 = function SvgViewListFilled32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$B({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$B || (_path$B = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M4 8a4 4 0 0 1 4-4h16a4 4 0 0 1 4 4v2.667a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4zM4 21.333a4 4 0 0 1 4-4h16a4 4 0 0 1 4 4V24a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4z"
  })));
};

var _path$A;
function _extends$A() { return _extends$A = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$A.apply(null, arguments); }
var SvgViewListFilled48 = function SvgViewListFilled48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$A({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$A || (_path$A = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M6 12a6 6 0 0 1 6-6h24a6 6 0 0 1 6 6v4a6 6 0 0 1-6 6H12a6 6 0 0 1-6-6zM6 32a6 6 0 0 1 6-6h24a6 6 0 0 1 6 6v4a6 6 0 0 1-6 6H12a6 6 0 0 1-6-6z"
  })));
};

var ViewListFilledIcon = function ViewListFilledIcon(props) {
  var viewListFilled = {
    12: SvgViewListFilled12,
    16: SvgViewListFilled16,
    18: SvgViewListFilled18,
    24: SvgViewListFilled24,
    32: SvgViewListFilled32,
    48: SvgViewListFilled48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: viewListFilled
  }, props));
};

var _path$z;
function _extends$z() { return _extends$z = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$z.apply(null, arguments); }
var SvgViewThumbnailFilled12 = function SvgViewThumbnailFilled12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$z({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$z || (_path$z = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M1.5 2.5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1zM1.5 7.5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1zM6.5 2.5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1zM6.5 7.5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1z"
  })));
};

var _path$y;
function _extends$y() { return _extends$y = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$y.apply(null, arguments); }
var SvgViewThumbnailFilled16 = function SvgViewThumbnailFilled16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$y({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$y || (_path$y = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M2 3.3A1.3 1.3 0 0 1 3.3 2h2.9a1.3 1.3 0 0 1 1.3 1.3v2.9a1.3 1.3 0 0 1-1.3 1.3H3.3A1.3 1.3 0 0 1 2 6.2zM2 9.8a1.3 1.3 0 0 1 1.3-1.3h2.9a1.3 1.3 0 0 1 1.3 1.3v2.9A1.3 1.3 0 0 1 6.2 14H3.3A1.3 1.3 0 0 1 2 12.7zM8.5 3.3A1.3 1.3 0 0 1 9.8 2h2.9A1.3 1.3 0 0 1 14 3.3v2.9a1.3 1.3 0 0 1-1.3 1.3H9.8a1.3 1.3 0 0 1-1.3-1.3zM8.5 9.8a1.3 1.3 0 0 1 1.3-1.3h2.9A1.3 1.3 0 0 1 14 9.8v2.9a1.3 1.3 0 0 1-1.3 1.3H9.8a1.3 1.3 0 0 1-1.3-1.3z"
  })));
};

var _path$x;
function _extends$x() { return _extends$x = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$x.apply(null, arguments); }
var SvgViewThumbnailFilled18 = function SvgViewThumbnailFilled18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$x({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$x || (_path$x = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M2.25 3.75a1.5 1.5 0 0 1 1.5-1.5h3a1.5 1.5 0 0 1 1.5 1.5v3a1.5 1.5 0 0 1-1.5 1.5h-3a1.5 1.5 0 0 1-1.5-1.5zM2.25 11.25a1.5 1.5 0 0 1 1.5-1.5h3a1.5 1.5 0 0 1 1.5 1.5v3a1.5 1.5 0 0 1-1.5 1.5h-3a1.5 1.5 0 0 1-1.5-1.5zM9.75 3.75a1.5 1.5 0 0 1 1.5-1.5h3a1.5 1.5 0 0 1 1.5 1.5v3a1.5 1.5 0 0 1-1.5 1.5h-3a1.5 1.5 0 0 1-1.5-1.5zM9.75 11.25a1.5 1.5 0 0 1 1.5-1.5h3a1.5 1.5 0 0 1 1.5 1.5v3a1.5 1.5 0 0 1-1.5 1.5h-3a1.5 1.5 0 0 1-1.5-1.5z"
  })));
};

var _path$w;
function _extends$w() { return _extends$w = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$w.apply(null, arguments); }
var SvgViewThumbnailFilled24 = function SvgViewThumbnailFilled24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$w({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$w || (_path$w = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M3 5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zM3 15a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zM13 5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2zM13 15a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2z"
  })));
};

var _path$v;
function _extends$v() { return _extends$v = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$v.apply(null, arguments); }
var SvgViewThumbnailFilled32 = function SvgViewThumbnailFilled32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$v({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$v || (_path$v = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M4 7a3 3 0 0 1 3-3h4.6a3 3 0 0 1 3 3v4.6a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3zM4 20.4a3 3 0 0 1 3-3h4.6a3 3 0 0 1 3 3V25a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3zM17.4 7a3 3 0 0 1 3-3H25a3 3 0 0 1 3 3v4.6a3 3 0 0 1-3 3h-4.6a3 3 0 0 1-3-3zM17.4 20.4a3 3 0 0 1 3-3H25a3 3 0 0 1 3 3V25a3 3 0 0 1-3 3h-4.6a3 3 0 0 1-3-3z"
  })));
};

var _path$u;
function _extends$u() { return _extends$u = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$u.apply(null, arguments); }
var SvgViewThumbnailFilled48 = function SvgViewThumbnailFilled48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$u({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$u || (_path$u = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M6 10a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4v8a4 4 0 0 1-4 4h-8a4 4 0 0 1-4-4zM6 30a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4v8a4 4 0 0 1-4 4h-8a4 4 0 0 1-4-4zM26 10a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4v8a4 4 0 0 1-4 4h-8a4 4 0 0 1-4-4zM26 30a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4v8a4 4 0 0 1-4 4h-8a4 4 0 0 1-4-4z"
  })));
};

var ViewThumbnailFilledIcon = function ViewThumbnailFilledIcon(props) {
  var viewThumbnailFilled = {
    12: SvgViewThumbnailFilled12,
    16: SvgViewThumbnailFilled16,
    18: SvgViewThumbnailFilled18,
    24: SvgViewThumbnailFilled24,
    32: SvgViewThumbnailFilled32,
    48: SvgViewThumbnailFilled48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: viewThumbnailFilled
  }, props));
};

var _path$t, _path2$c, _path3$5;
function _extends$t() { return _extends$t = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$t.apply(null, arguments); }
var SvgWifi12 = function SvgWifi12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$t({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$t || (_path$t = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M1.603 3.726a6.2 6.2 0 0 1 8.769 0l.603.603a.7.7 0 1 1-.99.99l-.603-.603a4.8 4.8 0 0 0-6.789 0l-.603.603A.7.7 0 1 1 1 4.33z",
    clipRule: "evenodd"
  })), _path2$c || (_path2$c = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M3.01 6.047a4.2 4.2 0 0 1 5.955 0l.147.148a.7.7 0 0 1-.993.987l-.146-.147a2.8 2.8 0 0 0-3.97 0l-.147.147a.7.7 0 1 1-.993-.987z",
    clipRule: "evenodd"
  })), _path3$5 || (_path3$5 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M6.8 7.794a1.176 1.176 0 1 0-1.626 1.698 1.176 1.176 0 0 0 1.627-1.698"
  })));
};

var _path$s, _path2$b, _path3$4;
function _extends$s() { return _extends$s = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$s.apply(null, arguments); }
var SvgWifi16 = function SvgWifi16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$s({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$s || (_path$s = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M2.185 5.017a8.2 8.2 0 0 1 11.597 0l.804.804a.867.867 0 0 1-1.226 1.226l-.804-.804a6.467 6.467 0 0 0-9.145 0l-.804.804A.867.867 0 0 1 1.38 5.82z",
    clipRule: "evenodd"
  })), _path2$b || (_path2$b = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M4.06 8.112a5.533 5.533 0 0 1 7.847 0l.195.196a.867.867 0 1 1-1.23 1.223l-.194-.197a3.8 3.8 0 0 0-5.389 0l-.195.197a.867.867 0 1 1-1.23-1.223z",
    clipRule: "evenodd"
  })), _path3$4 || (_path3$4 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M9.022 10.442a1.501 1.501 0 1 0-2.077 2.168 1.501 1.501 0 0 0 2.077-2.168"
  })));
};

var _path$r, _path2$a, _path3$3;
function _extends$r() { return _extends$r = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$r.apply(null, arguments); }
var SvgWifi18 = function SvgWifi18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$r({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$r || (_path$r = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M2.485 5.67a9.19 9.19 0 0 1 12.993 0l.904.904A.938.938 0 0 1 15.057 7.9l-.905-.905a7.313 7.313 0 0 0-10.341 0l-.905.905A.938.938 0 0 1 1.58 6.574z",
    clipRule: "evenodd"
  })), _path2$a || (_path2$a = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M4.594 9.151a6.19 6.19 0 0 1 8.774 0l.22.221a.937.937 0 1 1-1.33 1.322l-.219-.22a4.313 4.313 0 0 0-6.115 0l-.22.22a.938.938 0 0 1-1.33-1.322z",
    clipRule: "evenodd"
  })), _path3$3 || (_path3$3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M10.124 11.774a1.651 1.651 0 1 0-2.285 2.384 1.651 1.651 0 0 0 2.284-2.384"
  })));
};

var _path$q, _path2$9, _path3$2;
function _extends$q() { return _extends$q = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$q.apply(null, arguments); }
var SvgWifi24 = function SvgWifi24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$q({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$q || (_path$q = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M3.348 7.595c4.765-4.765 12.49-4.765 17.254 0L21.808 8.8a1.2 1.2 0 0 1-1.697 1.697l-1.206-1.206c-3.828-3.827-10.033-3.827-13.86 0L3.84 10.498A1.2 1.2 0 0 1 2.142 8.8z",
    clipRule: "evenodd"
  })), _path2$9 || (_path2$9 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M6.161 12.237a8.2 8.2 0 0 1 11.628 0l.293.294a1.2 1.2 0 0 1-1.702 1.693l-.293-.295a5.8 5.8 0 0 0-8.224 0l-.293.295a1.2 1.2 0 0 1-1.702-1.693z",
    clipRule: "evenodd"
  })), _path3$2 || (_path3$2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M13.473 15.734a2.152 2.152 0 1 0-2.977 3.108 2.152 2.152 0 0 0 2.977-3.108"
  })));
};

var _path$p, _path2$8, _path3$1;
function _extends$p() { return _extends$p = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$p.apply(null, arguments); }
var SvgWifi32 = function SvgWifi32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$p({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$p || (_path$p = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M4.559 10.221c6.3-6.3 16.515-6.3 22.816 0l1.608 1.608a1.467 1.467 0 1 1-2.075 2.075L25.3 12.296c-5.155-5.155-13.512-5.155-18.667 0l-1.608 1.608a1.467 1.467 0 1 1-2.074-2.075z",
    clipRule: "evenodd"
  })), _path2$8 || (_path2$8 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M8.31 16.41c4.222-4.244 11.092-4.244 15.314 0l.39.393a1.467 1.467 0 0 1-2.08 2.069l-.39-.393a7.867 7.867 0 0 0-11.155 0l-.39.393a1.467 1.467 0 1 1-2.08-2.069z",
    clipRule: "evenodd"
  })), _path3$1 || (_path3$1 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M17.859 21.076a2.735 2.735 0 1 0-3.785 3.95 2.735 2.735 0 0 0 3.785-3.95"
  })));
};

var _path$o, _path2$7, _path3;
function _extends$o() { return _extends$o = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$o.apply(null, arguments); }
var SvgWifi48 = function SvgWifi48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$o({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$o || (_path$o = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M6.98 15.473c9.372-9.373 24.568-9.373 33.94 0l2.413 2.412a2 2 0 0 1-2.829 2.828l-2.412-2.412c-7.81-7.81-20.474-7.81-28.284 0l-2.412 2.412a2 2 0 1 1-2.829-2.828z",
    clipRule: "evenodd"
  })), _path2$7 || (_path2$7 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M12.606 24.756c6.255-6.289 16.433-6.289 22.688 0l.586.59a2 2 0 0 1-2.836 2.82l-.586-.589c-4.691-4.717-12.325-4.717-17.016 0l-.586.59a2 2 0 1 1-2.836-2.822z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M26.65 31.758a3.903 3.903 0 1 0-5.4 5.637 3.903 3.903 0 0 0 5.4-5.637"
  })));
};

var WifiIcon = function WifiIcon(props) {
  var wifi = {
    12: SvgWifi12,
    16: SvgWifi16,
    18: SvgWifi18,
    24: SvgWifi24,
    32: SvgWifi32,
    48: SvgWifi48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: wifi
  }, props));
};

var _path$n;
function _extends$n() { return _extends$n = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$n.apply(null, arguments); }
var SvgWon12 = function SvgWon12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$n({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$n || (_path$n = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M1.87 1.914a.6.6 0 0 1 .716.456l.673 3.03h1.482l.673-3.03a.6.6 0 0 1 1.172 0l.673 3.03h1.482l.673-3.03a.6.6 0 0 1 1.172.26L9.97 5.4H11a.6.6 0 1 1 0 1.2H9.703l-.63 2.834c-.255 1.148-1.892 1.148-2.147 0L6.296 6.6h-.593l-.63 2.834c-.255 1.148-1.892 1.148-2.147 0L2.296 6.6H1a.6.6 0 0 1 0-1.2h1.03l-.616-2.77a.6.6 0 0 1 .456-.716M3.526 6.6 4 8.734 4.474 6.6zM5.97 5.4h.06L6 5.266zm1.556 1.2L8 8.734 8.474 6.6z",
    clipRule: "evenodd"
  })));
};

var _path$m;
function _extends$m() { return _extends$m = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$m.apply(null, arguments); }
var SvgWon16 = function SvgWon16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$m({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$m || (_path$m = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M2.504 2.601a.75.75 0 0 1 .895.57l.906 4.08h2.056l.907-4.08a.75.75 0 0 1 1.464 0l.907 4.08h2.056l.906-4.08a.75.75 0 0 1 1.464.325l-.834 3.754h1.436a.75.75 0 0 1 0 1.5h-1.77l-.848 3.818c-.328 1.479-2.437 1.479-2.765 0L8.435 8.75h-.87l-.849 3.818c-.329 1.479-2.437 1.479-2.766 0L3.102 8.75H1.333a.75.75 0 0 1 0-1.5H2.77l-.835-3.754a.75.75 0 0 1 .57-.895m2.135 6.15.694 3.125.695-3.126zm3.259-1.5h.204L8 6.79zm2.074 1.5.695 3.125.694-3.126z",
    clipRule: "evenodd"
  })));
};

var _path$l;
function _extends$l() { return _extends$l = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$l.apply(null, arguments); }
var SvgWon18 = function SvgWon18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$l({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$l || (_path$l = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M2.826 2.969a.8.8 0 0 1 .955.607L4.808 8.2h2.384l1.027-4.624a.8.8 0 0 1 1.562 0L10.808 8.2h2.383l1.028-4.624a.8.8 0 1 1 1.562.347L14.83 8.2H16.5a.8.8 0 0 1 0 1.6h-2.025l-.962 4.329c-.36 1.618-2.666 1.618-3.026 0l-.962-4.33h-1.05l-.962 4.33c-.36 1.618-2.667 1.618-3.026 0l-.962-4.33H1.5a.8.8 0 1 1 0-1.6h1.67l-.951-4.276a.8.8 0 0 1 .607-.954m2.338 6.83L6 13.563 6.836 9.8zM8.83 8.2h.338L9 7.439zm2.333 1.6L12 13.563l.836-3.762z",
    clipRule: "evenodd"
  })));
};

var _path$k, _path2$6;
function _extends$k() { return _extends$k = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$k.apply(null, arguments); }
var SvgWon24 = function SvgWon24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$k({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$k || (_path$k = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M1.1 12a.9.9 0 0 1 .9-.9h20a.9.9 0 0 1 0 1.8H2a.9.9 0 0 1-.9-.9",
    clipRule: "evenodd"
  })), _path2$6 || (_path2$6 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M3.805 4.121a.9.9 0 0 1 1.074.684l3.023 13.607q.012.043.018.049l.01.01a.12.12 0 0 0 .07.02.12.12 0 0 0 .07-.02l.01-.01a.2.2 0 0 0 .018-.049L11.12 4.805a.9.9 0 0 1 1.758 0l3.024 13.607q.01.043.017.049l.01.01a.12.12 0 0 0 .07.02c.037 0 .06-.012.07-.02l.01-.01a.2.2 0 0 0 .018-.049l3.024-13.607a.9.9 0 0 1 1.757.39l-3.024 13.607c-.441 1.984-3.269 1.984-3.71 0L12 9.15l-2.145 9.653c-.441 1.984-3.269 1.984-3.71 0L3.122 5.195a.9.9 0 0 1 .683-1.074",
    clipRule: "evenodd"
  })));
};

var _path$j, _path2$5;
function _extends$j() { return _extends$j = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$j.apply(null, arguments); }
var SvgWon32 = function SvgWon32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$j({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$j || (_path$j = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M1.667 16a1 1 0 0 1 1-1h26.666a1 1 0 1 1 0 2H2.667a1 1 0 0 1-1-1",
    clipRule: "evenodd"
  })), _path2$5 || (_path2$5 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M5.117 3.69a1 1 0 0 1 1.193.76l4.357 19.607L15.024 4.45a1 1 0 0 1 1.952 0l4.358 19.607L25.69 4.45a1 1 0 0 1 1.952.434L23.286 24.49c-.464 2.088-3.44 2.088-3.905 0l-3.38-15.215-3.382 15.215c-.464 2.088-3.44 2.088-3.905 0L4.357 4.884a1 1 0 0 1 .76-1.193",
    clipRule: "evenodd"
  })));
};

var _path$i;
function _extends$i() { return _extends$i = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$i.apply(null, arguments); }
var SvgWon48 = function SvgWon48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$i({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$i || (_path$i = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M9.171 6.74a1.2 1.2 0 1 0-2.342.52l3.453 15.54H4a1.2 1.2 0 0 0 0 2.4h6.815l3.037 13.668c.51 2.296 3.785 2.296 4.296 0L21.185 25.2h5.63l3.037 13.668c.51 2.296 3.785 2.296 4.296 0L37.185 25.2H44a1.2 1.2 0 0 0 0-2.4h-6.282l3.453-15.54a1.2 1.2 0 0 0-2.342-.52l-3.57 16.06H28.74L25.172 6.74a1.2 1.2 0 0 0-2.343 0l-3.57 16.06H12.74zm4.103 18.46L16 37.468 18.726 25.2zm8.444-2.4h4.564L24 12.532zm7.556 2.4L32 37.468 34.726 25.2z",
    clipRule: "evenodd"
  })));
};

var WonIcon = function WonIcon(props) {
  var won = {
    12: SvgWon12,
    16: SvgWon16,
    18: SvgWon18,
    24: SvgWon24,
    32: SvgWon32,
    48: SvgWon48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: won
  }, props));
};

var _path$h;
function _extends$h() { return _extends$h = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$h.apply(null, arguments); }
var SvgWrite12 = function SvgWrite12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$h({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$h || (_path$h = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M3.2 9.3h.303L9.15 3.65a.214.214 0 1 0-.302-.303L3.2 8.997zM2 10V8.707a.5.5 0 0 1 .146-.354L8 2.5a1.414 1.414 0 1 1 2 2l-5.854 5.854a.5.5 0 0 1-.353.146H2.5A.5.5 0 0 1 2 10",
    clipRule: "evenodd"
  })));
};

var _path$g, _path2$4;
function _extends$g() { return _extends$g = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$g.apply(null, arguments); }
var SvgWrite16 = function SvgWrite16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$g({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$g || (_path$g = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M4.167 12.5h.545l7.56-7.56a.386.386 0 0 0-.545-.546l-7.56 7.56zm-1.5.833V11.61c0-.176.07-.346.195-.471l7.804-7.805A1.886 1.886 0 0 1 13.333 6l-7.805 7.805a.67.67 0 0 1-.471.195H3.333a.667.667 0 0 1-.667-.667",
    clipRule: "evenodd"
  })), _path2$4 || (_path2$4 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "m11.47 7.197-2-2 1.06-1.06 2 2z",
    clipRule: "evenodd"
  })));
};

var _path$f, _path2$3;
function _extends$f() { return _extends$f = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$f.apply(null, arguments); }
var SvgWrite18 = function SvgWrite18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$f({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$f || (_path$f = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M4.6 14.15h.737l8.532-8.531L15 6.75l-8.707 8.707a1 1 0 0 1-.707.293H4a1 1 0 0 1-1-1v-1.586a1 1 0 0 1 .293-.707L12 3.75a2.121 2.121 0 0 1 3 3l-1.131-1.131a.521.521 0 0 0-.738-.738L4.6 13.413z",
    clipRule: "evenodd"
  })), _path2$3 || (_path2$3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "m12.934 8.066-2.25-2.25 1.132-1.132 2.25 2.25z",
    clipRule: "evenodd"
  })));
};

var _path$e, _path2$2;
function _extends$e() { return _extends$e = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$e.apply(null, arguments); }
var SvgWrite24 = function SvgWrite24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$e({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$e || (_path$e = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M5.8 19.2h1.454L18.727 7.727a1.028 1.028 0 0 0-1.454-1.454L5.8 17.746zM4 20v-2.586a1 1 0 0 1 .293-.707L16 5a2.828 2.828 0 1 1 4 4L8.293 20.707a1 1 0 0 1-.707.293H5a1 1 0 0 1-1-1",
    clipRule: "evenodd"
  })), _path2$2 || (_path2$2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "m17.364 10.637-3-3 1.272-1.273 3 3z",
    clipRule: "evenodd"
  })));
};

var _path$d, _path2$1;
function _extends$d() { return _extends$d = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$d.apply(null, arguments); }
var SvgWrite32 = function SvgWrite32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$d({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$d || (_path$d = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M7.333 23.495V26h2.505l15.414-15.414a1.77 1.77 0 0 0 0-2.505l1.415-1.414a3.77 3.77 0 0 1 0 5.333L11.252 27.414A2 2 0 0 1 9.838 28H7.333a2 2 0 0 1-2-2v-2.505a2 2 0 0 1 .586-1.414L21.333 6.667a3.77 3.77 0 0 1 5.334 0L25.252 8.08a1.77 1.77 0 0 0-2.504 0z",
    clipRule: "evenodd"
  })), _path2$1 || (_path2$1 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "m23.293 14.04-4-4 1.414-1.414 4 4z",
    clipRule: "evenodd"
  })));
};

var _path$c, _path2;
function _extends$c() { return _extends$c = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$c.apply(null, arguments); }
var SvgWrite48 = function SvgWrite48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$c({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$c || (_path$c = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "M10.4 35.243V39a.6.6 0 0 0 .6.6h3.757a.6.6 0 0 0 .425-.176l23.12-23.12a3.257 3.257 0 0 0-4.605-4.607L10.576 34.818a.6.6 0 0 0-.176.425M8 39v-3.757a3 3 0 0 1 .879-2.122L32 10.001a5.657 5.657 0 0 1 8 8L16.879 41.12a3 3 0 0 1-2.122.88H11a3 3 0 0 1-3-3",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    fillRule: "evenodd",
    d: "m35.152 20.849-6-6 1.697-1.697 6 6z",
    clipRule: "evenodd"
  })));
};

var WriteIcon = function WriteIcon(props) {
  var write = {
    12: SvgWrite12,
    16: SvgWrite16,
    18: SvgWrite18,
    24: SvgWrite24,
    32: SvgWrite32,
    48: SvgWrite48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: write
  }, props));
};

var _path$b;
function _extends$b() { return _extends$b = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$b.apply(null, arguments); }
var SvgWriteFilled12 = function SvgWriteFilled12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$b({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$b || (_path$b = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M2 10.25V8.603a.25.25 0 0 1 .073-.176l4.594-4.594a.5.5 0 0 1 .707 0l1.293 1.293a.5.5 0 0 1 0 .707l-4.594 4.594a.25.25 0 0 1-.177.073H2.25a.25.25 0 0 1-.25-.25m7.126-5.583a.5.5 0 0 0 .707 0l.813-.814a.5.5 0 0 0 0-.707L9.354 1.853a.5.5 0 0 0-.708 0l-.813.814a.5.5 0 0 0 0 .707z"
  })));
};

var _path$a;
function _extends$a() { return _extends$a = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$a.apply(null, arguments); }
var SvgWriteFilled16 = function SvgWriteFilled16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$a({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$a || (_path$a = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M2.667 13.667V11.47c0-.088.035-.173.097-.235L8.89 5.11c.26-.26.682-.26.943 0l1.724 1.724c.26.26.26.682 0 .943L5.43 13.902a.33.33 0 0 1-.236.098H3a.333.333 0 0 1-.333-.333m9.501-7.445c.26.26.683.26.943 0l1.084-1.084a.667.667 0 0 0 0-.943l-1.723-1.724a.667.667 0 0 0-.943 0l-1.084 1.084a.667.667 0 0 0 0 .943z"
  })));
};

var _path$9;
function _extends$9() { return _extends$9 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$9.apply(null, arguments); }
var SvgWriteFilled18 = function SvgWriteFilled18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$9 || (_path$9 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M3 15.375v-2.47c0-.1.04-.195.11-.265L10 5.75a.75.75 0 0 1 1.06 0L13 7.69a.75.75 0 0 1 0 1.06l-6.89 6.89a.38.38 0 0 1-.265.11h-2.47A.375.375 0 0 1 3 15.375M13.69 7a.75.75 0 0 0 1.06 0l1.22-1.22a.75.75 0 0 0 0-1.06l-1.94-1.94a.75.75 0 0 0-1.06 0L11.75 4a.75.75 0 0 0 0 1.06z"
  })));
};

var _path$8;
function _extends$8() { return _extends$8 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$8.apply(null, arguments); }
var SvgWriteFilled24 = function SvgWriteFilled24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$8 || (_path$8 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M4 20.5v-3.293a.5.5 0 0 1 .146-.353l9.187-9.187a1 1 0 0 1 1.415 0l2.585 2.586a1 1 0 0 1 0 1.414l-9.187 9.187a.5.5 0 0 1-.353.146H4.5a.5.5 0 0 1-.5-.5M18.253 9.333a1 1 0 0 0 1.414 0l1.626-1.626a1 1 0 0 0 0-1.414l-2.586-2.586a1 1 0 0 0-1.414 0l-1.626 1.626a1 1 0 0 0 0 1.415z"
  })));
};

var _path$7;
function _extends$7() { return _extends$7 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$7.apply(null, arguments); }
var SvgWriteFilled32 = function SvgWriteFilled32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$7 || (_path$7 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M5.333 27.333v-4.39c0-.177.07-.347.196-.472l12.249-12.249c.52-.52 1.364-.52 1.885 0l3.448 3.448c.52.52.52 1.365 0 1.886l-12.25 12.249a.67.67 0 0 1-.47.195H6a.667.667 0 0 1-.667-.667m19.004-14.889c.52.521 1.364.521 1.885 0l2.168-2.168c.521-.52.521-1.365 0-1.886l-3.447-3.447a1.333 1.333 0 0 0-1.886 0L20.89 7.11c-.52.52-.52 1.365 0 1.886z"
  })));
};

var _path$6;
function _extends$6() { return _extends$6 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$6.apply(null, arguments); }
var SvgWriteFilled48 = function SvgWriteFilled48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path$6 || (_path$6 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3438",
    d: "M8 41v-6.586a1 1 0 0 1 .293-.707l18.374-18.374a2 2 0 0 1 2.828 0l5.172 5.172a2 2 0 0 1 0 2.828L16.293 41.707a1 1 0 0 1-.707.293H9a1 1 0 0 1-1-1m28.505-22.333a2 2 0 0 0 2.828 0l3.253-3.253a2 2 0 0 0 0-2.828l-5.172-5.172a2 2 0 0 0-2.828 0l-3.252 3.252a2 2 0 0 0 0 2.829z"
  })));
};

var WriteFilledIcon = function WriteFilledIcon(props) {
  var writeFilled = {
    12: SvgWriteFilled12,
    16: SvgWriteFilled16,
    18: SvgWriteFilled18,
    24: SvgWriteFilled24,
    32: SvgWriteFilled32,
    48: SvgWriteFilled48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: writeFilled
  }, props));
};

var _path$5;
function _extends$5() { return _extends$5 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$5.apply(null, arguments); }
var SvgRedo12 = function SvgRedo12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path$5 || (_path$5 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M7.576 1.576a.6.6 0 0 1 .848 0l2.148 2.148a1.1 1.1 0 0 1 0 1.555L8.424 7.427a.6.6 0 1 1-.848-.849L9.054 5.1H4.5a1.9 1.9 0 0 0 0 3.8h1.25a.6.6 0 0 1 0 1.2H4.5a3.1 3.1 0 0 1 0-6.2H9.05L7.576 2.425a.6.6 0 0 1 0-.849",
    clipRule: "evenodd"
  })));
};

var _path$4;
function _extends$4() { return _extends$4 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$4.apply(null, arguments); }
var SvgRedo16 = function SvgRedo16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path$4 || (_path$4 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M10.136 2.137a.75.75 0 0 1 1.061 0L14.061 5a1.414 1.414 0 0 1 0 2.004l-.335-.335.335.335-2.864 2.863a.75.75 0 0 1-1.06-1.06l2.056-2.057H6a2.583 2.583 0 1 0 0 5.167h1.667a.75.75 0 0 1 0 1.5H6A4.083 4.083 0 0 1 6 5.25h6.19l-2.054-2.053a.75.75 0 0 1 0-1.06",
    clipRule: "evenodd"
  })));
};

var _path$3;
function _extends$3() { return _extends$3 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$3.apply(null, arguments); }
var SvgRedo18 = function SvgRedo18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path$3 || (_path$3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M11.434 2.434a.8.8 0 0 1 1.132 0l3.221 3.222a1.547 1.547 0 0 1 0 2.192l-3.221 3.221a.8.8 0 0 1-1.132-1.131l2.388-2.388H6.75a2.95 2.95 0 0 0 0 5.9h1.875a.8.8 0 1 1 0 1.6H6.75a4.55 4.55 0 0 1 0-9.1h7.069l-2.385-2.384a.8.8 0 0 1 0-1.132",
    clipRule: "evenodd"
  })));
};

var _path$2;
function _extends$2() { return _extends$2 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2.apply(null, arguments); }
var SvgRedo24 = function SvgRedo24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path$2 || (_path$2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M15.364 3.363a.9.9 0 0 1 1.273 0l4.295 4.295a1.897 1.897 0 0 1 0 2.687l-4.295 4.296a.9.9 0 1 1-1.273-1.273L18.832 9.9H9a4.1 4.1 0 1 0 0 8.2h2.5a.9.9 0 0 1 0 1.8H9A5.9 5.9 0 1 1 9 8.1h9.827l-3.463-3.464a.9.9 0 0 1 0-1.273",
    clipRule: "evenodd"
  })));
};

var _path$1;
function _extends$1() { return _extends$1 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1.apply(null, arguments); }
var SvgRedo32 = function SvgRedo32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path$1 || (_path$1 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M20.626 4.626a1 1 0 0 1 1.415 0l5.727 5.727a2.33 2.33 0 0 1 0 3.3L22.04 19.38a1 1 0 0 1-1.415-1.415L25.592 13H12a5.667 5.667 0 1 0 0 11.333h3.334a1 1 0 1 1 0 2H12A7.667 7.667 0 1 1 12 11h13.586l-4.96-4.96a1 1 0 0 1 0-1.414",
    clipRule: "evenodd"
  })));
};

var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var SvgRedo48 = function SvgRedo48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M31.152 7.152a1.2 1.2 0 0 1 1.697 0l8.59 8.59c.623.623.935 1.44.937 2.255.002.82-.31 1.644-.937 2.27l-8.59 8.591a1.2 1.2 0 0 1-1.697-1.697l7.96-7.961H18a8.8 8.8 0 0 0 0 17.6h5a1.2 1.2 0 1 1 0 2.4h-5c-6.185 0-11.2-5.014-11.2-11.2S11.815 16.8 18 16.8h21.103l-7.952-7.951a1.2 1.2 0 0 1 0-1.697",
    clipRule: "evenodd"
  })));
};

var RedoIcon = function RedoIcon(props) {
  var redo = {
    12: SvgRedo12,
    16: SvgRedo16,
    18: SvgRedo18,
    24: SvgRedo24,
    32: SvgRedo32,
    48: SvgRedo48
  };
  return jsx(IconTemplate, _objectSpread2({
    icons: redo
  }, props));
};

export { DropdownRightIcon as $, AlertFilledIcon as A, BullhornIcon as B, CalculatorIcon as C, ChevronRightIcon as D, ChevronUpIcon as E, CircleCheckFilledIcon as F, CircleFilledIcon as G, CircleWonFilledIcon as H, InfoIcon as I, ClockIcon as J, ClockFilledIcon as K, CommentIcon as L, CommentFilledIcon as M, ContentListIcon as N, CouponIcon as O, CouponFilledIcon as P, CrownFilledIcon as Q, CubeBadgeSparkleIcon as R, CubeOpenIcon as S, DataListIcon as T, DataListFilledIcon as U, DeleteIcon as V, DeleteFilledIcon as W, DismissIcon as X, DismissCircleIcon as Y, DownloadIcon as Z, DropdownDownIcon as _, AddIcon as a, StackedImagesFilledIcon as a$, DropdownUpIcon as a0, ExpandIcon as a1, ExportIcon as a2, FaceSmilingSafetyHelmetIcon as a3, FaceSmilingSafetyHelmetFilledIcon as a4, FastForwardFilledIcon as a5, FilterIcon as a6, FilterFilledIcon as a7, FilterNewIcon as a8, GlobeIcon as a9, PlayFilledIcon as aA, PointIcon as aB, PointFilledIcon as aC, PresentIcon as aD, PresentFilledIcon as aE, ProfileIcon as aF, ProfileFilledIcon as aG, QuestionIcon as aH, QuestionFilledIcon as aI, ScrapIcon as aJ, ScrapFilledIcon as aK, SearchIcon as aL, SearchImageIcon as aM, SendFilledIcon as aN, SettingIcon as aO, ShareIcon as aP, ShieldIcon as aQ, ShieldFilledIcon as aR, SignOutIcon as aS, SignedIcon as aT, SignedFilledIcon as aU, SortingIcon as aV, SoundMuteFilledIcon as aW, SoundOffFilledIcon as aX, SoundOnFilledIcon as aY, SquareAndPencilIcon as aZ, StackedImagesIcon as a_, HandlerIcon as aa, HeartIcon as ab, HeartFilledIcon as ac, HomeIcon as ad, HomeFilledIcon as ae, InfoFilledIcon as af, LaunchIcon as ag, LinkIcon as ah, LocationIcon as ai, LocationFilledIcon as aj, LockIcon as ak, LockFilledIcon as al, MedalIcon as am, MedalFilledIcon as an, MenuIcon as ao, MenuFoldIcon as ap, MenuOpenIcon as aq, MoreHorizontalIcon as ar, MoreVerticalIcon as as, NotificationIcon as at, NotificationFilledIcon as au, PauseIcon as av, PhotoIcon as aw, PinIcon as ax, PlayCircleIcon as ay, PlayCircleFilledIcon as az, AddCircleIcon as b, StarIcon as b0, StarFilledIcon as b1, StatIcon as b2, StoreIcon as b3, StoreFilledIcon as b4, SubtractIcon as b5, TagIcon as b6, TagFilledIcon as b7, TextBoldIcon as b8, TextItalicIcon as b9, TextRectangleOnRectangleAngledIcon as ba, TextRectangleOnRectangleAngledFilledIcon as bb, TextUnderlineIcon as bc, ThumbsUpIcon as bd, ThumbsUpFilledIcon as be, TruckIcon as bf, TruckFilledIcon as bg, TvIcon as bh, UndoIcon as bi, UploadIcon as bj, ViewListFilledIcon as bk, ViewThumbnailFilledIcon as bl, WifiIcon as bm, WonIcon as bn, WriteIcon as bo, WriteFilledIcon as bp, RedoIcon as bq, AddCircleFilledIcon as c, AlertIcon as d, ArrowClockwiseIcon as e, ArrowDownIcon as f, ArrowLeftIcon as g, ArrowLeftArrowRightIcon as h, ArrowRightIcon as i, ArrowUpIcon as j, AttachIcon as k, BullhornFilledIcon as l, CalendarIcon as m, CalendarFilledIcon as n, CallIcon as o, CallFilledIcon as p, CameraIcon as q, CameraFilledIcon as r, CardIcon as s, CardFilledIcon as t, CartIcon as u, CashIcon as v, CashFilledIcon as w, CheckIcon as x, ChevronDownIcon as y, ChevronLeftIcon as z };
//# sourceMappingURL=icons.js.map
